const _ = {
  T_50_XYL_2NBCL_BLOODMOON_SKYBOX: "خلفية تسوكويومي",
  BR_WORKSHOP_INVALID_PERFORMANCE_COST: "فشل النشر بسبب وجود أصول مشهد زائدة. يرجى حذف بعض الأصول والمحاولة مرة أخرى.",
  BR_WORKSHOP_NO_PERMISSION_PUB_MONETIZATION_MAP: "لا يوجد حالياً إذن للوصول إلى الميزات المتعلقة بالعضوية",
  T_12_I_GIFT_SENDER_BELL: "جرس",
  T_12_L_ACCESSORY_COS_MOTORHELMET_DESC: `الآن أنت تراه، 
والآن أنت لا تريد ذلك. [FFB300](يخفي الخوذة)[-]`,
  T_12_L_ACCESSORY_COS_SANTAHEAD: "قناع الرجل العجوز",
  T_12_L_COS_PINKMAN: "دينو وردي",
  T_12_L_COS_POLAR: "الدب القطبي",
  T_12_L_COS_RENDER: "الدينو الملون",
  T_12_L_COS_TIGER: "بدلة نمر",
  T_12_L_MALE_BOTTOM_COS_ELF: "قزم الشتاء (لباس سفلي)",
  T_12_L_MALE_COS_SANTA: "العجوز الغاضب",
  T_12_L_MALE_HAIR_COS_ELF: "قزم الشتاء (رأس)",
  T_12_L_MALE_SHOE_COS_ELF: "قزم الشتاء (حذاء)",
  T_12_L_MALE_TOP_COS_ELF: "قزم الشتاء (لباس علوي)",
  T_12_O_CAT_NAME: "قطة",
  T_12_O_M1014_CHRISTMAS_NAME: "M1014 - أرض الشتاء",
  T_12_O_MACHETE_GOLD_NAME: "شفرة - الذهبية",
  T_12_O_PET_TITLE: "حيوان أليف",
  T_12_Q_ITEM_AN94: "AN94",
  T_12_Q_ITEM_DOUBLEJUMPSHOE: "حذاء القفز",
  T_12_Q_ITEM_DOUBLEJUMPSHOE_DESC: "أحذية مصنوعة وفقًا لتقنية حديثة. تسمح للأشخاص بالقفز-المزدوج.",
  T_12_Q_ITEM_FLYSHOE: "حذاء حزمة الطائرة النفاثة",
  T_12_Q_ITEM_FLYSHOE_DESC: "حذاء يسمح لك للمستخدم بالتحليق جوًا. حاول ألا تستنفذ الوقود في عنان السماء.",
  T_12_Q_ITEM_STOCK1: "مخزون المستوى 1",
  T_12_Q_ITEM_STOCK2: "مخزون المستوى 2",
  T_12_Q_ITEM_STOCK3: "مخزون المستوى 3",
  T_12_Q_ITEM_TREATMENTGUN: "مسدس العلاج",
  T_12_Q_ITEM_VEST4: "سترة المستوى 4",
  T_12_R_CHARACTER_GANGLEADER_NAME: "أنطونيو",
  T_12_R_CHARACTER_MONKEYGOD_NAME: "ووكونج",
  T_12_R_EMOTE_SHOOTDANCE_NAME: "رقصة الانطلاق",
  T_12_R_EMOTE_WAVE_NAME: "تحية للجيش",
  T_12_R_SKILL_NAME_GANGLEADER: "روح رجل العصابات",
  T_12_R_SKILL_NAME_MONKEYGOD: "تمويه",
  T_13_I_COLLECTION_V_AMPHIBIAN: "سيارة برمائية",
  T_13_I_COLLECTION_V_JEEP: "سيارة جيب",
  T_13_I_COLLECTION_V_MONSTER: "الشاحنة المتوحشة",
  T_13_I_COLLECTION_V_MOTOBIKE: "الدراجة النارية",
  T_13_I_COLLECTION_V_ROADSTER: "سيارة رياضية",
  T_13_I_COLLECTION_V_SUV: "شاحنة التوصيل",
  T_13_I_COLLECTION_V_TUTU: "سيارة توك توك",
  T_13_L_MALE_ACCESSORY_COS_BJD: "أزرق القطب الشمالي (قناع)",
  T_13_L_MALE_BOTTOM_COS_VALENTINE: "نسيم الحب في الهواء (لباس سفلي)",
  T_13_L_MALE_HAIR_COS_BJD: "أزرق مطاطي (رأس)",
  T_13_L_MALE_TOP_COS_VALENTINE: "نسيم الحب في الهواء (لباس علوي)",
  T_13_M_PVE_MATCH_SUMMARY_WEAPON: "سلاح",
  T_13_O_PETSKIN_OCELOT_CAT_NAME: "ملابس الحيوانات الأليفة: قطة المحقق",
  T_13_O_SCAR_VALENTINE_NAME: "SCAR - كيوبيد",
  T_13_R_CHARACTER_HACKERGIRL_NAME: "موكو",
  T_13_R_EMOTE_BABYSHARK_NAME: "قرش صغير (بيبي شارك)",
  T_13_R_EMOTE_BOMBSQUAD_NAME: "اندفع",
  T_13_R_EMOTE_EGYPT_NAME: "رقص المومياء",
  T_13_R_PVE_WEAPON_SLOT: "فتحة السلاح",
  T_13_R_PVE_WEAPONSKIN_RANGE: "المدى الفعال",
  T_13_R_PVE_WEAPONSKIN_SPEED: "معدل إطلاق النيران",
  T_13_R_SKILL_DESC_HACKERGIRL: "ضع علامة على الأعداء لـ [FFB300]{0}ث[-]. ستتم مشاركة المعلومات مع الزملاء.",
  T_13_R_SKILL_NAME_HACKERGIRL: "عين الهاكر",
  T_13_Z_KICKOFF_BAN: "محظور",
  T_13_Z_ROOM_MORNING: "يوم",
  T_13_Z_ROOM_NIGHT: "ليلة",
  T_14_G_ITEM_KATANA: "كاتانا",
  T_14_I_HEADPIC_SONGKRAN_NAME: "رذاذ!",
  T_14_L_ACCESSORY_COS_EASTERHEAD2: "الأرنب المكعب",
  T_14_L_COS_EASTER: "ملاحظ 1937",
  T_14_L_FEMALE_SHOE_COS_FIREFIGHTERS: "سيدة اللهيب (حذاء)",
  T_14_L_MALE_ACCESSORY_COS_EASTERRABBIT: "الأرنب المحارب (قناع)",
  T_14_O_AK_WATERSPLASHING_NAME: "AK47 - بالون مياه",
  T_14_O_DOG_NAME: "جرو آلي",
  T_14_O_PETSKIN_IRON_DOG_NAME: "ملابس الحيوانات الأليفة: جرو من الصلب الكامل",
  T_14_O_PETSKIN_LIGNTNING_DOG_NAME: "ملابس الحيوانات الأليفة: جرو مضيئ",
  T_14_O_PETSKIN_MAGNETIC_DOG_NAME: "ملابس الحيوانات الأليفة: جرو مغناطيسي",
  T_14_O_PETSKIN_NIGHT_CAT_NAME: "ملابس الحيوانات الأليفة: قطة الليل",
  T_14_O_SCAR_BLOODMOON_NAME: "SCAR - القمر الدامي",
  T_14_O_SCAR_SHARK_NAME: "SCAR - هجوم القرش",
  T_14_Q_ITEM_RGS50: "RGS50",
  T_14_R_CHARACTER_SAMURAI_NAME: "هياتو",
  T_14_R_SKILL_DESC_SAMURAI: "عن كل [FFB300]{0}%[-] من الصحة المفقودة، يزداد اختراق الدروع بنسبة [FFB300]{1}%[-].",
  T_14_R_SKILL_NAME_SAMURAI: "البوشيدو",
  T_15_L_MALE_ACCESSORY_COS_FAIM: "ضربة الجوع (قناع)",
  T_15_L_MALE_ACCESSORY_COS_PESTILENCE: "اللمسة السّامة (قناع)",
  T_15_L_MALE_BOTTOM_COS_FAIM: `ضربة الجوع
 (رداء سفلي)`,
  T_15_L_MALE_BOTTOM_COS_PESTILENCE: `اللمسة السّامة 
(رداء سفلي)`,
  T_15_L_MALE_SHOE_COS_FAIM: "ضربة الجوع(حذاء)",
  T_15_L_MALE_SHOE_COS_PESTILENCE: "اللمسة السّامة (حذاء)",
  T_15_L_MALE_TOP_COS_FAIM: "ضربة الجوع (رداء علوي)",
  T_15_L_MALE_TOP_COS_PESTILENCE: "اللمسة السّامة (رداء علوي)",
  T_15_L_TOP_COS_MOTHERSDAY: "أفضل أم",
  T_15_O_AN94_APOCALYPSE_NAME: "AN94 - المشتعل",
  T_15_O_BASEBALLBAT_VIKING_NAME: "مضرب - قراصنة الفايكينج",
  T_15_O_M1014_APOCALYPSE_NAME: "M1014 - الطوفان",
  T_15_O_M4A1_APOCALYPSE_NAME: "M4A1 - الطوفان",
  T_15_O_PANTHER_NAME: "نمر أسود ليلي",
  T_15_O_PETSKIN_CAPTAIN_PANTHER_NAME: "القائد",
  T_15_O_PETSKIN_GOLDEN_PANTHER_NAME: "الفهد الذهبي",
  T_15_O_PETSKIN_PURPLE_PANTHER_NAME: "هيمنة",
  T_15_O_SKS_DEATH_NAME: "SKS - أمنية الموت",
  T_15_O_UMP_APOCALYPSE_NAME: "UMP - الطوفان",
  T_15_Q_ITEM_CG15: "CG15",
  T_15_Q_ITEM_GATLING: "جاتلينج",
  T_15_R_CHARACTER_AGENT_NAME: "لورا",
  T_15_R_EMOTE_LETSGROOVE_NAME: "ارقص معي",
  T_15_R_SKILL_DESC_AGENT: "تزداد الدقة بنسبة [FFB300]{0}%[-] أثناء التصويب.",
  T_15_R_SKILL_NAME_AGENT: "قناص ماهر",
  T_15_W_BACKPACK_MECHGIRL_NAME: "حقيبة - أجنحة بنفسجية",
  T_16_B_ITEM_GRAPPLINGHOOK: "خطاف",
  T_16_B_ITEM_GRAPPLINGHOOKGUN: "مسدس الخطاف",
  T_16_L_MALE_COS_LEGO: "رجل المكعبات الغاضب",
  T_16_L_MALE_SHOE_COS_SUMMER: "العطلة الصيفية (حذاء)",
  T_16_P_MANUAL_MONSTER: "الشاحنة المتوحشة",
  T_16_P_MANUAL_MUSHROOM1: "فطر المستوى 1",
  T_16_P_MANUAL_MUSHROOM2: "فطر المستوى 2",
  T_16_P_MANUAL_MUSHROOM3: "فطر المستوى 3",
  T_16_P_MANUAL_MUSHROOM4: "فطر المستوى 4",
  T_16_P_MANUAL_ROADSTER_DESC: "سيارة رياضية عصرية. منخفضة الـ HP ولكن ذات سرعة قصوى جنونية. يمكن أن تحمل ما يصل إلى 2 لاعبين.",
  T_16_P_MANUAL_STROP: "حبل تزحلق",
  T_16_P_MANUAL_SUV: "شاحنة التوصيل",
  T_16_P_MANUAL_SUV_DESC: `سيارة فري فاير
 الخاصة. درع متوسط وسرعة قصوى. يمكن أن تحمل ما يصل
 إلى 2 لاعبين.`,
  T_16_P_MANUAL_TUTU_DESC: "مركبة منخفضة الـ HP وبطيئة الحركة. يمكن أن تحمل ما يصل إلى 3 لاعبين.",
  T_16_P_MANUAL_WEAPON_AR: "اسلحة اتوماتيكية",
  T_16_P_MANUAL_WEAPON_BOMB: "قنبلة يد",
  T_16_P_MANUAL_WEAPON_PISTOL: "مسدس",
  T_16_P_MANUAL_WEAPON_SG: "بندقية",
  T_16_P_MANUAL_WEAPON_SMG: "SMG",
  T_16_P_MANUAL_WEAPON_SR: "بندقية قنص",
  T_16_Q_MINISENTRY: "برج صغير",
  T_16_Q_MINISENTRY_DESC: "البرج الاوتوماتيكي مصنوع بالتكنولوجيا الحديثة. وسوف يمسح ويهاجم الأعداء عند اقترابهم.",
  T_16_R_EMOTE_DESERT_NAME: "السلام المخيف",
  T_16_R_EMOTE_EPHUNTER_NAME: "معركة الرقص",
  T_16_R_EMOTE_EPHUNTER2_NAME: "أعطني كفك!",
  T_16_R_EMOTE_KICKTHEMOON_NAME: "قم بركل القمر",
  T_16_R_EMOTE_WIGGLEWALK_NAME: "المشي المتذبب",
  T_16_W_AK_FIRE_NAME: "AK47 - الأحمر الملتهب",
  T_16_W_SCAR_LLENN_NAME: "SCAR - المارد الوردي",
  T_16_W_SCAR_WATER_NAME: "SCAR - عنصر الماء",
  T_16_Y_CHARACTER_HITMAN_NAME: "رافائيل",
  T_16_Y_PANDA_NAME: "الباندا",
  T_16_Y_PETSKIN_BROWN_PANDA_NAME: "لباس الحيوان الأليف: الباندا المتوحش",
  T_16_Y_PETSKIN_SKELETON_PANDA_NAME: "لباس الحيوان الأليف: بندا الجمجمة",
  T_16_Y_PETSKIN_THOR_PANDA_NAME: "لباس حيوان الأليف: الباندا الصاعق",
  T_17_B_CS_MODE_NAME: "كلاش سكواد",
  T_17_C_SKILL_NAME_PLAYBOY: "حركة غريبة",
  T_17_L_FEMALE_ACCESSORY_COS_JOKER_ROYAL: "المهرج الملكي (قناع)",
  T_17_L_FEMALE_ACCESSORY_COS_VAMPIRE: "العشيقة الدموية (قناع)",
  T_17_L_FEMALE_BOTTOM_COS_VAMPIRE: "العشيقة الدموية (سفلي)",
  T_17_L_FEMALE_HAIR_COS_SELVEDGEWORK: "الثعلب السحري (رأس)",
  T_17_L_FEMALE_SHOE_COS_VAMPIRE: "العشيقة الدموية (حذاء)",
  T_17_L_FEMALE_TOP_COS_VAMPIRE: "العشيقة الدموية (علوي)",
  T_17_L_MALE_ACCESSORY_COS_VAMPIRE: "انتقام مصاص الدماء (قناع)",
  T_17_L_MALE_BOTTOM_COS_BOSOZOKU: "سغاح الشارح (سُفلي)",
  T_17_L_MALE_BOTTOM_COS_VAMPIRE: "انتقام مصاص الدماء(سفلي)",
  T_17_L_MALE_HAIR_COS_FFUNIT: "اللون الارجواني (رأس)",
  T_17_L_MALE_SHOE_COS_INDEPENDENCE: "جنتلمان (حذاء)",
  T_17_L_MALE_SHOE_COS_VAMPIRE: "انتقام مصاص الدماء (حذاء)",
  T_17_L_MALE_TOP_COS_VAMPIRE: "انتقام مصاص الدماء (علوي)",
  T_17_L_MALE_TOP_COS_YINYANG_GOLD: "الظل الذهبي (علوي)",
  T_17_O_PETSKIN_ANNIVERSARY_CAT_NAME: "الاميرة مياه",
  T_17_O_PETSKIN_EARTHDRAGON_SHIBA_NAME: "القصة الذهبية",
  T_17_O_PETSKIN_ELECTRICDRAGON_SHIBA_NAME: "الازرق العميق",
  T_17_O_PETSKIN_GREENDRAGON_SHIBA_NAME: "غلاف حيوان: الاخضر المحظوظ",
  T_17_O_SHIBA_NAME: "شيبا",
  T_17_Q_FOLDWINGS: "طائرة شراعية",
  T_17_Q_FOLDWINGS_DESC: "يسمح لك بالانزلاق من تضاريس مرتفعة.",
  T_17_Q_SUPERHEAT: "البلازما",
  T_17_R_EMOTE_PARTYDANCE_NAME: "حفلة رقص",
  T_17_W_FAMAS_VAMPIRE_NAME: "فاماس - مصاص الدماء",
  T_17_W_SCAR_ASSASSIN_NAME: "SCAR - فانتوم القاتل",
  T_17_W_SCAR_PLAYBOY_NAME: "SCAR - موضة قديمة",
  T_17_Y_CHARACTER_MADEMANA_NAME: "A124",
  T_17_Y_CHARACTER_PLAYBOY_NAME: "يوسف",
  T_17_Z_CS_NAME: "الاسم",
  T_17_Z_ROOM_JUMP_SWITCH: "ارتفاع القفزة",
  T_17_Z_ROOM_SPEED_SWITCH: "سرعة الحركة",
  T_18_B_THROWINGKNIFE_NAME: "سكين FF",
  T_18_C_DUMMY_NAME: "قنبلة يدوية خادعة",
  T_18_C_SKILL_DESC_DJMALE: "إنشاء هالة [FFB300]{1}م[-] تزيد من سرعة الحركة بنسبة [FFB300]{3}%[-] واستعادة [FFB300]{2} من الصحة[-] لمدة [FFB300]{0}ث[-].التأثيرات لا تتراكم. التهدئة: [FFB300]{4}ث[-].",
  T_18_C_SKILL_NAME_DJMALE: "إسقاط الإيقاع",
  T_18_C_SKILL_NAME_JUNKENGINEER: "إعادة تدوير العتاد",
  T_18_L_COS_INDIANEWYEAR: "ديوالي دينو",
  T_18_L_HAIR_COS_HALLOWEEN2019: "وجه عبوس",
  T_18_L_MALE_ACCESSORY_COS_BJD2_MAGMA: "الأحمر المشتعل (قناع)",
  T_18_O_FOX_NAME: "روح الثعلب",
  T_18_O_PETSKIN_BLACKFOX_NAME: "ثعلب الحرب",
  T_18_O_PETSKIN_BLUEFOX_NAME: "جلد الحيوانات الأليفة: الثعلب الأزرق",
  T_18_O_PETSKIN_HALLOWEEN_SHIBA_NAME: "جلد الحيوانات الأليفة: حمم اليقطين",
  T_18_O_PETSKIN_PINKFOX_NAME: "جلد الحيوانات الأليفة: الثعلب الأحمر",
  T_18_O_PETSKIN_SPIRIT_PANTHER_NAME: "جلد الحيوانات الأليفة: الروح",
  T_18_U_WEAPON_M1887_NAME: "M1887",
  T_18_W_M4A1_FIRESKELETON_N: "M4A1 - الجمجمة المشتعلة",
  T_18_W_UMP_GEISHA_N: "UMP - فن الحرب",
  T_18_Y_CHARACTER_DJMALE_N: "ألوك",
  T_18_Y_CHARACTER_JUNKENGINEER_N: "شاني",
  T_19_B_HB_NAME: "مزلاجة الكهربائية",
  T_19_C_ICE_GUN_NAME: "مسدس الثلج",
  T_19_C_SKILL_DESC_DEMOLITIONIST: "يزيد ضررالسلاح المتفجر بمقدار FFB300]{0}%[-]، ويزيد نطاق الضرر بمقدار [FFB300]{1}%[-].",
  T_19_C_SKILL_DESC_TOMBOY: "عند القيادة، تستعيد [FFB300]{1}نقاط صحة[-] كل [FFB300]{0}ث[-] لكل شخص على السيارة، ما يصل إلى حد أقصى من [FFB300]{2}[-] نقاط الصحة.",
  T_19_C_SKILL_NAME_DEMOLITIONIST: "فن الدمار",
  T_19_C_SKILL_NAME_TOMBOY: "العداء السريع",
  T_19_I_EVENT_INFI_ITEM: "بلا حدود",
  T_19_L_A_ICEFESTIVAL19_B: "الضحكة الأخيرة",
  T_19_L_F_S_ICEFESTIVAL: "أسلوب ثلجي (حذاء)",
  T_19_L_MALE_BOTTOM_COS_DISCOMAN: "ديسكو فياسكو (بنطال)",
  T_19_L_MALE_HAIR_COS_DISCOMAN: "ديسكو فياسكو (شعر)",
  T_19_L_MALE_TOP_COS_DISCOMAN: "ديسكو فياسكو (قميص)",
  T_19_O_PETSKIN_NAME: "سكن الحيوان الأليف :الأفتراضى",
  T_19_O_PETSKIN_PANDA_TRAPRAP_NAME: "سكن الحيوان الاليف : هيب هوب باندا",
  T_19_O_PETSKIN_PANDA_WINTERFELL_NAME: "سكن الحيوان الأليف : الباندا القطبية",
  T_19_O_PETSKIN_ROBOT_PHARAOH_NAME: "سكن الحيوان الأليف: الروبوت الفرعوني",
  T_19_O_PETSKIN_ROBOT_SPRING_NAME: "الحيوان الاليف : عيد الربيع روبو",
  T_19_O_PETSKIN_ROBOT_WINTERFELL_NAME: "الحيوان الاليف :سنوروبو",
  T_19_O_PETSKIN_SHIBA_TRAPRAP_NAME: "الحيوان الاليف : هيب هوب شيبا",
  T_19_O_ROBOT_NAME: "روبو",
  T_19_O_TDM_NAME: "الماتش القاتل",
  T_19_R_EMOTE_MIGUEL_NAME: "رقصة البريك دانس",
  T_19_S_SECOND_WEAPON_TITLE: "سلاح ثانوى",
  T_19_S_VEST_TITLE: "سترة مضادة للرصاص",
  T_19_U_DOUBLEMAGEZINE_ATTACHMENT_NAME: "ذخيرة مزدوجة",
  T_19_W_GROZA_TAGGERCREW_N: "جروزا - الغضب & التمرد",
  T_19_W_M60_ICEFESTIVAL_N: "M60 - إختيارجندي الشتاء",
  T_19_W_MP40_PARK_N: "MP40 - كرنفال",
  T_19_W_SCAR_CNNEWYEAR19_N: "SCAR - التنين الشائك",
  T_19_X_PVE_SAMURAINAME: "حارس الساموراي",
  T_19_Y_CHARACTER_DEMOLITIONIST_N: "الفارو",
  T_19_Y_CHARACTER_TOMBOY_N: "نورتورا",
  T_20_C_INHALER_NAME: "المستنشق",
  T_20_C_SKILL_DESC_PARKOURGUY: "عند استخدام الأسلحة، فإن ضرب أحد الأعداء يسترد بعض نقاط الصحة للمستخدم، ويؤدي القضاء على العدو إلى استعادة [FFB300]{0}%[-] من نقاط الصحة للمستخدم.",
  T_20_C_SKILL_NAME_GRAFFITIST: "الرسامة الماهرة",
  T_20_C_SKILL_NAME_KELLY_AWAKENING: "السرعة القاتلة",
  T_20_C_SKILL_NAME_PARKOURGUY: "الغزو المستمر",
  T_20_L_A_APRILFOOL2020: "الكلب بوبي",
  T_20_L_F_A_METALHEAD_RED: "انثى الشهاب الناري (قناع)",
  T_20_L_F_B_THAIGIRL: "راقصة الفينكس (سفلي)",
  T_20_L_F_H_KILLERCUPID: "المعشوقة المغرورة (رأس)",
  T_20_L_F_H_THAIGIRL: "راقصة الفينكس (رأس)",
  T_20_L_F_S_THAIGIRL: "راقصة الفينكس (حذاء)",
  T_20_L_F_T_METALHEAD_RED: "انثى الشهاب الناري (علوي)",
  T_20_L_F_T_THAIGIRL: "راقصة الفينيكس (علوي)",
  T_20_L_JEANDINO: "دينو الجينز",
  T_20_L_M_A_METALHEAD_RED: "الشهاب الناري (قناع)",
  T_20_L_M_T_METALHEAD_RED: "الشهاب الناري (علوي)",
  T_20_L_M_T_STOCKING: "(الوسيم (علوي",
  T_20_O_PETSKIN_LOVERFOX_NAME: `سكن الذئب :
ذئب الفالنتاين`,
  T_20_P_CHANNEL_G: "رابطة",
  T_20_P_WORLD_SSPEAKER: "مكبر الصوت",
  T_20_S_CSROOM_COIN: "النقود الافتراضية",
  T_20_U_SHIELD_GUN_NAME: "درع السلاح",
  T_20_W_AN94_METALHEAD_N: "AN94 - الشهاب الشمسي",
  T_20_W_P90_EVILBONE_N: "P90 - المعاقب",
  T_20_Y_CHARACTER_GRAFFITIST_N: "ستيفاني",
  T_20_Y_CHARACTER_KELLY_AWAKENING_N: "كيلي السريعة",
  T_20_Y_CHARACTER_PARKOURGUY_N: "جوتا",
  T_21_B_SMOKEGRENADE_DESC: "يولد دخانًا ، رائعًا للإستخباء والمناورات",
  T_21_B_SMOKEGRENADE_NAME: "قنبلة دخانية",
  T_21_C_AUTOPICKUP_AVERAGE: "الافتراضية",
  T_21_C_SKILL_DESC_KPOPSINGER: "أثناء مساعدة الزميل، يعطى للزميل [FFB300]{0}درع صحة[-] و [FFB300]{1}%[-] زيادة في سرعة الحركة. تقلل تأثيرات التعزيز خلال [FFB300]{2}ث[-]  بعد المساعدة الناجحة. يقلل سرعة نزيف الدم للزميل الذي تم إسقاطه بنسبة [FFB300]{3}%[-]. التأثيرات لا تتراكم.",
  T_21_C_SKILL_DESC_SOCCERSTAR: "كل قتل يزيد الحد الأقصى لنقاط الصحة بمقدار [FFB300]{0}[-]. الحد الأقصى للتعزيز: [FFB300]{1}[-].",
  T_21_C_SKILL_NAME_KPOPSINGER: "أغنية الشفاء",
  T_21_C_SKILL_NAME_SOCCERSTAR: "هاتريك",
  T_21_L_ANGELICAL: "دينو الملاك",
  T_21_L_S_VNSLIPPER: "أحذية فيتنايمة",
  T_21_O_OTTER_NAME: "اوترو",
  T_21_O_PETSKIN_OTTER_GREY_NAME: "سكن الحيوان الأليف: اوترو المشع",
  T_21_O_PETSKIN_OTTER_PINK_NAME: "سكن الحيوان الأليف: اوترو الساكورا",
  T_21_O_PETSKIN_OTTER_PURPLE_NAME: "سكن الحيوان الأليف: اوترو الفسفوري",
  T_21_O_PETSKIN_ROBOT_DEATH_NAME: "سكن حيوان الأليف: الدمار الشامل",
  T_21_O_PETSKIN_SPINE_PANTHER_NAME: "سكن الحيوان الأليف: صاعقة البرق",
  T_21_R_EMOTE_SORROW_NAME: "لماذا ؟ اوه لماذا؟",
  T_21_U_WEAPON_THOMPSON_NAME: "طومسون",
  T_21_W_BACKPACK_SPINE_N: "حقيبة - المشاغب",
  T_21_W_BASEBALLPOLE_DEATH2020_N: "ضربة الموت الأخيرة",
  T_21_W_M79_RABBITKILLER_N: "M79 - الأرنب المشاكس",
  T_21_W_PAN_VOLCANO_N: "مقلاة - الغضب البركاني",
  T_21_W_XM8_RAINBOW_N: "XM8 - سونقكران",
  T_21_Y_CHARACTER_KPOPSINGER_N: "كابيلا",
  T_21_Y_CHARACTER_SOCCERSTAR_N: "لوكوثا",
  T_22_C_BLT_NAME: "M82B",
  T_22_C_SKILL_DESC_DETECTIVE: "حدد مواقع الأعداء على بعد [FFB300]{0}م[-] لمن ليس في موضع الإنبطاح أو الجلوس. يستمر لمدة [FFB300]{1}ث[-]، يتم مشاركة مكان الأعداء مع الفريق. التهدئة [FFB300]{2}ث[-].",
  T_22_C_SKILL_NAME_DETECTIVE: "تتبع الخطوات",
  T_22_C_SKILL_NAME_STREAMERGUY: "كان محط الأنظار",
  T_22_L_F_H_COLLEGE: "المتمردة الدموية (شعر)",
  T_22_L_F_S_SUMMER20: "حبيبة الصيف (حذاء)",
  T_22_L_M_A_GREENCOAT: "نادي الأغنياء (قناع)",
  T_22_L_M_A_PINKFUR: "نادي الساكورا (قناع)",
  T_22_L_M_A_PLAGUE2: "شبح الإبادة (قناع)",
  T_22_L_M_B_FAIM2: "المجاعة الحارقة (أسفل)",
  T_22_L_M_B_GREENCOAT: "نادي الأغنياء (أسفل)",
  T_22_L_M_B_PINKFUR: "نادي الساكورا (أسفل)",
  T_22_L_M_B_PLAGUE2: "شبح الإبادة (أسفل)",
  T_22_L_M_B_REDPANTS: "النادي العصري (أسفل)",
  T_22_L_M_B_TIGERSTRIPE: "نادي النمور(أسفل)",
  T_22_L_M_H_COLLEGE: "المتمرد الدموي (شعر)",
  T_22_L_M_H_FAIM2: "المجاعة الحارقة (شعر)",
  T_22_L_M_H_GREENCOAT: "نادي الأغنياء (شعر)",
  T_22_L_M_H_PINKFUR: "نادي الساكورا (شعر)",
  T_22_L_M_H_PLAGUE2: "شبح الإبادة (شعر)",
  T_22_L_M_H_REDPANTS: "النادي العصري (شعر)",
  T_22_L_M_H_TIGERSTRIPE: "نادي النمور(شعر)",
  T_22_L_M_S_FAIM2: "المجاعة الحارقة (حذاء)",
  T_22_L_M_S_PLAGUE2: "شبح الإبادة (حذاء)",
  T_22_L_M_T_FAIM2: "المجاعة الحارقة (أعلى)",
  T_22_L_M_T_GREENCOAT: "نادي الأغنياء (أعلى)",
  T_22_L_M_T_PINKFUR: "نادي الساكورا (اعلى)",
  T_22_L_M_T_PLAGUE2: "شبح الإبادة (أعلى)",
  T_22_L_M_T_REDPANTS: "النادي العصري (أعلى)",
  T_22_L_M_T_TIGERSTRIPE: "نادي النمور(أعلى)",
  T_22_LC_KAR98K_COLLEGE_N: "Kar98k - أكاديمية المتمردين",
  T_22_LC_PAN_CAPTAINBUBBLE_N: "مقلاة - البطيخ",
  T_22_LC_SCAR_HERMIT_N: "SCAR -  الباحث الغامض",
  T_22_LC_TREATMENTGUN_APOCALYPSE2_N: "مسدس العلاج - شعاع الحياة",
  T_22_O_HAWK_NAME: "فالكو",
  T_22_O_PETSKIN_FOX_APOCALYPSE_NAME: "سكن الحيوان الأليف: ثعلب نهاية العالم",
  T_22_O_PETSKIN_HAWK_FIRE_NAME: "سكن الحيوان الأليف: فالكو الجحيم",
  T_22_O_PETSKIN_HAWK_NATURE_NAME: "سكن الحيوان الأليف: فالكو الأخضر",
  T_22_O_PETSKIN_SHIBA_SUMMER_NAME: "سكن الحيوان الأليف: شيبا المشرق",
  T_22_Q_BOMB_PLIERS: "عدة الإبطال",
  T_22_R_EMOTE_SHIMMY_NAME: "رقصة شيمي",
  T_22_U_GOLD_AWM_N: "AWM-Y",
  T_22_U_WPNSKN_BITE: "اختراق الدروع",
  T_22_U_WPNSKN_SPEED_RUN: "سرعة الحركة",
  T_22_Y_CHARACTER_DETECTIVE_N: "كلو",
  T_22_Y_CHARACTER_STREAMERGUY_N: "وولفرا",
  T_23_B_CARDIAC_NAME: "الأفق",
  T_23_C_SKILL_NAME_HAYATO_AWAKENING: "فن الشفرات",
  T_23_C_SKILL_NAME_SWATGUY: "إعادة تحميل شرسة",
  T_23_D_CHARACTER_HAYATO_AWAKENING_N: "هياتو الجمر",
  T_23_D_CHARACTER_SWATGUY_N: "جاي",
  T_23_L_F_B_GANGSTERRAP_GOLD: "الرابر الذهبية (أسفل)",
  T_23_L_F_B_MIKOGIRL: "حكيمة القطب الشمالي (أسفل)",
  T_23_L_F_B_NAVYGIRL: "فتاة البحرية (أسفل)",
  T_23_L_F_H_GANGSTERRAP_GOLD: "الرابر الذهبية (رأس)",
  T_23_L_F_H_MIKOGIRL: "حكيمة القطب الشمالي (رأس)",
  T_23_L_F_H_NAVYGIRL: "فتاة البحرية (رأس)",
  T_23_L_F_S_MIKOGIRL: "حكيمة القطب الشمالي (حذاء)",
  T_23_L_F_S_ORDERCHALLENGER: "العقل المدبر (حذاء)",
  T_23_L_F_T_GANGSTERRAP_GOLD: "الرابر الذهبية (أعلى)",
  T_23_L_F_T_MIKOGIRL: "حكيمة القطب الشمالي (أعلى)",
  T_23_L_F_T_NAVYGIRL: "فتاة البحرية (أعلى)",
  T_23_L_M_A_GANGSTERRAP_GOLD: "الرابر الغني (قناع)",
  T_23_L_M_B_FOXGUY: "حكيم القطب الشمالي (أسفل)",
  T_23_L_M_B_GANGSTERRAP_GOLD: "الرابر الغني (أسفل)",
  T_23_L_M_H_FOXGUY: "حكيم القطب الشمالي (رأس)",
  T_23_LC_SKS_GEMINI_N: "SKS - مهووس هستيري",
  T_23_O_PENGUIN_NAME: "السيد واجر",
  T_23_O_PETSKIN_PENGUIN_A_NAME: "سكن الحيوان الأليف: واجر المحتفل",
  T_23_O_PETSKIN_PENGUIN_C_NAME: "سكن الحيوان الأليف: واجر الصاخب",
  T_23_O_PETSKIN_PENGUIN_G_NAME: "سكن الحيوان الأليف: واجر الذهبي",
  T_23_T_ANNI3_LOBBY_NODENAME20: "كلاش سكواد",
  T_23_T_ANNI3_LOBBY_NODENAME5: "شخصية",
  T_23_U_AUG: "AUG",
  T_23_Z_R_UID: "أي دي",
  T_24_AD_ADSPACE_WARNING: "تحذير",
  T_24_C_FLAMETHROWER_NAME: "قاذف اللهب",
  T_24_C_SKILL_DESC_PROFESSOR: "زيادة نقاط EP بحد أقصى بمقدار [FFB300]{0}[-]. وضع جوجيتسو: يحصل الحلفاء في نطاق [FFB300]{2}م[-] متر على زيادة بنسبة [FFB300]{1}%[-] في معدل تحويل EP.  وضع علم النفس: استرجاع [FFB300]{5} نقاط EP[-] كل [FFB300]{4}ث[-]، حتى [FFB300]{6} نقاط EP[-]. وضع التهدئة: [FFB300]{3}ث[-].",
  T_24_C_SKILL_NAME_PARTYGIRL: "الإحتفال الدائم",
  T_24_C_SKILL_NAME_PROFESSOR: "سيد الكل",
  T_24_D_CHARACTER_PARTYGIRL_N: "داشا",
  T_24_D_CHARACTER_PROFESSOR_N: "كي",
  T_24_L_B_MAXPANTS: "بنطال ماكس",
  T_24_L_H_PUMPKIN2020_A: "اليقطين المختل (رأس)",
  T_24_L_T_TSHIRT_COMEDIAN: "بطل الفرصة الأحيرة",
  T_24_LC_MP5_RICHBOXER_N: "MP5 - بطل الملاكمة",
  T_24_LC_SCAR_PARTYGIRL_N: "SCAR - الإحتفال الشرس",
  T_24_LC_SVD_WARRINGSTATES_N: "SVD - أسطورة السيافين",
  T_24_U_M21A5: "النقار",
  T_24_U_PARAFAL: "بارافال",
  T_24_V_TRAINING_AIMBOT_GAMESCORE: "النتيجة",
  T_24_V_TRAINING_BOX_ATTACH: "المرفقات",
  T_24_V_TRAINING_BOX_WEAPON: "اسلحة",
  T_24_W_ARMORY: "أسلحة",
  T_24_W_ARMOTY_MELEE: "سلاح المشاجرة",
  T_24_W_ARMOTY_PISTOL: "مسدسات",
  T_24_W_ARMOTY_RIFLE: "بنادق",
  T_24_W_ARMOTY_SHOTGUN: "شوتجن",
  T_24_W_ARMOTY_SNIPER: "قناصة",
  T_24_W_ARMOTY_SPECIAL: "أخرى",
  T_24_W_ARMOTY_SUBMACHINE: "رشاش خفيف",
  T_24_W_PETSKIN_PANDA_BOOYAHDAY_N: "سكن الحيوان الأليف: بندا بوياه",
  T_24_W_PETSKIN_RACCOON_BRIGHT_N: "سكن الحيوان الأليف: جمجمة روكي",
  T_24_W_PETSKIN_RACCOON_MECH_N: "سكن الحيوان الأليف: روكي المحتفل",
  T_24_W_PETSKIN_RACCOON_UNDEAD_N: "سكن الحيوان الأليف: روكي المميت",
  T_24_W_RACCOON_N: "روكي",
  T_25_C_SKILL_NAME_BOUNTYHUNTER: "مسيطر الزمن",
  T_25_D_CHARACTER_BOUNTY_N: "كرونو",
  T_25_E_HUD_01: "الإعداد المسبق 1",
  T_25_E_HUD_02: "الإعداد المسبق 2",
  T_25_L_F_B_DEMONKILLER: "طالبة الثانوية الغاضبة (سفلي)",
  T_25_L_F_H_DEMONKILLER: "طالبة الثانوية الغاضبة (رأس)",
  T_25_L_F_S_DEMONKILLER: "طالبة الثانوية الغاضبة (حذاء)",
  T_25_L_F_T_DEMONKILLER: "طالبة الثانوية الغاضبة (علوي)",
  T_25_L_HA_FP_EVIL: "الشرير (طلاء وجه)",
  T_25_L_M_H_ANIMEHAIR: "النسيم (شعر)",
  T_25_L_S_MAXSNEAKERS: "حذاء ماكس",
  T_25_LC_BASEBALLBAT_BOUNTY_N: "مضرب - تأرجح تقني",
  T_25_LC_GLOO_WINTERFEST2020_N: "جدار جلو - أرض الشتاء 2020",
  T_25_LC_M1887_WINTERFEST2020_N: "M1887 - أرض الشتاء 2020",
  T_25_LC_MACHETE_BOUNTY_N: "شفرة - التقنية",
  T_25_LC_P90_MUSICFALL_GREEN_N: "P90 - النغم الصاخب الأخضر",
  T_25_LC_P90_MUSICFALL_RED_N: "P90 - النغم الصاخب الأحمر",
  T_25_LC_PAN_BOUNTY_N: "مقلاة - الصائد التقني",
  T_25_R_LEGEND_REMIND: "تذكير",
  T_25_U_MAG7: "MAG-7",
  T_25_U_SICKLE: "منجل",
  T_25_U_VECTOR: "فكتور",
  T_25_W_BABOON_N: "بيستون",
  T_25_W_PETSKIN_BABOON_FROZEN_N: "سكن حيوان أليف: بيستون الجليدي",
  T_25_W_PETSKIN_BABOON_HELL_N: "سكن حيوان أليف: بيستون المتوهج",
  T_25_W_PETSKIN_BABOON_PURE_N: "سكن حيوان أليف: بيستون الأبيض العظيم",
  T_25_W_PETSKIN_PANTHER_WINTERFEST2020_N: "سكن الحيوان الأليف: النمر الثلجي",
  T_25_Z_R_SIMULATOR_OFF: "عدم السماح",
  T_26_C_SKILL_DESC_SUPERSTAR: "يطلق العنان لموجة صوتية للأمام لمسافة [FFB300]{0}م[-]. تنفجر الموجة وتسبب ضررًا لجدران الجلو بنصف قطرها [FFB300]{1}م[-] لمدة [FFB300]{2}ث[-]. التهدئة: [FFB300]{3}ث[-].",
  T_26_C_SKILL_NAME_SUPERSTAR: "تيار الإيقاع",
  T_26_D_CHARACTER_DELIVERY_N: "شيرو",
  T_26_D_CHARACTER_SUPERSTAR_N: "سكايلر",
  T_26_ET_CELLPHONE_NAME: "الدرون-لايت",
  T_26_L_A_FLAMING_PREM: "الجندي المشتعل (قناع)",
  T_26_L_A_SANTAMODE: "الرجل الثلجي بوب (قناع)",
  T_26_L_B_SANTAMODE: "الرجل الثلجي بوب (سفلي)",
  T_26_L_F_B_WATERFEST21_A: "نسيم الصيف (سفلي)",
  T_26_L_F_H_WATERFEST21_A: "نسيم الصيف (رأس)",
  T_26_L_F_S_WATERFEST21_A: "نسيم الصيف (حذاء)",
  T_26_L_F_T_WATERFEST21_A: "نسيم الصيف (علوي)",
  T_26_L_M_A_EGGDAY2021: "الأرنب الإلكتروني (قناع)",
  T_26_L_M_B_EGGDAY2021: "الأرنب الإلكتروني (سفلي)",
  T_26_L_M_B_PAIRING: "ذكر الثنائي الديناميكي  (سفلي)",
  T_26_L_M_B_WATERFEST21_A: "موج الصيف (سفلي)",
  T_26_L_M_H_EGGDAY2021: "الأرنب الإلكتروني (رأس)",
  T_26_L_M_H_PAIRING: "ذكر الثنائي الديناميكي  (رأس)",
  T_26_L_M_H_WATERFEST21_A: "موج الصيف (رأس)",
  T_26_L_M_S_EGGDAY2021: "الأرنب الإلكتروني (حذاء)",
  T_26_L_M_S_PAIRING: "ذكر الثنائي الديناميكي  (حذاء)",
  T_26_L_M_S_WATERFEST21_A: "موج الصيف (حذاء)",
  T_26_L_M_T_EGGDAY2021: "الأرنب الإلكتروني (علوي)",
  T_26_L_M_T_PAIRING: "ذكر الثنائي الديناميكي  (علوي)",
  T_26_L_M_T_WATERFEST21_A: "موج الصيف (علوي)",
  T_26_L_S_SANTAMODE: "الرجل الثلجي بوب (حذاء)",
  T_26_L_T_SANTAMODE: "الرجل الثلجي بوب (علوي)",
  T_26_LC_AWM_KOICARP_N: "AWM - كوي المحظوظ",
  T_26_LC_KATANA_VALENTINE2021_N: "كاتانا - الموسم الوردي",
  T_26_LC_VEHICLE_ROADSTER_COBRA_N: "سيارة رياضية - كوبرا",
  T_26_P_SKILL_NAME_DELIVERY: "تم توريد الضرر",
  T_26_V_TRAINING_BHH: "المطرقة الساحرة",
  T_26_V_TRAINING_DICE: "النرد العملاق",
  T_26_W_DRAGON_N: "دريكي",
  T_26_W_PETSKIN_DRAGON_EVIL_N: "سكن الحيوان الأليف: دريكي المضيء",
  T_26_W_PETSKIN_DRAGON_GOLDEN_N: "سكن الحيوان الأليف: بريق دريكي",
  T_26_W_PETSKIN_DRAGON_PURPLE_N: "سكن الحيوان الأليف: مجرة دريكي",
  T_26_W_PETSKIN_PENGUIN_VALENTINE2021_N: "سكن الحيوان الأليف: واجر الحب",
  T_26_XL_SETTING_TEAMMATE_INFO: "معلومات زميل الفريق",
  T_26_YP_HISTORY_WIN: "الفوز",
  T_26_YP_SOCIAL_GENDER_FEMALE: "أنثى",
  T_26_YP_SOCIAL_GENDER_MALE: "ذكر",
  T_26_YP_SOCIAL_NAME: "اللقب",
  T_27_C_SKILL_DESC__RACERGIRL: "تزيد سرعة قيادة كل المركبات بنسبة [FFB300]{0}%[-]. أثناء القيادة من الصعب إستهدافك من طرف الخصم، وتقوم بتقليل الضرر الذي تستقبله بنسبة [FFB300]{1}%[-].",
  T_27_C_SKILL_DESC_BOUNTYHUNTER: "يشكل درع شفاف على شكل دائرة التي تمنع [FFB300]{0} ضرر[-]. عند تشغيل الدرع لا تستطيع إلحاق الضرر بالأعداء من الداخل. يدوم الدرع لمدة [FFB300]{1}ث[-]. التهدئة [FFB300]{2}ث[-].",
  T_27_C_SKILL_DESC_FALCONER: "كلما زادت المسافة زاد معها الضرر حتى [FFB300]{0}%[-]. يزداد الضرر على الأعداء الذين عليهم علامة بنسبة [FFB300]{1}%[-].",
  T_27_C_SKILL_DESC_HAYATO_AWAKENING: "الصحوة: تقلل الضرر الأمامي بنسبة [FFB300]{1}%[-] مقابل كل [FFB300]{0}%[-] من الصحة المفقودة.",
  T_27_C_SKILL_DESC_KELLY_AWAKENING: "الصحوة: اركض بسرعة لمدة [FFB300]{0}ث[-] للتفعيل. عند التفعيل، تسبب الطلقات [FFB300]{2}[-] الأولى على الهدف [FFB300]{1}%[-] من الضرر. يستمر لمدة [FFB300]{3}ث[-].",
  T_27_C_SKILL_NAME_FALCONER: "الصقار المتوهج",
  T_27_C_SKILL_NAME_XTREME: "اللقاء الشديد",
  T_27_D_CHARACTER_ANDREW_AWAKENING_N: 'أندرو "الشرس"',
  T_27_D_CHARACTER_FALCONER_N: "مارو",
  T_27_D_CHARACTER_XTREME_N: "زينه",
  T_27_F_EAP_PKG3_D: "قاتل بأسلوبك!",
  T_27_HYL_SKILLBOARD_HP: "HP",
  T_27_L_A_CARDBOARD_MID2: "النمر الورقي (قناع)",
  T_27_L_B_CARDBOARD_REG: "الدب الورقي (سفلي)",
  T_27_L_M_S_KAZAKHSTAN: "الباغتور (حذاء)",
  T_27_L_S_CARDBOARD_REG: "الدب الورقي (حذاء)",
  T_27_L_T_CARDBOARD_REG: "الدب الورقي (علوي)",
  T_27_LC_VECTOR_FFWS2021_N: "فكتور - البطولة العالمية 2021",
  T_27_LC_VEHICLE_MONSTER_FFWS2021_N: "شاحنة متوحشة - البطولة العالمية 2021",
  T_27_LC_VEHICLE_MOTOBIKE_BOXER_N: "دراجة نارية - الليلة الحاسمة",
  T_27_LC_VEHICLE_ROADSTER_FASTBREAKING_N: "سيارة رياضية - الأمل",
  T_27_LC_VEHICLE_SUV_DRAGON_N: "شاحنة - شعلة دراكو",
  T_27_P_SKILL_NAME_HITMAN_RE: "الصمت المميت",
  T_27_R_EMOTE_GREETING_NAME: "تحياتي",
  T_27_R_VEHICLE_ACCELERATION: "التسريع",
  T_27_R_VEHICLE_HP: "المتانة",
  T_27_R_VEHICLE_SPEED: "السرعة القصوى",
  T_27_U_KORD: "كورد",
  T_27_U_M1917: "M1917",
  T_27_U_SKILL_DESC_ANDREW_AWAKENING: "الصحوة: تعزيز تقليل ضرر الدرع بنسبة [FFB300]{0}%[-]. تقليل ضرر إضافي بنسبة [FFB300]{1}%[-] لكل زميل في نطاق [FFB300]{2}م[-].",
  T_27_U_SKILL_NAME_ANDREW_AWAKENING: "حزمة الذئب",
  T_27_U_WSP: "USP-2",
  T_27_W_ALIEN_N: "مووني",
  T_27_W_ARMOTY_DMR: "بندقية الرامي",
  T_27_W_PETSKIN_ALIEN_CRYSTAL_N: "سكن الحيوان الأليف: مووني الكريستالي",
  T_27_W_PETSKIN_ALIEN_GAMER_N: "سكن الحيوان الأليف: مووني الجيمر",
  T_27_W_PETSKIN_ALIEN_HIPSTER_N: "سكن الحيوان الأليف: مووني الأنيق",
  T_27_W_PETSKIN_DOG_FFWS2021_N: "سكن الحيوان الأليف: جرو البطولة العالمية 2021",
  T_27_W_PETSKIN_PANDA_FFWS2021_N: "سكن الحيوان الأليف: باندا البطولة العالمية 2021",
  T_27_XC_REPLAY_DIE: "موت",
  T_27_XC_REPLAY_KILL: "قتل",
  T_27_XL_WEREWOLVES_INGAME_REPAIR: "إصلاح",
  T_28_C_G_ICE_NAME: "فلاش المتجمد",
  T_28_C_SKILL_DESC_STREETBEAT: "عند إطلاق النار أثناء الحركة، تزداد سرعة الحركة بنسبة [FFB300]{0}%[-]، وتزيد الدقة بنسبة [FFB300]{1}%[-].",
  T_28_C_SKILL_NAME_STREETBEAT: "نغمات الرصاص",
  T_28_D_CHARACTER_STREETBEAT_N: "دي بي",
  T_28_HI_UZI: "أوزي الصغير",
  T_28_L_B_BRJERSEY_A: "زي كرة القدم رقم 24 (سفلي)",
  T_28_L_B_BRJERSEY_B: "زي كرة القدم رقم 10 (سفلي)",
  T_28_L_B_BRJERSEY_C: "زي كرة القدم رقم 24 (سفلي)",
  T_28_L_B_BRJERSEY_D: "زي كرة القدم رقم 30 (سفلي)",
  T_28_L_B_BRJERSEY_E: "زي كرة القدم رقم 1 (سفلي)",
  T_28_L_B_BRJERSEY_F: "زي كرة القدم رقم 20 (سفلي)",
  T_28_L_F_B_FOURSYMBOLS_C: "الزوبعة القرمزية (سفلي)",
  T_28_L_F_H_FOURSYMBOLS_C: "الزوبعة القرمزية (رأس)",
  T_28_L_F_HA_FOURSYMBOLS_C: "الزوبعة القرمزية (طلاء وجه)",
  T_28_L_F_S_FOURSYMBOLS_C: "الزوبعة القرمزية (حذاء)",
  T_28_L_F_T_FOURSYMBOLS_C: "الزوبعة القرمزية (علوي)",
  T_28_L_HA_THUNDER: "عين البرق (طلاء وجه)",
  T_28_L_M_A_SPORTSUIT: "فتى المتزلج (قناع)",
  T_28_L_M_B_FOURSYMBOLS_D: "ظلال الأرض (سفلي)",
  T_28_L_M_B_SPORTSUIT: "فتى المتزلج (سفلي)",
  T_28_L_M_H_FOURSYMBOLS_D: "ظلال الأرض (رأس)",
  T_28_L_M_H_SPORTSUIT: "فتى المتزلج (رأس)",
  T_28_L_M_S_FOURSYMBOLS_D: "ظلال الأرض (حذاء)",
  T_28_L_M_S_SPORTSUIT: "فتى المتزلج (حذاء)",
  T_28_L_M_T_FALLWINTER: "الراقص الوردي (علوي)",
  T_28_L_M_T_FOURSYMBOLS_D: "ظلال الأرض (علوي)",
  T_28_L_M_T_SPORTSUIT: "فتى المتزلج (علوي)",
  T_28_L_T_BRJERSEY_A: "زي كرة القدم رقم 23 (علوي)",
  T_28_L_T_BRJERSEY_B: "زي كرة القدم رقم 10 (علوي)",
  T_28_L_T_BRJERSEY_C: "زي كرة القدم رقم 24 (علوي)",
  T_28_L_T_BRJERSEY_D: "زي كرة القدم رقم 30 (علوي)",
  T_28_L_T_BRJERSEY_E: "زي كرة القدم رقم 1 (علوي)",
  T_28_L_T_BRJERSEY_F: "زي كرة القدم رقم 20 (علوي)",
  T_28_LC_AN94_CRIMSONBRIDE_N: "AN94 - عروسة الياقوت",
  T_28_LC_GLOO_FALLWINTER_N: "جدار جلو - الراقص الوردي",
  T_28_LC_GLOO_FOURSYMBOLS_N: "جدار جلو - جالب العاصفة",
  T_28_LC_KORD_SHINOBI_N: "كورد - شينوبي البرق",
  T_28_LC_M21A5_FANTASYEYE_N: "النقار - عديم الرحمة",
  T_28_LC_MAG7_WHITESHARK_N: "MAG-7 - الزعنف المميت",
  T_28_LC_PAN_FOURSYMBOLS_N: "مقلاة - ظلال الأرض",
  T_28_LC_VEHICLE_JEEP_FOURSYMBOLS_N: "سيارة جيب - جالب العاصفة",
  T_28_T_WS_ITEM1: "صندوق المربع",
  T_28_T_WS_ITEM10: "كوخ",
  T_28_T_WS_ITEM11: "برج الحراسة",
  T_28_T_WS_ITEM12: "المخفر",
  T_28_T_WS_ITEM13: "البيت أ",
  T_28_T_WS_ITEM14: "البيت ب",
  T_28_T_WS_ITEM15: "البيت ج",
  T_28_T_WS_ITEM16: "هيكل الرمل",
  T_28_T_WS_ITEM17: "نافورة",
  T_28_T_WS_ITEM18: "زهرة الكرز",
  T_28_T_WS_ITEM19: "شجرة الموز",
  T_28_T_WS_ITEM2: "صندوق الطويل",
  T_28_T_WS_ITEM20: "المرحاض",
  T_28_T_WS_ITEM21: "سور",
  T_28_T_WS_ITEM3: "شجيرة",
  T_28_T_WS_ITEM4: "كومة قش",
  T_28_T_WS_ITEM5: "سيارة",
  T_28_T_WS_ITEM6: "باص",
  T_28_T_WS_ITEM7: "الحاوية أ",
  T_28_T_WS_ITEM8: "الحاوية ب",
  T_28_T_WS_ITEM9: "الحاوية ج",
  T_28_T_WS_TYPE1: "عناصر",
  T_28_T_WS_TYPE4: "زينة",
  T_28_W_DUCK_N: "دكتور بيني",
  T_28_W_PETSKIN_DRAGON_FOURSYMBOLS_N: "سكن الحيوان الأليف: دريكي الأسطورة",
  T_28_W_PETSKIN_DUCK_ARMY_N: "سكن الحيوان الأليف: الرقيب بيني",
  T_28_W_PETSKIN_DUCK_BLACK_N: "سكن الحيوان الأليف: بيني الشرس",
  T_28_W_PETSKIN_DUCK_SHINY_N: "سكن الحيوان الأليف: دي جي بيني",
  T_28_YF_AR15: "الرفراف",
  T_29_C_SKILL_DESC_MOCO_AWAKENING: "الصحوة: تدوم العلامات على الأعداء المضربين لفترة أطول عندما يتحرك الأعداء (حتى [FFB300]{0}ثانية[-] لفترة أطول).",
  T_29_C_SKILL_NAME_MOCO_AWAKENING: "العين الغامضة",
  T_29_C_SKILL_NAME_MUSICBRO_BLACK: "المشاعر الحيوية",
  T_29_C_SKILL_NAME_MUSICBRO_WHITE: "نبضات قلب شافي",
  T_29_D_CHARACTER_AMOCO_N: 'موكو "الغامضة"',
  T_29_D_CHARACTER_MUSICBRO1_N: "ديميتري",
  T_29_D_CHARACTER_MUSICBRO2_N: "ثيفا",
  T_29_HI_MINI14: "AC80",
  T_29_L_B_TRJERSEY: "قميص كرة القدم المخطط (سفلي)",
  T_29_L_M_A_FALCONER_C: "الإمبراطور (قناع)",
  T_29_L_M_A_JUNGLE_GREEN: "السلحفاة المحارب (قناع)",
  T_29_L_M_B_FALCONER_C: "الإمبراطور (سفلي)",
  T_29_L_M_B_JUNGLE_GREEN: "السلحفاة المحارب (سفلي)",
  T_29_L_M_H_FALCONER_C: "الإمبراطور (رأس)",
  T_29_L_M_H_JUNGLE_GREEN: "السلحفاة المحارب (رأس)",
  T_29_L_M_S_FALCONER_C: "الإمبراطور (حذاء)",
  T_29_L_M_S_JUNGLE_GREEN: "السلحفاة المحارب (حذاء)",
  T_29_L_M_T_FALCONER_C: "الإمبراطور (علوي)",
  T_29_L_M_T_JUNGLE_GREEN: "السلحفاة المحارب (علوي)",
  T_29_L_T_TRJERSEY: "قميص كرة القدم المخطط (علوي)",
  T_29_M_WS_ITEM22: "حاوية وعرة",
  T_29_M_WS_ITEM23: "سياج وعرة",
  T_29_M_WS_ITEM24: "نقطة إنعاش أ",
  T_29_M_WS_ITEM25: "نقطة إنعاش ب",
  T_29_M_WS_TYPE5: "التفاعلات",
  T_29_W_PETSKIN_BROWN_TIGER_N: "سكن الحيوان الأليف: نمر سينسي الأرضي",
  T_29_W_PETSKIN_FIRE_TIGER_N: "سكن الحيوان الأليف: نمر سينسي المشتعل",
  T_29_W_PETSKIN_HAWK_MOCOMONTH_N: "سكن الحيوان الأليف: فالكو الآلي",
  T_29_W_PETSKIN_PANDA_MUSICFEST_N: "سكن الحيوان الأليف: باندا المحتفل",
  T_29_W_PETSKIN_WHITE_TIGER_N: "سكن الحيوان الأليف: نمر سينسي الثلجي",
  T_29_W_TIGER_NINJA_N: "نمر سينسي",
  T_29_YF_MACHETE_MUSICFEST_N: "شفرة - الموجات الصوتية",
  T_29_YF_MAGEZINE_CHAIN_N: "ذخيرة AR",
  T_29_YF_MUZZLE_CRASH_N: "فوهة SMG",
  T_29_YF_MUZZLE_WIDE_N: "فوهة الشوتجن",
  T_29_YF_SPAS12_MOCOMONTH_N: "SPAS12 - الأضواء الكونية",
  T_29_YF_UZI_GOLDENWING_N: "أوزي الصغير - العنبر الذهبي",
  T_29_YF_VEHICLE_MONSTER_SKELETONTRUCK_N: "شاحنة متوحشة - القضمة البشعة",
  T_30_AD_RP_ROUNDEND: "نهاية الجولة",
  T_30_AD_TRAINING_SNOWBALL: "كرة الثلج",
  T_30_AD_TRAINING_SNOWBALL_DES: "دعونا نخوض معركة بكرات الثلج!",
  T_30_C_SKILL_DESC_BOOYAHGUY: "[FFB300]{0}ث[-] بعد التعرض للهجوم، قم باستعادة [FFB300]{1}نقاط الصحة[-]/ث في [FFB300]{2}ث[-]",
  T_30_C_SKILL_NAME_BOOYAHGUY: "خافق الجرس",
  T_30_C_SKILL_NAME_MUERTOGUY: "ضباب الذاكرة",
  T_30_D_CHARACTER_BOOYAHGUY_N: "ليون",
  T_30_D_CHARACTER_MUERTOGUY_N: "أودو",
  T_30_JMF_SKILLCHIP_NAME_SWATGUY: "رقاقة جاي",
  T_30_L_A_BRMASCOT_ADULT: "رأس الكتكوت الغاضب",
  T_30_L_A_BRMASCOT_KIDS: "رأس الكتكوت اللطيف",
  T_30_L_A_SUGARSKULL21_BANDANA: "قناع عضة الموت",
  T_30_L_B_BRFOOTBALL_BLACK: "قميص كرة القدم CBF - أسود (سفلي)",
  T_30_L_B_BRFOOTBALL_GREEN: "قميص كرة القدم CBF - الأخضر (سفلي)",
  T_30_L_B_BRFOOTBALL_GREY: "قميص كرة القدم CBF - رمادي (سفلي)",
  T_30_L_B_BRUNIFORM: "الكناري الصغير (سفلي)",
  T_30_L_F_A_SUGARSKULL21: "ملكة القناع الذهبي (قناع)",
  T_30_L_F_B_SUGARSKULL21: "ملكة القناع الذهبي (سفلي)",
  T_30_L_F_B_THASIAN: "المتمردة المرجانية (سفلي)",
  T_30_L_F_H_CATEARS: "آذان كاواي",
  T_30_L_F_H_SUGARSKULL21: "ملكة القناع الذهبي (رأس)",
  T_30_L_F_H_THASIAN: "المتمردة المرجانية (رأس)",
  T_30_L_F_S_SUGARSKULL21: "ملكة القناع الذهبي (حذاء)",
  T_30_L_F_S_THASIAN: "المتمردة المرجانية (حذاء)",
  T_30_L_F_T_SUGARSKULL21: "ملكة القناع الذهبي (علوي)",
  T_30_L_F_T_THASIAN: "المتمردة المرجانية (علوي)",
  T_30_L_H_CHILDRENSDAY_BLUE: "رأس الدولفين",
  T_30_L_H_CHILDRENSDAY_RED: "رأس الفيل",
  T_30_L_H_CLOWNHAT: "قبعة السيرك - صفراء",
  T_30_L_H_ZASCARF: "وشاح ذهبي جريء",
  T_30_L_M_A_LIGHTFEST_GANGSTER: "منتدى العصابات (قناع)",
  T_30_L_M_A_SUGARSKULL21: "ملك القناع الذهبي (قناع)",
  T_30_L_M_B_LIGHTFEST_GANGSTER: "منتدى العصابات (سفلي)",
  T_30_L_M_B_PKCRICKET: "بطل باللون الأخضر (سفلي)",
  T_30_L_M_B_SUGARSKULL21: "ملك القناع الذهبي (سفلي)",
  T_30_L_M_B_SUGARSKULL21_CASUAL: "مسابق الريح (سفلي)",
  T_30_L_M_B_THASIAN: "المرجان المتمرد (سفلي)",
  T_30_L_M_H_LIGHTFEST_GANGSTER: "منتدى العصابات (رأس)",
  T_30_L_M_H_SUGARSKULL21: "ملك القناع الذهبي (رأس)",
  T_30_L_M_H_SUGARSKULL21_CASUAL: "مسابق الريح (رأس)",
  T_30_L_M_H_THASIAN: "المرجان المتمرد (رأس)",
  T_30_L_M_HA_BOOYAHDAY21_YELLOW: "الحارس العظمي ألفا (طلاء وجه)",
  T_30_L_M_S_LIGHTFEST_GANGSTER: "منتدى العصابات (حذاء)",
  T_30_L_M_S_PKCRICKET: "بطل باللون الأخضر (حذاء)",
  T_30_L_M_S_SUGARSKULL21: "ملك القناع الذهبي (حذاء)",
  T_30_L_M_S_SUGARSKULL21_CASUAL: "مسابق الريح (حذاء)",
  T_30_L_M_S_THASIAN: "المرجان المتمرد (حذاء)",
  T_30_L_M_T_LIGHTFEST_GANGSTER: "منتدى العصابات (علوي)",
  T_30_L_M_T_PKCRICKET: "بطل باللون الأخضر (علوي)",
  T_30_L_M_T_SUGARSKULL21: "ملك القناع الذهبي (علوي)",
  T_30_L_M_T_SUGARSKULL21_CASUAL: "مسابق الريح (علوي)",
  T_30_L_M_T_THASIAN: "المرجان المتمرد (علوي)",
  T_30_L_S_BRUNIFORM: "الكناري الصغير (حذاء)",
  T_30_L_T_BRFOOTBALL_BLACK: "قميص كرة القدم CBF - أسود (علوي)",
  T_30_L_T_BRFOOTBALL_GREEN: "قميص كرة القدم CBF - الأخضر (علوي)",
  T_30_L_T_BRFOOTBALL_GREY: "قميص كرة القدم CBF - رمادي (علوي)",
  T_30_L_T_BRUNIFORM: "الكناري الصغير (علوي)",
  T_30_M_WS_PARTY_MODE: "ساحة اللعب",
  T_30_R_EMOTE_BATTLEINSTYLE_NAME: "BATTLE IN STYLE",
  T_30_R_EMOTE_BOOYAHDAY21_PROVOCATION_NAME: "المتحدي",
  T_30_R_EMOTE_MAX_NAME: "أناقة الرابر",
  T_30_R_LEGEND_HALO_NAME: "دائرة حرارية",
  T_30_T_WS_DEFAULTDESCRIPTION: "خريطة مثيرة في فري فاير أرض الحِرف",
  T_30_T_WS_ITEM26: "الإطارات",
  T_30_T_WS_ITEM27: "الإطارات الفوضوية أ",
  T_30_T_WS_ITEM28: "الإطارات الفوضوية ب",
  T_30_T_WS_ITEM29: "الإطارات الفوضوية ج",
  T_30_T_WS_ITEM30: "سيارة تصادم",
  T_30_T_WS_ITEM31: "سيارة برمائية",
  T_30_T_WS_ITEM32: "سيارة جيب",
  T_30_T_WS_ITEM33: "سلة مهملات",
  T_30_T_WS_ITEM34: "ظل",
  T_30_T_WS_ITEM35: "خيمة طبية",
  T_30_T_WS_ITEM36: "كراج",
  T_30_T_WS_ITEM37: "جدران مطلية",
  T_30_T_WS_ITEM38: "توري",
  T_30_T_WS_ITEM39: "منصة حديدية",
  T_30_T_WS_ITEM40: "كوخ الموقع",
  T_30_T_WS_ITEM41: "مقطورة",
  T_30_T_WS_ITEM42: "الجدار أ",
  T_30_T_WS_ITEM43: "الجدار ب",
  T_30_T_WS_ITEM44: "الجدار ج",
  T_30_T_WS_ITEM45: "الجدار د",
  T_30_T_WS_ITEM46: "الجدار هـ",
  T_30_T_WS_ITEM47: "جدار و",
  T_30_U_ATTACHMENT_1: "معزز الدرع",
  T_30_U_ATTACHMENT_4: "توسعة السترة",
  T_30_U_ATTACHMENT_5: "مثخن خوذة",
  T_30_U_ATTACHMENT_6: "سترة مثخنة",
  T_30_W_PETSKIN_BABOON_SUGARSKULL21_N: "سكن الحيوان الأليف: جمجمة بيستون",
  T_30_W_PETSKIN_PENGUIN_EVILRHYTHM_N: "سكن الحيوان الأليف: واجر الروك",
  T_30_W_PETSKIN_RABBIT_BULLSEYE_N: "سكن الحيوان الأليف: العميلة هوب الهدّافة",
  T_30_W_PETSKIN_RABBIT_CLOWN_N: "سكن الحيوان الأليف: العميل أرنوب الكارنيفال",
  T_30_W_PETSKIN_RABBIT_URBAN_N: "سكن الحيوان الأليف: العميلة هوب التقني",
  T_30_W_PETSKIN_ROBOT_TRNAZAR_N: "سكن الحيوان الأليف: نزار روبو",
  T_30_W_PETSKIN_ROBOT_VNDRINK_N: "سكن الحيوان الأليف: روبو الأخضر المتجمد",
  T_30_W_RABBIT_N: "العميلة هوب",
  T_30_XH_PCMAP_P17: "فاكتوري",
  T_30_YF_GLOO_BOOYAHDAY21_N: "جدار جلو  - يوم بوياه 2021",
  T_30_YF_GRENADE_BOOYAHDAY21_N: "قنبلة - يوم بوياه 2021",
  T_30_YF_Healinggun_Sniper_N: "قناص العلاج",
  T_30_YF_MINI_LIGHTFEST_N: "AC80 - المحارب الملكي",
  T_30_YF_PARAFAL_ZATRIBAL_N: "بارافال - الوريث القرمزي",
  T_30_YF_SCAR_LIGHTFEST_N: "SCAR - المحارب الملكي",
  T_30_YF_THOMPSON_SUGARSKULL21_N: "طومسون - القناع الذهبي",
  T_30_YF_VEHICLE_ROADSTER_EVILRHYTHM_N: "سيارة رياضية - صاحب الجمجمة",
  T_31_C_SKILL_NAME_WINTERGUY: "الثلج الحديدي",
  T_31_HQ_BASEBALLBAT_WINTERFEST21_N: "مضرب - الشتاء",
  T_31_HQ_GLOO_EAGLE_N: "جدار جلو - الرمال الحارقة",
  T_31_HQ_HEALINGSNIPER_WINTERFEST21_N: "قناص العلاج - عظام الجليد",
  T_31_HQ_KATANA_WINTERFEST21_N: "كاتانا - حطام الثلج",
  T_31_HQ_PAN_WINTERFEST21_N: "مقلاة - حطام الثلج",
  T_31_HQ_PETSKIN_OTTER_WINTERFEST21_N: "سكن الحيوان الأليف: أوترو الثلجي",
  T_31_HQ_PETSKIN_PENGUIN_WINTERFEST21_N: "سكن الحيوان الأليف: واجر على الثلج",
  T_31_HQ_PETSKIN_YETI_GREEN_N: "سكن حيوان أليف: قبيلة ياتي",
  T_31_HQ_PETSKIN_YETI_RED_N: "سكن حيوان أليف: ياتي الملكي",
  T_31_HQ_SICKLE_WINTERFEST21_N: "منجل - الثلج",
  T_31_HQ_VEHICLE_MOTOBIKE_NEWYEAR21_N: "دراجة نارية - إزدهار الجليد",
  T_31_HQ_YETI_N: "ياتي",
  T_31_KK_WINTER_BUJIX: "صندوق الإمداد",
  T_31_KK_WINTER_SANJITOU: "خوذة",
  T_31_L_A_BDCRICKET: "انتصار الضارب (قناع)",
  T_31_L_A_WINTERFEST21: "وشاح الرنة",
  T_31_L_B_BDCRICKET: "انتصار الضارب (سفلي)",
  T_31_L_B_MEJERSEY_10: "قميص كرة رقم 10 الياقوتي (سفلي)",
  T_31_L_B_MEJERSEY_11: "قميص كرة رقم 11 الأحمر (سفلي)",
  T_31_L_B_MEJERSEY_13: "قميص كرة رقم 13 الأبيض (سفلي)",
  T_31_L_B_MEJERSEY_18G: "قميص الكرة رقم 18 الأخضر (سفلي)",
  T_31_L_B_MEJERSEY_18R: "قميص الكرة رقم 18 القرمزي (سفلي)",
  T_31_L_B_MEJERSEY_7: "قميص كرة رقم 7 الريحان (سفلي)",
  T_31_L_F_B_RUMUSICIAN: "المصيدة المربوطة (سفلي)",
  T_31_L_F_B_THAGENT: "المستكشفة الليلية (سفلي)",
  T_31_L_F_H_REGGAETON_HEADWEAR: "قبعة دلو مصبوغة",
  T_31_L_F_H_RUMUSICIAN: "المصيدة المربوطة (رأس)",
  T_31_L_F_H_THAGENT: "المستكشفة الليلية (رأس)",
  T_31_L_F_HA_RUMUSICIAN: "المصيدة المربوطة (طلاء وجه)",
  T_31_L_F_S_RUMUSICIAN: "المصيدة المربوطة (حذاء)",
  T_31_L_F_S_THAGENT: "المستكشفة الليلية (حذاء)",
  T_31_L_F_T_RUMUSICIAN: "المصيدة المربوطة (علوي)",
  T_31_L_F_T_THAGENT: "المستكشفة الليلية (علوي)",
  T_31_L_HA_RUMUSICIAN_MU: "شريط الفخ (طلاء وجه)",
  T_31_L_HA_WINTERFEST21_BLUE: "طلاء للوجه المهرج المجمد",
  T_31_L_HA_WINTERFEST21_PINK: "طلاء وجه الألعاب النارية",
  T_31_L_M_A_REGGAETON_B: "نيون ريجيتون (قناع)",
  T_31_L_M_A_REGGAETON_P: "الغرور النابض (قناع)",
  T_31_L_M_A_RUMUSICIAN: "الكمين المربوط (قناع)",
  T_31_L_M_A_THAGENT: "المستكشف الليلي (قناع)",
  T_31_L_M_B_PKCOSTUME: "الذكي باللون الأخضر (سفلي)",
  T_31_L_M_B_REGGAETON_B: "نيون ريجيتون (سفلي)",
  T_31_L_M_B_REGGAETON_P: "الغرور النابض (سفلي)",
  T_31_L_M_B_RUMUSICIAN: "الكمين المربوط (سفلي)",
  T_31_L_M_B_THAGENT: "المستكشف الليلي (سفلي)",
  T_31_L_M_H_GREENCAP: "قبعة المنتصر",
  T_31_L_M_H_PKCOSTUME: "الذكي باللون الأخضر (رأس)",
  T_31_L_M_H_REGGAETON_B: "نيون ريجيتون (رأس)",
  T_31_L_M_H_REGGAETON_HEADWEAR: "قبعة مصبوغة",
  T_31_L_M_H_REGGAETON_P: "الغرور النابض (رأس)",
  T_31_L_M_H_RUMUSICIAN: "الكمين المربوط (رأس)",
  T_31_L_M_H_THAGENT: "المستكشف الليلي (رأس)",
  T_31_L_M_S_PKCOSTUME: "الذكي باللون الأخضر (حذاء)",
  T_31_L_M_S_REGGAETON_B: "نيون ريجيتون (حذاء)",
  T_31_L_M_S_REGGAETON_P: "الغرور النابض (حذاء)",
  T_31_L_M_S_RUMUSICIAN: "الكمين المربوط (حذاء)",
  T_31_L_M_S_THAGENT: "المستكشف الليلي (حذاء)",
  T_31_L_M_T_PKCOSTUME: "الذكي باللون الأخضر (علوي)",
  T_31_L_M_T_REGGAETON_B: "نيون ريجيتون (علوي)",
  T_31_L_M_T_REGGAETON_P: "الغرور النابض (علوي)",
  T_31_L_M_T_REGGAETON_TATOO: "حبر فاميليا",
  T_31_L_M_T_RUMUSICIAN: "الكمين المربوط (علوي)",
  T_31_L_M_T_THAGENT: "المستكشف الليلي (علوي)",
  T_31_L_S_BDCRICKET: "انتصار الضارب (حذاء)",
  T_31_L_T_BDCRICKET: "انتصار الضارب (علوي)",
  T_31_L_T_BRBANK: "الجاكيت الكستنائي",
  T_31_L_T_MEJERSEY_10: "قميص كرة رقم 10 الياقوتي (علوي)",
  T_31_L_T_MEJERSEY_11: "قميص كرة رقم 11 الأحمر (علوي)",
  T_31_L_T_MEJERSEY_13: "قميص كرة رقم 13 الأبيض (علوي)",
  T_31_L_T_MEJERSEY_18G: "قميص الكرة رقم 18 الأخضر (علوي)",
  T_31_L_T_MEJERSEY_18R: "قميص الكرة رقم 18 القرمزي (علوي)",
  T_31_L_T_MEJERSEY_7: "قميص كرة رقم 7 الريحان (علوي)",
  T_31_L_T_PKMOBILE: "قميص انفنكس",
  T_31_L_T_REGGAETON_HOOD: "جاكيت ابتسامة العصابة",
  T_31_MF_CHARACTER_WINTERGUY_N: "نايري",
  T_31_R_EMOTE_FALCONER_NAME: "رقم 1",
  T_31_RW_COMBINEMACHINE_2: "منشط الثنائي (متقدم)",
  T_31_RW_VIBRATION_EXPLOSION: "انفجارات",
  T_31_RW_VIBRATION_MELEEWEAPONS: "أسلحة المشاجرة",
  T_31_RW_VIBRATION_OTHERWEAPONS: "أسلحة أخرى",
  T_31_T_WS_1PLAYERTEAM: "فردي",
  T_31_T_WS_2PLAYERTEAM: "ثنائي",
  T_31_T_WS_3PLAYERTEAM: "ثلاثي",
  T_31_T_WS_4PLAYERTEAM: "سكواد",
  T_31_T_WS_5PLAYERTEAM: "ضد 5",
  T_31_T_WS_6PLAYERTEAM: "ضد 6",
  T_31_T_WS_BUFFTIME_TITLE: "وقت التحديث (ث)",
  T_31_T_WS_BUFFTYPE_AMMO: "ذخيرة",
  T_31_T_WS_BUFFTYPE_ARMOR: "درع",
  T_31_T_WS_BUFFTYPE_HP: "نقاط الصحة",
  T_31_T_WS_BUFFTYPE_RANDOM: "عشوائي",
  T_31_T_WS_BUFFTYPE_TITLE: "نوع المقوي",
  T_31_T_WS_DESC48: "يأخذك إلى مكان آخر في غضون أجزاء من الثانية",
  T_31_T_WS_DESC49: "يصدر صوت البيانو",
  T_31_T_WS_DESC51: "يصدر صوت طبل",
  T_31_T_WS_DESC53: "يخلق صوت جهاز مزج الموسيقى",
  T_31_T_WS_DESC59: "جهاز يقوم بشكل دوري بتوليد المقوي. احصل عليه للحصول على التحسين المقابل",
  T_31_T_WS_DRUMTYPE_CLAPS: "صفق",
  T_31_T_WS_DRUMTYPE_HIHATS: "هاي هات",
  T_31_T_WS_DRUMTYPE_KICK: "ركلة طبل",
  T_31_T_WS_DRUMTYPE_OPENHIHATS: "هاي هات افتتاحية",
  T_31_T_WS_DRUMTYPE_RIDES: "ركوب الصنج",
  T_31_T_WS_DRUMTYPE_SNARES: "صفق الطبل",
  T_31_T_WS_EARLYSHRINK: "تقلص سريع",
  T_31_T_WS_ITEM48: "منفذ",
  T_31_T_WS_ITEM49: "مفتاح البيانو",
  T_31_T_WS_ITEM51: "مفتاح الطبل",
  T_31_T_WS_ITEM53: "مفتاح كومبو أ",
  T_31_T_WS_ITEM55: "مفتاح كومبو ب",
  T_31_T_WS_ITEM57: "مفتاح كومبو سي",
  T_31_T_WS_ITEM59: "مولد التقوية",
  T_31_T_WS_LATESHRINK: "تقلص متأخر",
  T_31_T_WS_ME_DAMAGE: "الأضرار التي لحقت",
  T_31_T_WS_ME_DAMAGED: "الضرر الحاصل",
  T_31_T_WS_ME_DEFAULTEPPERCENT: "نسبة EP الأولي",
  T_31_T_WS_ME_DEFAULTSAFERADIUS: "نصف قطر المنطقة الآمنة الأولى",
  T_31_T_WS_ME_EPQUICKRESTORE: "تحويل سريع لنقاط EP",
  T_31_T_WS_ME_FLOW: "وضع",
  T_31_T_WS_ME_GENERALSETTING: "عام",
  T_31_T_WS_ME_INRANDOMSPAWN: "نقطة إنعاش عشوائية",
  T_31_T_WS_ME_KILLSCORE: "مكافأة القتل",
  T_31_T_WS_ME_MAXEP: "EP القصوى",
  T_31_T_WS_ME_MAXHP: "نقاط الصحة القصوى",
  T_31_T_WS_ME_NEARTEAM: "أعضاء الفريق القريبين",
  T_31_T_WS_ME_REBIRTH: "وقت إنتظار الإنعاش",
  T_31_T_WS_ME_REBIRTHLOCATION: "موقع الإنعاش",
  T_31_T_WS_ME_SAFEZONESHRINKTIME: "وقت تقليص المنطقة",
  T_31_T_WS_ME_WINSCORE: "النتيجة الفائزة",
  T_31_T_WS_MINIZONE: "منطقة صغيرة",
  T_31_T_WS_MUSICTYPE_TITLE: "نوع الموسيقى",
  T_31_T_WS_UNLIMITEDAMMO: "ذخيرة غير محدودة",
  T_31_WT_WS_DESC1: "صندوق خشبي مربع يمكن رصه",
  T_31_WT_WS_DESC10: "كوخ قديم مع سلالم خشبية للصعود إليه",
  T_31_WT_WS_DESC11: "بنيت مع نوافذ متعددة لأغراض التصوير",
  T_31_WT_WS_DESC12: "معدنية وتحتوي على أبواب وشبابيك",
  T_31_WT_WS_DESC13: "تحتوي على أبواب ونوافذ",
  T_31_WT_WS_DESC14: "منزل من طابقين مع شرفة",
  T_31_WT_WS_DESC15: "منزل من طابقين مع سقف مغلق",
  T_31_WT_WS_DESC16: "ديكور - تمثال من الرمل على شكل قلب",
  T_31_WT_WS_DESC17: "ديكور - نافورة من المياه النقية",
  T_31_WT_WS_DESC18: "ديكور - شجرة من الزهور الوردية",
  T_31_WT_WS_DESC19: "ديكور - شجرة موز صغيرة بدون موز",
  T_31_WT_WS_DESC2: "صندوق خشبي مستطيل يمكن رصه",
  T_31_WT_WS_DESC20: "أثاث حمام أبيض يمكن وضعه في الداخل",
  T_31_WT_WS_DESC21: "سياج صغير يمكن استخدامه لتقسيم المساحات",
  T_31_WT_WS_DESC22: "يمكن كسر اللوح الخشبي الجانبي بالقوة",
  T_31_WT_WS_DESC23: "سياج صغير يمكن كسره بالقوة",
  T_31_WT_WS_DESC24: "منطقة الإحياء لفريق A (صالح فقط في أوضاع كلاش سكواد وماتش قاتل وساحة اللعب)",
  T_31_WT_WS_DESC25: "منطقة الإحياء لفريق B (صالح فقط في أوضاع كلاش سكواد وماتش قاتل وساحة اللعب)",
  T_31_WT_WS_DESC26: "يقفز اللاعبين إلى الاتجاه الذي يواجهونه لمسافة قصيرة",
  T_31_WT_WS_DESC27: "يقفز اللاعبين في الاتجاه الإعداد المسبق، لمسافة قصيرة",
  T_31_WT_WS_DESC28: "يقفز اللاعبين في الاتجاه الإعداد المسبق، لمسافة متوسطة",
  T_31_WT_WS_DESC29: "يقفز اللاعبين في الاتجاه الإعداد المسبق، لمسافة طويلة",
  T_31_WT_WS_DESC3: "مزينة بأزهار حمراء وصفراء يمكن أن تضيء ساحة المعركة",
  T_31_WT_WS_DESC30: "سيارة الوفير التي يمكن قيادتها",
  T_31_WT_WS_DESC31: "سيارة برمائية يمكن قيادتها",
  T_31_WT_WS_DESC32: "سيارة جيب يمكن قيادتها",
  T_31_WT_WS_DESC33: "مليئة بالقمامة. أقصر من الإنسان ولكن يمكن أن يوفر بعض الغطاء",
  T_31_WT_WS_DESC34: "مأوى في الهواء الطلق، مضمار سباق معدني",
  T_31_WT_WS_DESC35: "خيمة متوسطة الحجم ببابين ولكن بدون نوافذ",
  T_31_WT_WS_DESC36: "كراج كبير مبني من الطوب",
  T_31_WT_WS_DESC37: "طوب كبير يمكن استخدامه لتقسيم المساحات",
  T_31_WT_WS_DESC38: "معلم مفيد",
  T_31_WT_WS_DESC39: "منصة معدنية كبيرة يمكن استخدامها كحفر قتال رئيسي",
  T_31_WT_WS_DESC4: "أطول من الإنسان وبالتالي يمكن أن يكون بمثابة غطاء",
  T_31_WT_WS_DESC40: "تبدو كمركبة ترفيهية ولها أبواب ونوافذ متعددة",
  T_31_WT_WS_DESC41: "تبدو كمركبة ترفيهية ولها باب واحد ونوافذ متعددة",
  T_31_WT_WS_DESC42: "جدار من جانب واحد مع مدخل",
  T_31_WT_WS_DESC43: "جدار عادي من جانب واحد",
  T_31_WT_WS_DESC44: "زاوية حائط",
  T_31_WT_WS_DESC45: "زاوية حائط غير مستوية",
  T_31_WT_WS_DESC46: "زاوية حائط غير مستوية",
  T_31_WT_WS_DESC47: "زاوية حائط بها نوافذ",
  T_31_WT_WS_DESC5: "سيارة مهجورة أقصر بقليل من الإنسان ولكنها توفر بعض الغطاء",
  T_31_WT_WS_DESC6: "أطول من الإنسان وبالتالي يمكن أن يكون بمثابة غطاء",
  T_31_WT_WS_DESC7: "يفتح على كلا الطرفين ويمكن ترتيبه لتشكيل مسارات أو لتقسيم المناطق",
  T_31_WT_WS_DESC8: "يفتح من طرف واحد ويمكن استخدامه لتقسيم المناطق",
  T_31_WT_WS_DESC9: "مختومة من كلا الطرفين ويمكن استخدامها لتقسيم المناطق",
  T_31_YF_MAC10_N: "MAC10",
  T_31_YM_PIN_VEHICLE: "مركبة",
  T_31_Z_OB_UAV: "الدرون",
  T_32_C_SKILL_DESC_YAKUZA: "يندفع للأمام بسرعة كبيرة لمدة [FFB300]{0}ث[-]. يمكن تجميع هذه المهارة لما يصل إلى [FFB300]{2} استخدام[-]، مع وقت تهدئة مدتها [FFB300]{3}ث[-] بين كل استخدام. وقت تجديد الاندفاع [FFB300]{1}ث[-].",
  T_32_C_SKILL_NAME_YAKUZA: "اندفاع المتمرد",
  T_32_HQ_AUG_VNSTREET_N: "AUG - المسلحة الشرسة",
  T_32_HQ_BACKPACK_REDDRAGON_N: "حقيبة - تنين الفجرية",
  T_32_HQ_BLT_VALENTINE2022_N: "M82B - مصاص الدماء الحاقد",
  T_32_HQ_GLOO_DUNHUANG_N: "جدار جلو - البلاتيني المجمد",
  T_32_HQ_GLOO_HURRICANE_2_N: "جدار جلو - قلب الفجرية",
  T_32_HQ_GRENADE_HURRICANE_N: "قنبلة - الميكرفون النحاسي",
  T_32_HQ_MAC10_DUNHUANG_N: "MAC10 - البلاتيني المجمد",
  T_32_HQ_PETSKIN_DUCK_RED_N: "سكن الحيوان الأليف: بيني الأحمر",
  T_32_HQ_PETSKIN_TORTOISE_BLUE_N: "سكن الحيوان الأليف: فلاش الآلي",
  T_32_HQ_PETSKIN_TORTOISE_GREEN_N: "سكن الحيوان الأليف: فلاش اللاعب",
  T_32_HQ_PETSKIN_TORTOISE_RED_N: "سكن الحيوان الأليف: فلاش المحتفل",
  T_32_HQ_TORTOISE_N: "فلاش",
  T_32_HQ_VEHICLE_ROADSTER_UNDERTAKER_N: "سيارة رياضية - الرماد الأرجواني",
  T_32_L_F_A_PHARAOH: "كليوباترا الذهبية (قناع)",
  T_32_L_F_B_PHARAOH: "كليوباترا الذهبية (سفلي)",
  T_32_L_F_H_PHARAOH: "كليوباترا الذهبية (رأس)",
  T_32_L_F_HA_PHARAOH: "كليوباترا الذهبية (طلاء وجه)",
  T_32_L_F_S_PHARAOH: "كليوباترا الذهبية (حذاء)",
  T_32_L_F_T_PHARAOH: "كليوباترا الذهبية (علوي)",
  T_32_L_M_A_JUNKFOOD: "فتى البرجر (قناع)",
  T_32_L_M_A_PHARAOH: "المومياء الذهبي (قناع)",
  T_32_L_M_B_JUNKFOOD: "فتى البرجر (سفلي)",
  T_32_L_M_B_PHARAOH: "المومياء الذهبي (سفلي)",
  T_32_L_M_H_JUNKFOOD: "فتى البرجر (رأس)",
  T_32_L_M_H_PHARAOH: "المومياء الذهبي (رأس)",
  T_32_L_M_S_JUNKFOOD: "فتى البرجر (حذاء)",
  T_32_L_M_S_PHARAOH: "المومياء الذهبي (حذاء)",
  T_32_L_M_T_JUNKFOOD: "فتى البرجر (علوي)",
  T_32_L_M_T_PHARAOH: "المومياء الذهبي (علوي)",
  T_32_L_T_WHITESWEATER: "ياقة ضيقة بيضاء",
  T_32_LC_NEWVAULT_EMOTE: "رقصة",
  T_32_LO_WS_IMMORTAL: "المنطقة الخالدة",
  T_32_LO_WS_ITEM60: "أنبوب",
  T_32_LO_WS_ITEM60_DESC: "نفق قابل للسير",
  T_32_LO_WS_ITEM61: "أنبوب بشكل تي",
  T_32_LO_WS_ITEM61_DESC: "نفق قابل للسير",
  T_32_LO_WS_ITEM62: "تقاطع الأنابيب",
  T_32_LO_WS_ITEM62_DESC: "نفق متقاطع قابل للمشي",
  T_32_LO_WS_ITEM63: "ركن الأنابيب",
  T_32_LO_WS_ITEM63_DESC: "نفق بزاوية يمكن السير فيه",
  T_32_LO_WS_ITEM64: "شاحنة الطعام",
  T_32_LO_WS_ITEM64_DESC: "توقف هنا للحصول على لقمة",
  T_32_LO_WS_ITEM65: "ظلال العشب",
  T_32_LO_WS_ITEM65_DESC: "فطر كبير يمكنه حمل الإنسان",
  T_32_LO_WS_ITEM66: "علاقة",
  T_32_LO_WS_ITEM66_DESC: "يشيع في المناطق السكنية",
  T_32_LO_WS_ITEM67: "لوح خشبي",
  T_32_LO_WS_ITEM67_DESC: "تستخدم لعمل جسر خشبي بسيط",
  T_32_LO_WS_ITEM68: "شاشة شعرية",
  T_32_LO_WS_ITEM68_DESC: "إحساس شرقي",
  T_32_LO_WS_ITEM69: "عمود",
  T_32_LO_WS_ITEM69_DESC: "عادة يتم مشاهدته في مواقع البناء",
  T_32_LO_WS_ITEM70: "صبار",
  T_32_LO_WS_ITEM70_DESC: "عظيم ولكن لا يلدغ",
  T_32_LO_WS_ITEM71: "شجرة بلا أوراق",
  T_32_LO_WS_ITEM71_DESC: "شجرة عاشت لقرون",
  T_32_LO_WS_ITEM72: "الفانوس الحجري",
  T_32_LO_WS_ITEM72_DESC: "زخرفة ذات مناظر خلابة في حدائق إمبراطورية",
  T_32_LO_WS_ITEM73: "مصباح الشارع",
  T_32_LO_WS_ITEM73_DESC: "ينظر عادة في الشوارع",
  T_32_LO_WS_ITEM74: "لوحة شمسية",
  T_32_LO_WS_ITEM74_DESC: "يمتص الطاقة من ضوء الشمس",
  T_32_LO_WS_ITEM75: "مكيف A",
  T_32_LO_WS_ITEM75_DESC: "ابق باردًا في الحرارة",
  T_32_LO_WS_ITEM76: "مروحة",
  T_32_LO_WS_ITEM77: "مقلاة طائرة",
  T_32_LO_WS_ITEM78: "مكعب",
  T_32_LO_WS_ITEM79: "حلقة",
  T_32_LO_WS_ITEM80: "المطرقة",
  T_32_LO_WS_ITEM81: "لوحة",
  T_32_LO_WS_ITEM82: "هدف إطلاق النار",
  T_32_LO_WS_ITEM83: "جدار مثني",
  T_32_LO_WS_ITEM84AMMO: "نقطة غنائم الذخيرة",
  T_32_LO_WS_ITEM84AMMO_DESC: "عند وضعها، ستظهر نوع (أنواع) الذخيرة المحددة هناك",
  T_32_LO_WS_ITEM84AR: "نقطة غنائم الدرع",
  T_32_LO_WS_ITEM84AR_DESC: "عند وضعه، سيظهر نوع (أنواع) الدروع المحددة هناك",
  T_32_LO_WS_ITEM84ARLV1: "مستوى الدرع 1",
  T_32_LO_WS_ITEM84ARLV2: "مستوى الدرع 2",
  T_32_LO_WS_ITEM84ARLV3: "مستوى الدرع 3",
  T_32_LO_WS_ITEM84CO: "نقطة غنائم المواد الاستهلاكية",
  T_32_LO_WS_ITEM84CO_DESC: "عند وضعها، ستظهر نوع (أنواع) مستهلكات محددة هناك",
  T_32_LO_WS_ITEM84JA: "نقطة غنائم قابل للرمي",
  T_32_LO_WS_ITEM84JA_DESC: "عند وضعها، سيظهر النوع (الأنواع) المحددة القابلة للرمي هناك",
  T_32_LO_WS_ITEM84TE: "نقطة غنائم العدسة",
  T_32_LO_WS_ITEM84TE_DESC: "عند وضعها، سيظهر نوع (أنواع) النطاق المحدد هناك",
  T_32_LO_WS_ITEM84W: "نقطة غنائم الأسلحة",
  T_32_LO_WS_ITEM84W_DESC: "عند وضعه، سيظهر نوع (أنواع) السلاح المحدد هناك",
  T_32_LO_WS_ITEM85: "منطقة الموت/الخالدة",
  T_32_LO_WS_ITEM85_DESC: "عند وضعها، سيختبر اللاعبون الذين يدخلون منطقة الزناد تأثيرًا محددًا إما خالدًا أو مهلكًا. (غير صالح في أوضاع كلاش سكواد وماتش قاتل وساحة اللعب)",
  T_32_LO_WS_ITEM85CP: "نقطة تسجيل",
  T_32_LO_WS_ITEM85CP_DESC: "عنصر يستخدم لبناء طريقة اللعب في وضع الباركور. لكي تظهر نقطة تسجيل النهائية،  يجب أن يمر اللاعبون بكل نقطة تسجيل واحدة تلو الأخرى. عند اللإقصاء وموقع الإحياء، يمكن للاعب اختيار إعادة الظهور عند آخر نقطة تسجيل اجتازها. (غير صالح في أوضاع كلاش سكواد وماتش قاتل وساحة اللعب)",
  T_32_LO_WS_ITEM85TM: "نقطة النهاية",
  T_32_LO_WS_ITEM85TM_DESC: "عنصر يستخدم لبناء طريقة اللعب في وضع الباركور. يجب أن يصل اللاعبون إلى داخل خط النهاية حتى يكتمل الهدف. (غير صالح في أوضاع كلاش سكواد وماتش قاتل وساحة اللعب)",
  T_32_LO_WS_ITEM86: "نقطة إنعاش",
  T_32_LO_WS_ITEM86_DESC: "لن يتم تعيين فريق معين لهذه النقطة. عند وضعها، سيظهر فريق عشوائي هنا. (غير صالح في أوضاع كلاش سكواد وماتش قاتل وساحة اللعب)",
  T_32_LO_WS_ITEM86L: "نقطة إنعاش كبيرة",
  T_32_LO_WS_ITEM86L_DESC: "يوصى بنقطة إحياء كبيرة لوضع الباركور، يتم إحياء جميع اللاعبين. (غير صالح في أوضاع كلاش سكواد وماتش قاتل وساحة اللعب)",
  T_32_LO_WS_ITEM87: "كتلة",
  T_32_LO_WS_ITEM87_DESC: "تمكين تخصيص الحجم",
  T_32_LO_WS_ITEM88: "مكعبة ومنحدر",
  T_32_LO_WS_ITEM88_DESC: "مكعبة أو منحدر يمكن تعديل حجمه",
  T_32_LO_WS_ITEMLINE: "تغيير",
  T_32_LO_WS_ITEMMOVE: "إعدادات المشغل",
  T_32_LO_WS_ITEMROT: "تحول",
  T_32_LO_WS_ITEMSCALE: "حجم",
  T_32_LO_WS_KILLZONE: "منطقة الموت",
  T_32_LO_WS_LOOT_AMMOTYPE: "ذخيرة",
  T_32_LO_WS_LOOT_ARTYPE: "درع",
  T_32_LO_WS_LOOT_COTYPE: "مستهلك",
  T_32_LO_WS_LOOT_JATYPE: "قابل للرمي",
  T_32_LO_WS_LOOT_RANDOM: "عشوائي",
  T_32_LO_WS_LOOT_TETYPE: "عدسة",
  T_32_LO_WS_LOOT_WEAPONTYPE: "سلاح",
  T_32_LO_WS_SCALEX: "الطول",
  T_32_LO_WS_SCALEY: "الطول",
  T_32_LO_WS_SCALEZ: "عرض",
  T_32_LO_WS_TRIGGERH: "إخفاء",
  T_32_LO_WS_TRIGGERHORP: "إظهار/إخفاء المشغلات",
  T_32_LO_WS_TRIGGERP: "اظهار",
  T_32_LO_WS_TRIGGERTYPE: "نوع المشغل",
  T_32_M_WS_MODE_ANNIHILATE: "قضاء الكل",
  T_32_M_WS_MODE_SCORE: "انتزاع النقاط",
  T_32_M_WS_MODE_SPEED: "باركور",
  T_32_M_WS_MULTIPLETEAMS: "قتال متعدد الفرق",
  T_32_M_WS_ROUNDS: "جولات",
  T_32_R_EMOTE_HURRICANE_BLUE_NAME: "رقصة الخطوات",
  T_32_RW_WEAPON_M1887TD_NAME: "M1887-X",
  T_32_T_WS_ME_BLUECIRCLE: "منطقة الخطر",
  T_32_T_WS_ME_BLUECIRCLEDAMAGE: "ضرر",
  T_32_T_WS_ME_BLUECIRCLESETTING: "منطقة الخطر",
  T_32_T_WS_ME_CUSTOM: "تخصيص",
  T_32_T_WS_ME_ENDTYPE1: "قضاء الكل",
  T_32_T_WS_ME_ENDTYPE2: "انتزاع النقاط",
  T_32_T_WS_ME_ENDTYPE3: "باركور",
  T_32_T_WS_ME_ENDTYPEDESC1: "كن آخر فريق على قيد الحياة",
  T_32_T_WS_ME_ENDTYPEDESC2: `وضع يعتمد على النقاط حيث يفوز الفريق الذي يصل أولاً إلى النتيجة المستهدفة.
يمكنك تعيين قواعد اللعب وتحرير معلمات اللعب كما تريد، بما في ذلك تعيين النتيجة الممنوحة لعمليات القتل.`,
  T_32_T_WS_ME_ENDTYPEDESC3: "وضع باركور حيث يفوز الفريق الأول الذي يصل جميع أعضائه إلى نقطة النهاية. يمكنك ضبط قواعد اللعب وعناصر المسارات وخط النهاية كما تريد.",
  T_32_T_WS_ME_MATCHTIME: "وقت المباراة",
  T_32_T_WS_ME_MECHANIC: "آلية",
  T_32_T_WS_ME_NEARCHECKPOINT: "بالقرب من نقطة تسجيل",
  T_32_T_WS_ME_PLAYERNUMLIMIT: "غير قادر على الحصول على أكثر من 12 لاعبا في المجموع",
  T_32_T_WS_ME_PREGAMETIME: "وقت التجهيز",
  T_32_T_WS_ME_RESPAWN: "إعادة إحياء",
  T_32_T_WS_ME_RESPAWNSETTING: "إعادة إحياء",
  T_32_T_WS_ME_ROUNDNUM: "عدد الجولات",
  T_32_T_WS_ME_ROUNDOPEN: "تمكن جولات متعددة",
  T_32_T_WS_ME_ROUNDRESET: "جولة إعادة التعيين",
  T_32_T_WS_ME_ROUNDSETTING: "جولات",
  T_32_T_WS_ME_SAFEZONESHRINKTIME2: "مدة تقلص المنطقة",
  T_32_T_WS_ME_SCORESETTING: "نتيجة",
  T_32_T_WS_ME_TEAMMATENUM: "أعضاء لكل فريق",
  T_32_T_WS_ME_TEAMNUM: "عدد الفرق",
  T_32_T_WS_ME_TEAMSETTING: "فريق",
  T_32_U_ATTACHMENT_8: "جيب الحقيبة",
  "T_32_U_GOLD_FAMAS-I": "فاماس-I",
  "T_32_U_GOLD_FAMAS-II": "فاماس-II",
  "T_32_U_GOLD_FAMAS-III": "فاماس-III",
  T_32_U_GOLD_HEATGUN_I: "بلازما-I",
  T_32_U_GOLD_HEATGUN_II: "بلازما-II",
  T_32_U_GOLD_HEATGUN_III: "بلازما-III",
  T_32_U_GOLD_KAR98K_I: "Kar98K-I",
  T_32_U_GOLD_KAR98K_II: "Kar98K-II",
  T_32_U_GOLD_KAR98K_III: "Kar98K-III",
  T_32_U_GOLD_M14_I: "M14-I",
  T_32_U_GOLD_M14_II: "M14-II",
  T_32_U_GOLD_M14_III: "M14-III",
  "T_32_U_GOLD_M4A1-I": "M4A1-I",
  "T_32_U_GOLD_M4A1-II": "M4A1-II",
  "T_32_U_GOLD_M4A1-III": "M4A1-III",
  T_32_U_GOLD_M60_I: "M60-I",
  T_32_U_GOLD_M60_II: "M60-II",
  T_32_U_GOLD_M60_III: "M60-III",
  T_32_U_GOLD_MP5_I: "MP5-I",
  T_32_U_GOLD_MP5_II: "MP5-II",
  T_32_U_GOLD_MP5_III: "MP5-III",
  T_32_U_GOLD_VSS_I: "VSS-I",
  T_32_U_GOLD_VSS_II: "VSS-II",
  T_32_U_GOLD_VSS_III: "VSS-III",
  T_32_U_REPLACER: "ترقية الرقاقة",
  T_32_WT_WS_BARRIER: "الحواجز",
  T_32_WT_WS_BDS: "البنايات",
  T_32_WT_WS_MMINVALIDERROR: "رمز الخريطة غير صالح",
  T_32_WT_WS_TRGS: "المشغلات",
  T_32_YF_CHARGESHOT_N: "الشحن العنيف",
  T_32_YF_GOLD_GROZA_N: "جروزا-X",
  T_32_YF_GOLD_M249_N: "M249-X",
  T_32_YF_GOLD_SVD_N: "SVD-Y",
  T_32_YS_WEAPON_TAG_18: "ضرر إضافي",
  T_32_YS_WEAPON_TAG_3: "معدل إطلاق النار",
  T_32_YS_WEAPON_TAG_36: "اختراق الدروع",
  T_32_YS_WEAPON_TAG_39: "يدعم ثنائي",
  T_32_YS_WEAPON_TAG_42: "جدار الثلج",
  T_33_C_SKILL_DESC_GRAFFITIST: "تُنشئ منطقة [FFB300]{0}م[-]، حيث تكون المقذوفات غير صالحة. سيستعيد الحلفاء في المنطقة [FFB300]{1}%[-] متانة للدروع كل ثانية وسيقل ضرر الذخيرة بنسبة [FFB300]{2}%[-]. يستمر لمدة [FFB300]{3}ث[-]. التأثيرات لا تتراكم. التهدئة: [FFB300]{4}ث[-].",
  T_33_C_SKILL_DESC_HITMAN: "عند استخدام بنادق القناصة (السنايبر) وبنادق الرماية، سيشغل كاتم الصوت تلقائيا. وعند إسقاط الأعداء سينزفون [FFB300]{0}%[-] بشكل أسرع.",
  T_33_C_SKILL_DESC_KENTA: "يشكل درعًا يبلغ عرضه  [FFB300]{0}م[-] ويقلل [FFB300]{1}%[-] من ضرر السلاح القادم من الأمام. عند إطلاق النار، يتم تقليل الضرر إلى [FFB300]{2}%[-] . يستمر لمدة [FFB300]{3}ث[-]. وقت التهدئة: [FFB300]{4}ث[-].",
  T_33_C_SKILL_DESC_MADEMANA: "يطلق موجة كهرومغناطيسية بقطر [FFB300]{0}م[-] تعطل تفعيل مهارات الأعداء، تسبب [FFB300]{3} ضرر[-]، وتقاطع عد تنازلي لتفاعلاتهم. تستمر لمدة [FFB300]{1}ث[-]. فترة التهدئة: [FFB300]{2}ث[-].",
  T_33_C_SKILL_NAME_BODYGUARD: "خبير الأسلحة النارية",
  T_33_C_SKILL_NAME_KENTA: "غضب السياف",
  T_33_C_SKILL_NAME_MADEMANA: "إثارة المعركة",
  T_33_DY_AXOLOTL_N: "زاسيل",
  T_33_DY_PETSKIN_AXOLOTL_GREY_N: "سكن الحيوان الأليف: زاسيل الدلاع",
  T_33_DY_PETSKIN_DUCK_FFWS03_N: "سكن الحيوان الأليف: بيني البطولة العالمية",
  T_33_DY_PETSKIN_HAWK_FASTBREAKING22_N: "سكن الحيوان الأليف: فالكو المزدهر",
  T_33_HQ_BASEBALLBAT_APRILFOOL22_N: "مضرب - الخبز الفرنسي القاتل",
  T_33_HQ_EMOTE_SONGKRAN_N: "تعال وارقص!",
  T_33_HQ_G18_CYBERTHIEF_N: "G18 - القالب الأزرق",
  T_33_HQ_GRENADE_CYBERTHIEF_N: "قنبلة - القالب الأزرق",
  T_33_HQ_M14_SPIDERLILY_N: "M14 - الزهرة المحترقة",
  T_33_HQ_MAG7_FFUNIT2_N: "MAG-7 -  فارس الظلال",
  T_33_HQ_MP40_FFWS03_N: "MP40 - محارب القلعة",
  T_33_HQ_SCAR_FFWS03_N: "SCAR - محارب القلعة",
  T_33_HQ_SICKLE_FASTBREAKING22_N: "منجل - قوة الزمرد",
  T_33_HQ_THROWINGKNIFE_FFWS03_N: "خنجر - محارب القلعة",
  T_33_HQ_VECTOR_CYBERTHIEF_N: "فكتور - القالب الأزرق",
  T_33_HQ_VEHICLE_JEEP_FASTBREAKING22_N: "سيارة جيب - وميض الزمرد",
  T_33_HQ_VEHICLE_MONSTER_LION_RED_N: "شاحنة متوحشة - العظام الحارق",
  T_33_HQ_VEHICLE_SUV_FFWS03_N: "شاحنة - حارسة القلعة",
  T_33_LO_WS_BHPARA_A: "نشط",
  T_33_LO_WS_BHPARA_ATKMODE: "نوع الهجوم",
  T_33_LO_WS_BHPARA_GROUP: "فريق",
  T_33_LO_WS_BHPARA_NA: "لا يوجد هجوم",
  T_33_LO_WS_BHPARA_P: "ثانوية",
  T_33_LO_WS_DICE_DESC: "يعزز القفزة استخدمه في الألعاب",
  T_33_LO_WS_DICEVXZ: "السرعة الأفقية",
  T_33_LO_WS_DICEVY: "السرعة العمودية",
  T_33_LO_WS_DTOWER: "برج",
  T_33_LO_WS_DTOWER_DESC: "يهاجم تلقائيًا الأعداء الموجودين على مسافة معينة من الهيكل الدفاعي. يتم تعطيله إذا وصلت نقاط الصحة الخاص به إلى الصفر. (غير صالح في أوضاع كلاش سكواد وماتش قاتل وساحة اللعب)",
  T_33_LO_WS_FORT: "القلعة",
  T_33_LO_WS_FORT_DESC: "يهاجم تلقائيًا الأعداء الموجودين على مسافة معينة من الهيكل الحرج. يتم تعطيله إذا وصلت نقاط الصحة الخاص به إلى الصفر. (غير صالح في أوضاع كلاش سكواد وماتش قاتل وساحة اللعب)",
  T_33_LO_WS_ITEM89: "خزان المصفاة",
  T_33_LO_WS_ITEM89_DESC: "هيكل لتخزين المياه",
  T_33_LO_WS_ITEM90: "بيت الكلب",
  T_33_LO_WS_ITEM90_DESC: "منزل للكلاب",
  T_33_LO_WS_ITEM91: "محطة الحافلة",
  T_33_LO_WS_ITEM91_DESC: "موقف حافلات عام",
  T_33_LO_WS_ITEM92: "جدار الجرافيتي",
  T_33_LO_WS_ITEM92_DESC: "جدار مزين برشاش",
  T_33_LO_WS_ITEM93: "مستقر",
  T_33_LO_WS_ITEM93_DESC: "هيكل أساسي مصنوع من القش",
  T_33_LO_WS_ITEM94: "مقعد",
  T_33_LO_WS_ITEM94_DESC: "مقعد الحديقة",
  T_33_LO_WS_ITEM95: "جسر حجري",
  T_33_LO_WS_ITEM95_DESC: "جسر مبني بالحجارة",
  T_33_LO_WS_ITEM96: "ظل الشمس",
  T_33_LO_WS_ITEM96_DESC: "امنع حروق الشمس تحت المظلة",
  T_33_LO_WS_ITEM97: "قوس خط النهاية",
  T_33_LO_WS_ITEM97_DESC: "يحدد خط النهاية",
  T_33_LO_WS_ITEM98: "لوحة الإعلانات",
  T_33_LO_WS_ITEM98_DESC: "راية عادية للإعلانات",
  T_33_LO_WS_PARA_DM: "ضرر",
  T_33_LO_WS_PARA_HP: "نقاط الصحة",
  T_33_LO_WS_PARA_RANGE: "مسح مسافة العدو",
  T_33_LO_WS_PARA_SP: "سرعة",
  T_33_LO_WS_ZBPARA_AMOUNT: "زومبي لكل جولة",
  T_33_LO_WS_ZBPARA_INTERVAL: "فاصل الجولة (ث)",
  T_33_LO_WS_ZBPARA_ROUND: "عدد الجولات",
  T_33_LO_WS_ZBSPAWNER: "مركز الزومبي",
  T_33_LO_WS_ZBSPAWNER_DESC: "يولد الزومبي تلقائيًا وفقًا للتكوينات. يمكن تكوين سلوكهم باستخدام القائمة المنسدلة. (غير صالح في أوضاع كلاش سكواد وماتش قاتل وساحة اللعب)",
  T_33_MF_CHARACTER_BLACKSMITH_N: "كينتا",
  T_33_PD_ZOMBIE_LEVELUP: "رفع المستوى",
  T_33_RW_SKILL_DESC_GANGGIRL: "يزيد معدل إطلاق النار بنسبة [FFB300]{0}%[-]. عندما يضرب المستخدم عدوًا، يتم تحويل [FFB300]{1}%[-]. كحد أقصى من معدل إطلاق النار إلى سرعة حركة، ويتم إعادة ضبط التحويل عندما ينجو المستخدم من القتال.",
  T_33_RW_SKILL_NAME_GANGGIRL: "القتال أو الهروب",
  T_33_WT_WS_BASICSET1: "الأساسي",
  T_33_WT_WS_QCEPRTIP: "تحويل نقاط الخبرة إلى نقاط الصحة بشكل أسرع",
  T_33_WT_WS_SKILLSET_TAG: "مهارة غير محدودة",
  T_33_WT_WS_SKILLSET1: "إعدادات المهارات",
  T_33_WT_WS_SKILLSET10: "مسيطر الزمن (كرونو)",
  T_33_WT_WS_SKILLSET11: "تيار الإيقاع (سكايلر)",
  T_33_WT_WS_SKILLSET12: "اللقاء الشديد (زينه)",
  T_33_WT_WS_SKILLSET13: "نبضات قلب شافي (ديميتري)",
  T_33_WT_WS_SKILLSET2: "مهارات ثانوية",
  T_33_WT_WS_SKILLSET2_TIP: "تشغيل / إيقاف المهارات الثانوية",
  T_33_WT_WS_SKILLSET3: "المهارات النشطة (قم بتشغيلها لضبط وقت التهدئة أدناه)",
  T_33_WT_WS_SKILLSET3_TIP: "تشغيل / إيقاف المهارات النشطة. في حالة التشغيل، يمكن تكوين وقت التهدئة لمختلف المهارات النشطة أدناه.",
  T_33_WT_WS_SKILLSET4: "التمويه (ووكونج)",
  T_33_WT_WS_SKILLSET5: "إثارة المعركة (A124)",
  T_33_WT_WS_SKILLSET6: "إسقاط الإيقاع (ألوك)",
  T_33_WT_WS_SKILLSET7: "الرسامة الماهرة (ستيفي)",
  T_33_WT_WS_SKILLSET8: "تتبع الخطوات (كلو)",
  T_33_WT_WS_SKILLSET9: "سيد الكل (كي)",
  T_33_WT_WS_UNIT_HPSECOND: "نقاط صحة للثانية",
  T_33_WT_WS_UNIT_METER: "متر",
  T_33_WT_WS_UNIT_SECOND: "ثانية",
  T_33_YF_G36_N: "G36",
  T_33_YS_B_RAINCOAT: "دمية المطر (سفلي)",
  T_33_YS_H_ONIGIRI: "رأس أونيقيري",
  T_33_YS_H_RAINCOAT: "دمية المطر (رأس)",
  T_33_YS_HA_CRYINGFACE: "تعبير البكاء (طلاء وجه)",
  T_33_YS_M_H_FROGKING: "قبعة ملك الضفدع",
  T_33_YS_S_RAINCOAT: "دمية المطر (حذاء)",
  T_33_YS_T_BLACKHOLE: "سترة الدوار",
  T_33_YS_T_RAINCOAT: "دمية المطر (علوي)",
  T_33_YS_T_SOCCER_GREEN: "الركلة المكهربة (قميص)",
  T_33_YS_T_SOCCER_YELLOW: "الركلة النشطة (قميص)",
  T_33_YS_T_WIFI: "قميص نقص الشبكة",
  T_34_C_SKILL_DESC_STREAMERGUY: "كل عملية القتل أو مشاهد يمنحك تراكمًا واحدًا من التأثير. كل تراكم يقلل من الضرر الناتج عن الطلقات في الرأس بنسبة [FFB300]{0}%[-] (بحد أقصى [FFB300]{1}%[-] إجمالاً) ويزيد من الضرر الناتج عن الطلقات في الرأس للأعداء بنسبة [FFB300]{2}%[-] (بحد أقصى [FFB300]{3}%[-] إجمالاً).",
  T_34_C_SKILL_DESC_TRACKER: "يطلق درون باتجاه أقرب عدو في [FFB300]100متر[-] من المسافة الأمامية، مما يؤدي [FFB300]{5}-مترًا[-] انفجارا نبضيا مما يقلل سرعة الحركة بنسبة [FFB300]{0}%[-] وسرعة إطلاق النار بنسبة [FFB300]{1}%[-]. يستمر لمدة [FFB300]{3}ث[-]. وتحدث [FFB300]{2} ضررًا[-]. التهدئة: [FFB300]{4}ث[-].",
  T_34_C_SKILL_NAME_TRACKER: "موجة الصدمة الحواس",
  T_34_DY_PETSKIN_SURFSHARK_ENERGY_N: "سكن الحيوان الأليف: مواكب الأمواج الغاضب",
  T_34_DY_PETSKIN_SURFSHARK_SEA_N: "سكن الحيوان الأليف: فين البحار العميق",
  T_34_DY_PETSKIN_SURFSHARK_STORM_N: "سكن الحيوان الأليف: فين عاصفة الرعد",
  T_34_DY_PETSKIN_TIGER_BIS_N: "سكن الحيوان الأليف: تايقر الديجيتال",
  T_34_DY_SURFSHARK_N: "فين",
  T_34_HQ_EMOTE_BIS_COMMAND_N: "قائد عظيم",
  T_34_HQ_EMOTE_RAMPAGE4_BLUE_N: "نشيط",
  T_34_HQ_EMOTE_RIDICULE_N: "سخرية",
  T_34_HQ_VEHICLE_SUV_CRAZYSCIENTIST_N: "شاحنة - المهندس الشرير",
  T_34_HQ_VEHICLE_TUTU_WINTERDOG_N: "سيارة توك توك - جرو هاسكي",
  T_34_JL_EAGLE_RAMPAGE4_N: "نسر الصحراء - انفجار الهجين",
  T_34_JL_G36_MADBIONIC_N: "G36 - الآلية الحارقة",
  T_34_JL_GRENADE_BIS_N: "قنبلة - جيش بكسل",
  T_34_JL_MACHETE_RAMPAGE4_N: "شفرة - الليلية",
  T_34_JL_THROWINGKNIFE_BANANA_N: "خنجر - الموز",
  T_34_JL_UMP45_BIS_N: "UMP - الناجي الإلكتروني",
  T_34_LY_WS_ABS_DESC: "احصل على القيمة المطلقة لهذا الرقم",
  T_34_LY_WS_ADD_DESC: "أضف عنصرًا جديدًا إلى نهاية القائمة",
  T_34_LY_WS_AUTO_A: "مسح تلقائي للأعداء",
  T_34_LY_WS_BOT: "عادي",
  T_34_LY_WS_BOT_PATH: "المسار",
  T_34_LY_WS_BOT_TYPE: "نوع",
  T_34_LY_WS_BOT4: "فأس",
  T_34_LY_WS_BOT5: "رمي",
  T_34_LY_WS_BOT6: "تنفجر الذات",
  T_34_LY_WS_BOT8: "محمي",
  T_34_LY_WS_COL_DESC: "اختر اللون",
  T_34_LY_WS_DEL_DESC: "احذف العنصر المقابل من مؤشر معين في قائمة",
  T_34_LY_WS_DF_PER: "دفاع %",
  T_34_LY_WS_FORT_INTERVAL: "وقت الهجوم الفاصل (ث)",
  T_34_LY_WS_GET: "احصل على",
  T_34_LY_WS_GET_DESC: "احصل على العنصر المقابل من مؤشر معين في قائمة",
  T_34_LY_WS_GLEN_ARR_DESC: "احصل على عدد العناصر في القائمة الحالية",
  T_34_LY_WS_GLEN_DESC: "الحصول على طول هذه السلسلة من النص",
  T_34_LY_WS_GVX: "الحصول على مكون متجه س",
  T_34_LY_WS_GVX_DESC: "الحصول على المكون الأول من المتجه",
  T_34_LY_WS_GVY: "الحصول على مكون المتجه ص",
  T_34_LY_WS_GVY_DESC: "احصل على المكون الثاني من المتجه",
  T_34_LY_WS_GVZ: "الحصول على مكون متجه ض",
  T_34_LY_WS_GVZ_DESC: "احصل على المكون الثالث للمتجه",
  T_34_LY_WS_INDEX: "مؤشر",
  T_34_LY_WS_JOIN: "اربط",
  T_34_LY_WS_NEG_DESC: "احصل على القيمة السالبة لهذا الرقم",
  T_34_LY_WS_PATH: "واضع المسار",
  T_34_LY_WS_PATH_DESC: "تُستخدم لإضافة أو حذف مسارات السفر لعناصر المعيشة الخاصة. (غير صالح في أوضاع كلاش سكواد وماتش قاتل وساحة اللعب)",
  T_34_LY_WS_POINT: "علامة",
  T_34_LY_WS_POINT_DESC: "استخدم لتمييز موقع الموضع الحالي. (غير صالح في أوضاع كلاش سكواد وماتش قاتل وساحة اللعب)",
  T_34_LY_WS_RANGE_F: "بعيد",
  T_34_LY_WS_RANGE_M: "متوسط",
  T_34_LY_WS_RANGE_N: "قريب",
  T_34_LY_WS_RNDF_DESC: "إنشاء عشري عشوائي من فاصل زمني",
  T_34_LY_WS_RNDI_DESC: "إنشاء عدد صحيح عشوائي من فاصل زمني",
  T_34_LY_WS_SET: "تعيين",
  T_34_LY_WS_SET_DESC: "قم بتعيين العنصر المقابل لمؤشر معين في قائمة",
  T_34_LY_WS_SQRT_DESC: "احصل على الجذر التربيعي لهذا الرقم",
  T_34_LY_WS_STRC_DESC: "اربط سلسلتين من النصوص",
  T_34_LY_WS_SVX: "تعيين عنصر ناقل س",
  T_34_LY_WS_SVX_DESC: "اضبط المكون الأول للمتجه",
  T_34_LY_WS_SVY: "تعيين مكون متجه ص",
  T_34_LY_WS_SVY_DESC: "اضبط المكون الثاني للمتجه",
  T_34_LY_WS_SVZ: "تعيين عنصر متجه ض",
  T_34_LY_WS_SVZ_DESC: "اضبط المكون الثالث للمتجه",
  T_34_LY_WS_VADD: "إضافة المتجه",
  T_34_LY_WS_VADD_DESC: "أضف متجهين",
  T_34_LY_WS_VAL_DESC: "أدخل عددًا صحيحًا أو عشريًا وفقًا للسيناريو",
  T_34_LY_WS_VANG_DESC: "احسب الزاوية بين متجهين",
  T_34_LY_WS_VCP: "المنتوج الوسيط",
  T_34_LY_WS_VCP_DESC: "احسب حاصل الضرب الاتجاهي لمتجهين",
  T_34_LY_WS_VDIS_DESC: "احسب المسافة بين متجهين",
  T_34_LY_WS_VDP: "الضرب القياسي",
  T_34_LY_WS_VDP_DESC: "احسب حاصل الضرب القياسي لمتجهين",
  T_34_LY_WS_VFX1: "كروي",
  T_34_LY_WS_VFX2: "إسطواني",
  T_34_LY_WS_VFX3: "حلقة",
  T_34_LY_WS_VFX4: "بووم",
  T_34_LY_WS_VFX5: "بكسل",
  T_34_LY_WS_VFX6: "شرارات",
  T_34_LY_WS_VMOD_DESC: "احسب مقدار المتجه",
  T_34_LY_WS_VMUL: "ضرب المتجه",
  T_34_LY_WS_VMUL_DESC: "اضرب متجهين",
  T_34_LY_WS_VNOR_DESC: "تطبيع المتجه",
  T_34_LY_WS_VSUB: "طرح المتجه",
  T_34_LY_WS_VSUB_DESC: "اطرح متجهين",
  T_34_M_WS_ANGLE: "زاوية التدوير",
  T_34_M_WS_ARRAY: "قائمة",
  T_34_M_WS_ATT: "ملكية",
  T_34_M_WS_BOOL: "قيمة منطقية",
  T_34_M_WS_COLORARRAY: "مجموعة اللون",
  T_34_M_WS_COLOUR: "اللون",
  T_34_M_WS_CONFRONBANNER: "راية القتال",
  T_34_M_WS_COORDINATE: "إحداثيات",
  T_34_M_WS_CUSTOMINF: "تخصيص الواجهة",
  T_34_M_WS_CUSTOMMODEDESC: `وضع فارغ وقابل للتخصيص بالكامل بدون طريقة لعب محددة مسبقًا، حيث يمكنك إنشاء اللعبة واللعب وفقًا لقواعدك الخاصة.
قد يكون الأمر صعبًا بعض الشيء بالنسبة لمنشئي الخرائط المبتدئين.`,
  T_34_M_WS_DAMAGETYPE: "نوع الضرر",
  T_34_M_WS_DAMAGETYPEDESC: "نوع الضرر الذي يحدده النظام حاليًا",
  T_34_M_WS_DESCTEXT: "نص وصفي",
  T_34_M_WS_DURACTION: "المدة",
  T_34_M_WS_ECAMODE: "تخصيص الوضع",
  T_34_M_WS_ENDPHASEDESC: "قم بإنهاء المرحلة الحالية فورًا وانتقل إلى المرحلة التالية",
  T_34_M_WS_ENTITY: "كيان",
  T_34_M_WS_FLOAT: "عدد عشري",
  T_34_M_WS_GAME: "إعدادات",
  T_34_M_WS_GAMERESULTS: "نتيجة المباراة",
  T_34_M_WS_GETCONTROL2: "احصل على كيان تحكم من واجهة اللاعبين لتعديل خصائص الكيان (بما في ذلك التصميم واللون والمحتوى وإلخ)",
  T_34_M_WS_HEIGHT: "الطول",
  T_34_M_WS_HUDBUTTONWIDGET: "زر التحكم",
  T_34_M_WS_HUDEMPTYWIDGET: "محور فارغ",
  T_34_M_WS_HUDIMAGEWIDGET: "التحكم بالصورة",
  T_34_M_WS_HUDINPUTWIDGET: "التحكم في مربع النص",
  T_34_M_WS_HUDLABELWIDGET: "التحكم بالنص",
  T_34_M_WS_ICON: "أيقونة",
  T_34_M_WS_ICON_AIM: "هدف",
  T_34_M_WS_ICON_ARROW: "سهم",
  T_34_M_WS_ICON_BLAST: "انفجار",
  T_34_M_WS_ICON_CIRCULAR: "دائرة",
  T_34_M_WS_ICON_CLOTH: "كف اليد",
  T_34_M_WS_ICON_COLLIMATION: "التقاطع",
  T_34_M_WS_ICON_CORPSE: "زومبي",
  T_34_M_WS_ICON_CROSS: "تقاطع",
  T_34_M_WS_ICON_DAY: "شمس",
  T_34_M_WS_ICON_DEFENSE: "درع",
  T_34_M_WS_ICON_DIALOGUE: "حوار",
  T_34_M_WS_ICON_DIAMONDS: "جواهر",
  T_34_M_WS_ICON_EXCLAMATIONMARK: "علامة تعجب",
  T_34_M_WS_ICON_FLAG: "علم",
  T_34_M_WS_ICON_FOLDER: "مجلد",
  T_34_M_WS_ICON_GLASSES: "عين",
  T_34_M_WS_ICON_GUN: "مسدس",
  T_34_M_WS_ICON_HEART: "قلب",
  T_34_M_WS_ICON_HEXAGON: "سداسي",
  T_34_M_WS_ICON_HOURGLASS: "الساعة الرملية",
  T_34_M_WS_ICON_HOUSE: "منزل",
  T_34_M_WS_ICON_KEY: "مفتاح",
  T_34_M_WS_ICON_LIGHTNING: "برق",
  T_34_M_WS_ICON_LOCK: "قفل",
  T_34_M_WS_ICON_LOOP: "عقدة",
  T_34_M_WS_ICON_MAGNIFIER: "عدسة مكبرة",
  T_34_M_WS_ICON_MONEY: "مال",
  T_34_M_WS_ICON_MONTH: "قمر",
  T_34_M_WS_ICON_OPENFOLDER: "افتح المجلد",
  T_34_M_WS_ICON_PLUS: "زائد",
  T_34_M_WS_ICON_QUADRI: "رباعي",
  T_34_M_WS_ICON_QUESTIONMARK: "علامة استفهام",
  T_34_M_WS_ICON_RECYCLING: "إعادة التدوير",
  T_34_M_WS_ICON_REFRESH: "تحديث",
  T_34_M_WS_ICON_REST: "راحة",
  T_34_M_WS_ICON_RETURN: "رجوع",
  T_34_M_WS_ICON_RIGHTTRAPEZOID: "شبه منحرف لليمين",
  T_34_M_WS_ICON_SCISSORS: "مقص",
  T_34_M_WS_ICON_SETUP: "ضبط",
  T_34_M_WS_ICON_SIGN: "علامة",
  T_34_M_WS_ICON_SIGNOUT: "خروج",
  T_34_M_WS_ICON_SQUARE: "مربع",
  T_34_M_WS_ICON_STAR: "نجمة",
  T_34_M_WS_ICON_STONE: "حجر",
  T_34_M_WS_ICON_SWIMMINGCIRCLE: "خاتم السباحة",
  T_34_M_WS_ICON_TAGGING: "شعار",
  T_34_M_WS_ICON_THESWORD: "سيف",
  T_34_M_WS_ICON_TRAPEZOID: "شبه منحرف",
  T_34_M_WS_ICON_TRASHCAN: "سلة مهملات",
  T_34_M_WS_ICON_TRIANGLE: "مثلث",
  T_34_M_WS_ICON_TROPHY: "كأس",
  T_34_M_WS_ICON_UP: "علامة البصمة",
  T_34_M_WS_ICON_WRONG: "خطأ",
  T_34_M_WS_ICON_YES: "يمين",
  T_34_M_WS_ICONNAME: "اسم الأيقونة",
  T_34_M_WS_INT: "عدد صحيح",
  T_34_M_WS_KILLZONE: "منطقة الموت",
  T_34_M_WS_LEFTCOLOR: "لون اليسار",
  T_34_M_WS_LEFTTEAMINDEX: "فهرس الفريق الأيسر",
  T_34_M_WS_LEFTTEAMSCORE: "نتيجة الفريق الأيسر",
  T_34_M_WS_LOCSWITCH: "تبديل التعريب",
  T_34_M_WS_MAX: "الأقصى",
  T_34_M_WS_MIN: "الأقل",
  T_34_M_WS_NUMBER: "رقم",
  T_34_M_WS_OBJECT: "كيان",
  T_34_M_WS_OPEN: "تشغيل",
  T_34_M_WS_OPENSATUS: "تشغيل الحالة",
  T_34_M_WS_PICTURE: "الجرافيكس",
  T_34_M_WS_RANKARRAY: "مجموعة الترتيب",
  T_34_M_WS_RESULTS: "النتائج",
  T_34_M_WS_RIGHTCOLOR: "لون اليمين",
  T_34_M_WS_RIGHTTEAMINDEX: "مؤشر الفريق اليمنى",
  T_34_M_WS_RIGHTTEAMSCORE: "نتيجة الفريق اليمنى",
  T_34_M_WS_ROUNDBANNER: "راية الجولة",
  T_34_M_WS_ROUNDDESC: "وصف الجولة",
  T_34_M_WS_ROUNDHUD: "رقم الجولة",
  T_34_M_WS_ROUNDPARAMS: "مجموعة عدد الجولة",
  T_34_M_WS_SAME_NAME: "الاسم مكرر. من فضلك جرب اسم آخر.",
  T_34_M_WS_SCOREARRAY: "مجموعة نقاط",
  T_34_M_WS_SCORINGTYPE: "نوع النتيجة",
  T_34_M_WS_SCORINGTYPEDECS: "نوع النتيجة التي يمكن للاعبين الحصول عليها. يدعم تخصيص النتيجة.",
  T_34_M_WS_SCUFFLESCORING: "نتيجة متعددة الفرق",
  T_34_M_WS_SETATTRIBUTES: "إعدادات الخاصية",
  T_34_M_WS_SHUT: "قفل",
  T_34_M_WS_SOUND: "مؤثرات الصوت",
  T_34_M_WS_SOUNDCLICK: "النقر",
  T_34_M_WS_SOUNDDD: "العد التنازلي",
  T_34_M_WS_SOUNDFEMALEA: "المصابة",
  T_34_M_WS_SOUNDM: "إطلاق النار",
  T_34_M_WS_SOUNDMALEA: "المصاب",
  T_34_M_WS_SOUNDUAV: "انفجار",
  T_34_M_WS_ST_ASSISTCOUNT: "المساعدات",
  T_34_M_WS_ST_CHECKPROGRESS: "التقدم المحرز في نقطة تسجيل",
  T_34_M_WS_ST_DAMAGESUM: "ضرر",
  T_34_M_WS_ST_FINISHCOUNT: "مقدار الأهداف التي تم تحقيقها",
  T_34_M_WS_ST_FINISHORDER: "ترتيب الأهداف التي تم تحقيقها",
  T_34_M_WS_ST_FINISHTIME: "وقت تحقيق الأهداف",
  T_34_M_WS_ST_KILLCOUNT: "القتلات",
  T_34_M_WS_ST_MAINSCORE: "نتيجة الهدف",
  T_34_M_WS_ST_RANKSCORE: "درجة التصنيف",
  T_34_M_WS_ST_SURVIVALDURACTION: "وقت النجاة",
  T_34_M_WS_ST_UNKOWN: "مجهول",
  T_34_M_WS_STARTBANNER: "راية البداية",
  T_34_M_WS_STARTTIME: "وقت البدء",
  T_34_M_WS_STRING: "نص",
  T_34_M_WS_STUDIO: "استوديو",
  T_34_M_WS_TEAMARRAY: "مجموعة الفريق",
  T_34_M_WS_TEXTCONTENT: "محتوى",
  T_34_M_WS_THEMECOLOR: "لون الموضوع",
  T_34_M_WS_TIME: "العد التنازلي HUD",
  T_34_M_WS_TITLETEXT: "نص العنوان",
  T_34_M_WS_TYPE: "نوع",
  T_34_M_WS_UODATETYPE: "نوع التحديث",
  T_34_M_WS_VARNAME: "اسم متغير",
  T_34_M_WS_VECTOR: "فكتور",
  T_34_M_WS_VFX: "تأثيرات بصرية",
  T_34_M_WS_WIDTH: "العرض",
  T_34_MF_CHARACTER_TRACKER_N: "هومر",
  T_34_PD_FlagBattle_HYPE_1: "النار",
  T_34_SP_WS_BLOCK1_NAME: "تبديل المرحلة",
  T_34_SP_WS_BLOCK1_NAMEDESC: "بدّل مرحلة المباراة للدخول إلى المرحلة (أو الجولة) المرغوبة. تحتوي الجولات أيضًا على مؤشرات مراحل وهي نوع خاص من المراحل.",
  T_34_SP_WS_BLOCK1_PARAM1_NAMEDESC: "مؤشر المرحلة المستهدفة",
  T_34_SP_WS_BLOCK10_NAME: "أنشئ تأثيرات بصرية",
  T_34_SP_WS_BLOCK10_NAMEDESC: "قم بإنشاء أيقونة باستخدام تأثيرات بصرية معينة. يمكن تكوين المزيد من ميزات التأثير البصري عن طريق ضبط خصائص كيان التأثيرات البصرية.",
  T_34_SP_WS_BLOCK10_PARAM3_NAME: "تأثير بصري",
  T_34_SP_WS_BLOCK10_PARAM3_NAMEDESC: "أنواع المؤثرات البصرية التي يمكن تطبيقها",
  T_34_SP_WS_BLOCK12_NAME: "حذف المؤثرات البصرية",
  T_34_SP_WS_BLOCK12_NAMEDESC: "احذف التأثير البصري المعين",
  T_34_SP_WS_BLOCK12_PARAM1_NAME: "كيان المؤثرات البصرية",
  T_34_SP_WS_BLOCK12_PARAM1_NAMEDESC: "كيان التأثير البصري المراد حذفه",
  T_34_SP_WS_BLOCK13_NAMEDESC: "اطلب من العميل تشغيل المؤثرات البصرية",
  T_34_SP_WS_BLOCK13_PARAM1_NAME: "قائمة اللاعبين",
  T_34_SP_WS_BLOCK13_PARAM1_NAMEDESC: "اللاعبون الذين سيتلقون الرسالة",
  T_34_SP_WS_BLOCK13_PARAM2_NAME: "مسار الموارد",
  T_34_SP_WS_BLOCK13_PARAM2_NAMEDESC: "مسار موارد النظام في:المسار. مسار المورد المخصص خارج:المسار. فارغ بشكل افتراضي.",
  T_34_SP_WS_BLOCK13_PARAM3_NAMEDESC: "قناة RGBA، حيث تأخذ كل قناة قيمة بين 0 و 255 محفوظة في int32. اللون الافتراضي هو الأبيض (255،255،255،255).",
  T_34_SP_WS_BLOCK13_PARAM4_NAME: "تكبير",
  T_34_SP_WS_BLOCK13_PARAM4_NAMEDESC: "مقياس التكبير؛ الافتراضي هو 1",
  T_34_SP_WS_BLOCK13_PARAM5_NAMEDESC: "موقع العرض معبراعنه في الإحداثيات العالمية. المتجه 3(0) افتراضياً.",
  T_34_SP_WS_BLOCK14_NAME: "تشغيل المؤثرات الصوتية",
  T_34_SP_WS_BLOCK14_NAMEDESC: "اطلب من العميل تشغيل المؤثرات الصوتية",
  T_34_SP_WS_BLOCK15_NAME: "سجل الإخراج",
  T_34_SP_WS_BLOCK15_NAMEDESC: "محتوى الإخراج على واجهة السجل",
  T_34_SP_WS_BLOCK2_NAMEDESC: "قم بالتشغيل لتمكين الضرر الذي يلحق باللاعبين خارج المنطقة الآمنة",
  T_34_SP_WS_BLOCK2_PARAM1_NAMEDESC: "النقطة الوسطية للمنطقة الآمنة",
  T_34_SP_WS_BLOCK2_PARAM2_NAME: "نصف قطر",
  T_34_SP_WS_BLOCK2_PARAM2_NAMEDESC: "نصف قطر المنطقة الآمنة",
  T_34_SP_WS_BLOCK2_PARAM3_NAMEDESC: "بدأ العد التنازلي للمنطقة الآمنة في التقلص",
  T_34_SP_WS_BLOCK2_PARAM4_NAMEDESC: "تتقلص مدة المنطقة الآمنة",
  T_34_SP_WS_BLOCK2_PARAM5_NAMEDESC: "مقدار الضرر الحاصل خارج المنطقة الآمنة",
  T_34_SP_WS_BLOCK3_NAMEDESC: "عند إيقاف تشغيل منطقة الخطر، لن يتلقى اللاعبون خارج المنطقة الآمنة أي ضرر",
  T_34_SP_WS_BLOCK4_NAMEDESC: "استخدام لتأخير إجراء لاحق لوقت محدد",
  T_34_SP_WS_BLOCK4_PARAM1_NAMEDESC: "مدة الانتظار، تقاس بالمللي ثانية",
  T_34_SP_WS_BLOCK5_NAMEDESC: "استخدم لتأجيل إجراء لاحق إلى الإطار التالي",
  T_34_SP_WS_BLOCK6_NAME: "أنشئ HUD مخصص",
  T_34_SP_WS_BLOCK6_NAMEDESC: "أنشئ HUD مخصص معين",
  T_34_SP_WS_BLOCK6_PARAM1_NAMEDESC: "اسم يُستخدم لإنشاء كيان HUD. المتغير المحلي الذي يتوافق معه هو كيان HUD الذي يتم إنشاؤه.",
  T_34_SP_WS_BLOCK6_PARAM2_NAME: "لاعب",
  T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC: "كيان لاعب معين. مرئي فقط للاعب المذكور.",
  T_34_SP_WS_BLOCK6_PARAM3_NAMEDESC: "المؤشر الفريد لـ HUD",
  T_34_SP_WS_BLOCK7_NAMEDESC: "قم بإنشاء HUD افتراضي، والذي يكون مرئيا فقط للاعبين المعينين",
  T_34_SP_WS_BLOCK8_NAMEDESC: "عند الحذف، لن يتم عرض HUD الافتراضي على العميل (سواء كان مخفيا أو مهملا)",
  T_34_SP_WS_BLOCK8_PARAM1_NAME: "كيان HUD",
  T_34_SP_WS_BLOCK8_PARAM1_NAMEDESC: "كيان HUD المراد حذفه",
  T_34_SP_WS_BLOCK9_NAMEDESC: "عند الحذف، لن يتم عرض HUD المخصص على العميل (سواء كان مخفيا أو مهملا)",
  T_34_T_WS_BLOCK1_NAMEDESC: "يتم تشغيل الحادث عند تبدأ المباراة",
  T_34_T_WS_BLOCK10_NAMEDESC: "يتم تشغيل الحادث عند يتم القضاء على اللاعب",
  T_34_T_WS_BLOCK10_PARAM1_DESC: "اللاعب الذي تم إقصاؤه والذي سيتسبب في الحادث",
  T_34_T_WS_BLOCK13_NAMEDESC: "يتم تشغيل الحادث عندما يساعد لاعب لاعبا آخر",
  T_34_T_WS_BLOCK13_PARAM2_DESC: "اللاعب الذي يتم إقصاؤه",
  T_34_T_WS_BLOCK14_NAMEDESC: "يتم تشغيل الحادث عندما يلحق اللاعب ضررًا",
  T_34_T_WS_BLOCK14_PARAM2_DESC: "اللاعب الذي يتلقى الضرر",
  T_34_T_WS_BLOCK14_PARAM3_DESC: "نوع الضرر الذي يحدث",
  T_34_T_WS_BLOCK14_PARAM4_DESC: "مقدار الضرر الذي لحق",
  T_34_T_WS_BLOCK15_NAMEDESC: "يتم تشغيل الحادث عندما يقتل اللاعب لاعب آخر",
  T_34_T_WS_BLOCK15_PARAM2_DESC: "اللاعب الذي يتم إقصاؤه",
  T_34_T_WS_BLOCK15_PARAM3_DESC: "نوع الضرر الذي يسبب الإزالة",
  T_34_T_WS_BLOCK16_NAMEDESC: "يتم تشغيل الحادث عندما ينضم اللاعب إلى المباراة",
  T_34_T_WS_BLOCK17_NAMEDESC: "يتم تشغيل الحادث عندما يتم إحياء اللاعب",
  T_34_T_WS_BLOCK18_NAMEDESC: "يتم تشغيل الحادث عند إزالة الفريق",
  T_34_T_WS_BLOCK19_NAMEDESC: "يتم تشغيل الحادث عند إضافة فريق",
  T_34_T_WS_BLOCK2_NAMEDESC: "يتم تشغيل الحادث عند انتهاء المباراة",
  T_34_T_WS_BLOCK20_NAMEDESC: "يتم تشغيل الحادث عندما يتم القضاء على فريق",
  T_34_T_WS_BLOCK3_NAMEDESC: "يتم تشغيل الحادث عندما تبدأ كل جولة",
  T_34_T_WS_BLOCK3_PARAM1_DESC: "يبدأ رقم الجولة من 0",
  T_34_T_WS_BLOCK3_PARAM1_NAME: "مؤشر الجولة",
  T_34_T_WS_BLOCK4_NAMEDESC: "يتم تشغيل الحادث عندما تنتهي كل جولة",
  T_34_T_WS_BLOCK5_NAMEDESC: "يتم تشغيل الحادث عندما تبدأ المرحلة",
  T_34_T_WS_BLOCK5_PARAM1_DESC: "يبدأ رقم المرحلة من 0",
  T_34_T_WS_BLOCK5_PARAM1_NAME: "كيان المرحلة",
  T_34_T_WS_BLOCK6_NAMEDESC: "يتم تشغيل الحادث عندما تنتهي المرحلة",
  T_34_T_WS_BLOCK7_NAMEDESC: "يتم تشغيل الحادث عندما يخرج اللاعب من المباراة",
  T_34_T_WS_BLOCK7_PARAM1_DESC: "اللاعب الذي سيتسبب في الحادث",
  T_34_T_WS_BLOCK7_PARAM1_NAME: "اثار اللاعب",
  T_34_T_WS_BLOCK8_NAMEDESC: "يتم تشغيل الحادث عندما تتغير نتيجة اللاعب",
  T_34_T_WS_BLOCK8_PARAM2_DESC: "نوع النتيجة المتغيرة",
  T_34_T_WS_BLOCK8_PARAM3_DESC: "قيمة النتيجة بعد التغيير",
  T_34_T_WS_BLOCK9_NAMEDESC: "يتم تشغيل الحادث عندما تتغير نتيجة الفريق",
  T_34_T_WS_BLOCK9_PARAM1_DESC: "الفريق الذي سيتسبب في الحادث",
  T_34_WT_WS_BORNENTITY_PARAM1: "نقطة إنعاش",
  T_34_WT_WS_BORNENTITY_PARAM2: "الإحداثيات المتوفرة",
  T_34_WT_WS_BORNENTITY_PARAM3: "تعيين كنقطة إحياء افتراضية",
  T_34_WT_WS_BORNENTITY_PARAM4: "حدود متوهجة",
  T_34_WT_WS_BORNENTITY_PARAM5: "قيد الاستخدام أو ليس قيد الاستخدام",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM1: "نقطة تسجيل HUD",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM2: "افتح الحالة",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM1: "مشغل الحالة",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM2: "تحديد للقضاء أو لم تحدد للقضاء",
  T_34_WT_WS_ENTITY_PARAM1: "كيان اللعبة",
  T_34_WT_WS_ENTITY_PARAM10: "# من الفرق",
  T_34_WT_WS_ENTITY_PARAM11: "# من أعضاء الفريق",
  T_34_WT_WS_ENTITY_PARAM12: "إعادة المعدات كل جولة",
  T_34_WT_WS_ENTITY_PARAM13: "تمكين الضرر خارج المنطقة",
  T_34_WT_WS_ENTITY_PARAM14: "حجم المنطقة",
  T_34_WT_WS_ENTITY_PARAM15: "وقت بدء تقليص المنطقة",
  T_34_WT_WS_ENTITY_PARAM16: "مدة تقليص المنطقة",
  T_34_WT_WS_ENTITY_PARAM17: "الضرر خارج المنطقة",
  T_34_WT_WS_ENTITY_PARAM18: "النتيجة المستهدفة",
  T_34_WT_WS_ENTITY_PARAM19: "درجة الإقصاء",
  T_34_WT_WS_ENTITY_PARAM2: "حالة غير صالحة",
  T_34_WT_WS_ENTITY_PARAM20: "نوع الإحياء",
  T_34_WT_WS_ENTITY_PARAM21: "معايير ترتيب نتيجة الجولة (اللاعب)",
  T_34_WT_WS_ENTITY_PARAM22: "أهمية المعايير (اللاعب)",
  T_34_WT_WS_ENTITY_PARAM23: "معايير ترتيب نتيجة الجولة (الفريق)",
  T_34_WT_WS_ENTITY_PARAM24: "أهمية المعايير (الفريق)",
  T_34_WT_WS_ENTITY_PARAM25: "معايير ترتيب الدرجات (MVP)",
  T_34_WT_WS_ENTITY_PARAM26: "أهمية المعايير (MVP)",
  T_34_WT_WS_ENTITY_PARAM27: "نتيجة تصنيف الجولة",
  T_34_WT_WS_ENTITY_PARAM28: "أظهر المعايير على صفحة النتائج",
  T_34_WT_WS_ENTITY_PARAM29: "إجمالي # من الجولات",
  T_34_WT_WS_ENTITY_PARAM3: "وقت اللعب",
  T_34_WT_WS_ENTITY_PARAM4: "مؤشر الجولة الحالية",
  T_34_WT_WS_ENTITY_PARAM5: "مؤشرالمرحلة الحالية",
  T_34_WT_WS_ENTITY_PARAM6: "معرف قالب الوضع",
  T_34_WT_WS_ENTITY_PARAM7: "تمكين إحياء اللاعب",
  T_34_WT_WS_ENTITY_PARAM8: "تمكين إحياء الروبوت",
  T_34_WT_WS_ENTITY_PARAM9: "وقت الإحياء",
  T_34_WT_WS_ENTITY1_NAME: "الكيان الحالي",
  T_34_WT_WS_ENTITY1_NAMEDESC: "العودة إلى الكيان الحالي",
  T_34_WT_WS_ENTITY10_NAME: "إزالة الأيقونة",
  T_34_WT_WS_ENTITY10_NAMEDESC: "إزالة أيقونة معينة",
  T_34_WT_WS_ENTITY10_PARAM1DESC: "حدد الأيقونة التي تريد إزالتها",
  T_34_WT_WS_ENTITY11_NAME: "إزالة النص",
  T_34_WT_WS_ENTITY11_NAMEDESC: "قم بإزالة كيان النص",
  T_34_WT_WS_ENTITY11_PARAM2ESC: "حدد النص الذي ترغب في إزالته",
  T_34_WT_WS_ENTITY12_NAMEDESC: "أضف عنصرًا للاعبين معينين",
  T_34_WT_WS_ENTITY12_PARAM1DESC: "اللاعب (اللاعبون) الذي سيحصل على العنصر",
  T_34_WT_WS_ENTITY12_PARAM2DESC: "معرف العنصر المحدد الذي سيتم الحصول عليه",
  T_34_WT_WS_ENTITY12_PARAM2DESC3: "كمية العناصر التي سيتم إعطاؤها",
  T_34_WT_WS_ENTITY12_PARAM3: "كمية",
  T_34_WT_WS_ENTITY13_PARAM1: "نوع",
  T_34_WT_WS_ENTITY13_PARAM2: "الموقع الحالي",
  T_34_WT_WS_ENTITY13_PARAM2DESC: "إحداثيات موقع ظهور العنصر",
  T_34_WT_WS_ENTITY13_PARAM4: "العنصر",
  T_34_WT_WS_ENTITY14_NAME: "إزالة العنصر",
  T_34_WT_WS_ENTITY14_NAMEDESC: "إزالة عنصر معين",
  T_34_WT_WS_ENTITY14_PARAM1DESC: "احذف العنصر",
  T_34_WT_WS_ENTITY15_NAMEDESC: "احصل على جميع الكيانات اللاعب",
  T_34_WT_WS_ENTITY16_NAMEDESC: "احصل على جميع كيانات الفريق",
  T_34_WT_WS_ENTITY17_NAMEDESC: "استعادة كمية معينة من نقاط الصحة للاعبين المعينين. إذا تجاوز كمية الاستعادة الحد الأقصى من نقاط الصحة، فستستعيد نقاط الصحة فقط إلى الحد الأقصى.",
  T_34_WT_WS_ENTITY17_PARAM1DESC: "اللاعب (اللاعبون) الذين يتم تكوين تقلبات نقاط الصحة الخاصة بهم",
  T_34_WT_WS_ENTITY17_PARAM2DESC: "الكمية المعينة من نقاط الصحة المراد استعادتها",
  T_34_WT_WS_ENTITY18_NAME: "احصل على إحداثيات تظهر عشوائية",
  T_34_WT_WS_ENTITY18_NAMEDESC: "تكوين المواقع للاعبين المعينين للظهور والعودة إليها",
  T_34_WT_WS_ENTITY18_PARAM1DESC: "اللاعبين الذين سيظهرون بشكل عشوائي من هذا الموقع",
  T_34_WT_WS_ENTITY18_RETURNDESC: "إحداثيات الموقع الذي سيتم تعيين اللاعب فيه",
  T_34_WT_WS_ENTITY19_NAME: "احصل على نتيجة اللاعب",
  T_34_WT_WS_ENTITY19_NAMEDESC: "احصل على درجات معينة من اللاعبين المعينين",
  T_34_WT_WS_ENTITY19_PARAM1DESC: "احصل على كيان النتيجة لهذا اللاعب (اللاعبين)",
  T_34_WT_WS_ENTITY19_PARAM2DESC: "احصل على نوع الدرجة",
  T_34_WT_WS_ENTITY19_RETURNDESC: "قيمة النتيجة المحددة التي سيتم الحصول عليها",
  T_34_WT_WS_ENTITY2_NAME: "تعيين الخاصية",
  T_34_WT_WS_ENTITY2_NAMEDESC: "تكوين قيمة الخاصية، حيث تم تحديد نوع الخاصية بالفعل",
  T_34_WT_WS_ENTITY2_PARAM1: "كيان",
  T_34_WT_WS_ENTITY2_PARAM1DESC: "قيمة خاصية كيان اللعبة",
  T_34_WT_WS_ENTITY2_PARAM3: "ملكية",
  T_34_WT_WS_ENTITY2_PARAM3DESC: "خاصية معينة لهذا كيان اللعبة",
  T_34_WT_WS_ENTITY2_PARAM4: "قيمة",
  T_34_WT_WS_ENTITY2_PARAM4DESC: "قيمة محددة للخاصية. تأكد من أن نوع الخاصية يتماشى مع النوع المحدد ويتطابق مع النوع الذي تم تكوينه في الكتل ذات الصلة.",
  T_34_WT_WS_ENTITY20_NAMEDESC: "تكوين درجات معينة من اللاعبين المعينين",
  T_34_WT_WS_ENTITY20_PARAM1DESC: "تكوين كيان النتيجة لهذا اللاعب (اللاعبين)",
  T_34_WT_WS_ENTITY20_PARAM2DESC: "تكوين نوع النتيجة",
  T_34_WT_WS_ENTITY20_PARAM3: "النتيجة",
  T_34_WT_WS_ENTITY20_PARAM3DESC: "يتم تعيين قيمة النتيجة المحددة",
  T_34_WT_WS_ENTITY21_NAME: "احصل على مجموع نتيجة الفريق",
  T_34_WT_WS_ENTITY21_NAMEDESC: "احصل على نوع معين من مجموع النتائج للفرق المعينة",
  T_34_WT_WS_ENTITY21_PARAM1: "فريق",
  T_34_WT_WS_ENTITY21_PARAM1DESC: "احصل على كيان النتيجة لهذا الفريق (الفرق)",
  T_34_WT_WS_ENTITY22_NAME: "تعيين نتيجة الجولة الحالية للفريق",
  T_34_WT_WS_ENTITY22_NAMEDESC: "قم تكوين نوع معين من نتائج الجولة الحالية للفرق المعينة",
  T_34_WT_WS_ENTITY22_PARAM1DESC: "تكوين نتيجة (درجات) هذا الفريق (الفرق)",
  T_34_WT_WS_ENTITY23_NAME: "احصل على نتيجة جولة اللاعب",
  T_34_WT_WS_ENTITY23_NAMEDESC: "احصل على درجات معينة من جولة معينة للاعبين المعينين",
  T_34_WT_WS_ENTITY23_PARAM1DESC: "احصل على درجة (درجات) الجولة لهذا اللاعب (اللاعبين)",
  T_34_WT_WS_ENTITY23_PARAM2: "الجولة",
  T_34_WT_WS_ENTITY23_PARAM2DESC: "احصل على النتيجة من هذه الجولة",
  T_34_WT_WS_ENTITY24_NAME: "احصل على نتيجة جولة الفريق",
  T_34_WT_WS_ENTITY24_NAMEDESC: "احصل على درجات معينة من جولة معينة للفرق المعينة",
  T_34_WT_WS_ENTITY25_NAME: "النقل الفضائي",
  T_34_WT_WS_ENTITY25_NAMEDESC: "انتقال فوري للاعبين المعينين إلى موقع معين",
  T_34_WT_WS_ENTITY25_PARAM1DESC: "اللاعب (اللاعبون) الذي سيتم نقله آنيًا",
  T_34_WT_WS_ENTITY25_PARAM2DESC: "إحداثيات مكان انتقال اللاعب (اللاعبين) آنيًا",
  T_34_WT_WS_ENTITY26_NAMEDESC: "تمكين اللاعبين المعينين من إلحاق الضرر بالأهداف المحددة. إذا لم يتم تحديد لاعب مهاجم، فستتلقى الأهداف المحددة ضررًا من النظام.",
  T_34_WT_WS_ENTITY26_PARAM2DESC: "الكيانات التي ستتلقى الضرر",
  T_34_WT_WS_ENTITY26_PARAM4DESC: "مقدار الضرر الذي تم التعامل معه",
  T_34_WT_WS_ENTITY28_NAMEDESC: "إحياء اللاعبين المعينين",
  T_34_WT_WS_ENTITY28_PARAM1DESC: "كيانات اللاعب التي يمكن إحياؤها",
  T_34_WT_WS_ENTITY3_NAMEDESC: "تكوين نوع الكتلة",
  T_34_WT_WS_ENTITY3_PARAM1: "كما",
  T_34_WT_WS_ENTITY4_NAME: "احصل على الممتلكات",
  T_34_WT_WS_ENTITY4_NAMEDESC: "احصل على خاصية محددة لكيان",
  T_34_WT_WS_ENTITY4_PARAM1DESC: "احصل على كيان اللعبة المحدد لقيمة الخاصية",
  T_34_WT_WS_ENTITY4_RETURNDESC: "قيمة الممتلكات المحددة التي سيتم الحصول عليها",
  T_34_WT_WS_ENTITY5_NAMEDESC: "تكوين القدرة على التحرك لجميع اللاعبين",
  T_34_WT_WS_ENTITY6_NAME: "أنشئ أيقونة",
  T_34_WT_WS_ENTITY6_PARAM1: "أيقونة",
  T_34_WT_WS_ENTITY6_PARAM1DESC: "صورة معروضة على HUD. اختر من بين مختلف التصاميم.",
  T_34_WT_WS_ENTITY6_PARAM4DESC: "اختر الأيقونة التي يجب أن يطبق عليها التصميم",
  T_34_WT_WS_ENTITY7_NAMEDESC: "قم بإنشاء أيقونة HUD للاعبين المعينين. إذا لم يتم تحديد أي كيان لاعب، فسيتم إنشاء HUD لجميع اللاعبين.",
  T_34_WT_WS_ENTITY7_PARAM1: "لاعب",
  T_34_WT_WS_ENTITY7_PARAM1DESC: "قم بإنشاء أيقونة HUD لاختيار لاعب (لاعبين)",
  T_34_WT_WS_ENTITY8_NAME: "أنشئ نصًا",
  T_34_WT_WS_ENTITY8_PARAM1: "نص",
  T_34_WT_WS_ENTITY8_PARAM1DESC: "محتوى النص المحدد الذي سيتم إنشاؤه من هذا الأمر",
  T_34_WT_WS_ENTITY8_PARAM3DESC: "كيان النص الذي يتم إنشاؤه حاليًا",
  T_34_WT_WS_ENTITY9_NAMEDESC: "أضف سطرًا من نص HUD للاعبين المعينين. إذا لم يتم تحديد أي كيان لاعب، فسيتم إنشاء النص على HUD لجميع اللاعبين.",
  T_34_WT_WS_ENTITY9_PARAM1DESC: "أضف نص HUD لاختيار لاعب (لاعبين)",
  T_34_WT_WS_ICONENTITY_PARAM1: "كيان أيقوني",
  T_34_WT_WS_ICONENTITY_PARAM2: "التصميم",
  T_34_WT_WS_ICONENTITY_PARAM3: "اللون",
  T_34_WT_WS_ICONENTITY_PARAM4: "حجم",
  T_34_WT_WS_ICONENTITY_PARAM5: "موقع العرض",
  T_34_WT_WS_ICONENTITY_PARAM6: "اتبع الهدف",
  T_34_WT_WS_ICONENTITY_PARAM7: "مرئي من خلال الجدران",
  T_34_WT_WS_ICONENTITY_PARAM8: "دائمًا بتشغيل الشاشة",
  T_34_WT_WS_ONETEAM_TAG: "فريق واحد",
  T_34_WT_WS_PHASEENTITY_PARAM1: "كيان المرحلة",
  T_34_WT_WS_PHASEENTITY_PARAM2: "مؤشرالمرحلة",
  T_34_WT_WS_PHASEENTITY_PARAM3: "وقت البدء",
  T_34_WT_WS_PHASEENTITY_PARAM4: "وقت النهاية",
  T_34_WT_WS_PHASEENTITY_PARAM5: "المدة",
  T_34_WT_WS_PLAYERENTITY_PARAM1: "كيان اللاعب",
  T_34_WT_WS_PLAYERENTITY_PARAM10: "نقطة الإحياء",
  T_34_WT_WS_PLAYERENTITY_PARAM12: "نسبة الضرر",
  T_34_WT_WS_PLAYERENTITY_PARAM13: "نموذج الشخصية ثلاثية الأبعاد",
  T_34_WT_WS_PLAYERENTITY_PARAM17: "هوية",
  T_34_WT_WS_PLAYERENTITY_PARAM18: "نقاط الصحة الحالية",
  T_34_WT_WS_PLAYERENTITY_PARAM2: "الحد الأقصى لنقاط الصحة",
  T_34_WT_WS_PLAYERENTITY_PARAM3: "AI",
  T_34_WT_WS_PLAYERENTITY_PARAM4: "حالة اللاعب",
  T_34_WT_WS_PLAYERENTITY_PARAM5: "وقت النجاة",
  T_34_WT_WS_PLAYERENTITY_PARAM6: "منيع",
  T_34_WT_WS_PLAYERENTITY_PARAM7: "فريق",
  T_34_WT_WS_PLAYERENTITY_PARAM8: "معرف نقطة الهدف",
  T_34_WT_WS_PLAYERENTITY_PARAM9: "نقطة إنعاش",
  T_34_WT_WS_PROCIRCLE_ICON: "أيقونة",
  T_34_WT_WS_PVEDESC1: "إذا وصل لاعب واحد على الأقل إلى خط النهاية قبل نفاد الوقت، يفوز الفريق. إذا تم القضاء على جميع اللاعبين في نفس الوقت، تنتهي اللعبة.",
  T_34_WT_WS_PVEDESC2: "ابقى على قيد الحياة لفترة محددة للفوز. إذا تم القضاء على جميع اللاعبين في نفس الوقت، تنتهي اللعبة.",
  T_34_WT_WS_PVENAME1: "راش",
  T_34_WT_WS_PVENAME2: "التحمل",
  T_34_WT_WS_RUNCHECKENTITY_PARAM1: "معرف النقطة الحالية",
  T_34_WT_WS_RUNCHECKENTITY_PARAM2: "رقم نقطة تسجيل وضع الباركور",
  T_34_WT_WS_SKILLSET14: "غضب السياف (كينتا)",
  T_34_WT_WS_TEAMENTITY_PARAM1: "كيان الفريق",
  T_34_WT_WS_TEAMENTITY_PARAM2: "محترف",
  T_34_WT_WS_TEAMENTITY_PARAM3: "جميع الأعضاء",
  T_34_WT_WS_TRIGGERNTITY_PARAM1: "المشغل العادي",
  T_34_WT_WS_TRIGGERNTITY_PARAM2: "نوع المظهر",
  T_34_WT_WS_TXTENTITY_PARAM1: "كيان النص",
  T_34_WT_WS_TXTENTITY_PARAM2: "محتوى",
  T_34_WT_WS_VFXENTITY_PARAM1: "كيان التأثيرات البصرية",
  T_34_WZ_WS_LOGIC10_NAME: "تابع إلى التالي",
  T_34_WZ_WS_LOGIC10_NAMEDESC: "تخطي تكرار الجولة الحالية وتنفيذ التالي",
  T_34_WZ_WS_LOGIC11_NAME: "رجوع",
  T_34_WZ_WS_LOGIC11_NAMEDESC: "إنهاء التنفيذ الحالي والعودة إلى البرنامج الرئيسي. يسمح بإعادة إرسال البيانات عند العودة.",
  T_34_WZ_WS_LOGIC11_PARAM1_NAME: "قيمة الإرجاع",
  T_34_WZ_WS_LOGIC11_PARAM1_NAMEDESC: "يتم إرسال البيانات إلى البرنامج الرئيسي",
  T_34_WZ_WS_LOGIC2_NAME: "قارن",
  T_34_WZ_WS_LOGIC2_NAMEDESC: "قارن بين قيمتين باستخدام مشغل معين",
  T_34_WZ_WS_LOGIC2_PARAM1_NAME: "القيمة اليسرى",
  T_34_WZ_WS_LOGIC2_PARAM1_NAMEDESC: "قيمة الجانب الأيسر المستخدمة للمقارنة",
  T_34_WZ_WS_LOGIC2_PARAM2_NAME: "وظيفة المقارنة",
  T_34_WZ_WS_LOGIC2_PARAM2_NAMEDESC: "حدد الطريقة التي تريد بها مقارنة القيم. العوامل المدعومة هي: >, ≥, ==, ≠, ≤, <، و(قيمة منطقية فقط)، أو (قيمة منطقية فقط)",
  T_34_WZ_WS_LOGIC2_PARAM3_NAME: "القيمة اليمنى",
  T_34_WZ_WS_LOGIC2_PARAM3_NAMEDESC: "قيمة الجانب الأيمن المستخدمة للمقارنة",
  T_34_WZ_WS_LOGIC2_PARAM4_NAMEDESC: "نتيجة المقارنة",
  T_34_WZ_WS_LOGIC3_NAME: "NOT",
  T_34_WZ_WS_LOGIC3_NAMEDESC: "يعطي عكس القيمة المنطقية",
  T_34_WZ_WS_LOGIC3_PARAM1_NAMEDESC: "القيمة التي ترغب في استخدام مشغل NOT عليها",
  T_34_WZ_WS_LOGIC3_PARAM2_NAMEDESC: "نتيجة عملية NOT",
  T_34_WZ_WS_LOGIC4_NAME: "تحقق فارغ",
  T_34_WZ_WS_LOGIC4_NAMEDESC: "تحقق مما إذا كان الكيان فارغًا أو غير صحيحا",
  T_34_WZ_WS_LOGIC4_PARAM1_NAME: "كيان",
  T_34_WZ_WS_LOGIC4_PARAM1_NAMEDESC: "الكيان المراد التحقق من الفراغ",
  T_34_WZ_WS_LOGIC4_PARAM2_NAMEDESC: "ما إذا كان الكيان فارغًا أم لا",
  T_34_WZ_WS_LOGIC5_NAME: "إذا",
  T_34_WZ_WS_LOGIC5_NAMEDESC: "يتم التنفيذ وفقًا لما إذا تم استيفاء الشروط أم لا. العمليات الفرعية هي نفسها الفروع المنطقية اللاحقة.",
  T_34_WZ_WS_LOGIC5_PARAM1_NAME: "قيمة",
  T_34_WZ_WS_LOGIC5_PARAM1_NAMEDESC: "يجب أن يكون عدد الشروط وعدد العمليات الفرعية (الفروع المنطقية) متماثلًا",
  T_34_WZ_WS_LOGIC6_NAME: "حلقة من نطاق عدد صحيح",
  T_34_WZ_WS_LOGIC6_NAMEDESC: "حلقة من x إلى y بخطوة z. العملية الفرعية هي الحلقة نفسها.",
  T_34_WZ_WS_LOGIC6_PARAM1_NAMEDESC: "اسم مؤشر الحلقة الذي يمكن استخدامه لاستخراج قيمة مؤشر حلقة المتغير المحلي",
  T_34_WZ_WS_LOGIC6_PARAM2_NAME: "قيمة البداية",
  T_34_WZ_WS_LOGIC6_PARAM2_NAMEDESC: "القيمة التي تبدأ عندها الحلقة",
  T_34_WZ_WS_LOGIC6_PARAM3_NAME: "القيمة النهائية",
  T_34_WZ_WS_LOGIC6_PARAM3_NAMEDESC: "القيمة التي تنتهي عندها الحلقة",
  T_34_WZ_WS_LOGIC6_PARAM4_NAME: "خطوة",
  T_34_WZ_WS_LOGIC6_PARAM4_NAMEDESC: "خطوة كل حلقة. عندما تكون قيمة البداية أقل من القيمة النهائية، يجب أن تكون الخطوة أكبر من 0. عندما تكون قيمة البداية أكبر من القيمة النهائية، يجب أن تكون الخطوة أقل من 0.",
  T_34_WZ_WS_LOGIC7_NAME: "قم بتكرار كل عنصر",
  T_34_WZ_WS_LOGIC7_NAMEDESC: "لتمكين اجتياز حاوية بيانات لاستخراج كل عنصر فرعي بداخلها. العملية الفرعية هي الحلقة نفسها.",
  T_34_WZ_WS_LOGIC7_PARAM1_NAME: "العنصر",
  T_34_WZ_WS_LOGIC7_PARAM1_NAMEDESC: "اجتياز إلى هذا الاسم سيستخرج قيمة العنصر الفرعي للعامل المحلي",
  T_34_WZ_WS_LOGIC7_PARAM3_NAME: "حاوية البيانات",
  T_34_WZ_WS_LOGIC7_PARAM3_NAMEDESC: "حاوية البيانات لاجتيازها. يدعم حاليًا أنواع القوائم.",
  T_34_WZ_WS_LOGIC8_NAME: "حلقة شرطية",
  T_34_WZ_WS_LOGIC8_NAMEDESC: "تتكرر الحلقة الشرطية حتى يتم استيفاء الشرط. الحلقة تتوقف عندما يكون الشرط خطأ.",
  T_34_WZ_WS_LOGIC8_PARAM1_NAME: "الشروط",
  T_34_WZ_WS_LOGIC8_PARAM1_NAMEDESC: "تكرار الحلقة إذا كان الشرط صحيحا وتتوقف حتى يصبح الشرط خطأ",
  T_34_WZ_WS_LOGIC9_NAME: "حلقة الكسر",
  T_34_WZ_WS_LOGIC9_NAMEDESC: "توقف عملية الحلقة الحالية وتقفز من الحلقة",
  T_34_Y_B_DINOSAURS: "دينو الوهمي (سفلي)",
  T_34_YF_M24_N: "M24",
  T_34_YS_F_B_ANGEL_BW: "Angelic الأبيض (أنثى)",
  T_34_YS_F_B_PANDACATTLE: "بيجاما البقرة (سفلي)",
  T_34_YS_F_B_RAMPAGE4_RAIN: "الغضب المائي (سفلي)",
  T_34_YS_F_H_RAMPAGE4_RAIN: "الغضب المائي (رأس)",
  T_34_YS_F_HA_RAMPAGE4_RAIN: "الغضب المائي (طلاء وجه)",
  T_34_YS_F_S_PANDACATTLE: "بيجاما البقرة (حذاء)",
  T_34_YS_F_S_RAMPAGE4_RAIN: "الغضب المائي (حذاء)",
  T_34_YS_F_T_PANDACATTLE: "بيجاما البقرة (علوي)",
  T_34_YS_F_T_RAMPAGE4_RAIN: "الغضب المائي (علوي)",
  T_34_YS_M_B_ANGEL_BW: "Angelic الأبيض (ذكر)",
  T_34_YS_M_B_PANDACATTLE: "بيجاما باندا (سفلي)",
  T_34_YS_M_H_PANDACATTLE: "بيجاما باندا (رأس)",
  T_34_YS_M_S_PANDACATTLE: "بيجاما باندا (حذاء)",
  T_34_YS_M_T_PANDACATTLE: "بيجاما باندا (علوي)",
  T_34_YZY_CHARACTER_RHYTHMGIRL_N: "A-Patroa",
  T_35_C_SKILL_DESC_BRAZILSOLDIER: "كسب [FFB300]{0} نقاط EP[-] عن طريق هزيمة العدو.",
  T_35_DY_PET_OWL_N: "هووت",
  T_35_DY_PETSKIN_ALIEN_DIGITALUNIVERSE_N: "سكن الحيوان الأليف: سفينة مووني الفضائية",
  T_35_DY_PETSKIN_CATEAM_AXOLOTL_N: "سكن الحيوان الأليف: زاسيل الرؤية الزرقاء",
  T_35_DY_PETSKIN_CATEAM_HAWK_N: "سكن الحيوان الأليف: آغي الأزرق",
  T_35_DY_PETSKIN_OWL_FIRE_N: "سكن الحيوان الأليف: هووت على نار",
  T_35_DY_PETSKIN_OWL_NIGHT_N: "سكن الحيوان الأليف: هووت الليلي",
  T_35_DY_PETSKIN_OWL_STORM_N: "سكن الحيوان الأليف: هووت المثلج",
  T_35_JL_KNOCKEDDOWN: "تم سقط",
  T_35_JL_SKILL_DESC_CRAZYGIRL: "في غضون [FFB300]{1}ث[-] سيؤدي إطلاق النار بنجاح على جدار الجلو لتحديد الأعداء في نطاق [FFB300]{3}متر[-] منه، واختراق جدار الجلو لإحداث ضرر للأعداء المذكورين (سيكون الضرر المُحدث أقل من المعتاد). فعالة يحد أقصى [FFB300]{0}[-] جدران جلو. وقت التهدئة: [FFB300]{2}ث[-].",
  T_35_JL_SKILL_NAME_CRAZYGIRL: "خلف الجدار",
  T_35_KY_INFECTION_MAPNAME: "منطقة الخردة",
  T_35_M_WS_BUTTONCLICKDESC: "يُفعّل هذا الحدث عند الضغط على الزر المُناسب. يُمكن الحصول على مُشغّل التفعيل باستخدام المُعلمات.",
  T_35_M_WS_GETTEAMMATEPOS: "احصل مواقع زملاء الفريق القريبة",
  T_35_M_WS_ROUND2: "الجولة الحالية",
  T_35_PD_Infection_HUMANSELECT: "اختر سلاحا",
  T_35_PD_INFECTION_MODENAME: "صعود الروبوتات",
  T_35_QX_WS_ICONTYPE_ITEM: "العنصر",
  T_35_QX_WS_ICONTYPE_NATURE: "أشكال الطبيعة",
  T_35_QX_WS_ICONTYPE_SHAPE: "هندسي",
  T_35_QX_WS_ICONTYPE_SYMBOL: "رمز",
  T_35_QX_WS_SOUNDTYPE_WEAPON: "أسلحة",
  T_35_R_EMOTE_TAG_MUSIC_N: "الموسيقى",
  T_35_RW_SKILL_DESC_Singers: "يمكن لمستخدم المهارة وحلفائه في نطاق [FFB300]{0}متر[-] منع [FFB300]{1}%[-] من الضرر باستخدام نقاط EP. في هذه الحالة، سيتم إضافة مقدار نقاط EP المخصومة من الحلفاء إلى نقاط EP مستخدم المهارة.",
  T_35_RW_SKILL_NAME_Singers: "الحارس الصامت",
  T_35_SP_WS_COMMENTKEY_01: "صعوبة مناسبة",
  T_35_SP_WS_COMMENTKEY_02: "إبداعي",
  T_35_SP_WS_COMMENTKEY_03: "طريقة لعب مثيرة للاهتمام",
  T_35_SP_WS_COMMENTKEY_04: "يمكن لعبه بشكل متكرر",
  T_35_SP_WS_COMMENTKEY_05: "قصة مثيرة للاهتمام",
  T_35_SP_WS_COMMENTKEY_06: "جيد التوازن",
  T_35_SP_WS_COMMENTKEY_07: "تجربة ممتعة",
  T_35_SP_WS_COMMENTKEY_08: "مرنة",
  T_35_SP_WS_COMMENTKEY_09: "مُرضٍ كثيرا",
  T_35_SP_WS_COMMENTKEY_10: "صعبة جدًا",
  T_35_SP_WS_COMMENTKEY_11: "سهلة جدًا",
  T_35_SP_WS_COMMENTKEY_12: "مملة",
  T_35_SP_WS_COMMENTKEY_13: "طويلة جدًا",
  T_35_SP_WS_COMMENTKEY_14: "غير متوازن",
  T_35_SP_WS_COMMENTKEY_15: "تجربة غير سارة",
  T_35_SP_WS_IMAGE03: "نسيج",
  T_35_SP_WS_IMAGE04: "إطار",
  T_35_SY_CHARGESHOT_TEARS_N: "الشحن العنيف - بريق الحمم",
  T_35_SY_GRENADE_DIGITALUNIVERSE_01_N: "قنبلة - جمجمة الكريستال",
  T_35_SY_GRENADE_PIRATES_N: "قنبلة - الجمجمة الصاخبة",
  T_35_SY_GRENADE_RIDERS_N: "قنبلة - الدراج العنيف",
  T_35_SY_M24_KUN_N: "M24 - عاصف النهر",
  T_35_SY_SCAR_PARKOUR_N: "SCAR - العداء الحر",
  T_35_SY_VEHICLE_JEEP_PANTOMIME_N: "سيارة جيب - أحجية أحادية اللون",
  T_35_SY_VEHICLE_MONSTER_DIGITALUNIVERSE_D: "استمتع بالاحتفال!",
  T_35_SY_VEHICLE_MOTOBIKE_DIGITALUNIVERSE_N: "دراجة نارية - التناظر البلوري",
  T_35_WT_WS_PREFAB_MENUBAR_1: "ديكور الهيكل",
  T_35_WT_WS_PREFAB_MENUBAR_1_1: "الهياكل",
  T_35_WT_WS_PREFAB_MENUBAR_1_6: "أخرى",
  T_35_WT_WS_PREFAB_MENUBAR_2: "عمارة",
  T_35_WT_WS_PREFAB_MENUBAR_2_1: "المباني الكبيرة",
  T_35_WT_WS_PREFAB_MENUBAR_2_2: "مباني متوسطة الحجم",
  T_35_WT_WS_PREFAB_MENUBAR_3: "الكائنات الوظيفية",
  T_35_WT_WS_PREFAB_MENUBAR_3_1: "أساسيات الوضع",
  T_35_WT_WS_PREFAB_MENUBAR_3_6: "الموسيقى",
  T_35_WT_WS_PVEMODE_TAG: "وضع النجاة",
  T_35_WZY_WS_BECRE_NAMEDESC: "يتم تشغيله عند إنشاء هذا الكيان",
  T_35_WZY_WS_BEKILL_NAMEDESC: "يتم تشغيله عندما يتم استبعاد هذا الكيان. يمكن تحديد مصدر الهجوم باستخدام كيان الزناد ويمكن تحديد نوع الهجوم باستخدام نوع الضرر.",
  T_35_WZY_WS_BEKILL_PARAM1_NAMEDESC: "العنصر الذي تسبب في الحادث",
  T_35_WZY_WS_CREPROP_NAMEDESC: "قم بإنشاء نوع عنصر أو مجموعة عناصر في موقع محدد. عند إنشاء نوع واحد من العناصر، يكون المبلغ هو رقم هذا العنصر. عند إنشاء مجموعة من العناصر، فإن المبلغ هو قائمة المبلغ التي تتوافق مع قائمة العناصر. ستعتمد العناصر التي تم إنشاؤها على وحدات الخريطة.",
  T_35_WZY_WS_CREPROP_PARAM1_NAMEDESC: "قائمة تحتوي على العناصر التي سيتم إنشاؤها. يمكن أن تتكون أيضًا من عنصر واحد.",
  T_35_WZY_WS_CREPROP_PARAM2_NAMEDESC: "قائمة المقدار التي تتوافق مع قائمة العناصر. قد يحتوي فقط على مقدار نوع عنصر واحد.",
  T_35_WZY_WS_DAMTYPE_CAR: "مركبة",
  T_35_WZY_WS_DAMTYPE_FALL: "سقط",
  T_35_WZY_WS_DAMTYPE_FIREARMS: "مسدس",
  T_35_WZY_WS_DAMTYPE_GRENADE: "قنبلة",
  T_35_WZY_WS_DAMTYPE_MELEE: "المشاجرة",
  T_35_WZY_WS_DAMTYPE_ZONE: "خارج المنطقة",
  T_35_WZY_WS_DELPROP_NAMEDESC: "حذف عدد محدد من عناصر لاعبين محددين",
  T_35_WZY_WS_ENTERTRIGGER_NAME: "دخول منطقة الزناد",
  T_35_WZY_WS_ENTERTRIGGER_NAMEDESC: "يتم تشغيله عندما يدخل كيان الزناد إلى منطقة الزناد",
  T_35_WZY_WS_ENTITYPLAYER_DESC: "اللاعب للحصول على الكيان. عند ربطه باللاعب، سيتم تحديث معلومات الكيان للاعب المذكور فقط. عندما لا يتم ربط أي لاعب، سيتلقى جميع اللاعبين معلومات الكيان.",
  T_35_WZY_WS_FIGHTENTITY_NAME: "كيان المعركة",
  T_35_WZY_WS_GETALLOB_NAMEDESC: "احصل على جميع العناصر من  النوع المحدد. النتيجة التي تم إرجاعها هي قائمة.",
  T_35_WZY_WS_GETALLOB_PARAM1_NAMEDESC: "نوع العنصر",
  T_35_WZY_WS_HUDWIDGET_NAME: "التحكم في الواجهة",
  T_35_WZY_WS_HURT_NAMEDESC: "يتم تشغيله عندما يتعرض هذا الكيان للضرر. يمكن تحديد مصدر الهجوم باستخدام كيان الزناد.",
  T_35_WZY_WS_ITEMSTYPE_NAMEDESC: "نوع العنصر",
  T_35_WZY_WS_LEVELOBJECT_NAME: "عنصر المرحلة",
  T_35_WZY_WS_OBKILL_NAMEDESC: "يتم تشغيله عندما يقوم هذا الكيان بحذف كيان آخر. يمكن تحديد نوع الكيان الذي يتم حذفه باستخدام الكيان المحذوف.",
  T_35_WZY_WS_OBKILL_PARAM1_NAMEDESC: "الكيان الذي تم استبعاده",
  T_35_WZY_WS_ONHURT_NAMEDESC: "يتم تشغيله عندما يتسبب كيان في حدوث ضرر",
  T_35_WZY_WS_ONHURT_PARAM1_DESC: "الكيان الذي يتعامل مع الضرر",
  T_35_WZY_WS_ONHURT_PARAM1_NAME: "الكيان المستهدف",
  T_35_WZY_WS_PREFABID_NAME: "معرف القالب",
  T_35_WZY_WS_PROPERTY_EPNOW: "الخبرة الحالية",
  T_35_WZY_WS_PROPERTY_JUMP: "ارتفاع القفزة",
  T_35_WZY_WS_QUITTRIGGER_NAME: "خروج منطقة الزناد",
  T_35_WZY_WS_QUITTRIGGER_NAMEDESC: "يتم تشغيله عندما يخرج كيان الزناد من منطقة الزناد",
  T_35_WZY_WS_REMOVEELEMENT_NAMEDESC: "أزل عنصر معين من القائمة. [القائمة] هي القائمة التي يقع فيها العنصر. [العنصر] هو العنصر المراد إزالته.",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAME: "قيمة العنصر",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAMEDESC: "قيمة العنصر المراد إزالته",
  T_35_WZY_WS_ROUNDENTITY_NAME: "كيان مستدير",
  T_35_WZY_WS_TOWER_PARAM1: "البرج والقلعة",
  T_35_WZY_WS_TOWER_PARAM2: "معرف الفريق",
  T_35_WZY_WS_TOWER_PARAM3: "نقاط الصحة الحالية",
  T_35_WZY_WS_TOWER_PARAM4: "الحد الأقصى للصحة",
  T_35_WZY_WS_TOWER_PARAM5: "الضرر",
  T_35_WZY_WS_TOWER_PARAM6: "الفترة الفاصلة للهجوم",
  T_35_WZY_WS_TOWER_PARAM7: "نطاق الهجوم",
  T_35_WZY_WS_TOWER_PARAM8: "دفاع %",
  T_35_XYL_PDM_REVENGE: "انتقم",
  T_35_XYL_WS_BISPARTERRE: "جرافيتي سرير من الزهر",
  T_35_XYL_WS_BISPARTERRE_DESC: "سرير زهرة حجري على طراز قاتل بأسلوبك",
  T_35_XYL_WS_BISWALL: "جدار الجرافيتي",
  T_35_XYL_WS_BISWALL_DESC: "جدار بموضوع قاتل بأسلوبك يمكن دمجه",
  T_35_XYL_WS_BOTDROP: "قم بتشغيل / إيقاف تشغيل الغنائم",
  T_35_XYL_WS_CUSTOMTRIGGER: "مشغل مخصص",
  T_35_XYL_WS_CUSTOMTRIGGER_DESC: "ضع عنصرًا يُطلق تأثيرًا خاصًا مخصصًا معينًا عندما يقوم اللاعب بتنشيطه. يجب تكوين التأثير في البرنامج النصي. (فقط في وضع التخصيص.)",
  T_35_XYL_WS_DOUBLEDOOR: "بوابة",
  T_35_XYL_WS_DOUBLEDOOR_DESC: "بوابة مفتوحة",
  T_35_XYL_WS_RESET: "قم بإعادة تعيين كل جولة",
  T_35_XYL_WS_RESETN: "لا",
  T_35_XYL_WS_RESETY: "نعم",
  T_35_XYL_WS_ROADBLOCK: "حاجز A",
  T_35_XYL_WS_ROADBLOCK_DESC: "يمنع من المرور من خلاله",
  T_35_XYL_WS_STAIRS: "السلالم",
  T_35_XYL_WS_STAIRS_DESC: "السلالم التي يمكن دمجها مع الهبوط",
  T_35_XYL_WS_STAIRSL: "الهبوط ب",
  T_35_XYL_WS_STAIRSL_DESC: "منصة يمكن دمجها مع السلالم",
  T_35_XYL_WS_STAIRSZ: "الهبوط أ",
  T_35_XYL_WS_STAIRSZ_DESC: "منصة يمكن دمجها مع السلالم",
  T_35_XYL_WS_TBOOTH: "كشك الهاتف",
  T_35_XYL_WS_TBOOTH_DESC: "ينظر عادة في الشوارع",
  T_35_YF_PP19_N: "بيزون",
  T_35_YS_A_CATEAM_HW: "آغي",
  T_35_YS_A_CUBBY: "وشاح الدبدوب",
  T_35_YS_F_A_PANTOMIME: "محبة أحادي اللون (قناع)",
  T_35_YS_F_A_RIDERS: "الدراجة القاتلة (قناع)",
  T_35_YS_F_B_DIGITALUNIVERSE2: "موحدة الجمال (سفلي)",
  T_35_YS_F_B_GOLDCHAIN: "درع الأغنياء (سفلي)",
  T_35_YS_F_B_PANTOMIME: "محبة أحادي اللون (سفلي)",
  T_35_YS_F_B_RIDERS: "الدراجة القاتلة (سفلي)",
  T_35_YS_F_H_BEAR_HW: "قبعة الدبدوب",
  T_35_YS_F_H_DIGITALUNIVERSE2: "موحدة الجمال (رأس)",
  T_35_YS_F_H_GOLDCHAIN: "درع الأغنياء (رأس)",
  T_35_YS_F_H_PANTOMIME: "محبة أحادي اللون (رأس)",
  T_35_YS_F_H_RIDERS: "الدراجة القاتلة (رأس)",
  T_35_YS_F_HA_GOLDCHAIN: "درع الأغنياء (طلاء وجه)",
  T_35_YS_F_S_DIGITALUNIVERSE2: "موحدة الجمال (حذاء)",
  T_35_YS_F_S_GOLDCHAIN: "درع الأغنياء (حذاء)",
  T_35_YS_F_S_PANTOMIME: "محبة أحادي اللون (حذاء)",
  T_35_YS_F_S_RIDERS: "الدراجة القاتلة (حذاء)",
  T_35_YS_F_T_DIGITALUNIVERSE2: "موحدة الجمال (علوي)",
  T_35_YS_F_T_GOLDCHAIN: "درع الأغنياء (علوي)",
  T_35_YS_F_T_PANTOMIME: "محبة أحادي اللون (علوي)",
  T_35_YS_F_T_RIDERS: "الدراجة القاتلة (علوي)",
  T_35_YS_ITEM_SUPERFAK: "العلاج السوبر",
  T_35_YS_M_A_GOLDCHAIN: "السلاسل الفاخرة (قناع)",
  T_35_YS_M_A_RIDERS: "الدراج العنيف (قناع)",
  T_35_YS_M_B_GOLDCHAIN: "السلاسل الفاخرة (سفلي)",
  T_35_YS_M_B_RIDERS: "الدراج العنيف (سفلي)",
  T_35_YS_M_H_BEAR_HW: "قبعة الدبدوب",
  T_35_YS_M_H_GOLDCHAIN: "السلاسل الفاخرة (رأس)",
  T_35_YS_M_H_RIDERS: "الدراج العنيف (رأس)",
  T_35_YS_M_S_GOLDCHAIN: "السلاسل الفاخرة (حذاء)",
  T_35_YS_M_S_RIDERS: "الدراج العنيف (حذاء)",
  T_35_YS_M_T_GOLDCHAIN: "السلاسل الفاخرة (علوي)",
  T_35_YS_M_T_RIDERS: "الدراج العنيف (علوي)",
  T_35_YS_T_CHAMPION: "قميص البطل",
  T_35_YS_T_PAINTING: "القميص المضغوط",
  T_35_YZY_CHARACTER_CRAZYGIRL_N: "آيريس",
  T_35_YZY_CHARACTER_SINGERS_N: "J.Biebs",
  T_36_JH_WS_BASEMONEY: "احصل عملات عند بدء المباراة",
  T_36_JH_WS_CESAYCLOSE: "تعطيل الإغلاق اليدوي أم لا",
  T_36_JH_WS_CHOOSEEDITSHOP: "حدد متجرًا لتعديله",
  T_36_JH_WS_CHOOSESHOP: "اختر متجرًا",
  T_36_JH_WS_COINCOUNT: "مقدار العملة",
  T_36_JH_WS_COINHUD: "عرض كمية العملة أم لا",
  T_36_JH_WS_CRAFTSHOP: "تعديل المتجر",
  T_36_JH_WS_CREATEGOLD: "مولد العملة",
  T_36_JH_WS_CSHOPENTITY: "كيان ربط المتجر",
  T_36_JH_WS_CSHOPHUD: "واجهة المتجر",
  T_36_JH_WS_CURRENTLIMIT: "حد الشراء المتبقي",
  T_36_JH_WS_ECONOMIC: "الإقتصاد",
  T_36_JH_WS_INGAMEECONOMI: "إقتصاد اللعبة",
  T_36_JH_WS_ITEMINDEXID: "رقم البضائع",
  T_36_JH_WS_KILLMONEY: "احصل على عملات للقتال",
  T_36_JH_WS_KILLMONEYTIP: "كيمة العملات التي تربحها  للقضاء على الزومبي في وضع الاندفاع ووضع التحمل",
  T_36_JH_WS_LISTINDEX: "قائمة أنواع البضائع",
  T_36_JH_WS_NULL: "لا شيء",
  T_36_JH_WS_NUMBER: "المقدار",
  T_36_JH_WS_OPTIONNAME: "وضع صعود الروبوتات الحصري",
  T_36_JH_WS_REALSHOPENTITY: "كيان المتجر",
  T_36_JH_WS_SEEORHIDE: "عرض آلة البيع",
  T_36_JH_WS_SHOPFRONT: "المتجر",
  T_36_JH_WS_SHOPITEMLIST: "نوع البضائع",
  T_36_JH_WS_SHOPOPENCON: "حالة الفتح",
  T_36_JH_WS_SSHOPNAME: "اسم المتجر",
  T_36_JH_WS_TOTALLIMIT: "حد الشراء",
  T_36_JH_WS_TRIGGERWIDE: "نطاق الزناد",
  T_36_JH_WS_VENDMACHINE: "آلة البيع",
  T_36_JH_WS_WINMONEY: "احصل على عملات للنصر",
  T_36_JH_WS_WORTH: "القيمة",
  T_36_JL_FOREGRIP_MR_N: "قبضة الرماية",
  T_36_JL_GOLD_SCAR_I_N: "SCAR-I",
  T_36_JL_GOLD_SCAR_II_N: "SCAR-II",
  T_36_JL_GOLD_SCAR_III_N: "SCAR-III",
  T_36_JL_STOCK_SG_N: "مخزون الشوتجن",
  T_36_JL_STOCK_SR_N: "مخزون القناص",
  T_36_KK_WS_MONTSTERDES: "شاحنة ذات 4 مقاعد ذات متانة عالية ويمكنها السفر عبر التضاريس الوعرة",
  T_36_M_WS_SETTEMPVAR: "قم بتعيين عامل مؤقت",
  T_36_M_WS_TEMPVAR: "عامل مؤقت",
  T_36_SY_AK47_MAMBAS_N: "AK47 - لسعة المامبا",
  T_36_SY_AN94_MAMBAS_N: "AN94 - لسعة المامبا",
  T_36_SY_AR15_MAMBAS_N: "الرفراف - لسعة المامبا",
  T_36_SY_AUG_MAMBAS_N: "AUG - لسعة المامبا",
  T_36_SY_AWM_MAMBAS_N: "AWM - لسعة المامبا",
  T_36_SY_BLT_MAMBAS_N: "M828 - لسعة المامبا",
  T_36_SY_CHARGESHOT_MAMBAS_N: "الشحن العنيف - لسعة المامبا",
  T_36_SY_EAGLE_MAMBAS_N: "نسر الصحراء - لسعة المامبا",
  T_36_SY_FAMAS_MAMBAS_N: "فاماس - لسعة المامبا",
  T_36_SY_G18_MAMBAS_N: "G18 - لسعة المامبا",
  T_36_SY_G36_MAMBAS_N: "G36 - لسعة المامبا",
  T_36_SY_GRENADE_FESTIVAL_TU_N: "قنبلة - احتفالية البحرية",
  T_36_SY_GROZA_MAMBAS_N: "جروزا - لسعة المامبا",
  T_36_SY_HAND_CANNON_MAMBAS_N: "مدفع يدوي - لسعة المامبا",
  T_36_SY_HEALINGSNIPER_MAMBAS_N: "قناص العلاج - لسعة المامبا",
  T_36_SY_ICE_GUN_MAMBAS_N: "مسدس الثلج - لسعة المامبا",
  T_36_SY_KAR98K_MAMBAS_N: "Kar98k - لسعة المامبا",
  T_36_SY_KORD_MAMBAS_N: "كورد - لسعة المامبا",
  T_36_SY_M1014_MAMBAS_N: "M1014 - لسعة المامبا",
  T_36_SY_M14_MAMBAS_N: "M14 - لسعة المامبا",
  T_36_SY_M1873_MAMBAS_N: "M1873 - لسعة المامبا",
  T_36_SY_M1887_MAMBAS_N: "M1887 - لسعة المامبا",
  T_36_SY_M1917_MAMBAS_N: "M1917 - لسعة المامبا",
  T_36_SY_M21A5_MAMBAS_N: "النقار - لسعة المامبا",
  T_36_SY_M24_MAMBAS_N: "M24 - لسعة المامبا",
  T_36_SY_M249_MAMBAS_N: "M249 - لسعة المامبا",
  T_36_SY_M4A1_MAMBAS_N: "M4A1 - لسعة المامبا",
  T_36_SY_M500_MAMBAS_N: "M500 - لسعة المامبا",
  T_36_SY_M60_MAMBAS_N: "M60 - لسعة المامبا",
  T_36_SY_M79_MAMBAS_N: "M79 - لسعة المامبا",
  T_36_SY_MAC10_MAMBAS_N: "MAC10 - لسعة المامبا",
  T_36_SY_MAG7_MAMBAS_N: "MAG-7 - لسعة المامبا",
  T_36_SY_MINI_MAMBAS_N: "AC80 - لسعة المامبا",
  T_36_SY_MP40_MAMBAS_N: "MP40 - لسعة المامبا",
  T_36_SY_MP5_MAMBAS_N: "MP5 - لسعة المامبا",
  T_36_SY_P90_MAMBAS_N: "P90 - لسعة المامبا",
  T_36_SY_PARAFAL_MAMBAS_N: "بارافال - لسعة المامبا",
  T_36_SY_PP19_MAMBAS_N: "بيزون - لسعة المامبا",
  T_36_SY_PP19_POLICEMAN_N: "بيزون - حارس الأشباح",
  T_36_SY_SCAR_MAMBAS_N: "SCAR - لسعة المامبا",
  T_36_SY_SKS_MAMBAS_N: "SKS - لسعة المامبا",
  T_36_SY_SPAS12_MAMBAS_N: "SPAS12 - لسعة المامبا",
  T_36_SY_SUPERHEAT_GUN_MAMBAS_N: "بلازما - لسعة المامبا",
  T_36_SY_SVD_MAMBAS_N: "SVD - لسعة المامبا",
  T_36_SY_THOMPSON_MAMBAS_N: "طومسون - لسعة المامبا",
  T_36_SY_THROWINGKNIFE_MAMBAS_N: "خنجر - مامبا",
  T_36_SY_THROWINGKNIFE_MENA_N: "خنجر - بوهو",
  T_36_SY_TREATMENTGUN_MAMBAS_N: "مسدس العلاج - لسعة المامبا",
  T_36_SY_UMP45_MAMBAS_N: "UMP - لسعة المامبا",
  T_36_SY_USP45_MAMBAS_N: "USP - لسعة المامبا",
  T_36_SY_UZI_MAMBAS_N: "أوزي الصغير - لسعة المامبا",
  T_36_SY_VECTOR_MAMBAS_N: "فكتور - لسعة المامبا",
  T_36_SY_VEHICLE_MONSTER_TRUCK_BDK_N: "شاحنة متوحشة - الذهبي المشتعل",
  T_36_SY_VEHICLE_MOTOBIKE_SUGARSKULL22_N: "دراجة نارية - المرشد الوفي",
  T_36_SY_VEHICLE_ROADSTER_BDK_N: "سيارة رياضية - السائق المحترف",
  T_36_SY_VEHICLE_TUTU_POLICEMAN_N: "سيارة توك توك - رحلة للعالم السفلي",
  T_36_SY_VSS_MAMBAS_N: "VSS - لسعة المامبا",
  T_36_SY_XM8_MAMBAS_N: "XM8 - لسعة المامبا",
  T_36_WZY_AFTERACCUMULATOR: "المجمع الخلفي",
  T_36_WZY_AVAILAB: "مفعل",
  T_36_WZY_BACKANDFORTH: "ذهابا وإيابا",
  T_36_WZY_BASEMULTIPLIER: "المضاعف الأساسي",
  T_36_WZY_BASIC: "النوع الأساسي",
  T_36_WZY_BEFORACCUMULATOR: "المجمع الأمامي",
  T_36_WZY_CYLIC: "العودة",
  T_36_WZY_GUNPRO_PARAM1: "الضرر الأساسي",
  T_36_WZY_GUNPRO_PARAM10: "بداية انتشار الرصاصة",
  T_36_WZY_GUNPRO_PARAM11: "الحد الأقصى لمنطقة الانتشار",
  T_36_WZY_GUNPRO_PARAM12: "انفجار",
  T_36_WZY_GUNPRO_PARAM2: "الرصاص في الذخيرة",
  T_36_WZY_GUNPRO_PARAM3: "رقم المخزن الأولي",
  T_36_WZY_GUNPRO_PARAM4: "فاصل إطلاق النار",
  T_36_WZY_GUNPRO_PARAM7: "المسافة لأقصى ضرر",
  T_36_WZY_GUNPRO_PARAM8: "المسافة للحد الأدنى من الضرر",
  T_36_WZY_GUNPRO_PARAM9: "الحد الأدنى من الضرر",
  T_36_WZY_MULTIPLIR: "المضاعف",
  T_36_WZY_PRICE: "السعر",
  T_36_WZY_SUMMULTIPLIER: "مجمع المضاعف",
  T_36_WZY_WS_3DZOOM: "تكبير ثلاثي الأبعاد",
  T_36_WZY_WS_ABSRES: "نتيجة القيمة المطلقة",
  T_36_WZY_WS_ADDALLELE_NAMEDESC: "أضف جميع العناصر من [قائمة المصدر] إلى أسفل [قائمة الهدف]",
  T_36_WZY_WS_ADDALLELE_PARAM1_DESC: "القائمة المستهدفة لإضافة العناصر",
  T_36_WZY_WS_ADDALLELE_PARAM2_DESC: "قائمة المصادر التي تحتوي على العناصر المراد إضافتها",
  T_36_WZY_WS_ADDCURR_NAMEDESC: "أضف مقدار معين من العملة المحددة في محفظة معينة",
  T_36_WZY_WS_ADDCURR_PARAM1_NAME: "المحفظة",
  T_36_WZY_WS_ADDCURR_PARAM1_NAMEDESC: "المحفظة المراد إضافة العملة إليها",
  T_36_WZY_WS_ADDSUB: "جمع أو طرح القيم",
  T_36_WZY_WS_AIENTITY: "كيان الذكاء الاصطناعي",
  T_36_WZY_WS_ALLSHOP_DESC: "قائمة تتكون من كيانات المتجر",
  T_36_WZY_WS_ANGLE_DESC: "قياس الزاوية",
  T_36_WZY_WS_ANYTYPE: "أي نوع",
  T_36_WZY_WS_ARILEFT: "القيمة اليسرى في العملية",
  T_36_WZY_WS_ARIRES: "نتيجة العملية",
  T_36_WZY_WS_ARIRIGHT: "القيمة اليمنى في العملية",
  T_36_WZY_WS_ARITHMETIC_NAME: "4 عمليات حسابية",
  T_36_WZY_WS_ARITHMETIC_NAMEDESC: "تدعم عمليات الأعداد الصحيحة الأساسية الجمع والطرح والضرب والقسمة والباقي. تدعم عمليات الطفو الجمع والطرح والضرب والقسمة.",
  T_36_WZY_WS_ARRAY_DESC: "القائمة المستهدفة",
  T_36_WZY_WS_ARRCONELE_NAMEDESC: "تحقق مما إذا كانت القائمة تحتوي على عنصر معين. القيمة التي تم إرجاعها هي قيمة منطقية.",
  T_36_WZY_WS_ARRCONELE_PARAM1_DESC: "القائمة المعينة",
  T_36_WZY_WS_ARRCONELE_PARAM2_DESC: "العنصر الذي يجب البحث عنه في القائمة",
  T_36_WZY_WS_ARRCONELERES: "نتيجة وجود عنصر معين في القائمة. القيمة هي قيمة منطقية.",
  T_36_WZY_WS_ATTACK: "الدورية والهجوم",
  T_36_WZY_WS_BEKNODOWN_NAMEDESC: "يتم تشغيله عند سقوط اللاعب",
  T_36_WZY_WS_BIGFLOAT: "عشري كبير",
  T_36_WZY_WS_BIGTOYBALL: "النرد",
  T_36_WZY_WS_BOOLLIST: "قائمة منطقية",
  T_36_WZY_WS_CEIL_NAME_DESC: "تقريب قيمة إلى أصغر عدد صحيح أكبر من نفسه",
  T_36_WZY_WS_CEIL_PARAM1_NAMEDESC: "القيمة المطلوب تقريبها",
  T_36_WZY_WS_CEILRES: "نتيجة التقريب لأعلى",
  T_36_WZY_WS_CHASEENT_NAMEDESC: "سوف يقوم الذكاء الاصطناعي المختار بمطاردة هذا الكيان بغض النظر عن المسافة. يمكن أن يكون [الكيان المطارد] أي كيان. عندما لا يمتلك [الكيان المطارد] خاصية الصحة، فلن يتسبب كيان الذكاء الاصطناعي في أي ضرر.",
  T_36_WZY_WS_CHASEENT_PARAM1_NAMEDESC: "الكيان الذي يقوم بالمطاردة",
  T_36_WZY_WS_CHASEENT_PARAM2_NAMEDESC: "الكيان المستهدف الذي تتم مطاردته. يمكن أن يكون أي كيان.",
  T_36_WZY_WS_CLONEOBJ_PARAM1_DESC: "قالب استنساخ الكائنات. حدد باستخدام المؤشر. ستكون خاصية الاستنساخ والنصوص الخاصة بهما نفس تلك الخاصة بالكائن المختار.",
  T_36_WZY_WS_CLONEOBJ_PARAM2_DESC: "كيان الكائن المراد استنساخه",
  T_36_WZY_WS_CONDITION: "الشرط",
  T_36_WZY_WS_CONDITIONLIST: "قائمة الشروط",
  T_36_WZY_WS_CONOFHUD: "كيان HUD الذي توجد فيه السيطرة",
  T_36_WZY_WS_CONTROL_DESC: "الفهرس الوحيد لعنصر تحكم",
  T_36_WZY_WS_COS_NAMEDESC: "أوجد جيب تمام الزاوية",
  T_36_WZY_WS_COSRES: "جيب التمام للزاوية",
  T_36_WZY_WS_CREABLEOB: "عنصر قابل للإنشاء",
  T_36_WZY_WS_CREOBJ_NAMEDESC: "إنشاء كيان كائن في موقع معين. (نسخة تجريبية)",
  T_36_WZY_WS_CREOBJ_PARAM1_DESC: "إحداثيات الكائن المراد إنشاؤه",
  T_36_WZY_WS_CREOBJ_PARAM2_DESC: "نوع الكائن المراد إنشاؤه",
  T_36_WZY_WS_CREOBJ_PARAM3_DESC: "كيان العنصر المراد إنشاؤه",
  T_36_WZY_WS_CREPROD_PARAM2_NAME: "العملة",
  T_36_WZY_WS_CREPROD_PARAM4_NAME: "كيان البضاعة",
  T_36_WZY_WS_CREPROD_PARAM4_NAMEDESC: "أنشئ كيان البضاعة",
  T_36_WZY_WS_CREWALL_NAMEDESC: "إنشاء كيان المحفظة. [ربط اللاعب] هو اللاعب الذي يمكنه رؤية هذه المحفظة. [المالك] هو اللاعب الذي تنتمي إليه المحفظة. غير صالح إذا كانت المحفظة موجودة بالفعل.",
  T_36_WZY_WS_CREWALL_PARAM1_NAME: "لاعب منضم",
  T_36_WZY_WS_CREWALL_PARAM1_NAMEDESC: "اللاعب الذي تظهر له المحفظة. إذا لم يتم تكوين إعدادات، فستكون المحفظة مرئية للجميع.",
  T_36_WZY_WS_CREWALL_PARAM2_NAMEDESC: "صاحب المحفظة",
  T_36_WZY_WS_CREWALL_PARAM3_NAME: "كيان المحفظة",
  T_36_WZY_WS_CREWALL_PARAM3_NAMEDESC: "تم إنشاء كيان المحفظة",
  T_36_WZY_WS_CURRAMT: "مقدار العملة",
  T_36_WZY_WS_DATA_TYPE1: "المعلمة المضافة",
  T_36_WZY_WS_DATA_TYPE2: "الحساب الأساسي والمنطقي",
  T_36_WZY_WS_DATA_TYPE3: "قائمة التلاعب",
  T_36_WZY_WS_DATA_TYPE4: "حساب المتجه",
  T_36_WZY_WS_DESTITEM_NAME: "تدمير عنصر اللاعب",
  T_36_WZY_WS_DESTITEM_NAMEDESC: "تدمير نوع معين من العناصر للاعب معين",
  T_36_WZY_WS_DESTITEM_PARAM1_NAMEDESC: "العناصر التي يمكن تدميرها هي الأسلحة والسترات والخوذات",
  T_36_WZY_WS_DESTITEM_PARAM2_NAMEDESC: "مؤشر الفتحة لنوع العنصر المحدد. مؤشر السلاح هو [1,3] والسترة والخوذة هي 1 بشكل افتراضي.",
  T_36_WZY_WS_DESTITEM_WHELOSTEQU: "تفقد المعدات عند التخلص منها",
  T_36_WZY_WS_DESTOBJ: "الأشياء القابلة للتدمير",
  T_36_WZY_WS_DIRPOINT: "نقطة الاتجاه",
  T_36_WZY_WS_DIRPOINTDESC: "نقطة الاتجاه التي سيتم إنشاؤها",
  T_36_WZY_WS_ELEFINDRES: "فهرس الموضع الأول لعنصر ما",
  T_36_WZY_WS_ELEFIRINDEX_NAMEDESC: "احصل على مؤشر المركز الأول لعنصر في القائمة. وإذا لم يكن العنصر المستهدف موجودًا في القائمة، فإن النتيجة ستعود إلى -1.",
  T_36_WZY_WS_ELEFIRINDEX_PARAM2_DESC: "العنصر الذي يجب البحث عنه في القائمة",
  T_36_WZY_WS_ELELASINDEX_NAMEDESC: "احصل على مؤشر المركز الأخير لعنصر في القائمة. وإذا لم يكن العنصر المستهدف موجودًا في القائمة، فإن النتيجة ستعود إلى -1.",
  T_36_WZY_WS_ELELINDRES: "مؤشر الموضع الأخير للعنصر",
  T_36_WZY_WS_ELEMENTSNUM: "رقم العناصر في القائمة",
  T_36_WZY_WS_ENTCOLLIDE_NAMEDESC: "يتم تشغيله عندما يصطدم [كيان الزناد] بهذا الزناد",
  T_36_WZY_WS_ENTCOLLIDE_PARAM1_NAMEDESC: "الكيان الذي يصطدم به هذا الزناد",
  T_36_WZY_WS_ENTDRIVEH_NAMEDESC: "يتم تشغيله عندما يقوم [كيان الزناد] بقيادة المركبة",
  T_36_WZY_WS_ENTDRIVEH_PARAM1_NAMEDESC: "الجهة التي تقود المركبة",
  T_36_WZY_WS_ENTERTRI_NAMEDESC: "يطلق عندما يدخل اللاعب الزناد",
  T_36_WZY_WS_ENTERTRI_PARAM1_DESC: "الزناد للدخول",
  T_36_WZY_WS_ENTGETOFFVEH_NAMEDESC: "يتم تشغيله عندما يخرج [كيان الزناد] المركبة",
  T_36_WZY_WS_ENTGETOFFVEH_PARAM1_NAMEDESC: "الجهة التي تخرج من المركبة",
  T_36_WZY_WS_ENTGETONVEH_NAMEDESC: "يتم تشغيله عندما يدخل [كيان الزناد] المركبة",
  T_36_WZY_WS_ENTGETONVEH_PARAM1_NAMEDESC: "الكيان الذي يدخل المركبة",
  T_36_WZY_WS_ENTITY_TYPE1: "شائع الاستخدام",
  T_36_WZY_WS_ENTITY_TYPE2: "الخصائص",
  T_36_WZY_WS_ENTITY_TYPE3: "الأشياء والعناصر",
  T_36_WZY_WS_ENTITY_TYPE4: "الذكاء الإصطناعي",
  T_36_WZY_WS_ENTITY2_PARAM4_DESC: "قيمة العنصر المطلوب تغييرها",
  T_36_WZY_WS_ENTITY7_PARAM1_DESC: "اللاعب المستهدف",
  T_36_WZY_WS_ENTITYLIST: "قائمة الكيانات",
  T_36_WZY_WS_ENTKNOFLY_NAMEDESC: "يتم تشغيله عندما يرتد [كيان الزناد] عن الإطارات",
  T_36_WZY_WS_ENTKNOFLY_PARAM1_NAMEDESC: "الكيان الذي يرتد عن الإطار",
  T_36_WZY_WS_ENTTP_NAMEDESC: "يتم تشغيله عند دخول [كيان الزناد] إلى البوابة ويتم نقله آنيًا",
  T_36_WZY_WS_ENTTP_PARAM1_NAMEDESC: "الكيان الذي يتم نقله آنيًا",
  T_36_WZY_WS_EQUARMOR_PARAM2_DESC: "نوع الدرع المجهز، بما في ذلك السترة والخوذة ووحقيبة الظهر",
  T_36_WZY_WS_EQUWEAP_NAMEDESC: "يطلق عندما يقوم اللاعب بتجهيز سلاح بنجاح. [لاعب نشط] هو اللاعب الذي ينجح في تجهيز سلاح. [كيان السلاح] هو السلاح الذي جهزه اللاعب.",
  T_36_WZY_WS_EQUWEAP_PARAM2_DESC: "تم تجهيز كيان السلاح",
  T_36_WZY_WS_EQUWEAP_PARAM2_NAME: "نوع السلاح",
  T_36_WZY_WS_EULERANGLE: "زوايا أويلر",
  T_36_WZY_WS_FACECAMERA: "متوجه للكاميرا دائما",
  T_36_WZY_WS_FLOATLIST: "قائمة عائمة",
  T_36_WZY_WS_FLOOR_NAME_DESC: "تقريب قيمة إلى أكبر عدد صحيح أصغر من نفسه",
  T_36_WZY_WS_FLOOR_PARAM1_NAMEDESC: "القيمة المطلوب تقريبها",
  T_36_WZY_WS_FLOORRES: "نتيجة التقريب لأسفل",
  T_36_WZY_WS_FORMUENT: "كيان قادر على صياغة الملكية",
  T_36_WZY_WS_FORMUFACT: "نوع عامل صيغة الخاصية",
  T_36_WZY_WS_GAME_TYPE2: "اللعب",
  T_36_WZY_WS_GAME_TYPE3: "التأثيرات الخاصة",
  T_36_WZY_WS_GENENT_NAMEDESC: "تنطلق عندما يولد المولد الوحدات. [قائمة كيانات الوحدة] هي قائمة الوحدات التي يولدها المولد. [رقم الأمواج] هو عدد الموجات التي ولّدها الجيل.",
  T_36_WZY_WS_GENENT_PARAM1_NAME: "كيان الوحدة",
  T_36_WZY_WS_GENENT_PARAM1_NAMEDESC: "قائمة تتكون من وحدات الوحدات التي تم إنتاجها بواسطة منشئ",
  T_36_WZY_WS_GENENT_PARAM2_NAMEDESC: "عدد الموجات التي يولدها المولد",
  T_36_WZY_WS_GETALLSHOP_NAMEDESC: "الحصول على جميع المخازن في المباراة. القيمة التي تم إرجاعها هي قائمة تتكون من كيانات المتجر.",
  T_36_WZY_WS_GETCOLOR_NAMEDESC: "استخدم RGB للحصول على لون",
  T_36_WZY_WS_GETCURRAMT_NAMEDESC: "احصل على مقدار عملة معينة في محفظة معينة",
  T_36_WZY_WS_GETCURRAMT_PARAM1_NAMEDESC: "المحفظة المراد الحصول منها على مقدار العملة",
  T_36_WZY_WS_GETCURRAMT_PARAM2_NAMEDESC: "نوع العملة لمقدار العملة المراد الحصول عليه",
  T_36_WZY_WS_GETENTTYPE_NAMEDESC: "احصل على نوع الكيان للكيان المستهدف",
  T_36_WZY_WS_GETENTTYPE_PARAM1_DESC: "الكيان المطلوب الحصول على نوعه",
  T_36_WZY_WS_GETENTTYPERES: "نوع الكيان للكيان المستهدف",
  T_36_WZY_WS_GETFOR_NAME: "احصل على إحداثيات الاتجاه",
  T_36_WZY_WS_GETFOR_NAMEDESC: "احصل على متجه نقطة اتجاه معينة",
  T_36_WZY_WS_GETFORRES: "متجه نقطة الإتجاه",
  T_36_WZY_WS_GETMONEYENT_NAMEDESC: "احصل على كيان العملة من نوع عملة معين في المحفظة",
  T_36_WZY_WS_GETMONEYENT_PARAM1_DESC: "المحفظة التي يكون فيها كيان العملة",
  T_36_WZY_WS_GETPOS_NAME: "الحصول على الإحداثيات",
  T_36_WZY_WS_GETPOS_NAMEDESC: "احصل على إحداثيات نقطة اتجاه معينة",
  T_36_WZY_WS_GETPOS_PARAM1_DESC: "نقطة الاتجاه المعينة",
  T_36_WZY_WS_GETPROP_PARAM2_NAME: "نوع المعدات",
  T_36_WZY_WS_GETWALLET_NAME: "احصل على المحفظة",
  T_36_WZY_WS_GETWALLET_NAMEDESC: "احصل على المحفظة الخاصة بالمالك المختار",
  T_36_WZY_WS_GETWALLET_PARAM2_NAMEDESC: "ما إذا كانت محفظة الربط موجودة",
  T_36_WZY_WS_GETWALLETRES: "كيان محفظة المالك",
  T_36_WZY_WS_HUDCONTROL_DESC: "كيان التحكم في HUD",
  T_36_WZY_WS_HUDTYPE: "نوع HUD",
  T_36_WZY_WS_INCIDENT_TYPE1: "حادث عالمي",
  T_36_WZY_WS_INCIDENT_TYPE2: "حادثة الكيان",
  T_36_WZY_WS_INDEX_DESC: "قيمة فهرس قائمة. يبدأ من 0.",
  T_36_WZY_WS_INTLIST: "قائمة عدد صحيح",
  T_36_WZY_WS_JENTSUBCL_NAMEDESC: "تحقق مما إذا كان نوع الكيان ينتمي إلى فئة فرعية معينة. النتيجة التي تم إرجاعها هي قيمة منطقية.",
  T_36_WZY_WS_JENTSUBCL_PARAM2_NAMESESC: "الفئة الأصل للتحقق مما إذا كان الكيان ينتمي إليها",
  T_36_WZY_WS_JENTSUBCLRES: "نتيجة التحقق من الفئة الأصل",
  T_36_WZY_WS_JENTTYPE_NAMEDESC: "تحقق مما إذا كان الكيان ينتمي إلى نوع كيان معين. النتيجة التي تم إرجاعها هي قيمة منطقية.",
  T_36_WZY_WS_JENTTYPE_PARAM1_NAMEDESC: "الكيان للتحقق",
  T_36_WZY_WS_JENTTYPE_PARAM2_NAMEDESC: "يعني أنه نفس نوع الكيان",
  T_36_WZY_WS_JENTTYPERES: "نتيجة فحص الكيان",
  T_36_WZY_WS_JUSTPATROL: "دورية فقط",
  T_36_WZY_WS_LEAVETRI_NAMEDESC: "يطلق عندما يخرج اللاعب من الزناد",
  T_36_WZY_WS_LEAVETRI_PARAM1_DESC: "الزناد للخروج",
  T_36_WZY_WS_LEVELOBLIST: "قائمة العنصر",
  T_36_WZY_WS_LEVOBJSLIST: "قائمة بكافة كائنات الخريطة في هذه المباراة",
  T_36_WZY_WS_LEVOBTYPE: "نوع الكائن",
  T_36_WZY_WS_LISTT: "أي قائمة",
  T_36_WZY_WS_LOGCONTEXT_DESC: "المحتوى المراد طباعته",
  T_36_WZY_WS_LOGIC2_PARAM1_NAMEDESC: "السلسلة المتبقية المراد توصيلها",
  T_36_WZY_WS_LOGIC2_PARAM3_NAMEDESC: "السلسلة الصحيحة المراد توصيلها",
  T_36_WZY_WS_LOGIC5_PARAM1_NAMEDESC: "قيمة العنصر المراد إضافتها",
  T_36_WZY_WS_LOGOPER: "عند إجراء العمليات المنطقية (و أو): إذا كان استخدام العملية والقيمتين المنطقيتين هما صحيح، تكون النتيجة صحيحة، وإذا كان استخدام العملية أو والقيمتين المنطقتين ليستا خطأ، فإن النتيجة هي صحيحة.",
  T_36_WZY_WS_LOOTPOINT: "نقطة الغنائم",
  T_36_WZY_WS_MAINWEAP: "السلاح الحالي",
  T_36_WZY_WS_MAX_DESC: "النطاق العلوي للعدد الصحيح الذي تم إنشاؤه (فاصل مفتوح)",
  T_36_WZY_WS_MIN_DESC: "النطاق الأدنى للعدد الصحيح الذي تم إنشاؤه (فاصل مغلق)",
  T_36_WZY_WS_MODGUNPRO_PARAM1_NAME: "كيان السلاح",
  T_36_WZY_WS_MONENT: "كيان العملة",
  T_36_WZY_WS_MONTYPE: "نوع العملة",
  T_36_WZY_WS_MOVETO_NAMEDESC: "اجعل الذكاء الاصطناعي يتحرك نحو نقطة الهدف. استخدم [العودة أم لا] لتحديد ما إذا كان الذكاء الاصطناعي سيعود إلى موضعه الأصلي. استخدم [هجوم أم لا] لتحديد ما إذا كان الذكاء الاصطناعي سوف يبحث عن الأعداء في طريقه.",
  T_36_WZY_WS_MOVETO_PARAM1_NAMEDESC: "كيان الذكاء الاصطناعي الذي سيسافر",
  T_36_WZY_WS_MOVETO_PARAM2_NAMEDESC: "الوجهة",
  T_36_WZY_WS_MOVETO_PARAM3_NAMEDESC: "تُستخدم لتعيين ما إذا كان الذكاء الإصطناعي سيعود إلى الموقع الأصلي بعد وصوله إلى الوجهة. صحيح تعني العودة ؛ خطأ تعني عدم العودة.",
  T_36_WZY_WS_MOVETO_PARAM4_NAME: "هجوم أم لا",
  T_36_WZY_WS_MOVETO_PARAM4_NAMEDESC: "تُستخدم لتحديد ما إذا كان الذكاء الاصطناعي سيهاجم الأعداء القريبين على طول الطريق. صحيح تعني البحث عن الأعداء ؛ خطأ تعني عدم البحث عن الأعداء.",
  T_36_WZY_WS_MULVALUE: "العددية",
  T_36_WZY_WS_MULVEC: "متجه الضرب العددي",
  T_36_WZY_WS_NEGRES: "نتيجة القيمة السلبية",
  T_36_WZY_WS_NEUTRAL: "محايد",
  T_36_WZY_WS_NEXTVAWE_NAMEDESC: "يفرض على المولد المعين إنتاج الموجة التالية. تشتمل المولدات على منطقة إحياء الزومبي وبويضات العناصر.",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAME: "مولد الكيان",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAMEDESC: "كيان المولد المعين، مثل منطقة إحياء الزومبي ويولد العنصر",
  T_36_WZY_WS_OBJENT: "عنصر الكيان",
  T_36_WZY_WS_OBTITEM_NAMEDESC: "يتم تشغيله عند الحصول على عنصر. [نوع العنصر] هو نوع العنصر الذي تم الحصول عليه.",
  T_36_WZY_WS_OBTWEAP_NAMEDESC: "يتم تشغيله عند الحصول على السلاح. [كيان السلاح] هو السلاح الذي تم الحصول عليه.",
  T_36_WZY_WS_ONEWAY: "طرف واحد",
  T_36_WZY_WS_OPENSTATE: "الحالة",
  T_36_WZY_WS_OPERMETHOD_NAME: "العملية",
  T_36_WZY_WS_OPERMETHOD_NAMEDESC: "العمليات الحسابية الأساسية. حاليًا، تتضمن عمليات الأعداد الصحيحة الجمع والطرح والضرب والقسمة والباقي، وتشمل عمليات الطفو الجمع والطرح والضرب والقسمة.",
  T_36_WZY_WS_OWNERENT_DESC: "الكيان الذي يجب الحصول على محفظته",
  T_36_WZY_WS_PERCENTAGE: "تعديل النسبة المئوية",
  T_36_WZY_WS_PLACOLLIDE_NAME: "عندما يصطدم اللاعب بالزناد",
  T_36_WZY_WS_PLACOLLIDE_NAMEDESC: "يتم تشغيله عندما يصطدم [لاعب الزناد] بالزناد",
  T_36_WZY_WS_PLACOLLIDE_PARAM1_NAMEDESC: "اللاعب الذي يصطدم بالزناد",
  T_36_WZY_WS_PLACOLLIDE_PARAM2_NAMEDESC: "عنصر الكائن الذي يصطدم به اللاعب",
  T_36_WZY_WS_PLADRIVEH_NAME: "عندما يقود اللاعب المركبة",
  T_36_WZY_WS_PLADRIVEH_NAMEDESC: "يتم تشغيله عندما يقود [لاعب الزناد] مركبة",
  T_36_WZY_WS_PLADRIVEH_PARAM1_NAMEDESC: "اللاعب الذي يقود المركبة",
  T_36_WZY_WS_PLADRIVEH_PARAM2_NAMEDESC: "كيان المركبة التي يقودها اللاعب",
  T_36_WZY_WS_PLAGETOFFVEH_NAME: "عندما يخرج اللاعب من المركبة",
  T_36_WZY_WS_PLAGETOFFVEH_NAMEDESC: "يتم تشغيله عندما يخرج [لاعب الزناد] المركبة",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM1_NAMEDESC: "اللاعب الذي يخرج من المركبة",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM2_NAMEDESC: "كيان المركبة الذي يخرج منه اللاعب",
  T_36_WZY_WS_PLAGETONVEH_NAME: "عندما يدخل اللاعب المركبة",
  T_36_WZY_WS_PLAGETONVEH_NAMEDESC: "يتم تشغيله عندما يدخل [لاعب الزناد] المركبة",
  T_36_WZY_WS_PLAGETONVEH_PARAM2_NAMEDESC: "كيان المركبة الذي يدخله اللاعب",
  T_36_WZY_WS_PLAKNOFLY_NAME: "عندما يقفز اللاعب على الإطارات",
  T_36_WZY_WS_PLAKNOFLY_NAMEDESC: "يتم تشغيله عندما يرتد [لاعب الزناد] عن الإطارات",
  T_36_WZY_WS_PLAKNOFLY_PARAM1_NAMEDESC: "اللاعب الذي يرتد عن إطار",
  T_36_WZY_WS_PLAKNOFLY_PARAM2_NAMEDESC: "عنصر الكائن الذي يرتد عليه اللاعب",
  T_36_WZY_WS_PLATP_NAME: "بعد انتقال اللاعب عن بعد",
  T_36_WZY_WS_PLATP_PARAM1_NAMEDESC: "اللاعب الذي يستخدم البوابة",
  T_36_WZY_WS_PLATP_PARAM2_NAMEDESC: "كيان البوابة الذي استخدمه اللاعب",
  T_36_WZY_WS_PLAYERLIST_DESC: "قائمة بجميع اللاعبين في هذه المباراة",
  T_36_WZY_WS_POINTPICKER: "محور المسار",
  T_36_WZY_WS_PORTALENT: "كيان البوابة",
  T_36_WZY_WS_PREFAB: "النموذج",
  T_36_WZY_WS_PRODLIST: "قائمة البضائع",
  T_36_WZY_WS_PRODSORT_PARAM3_NAME: "امر ترتيب",
  T_36_WZY_WS_PROPMOD: "طريقة تغيير الملكية",
  T_36_WZY_WS_RANKABLEE: "كيان قادر على التصنيف",
  T_36_WZY_WS_REDCURR_NAMEDESC: "استهلك مقدار معين من العملة المحددة في محفظة معينة",
  T_36_WZY_WS_REDCURR_PARAM1_NAMEDESC: "المحفظة التي تنفق العملة",
  T_36_WZY_WS_REDCURR_PARAM2_NAMEDESC: "نوع العملة المستهلكة",
  T_36_WZY_WS_REDCURR_PARAM3_NAMEDESC: "مقدار العملة المستهلكة",
  T_36_WZY_WS_RNDFRES: "مولد التعويم العشوائي",
  T_36_WZY_WS_RNDIRES: "نتيجة توليد عدد صحيح عشوائي",
  T_36_WZY_WS_ROUND_NAME_DESC: "تقريب قيمة إلى أقرب عدد صحيح",
  T_36_WZY_WS_ROUND_PARAM1_NAMEDESC: "القيمة المطلوب تقريبها",
  T_36_WZY_WS_ROUNDRES: "نتيجة التقريب",
  T_36_WZY_WS_RUNAI_NAMEDESC: "شجرة السلوك التي سينفذها الذكاء الاصطناعي المحدد",
  T_36_WZY_WS_RUNAI_PARAM1_NAMEDESC: "كيان الوحدة الذي يقوم بإيقاف / تشغيل شجرة سلوك افتراضية",
  T_36_WZY_WS_SCOREABLEE: "كيان قادر للحصول على نقاط",
  T_36_WZY_WS_SCORECHANGE_NAMEDESC: "يتم تشغيله عندما تتغير النتيجة. [نوع النتيجة] هو نوع النتيجة التي تغيرت. [النتيجة] هي النتيجة الجديدة.",
  T_36_WZY_WS_SETDIRPOINT_NAME: "أنشئ نقطة اتجاه",
  T_36_WZY_WS_SETDIRPOINT_NAMESESC: "احصل على نقطة اتجاه تم إنشاؤها حديثًا. استخدم [الموقع] لتعيين إحداثيات النقطة و [الاتجاه] لتعيين متجه الاتجاه.",
  T_36_WZY_WS_SETDIRPOINT_PARAM1_NAMEDESC: "إحداثيات نقطة الاتجاه",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME: "الاتجاه",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAMEDESC: "متجه نقطة الاتجاه",
  T_36_WZY_WS_SETPATH_NAMEDESC: "ستسافر كيانات الذكاء الاصطناعي وفقًا للترتيب المحدد هنا. أنواع السفر المتاحة هي دائرة للخلف وذات اتجاه واحد ورحلة ذهابًا وإيابًا. يمكنك أيضًا تحديد ما إذا كان الذكاء الاصطناعي سوف يبحث عن الأعداء في طريقه.",
  T_36_WZY_WS_SETPATH_PARAM2_NAMEDESC: "قائمة تتكون من النقاط التي يجب أن ينتقل إليها الذكاء الاصطناعي",
  T_36_WZY_WS_SETPATH_PARAM3_NAME: "نوع السفر",
  T_36_WZY_WS_SETPATH_PARAM3_NAMEDESC: "هذه هي أنواع الرحلات. في اتجاه واحد، يتوقف الذكاء الاصطناعي عن السفر بمجرد وصوله إلى الوجهة. الدائرة الخلفية مخصصة للذكاء الاصطناعي للبحث عن طريق العودة بمجرد وصوله إلى الوجهة. ذهابًا وإيابًا بالنسبة لمنظمة العفو الدولية هو العودة إلى الموقع الأصلي وفقًا للترتيب العكسي لقائمة المسار.",
  T_36_WZY_WS_SHOPECON: "المتجر والاقتصاد",
  T_36_WZY_WS_SHOWFLO_NAMEDESC: "استخدم لعرض الإشعارات التي تطفو على الشاشة. قم بتكوين المحتوى باستخدام [النص]، ولون النص باستخدام [اللون]، ​​ومدة العرض باستخدام [المدة] (الوحدة مللي ثانية).",
  T_36_WZY_WS_SHOWFLO_PARAM1_DESC: "محتوى الإشعارات العائم",
  T_36_WZY_WS_SHOWFLO_PARAM2_DESC: "لون الإشعار العائم",
  T_36_WZY_WS_SHOWFLO_PARAM3_DESC: "مدة عرض الإشعار العائم، بمللي ثانية",
  T_36_WZY_WS_SIN_NAMEDESC: "ابحث عن جيب الزاوية",
  T_36_WZY_WS_SINRES: "جيب الزاوية",
  T_36_WZY_WS_SKIPKNODOWN: "سواء تم التخلص منها عند الضربة القاضية",
  T_36_WZY_WS_SQRTRES: "نتيجة الجذر التربيعي",
  T_36_WZY_WS_STRCONRES: "نتيجة اتصال السلسلة",
  T_36_WZY_WS_STRINGLIST: "قائمة المفاتيح",
  T_36_WZY_WS_STRLEN: "طول السلسلة",
  T_36_WZY_WS_STRVAL: "نتيجة السلسلة",
  T_36_WZY_WS_TAN_NAMEDESC: "أوجد ظل الزاوية",
  T_36_WZY_WS_TANRES: "ظل الزاوية",
  T_36_WZY_WS_TEAMLIST: "قائمة الفريق",
  T_36_WZY_WS_TEAMLIST_DESC: "قائمة بجميع الفرق في هذه المباراة",
  T_36_WZY_WS_TIMETWEENTIPS: "كيان إعلام العد التنازلي",
  T_36_WZY_WS_TOSTRING_NAMEDESC: "تحويل القيمة المستهدفة إلى سلسلة",
  T_36_WZY_WS_TOSTRING_PARAM1_DESC: "القيمة المستهدفة للتحويل إلى سلسلة",
  T_36_WZY_WS_TOSTRINGRES: "نتيجة تحويل السلسلة",
  T_36_WZY_WS_TOWERCAMP_DESC: "رقم الجانب ورقم الفريق متماثلان. تهاجم الأبراج والحصون المحايدة جميع اللاعبين وأنظمة الذكاء الاصطناعي داخل النطاق.",
  T_36_WZY_WS_TRACURR_NAMEDESC: "تحويل مقدار معين من العملة المحددة من محفظة إلى أخرى",
  T_36_WZY_WS_TRACURR_PARAM1_NAMEDESC: "المحفظة لتحويل العملة من",
  T_36_WZY_WS_TRACURR_PARAM2_NAMEDESC: "نوع العملة في المعاملة",
  T_36_WZY_WS_TRACURR_PARAM3_NAMEDESC: "مقدار العملة في المعاملة",
  T_36_WZY_WS_TRACURR_PARAM4_NAMEDESC: "المحفظة المراد تحويل العملة إليها",
  T_36_WZY_WS_TWEENTIPS: "كيان الإشعارات العائم",
  T_36_WZY_WS_TYPEENUM: "نوع التعداد",
  T_36_WZY_WS_USEPROP_NAMEDESC: "يتم تشغيله عندما يستخدم اللاعب عنصرًا. [لاعب الزناد] هو اللاعب الذي يستخدم عنصرًا. [نوع العنصر] هو العنصر الذي استخدمه اللاعب.",
  T_36_WZY_WS_USEPROP_PARAM2_DESC: "نوع العنصر الذي يستخدمه اللاعب",
  T_36_WZY_WS_VECADDLEFT: "القيمة اليسرى لإضافة المتجه",
  T_36_WZY_WS_VECADDRES: "نتيجة إضافة المتجه",
  T_36_WZY_WS_VECADDRIGHT: "القيمة اليمنى لإضافة المتجه",
  T_36_WZY_WS_VECANGLEFT: "القيمة اليسرى لزاوية المتجهات",
  T_36_WZY_WS_VECANGRES: "الزاوية بين متجهين",
  T_36_WZY_WS_VECANGRIGHT: "القيمة اليمنى للزاوية المتجهات",
  T_36_WZY_WS_VECCROLEFT: "القيمة اليسرى للناتج المتقاطع",
  T_36_WZY_WS_VECCRORES: "نتيجة حاصل الضرب التبادلي",
  T_36_WZY_WS_VECCRORIGHT: "القيمة اليمنى للناتج المتقاطع",
  T_36_WZY_WS_VECDISLEFT: "القيمة اليسرى لمسافة المتجهات",
  T_36_WZY_WS_VECDISRES: "المسافة بين متجهين",
  T_36_WZY_WS_VECDISRIGHT: "القيمة اليمنى لمسافة المتجهات",
  T_36_WZY_WS_VECDOCLEFT: "القيمة اليسرى للضرب القياسي",
  T_36_WZY_WS_VECDOCRES: "نتيجة الضرب القياسي",
  T_36_WZY_WS_VECDOCRIGHT: "القيمة اليمنى للضرب القياسي",
  T_36_WZY_WS_VECMULRES: "نتيجة الضرب العددي",
  T_36_WZY_WS_VECNORRES: "ناقل طبيعي",
  T_36_WZY_WS_VECSIZERES: "حجم المتجه",
  T_36_WZY_WS_VECSUBLEFT: "القيمة اليسرى للطرح المتجه",
  T_36_WZY_WS_VECSUBRES: "نتيجة الطرح المتجه",
  T_36_WZY_WS_VECSUBRIGHT: "القيمة اليمنى للطرح المتجه",
  T_36_WZY_WS_VECTORLIST: "قائمة المتجهات",
  T_36_WZY_WS_VECX: "مكون س",
  T_36_WZY_WS_VECY: "مكون ص",
  T_36_WZY_WS_VECZ: "مكون ض",
  T_36_WZY_WS_VEHENT: "كيان المركبة",
  T_36_WZY_WS_WALLCONT: "محتوى المحفظة",
  T_36_WZY_WS_ZOMBIESPERWAVE: "مستمر",
  T_36_XYL_WS_AIBOT: "وحدة",
  T_36_XYL_WS_AIGENERATOR: "مولّد الوحدة",
  T_36_XYL_WS_AIGENERATOR_DESC: "مولد يمكنه إنشاء وحدات معينة باستمرار (مثل الزومبي)",
  T_36_XYL_WS_AIWAVE: "عدد الوحدات لكل موجة",
  T_36_XYL_WS_ARROW: "علامة الاتجاه",
  T_36_XYL_WS_ARROW_DESC: "علامة تشير إلى اتجاه",
  T_36_XYL_WS_BREAKBOX: "صندوق قابل للكسر",
  T_36_XYL_WS_BREAKBOX_DESC: "صندوق خشبي يمكن كسره عند مهاجمته",
  T_36_XYL_WS_FENCE: "سياج معدني",
  T_36_XYL_WS_FENCE_DESC: "سياج يسمح للرصاص بالمرور من خلاله",
  T_36_XYL_WS_STAIRI: "الهبوط ج",
  T_36_XYL_WS_STAIRI_DESC: "منصة يمكن دمجها مع السلالم",
  T_36_XYL_WS_ZOMBIEAI: "زومبي",
  T_36_XYL_WS_ZOMBIEAI_DESC: "زومبي يمكن تخصيصه و عنصرًا يمكن الحصول عليه ومضاعفًا في مولِّد الوحدات",
  T_36_YF_CORRODE_GRENADE_N: "مذيب الجلو",
  T_36_YF_SETTING_TYPE3: "الإعداد المسبق 3",
  T_36_YS_B_BRFOOTBALL_BLUE01: "قميص CBF المحيط (سفلي)",
  T_36_YS_B_BRFOOTBALL_YELLOW01: "قميص صن شاين CBF (سفلي)",
  T_36_YS_F_A_GHOSTHUNTER: "عميلة القطط (قناع)",
  T_36_YS_F_B_GHOSTHUNTER: "عميلة القطط (سفلي)",
  T_36_YS_F_H_GHOSTHUNTER: "عميلة القطط (رأس)",
  T_36_YS_F_S_GHOSTHUNTER: "عميلة القطط (حذاء)",
  T_36_YS_SETTING_GRENADE: "عناصر قابلة للرمي",
  T_36_YS_SETTING_MOVE: "حركة",
  T_36_YS_T_BRFOOTBALL_BLUE01: "قميص CBF المحيط (علوي)",
  T_36_YS_T_BRFOOTBALL_YELLOW01: "قميص صن شاين CBF (علوي)",
  T_36_YZY_CHARACTER_GANGGIRL_N: "لونا",
  T_36_YZY_CHARACTER_YAKUZA_N: "تاتسويا",
  T_36_YZY_PET_WOLF_N: "فانغ",
  T_36_YZY_PETSKIN_AXOLOTL_GRIZA_N: "سكن الحيوان الأليف: زاسيل الأرجواني",
  T_36_YZY_PETSKIN_HAWK_BDK_N: "سكن الحيوان الأليف: بريق فالكو",
  T_36_YZY_PETSKIN_WOLF_FIRE_N: "سكن الحيوان الأليف: فانغ اللهب",
  T_36_YZY_PETSKIN_WOLF_SUGARSKULL22_N: "سكن الحيوان الأليف: المرشد الوفي",
  T_36_YZY_PETSKIN_WOLF_WINTER_N: "سكن الحيوان الأليف: فانغ القطبي",
  T_37_B_WS_HIDE: "الغميضة",
  T_37_HZ_WS_CATMODEDESC1: "الغميضة",
  T_37_JH_WS_CREATEGOLD_DESC: "آلة بيع يمكن للاعبين شراء العناصر منها. (غير صالح في أوضاع كلاش سكواد وماتش قاتل وساحة اللعب وصعود الروبوتات)",
  T_37_JH_WS_NAME1: "سكين FF (صعود الروبوتات)",
  T_37_JH_WS_NAME10: "M1887-X (صعود الروبوتات)",
  T_37_JH_WS_NAME11: "SPAS12 (صعود الروبوتات)",
  T_37_JH_WS_NAME12: "M1014 (صعود الروبوتات)",
  T_37_JH_WS_NAME13: "MP40 (صعود الروبوتات)",
  T_37_JH_WS_NAME14: "MP5-III (صعود الروبوتات)",
  T_37_JH_WS_NAME15: "P90 (صعود الروبوتات)",
  T_37_JH_WS_NAME16: "M60-III (صعود الروبوتات)",
  T_37_JH_WS_NAME17: "طومسون (صعود الروبوتات)",
  T_37_JH_WS_NAME18: "UMP (صعود الروبوتات)",
  T_37_JH_WS_NAME19: "SVD (صعود الروبوتات)",
  T_37_JH_WS_NAME2: "جروزا (صعود الروبوتات)",
  T_37_JH_WS_NAME20: "AWM - (صعود الروبوتات)",
  T_37_JH_WS_NAME21: "M82B (صعود الروبوتات)",
  T_37_JH_WS_NAME22: "M249-X (صعود الروبوتات)",
  T_37_JH_WS_NAME23: "Kar98k-III (صعود الروبوتات)",
  T_37_JH_WS_NAME3: "AK47 (صعود الروبوتات)",
  T_37_JH_WS_NAME4: "M4A1-III (صعود الروبوتات)",
  T_37_JH_WS_NAME5: "SCAR (صعود الروبوتات)",
  T_37_JH_WS_NAME6: "M14-III (صعود الروبوتات)",
  T_37_JH_WS_NAME7: "بارافال (صعود الروبوتات)",
  T_37_JH_WS_NAME8: "XM8 (صعود الروبوتات)",
  T_37_JH_WS_NAME9: "MAG-7 (صعود الروبوتات)",
  T_37_JH_WS_VENDMACHINE_DESC: "الذهب الذي يمكن التقاطه حول الخريطة. (غير صالح في أوضاع كلاش سكواد وماتش قاتل وساحة اللعب وصعود الروبوتات)",
  T_37_JH_WS_X: "المحور س",
  T_37_JH_WS_Y: "المحور ص",
  T_37_JH_WS_Z: "المحور ض",
  T_37_JL_FOOTBALL_TIE: "اربط",
  T_37_JL_GOLD_M1014_I_N: "M1014-I",
  T_37_JL_GOLD_M1014_II_N: "M1014-II",
  T_37_JL_GOLD_M1014_III_N: "M1014-III",
  T_37_JL_M1216_N: "تروجون",
  T_37_KK_WS_SNOWMAN: "واجر رجل الثلج",
  T_37_LC_BP_ENTRANCE_GIFT: "هدية!",
  T_37_M_WS_MISSING: "المصدر مفقود",
  T_37_M_WS_NAMEERROR: "يحتوي على أحرف حساسة. يرجى تغيير الاسم.",
  T_37_PD_HuntingGround_BOSSTITLE: "الجزار",
  T_37_QL_JUMPPAD_DES: "ينشئ لوحة قفز على الأرض. يمكن استخدامه للقفز عاليا في الهواء ويتيح إطلاق النار.",
  T_37_QL_JUMPPAD_NAME: "ترامبولين",
  T_37_R_TAILOR_LIMIT: "وقت محدود",
  T_37_RW_LOADOUT_BORNFIRETAG: "احصل على 2 شعلة في بداية المباراة. الشعلة [FFBA00]تعيد توليد 5 نقاط صحة و 20 EP في الثانية[-] (حتى 10 ثوانٍ) لك ولزملائك في الفريق داخل المنطقة. لا تتراكم تأثيرات النار.",
  T_37_RW_PROPCATAPULT_DESC: "عند النفخ، يمكن استخدام لوحة القفز لإسقاط لاعب في الهواء. لكن تأكد من البقاء في المنطقة الآمنة!",
  T_37_RW_PROPCATAPULT_NAME: "لوحة القفز",
  T_37_SP_WS_COLOR_02: "اللون",
  T_37_SP_WS_COLOR_03: "مظهر",
  T_37_SP_WS_LOG_ENTITY_IS_EMPTY: "يكون الكيان لاغيا عند الحصول على خاصيته أو تعيينها",
  T_37_SP_WS_LOG_PHASE_END: "انتهت المرحلة {0}.",
  T_37_SP_WS_LOG_PHASE_START: "تبدأ المرحلة {0}",
  T_37_SP_WS_LOG_ROUND_END: "انتهت الجولة {0}.",
  T_37_SP_WS_LOG_ROUND_START: "بدأت الجولة {0}.",
  T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH: "نوع غير متطابق عند تعيين قيمة للمتغير. النوع المطلوب: {0}. النوع الحالي: {1}.",
  T_37_SP_WS_LOG_VAR_UNDEFINED_OR_OUT_OF_SCOPE: "متغير محلي غير محدد أو خارج النطاق {0}",
  T_37_SP_WS_MAPACCESS_08: "تعديل",
  T_37_SP_WS_RACEMODE_01: "وضع العد التنازلي",
  T_37_SP_WS_RACEMODE_02: "وقت العد التنازلي",
  T_37_SP_WS_RACEMODE_04: "عند بدئت اللعبة، سيكون هناك عد تنازلي عندما يصل فريق بأكمله إلى نقطة النهاية. تنتهي اللعبة بانتهاء العد التنازلي.",
  T_37_SY_AR15_KABUKI_N: "الرفراف - المغنية هانا",
  T_37_SY_BACKPACK_STRAW_N: "حقيبة - قبعة القش",
  T_37_SY_GRENADE_FFWS2022_01_N: "قنبلة - نجم البحر",
  T_37_SY_GROUPANIM_BLACKHOLE_N: "الثقب الأسود",
  T_37_SY_M1216_MAMBAS_N: "تروجون -  لسعة المامبا",
  T_37_SY_PET_FLYINGCREATURE_N: "أرفون",
  T_37_SY_PETSKIN_DUCK_WINTERFEST22_N: "سكن الحيوان الأليف: بيني نجم الشتاء",
  T_37_SY_PETSKIN_FLYINGCREATURE_BLUE_N: "سكن الحيوان الأليف: رماد أرفون",
  T_37_SY_PETSKIN_FLYINGCREATURE_ORANGE_N: "سكن الحيوان الأليف: مجرة أرفون",
  T_37_SY_PETSKIN_FLYINGCREATURE_PURPLE_N: "سكن الحيوان الأليف: أرفون الناري",
  T_37_SY_PETSKIN_TORTOISE_SOCCER22_N: "سكن الحيوان الأليف: اللاعب فلاش",
  T_37_SY_PETSKIN_YETI_NEWYEAR22_N: "سكن الحيوان الأليف: ياتي أرض الشتاء",
  T_37_SY_VEHICLE_JEEP_WINTERFEST22_N: "سيارة جيب - احتفال الروك",
  T_37_SY_VEHICLE_SUV_FFWS2022_N: "شاحنة - وحش نجم البحار",
  T_37_WT_WS_PVE2DESC: `وضع البقاء على قيد الحياة من الزومبي حيث يقوم اللاعبون بالقضاء على عدد معين من الزومبي في غضون فترة زمنية محددة أو البقاء على قيد الحياة حتى النهاية.
يمكنك تعيين قواعد اللعب وتعديل إعدادات الزومبي كما تريد، بما في ذلك عدد الزومبي المستهدف الذي يجب القضاء عليه.`,
  T_37_WT_WS_RULEDESC: "تخلص من العدد المستهدف من الزومبي للفوز.",
  T_37_WT_WS_RULETITLE: "الهدف",
  T_37_WT_WS_TXT1: "تخلص من الزومبي",
  T_37_WT_WS_TXT1DESC: "عند التشغيل، يفوز اللاعبون من خلال القضاء على العدد المحدد من الزومبي. عند إيقاف التشغيل، يفوز اللاعبون بالنجاة حتى النهاية.",
  T_37_WT_WS_TXT2: "عدد الإقصاء",
  T_37_WZY_FRIDPLA: "لاعب ودود",
  T_37_WZY_FRIDSIDE: "فصيل ودود",
  T_37_WZY_FRIDTEAM: "فريق ودود",
  T_37_WZY_HOSTPLA: "لاعب العدو",
  T_37_WZY_HOSTSIDE: "فصيل العدو",
  T_37_WZY_WS_ACCFRAMES: "الإطارات المتراكمة",
  T_37_WZY_WS_ADDITEMTOPROD_NAMEDESC: "أضف عناصر إلى بضاعة. يمكنك إضافة عنصر واحد أو مجموعة من العناصر. يمكن أن يكون المبلغ إما عدد العناصر الفردية أو قائمة تتكون من عناصر من هذا المبلغ.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM1_DESC: "كيان البضائع المراد إضافة عناصر إليه",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM2_DESC: "العناصر المراد إضافتها. يمكنك إضافة عنصر واحد أو مجموعة من العناصر.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM3_DESC: "مقدار العناصر الفردية المراد إضافتها أو قائمة تتكون من عناصر هذه القيمة.",
  T_37_WZY_WS_ADDLABEL_NAMEDESC: "أضف علامة للكيان المحدد",
  T_37_WZY_WS_ADDLABEL_PARAM1_DESC: "الكيان المراد إضافة العلامة إليه",
  T_37_WZY_WS_ADDLABEL_PARAM2_DESC: "محتوى النص المراد إضافته",
  T_37_WZY_WS_AIMABLEENT: "كيان قادر على التصويب",
  T_37_WZY_WS_AIMASSISTTYPE: "نوع مساعد التصويب",
  T_37_WZY_WS_ALLOWDROP_NAME: "تمكين / تعطيل إسقاط العنصر",
  T_37_WZY_WS_ALLOWDROP_NAMEDESC: "ما إذا كان يمكن للاعب إسقاط العناصر",
  T_37_WZY_WS_ALLOWDROP_PARAM1_DESC: "كيان اللاعب لتكوين ما إذا كان سيتم إسقاط العناصر",
  T_37_WZY_WS_ALLOWDROP_PARAM2_DESC: "ما إذا كان بإمكان اللاعب إسقاط العناصر. هذه هي القيمة المنطقية.",
  T_37_WZY_WS_ALLOWPICKUP_NAME: "تمكين / تعطيل التقاط العنصر",
  T_37_WZY_WS_ALLOWPICKUP_NAMEDESC: "ما إذا كان يمكن للاعب التقاط العناصر",
  T_37_WZY_WS_ALLOWPICKUP_PARAM1_DESC: "كيان اللاعب لتكوين ما إذا كان سيتم التقاط العناصر",
  T_37_WZY_WS_ALLOWPICKUP_PARAM2_DESC: "ما إذا كان بإمكان اللاعب التقاط العناصر. هذه هي القيمة المنطقية.",
  T_37_WZY_WS_AMBIENTCOLOR: "لون الضوء المحيط",
  T_37_WZY_WS_AMRORTOOL: "إصلاح الدرع",
  T_37_WZY_WS_ATTACK: "اهجم",
  T_37_WZY_WS_BACKTONOR_NAMEDESC: "قم بإلغاء تمويه اللاعب حتى يعود إلى مظهره الطبيعي",
  T_37_WZY_WS_BACKTONOR_PARAM1_DESC: "الكيان اللاعب الذي سيتم إلغاء تمويهه",
  T_37_WZY_WS_BALLADDV_NAMEDES: "قم بزيادة سرعة كرة القدم",
  T_37_WZY_WS_BALLADDV_PARAM1_DESC: "كرة القدم لزيادة سرعة الـ",
  T_37_WZY_WS_BALLADDV_PARAM2_DESC: "متجه سرعة التعزيز",
  T_37_WZY_WS_BALLKICKED_NAMEDESC: "تنطلق عندما تصطدم كرة القدم برامي الكرة. [كيان اللاعب] هو اللاعب الذي يمتلك رامي الكرة. [زيادة السرعة] هي السرعة المضافة لكرة القدم بعد الضرب.",
  T_37_WZY_WS_BALLKICKED_PARAM1_DESC: "اللاعب الذي يمتلك رامي الكرة",
  T_37_WZY_WS_BALLKICKED_PARAM2_DESC: "متجه سرعة كرة القدم بعد إصابتها",
  T_37_WZY_WS_BALLKNOCKED_NAMEDESC: "تنطلق عندما تصطدم كرة القدم بكيان وتزداد سرعة الكرة. [الكيان المتصادم] هو الكيان الذي يصطدم بكرة القدم. [زيادة السرعة] هي السرعة المضافة لكرة القدم بعد الاصطدام.",
  T_37_WZY_WS_BALLKNOCKED_PARAM1_DESC: "الكيان الذي يصطدم بكرة القدم",
  T_37_WZY_WS_BALLKNOCKED_PARAM2_DESC: "السرعة المضافة لكرة القدم بعد الاصطدام",
  T_37_WZY_WS_BEAIMED_NAMEDESC: "تنطلق عندما يستهدف اللاعب العنصر",
  T_37_WZY_WS_BEAIMED_PARAM1_DESC: "اللاعب الذي يستهدف الكيان",
  T_37_WZY_WS_BEHAVIORSTAT: "حالة سلوك اللاعب",
  T_37_WZY_WS_BEHIT_PARAM1_DESC: "كيان السلاح الذي يضرب هذا الكيان",
  T_37_WZY_WS_BLOODBARENT: "كيان شريط الصحة",
  T_37_WZY_WS_BOMBEND: "قبل الإنفجار",
  T_37_WZY_WS_BOMBSTART: "إشارة القنبلة",
  T_37_WZY_WS_CHANENT: "كيان القناة",
  T_37_WZY_WS_CHEER: "هتاف",
  T_37_WZY_WS_CHELABEL_NAMEDESC: "تحقق مما إذا كان الكيان المحدد يحتوي على علامات معينة",
  T_37_WZY_WS_CHELABEL_PARAM1_DESC: "الكيان المراد التحقق مما إذا كان يحتوي على علامات",
  T_37_WZY_WS_CHELABEL_PARAM2_DESC: "العلامة المراد التحقق منها",
  T_37_WZY_WS_CHELABELRES: "نتيجة فحص العلامة. هذه قيمة منطقية.",
  T_37_WZY_WS_CJERSEY_NAME: "تغيير القميص",
  T_37_WZY_WS_CJERSEY_PARAM1_DESC: "اللاعب الذي تغير قميصه",
  T_37_WZY_WS_CJERSEY_PARAM2: "تصميم القميص",
  T_37_WZY_WS_CJERSEY_PARAM2_DESC: "التصميم للتغيير إليه",
  T_37_WZY_WS_CJERSEY_PARAM3_DESC: "لون الجزء 1 على القميص",
  T_37_WZY_WS_CJERSEY_PARAM4_DESC: "لون الجزء 2 على القميص",
  T_37_WZY_WS_CJERSEY_PARAM5_DESC: "لون الجزء 3 على القميص",
  T_37_WZY_WS_CJERSEYTYPE1: "التصميم 1",
  T_37_WZY_WS_CJERSEYTYPE2: "التصميم 2",
  T_37_WZY_WS_CJERSEYTYPE3: "التصميم 3",
  T_37_WZY_WS_CLEAR_ARR_DESC: "امسح كل العناصر في القائمة",
  T_37_WZY_WS_CREABLEOB_DESC: "نوع العنصر الذي يمكن إنشاؤه باستخدام الكتل",
  T_37_WZY_WS_CREPROD_NAMEDESC: "أنشئ بضاعة قابلة للتخصيص وإرجاع كيانًا للبضائع. يمكن تكوين محتوى البضائع من خلال إعدادات الخاصية.",
  T_37_WZY_WS_CRESHELVES_NAMEDESC: "قم بإنشاء قائمة بضائع قابلة للتخصيص وأعد كيانًا لقائمة البضائع. يمكن تغيير محتوى هذه القائمة من خلال إعدادات الخاصية.",
  T_37_WZY_WS_CRESHELVES_PARAM1_DESC: "كيان قائمة البضائع الذي سيتم إنشاؤه",
  T_37_WZY_WS_CRESIDE_NAMEDESC: "أنشئ كيان فصيل",
  T_37_WZY_WS_CRESIDE_PARAM1_DESC: "الكيان الفصيل الذي سيتم إنشاؤه",
  T_37_WZY_WS_CRESTORE_NAMEDESC: "أنشئ متجرًا قابلاً للتخصيص وأعد كيان متجر. يمكن تغيير محتوى المتجر من خلال إعدادات الخاصية.",
  T_37_WZY_WS_CRESTORE_PARAM2_DESC: "تم إنشاء كيان المتجر",
  T_37_WZY_WS_CSKYBOX_NAMEDESC: "قم بتغيير بيئة السماء في اللعبة. تشمل الخيارات النهار والغسق والليل.",
  T_37_WZY_WS_CSKYBOX_PARAM1_DESC: "نوع السماء المراد التغيير إليها. تشمل الخيارات النهار والغسق والليل.",
  T_37_WZY_WS_DARKNESS: "الظلمة العامة",
  T_37_WZY_WS_DELENT_NAMEDESC: "احذف كيانًا معينًا. يدعم حاليًا كيان الرمز، وكيان النص، وكيان HUD، وكيان التأثيرات البصرية، وكيان السلاح، وكيانات العناصر الأخرى.",
  T_37_WZY_WS_DELENT_PARAM1_DESC: "الكيان المراد حذفه",
  T_37_WZY_WS_DROP: "خطأ",
  T_37_WZY_WS_DROPITEMS_NAMEDESC: "ينطلق عندما يسقط اللاعب عنصرًا. [نوع العنصر] هو معرف نوع العنصر الذي تم إسقاطه.",
  T_37_WZY_WS_DROPITEMS_PARAM1_DESC: "معرف نوع العنصر الذي تم إسقاطه",
  T_37_WZY_WS_DROPWEAP_NAMEDESC: "تنطلق عندما يسقط اللاعب سلاحًا. [كيان السلاح] هو السلاح الذي يتم إسقاطه.",
  T_37_WZY_WS_DROPWEAP_PARAM1_DESC: "السلاح الذي تم إسقاطه",
  T_37_WZY_WS_DUMMYLEOBJ: "عنصر المرحلة العادية",
  T_37_WZY_WS_DUST: "الغسق",
  T_37_WZY_WS_EMPTYCH: "القناة الفارغة الافتراضية",
  T_37_WZY_WS_EMPTYCH1: "القناة الفارغة 1",
  T_37_WZY_WS_EMPTYCH2: "القناة الفارغة 2",
  T_37_WZY_WS_EMPTYCH3: "القناة الفارغة 3",
  T_37_WZY_WS_EMPTYCH4: "القناة الفارغة 4",
  T_37_WZY_WS_EMPTYCH5: "القناة الفارغة 5",
  T_37_WZY_WS_EMPTYCH6: "القناة الفارغة 6",
  T_37_WZY_WS_ENTFILTER_NAMEDESC: "احصل على قائمة تحتوي على جميع الكيانات التي تستوفي الشروط الثلاثة. المحتوى المُدرج ليشمل الكل، يستبعد، ويشمل، هو نوع مكون واحد أو قائمة أنواع المكونات. النتيجة التي تم إرجاعها هي قائمة الكيانات التي تفي بالشروط.",
  T_37_WZY_WS_ENTFILTER_PARAM1_DESC: "يجب أن تحتوي الكيانات التي تم تصفيتها على جميع المكونات من هذه المجموعة",
  T_37_WZY_WS_ENTFILTER_PARAM2_DESC: "يجب ألا تحتوي الكيانات التي تمت تصفيتها على مكونات معينة من هذه المجموعة",
  T_37_WZY_WS_ENTFILTER_PARAM3_DESC: "يجب أن تحتوي الكيانات التي تم تصفيتها على مكون واحد على الأقل من هذه المجموعة",
  T_37_WZY_WS_ENTITY2_PARAM3_DESC: "نوع خاصية هذا الكيان المطلوب تغييره",
  T_37_WZY_WS_ENTITY2_PARAM4_DESC: "قيمة الخاصية المطلوب التغيير إليها",
  T_37_WZY_WS_EXITCHAN_NAMEDESC: "دع اللاعب يغادر القناة الحالية حتى لا يكون في أي قناة",
  T_37_WZY_WS_EXITCHAN_PARAM1_DESC: "اللاعب لمغادرة القناة",
  T_37_WZY_WS_FAKEENT: "كيان تمويه",
  T_37_WZY_WS_FIND_STR_DESC: "ابحث عن موقع نص معين داخل سلسلة",
  T_37_WZY_WS_FINDSTR_PARAM1DESC: "الشخصية التي تبحث عنها",
  T_37_WZY_WS_FINDSTR_PARAM2DESC: "ابحث عن سلسلة من موقع البداية، والتي تبدأ من 0.",
  T_37_WZY_WS_FINDSTRRES: "الموقع الأول الذي تظهر فيه السلسلة. يبدأ من 0.",
  T_37_WZY_WS_FOGCOLOR: "لون الضباب",
  T_37_WZY_WS_FRICTIONCON: "مضاعف الاحتكاك المنتظم",
  T_37_WZY_WS_FRICTIONIMP: "مضاعف احتكاك التصادم",
  T_37_WZY_WS_FROMDEATH: "الإحياء",
  T_37_WZY_WS_FROMKNODOWN: "ساعد",
  T_37_WZY_WS_GETCHAN_NAMEDESC: "احصل على القناة التي يتواجد فيها اللاعب المعين",
  T_37_WZY_WS_GETCHAN_PARAM1_DESC: "كيان اللاعب الذي سيتم الحصول على قناته",
  T_37_WZY_WS_GETCHANRES: "القناة التي يتواجد فيها اللاعب حاليًا",
  T_37_WZY_WS_GETEMPTYCH_NAMEDES: "وفقًا لمعرف القناة من 1 إلى 8، احصل على القناة الفارغة التي تم إنشاؤها افتراضيًا في بداية اللعبة",
  T_37_WZY_WS_GETEMPTYCH_PARAM1_DESC: "معرف القناة الفارغة الافتراضية",
  T_37_WZY_WS_GETEMPTYCH_RES: "كيان القناة الذي تم الحصول عليه",
  T_37_WZY_WS_GETFAKEENT_NAMEDESC: "احصل على كيان تمويه للاعب",
  T_37_WZY_WS_GETFAKEENT_PARAM1_DESC: "العنصر الذي يجب الحصول على كيان تمويه",
  T_37_WZY_WS_GETGAMEENT_NAME: "كن عالميًا",
  T_37_WZY_WS_GETGAMEENT_NAMEDESC: "احصل على كيان اللعبة لهذه المباراة",
  T_37_WZY_WS_GETHOSTPLA_NAME: "احصل على لاعب قابل للهجوم",
  T_37_WZY_WS_GETHOSTSIDE_PARAM1: "كيان الفصيل",
  T_37_WZY_WS_GOAL_NAMEDESC: "يطلق عندما تدخل كرة القدم المرمى. [الهدف] هو الهدف الذي تدخله كرة القدم. [المسجل] هو آخر لاعب لمس الكرة. [المساعد] هو ثاني لاعب يلامس الكرة.",
  T_37_WZY_WS_GOAL_PARAM1_DESC: "الهدف الذي تدخله هذه كرة القدم",
  T_37_WZY_WS_GOAL_PARAM2_DESC: "آخر لاعب لمس الكرة",
  T_37_WZY_WS_GOAL_PARAM3_DESC: "اللاعب الثاني الذي لمس الكرة",
  T_37_WZY_WS_HEARTBEAT: "نبض القلب",
  T_37_WZY_WS_HEAVYWEAPON: "سلاح ثقيل",
  T_37_WZY_WS_HIHGSHOOTANGLE: "أصغر زاوية التسديد",
  T_37_WZY_WS_HOSTPLA: "قائمة باللاعبين القابلين للهجوم",
  T_37_WZY_WS_HOSTSIDE: "قائمة بالفصائل القابلة للهجوم",
  T_37_WZY_WS_HOSTTEAM: "قائمة بالفرق القابلة للهجوم",
  T_37_WZY_WS_ICON_CLOCK: "العد التنازلي",
  T_37_WZY_WS_ICON_CLOTHES: "أزياء",
  T_37_WZY_WS_ICON_QUIT: "خروج",
  T_37_WZY_WS_INSERT_ARR_DESC: "أدخل عنصرًا جديدًا في موقع معين في القائمة",
  T_37_WZY_WS_INTERCEPT_STR_DESC: "استخرج سلسلة بطول معين، بدءًا من موقع المؤشر. إذا تجاوز طول الاستخراج طول السلسلة، فسيتم استخراج المحتوى حتى نهاية السلسلة.",
  T_37_WZY_WS_INTERCEPTSTR_PARAM1DESC: "طول الاستخراج",
  T_37_WZY_WS_INTERCEPTSTRRES_DESC: "السلسلة التي تم استخراجها",
  T_37_WZY_WS_INTORINTL: "عدد صحيح أو قائمة عدد صحيح",
  T_37_WZY_WS_JOINSIDE_NAMEDESC: "دع اللاعب ينضم إلى فصيل معين",
  T_37_WZY_WS_JOINSIDE_PARAM2_DESC: "الفصيل الذي سينضم إليه اللاعب",
  T_37_WZY_WS_JUMP: "اقفز",
  T_37_WZY_WS_LABEL: "علامة",
  T_37_WZY_WS_LENSFLARE: "العدسة",
  T_37_WZY_WS_LENTH: "طول",
  T_37_WZY_WS_LIGHTATTACK: "ضربة ناجحة",
  T_37_WZY_WS_LIGHTCOLOR: "لون مصدر الضوء",
  T_37_WZY_WS_LIGHTINTENSITY: "سطوع مصدر الضوء",
  T_37_WZY_WS_LOADSCENE_NAMEDESC: "قم تحميل مشهد جديد",
  T_37_WZY_WS_LOADSCENE_PARAM1_DESC: "اسم المشهد المراد تحميله",
  T_37_WZY_WS_MOROBJECT: "عنصر تمويه",
  T_37_WZY_WS_MOVEAXISX: "تحرك على طول المحور س",
  T_37_WZY_WS_MOVEAXISY: "تحرك على طول المحور ص",
  T_37_WZY_WS_MOVEAXISZ: "تحرك على طول المحور ض",
  T_37_WZY_WS_MOVEDISTITLE: "مسافة الحركة",
  T_37_WZY_WS_MUTEQUICKCHAT_NAME: "تشغيل الرسائل السريعة أو إيقافها",
  T_37_WZY_WS_MUTEQUICKCHAT_NAMEDESC: "تشغيل الرسائل السريعة أو إيقاف تشغيلها. عند إيقاف التشغيل، لا يمكن استخدام HUD للرسالة السريعة ولن يتمكن اللاعبون من إرسال أو استقبال رسائل سريعة.",
  T_37_WZY_WS_MUTEQUICKCHAT_PARAM1_DESC: "اللاعب الذي يقوم بتشغيل / إيقاف تشغيل الرسائل السريعة",
  T_37_WZY_WS_MUTEVOICE_NAME: "تشغيل الدردشة الصوتية أو إيقافها",
  T_37_WZY_WS_MUTEVOICE_NAMEDESC: "تشغيل الدردشة الصوتية أو إيقاف تشغيلها. عند إيقاف التشغيل، لا يمكن استخدام HUD الصوتي ولن يتمكن اللاعبون من إرسال أو استقبال الرسائل الصوتية.",
  T_37_WZY_WS_MUTEVOICE_PARAM1_DESC: "اللاعب المراد تشغيل / إيقاف تشغيل الدردشة الصوتية له",
  T_37_WZY_WS_MUTEVOICE_PARAM2_DESC: "قيمة منطقية. صحيح يعني مقفل؛ خطأ يعني قيد التشغيل.",
  T_37_WZY_WS_NIGHTMODE: "وضع الليل",
  T_37_WZY_WS_ONAIM_NAMEDESC: "تنطلق عندما يهدف اللاعب إلى كيان قابل للهدف. [الكيان المستهدف] هو كيان قابل للهدف. عندما لا يكون هناك كيان مستهدف، تكون قيمة الإرجاع فارغة.",
  T_37_WZY_WS_ONAIM_PARAM1_NAME: "الكيان المستهدف",
  T_37_WZY_WS_ONHIT_PARAM1_DESC: "الكيان الذي أصابه السلاح",
  T_37_WZY_WS_ONSCENELOADING_NAMEDESC: "تنطلق عند تحميل المشهد بنجاح",
  T_37_WZY_WS_ONSCENELOADING_PARAM1_DESC: "اسم المشهد المراد تحميله. هذه سلسلة.",
  T_37_WZY_WS_ONSCENESWITCH_NAMEDESC: "تنطلق عندما يتغير المشهد بنجاح",
  T_37_WZY_WS_ONSCENESWITCH_PARAM1_DESC: "اسم المشهد الجديد. هذه سلسلة.",
  T_37_WZY_WS_OUTJERSEY_NAMEDESC: "استعادة ملابس اللاعب إلى مظهرها الافتراضي",
  T_37_WZY_WS_OUTJERSEY_PARAM1_DESC: "اللاعب الذي يجب استعادة ملابسه الافتراضية",
  T_37_WZY_WS_PETSET: "إعداد الحيوانات الأليفة",
  T_37_WZY_WS_PETSKILL: "مهارات الحيوانات الأليفة",
  T_37_WZY_WS_PETSWITCH2: "ما إذا كان يمكن استخدام مهارات الحيوانات الأليفة",
  T_37_WZY_WS_PLAMOVE_PARAM2_DESC: "ما إذا كان سيتم تمكين حركة اللاعب. هذه قيمة منطقية.",
  T_37_WZY_WS_PLAYERBEHAVIOR: "نوع سلوك اللاعب",
  T_37_WZY_WS_PRESS: "نقرة خفيفة",
  T_37_WZY_WS_PROGRESS: "التقدم الحالي",
  T_37_WZY_WS_PROGRESSBAR: "تقدم كيان HUD",
  T_37_WZY_WS_RANKDOWN: "انخفاض التصنيف",
  T_37_WZY_WS_REMLABEL_NAMEDESC: "إزالة علامة للكيان المحدد",
  T_37_WZY_WS_REMLABEL_PARAM1_DESC: "محتوى النص المراد إزالته",
  T_37_WZY_WS_REPLACE_STR_DESC: "استبدل محتوى سلسلة بمحتوى معين",
  T_37_WZY_WS_REPLACESTR_PARAM1DESC: "الشخصية المراد استبدالها",
  T_37_WZY_WS_REPLACESTR_PARAM2DESC: "الشخصية الجديدة لتحل محلها",
  T_37_WZY_WS_REVERSE_ARR_DESC: "اعكس كل العناصر في هذه القائمة",
  T_37_WZY_WS_REVIVEHERE: "اللاعب الذي يعيد إحياء زملائه في هذه نقطة الإحياء",
  T_37_WZY_WS_REVIVEHERE_NAMEDESC: "تنطلق عندما يقوم اللاعب بإحياء زملائه في هذه نقطة الإحياء",
  T_37_WZY_WS_REVIVEWAYDESC: "الطريقة التي يتم بها إحياء اللاعب أو مساعدته من الاقصاء أو نوك داون",
  T_37_WZY_WS_SATBEHAVIOR_NAMEDESC: "تكوين حالة السلوكيات المختلفة للاعبين. عند التعطيل، لا يمكن استخدام الأزرار المقابلة على HUD، ولا يُسمح بالحركات اليدوية والتلقائية. عند الإخفاء، لن يتم عرض الأزرار المقابلة على HUD، ولا يُسمح بالحركات اليدوية أثناء السماح بالحركات التلقائية. عند التمكين، سيتم عرض الأزرار المقابلة على HUD، ويسمح بالحركات اليدوية والتلقائية.",
  T_37_WZY_WS_SATBEHAVIOR_PARAM1_DESC: "اللاعب الذي سيحدد حالة السلوك",
  T_37_WZY_WS_SATBEHAVIOR_PARAM2_DESC: "سلوك اللاعب، بما في ذلك الحركة والهجوم والقفز والركض",
  T_37_WZY_WS_SATBEHAVIOR_PARAM3_DESC: "تشمل الحالة معطلة ومخفية وممكّنة. عند الإخفاء، لن يتم عرض الأزرار المقابلة على شاشة HUD، ولا يُسمح بالحركات اليدوية أثناء السماح بالحركات التلقائية. عند التشغيل، سيتم عرض الأزرار المقابلة على شاشة HUD، ويسمح بالحركات اليدوية والتلقائية.",
  T_37_WZY_WS_SETBALL_PARAM2_DESC: "إحداثيات كرة القدم",
  T_37_WZY_WS_SETBALL_PARAM3_DESC: "ما إذا كان يجب أن تحافظ كرة القدم على سرعة التكوين المسبق. هذه قيمة منطقية.",
  T_37_WZY_WS_SETPLAHOST_NAME: "إعداد هجوم اللاعب",
  T_37_WZY_WS_SETPLAHOST_NAMEDESC: "قم بتكوين ما إذا كان [إعداد اللاعب] يمكنه مهاجمة [اللاعب المستهدف]. يعتمد الإعداد الافتراضي على ما إذا كان اللاعب المستهدف ينتمي إلى فريق وفصيل يمكن مهاجمته. هذا الإعداد ذو أفضلية أعلى من إعداد الفريق / الفصيل.",
  T_37_WZY_WS_SETPLAHOST_PARAM1_DESC: "اللاعب لتكوين الأعداء له",
  T_37_WZY_WS_SETPLAHOST_PARAM2_DESC: "اللاعب الذي هو العدو",
  T_37_WZY_WS_SETPLAHOST_PARAM3: "قابل للهجوم أم لا",
  T_37_WZY_WS_SETPLAHOST_PARAM3_DESC: "نعم يعني قابل للهجوم؛ ولا يعني غير قابل للهجوم. يعتمد الإعداد الافتراضي على ما إذا كان اللاعب المستهدف ينتمي إلى فريق وفصيل يمكن مهاجمته.",
  T_37_WZY_WS_SETSIDEHOST_PARAM3_DESC: "نعم يعني قابل للهجوم؛ لا يعني غير قابل للهجوم",
  T_37_WZY_WS_SHADOWSTRENGTH: "الظلال",
  T_37_WZY_WS_SHOOTANGLE: "أصغر زاوية إطلاق",
  T_37_WZY_WS_SKYBOX: "صندوق السماء",
  T_37_WZY_WS_SKYBOXENT: "كيان السماء",
  T_37_WZY_WS_SKYBOXTYPE: "أنواع صناديق السماء الأساسية",
  T_37_WZY_WS_STEPPED: "خطوة على الزناد",
  T_37_WZY_WS_SWCHAN_NAMEDESC: "قم بتبديل قناة الدردشة الصوتية للاعب",
  T_37_WZY_WS_SWCHAN_PARAM1_DESC: "اللاعب المراد تبديل القنوات من أجله",
  T_37_WZY_WS_SWCHAN_PARAM2_DESC: "القناة المراد التبديل إليها",
  T_37_WZY_WS_SWITCHSCENE_NAMEDESC: "قم بالتبديل إلى مشهد معين",
  T_37_WZY_WS_SWITCHSCENE_PARAM1_DESC: "اسم المشهد المراد التبديل إليه",
  T_37_WZY_WS_TARGETSTR_DESC: "سلسلة الهدف",
  T_37_WZY_WS_TEAMASIDE: "الفريق والفصيل",
  T_37_WZY_WS_TELEPORTN_AUTO: "تلقائي",
  T_37_WZY_WS_TELEPORTN_AVAILABLE: "قابل للنقل أم لا",
  T_37_WZY_WS_TELEPORTN_MANUAL: "يدوي",
  T_37_WZY_WS_TELEPORTN_NO: "لا",
  T_37_WZY_WS_TELEPORTN_TITLE: "طريقة النقل الفضائي",
  T_37_WZY_WS_TELEPORTN_YES: "نعم",
  T_37_WZY_WS_TERRAINWET: "رطوبة الأرض",
  T_37_WZY_WS_TRANSFORM_NAMEDESC: "استبدل مظهر [كيان اللاعب] بمظهر [عنصر مشهد]",
  T_37_WZY_WS_TRANSFORM_PARAM1_DESC: "كيان اللاعب الذي يتغير مظهره",
  T_37_WZY_WS_TRANSFORM_PARAM2_DESC: "اللاعب الذي يجب الحصول على كيان تمويه",
  T_37_WZY_WS_TRANSP: "الشفافية",
  T_37_WZY_WS_UNLOADSCENE_NAMEDESC: "قم بإلغاء تثبيت مشهد معين",
  T_37_WZY_WS_UNLOADSCENE_PARAM1_DESC: "اسم المشهد المراد إزالته",
  T_37_WZY_WS_VFX1: "رمزي",
  T_37_WZY_WS_VFX2: "مدخن",
  T_37_WZY_WS_VFX3: "لعنة الإنفجار",
  T_37_WZY_WS_VFX5: "متجمد",
  T_37_WZY_WS_VFX6: "ضوء المسرح",
  T_37_WZY_WS_VFX7: "الاضطراب التصاعدي",
  T_37_WZY_WS_VFX8: "انفجار الغلاف الجوي",
  T_37_WZY_WS_VISABLE: "الرؤية",
  T_37_WZY_WS_WEAOPEN: "إظهار أم لا",
  T_37_WZY_WS_WEAPONENT: "كيان السلاح",
  T_37_WZY_WS_WEATARGETED: "ما إذا كان يمكن استهدافها من خلال مساعدة التصويب",
  T_37_XYL_CUSTOMJERSEY: "آلة القميص",
  T_37_XYL_CUSTOMJERSEY_DESC: "استخدم آلة القميص لإنشاء قميصك المثالي",
  T_37_XYL_FOOTGUN: "رامي الكرة",
  T_37_XYL_SOCCER: "كورة القدم",
  "T_37_XYL_SOCCER_ RADIUS": "نصف القطر",
  T_37_XYL_SOCCER_DESC: "كرة قدم يمكن تخصيص خصائصها",
  T_37_XYL_SOCCER_HIGHT1: "زاوية منتظمة",
  T_37_XYL_SOCCER_HIGHT2: "زاوية التسديد",
  T_37_XYL_SOCCER_RESET: "أعد ضبط الوقت بعد الهدف (ث)",
  T_37_XYL_SOCCER_RESIST1: "الاحتكاك (وضع الركلة)",
  T_37_XYL_SOCCER_RESIST2: "الاحتكاك (وضع السلاح)",
  T_37_XYL_SOCCERGOAL: "هدف",
  T_37_XYL_SOCCERGOAL_DESC: "هذا هو الهدف. أطلق النار على كرة القدم في المرمى للتسجيل. (صالحة فقط في انتزاع النقاط.)",
  T_37_XYL_SOCCERITEM: "موّلد العنصر",
  T_37_XYL_SOCCERITEM_DESC: "عند وضعه، سيولد العنصر المحدد",
  T_37_XYL_SPAWN_PEOPLE: "عدد من اللاعبين",
  T_37_XYL_WS_AIRCONDITIONER001: "مكيف B",
  T_37_XYL_WS_AMMUCHEST: "صندوق الحرب A",
  T_37_XYL_WS_BAFFLE001: "الحاجز A",
  T_37_XYL_WS_BARREL001: "براميل",
  T_37_XYL_WS_BARREL001_DES: "براميل خشبية دائرية شائعة",
  T_37_XYL_WS_BOARD001: "لوحة دعاية B",
  T_37_XYL_WS_BOOK001: "كومة من الكتب A",
  T_37_XYL_WS_BOOK002: "لعبة اللوحة A",
  T_37_XYL_WS_BOUGAINVILLEA: "شجيرات",
  T_37_XYL_WS_BOUGAINVILLEA_DES: "الديكور - يضيء المكان!",
  T_37_XYL_WS_BOX001: "كومة الصناديق A",
  T_37_XYL_WS_BOX002: "صندوق صغير",
  T_37_XYL_WS_BUSHCOVER: "شجيرة",
  T_37_XYL_WS_BUSHCOVER_DES: "شجيرة يمكن استخدامها للاختباء فيها",
  T_37_XYL_WS_CABINET001: "أدراج A",
  T_37_XYL_WS_CHAIR001: "كرسي A",
  T_37_XYL_WS_COCONUTTREE: "شجرة جوز الهند",
  T_37_XYL_WS_COCONUTTREE_DES: "الديكور - للحصول على أجواء شاطئية!",
  T_37_XYL_WS_COMPUTER001: "الكمبيوتر A",
  T_37_XYL_WS_DAMAGERATIO: "نسبة الضرر",
  T_37_XYL_WS_FIREEX: "طفاية حريق",
  T_37_XYL_WS_GUIDEPOSE: "مركز الإتجاه",
  T_37_XYL_WS_HUGEHOUSE001: "بيت 3 طوابق B",
  T_37_XYL_WS_HUGEHOUSE002: "بيت 2 طوابق B",
  T_37_XYL_WS_JACKSTRAW: "الفزاعة",
  T_37_XYL_WS_LADDER001: "سلم A",
  T_37_XYL_WS_OILDRUM: "برميل زيت",
  T_37_XYL_WS_ORNAMENT001: "إناء A",
  T_37_XYL_WS_PACKBOX: "حاوية الإمداد",
  T_37_XYL_WS_PILLA001: "عمود خرساني",
  T_37_XYL_WS_PRESENT: "صندوق الهدايا",
  T_37_XYL_WS_PRESENT_DES: "يحتوي على هدايا العطلات",
  T_37_XYL_WS_PUMPKIN: "فانوس يقطين المربع",
  T_37_XYL_WS_PUMPKINCUT: "فانوس اليقطين",
  T_37_XYL_WS_PUMPKINCUT_DES: "زخرفة شائعة لمهرجان الرعب",
  T_37_XYL_WS_ROADBLOCK001: "حاجز B",
  T_37_XYL_WS_SHELF001: "رف الكتب A",
  T_37_XYL_WS_SOFA001: "كنبة A",
  T_37_XYL_WS_SPAWNTEAM: "كل الفرق",
  T_37_XYL_WS_SUPPLYBOX: "صندوق الذخيرة",
  T_37_XYL_WS_TABLE001: "طاولة A",
  T_37_XYL_WS_TABLE002: "طاولة B",
  T_37_XYL_WS_TARGET001: "الهدف",
  T_37_XYL_WS_TEAMID_1: "1",
  T_37_XYL_WS_TEAMID_10: "10",
  T_37_XYL_WS_TEAMID_11: "11",
  T_37_XYL_WS_TEAMID_12: "12",
  T_37_XYL_WS_TEAMID_2: "2",
  T_37_XYL_WS_TEAMID_3: "3",
  T_37_XYL_WS_TEAMID_4: "4",
  T_37_XYL_WS_TEAMID_5: "5",
  T_37_XYL_WS_TEAMID_6: "6",
  T_37_XYL_WS_TEAMID_7: "7",
  T_37_XYL_WS_TEAMID_8: "8",
  T_37_XYL_WS_TEAMID_9: "9",
  T_37_XYL_WS_TELEPORTEND: "نقطة نهاية البوابة",
  T_37_XYL_WS_TELEPORTNEW: "البوابة A",
  T_37_XYL_WS_TELEPORTNEW_DESC: "بوابة يمكنها نقل اللاعب إلى نقطة نهاية البوابة",
  T_37_XYL_WS_TIRES001: "عجلة A",
  T_37_XYL_WS_TOOLRACK: "رف الأدوات",
  T_37_XYL_WS_WALL001: "جدار",
  T_37_XYL_WS_WOOD001: "خشب مقطع",
  T_37_XYL_WS_YELLOWDUCK001: "عوامة البطة",
  T_37_XYL_WS_YELLOWDUCK001_DES: "بالون سباحة منفوخة على شكل بطة",
  T_37_YM_BOMBSQUAD_DEFUSER: "المعطّل",
  T_37_YS_B_BRFOOTBALL_WHITE: "قميص CBF الأبيض (سفلي)",
  T_37_YS_F_B_VN_STREET: "الإلهام القرمزي (سفلي)",
  T_37_YS_F_H_VN_STREET: "الإلهام القرمزي (رأس)",
  T_37_YS_F_S_VN_STREET: "الإلهام القرمزي (حذاء)",
  T_37_YS_F_T_VN_STREET: "الإلهام القرمزي (علوي)",
  T_37_YS_M_A_CRICKET_BLACK: "لاعب كريكيت الأصفر (قناع)",
  T_37_YS_M_A_THKOL: "طافي الحريق (قناع)",
  T_37_YS_M_B_CRICKET_BLACK: "لاعب كريكيت الأصفر (سفلي)",
  T_37_YS_M_B_SILVERERA: "الحارس الجريء (سفلي)",
  T_37_YS_M_B_THKOL: "طافي الحريق (سفلي)",
  T_37_YS_M_H_SILVERERA: "الحارس الجريء (رأس)",
  T_37_YS_M_H_THKOL: "طافي الحريق (رأس)",
  T_37_YS_M_S_CRICKET_BLACK: "لاعب كريكيت الأصفر (حذاء)",
  T_37_YS_M_S_SILVERERA: "الحارس الجريء (حذاء)",
  T_37_YS_M_S_THKOL: "طافي الحريق (حذاء)",
  T_37_YS_M_T_CRICKET_BLACK: "لاعب كريكيت الأصفر (علوي)",
  T_37_YS_M_T_SILVERERA: "الحارس الجريء (علوي)",
  T_37_YS_M_T_THKOL: "طافي الحريق (علوي)",
  T_37_YS_T_BRFOOTBALL_WHITE: "قميص CBF الأبيض (علوي)",
  T_37_ZF_ROOM_UGC_MINPLAYER: "الحد الأدنى من اللاعبين",
  T_38_BQ_SKILL_NAME_DUMMY1: "المخاطر المزدوج",
  T_38_BQ_SKILL_NAME_DUMMY2: "فاصل شكلي",
  T_38_CJ_F_B_STREAMER_MUSIC: "باحثة الحب (سفلي)",
  T_38_CJ_F_H_STREAMER_MUSIC: "باحثة الحب (رأس)",
  T_38_CJ_F_S_STREAMER_MUSIC: "باحثة الحب (حذاء)",
  T_38_CJ_F_T_STREAMER_MUSIC: "باحثة الحب (علوي)",
  T_38_JH_WS_CM1: "قواعد واضحة",
  T_38_JH_WS_CM2: "قواعد غير واضحة",
  T_38_JH_WS_CM3: "كثرة الخروج",
  T_38_JL_M79_AMMO_N: "ذخيرة M79",
  T_38_JMF_SKILLCHIP_NAME_SINGER: "رقاقة J.Biebs",
  T_38_M_WS_VECTOR2: "متجه ثنائي الأبعاد",
  T_38_R_TACTICS_N: "إعداد مسبق",
  T_38_RW_NIW_NIWNAME: "صانع جدار الجلو",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CALLSTACKCOUNTMAX: "طبقات كثيرة جدًا من الكتل. الحالي: {0}. الحد الأقصى: {1}.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CREATEITEMCOUNTMAXPERMATCHKEY: "عدد العناصر التي قمت بإنشائها ({0}) تجاوز الحد ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_DISPATCHEVENTMAXCOUNTPERFRAME: "عدد الحوادث التي تم تلقيها داخل نفس الإطار ({0}) تجاوز الحد ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_ENTITIESCREATEDPERFRAMEMAX: "تم الوصول إلى الحد الأقصى لإنشاء الكيانات الديناميكية لكل إطار ({0})؛ تم رفض محاولة (محاولات) إنشاء {1}.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LISTINITLENGTHMAX: "تجاوز طول القائمة التي تمت تهيئتها ({0}) الحد الأقصى ({1}). يقوم تلقائيًا بإنشاء قائمة السعة القصوى.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LOOPTIMESMAX: "تجاوز عدد الحلقات ({0}) الحد ({1}). توقف الحلقة",
  T_38_SP_WS_LOG_EXCEED_LIMIT_PERSCOPECOROUTINECONCURRENCYMAX: "تجاوز عدد الكوروتين المتزامن ({0}) في نطاق الكوروتين الحد ({1}).",
  T_38_SP_WS_LOG_LIST_APPEND_IS_NIL: "فشل إضافة عنصر إلى القائمة. القائمة {0} فارغة",
  T_38_SP_WS_LOG_VAR_ARITHMETIC_FAILED: "أنواع القيمة غير المتطابقة عند تنفيذ العملية الحسابية الأساسية. نوع القيمة اليسرى هو {0} ونوع القيمة اليمنى هو {1}.",
  T_38_SP_WS_LOG_VAR_REPEATED_DEF_IN_SCOPE: "تعريف عامل مؤقت متكرر. اسم العامل: {0}.",
  T_38_SP_WS_REVIEW_01: "سامة",
  T_38_SP_WS_REVIEW_02: "بذيئة",
  T_38_SP_WS_REVIEW_03: "إهانة",
  T_38_SP_WS_REVIEW_04: "سامة للغاية",
  T_38_SP_WS_REVIEW_05: "تهديد",
  T_38_SP_WS_REVIEW_06: "عدم الاحترام",
  T_38_SP_WS_REVIEW_07: "قيد المراجعة",
  T_38_SP_WS_REVIEW_08: "{0} الاسم {1} لا يتوافق مع القواعد. {2}.",
  T_38_SP_WS_REVIEW_09: "سلسلة",
  T_38_SP_WS_REVIEW_10: "متجر",
  T_38_SP_WS_REVIEW_11: "عامل",
  T_38_SP_WS_REVIEW_12: "وظيفة",
  T_38_SP_WS_REVIEW_13: "العنصر",
  T_38_SP_WS_REVIEW_14: "اذهب إلى التعريف.",
  T_38_SP_WS_REVIEW_15: "اذهب إلى إدارة العناصر.",
  T_38_SP_WS_REVIEW_16: "لا توجد إعادة توجيه.",
  T_38_SP_WS_REVIEW_17: "اسم الخريطة",
  T_38_SP_WS_REVIEW_18: "الوصف",
  T_38_SP_WS_REVIEW_19: "صورة الغلاف",
  T_38_SP_WS_REVIEW_20: "يحتوي النص على كلمات حساسة.",
  T_38_SP_WS_REVIEW_21: "فشل الحفظ. تعذر المراجعة.",
  T_38_SP_WS_REVIEW_22: "مراجعة تحت فترة التهدئة.",
  T_38_SY_BASEBALLBAT_KITCHEN_N: "مضرب - الخادمة",
  T_38_SY_CHARACTER_DESIGNER_N: "سانتينو",
  T_38_SY_PET_CACTUS_N: "صبار",
  T_38_SY_PETSKIN_CACTUS_BLACK_N: "سكن الحيوان الأليف: صبار الشبح",
  T_38_SY_PETSKIN_CACTUS_PINK_N: "سكن الحيوان الأليف: صبار النيون",
  T_38_SY_PETSKIN_CACTUS_YELLOW_N: "سكن الحيوان الأليف: صبار النخيل",
  T_38_SY_PETSKIN_FLYINGCREATURE_ES_N: "سكن الحيوان الأليف: حفلة أرفون",
  T_38_SY_PETSKIN_RACCOON_MO_N: "سكن الحيوان الأليف: روكي عصري",
  T_38_SY_SCAR_ELDERGODS_N: "SCAR - ملك الناري",
  T_38_SY_SICKLE_ES_N: "منجل - بوب باو",
  T_38_SY_VEHICLE_SUV_KITCHEN_N: "شاحنة - طعام موتشي",
  T_38_WT_WS_MUITLEVEL: "متعدد المستويات",
  T_38_WT_WS_SKILLSET15: "إثارة المعركة (A124)",
  T_38_WT_WS_SKILLSET16: "موجة الصدمة الحواس (هومر)",
  T_38_WT_WS_SKILLSET17: "خلف الجدار (آيريس)",
  T_38_WT_WS_SKILLSET18: "اندفاع المتمرد (تاتسويا)",
  T_38_WZY_WS_ACTIVEA: "صالحة للاستعمال في المشهد أم لا",
  T_38_WZY_WS_ACTIVEB: "قم بتشغيل تحديث المنطق أم لا",
  T_38_WZY_WS_ACTIVEVALUE: "حالة النشاط",
  T_38_WZY_WS_AIR: "هواء",
  T_38_WZY_WS_ALLOWMOVE: "متحرك أم لا",
  T_38_WZY_WS_AMMOAMOUNT: "كمية الذخيرة",
  T_38_WZY_WS_AMMONAME: "كيان الذخيرة",
  T_38_WZY_WS_ARMOR_DAMRED: "مضاعف تقليل الضرر",
  T_38_WZY_WS_ARMOR_DAMRED_EXP: "مضاعف تقليل الضرر الانفجار",
  T_38_WZY_WS_ARMOR_DURABILITY: "المتانة الحالية",
  T_38_WZY_WS_ARMOR_DURABILITYMAX: "أقصى قدر من المتانة",
  T_38_WZY_WS_ARMOR_ISDAMAGE: "قابلة للضرر أو لا",
  T_38_WZY_WS_ARMOR_ISDESTROY: "قابلة للتدمير أم لا",
  T_38_WZY_WS_ARMOR_LEVEL: "المستوى",
  T_38_WZY_WS_ASSCONZOM: "مساعدة القضاء على الزومبي.",
  T_38_WZY_WS_BAGNAME: "كيان حقيبة الظهر",
  T_38_WZY_WS_BAGSPACEEX: "مساحة إضافية لحقيبة الظهر",
  T_38_WZY_WS_BRIDGING: "مكون تجسيد الجسر",
  T_38_WZY_WS_BUBBLE: "فقاعة",
  T_38_WZY_WS_CLEARBAG_NAMEDESC: "امسح كل العناصر الموجودة في حقيبة ظهر [كيان اللاعب]",
  T_38_WZY_WS_CLEARMAP_NAMEDESC: "امسح العناصر غير المرغوب فيها الموجودة حول الخريطة، مثل الغنائم والمواد القابلة للرمي وصناديق الغنائم",
  T_38_WZY_WS_CLEARPRO: "امسح عامل الملكية الفردية",
  T_38_WZY_WS_CLONEOBJ_NAMEDESC: "استنساخ كيان [عنصر المشهد] في موقع [كيان اللاعب] وأعد [كيان التمويه]",
  T_38_WZY_WS_COMPONENT: "المكون",
  T_38_WZY_WS_COSTAMMO: "تستهلك الذخيرة",
  T_38_WZY_WS_CRECREMA_NAMEDESC: "أنشئ كاميرا وأعد [كيان الكاميرا]، الذي يمكن تعديل خصائصه من خلال إعدادات الخاصية",
  T_38_WZY_WS_CYCLES: "مرات اللعب",
  T_38_WZY_WS_CYLINDERJUD_NAMEDESC: "تحقق مما إذا كان [كيان] داخل نطاق قطب دائري. [المركز] هو مركز القطب، [نصف القطر] هو نصف قطر السطح الدائري، [الارتفاع] هو ارتفاع القطب، [زوايا أويلر] هي زوايا الاتجاه ثلاثي الأبعاد للقطب.",
  T_38_WZY_WS_CYLINDERJUD_RES: "نتيجة فحص نطاق القطب الدائري. هذه قيمة منطقية.",
  T_38_WZY_WS_DAMSUMZOM: "الضرر الذي يلحق بالزومبي",
  T_38_WZY_WS_DARKNESS: "الظلام",
  T_38_WZY_WS_DIFCOLOR: "لون السطح",
  T_38_WZY_WS_DIFTEXTURE: "نسيج السطح",
  T_38_WZY_WS_DRUMMUSIC: "نوع المكون: الطبول",
  T_38_WZY_WS_ENTITY_PLAYERDISDESC: "اللاعب الذي تم قطع الاتصال به",
  T_38_WZY_WS_ENTITY_PLAYERRECDESC: "اللاعب الذي يعيد الاتصال",
  T_38_WZY_WS_EUIANCHOR: "تعداد نوع مرساة HUD",
  T_38_WZY_WS_FEATHER: "ريشة",
  T_38_WZY_WS_FLAMEAMMO: "ذخيرة قاذف اللهب",
  T_38_WZY_WS_FLOWER: "زهرة",
  T_38_WZY_WS_FOLLOW_NAMEDESC: "قم بتعيين [الكيان] ليتبع دائمًا [الكيان المتبع]. [إحداثيات الإزاحة] هي المسافة بين الكيانين.",
  T_38_WZY_WS_FOLLOWENT: "الكيان المتبع",
  T_38_WZY_WS_GETCURCAM_NAMEDESC: "احصل على كيان الكاميرا الذي يتم استخدامه حاليًا بواسطة [كيان اللاعب]",
  T_38_WZY_WS_GETCURCAMDESC: "الكاميرا التي يستخدمها اللاعب حاليًا",
  T_38_WZY_WS_GETITEMNUM_NAMEDESC: "احصل على مبلغ عنصر في [نوع العنصر المعين] الذي يمتلكه [اللاعب]",
  T_38_WZY_WS_GETITEMNUM_RES: "مقدار العنصر المعين الذي يمتلكه اللاعب",
  T_38_WZY_WS_GETVEC_NAME: "احصل على متجه",
  T_38_WZY_WS_GETVEC_NAMEDESC: "احصل على متجه باستخدام مكونات س و ص و ض لمجموعة إحداثيات",
  T_38_WZY_WS_GETVECRES: "المتجه الذي تم الحصول عليه من مكونات س و ص و ض",
  T_38_WZY_WS_GHOST: "شبح",
  T_38_WZY_WS_GRENADEFROZENNAME: "كيان فلاش المتجمد",
  T_38_WZY_WS_GRENADEFROZENPARAM1: "قطر منطقة الوقف",
  T_38_WZY_WS_GRENADEFROZENPARAM2: "مدة الوقف",
  T_38_WZY_WS_GRENADENAME: "كيان القنبلة",
  T_38_WZY_WS_GRENADEPARAM1: "الحد الأدنى من الضرر",
  T_38_WZY_WS_GRENADEPARAM2: "أقصى ضرر",
  T_38_WZY_WS_GRENADEPARAM4: "نطاق الانفجار",
  T_38_WZY_WS_GRENADEPARAM5: "سرعة الرمية",
  T_38_WZY_WS_GRENADEPARAM6: "تأخير الانفجار",
  T_38_WZY_WS_GRENADEPARAM7: "مضاعف الضرر الذاتي",
  T_38_WZY_WS_GRENADEPARAM8: "مضاعف حليف الضرر",
  T_38_WZY_WS_GRENADEPARAM9: "مضاعف ضرر المركبة",
  T_38_WZY_WS_GUNFIRE: "إطلاق النار",
  T_38_WZY_WS_GUNPRO_PARAM2: "سرعة إعادة التحميل",
  T_38_WZY_WS_GUNPRO_PARAM3: "معدل ضرر طلقات الجسم",
  T_38_WZY_WS_GUNPRO_PARAM4: "معدل ضرر طلقات الرأس",
  T_38_WZY_WS_GUNPRO_PARAM5: "معدل ضرر طلقات الأطراف",
  T_38_WZY_WS_GUNPRO_PARAM7: "ضرر إضافي",
  T_38_WZY_WS_HELMET_NAME: "كيان الخوذة",
  T_38_WZY_WS_ICON1: "تاج",
  T_38_WZY_WS_ICON2: "مبارزة",
  T_38_WZY_WS_INITPOS: "الموقع البداية",
  T_38_WZY_WS_ISRESET: "الحركة الترددية",
  T_38_WZY_WS_KILLCONZOM: "عدد الزومبي تم القضاء عليهم",
  T_38_WZY_WS_KILLENT_NAMEDESC: "قم بالقضاء على [الكيان] المختار، والذي يجب أن يكون من نوع كيان معركة. يتجاهل الوضع المنيع.",
  T_38_WZY_WS_LABELPARAM: "قائمة معلمات محتوى النص",
  T_38_WZY_WS_LEADMUSICA: "نوع المكون: بيانو (تريبل)",
  T_38_WZY_WS_LEADMUSICB: "نوع المكون: بيانو (ألتو)",
  T_38_WZY_WS_LEADMUSICC: "نوع المكون: بيانو (باس)",
  T_38_WZY_WS_LINE: "خط",
  T_38_WZY_WS_LIQUID: "سائل",
  T_38_WZY_WS_LOCALKEY: "مفتاح محلي",
  T_38_WZY_WS_LOCALPOS: "الموقع النسبي",
  T_38_WZY_WS_LOOKAT_NAMEDESC: "قم بتعيين [كيان] لمواجهة [الكيان المستهدف]. [إحداثيات الإزاحة] هو الاختلاف في إحداثيات النقطة المستهدفة وموقع الكيان.",
  T_38_WZY_WS_MAINWEAPONA: "السلاح الرئيسي 1",
  T_38_WZY_WS_MAINWEAPONB: "السلاح الرئيسي 2",
  T_38_WZY_WS_MOTIONTIME: "مدة الحركة",
  T_38_WZY_WS_MOTIONTYPE: "طريقة الحركة",
  T_38_WZY_WS_MUSHROOM_EPMODIFY: "نقاط الخبرة المعدلة",
  T_38_WZY_WS_MUSHROOMNAME: "كيان الفطر",
  T_38_WZY_WS_OBFACTION: "اطلع على الفصيل",
  T_38_WZY_WS_OBGLOBAL: "اطّلع على الجميع",
  T_38_WZY_WS_OBSERVER: "خيارات المتفرج",
  T_38_WZY_WS_OBTEAM: "اطلع على الفريق",
  T_38_WZY_WS_OFFSETVEC: "الإحداثيات الإزاحة",
  T_38_WZY_WS_ONBUY_NAMEDESC: "تنطلق عندما يشتري اللاعب عناصر من هذه آلة البيع. [كيان اللاعب] هو اللاعب الذي يقوم بالشراء. [كيان البضائع] هو العنصر الذي تم شراؤه.",
  T_38_WZY_WS_ONEQUIPED_NAMEDESC: "تنطلق عند التجهيز بواسطة [كيان اللاعب]",
  T_38_WZY_WS_ONJUMP_NAMEDESC: "تنطلق عندما يكمل اللاعب حركة القفز",
  T_38_WZY_WS_ONLIE_NAMEDESC: "تنطلق عندما يكمل اللاعب وضعية الانبطاح",
  T_38_WZY_WS_ONRELOAD_NAMEDESC: "تنطلق عند إعادة تحميل السلاح",
  T_38_WZY_WS_ONSPRINT_NAMEDESC: "تنطلق عندما يكمل اللاعب إجراء الركض",
  T_38_WZY_WS_ONSQUAT_NAMEDESC: "تنطلق عندما يكمل اللاعب حركة الانحناء",
  T_38_WZY_WS_ONWAEPKILL_NAMEDESC: "تنطلق عندما يقضي السلاح على وحدة. [الكيان المحذوف] هو الوحدة التي تم القضاء عليها.",
  T_38_WZY_WS_ONWEAPDAMAGE_NAMEDESC: "تنطلق عندما يلحق السلاح ضررًا بكيان المعركة. [هدف الضربة] هو كيان المعركة الذي تم إلحاق الضرر به. [الضرر] هو الضرر الذي يحدث.",
  T_38_WZY_WS_OWNER: "مالك",
  T_38_WZY_WS_PARAMLIST: "قائمة المعلمات",
  T_38_WZY_WS_PARTICALMAP: "رسم خرائط الجسيمات",
  T_38_WZY_WS_PAUSEMOTE_NAMEDESC: "أوقف مؤقتًا أو استأنف الرقصة الحالية لـ [كيان اللاعب]. [وقفة أم لا] هي قيمة منطقية. نعم يعني وقفة. لا يعني استئناف.",
  T_38_WZY_WS_PLAENTTRI_DESC: "يتم تنشيطه عن طريق دخول اللاعب إلى الزناد",
  T_38_WZY_WS_PLAQUITTRI_DESC: "يتم تنشيطه من قبل اللاعب الذي يترك الزناد",
  T_38_WZY_WS_PLAYEMOTE_NAMEDESC: "اجبر [كيان اللاعب] على تشغيل [الرقصة] المعينة مرة واحدة والعودة إلى المركز الأصلي عند الانتهاء",
  T_38_WZY_WS_PLAYSPEED: "نسبة سرعة التشغيل",
  T_38_WZY_WS_PREHUD_NAME: "أيقونة الإعداد المسبق",
  T_38_WZY_WS_QUITFACTION_NAMEDESC: "دع [كيان اللاعب] يغادر فصيله الحالي",
  T_38_WZY_WS_RESETENT: "أعد تعيين المكونات في كل جولة",
  T_38_WZY_WS_RESUUID: "الموارد UUID",
  T_38_WZY_WS_RIMCOLOR: "لون الحدود",
  T_38_WZY_WS_RIMTEXTURE: "نسيج الحدود",
  T_38_WZY_WS_SECTORJUD_NAMEDESC: "تحقق مما إذا كان [كيان] داخل مخروط. [المركز] و [نصف القطر] هما مركز ونصف قطر المخروط. [نصف القطر المستخرج] هو نصف قطر القطاع الأصغر داخل المخروط. الارتفاع هو ارتفاع الهيكل ثلاثي الأبعاد. [الزاوية] هي الزاوية المركزية للمخروط. [زاوية الاتجاه] هي متجه اتجاه المحور المركزي.",
  T_38_WZY_WS_SECTORJUD_RES: "نتيجة فحص النطاق على شكل مروحة. هذه قيمة منطقية.",
  T_38_WZY_WS_SETACTIVE_NAMEDESC: "عيّن حالة نشاط [الكيان المستهدف]. [حالة النشاط] هي قيمة منطقية وتؤثر على مدى توفر الكيان ورؤيته وقابلية تصادمه.",
  T_38_WZY_WS_SETROUNDSCORE: "حدد نتيجة جولة اللاعب",
  T_38_WZY_WS_SHOOTANGMAX: "زاوية التصويب القصوى",
  T_38_WZY_WS_SHOWMAPINFO: "عرض معلومات الخريطة لنفس الفصيل",
  T_38_WZY_WS_SHOWNAMEHUD: "عرض اسم HUD لنفس الفصيل",
  T_38_WZY_WS_SOUND1: "التسريع",
  T_38_WZY_WS_SOUND10: "بداية المرحلة",
  T_38_WZY_WS_SOUND11: "الزومبي",
  T_38_WZY_WS_SOUND12: "رعب",
  T_38_WZY_WS_SOUND13: "تحول",
  T_38_WZY_WS_SOUND14: "قصف القلب",
  T_38_WZY_WS_SOUND15: "نبضات قلب متوسطة",
  T_38_WZY_WS_SOUND16: "نبضات قلب بطيئة",
  T_38_WZY_WS_SOUND17: "وقت الذروة",
  T_38_WZY_WS_SOUND18: "انقر",
  T_38_WZY_WS_SOUND19: "استرداد المهارة",
  T_38_WZY_WS_SOUND2: "إختفاء الإشعار",
  T_38_WZY_WS_SOUND20: "انضم إلى لعبة",
  T_38_WZY_WS_SOUND3: "تأثيرات بصرية",
  T_38_WZY_WS_SOUND4: "زقزقة ليلية",
  T_38_WZY_WS_SOUND5: "ضرب (صريح)",
  T_38_WZY_WS_SOUND6: "تفاعل",
  T_38_WZY_WS_SOUND7: "البحث المفاجئ",
  T_38_WZY_WS_SOUND8: "الظهور",
  T_38_WZY_WS_SOUNDENT: "كيان الموسيقى",
  T_38_WZY_WS_SPAWNPOS: "نقطة الإنعاش القديمة",
  T_38_WZY_WS_SPHERENAME: "الكرة الأساسية",
  T_38_WZY_WS_SPHERERADIUS: "نصف قطر الكرة",
  T_38_WZY_WS_SPHERICALJUD_NAMEDESC: "تحقق مما إذا كان [كيان] داخل نطاق كروي. [المركز] و [نصف القطر] هو مركز ونصف قطر الهيكل الكروي.",
  T_38_WZY_WS_SPHERICALJUD_RES: "نتيجة فحص النطاق الكروي. هذه قيمة منطقية.",
  T_38_WZY_WS_SQUAREJUD_NAMEDESC: "تحقق مما إذا كان [كيان] داخل نطاق المكعب. [المركز] هو مركز المكعب، ويمثل [الطول] و [العرض] و [الارتفاع] طول المكعب وعرضه وارتفاعه، و [زوايا أويلر] هي زوايا الاتجاه ثلاثي الأبعاد للمكعب.",
  T_38_WZY_WS_SQUAREJUD_RES: "نتيجة فحص النطاق المكعبي. هذه قيمة منطقية.",
  T_38_WZY_WS_STARTGENTIME: "وقت بدء التظهر",
  T_38_WZY_WS_STAYTIME: "مدة إيقاف مؤقت",
  T_38_WZY_WS_SWITCHCAM_NAMEDESC: "تبديل كاميرا اللاعب إلى [كيان الكاميرا]. يمكن أن يكون [وضع التبديل] إما بدون رسوم متحركة أو حركة تقدمية. [وقت التبديل] هو وقت التبديل أثناء الوضع التقدمية.",
  T_38_WZY_WS_SWITCHCAM_PARAM3_DESC: "تبديل وضع الكاميرا. يمكنك الاختيار بين بلا رسوم متحركة وحركة تقدمية.",
  T_38_WZY_WS_SWITCHCAM_PARAM4_DESC: "وقت التبديل أثناء وضع الحركة التقدمية. عند تحديد لا توجد رسوم متحركة، يكون هذا الإعداد باطلاً.",
  T_38_WZY_WS_TEXTHUD: "مكون نص HUD",
  T_38_WZY_WS_TEXTTYPE: "حجم الخط",
  T_38_WZY_WS_TEXTUREID: "نوع الملمس",
  T_38_WZY_WS_TRANDIST: "المسافة القصوى",
  T_38_WZY_WS_TWEENERENABLED: "تشغيل نص UITweener أم لا",
  T_38_WZY_WS_TYPELIST: "قائمة النوع",
  T_38_WZY_WS_TYPELISTORLIST: "النوع أو قائمة النوع",
  T_38_WZY_WS_VEST_NAME: "كيان السترة",
  T_38_WZY_WS_VFX1: "مخفي القضاء",
  T_38_WZY_WS_VFX10: "الاحتراق الدوري",
  T_38_WZY_WS_VFX11: "غاز سام",
  T_38_WZY_WS_VFX13: "قلب",
  T_38_WZY_WS_VFX15: "باب",
  T_38_WZY_WS_VFX2: "الإبادة",
  T_38_WZY_WS_VFX3: "استنساخ القضاء",
  T_38_WZY_WS_VFX4: "رد فعل الضرب",
  T_38_WZY_WS_VFX5: "استنسخ",
  T_38_WZY_WS_VFX6: "تمويه",
  T_38_WZY_WS_VFX7: "شرار المتفجر",
  T_38_WZY_WS_VFX8: "درب الحركة",
  T_38_WZY_WS_VFX9: "الشحن الناري",
  T_38_WZY_WS_VFXENT: "مثيل التأثير البصري",
  T_38_WZY_WS_VFXTYPEA_NAME: "التأثيرات البصرية لرسم الخرائط القابلة للتخصيص",
  T_38_WZY_WS_VFXTYPEB_NAME: "التأثيرات البصرية لرسم الخرائط غير القابلة للتخصيص",
  T_38_WZY_WS_VISIBILITY: "نوع الرؤية",
  T_38_WZY_WS_VOLUME: "صوت",
  T_38_WZY_WS_WEAPONGEN: "مولد السلاح",
  T_38_WZY_WS_WHECYCLE: "إعادة التشغيل",
  T_38_XXJ_WS_BLOCKMODE: "الوضع المحظور",
  T_38_XXJ_WS_CUSTOMCAMARA: "تخصيص الكاميرا",
  T_38_XXJ_WS_FFCLASSIC: "فري فاير الكلاسيكية (اطلاق النار)",
  T_38_XXJ_WS_FOV: "مجال الرؤية",
  T_38_XXJ_WS_FOVDESC: "مجال الرؤية هو النطاق الذي يمكن ملاحظته للكاميرا.",
  T_38_XXJ_WS_FPS: "الشخص الأول (إطلاق النار)",
  T_38_XXJ_WS_HORIZONTALANGLE: "زاوية أفقية",
  T_38_XXJ_WS_INVISICAM: "شبه شفاف",
  T_38_XXJ_WS_OFFSET: "إزاحة",
  T_38_XXJ_WS_ORTHOGRAPHIC: "الهجاء",
  T_38_XXJ_WS_PERSPECTIVE: "منظور",
  T_38_XXJ_WS_PROJECTIONMODE: "وضع تقني",
  T_38_XXJ_WS_STABLE: "ثابت",
  T_38_XXJ_WS_STARTCAMERA: "الكاميرا الافتراضية",
  T_38_XXJ_WS_STARTCAMERAMODE: "وضع الكاميرا الافتراضي",
  T_38_XXJ_WS_THIRD: "تتبع الكاميرا",
  T_38_XXJ_WS_TOPVIEW: "زاوية عالية",
  T_38_XXJ_WS_TPS: "الشخص الثالث",
  T_38_XXJ_WS_TRANSVERSE: "حركة أفقية",
  T_38_XXJ_WS_VERTICALANGLE: "زاوية عمودية",
  T_38_XXJ_WS_ZOOM: "تكبير",
  T_38_XYL_WS_AISTARTTIME: "وقت البدء (ث)",
  T_38_XYL_WS_ARMORDESTROY: "مضاعف ضرر الدروع",
  T_38_XYL_WS_BONFIRE: "الشعلة",
  T_38_XYL_WS_CANDLE01: "الشمعة A",
  T_38_XYL_WS_CANNON01: "مدفع ميكانيكي",
  T_38_XYL_WS_CLIPAMMOSIZE: "تخزين الذخيرة",
  T_38_XYL_WS_DAMAGEDTRUCK: "الشاحنة التالفة",
  T_38_XYL_WS_DOLL01: "دمية غامضة",
  T_38_XYL_WS_ENTERANCEHOUSE01: "منزل من الطوب A",
  T_38_XYL_WS_FENCE002: "سياج معدني B",
  T_38_XYL_WS_FIREWORK01: "الألعاب النارية A",
  T_38_XYL_WS_GENERATOR: "مولد",
  T_38_XYL_WS_GRAVITY: "تسارع الجاذبية",
  T_38_XYL_WS_GRAVITYAREA: "منطقة الجاذبية غير الطبيعية",
  T_38_XYL_WS_GRAVITYAREA_DESC: "منطقة حيث يمكن للاعبين تغيير الجاذبية",
  T_38_XYL_WS_HOLDWEAPON: "عقد السلاح",
  T_38_XYL_WS_INDOORFURNITURE: "أثاث داخلي",
  T_38_XYL_WS_LIGHTTUBE001: "ضوء الأنبوب A",
  T_38_XYL_WS_LOVEBALLOON01: "بالون عيد الحب A",
  T_38_XYL_WS_LOVELAMP01: "ضوء شارع القلب",
  T_38_XYL_WS_LOVESIGN01: "حب الأضواء النيون",
  T_38_XYL_WS_OILDRUM_DAMAGE: "معدل ضرر برميل النفط",
  T_38_XYL_WS_OUTDOORPROPS: "العناصر الخارجية",
  T_38_XYL_WS_PIPEANDBOX: "الأنابيب والصناديق",
  T_38_XYL_WS_PLANT: "النباتات",
  T_38_XYL_WS_ROSE01: "الوردة",
  T_38_XYL_WS_ROSEN: "باقة الورد",
  T_38_XYL_WS_SMALLBUILDING: "المباني الصغيرة",
  T_38_XYL_WS_SOFA002: "كنبة B",
  T_38_XYL_WS_TOWNHOUSE01: "منزل قديم من طابقين",
  T_38_XYL_WS_TV001: "تلفزيون قديم",
  T_38_ZP_CC_EXCHANGESTATUS: "الحالة",
  T_39_BQ_SKILL_NAME_VILLAIN: "قرمزي كراش",
  T_39_CJ_A_BURN: "قناع النصر",
  T_39_HJ_WS_Arrow002: "السهم 2",
  T_39_HJ_WS_LIKERATE2: "{0} دقيقة",
  T_39_HJ_WS_LIKERATE3: "{0} - {1} دقيقة",
  T_39_HJ_WS_SOUND10: "خطوة",
  T_39_HJ_WS_SOUND11: "المهمة المكتملة 1",
  T_39_HJ_WS_SOUND13: "تنبيه الخطر 1",
  T_39_HJ_WS_SOUND14: "تنبيه الخطر 2",
  T_39_HJ_WS_SOUND15: "العد التنازلي 3",
  T_39_HJ_WS_SOUND16: "نصائح الصوت",
  T_39_HJ_WS_SOUND17: "نعيق الغراب",
  T_39_HJ_WS_SOUND18: "صوت النقل الآني إلى منطقة خاطئة",
  T_39_HJ_WS_SOUND19: "صوت الانتقال الفضائي إلى منطقة صحيحة",
  T_39_HJ_WS_SOUND2: "العد التنازلي 1",
  T_39_HJ_WS_SOUND20: "النقل الآني",
  T_39_HJ_WS_SOUND21: "الصدمة الكهربائية",
  T_39_HJ_WS_SOUND23: "الحصول على عنصر",
  T_39_HJ_WS_SOUND24: "موسيقى خلفية إلكترونية وجذابة",
  T_39_HJ_WS_SOUND25: "موسيقى خلفية لعبة كلاسيكية",
  T_39_HJ_WS_SOUND4: "صدى الجهاز الميكانيكي",
  T_39_HJ_WS_SOUND5: "البعوض",
  T_39_HJ_WS_SOUND6: "دينغ دينغ دينغ 1",
  T_39_HJ_WS_SOUND7: "دينغ دينغ دينغ 2",
  T_39_HJ_WS_SOUND8: "تم تشغيل العتاد",
  T_39_HJ_WS_SOUND9: "الشحن 1",
  T_39_HJ_WS_UNLIMITEDGLOOWALL: "جدران جلو غير محدودة",
  T_39_HJ_WS_UNLIMITEDTHROWABLES: "مواد قابلة للرمي غير محدودة",
  T_39_HQ_EVOGUN2_SOUNDEQUIP3: "صوت الإطلاق النار الخاص",
  T_39_HQ_UGC_CUSTOMRES: "الموارد المخصصة",
  T_39_M_ACCOUNTID: "حساب",
  T_39_M_WS_BUTTON_DOUBLECLICKDESC: "نفذ بعد النقر المزدوج",
  T_39_MF_SKILLTAG_4: "حركة",
  T_39_PD_HuntingGroundSnow_MYNAME: "السيد V",
  T_39_QL_SKILL_OTHO_DES: "بعد إسقاط العدو، يحدد زملائهم في الفريق في نطاق [FFB300]{0}م[-] من العدو ويبطئ سرعة حركتهم بنسبة [FFB300]{1}%[-]. يستمر لمدة [FFB300]{2}ث[-]. عندما سقوطك من قبل عدو قريب، يحدد ويبطئ المهاجم وزملائه.",
  T_39_QL_SKILL_WOLFRAHH_DES: "بعد إسقاط العدو، أدخل إلى وضع التمييز، الذي يزيد من معدل إطلاق النار بنسبة [FFB300]{0}%[-] وسرعة الحركة بنسبة [FFB300]{1}%[-] ولكن بعد ذلك يتحلل بسرعة. يدوم لمدة [FFB300]{2}ث[-]. أثناء وضع التمييز، سيؤدي إسقاط الأعداء على التوالي إلى إعادة ضبط العد التنازلي وزيادة معدل إطلاق النار بنسبة [FFB300]{3}%[-] وسرعة الحركة بنسبة [FFB300]{4}%[-].",
  T_39_QL_SKILL_XAYNE_DES1: "وضع اكستريم: احصل على [FFB300]{0} نقاط صحة مؤقتة[-] لمدة [FFB300]{1}ث[-]. خلال هذا الوقت، تتحسن تأثيرات علاج نقاط الصحة بنسبة [FFB300]{2}%[-]. وقت التهدئة: [FFB300]{3}ث[-].",
  T_39_RW_GM_DEFEAT: "فشل",
  T_39_RW_SKILL_DESC_FORD: "اكتسب [FFB300]{1} نقاط صحة في الثانية[-] لمدة [FFB300]{0}ث[-] عند تتعرض للضرر. بعد تحرير مهارة نشطة، ستتم إعادة تعيين هذه المهارة الثانوية على الفور. التهدئة: [FFB300]{2}ث[-].",
  T_39_SP_WS_ITEMENTITY_01: "كيان العنصر",
  T_39_SY_CHARACTER_ALVARO_AWAKENING_N: "انفجار غضب ألفارو",
  T_39_SY_CHARACTER_VILLAIN_N: "أوريون",
  T_39_SY_KATANA_FASTBREAKING23_N: "كاتانا - ألف ليلة وليلة",
  "T_39_SY_PETSKIN_FLYINGCREATURE_FB23 _N": "سكن الحيوان الأليف: أرفون الأخضر",
  "T_39_SY_PETSKIN_TIGER_BDFEST _N": "سكن الحيوان الأليف: النمر الملكي",
  "T_39_SY_PETSKIN_WOLF_SCARLET _N": "سكن الحيوان الأليف: فانغ العقرب",
  T_39_SY_VEHICLESKIN_MONSTER_TRUCK_FASTBREAKING23_N: "شاحنة متوحشة - العملاق الأخضر",
  T_39_SY_VEHICLESKIN_TUTU_BDFEST_N: "سيارة توك توك - مركبة مزهرة",
  T_39_WH_SKILL_DESC_GRENADESPLIT: "الصحوة: [FFB300]{0}ث[-] قبل التفجير، تنتج القنبلة إلى [FFB300]{1}[-] قنابل إضافية، والتي يمكن أن تسبب [FFB300]{2}%[-] من الضرر الأصلي.",
  T_39_WH_SKILL_NAME_GRENADESPLIT: "فاصل الانفجار",
  T_39_WT_WS_EMPTYMAP_TAG: "المساحة الفارغة",
  T_39_WT_WS_FEMAPMODE: "وضع اللقب",
  T_39_WT_WS_FEMAPTAG: "علامة الخريطة",
  T_39_WT_WS_MAPPLAYER: "عدد اللاعبين",
  T_39_WT_WS_MEDENTERNUM: "حد عدد اللاعب المنضم في منتصف اللعبة",
  T_39_WT_WS_MIDENTER: "الانضمام في منتصف اللعبة",
  T_39_WT_WS_MIDENTERCOUNT: "حصة الانضمام في منتصف المباراة",
  T_39_WT_WS_MIDENTERTIME1: "المهلة الزمنية للانضمام في منتصف اللعبة",
  T_39_WT_WS_MIDENTERTIME2: "مدة الانضمام في منتصف اللعبة",
  T_39_WT_WS_MIDENTERTIMETIP: "عندما لا يتم الوصول إلى حد عدد لاعبي الخريطة، قم بتمكين اللاعبين من الانضمام في غضون N ثانية بعد بدء المباراة. لا يمكن للاعبين الانضمام بعد N ثانية.",
  T_39_WT_WS_MIDENTERTIP: "عند التمكين، يمكن للاعبين الانضمام إلى هذه الخريطة في منتصف اللعبة",
  T_39_WT_WS_PLAYERCOUNT: "رقم اللاعب الأولي",
  T_39_WT_WS_PLAYERCOUNTTIP: "عدد اللاعب عند بدء المباراة. يمكن لمزيد من اللاعبين الانضمام في منتصف اللعبة حتى تصل إلى حد الخريطة.",
  T_39_WT_WS_TAG1: "قتل الجميع",
  T_39_WT_WS_TAG10: "سهل",
  T_39_WT_WS_TAG11: "متوسط",
  T_39_WT_WS_TAG12: "صعب",
  T_39_WT_WS_TAG13: "تحديا كبيرا",
  T_39_WT_WS_TAG14: "هاربة",
  T_39_WT_WS_TAG16: "VIP",
  T_39_WT_WS_TAG17: "الموارد المخصصة",
  T_39_WT_WS_TAG18: "الألغاز",
  T_39_WT_WS_TAG19: "سباق",
  T_39_WT_WS_TAG2: "اطلاق النار",
  T_39_WT_WS_TAG20: "موسيقى",
  T_39_WT_WS_TAG21: "موبا",
  T_39_WT_WS_TAG22: "مغامرة",
  T_39_WT_WS_TAG23: "مطاردة الزومبي",
  T_39_WT_WS_TAG24: "لاعب ضد لاعب",
  T_39_WT_WS_TAG25: "لعبة الحفلة",
  T_39_WT_WS_TAG26: "الماتش القاتل",
  T_39_WT_WS_TAG27: "برج الدفاع",
  T_39_WT_WS_TAG28: "تدريب",
  T_39_WT_WS_TAG3: "ملك الأسلحة",
  T_39_WT_WS_TAG4: "إعادة إحياء",
  T_39_WT_WS_TAG5: "قناص",
  T_39_WT_WS_TAG6: "نجاة",
  T_39_WT_WS_TAG7: "فردي",
  T_39_WT_WS_TAG8: "رعب",
  T_39_WT_WS_TAG9: "كلاسيكي",
  T_39_WT_WS_TAGMAXTIP: "حدد ما يصل إلى {0} علامة",
  T_39_WT_WS_TAGTYPE1: "نوع اللعب",
  T_39_WT_WS_TAGTYPE2: "نوع الخريطة",
  T_39_WT_WS_TAGTYPE3: "نوع الوضع",
  T_39_WT_WS_TAGTYPE4: "حجم الفريق",
  T_39_WZY_WS_ACCSPEED: "التسريع",
  T_39_WZY_WS_ADDSCRIPT_NAMEDESC: "أضف النص [اسم النص] لـ [الكيان]",
  T_39_WZY_WS_ASC: "تصاعدي",
  T_39_WZY_WS_ASCIGZERO: "تجاهل الصفر باستخدام تصاعدي",
  T_39_WZY_WS_BALLISTMOVENT: "كيان الحركة المقذوفات",
  T_39_WZY_WS_BEUSED_NAMEDESC: "يطلق حادث عندما يتم استخدام العنصرر بواسطة [كيان اللاعب]",
  T_39_WZY_WS_BODYSCALE: "مقياس الجسم",
  T_39_WZY_WS_BRAKETORQUE: "قوة حصان الفرامل",
  T_39_WZY_WS_CAMTRANTYPE: "نوع انتقال الكاميرا",
  T_39_WZY_WS_CARVEHICLE: "4-عجلات",
  T_39_WZY_WS_CHECKSCRIPT_NAMEDESC: "تحقق مما إذا كان النص المحدد [اسم النص] موجودًا في [الكيان]. (يجب أن تكون القيمة التي تم إرجاعها منطقية)",
  T_39_WZY_WS_CHECKSCRIPT_RES: "تحقق مما إذا كان الكيان لديه نتيجة النص المحدد (منطقي)",
  T_39_WZY_WS_COMBINEALL: "استخدام مزدوج (أسلحة مختلفة)",
  T_39_WZY_WS_COMBINESELF: "استخدام مزدوج (نفس السلاح)",
  T_39_WZY_WS_CONENAME: "المخروط الأساسي",
  T_39_WZY_WS_COORSYS: "نظام الإحداثيات",
  T_39_WZY_WS_CRASHMAXD: "الحد الأقصى من ضرر التصادم",
  T_39_WZY_WS_CRASHMIND: "الحد الأدنى من ضرر التصادم",
  T_39_WZY_WS_CRAWLSPEED: "نسبة سرعة الحركة (الانبطاح)",
  T_39_WZY_WS_CREBALLISTMOV_NAMEDESC: "أنشئ حركة المقذوفات لـ [الكيان المستهدف]. يمكن تحرير [السرعة الأولية] و [التسريع] و [المسافة القصوى] المتراكمة في اتجاه السرعة الأولية للكيان المستهدف، وإرجاع [كيان الحركة المقذوفات]",
  T_39_WZY_WS_CRETWEEN_NAME: "أنشئ حركة الاستيفاء",
  T_39_WZY_WS_CRETWEEN_NAMEDESC: "قم بإنشاء حركة استيفاء لـ [الكيان]، مع انتقال [سمات] الكيان بسلاسة من [قيمة البداية] إلى [القيمة المستهدفة] خلال [الوقت]. تمثل [الطريقة] طريقة الحركة ، بما في ذلك [اتجاه واحد]، [بينج بونج]، [دورة]. [المنحنى] هو منحنى الحركة. وسيتم إرجاع [كيان حركة الاستيفاء] بعد إنشاء الحركة.",
  T_39_WZY_WS_CURVE: "المنحنى",
  T_39_WZY_WS_CUSTRESULT: "نتيجة المباراة المخصصة",
  T_39_WZY_WS_CYLINDERNAME: "الاسطوانة الأساسية",
  T_39_WZY_WS_DEFAULT: "لا توجد رسوم متحركة (افتراضي)",
  T_39_WZY_WS_DESC: "هبوط",
  T_39_WZY_WS_DIFFUSEALPHA: "شفافية السطح",
  T_39_WZY_WS_DISCONNECT: "قطع الاتصال",
  T_39_WZY_WS_DOUBLEJUMPSHOE_ENERGYRECOVERY: "استعادة الطاقة في الثانية",
  T_39_WZY_WS_DOUBLEJUMPSHOE_JUMCONSUME: "تستهلك الطاقة",
  T_39_WZY_WS_DOUBLEJUMPSHOE_MAXJUMPH: "أقصى ارتفاع للقفز الثاني",
  T_39_WZY_WS_ENABLEJOIN: "اسمح بالانضمام في منتصف الطريق",
  T_39_WZY_WS_ENDPOS: "إحداثيات نقطة النهاية",
  T_39_WZY_WS_ENGINETORQUE: "قوة حصان المحرك",
  T_39_WZY_WS_EXPLODED: "أضرار الانفجار",
  T_39_WZY_WS_FEELDSPEED: "نسبة سرعة الحركة (هبوط)",
  T_39_WZY_WS_FLASH_CFLASHTIME: "وقت الفلاش المركزي",
  T_39_WZY_WS_FLASH_CRANGE: "نطاق المركز",
  T_39_WZY_WS_FLASH_EFLASHTIME: "وقت الفلاش الحاف",
  T_39_WZY_WS_FLASH_HITEFFECTSWITCH: "تأثير إصابة انفجار القنبلة",
  T_39_WZY_WS_FLASH_RANGE: "نطاق الانفجار",
  T_39_WZY_WS_FOLDWINGS_FALLSPEED: "سرعة الهبوط",
  T_39_WZY_WS_FOLDWINGS_FLYMAXH: "الارتفاع الأقصى",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDH: "سرعة الانزلاق الأفقي",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDV: "سرعة الانزلاق العمودي",
  T_39_WZY_WS_FOLDWINGS_MINENDH: "الارتفاع النهائي الأدنى",
  T_39_WZY_WS_FOLDWINGS_MINFLYH: "الحد الأدنى لارتفاع الإقلاع",
  T_39_WZY_WS_FOLDWINGS_OVERHFALLSPEED: "سرعة الهبوط بعد ارتفاع من الطيران",
  T_39_WZY_WS_FOLDWINGS_TURNSPEED: "سرعة الدوران",
  T_39_WZY_WS_FOLMOVENT: "الموقف بعد كيان الحركة",
  T_39_WZY_WS_GETSKILLLIST_NAMEDESC: "احصل على قائمة المهارات الخاصة بـ [كيان اللاعب]",
  T_39_WZY_WS_HB_BOOSTCD: "الركض في فترة التهدئة",
  T_39_WZY_WS_HB_BOOSTDURATION: "مدة الركض",
  T_39_WZY_WS_HB_BOOSTINITIAL: "الركض على المزلاجة تحت فترة التهدئة",
  T_39_WZY_WS_HB_BOOSTINITIALSWITCH: "الركض على المزلاجة تحت فترة التهدئة",
  T_39_WZY_WS_HB_BOOSTSPEED: "سرعة الركض",
  T_39_WZY_WS_HB_HOVERBCD: "المزلاجة  في فترة التهدئة",
  T_39_WZY_WS_HB_JUMPCD: "القفزة في فترة التهدئة",
  T_39_WZY_WS_HB_JUMPH: "ارتفاع القفز على المزلاجة",
  T_39_WZY_WS_HEADSCALE: "مقياس الرأس",
  T_39_WZY_WS_HEADSHOTDESCALE: "تقليل ضرر طلقة الرأس",
  T_39_WZY_WS_INTITALSPEED: "السرعة الأولية",
  T_39_WZY_WS_INVENTORYBASE: "أنواع العناصر الأساسية",
  T_39_WZY_WS_JETSHOE_BASEENERGYCOST: "تكلفة الطاقة في الثانية",
  T_39_WZY_WS_JETSHOE_BASEHSPEED: "السرعة الأفقية الأساسية",
  T_39_WZY_WS_JETSHOE_BASEVSPEED: "السرعة العمودية الأساسية",
  T_39_WZY_WS_JETSHOE_DASHENERGYCOST: "تكلفة طاقة داش في الثانية",
  T_39_WZY_WS_JETSHOE_DASHHSPEED: "سرعة العدو الأفقي",
  T_39_WZY_WS_JETSHOE_RUSHDIS: "مسافة الركض",
  T_39_WZY_WS_JETSHOE_RUSHENERGYCOST: "تكلفة الطاقة الاندفاع في الثانية",
  T_39_WZY_WS_JETSHOE_RUSHVSPEED: "سرعة العدو العمودي",
  T_39_WZY_WS_JETSHOE_UPENERGYCOST: "تكلفة الطاقة التصاعدية في الثانية",
  T_39_WZY_WS_LANDMINE_CANBEATTACK: "قابل للهجوم",
  T_39_WZY_WS_LANDMINE_CANSELFTRIGGER: "قابل للزناد الذاتي",
  T_39_WZY_WS_LANDMINE_CANTEAMTRIGGER: "ما إذا كان يمكن للحلفاء إطلاقها",
  T_39_WZY_WS_LANDMINE_CANVEHICLETRIGGER: "قابل للزناد بواسطة المركبة",
  T_39_WZY_WS_LANDMINE_LIFETIME: "المدة",
  T_39_WZY_WS_LANDMINE_STARTTIME: "وقت التنشيط",
  T_39_WZY_WS_LANDMINE_TRIGGERRADIUS: "نصف قطر الزناد",
  T_39_WZY_WS_LANDMINE_TRIGGERTIME: "وقت الزناد",
  T_39_WZY_WS_LEAVE: "خروج",
  T_39_WZY_WS_LIMBSCALE: "مقياس الأطراف",
  T_39_WZY_WS_LISTLOCSTR: "قائمة النصوص المترجمة",
  T_39_WZY_WS_LOADRESULT_NAME: "تحميل نتيجة المعركة",
  T_39_WZY_WS_LOADRESULT_NAMEDESC: "تحميل نتيجة معركة [اللاعب]، بما في ذلك [التصنيف]، [النتيجة]، [اسم النتيجة]، [قيمة النتيجة]. نوع النتيجة هو عدد صحيح. 1 للنصر، 2 للهزيمة، 3 لبوياه، 4 للتعادل.",
  T_39_WZY_WS_LOOKMOVENT: "كيان الحركة الذي يتبع النظرة",
  T_39_WZY_WS_MAXCOUNT: "الكمية القصوى",
  T_39_WZY_WS_MAXDISTANCE: "المسافة القصوى",
  T_39_WZY_WS_MINISENTRY_ANGELDOWN: "زاوية انحدار البرج",
  T_39_WZY_WS_MINISENTRY_ANGELSPEED: "سرعة البرج الزاوي",
  T_39_WZY_WS_MINISENTRY_ANGELUP: "زاوية ارتفاع البرج",
  T_39_WZY_WS_MINISENTRY_DAM: "ضرر البرج",
  T_39_WZY_WS_MINISENTRY_DEFENSE: "معدل تقليل الضرر",
  T_39_WZY_WS_MINISENTRY_FIREANGLE: "زاوية إطلاق النار",
  T_39_WZY_WS_MINISENTRY_HITCHANCE: "معدل ضرب البرج",
  T_39_WZY_WS_MINISENTRY_INTERVAL: "فاصل هجوم البرج",
  T_39_WZY_WS_MINISENTRY_MAXCOUNT: "أقصى عدد للبرج",
  T_39_WZY_WS_MINISENTRY_RANGE: "نطاق هجوم البرج",
  T_39_WZY_WS_MOVEENT: "كيان الحركة",
  T_39_WZY_WS_NOCOMBINE: "غير قابل للاستخدام المزدوج",
  T_39_WZY_WS_ONCE: "مرة واحدة",
  T_39_WZY_WS_ONDROP_NAMEDESC: "يطلق حادث عندما يتم تجاهل العنصر بواسطة [كيان اللاعب]",
  T_39_WZY_WS_ONEQUIP_NAMEDESC: "يطلق حادث عندما يكون العنصر مُجهزًا بواسطة [كيان اللاعب]",
  T_39_WZY_WS_ONGRAPFIRE_NAMEDESC: "تسببت حادثة عند يطلق سلاح الخطاف النار",
  T_39_WZY_WS_ONLANDSTART_NAMEDESC: "يطلق حادث عند تنشيط القنبلة الأرضية",
  T_39_WZY_WS_ONLANDTRIGGER_NAMEDESC: "يطلق حادث عندما يتم تشغيل قنبلة أرضية بواسطة [كيان اللاعب]",
  T_39_WZY_WS_ONMOTIONPAUSE_NAMEDESC: "تنطلق عند توقف حركة الكيان مؤقتًا",
  T_39_WZY_WS_ONMOTIONREATART_NAMEDESC: "تنطلق عند إعادة تشغيل الكيان للانتقال من الإيقاف المؤقت",
  T_39_WZY_WS_ONMOTIONSTART_NAMEDESC: "تنطلق عندما يبدأ الكيان في التحرك",
  T_39_WZY_WS_ONPICKUP_NAMEDESC: "يطلق حادث عندما يتم التقاط العنصر بواسطة [كيان اللاعب]",
  T_39_WZY_WS_ONTHROWHIT_NAMEDESC: "يتسبب الحادثة عندما تضرب القنابل بالهدف",
  T_39_WZY_WS_OPENATTACK: "ما إذا كان لتمكين الهجوم أم لا",
  T_39_WZY_WS_PAUSEMOV_NAMEDESC: "إيقاف مؤقت كيان الحركة أو قائمة كيانات الحركة",
  T_39_WZY_WS_PAUSESOUND_NAME: "إيقاف المؤثرات الصوتية مؤقتًا",
  T_39_WZY_WS_PAUSESOUND_NAMEDESC: "إيقاف مؤقت كيان الصوت أو قائمة كيانات الصوت",
  T_39_WZY_WS_PIANOTYPE: "نوع مكون الموسيقى",
  T_39_WZY_WS_PINGPONG: "بينج بونج",
  T_39_WZY_WS_PLAYABLELIST: "قائمة كيانات الحركة",
  T_39_WZY_WS_PLAYINGSTATUE: "حالة",
  T_39_WZY_WS_PLAYMOV_NAMEDESC: "استعادة كيان الحركة أو قائمة كيانات الحركة المتوقفة مؤقتا. يمكن اختيار استئناف أو إعادة التشغيل.",
  T_39_WZY_WS_PLAYSOUND_NAME: "تشغيل المؤثرات الصوتية",
  T_39_WZY_WS_PLAYSOUND_NAMEDESC: "قم باستعادة كيان الصوت أو قائمة كيانات الصوت المتوقفة مؤقتًا. يمكن أن تختار استئناف أو إعادة التشغيل",
  T_39_WZY_WS_PROCIRCLE_NAME: "دائرة التقدم",
  T_39_WZY_WS_RAYINSPCON_NAMEDESC: "ينبعث شعاعًا على طول [الاتجاه] من [الإحداثيات الأولية]، ويكتشف الكيان الأول الذي تم تسجيله ضمن [المسافة]، ويعيد [قائمة كيانات الضرر] و [قائمة إحداثيات الضرب]",
  T_39_WZY_WS_RAYINSPSIN_NAMEDESC: "ينبعث شعاعًا على طول [الاتجاه] من [الإحداثيات الأولية]، ويكتشف الكيان الأول الذي تم تسجيله ضمن [المسافة]، ويعيد [كيان الضرب] و [إحداثيات الضرب]",
  T_39_WZY_WS_REAHEALHP: "قيمة استعادة الدروع",
  T_39_WZY_WS_REAHEALTIME: "فاصل وقت في التأثير",
  T_39_WZY_WS_RELATCOORSYS: "نظام الإحداثيات النسبية",
  T_39_WZY_WS_REPAIRARM: "طقم الإصلاح",
  T_39_WZY_WS_REVERSE: "عكس الإتجاه",
  T_39_WZY_WS_RIMALPHA: "شفافية الحافة",
  T_39_WZY_WS_SCORENAME: "اسم الدرجة",
  T_39_WZY_WS_SENDSIGN_NAMEDESC: "إرسال إشارة إلى الكيان المستهدف، يتم تحديد المعلمات التي تم تحميلها بواسطة معلمات إشارة محددة مسبقًا. سيؤدي اختيار نوع الكيان في وقت التعريف إلى إنشاء حدث قبول الإشارة المقابل.",
  T_39_WZY_WS_SETFOLMOV_NAMEDESC: "أنشئ موقعًا بعد الحركة لـ [الكيان المستهدف]. يتبع [الكيان المستهدف] [الكيان التالي]. [إحداثيات الإزاحة] هي الإزاحة الإحداثية بين [الكيان المستهدف] و [الكيان التالي]. يمكن لـ [نظام الإحداثيات] تحديد نظام الإحداثيات العالمي ونظام الإحداثيات النسبية بناءً على توجيه الكيان التالي. سيتم إرجاع [الموقف بعد كيان الحركة] بعد إنشاء الحركة.",
  T_39_WZY_WS_SETLOOKMOV_NAMEDESC: "أنشئ حركة تتبع النظرة لـ [الكيان المستهدف]. يتبع [الكيان المستهدف] [الكيان التالي]. [إحداثيات الإزاحة] هي الإزاحة الإحداثية بين [الكيان المستهدف] و [الكيان التالي]. يمكن لـ [نظام الإحداثيات] تحديد نظام الإحداثيات العالمي ونظام الإحداثيات النسبية بناءً على توجيه الكيان التالي. سيتم إرجاع [كيان الحركة الذي يتبع النظرة] بعد إنشاء الحركة.",
  T_39_WZY_WS_SHOE_FALLDAMSCALE: "نسبة ضرر السقوط",
  T_39_WZY_WS_SHOE_MAXENERGY: "الطاقة القصوى",
  T_39_WZY_WS_SKILLLIST: "قائمة المهارات",
  T_39_WZY_WS_SKILLTYPE: "مهارة الشخصية",
  T_39_WZY_WS_SMOKEG_EFFECTTIME: "مدة تأثير الدخان",
  T_39_WZY_WS_SMOOTH: "تبديل الكاميرا",
  T_39_WZY_WS_SOUNDENTL: "قائمة كيانات المؤثرات الصوتية",
  T_39_WZY_WS_SOUNDENTLORSENT: "كيان أو قائمة المؤثرات الصوتية",
  T_39_WZY_WS_SPRINTSPEED: "نسبة سرعة الركض",
  T_39_WZY_WS_SQUATSPEED: "نسبة سرعة الحركة (القرفصاء)",
  T_39_WZY_WS_STARTCOO: "الإحداثيات الأولية",
  T_39_WZY_WS_STATE: "حالة اللعب",
  T_39_WZY_WS_TARGETVAL: "القيمة المستهدفة",
  T_39_WZY_WS_THROWSPEED: "سرعة الطيران الخطاف",
  T_39_WZY_WS_TOWER_PARAM10: "زاوية الدوران",
  T_39_WZY_WS_TOWER_PARAM11: "حالة البرج",
  T_39_WZY_WS_TOWER_PARAM12: "كيان اي دي",
  T_39_WZY_WS_TOWER_PARAM9: "اهجم الهدف",
  T_39_WZY_WS_TOWSPEED: "سرعة حركة اللاعب",
  T_39_WZY_WS_TWEENCURVE_NAME: "المنحنى المخصص",
  T_39_WZY_WS_TWEENCURVE_NAMEDESC: "يمكن استخدام منحنى مخصص لحركة الاستيفاء",
  T_39_WZY_WS_TWEENENT: "كيان حركة الاستيفاء",
  T_39_WZY_WS_TWEENPLAYST_NAME: "طرق الحركة",
  T_39_WZY_WS_TWEENPLAYST_NAMEDESC: "طرق الحركة الاستيفاء",
  T_39_WZY_WS_TWEENSTYLE: "الطريقة",
  T_39_WZY_WS_UNLOADSCRIPT_NAMEDESC: "حذف النص [اسم النص] لـ [الكيان]",
  T_39_WZY_WS_UPSET_NAMEDESC: "قم بترتيب العناصر المدرجة عشوائيًا",
  T_39_WZY_WS_VISIBLEONBACK: "مرئي من الخلف",
  T_39_WZY_WS_WEAPCOMBINET: "نوع سلاح مزدوج الاستخدام",
  T_39_WZY_WS_WEAPON_KNOCKDOWNDAM: "ضرر إضافي عند السقوط",
  T_39_WZY_WS_WEAPON_ONCEAMMO: "رقم طلقة واحدة",
  T_39_WZY_WS_WEAREPLAY: "إعادة تشغيل الحركة؟",
  T_39_WZY_WS_WORLDCOORSYS: "نظام الإحداثيات العالمية",
  T_39_XXJ_WS_ADDFRIEND: "إضافة صديق",
  T_39_XXJ_WS_ALLOWZ: "تفعيل حركة المحور x للاعب",
  T_39_XXJ_WS_BLOCKMODEDESC: "حركة الكاميرا عندما يكون هناك شيء بين الكاميرا والهدف",
  T_39_XXJ_WS_CAMERADISTANCE: "المسافة من الهدف",
  T_39_XXJ_WS_CAMERATYPEDESC: "يتم توفير أنواع متعددة من الكاميرا المعدة مسبقًا والمخصصة",
  T_39_XXJ_WS_CAMERAUSER: "مستخدم الكاميرا",
  T_39_XXJ_WS_CURENTCAMERA: "الكاميرا مستخدمة",
  T_39_XXJ_WS_DETAILS: "تفاصيل المباراة",
  T_39_XXJ_WS_FFECONOMY: "الإقتصاد",
  T_39_XXJ_WS_FOCUSTARGET: "الهدف الملاحظ",
  T_39_XXJ_WS_FOLLOWTARGET: "الهدف المتبع",
  T_39_XXJ_WS_GAMERESULT: "نتيجة المباراة",
  T_39_XXJ_WS_GAMETITLE1: "المباراة 1",
  T_39_XXJ_WS_GAMETITLE2: "المباراة 2",
  T_39_XXJ_WS_GIFT: "هدية",
  T_39_XXJ_WS_HORIZONTALANGLEDESC: "زاوية الدوران الأفقية للكاميرا",
  T_39_XXJ_WS_INVISICAM: "شفاف",
  T_39_XXJ_WS_INVISICAMDESC: "يصبح العنصر بين الكاميرا والهدف شفافًا",
  T_39_XXJ_WS_LEFTSCORE: "نتيجة الفريق اليسرى",
  T_39_XXJ_WS_LIKE: "اعجاب",
  T_39_XXJ_WS_LOBBY: "ردهة",
  T_39_XXJ_WS_MAINSCORENAME: "مجموع اسم الدرجة",
  T_39_XXJ_WS_MAINSCORENUM: "العدد الإجمالي للنتيجة",
  T_39_XXJ_WS_MAPEVALUATE: "تصنيف الخريطة",
  T_39_XXJ_WS_MULTITEAMRESULTHUD: "نتيجة فرق متعددة",
  T_39_XXJ_WS_MVP1: "أفضل لاعب 1",
  T_39_XXJ_WS_MVP2: "أفضل لاعب 2",
  T_39_XXJ_WS_OFFSET2: "إزاحة نقطة المراقبة",
  T_39_XXJ_WS_OFFSET2DESC: "يشير عادةً إلى إزاحة نقطة تركيز الكاميرا بالنسبة إلى الموضع الأصلي للاعب. (يختلف المعنى حسب نوع الكاميرا)",
  T_39_XXJ_WS_OFFSETDESC: "يشير عادة إلى إزاحة موضع الكاميرا بالنسبة إلى الموضع الأصلي للاعب. (يختلف المعنى حسب نوع الكاميرا)",
  T_39_XXJ_WS_ORTHOGONAL: "متعامد",
  T_39_XXJ_WS_ORTHOGONALDESC: "تصور الكاميرا أهدافًا بعيدة وأقرب بنفس الحجم",
  T_39_XXJ_WS_PERSPECTIVE: "منظور",
  T_39_XXJ_WS_PERSPECTIVEDESC: "تستخدم الكاميرا إسقاط المنظور لمراقبة الهدف",
  T_39_XXJ_WS_PROJECTIONMODEDESC: "تشكيل صورة الكاميرا عند التقديم",
  T_39_XXJ_WS_RANK1: "تصنيف الفريق",
  T_39_XXJ_WS_RANK2: "تصنيف اللاعب",
  T_39_XXJ_WS_REPORT: "بلاغ",
  T_39_XXJ_WS_REVIEW: "اعادة تشغيل",
  T_39_XXJ_WS_RIGHTSCORE: "نتيجة الفريق اليمنى",
  T_39_XXJ_WS_SCORENUM1: "النتيجة 1",
  T_39_XXJ_WS_SCORENUM2: "النتيجة 2",
  T_39_XXJ_WS_SCORENUM3: "النتيجة 3",
  T_39_XXJ_WS_SCORENUM4: "النتيجة 4",
  T_39_XXJ_WS_SCORENUM5: "النتيجة 5",
  T_39_XXJ_WS_SCORETITLELIST: "قائمة اسم الدرجة",
  T_39_XXJ_WS_SHARE: "مشاركة",
  T_39_XXJ_WS_SPECTATORSWITCH: "المتفرج",
  T_39_XXJ_WS_STABLE: "مستقر",
  T_39_XXJ_WS_STABLEDESC: "تظل الكاميرا ثابتة إذا كان هناك شيء بين الكاميرا والكيان المتبع",
  T_39_XXJ_WS_TEAMNAME1: "اسم الفريق اليسرى",
  T_39_XXJ_WS_TEAMNAME2: "اسم الفريق اليمنى",
  T_39_XXJ_WS_TEAMRANK: "تصنيف الفريق",
  T_39_XXJ_WS_TRANSITIONTIME: "وقت انتقال الكاميرا",
  T_39_XXJ_WS_TRANSITIONTYPE: "نوع انتقال الكاميرا",
  T_39_XXJ_WS_TWOTEAMRESULTHUD: "نتيجة 2 فريق",
  T_39_XXJ_WS_VERTICALANGLEDESC: "زاوية الدوران العمودي للكاميرا",
  T_39_XXJ_WS_ZOOM: "تكبير",
  T_39_XXJ_WS_ZOOMDESC: "تقوم الكاميرا بالتكبير إذا كان هناك عنصر بين الكاميرا والكيان المتبع",
  T_39_XYL_WS_LIGHTINTENSITY: "شدة الضوء",
  T_39_XYL_WS_LIGHTRANGE: "نطاق الضوء",
  T_39_XYL_WS_POINTLIGHT: "نقطة الضوء",
  T_39_XYL_WS_WATERZONE: "منطقة المياه المخصصة",
  T_40_B_DISABLE_RECONNECT: "تعطيل إعادة الاتصال التلقائي",
  T_40_CJ_T_SHUTTLECOCK_BLACK: "قميص منتصف الليل",
  T_40_CJ_T_SHUTTLECOCK_RED2: "قميص القطب الشمالي",
  T_40_CJ_T_SHUTTLECOCK_REDBLACK: "القميص الكرزي",
  T_40_CJ_T_SHUTTLECOCK_YELLOW: "قميص السماء المشمسة",
  T_40_CJ_T_SPORTSWEAR_FIRE: "القميص المشتعل",
  T_40_DYEING_CLEAR: "مسح حالة التلوين",
  T_40_HJ_WS_EFFECT32: "حذاء رياضي",
  T_40_HJ_WS_EFFECT33: "انفجار",
  T_40_HJ_WS_EFFECT34: "نقطة إنعاش",
  T_40_HJ_WS_EFFECT35: "الليزر",
  T_40_HJ_WS_EFFECT36: "ذخيرة",
  T_40_HJ_WS_EFFECT37: "تأثير الضرب",
  T_40_HJ_WS_EFFECT38: "تأثير إطلاق النار",
  T_40_HJ_WS_EFFECT43: "شبكة سبايدر",
  T_40_HJ_WS_EFFECT44: "إطلاق مهارة",
  T_40_HJ_WS_SOUND69: "فتح صندوق",
  T_40_HJ_WS_SOUND70: "رفع المستوى",
  T_40_HJ_WS_SOUND71: "المستوى الأقصى",
  T_40_HJ_WS_SOUND72: "النقر على زر",
  T_40_HJ_WS_SOUND73: "العد التنازلي 1",
  T_40_HJ_WS_SOUND74: "صافرة",
  T_40_HJ_WS_SOUND75: "انتهت اللعبة",
  T_40_HJ_WS_SOUND76: "تقدم",
  T_40_HJ_WS_SOUND77: "بوياه",
  T_40_HJ_WS_SOUND78: "نقطة تسجيل",
  T_40_HJ_WS_SOUND79: "العد التنازلي 2",
  T_40_HJ_WS_SOUND80: "تبدأ اللعبة",
  T_40_HJ_WS_SOUND81: "تم الحصول على العديد من العملات",
  T_40_HJ_WS_SOUND82: "تم الحصول على العملات",
  T_40_HJ_WS_SOUND83: "تم الحصول على بعض العملات",
  T_40_HJ_WS_SOUND84: "انضم إلى اللعبة",
  T_40_HJ_WS_SOUND85: "فتح صندوق الإمداد",
  T_40_HJ_WS_SOUND86: "بوق",
  T_40_HJ_WS_SOUND87: "تم القضاء على رئيس",
  T_40_HJ_WS_SOUND88: "فتح صندوق الحرب",
  T_40_HJ_WS_SOUND89: "مهارة الطلاء المتفجر",
  T_40_HJ_WS_SOUND90: "إصابة رصاصة",
  T_40_HJ_WS_SOUND91: "مهارة درع الطلاء",
  T_40_HJ_WS_SOUND92: "النقر على زر معطل",
  T_40_HJ_WS_SOUND93: "اكتمل شحن المهارة",
  T_40_HJ_WS_SOUND95: "مهارة الليزر",
  T_40_HJ_WS_SOUND96: "الحصول على العنصر 2",
  T_40_HJ_WS_SOUND97: "انتهت اللعبة 2",
  T_40_HJ_WS_SOUND98: "إشعارات القتل",
  T_40_HJ_WS_SOUNDTYPE_BMG: "موسيقى خلفية",
  T_40_HJ_WS_SOUNDTYPE_INGAME: "مؤثرات الصوت في المباراة",
  T_40_HJ_WS_SOUNDTYPE_UI: "تأثير الصوت لواجهة المستخدم",
  T_40_JH_WS_MAPTAG1: "لعبة اللون",
  T_40_JH_WS_MAPTAG10: "لون لعبة الغميضة",
  T_40_JH_WS_MAPTAG11: "الذكرى السنوية",
  T_40_JH_WS_MAPTAG12: "رول بلاي",
  T_40_JH_WS_MAPTAG13: "محاكاة",
  T_40_JH_WS_MAPTAG14: "غير متماثل",
  T_40_JH_WS_MAPTAG15: "موارد المعركة",
  T_40_JH_WS_MAPTAG16: "مرافقة العربة",
  T_40_JH_WS_MAPTAG17: "الخريطة الرسمية",
  T_40_JH_WS_MAPTAG18: "لعبة صغيرة",
  T_40_JH_WS_MAPTAG19: "تحدي السرعة",
  T_40_JH_WS_MAPTAG2: "رش اللون",
  T_40_JH_WS_MAPTAG20: "روجولايك",
  T_40_JH_WS_MAPTAG3: "قتال اللون",
  T_40_JH_WS_MAPTAG4: "معركة الألوان",
  T_40_JH_WS_MAPTAG5: "ملعب اللون",
  T_40_JH_WS_MAPTAG6: "لون الملعب",
  T_40_JH_WS_MAPTAG7: "حفلة الألوان",
  T_40_JH_WS_MAPTAG8: "لون الباركور",
  T_40_JH_WS_MAPTAG9: 'باركور "سبايدر-فيرس"',
  T_40_JH_WS_TAG30: "إعصار",
  T_40_JH_WS_TAG31: "مدمر المنزل",
  T_40_JH_WS_TAG32: "المدينة الغامضة",
  T_40_JH_WS_TAG33: "أزمة الفجر",
  T_40_JH_WS_TAG34: "صحوة الموت",
  T_40_JH_WS_TAG35: "قتال القبضة",
  T_40_JH_WS_TAG36: "سقف المصنع القديم",
  T_40_JH_WS_UGCTOKENNAME: "توكن أرض الحرف",
  T_40_L_QUICKMESSAGE_MODE2: "كلاش سكواد",
  T_40_M_WS_HIS: "من",
  T_40_SP_WS_DYEING: "لون",
  T_40_SP_WS_DYEING_AREA: "تلوين المنطقة",
  T_40_SP_WS_DYEING_COLOR: "رقم اللون",
  T_40_SP_WS_DYEING_COUNT: "عدد التلوين",
  T_40_SP_WS_DYEING_DIR: "اتجاه التلوين",
  T_40_SP_WS_DYEING_DIS: "مسافة التلوين",
  T_40_SP_WS_DYEING_FIXEDDYEINGRANGE: "منطقة التلوين الثابتة",
  T_40_SP_WS_DYEING_NORMAL: "عادي",
  T_40_SP_WS_DYEING_PLANE: "تلوين منطقة الطائرة",
  T_40_SP_WS_DYEING_POSITION: "إحداثية",
  T_40_SP_WS_DYEING_RANDOMDECAY: "تدهور معدل التلوين العشوائي",
  T_40_SP_WS_DYEING_RANDOMRATIO: "معدل التلوين العشوائي",
  T_40_SP_WS_DYEING_RANGE: "منطقة التلوين",
  T_40_SP_WS_DYEING_STATE: "حالة التلوين",
  T_40_SP_WS_FACTIONTIPS_11: "أرجواني",
  T_40_SP_WS_SHOE_CURENERGY: "الطاقة الحالية",
  T_40_SW_SKILL_Name_Nanoscientist: "درع الحياة",
  T_40_SY_AK47_PENGUIN_W_N: "AK47 - عجائب واجر",
  T_40_SY_CHARACTER_DJMALE_AWAKENING_N: "صحوة ألوك",
  T_40_SY_CHARACTER_NANOSCIENTIST_N: "سونيا",
  T_40_SY_FAMAS_PENGUIN_W_N: "فاماس - عجائب واجر",
  T_40_SY_M1014_PENGUIN_W_N: "M1014 - عجائب واجر",
  T_40_SY_M24_PENGUIN_W_N: "M24 - عجائب واجر",
  T_40_SY_MINI_PENGUIN_W_N: "AC80 - عجائب واجر",
  T_40_SY_PET_PUG_N: "بج",
  T_40_SY_PETSKIN_ALIEN_TIGHTGUY_N: 'سكن الحيوان الأليف: مووني "سبايدر-فيرس"',
  T_40_SY_PETSKIN_FLYINGCREATURE_ME_N: "سكن الحيوان الأليف: أرفون الكهربائي",
  T_40_SY_PETSKIN_PUG_BLACK_N: "سكن الحيوان الأليف: بج عين الليزر",
  T_40_SY_PETSKIN_PUG_GREEN_N: "سكن الحيوان الأليف: بج الصيفي",
  T_40_SY_PETSKIN_PUG_ORANGE_N: "سكن الحيوان الأليف: بج النمري",
  T_40_SY_SCAR_PENGUIN_W_N: "SCAR - عجائب واجر",
  T_40_SY_THOMPSON_PENGUIN_W_N: "طومسون - عجائب واجر",
  T_40_SY_UMP45_PENGUIN_W_N: "UMP - عجائب واجر",
  T_40_SY_USP45_PENGUIN_W_N: "USP - عجائب واجر",
  T_40_SY_UZI_PENGUIN_W_N: "أوزي الصغير - عجائب واجر",
  T_40_V_WS_INPUT_TEXT_ACTIVE: "تنشيط محتوى النص",
  T_40_V_WS_INPUT_TEXT_DEFAULT: "محتوى نص العنصر النائب",
  T_40_W_DJMALE_AWAKENING_D: "الصحوة: أثناء تنشيط الهالة، النوتات الموسيقية التي تدوم لمدة [FFB300]{2}ث[-] سيتم إسقاطها [FFB300]{1}م[-] خلف المستخدم المهارة كل [FFB300]{0}ث[-]. سيحصل زملاء الفريق الذين يلتقطون النوتة الموسيقية على نفس تأثير الهالة.",
  T_40_W_DJMALE_AWAKENING_N: "حفلة ريمكس",
  T_40_W_NURSE_D: "انشر [FFB300]{0}%[-] من تأثيرات العلاج الموجهة للهدف الواحد (المهارة، والمعدات الطبية، ومسدس العلاج، وإلخ) إلى زملاء الفريق في نطاق [FFB300]{1}م[-] من المستخدم.",
  T_40_WH_MP_BOXING_NAME: "مباراة الملاكمة",
  T_40_WH_MP_C_PACK: "حقيبة ظهر غير قانونية",
  T_40_WH_MP_EXCH_COIN: "النقود",
  T_40_WH_MP_EXCH_TEMPCOIN: "الأموال غير المشروعة",
  T_40_WH_MP_PAYCHECK: "الرواتب",
  T_40_WT_SKILL_DESC_MUSICBRO_BLACK: "تمت زيادة سرعة مساعدة زملائك في الفريق بنسبة [FFB300]{0}%[-]. وقت التهدئة: [FFB300]{3}ث[-]. يتعافى زميل الفريق الذي تم مساعدته [FFB300]{2} من نقاط الصحة[-] في [FFB300]{1}ث[-].",
  T_40_WT_SKILL_DESC_MUSICBRO_WHITE2: "ينشئ منطقة شفاء [FFB300]{0}بقطر متر[-]. في الداخل، يستعيد المستخدم والحلفاء [FFB300]{1} نقاط صحة / ثانية[-]. سيتم تشغيل المساعدة تلقائيًا عند الحاجة. تدوم المنطقة لمدة [FFB300]{2}ث[-]. يمكن تعزيز تأثيرات مساعدة زملائك في الفريق من خلال مهارات أخرى. التهدئة: [FFB300]{3}ث[-].",
  T_40_WT_WS_ICONENTITY_PARAM6: "طريقة العرض",
  T_40_WZY_WS_CUSTOMTRIGGER_CAPSULE: "كبسولة",
  T_40_WZY_WS_CUSTOMTRIGGER_HEIGHT: "الإرتفاع",
  T_40_WZY_WS_CUSTOMTRIGGER_RADIUS: "نصف القطر",
  T_40_WZY_WS_CUSTOMTRIGGER_SPHERE: "الكرة",
  T_40_WZY_WS_FONT_FF_CN_T: "FZLanTingHei-R-BIG5",
  T_40_WZY_WS_FONT_HINDSILIGURI: "Hind Siliguri",
  T_40_WZY_WS_FONT_NOTONASTALIQURDU: "Noto Nastaliq Urdu",
  T_40_WZY_WS_FONT_NOTOSANS: "GFF Devanagari",
  T_40_WZY_WS_FONT_SIMPBDO: "العربية البسيطة",
  T_40_WZY_WS_FONT_SUPERMARKET: "Supermarket",
  T_40_WZY_WS_ICONENTITY_COLOR: "اللون",
  T_40_WZY_WS_ICONENTITY_FILLED: "تقدمية",
  T_40_WZY_WS_ICONENTITY_ICONTYPE: "موارد الصورة",
  T_40_WZY_WS_ICONENTITY_NAME: "أيقونة العنصر",
  T_40_WZY_WS_ICONENTITY_RENDERTYPE: "طريقة العرض",
  T_40_WZY_WS_ICONENTITY_SIMPLE: "بسيطة",
  T_40_WZY_WS_ICONENTITY_SLICED: "9-الشبكة",
  T_40_WZY_WS_ICONENTITY_TILED: "البلاط",
  T_40_WZY_WS_NEWMAPTAG: "أيقونة خريطة جديدة",
  T_40_WZY_WS_NEWVFX1: "ضوء دائري",
  T_40_WZY_WS_NEWVFX10: "لعنة",
  T_40_WZY_WS_NEWVFX11: "منطقة الوقف",
  T_40_WZY_WS_NEWVFX12: "الهواء البارد",
  T_40_WZY_WS_NEWVFX13: "ندفة الثلج",
  T_40_WZY_WS_NEWVFX14: "اللهب",
  T_40_WZY_WS_NEWVFX15: "شعاع ضوء",
  T_40_WZY_WS_NEWVFX16: "انتشار الغاز السام",
  T_40_WZY_WS_NEWVFX17: "غاز سام",
  T_40_WZY_WS_NEWVFX18: "انفجار الحريق",
  T_40_WZY_WS_NEWVFX19: "تأثير الضوء",
  T_40_WZY_WS_NEWVFX2: "فقاعة",
  T_40_WZY_WS_NEWVFX20: "نجمة",
  T_40_WZY_WS_NEWVFX3: "رماد",
  T_40_WZY_WS_NEWVFX4: "رشق الحجارة",
  T_40_WZY_WS_NEWVFX5: "تأثير الخط",
  T_40_WZY_WS_NEWVFX6: "وميض",
  T_40_WZY_WS_NEWVFX7: "خاتم",
  T_40_WZY_WS_NEWVFX8: "جسيمات متصاعدة",
  T_40_WZY_WS_NEWVFX9: "دخان",
  T_40_WZY_WS_PRESENTTXT_FONTSIZE: "حجم الخط",
  T_40_WZY_WS_PRESENTTXT_FONTSTYLE: "نمط الخط",
  T_40_WZY_WS_TEXTENTITY_FONTTYPE: "الخط",
  T_40_WZY_WS_TEXTENTITY_NAME: "كائن النص",
  T_40_WZY_WS_UIFONT_LATIN: "Agency FB",
  T_40_WZY_WS_UIFONT_LATIN_BOLD: "GFF Latin",
  T_40_XXJ_WS_ACTIONHUD: "زر التفاعل مكون HUD",
  T_40_XXJ_WS_ACTIVEINHIERARCHY_DESCKEY: "ما إذا كان يمكن استخدامه في المشهد. هذا للقراءة فقط ويعتمد على الرئيسي متاح أم لا وحالة النشاط.",
  T_40_XXJ_WS_ACTIVEPARENT_DESCKEY: "ما إذا كان جميع الكيان الرئيسي نشطين. هذا للقراءة فقط وغير مرئي للاعبين.",
  T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY: "الكيان الرئيسي متاح أم لا",
  T_40_XXJ_WS_ACTIVESELF_DESCKEY: "عرض عندما تكون الحالة المفتوحة صحيحة، أو مغلقة بخلاف ذلك",
  T_40_XXJ_WS_ACTIVESELF1_DESCKEY: "ما إذا كان يمكن أن يكون نشطًا على الذات. لاستخدام في المشهد، يجب عليك استخدام نشط في المشهد أم لا. هذا للقراءة فقط ويتم تكوينه باستخدام API.",
  T_40_XXJ_WS_ADDORREMOVECAMERACULLINGMASK_DESCKEY: "ما إذا كانت cullingMask الكاميرا مرئية لطبقة معينة",
  T_40_XXJ_WS_ADDTOKENATPOSITION_DESCKEY: "توليد التوكن في مكان معين",
  T_40_XXJ_WS_ADDTOKENTOPLAYER_DESCKEY: "العنصر القابل للنهب لإعطائه للاعب",
  T_40_XXJ_WS_AFORWARD_DESCKEY: "الاتجاه الحالي للاعب",
  T_40_XXJ_WS_AFORWARD_NAMEKEY: "الاتجاه",
  T_40_XXJ_WS_AIREALATTACKENTITY_DESCKEY: "يهاجم الذكاء الاصطناعي الكيان",
  T_40_XXJ_WS_AITARGET_DESCKEY: "الذكاء الاصطناعي المهاجم",
  T_40_XXJ_WS_ALIGNMENT_DESCKEY: "أسلوب المحاذاة",
  T_40_XXJ_WS_ALIGNMENT_NAMEKEY: "محاذاة أفقية",
  T_40_XXJ_WS_ALIGNMENTVERTICAL_NAMEKEY: "محاذاة عمودية",
  T_40_XXJ_WS_ALPHA_DESCKEY: "الشفافية",
  T_40_XXJ_WS_AMMOINCLIP_DESCKEY: "عدد الذخيرة المتبقية",
  T_40_XXJ_WS_AMMOINCLIP_NAMEKEY: "الذخيرة المتبقية",
  T_40_XXJ_WS_ANCHORMAX: "المرساة القصوى",
  T_40_XXJ_WS_ANCHORMIN: "المرساة الدنيا",
  T_40_XXJ_WS_APOSITION_DESCKEY: "الموضع الحالي للاعب",
  T_40_XXJ_WS_APOSITION_NAMEKEY: "الموضع",
  T_40_XXJ_WS_ARMORHUD_NAMEKEY: "تبديل HUD للدرع",
  T_40_XXJ_WS_ASSETCONFIGID_NAMEKEY: "معرف الأصول المكون",
  T_40_XXJ_WS_ASSETID_NAMEKEY: "معرف الأصول",
  T_40_XXJ_WS_ATTACKENTITY_NAMEKEY: "هدف الهجوم",
  T_40_XXJ_WS_ATTACKGRENADE_NAMEKEY: "اهجم المواد القابلة للرمي",
  T_40_XXJ_WS_ATTACKTARGET_DESCKEY: "الكيان الذي يتم مهاجمته من قبل الذكاء الاصطناعي",
  T_40_XXJ_WS_ATTACKTARGET_NAMEKEY: "تم الهجوم على الهدف",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_DESCKEY: "الإحداثيات المتوفرة لنقاط الإنعاش",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_NAMEKEY: "الإحداثيات المتاحة",
  T_40_XXJ_WS_BACKGROUND_DESCKEY: "الصورة السفلية",
  T_40_XXJ_WS_BACKGROUND_NAMEKEY: "خلفية",
  T_40_XXJ_WS_BAGHUD_NAMEKEY: "الحقيبة",
  T_40_XXJ_WS_BGALPHA_NAMEKEY: "شفافية الخلفية",
  T_40_XXJ_WS_BGCOLOR_DESCKEY: "لون الخلفية",
  T_40_XXJ_WS_BGCOLOR_NAMEKEY: "لون الخلفية",
  T_40_XXJ_WS_BGFILL_DESCKEY: "ما إذا كان لملء الخلفية",
  T_40_XXJ_WS_BGFILL_NAMEKEY: "ملء الخلفية",
  T_40_XXJ_WS_BGNAME_DESCKEY: "اسم الخلفية",
  T_40_XXJ_WS_BGNAME_NAMEKEY: "اسم الخلفية",
  T_40_XXJ_WS_BGSIZEDELTA_DESCKEY: "حجم الخلفية دلتا",
  T_40_XXJ_WS_BGSIZEDELTA_NAMEKEY: "حجم الخلفية دلتا",
  T_40_XXJ_WS_BLUE: "أزرق",
  T_40_XXJ_WS_BODY_DESCKEY: "جذع",
  T_40_XXJ_WS_BODY_NAMEKEY: "جذع",
  T_40_XXJ_WS_BONESCALE_NAMEKEY: "مقياس الهيكل العظمي",
  T_40_XXJ_WS_BORNPOSITIONVEC3_DESCKEY: "نقطة إنعاش اللاعب",
  T_40_XXJ_WS_BORNPOSITIONVEC3_NAMEKEY: "نقطة إنعاش",
  T_40_XXJ_WS_BOTH: "واحد منهم",
  T_40_XXJ_WS_BUTTONNAME: "اسم مكون الزر",
  T_40_XXJ_WS_CAMERA_DESCKEY: "كاميرا",
  T_40_XXJ_WS_CAMERADIR_DESCKEY: "الاتجاه الذي تواجهه كاميرا العميل",
  T_40_XXJ_WS_CAMERAPOS_DESCKEY: "موقع كاميرا العميل",
  T_40_XXJ_WS_CAMERARAYCASTHUD_DESCKEY: "كشف خط كاميرا العميل",
  T_40_XXJ_WS_CAMERARAYCASTHUD_NAMEKEY: "كشف أشعة الكاميرا",
  T_40_XXJ_WS_CANCELDRAGIFFITS_DESCKEY: "توقف عن السحب عندما يتزامن مع منطقة العرض",
  T_40_XXJ_WS_CANCELDRAGIFFITS_NAMEKEY: "الخروج من السحب بعد التناسب",
  T_40_XXJ_WS_CAPSULEHEIGHT_DESCKEY: "المسافة بين مركز أنصاف دائرة لشكل حبوب منع الحمل. لا يمكن أن يكون أصغر من نصف قطر الكرة.",
  T_40_XXJ_WS_CELLSIZE_DESCKEY: "حجم الخلية",
  T_40_XXJ_WS_CELLSIZE_NAMEKEY: "ارتفاع خلية الفرع",
  T_40_XXJ_WS_CELLVALUE: "اقرأ محتوى خلية معينة وأعد عنصرًا",
  T_40_XXJ_WS_CENTER_DESCKEY: "ينسق العالم الذي يتوافق مع مركز الخريطة المصغرة. 0 افتراضيًا.",
  T_40_XXJ_WS_CENTER_NAMEKEY: "مركز الخريطة المصغرة",
  T_40_XXJ_WS_CENTEROFFSET_DESCKEY: "إزاحة موضع الزر",
  T_40_XXJ_WS_CENTEROFFSET_NAMEKEY: "موضع الإزاحة",
  T_40_XXJ_WS_CENTEROFMASS_DESCKEY: "مركز الكتلة بالنسبة للإحداثيات المحلية",
  T_40_XXJ_WS_CENTEROFMASS_NAMEKEY: "مركز الكتلة",
  T_40_XXJ_WS_CENTRALLINEACTIVE_DESCKEY: "ما إذا كان سيتم عرض الخط الأوسط",
  T_40_XXJ_WS_CENTRALLINEACTIVE_NAMEKEY: "عرض الخط الأوسط أم لا",
  T_40_XXJ_WS_CENTRALLINEPOS_DESCKEY: "موضع الخط الأوسط [0،1]",
  T_40_XXJ_WS_CENTRALLINEPOS_NAMEKEY: "موضع الخط الأوسط",
  T_40_XXJ_WS_CHASERANGE: "مطاردة المجاورة",
  T_40_XXJ_WS_CHASETARGET_DESCKEY: "الكيان الذي يطارده الذكاء الاصطناعي",
  T_40_XXJ_WS_CHASETARGET_NAMEKEY: "الهدف مطارد",
  T_40_XXJ_WS_CHILD_DESCKEY: "الكيان الفرع",
  T_40_XXJ_WS_CHILDINDEX_NAMEKEY: "فرع الرئيس",
  T_40_XXJ_WS_CHITPOS_DESCKEY: "النقطة التي يصاب بها خط الكاميرا",
  T_40_XXJ_WS_CHOOSECARHUD: "حدد كيان بطاقة HUD",
  T_40_XXJ_WS_CLAMP_DESCKEY: "إذا كانت المعلمة ضمن النطاق العددي بين الحد الأدنى والحد الأقصى للقيم، فستقوم الوظيفة بإرجاع قيمة المعلمة؛ إذا كانت المعلمة أكبر من النطاق، فستُرجع الوظيفة القيمة القصوى؛ إذا كانت الوسيطة أقل من النطاق، فستُرجع الوظيفة القيمة الدنيا",
  T_40_XXJ_WS_CLEARALLCHILDREN_DESCKEY: "يدعم فقط الكيانات التي تحتوي على مكون التحويل. مقيد حاليا لجميع العناصر.",
  T_40_XXJ_WS_CLICKSIZE_DESCKEY: "حجم منطقة النقر",
  T_40_XXJ_WS_CLICKSIZE_NAMEKEY: "انقر الحجم",
  T_40_XXJ_WS_CLIPPINGTYPE_DESCKEY: "نوع القطع",
  T_40_XXJ_WS_CLIPPINGTYPE_NAMEKEY: "نوع القطع",
  T_40_XXJ_WS_CLONEENT_D: "استنسخ الكيان المحدد وخصائصه مع الاحتفاظ بالكيان الرئيسي الأصلي. إذا تم تحديد عنصر المرحلة، فسوف يعتمد على إنشاء عنصر المرحلة.",
  T_40_XXJ_WS_CLOTHES_DESCKEY: "قائمة الأزياء",
  T_40_XXJ_WS_CLOTHID_DESCKEY: "معرف الزي",
  T_40_XXJ_WS_CLOTHID_NAMEKEY: "معرف الزي",
  T_40_XXJ_WS_CLOTHID1_DESCKEY: "معرف الزي",
  T_40_XXJ_WS_COL_DESC: "العمود للقراءة.",
  T_40_XXJ_WS_COLNAME_DESC: "اسم العمود الذي سيُقرأ.",
  T_40_XXJ_WS_COLOR_DESCKEY: "اللون",
  T_40_XXJ_WS_COLOR_NAMEKEY: "القيمة",
  T_40_XXJ_WS_COLOR1_DESCKEY: "أضف طبقات اللون باستخدام قناة اللون RGBA. تقع قيمة القناة بين 0 و 255 ويتم تخزينها في Int32. اللون الأبيض (255، 255، 255، 255) افتراضيًا.",
  T_40_XXJ_WS_COLOR2_DESCKEY: "لون شريط التقدم",
  T_40_XXJ_WS_COLOR3_DESCKEY: "نوع قناة ألوان RGBA، والتي تتراوح من 0 إلى 255",
  T_40_XXJ_WS_COLOR4_DESCKEY: "لون النص",
  T_40_XXJ_WS_COLOR5_DESCKEY: "لون HUD",
  T_40_XXJ_WS_COLOR6_DESCKEY: "لون الإضاءة",
  T_40_XXJ_WS_COLORA_DESCKEY: "قيمة اللون A",
  T_40_XXJ_WS_COLORB_DESCKEY: "قيمة اللون B",
  T_40_XXJ_WS_COLORBAR_NAMEKEY: "لون شريط التقدم",
  T_40_XXJ_WS_COLORDRUM_DESCKEY: "برميل اللون",
  T_40_XXJ_WS_COLORDRUM_NAMEKEY: "برميل اللون",
  T_40_XXJ_WS_COLORG_DESCKEY: "قيمة اللون G",
  T_40_XXJ_WS_COLORGETCHANNEL_DESCKEY: "احصل على قناة RGBA",
  T_40_XXJ_WS_COLORGUN: "بندقية رش قوس قزح",
  T_40_XXJ_WS_COLORGUN_01: "بندقية رش قوس قزح (حمراء)",
  T_40_XXJ_WS_COLORGUN_02: "بندقية رش قوس قزح (صفراء)",
  T_40_XXJ_WS_COLORGUN_03: "بندقية رش قوس قزح (زرقاء)",
  T_40_XXJ_WS_COLORGUN_04: "بندقية رش قوس قزح (خضراء)",
  T_40_XXJ_WS_COLORGUN_05: "بندقية رش قوس قزح (أرجوانية)",
  T_40_XXJ_WS_COLORR_DESCKEY: "قيمة اللون R",
  T_40_XXJ_WS_COLORTEXT_NAMEKEY: "لون الخط",
  T_40_XXJ_WS_COLVALUE: "محتوى العمود",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_DESCKEY: "كيان HUD لمفتاح تبديل HUD العام",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_NAMEKEY: "كيان HUD لمفتاح تبديل HUD العام",
  T_40_XXJ_WS_CONSTRAINT_DESCKEY: "القيود",
  T_40_XXJ_WS_CONSTRAINT_NAMEKEY: "القيود",
  T_40_XXJ_WS_CONSTRAINTCOUNT_DESCKEY: "عدد القيود",
  T_40_XXJ_WS_CONSTRAINTCOUNT_NAMEKEY: "عدد القيود",
  T_40_XXJ_WS_CONTENTORIGIN_DESCKEY: "المحتوى الأصلي",
  T_40_XXJ_WS_CONTENTORIGIN_NAMEKEY: "الاتجاه الافتراضي",
  T_40_XXJ_WS_CONTENTORIGIN2_DESCKEY: "نقطة البداية للتمرير. الزاوية اليسرى العليا بشكل افتراضي.",
  T_40_XXJ_WS_CREATEMAPBITENTITY_DESCKEY: "قم بتوليد بكسل ثابت لعنصر معين في الخريطة. لن يتحرك البكسل مع العنصر.",
  T_40_XXJ_WS_CREATEMAPICONENTITY_DESCKEY: "أنشئ أيقونة الخريطة المصغرة",
  T_40_XXJ_WS_CREATETIMESTAMPLOCSTRING_DESCKEY: "تحديد سلسلة نص مترجمة للطابع الزمني",
  T_40_XXJ_WS_CREATEUIWIDGET_D: "قم بإنشاء مكون واجهة مستخدم مخصص في HUD المخصص والمكون الرئيسي",
  T_40_XXJ_WS_CREEP_NAMEKEY: "زحف",
  T_40_XXJ_WS_CROUCH_DESCKEY: "عرض عندما يكون صحيحًا، أو مغلقًا بخلاف ذلك",
  T_40_XXJ_WS_CROUCH_NAMEKEY: "انحن",
  T_40_XXJ_WS_CULLINGMASK_DESCKEY: "هذه هي طبقة عرض cullingMask الكاميرا. يمكنك تصفية كيان العرض باستخدام مستوى الطبقة المرئية.",
  T_40_XXJ_WS_CULLINGMASK_NAMEKEY: "cullingMask",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_DESCKEY: "معرف العلوي",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_NAMEKEY: "علوي",
  T_40_XXJ_WS_CUSTOMCLOTHFACEID_DESCKEY: "معرف طلاء الوجه",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_DESCKEY: "معرف الأحذية",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_NAMEKEY: "أحذية",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_DESCKEY: "معرف الرأس",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_NAMEKEY: "رأس",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_DESCKEY: "معرف طلاء الوجه",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_NAMEKEY: "قناع",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_DESCKEY: "معرف السفلي",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_NAMEKEY: "سفلي",
  T_40_XXJ_WS_CUSTOMCLOTHMAKEUP_NAMEKEY: "طلاء وجه",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_DESCKEY: "معرف الحزمة",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_NAMEKEY: "بذلة",
  T_40_XXJ_WS_CUSTOMXY_DESCKEY: "مقدار السحب في الاتجاه س ص",
  T_40_XXJ_WS_CUSTOMXY_NAMEKEY: "السحب س ص",
  T_40_XXJ_WS_DB: "قراءة قيمة الجدول",
  T_40_XXJ_WS_DB_DESC: "اقرأ القيمة المقابلة لمعرف معين في جدول معين في قاعدة البيانات.",
  T_40_XXJ_WS_DBDELETE_DESC: "احذف قيمة مقابلة لمعرف معين في جدول معين في قاعدة البيانات.",
  T_40_XXJ_WS_DBKEY_DESCKEY: "اسم مخصص يستخدم لتعريف البيانات",
  T_40_XXJ_WS_DBKEY_NAMEKEY: "المعرف",
  T_40_XXJ_WS_DBTABLENAME: "اسم جدول قاعدة البيانات",
  T_40_XXJ_WS_DBTABLENAME_DESC: "اسم الجدول في قاعدة البيانات.",
  T_40_XXJ_WS_DBVALUE_DESCKEY: "القيمة المراد كتابتها",
  T_40_XXJ_WS_DBWRITE: "اكتب قيمة الجدول",
  T_40_XXJ_WS_DBWRITE_DESC: "اكتب قيمة مقابلة لمعرف معين في جدول معين في قاعدة البيانات.",
  T_40_XXJ_WS_DEFENCEGRENADE_NAMEKEY: "ادفع المواد القابلة للرمي",
  T_40_XXJ_WS_DEFULT: "الإفتراضي",
  T_40_XXJ_WS_DELETELEADERBOARD_DESC: "حذف قيمة مقابلة لمفتاح معين في جدول لوحة متصدرين معين في قاعدة البيانات.",
  T_40_XXJ_WS_DELETELEADERBOARD2_DESC: "احذف قيمة مقابلة لتصنيف معين في جدول لوحة متصدرين معين في قاعدة البيانات.",
  T_40_XXJ_WS_DEPTH: "طبقة HUD",
  T_40_XXJ_WS_DEPTH_D: "الطبقة الأساسية لـ HUD",
  T_40_XXJ_WS_DICTANDLIST: "قائمة وقاموس",
  T_40_XXJ_WS_DICVALUE_DESCKEY: "قيمة القاموس المستهدف",
  T_40_XXJ_WS_DIFFUSEALPHA_DESCKEY: "شفافية السطح",
  T_40_XXJ_WS_DIR_DESCKEY: "متجه",
  T_40_XXJ_WS_DIRECTPOSVEC3_DESCKEY: "نقطة يتم توفيرها ويمكن استخدامها كنقاط إنعاش، إلخ.",
  T_40_XXJ_WS_DIRECTPOSVEC3_NAMEKEY: "إحداثيات",
  T_40_XXJ_WS_DISABLEALL: "إلغاء تحديد الكل",
  T_40_XXJ_WS_DISABLECOLOR_NAMEKEY: "اللون المعطل",
  T_40_XXJ_WS_DISTANT_DESCKEY: "مسافة كشف خط الكاميرا",
  T_40_XXJ_WS_DISTANT_NAMEKEY: "عرض المسافة",
  T_40_XXJ_WS_DRAGEFFECT_DESCKEY: "يدعم اتجاهات السحب المتعددة",
  T_40_XXJ_WS_DRAGEFFECT_NAMEKEY: "تأثير السحب",
  T_40_XXJ_WS_DRIVER_DESCKEY: "سائق المركبة",
  T_40_XXJ_WS_DRIVER_NAMEKEY: "سائق",
  T_40_XXJ_WS_EDITVALUE_DESCKEY: "تعديل قيمة",
  T_40_XXJ_WS_EFFECTACTIVE_DESCKEY: "عرض التأثيرات الخاصة",
  T_40_XXJ_WS_EFFECTACTIVE_NAMEKEY: "عرض التأثيرات الخاصة",
  T_40_XXJ_WS_EFFECTCOLOR_NAMEKEY: "لون التأثيرات",
  T_40_XXJ_WS_EFFECTENTITY_DESCKEY: "يمثل كيان التأثيرات الخاصة التأثير الخاص الذي سيتم عرضه",
  T_40_XXJ_WS_EFFECTENTITYGENERATOR_DESCKEY: "عنصر التأثيرات الخاصة",
  T_40_XXJ_WS_EMOTIONHUD_NAMEKEY: "تبديل HUD لإيموجي",
  T_40_XXJ_WS_ENABLEALL: "حدد الكل",
  T_40_XXJ_WS_ENABLELOGIC_DESCKEY: "ما إذا كان سيتم تشغيل تحديث المنطق. عند إيقاف التشغيل، ستتوقف الكتل الموجودة في هذا الكيان عن تحديث كل إطار.",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_DESCKEY: "عند كتابتها في سمات السلاح، ستتأثر الإحصائيات الأساسية للسلاح بغلاف السلاح",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_NAMEKEY: "اكتب سمة غلاف السلاح",
  T_40_XXJ_WS_ENTITY_DESCKEY: "الكيان هو وعاء يحتوي على جميع المكونات، والتي يجب إضافتها إلى الكيانات حتى يتم تنشيطها",
  T_40_XXJ_WS_ENTITY_NAMEKEY: "نوع الكيان",
  T_40_XXJ_WS_ENTITY1_DESCKEY: "المكون الأساسي للكيان. ستجمع جميع المكونات بين هذا المكون.",
  T_40_XXJ_WS_ENTITYVARNAME_DESCKEY: "الكيان المطلوب التحول إليه",
  T_40_XXJ_WS_ENTITYVARNAME11_DESCKEY: "اسم المعلمة المستخدم في الكود لتمثيل كيان عنصر تحكم واجهة المستخدم المخصص المُضاف حديثًا. قيمة العامل المحلي المقابل لها هي كيان عنصر تحكم واجهة المستخدم المخصصة المضافة حديثًا.",
  T_40_XXJ_WS_ENTITYVARNAME12_DESCKEY: "اسم عامل الكيان",
  T_40_XXJ_WS_ENTITYVARNAME13_DESCKEY: "اسم المعلمة المستخدم في الكود لتمثيل كيان الأيقونة التي تم إنشاؤها. قيمة المتغيرة المحلية المقابلة لها هي كيان الأيقونة التي تم إنشاؤها.",
  T_40_XXJ_WS_EPITEMHUD_NAMEKEY: "تبديل HUD لشريط EP",
  T_40_XXJ_WS_EULERANGLES_DESCKEY: "زوايا أويلر",
  T_40_XXJ_WS_FACINFECTION: "الفصيل (صعود الروبوتات)",
  T_40_XXJ_WS_FACINFECTION_DESC: "فصيل اللاعب. 1 = الإنسان، 2 = الزومبي.",
  T_40_XXJ_WS_FEMALE: "أنثى",
  T_40_XXJ_WS_FILLDIRECTION_DESCKEY: "اتجاه التعبئة",
  T_40_XXJ_WS_FILLDIRECTION_NAMEKEY: "فرز الاتجاه",
  T_40_XXJ_WS_FIRE_NAMEKEY: "نار",
  T_40_XXJ_WS_FLOATVALUE_DESCKEY: "القيمة الطافية",
  T_40_XXJ_WS_FOLLOWTARGET_DESCKEY: "الكيان المستهدف لمتابعة. فارغ بشكل افتراضي.",
  T_40_XXJ_WS_FONTSIZE_DESCKEY: "حجم النص",
  T_40_XXJ_WS_FONTSIZE_NAMEKEY: "حجم الخط",
  T_40_XXJ_WS_FONTSTYLE_DESCKEY: "نمط الخط",
  T_40_XXJ_WS_FOOTBALLGLOOWALL: "جدار جلو كرة القدم",
  T_40_XXJ_WS_FORMATSTYLE_DESCKEY: "أسلوب التنسيق",
  T_40_XXJ_WS_FORWARD_DESCKEY: "اتجاه اللاعب",
  T_40_XXJ_WS_FORWARD1_DESCKEY: "الاتجاه إلى النقل الآني",
  T_40_XXJ_WS_FREE_DESCKEY: "كاميرا قابلة للتحكم من قبل اللاعب ويمكن تحريكها بحرية",
  T_40_XXJ_WS_FREE_NAMEKEY: "الكاميرا الحرة",
  T_40_XXJ_WS_GENDER: "الجنس",
  T_40_XXJ_WS_GENDER_DESCKEY: "الجنس",
  T_40_XXJ_WS_GENDERTYPE_DESCKEY: "تعداد الجنس",
  T_40_XXJ_WS_GETCAMERACULLINGMASK_DESCKEY: "احصل على cullingMask الكاميرا",
  T_40_XXJ_WS_GETCHILDBYINDEX_DESCKEY: "يدعم فقط الكيانات التي تحتوي على مكون التحويل. مقيد حاليا لجميع العناصر.",
  T_40_XXJ_WS_GETCHILDREN_DESCKEY: "يدعم فقط الكيانات التي تحتوي على مكون التحويل. مقيد حاليا لجميع العناصر.",
  T_40_XXJ_WS_GETPARENT_DESCKEY: "يدعم فقط الكيانات التي تحتوي على مكون التحويل. مقيد حاليا لجميع العناصر.",
  T_40_XXJ_WS_GETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "احصل على معرف زي اللاعب",
  T_40_XXJ_WS_GETPLAYERRANK: "احصل على تصنيف اللاعب",
  T_40_XXJ_WS_GETPLAYERRANK_D: "احصل على التصنيف الإجمالي للاعب",
  T_40_XXJ_WS_GETPLAYERROUNDRANK: "احصل على تصنيف جولة اللاعب",
  T_40_XXJ_WS_GETPLAYERROUNDRANK_D: "احصل على تصنيف جولة محدد للاعب",
  T_40_XXJ_WS_GETPLAYERTOKENNUM_DESCKEY: "ابحث عن بيانات توكن اللاعب",
  T_40_XXJ_WS_GETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "احصل على غلاف سلاح اللاعب",
  T_40_XXJ_WS_GETRANDOMSPAWNPOSVEC3_DESCKEY: "احصل على مجموعة من الإحداثيات التي لم تشغلها نقاط الإنعاش العشوائية",
  T_40_XXJ_WS_GETSCENESKYBOX_DESCKEY: "احصل على صندوق مشهد السماء",
  T_40_XXJ_WS_GETSERVERREGION_DESCKEY: "احصل على منطقة الخادم",
  T_40_XXJ_WS_GETSERVERTIME_DESCKEY: "احصل على الطابع الزمني للخادم",
  T_40_XXJ_WS_GETTEAMMATENEARPOSVEC3_DESCKEY: "احصل على موقع بالقرب من زميلك في الفريق، وتجنب المناطق التي لا يمكن للاعبين الوقوف عليها",
  T_40_XXJ_WS_GETTEAMRANK: "احصل على تصنيف الفريق",
  T_40_XXJ_WS_GETTEAMRANK_D: "احصل على التصنيف الإجمالي للفريق",
  T_40_XXJ_WS_GETTEAMROUNDRANK: "احصل على تصنيف جولة الفريق",
  T_40_XXJ_WS_GETTEAMROUNDRANK_D: "احصل على تصنيف جولة محددة للفريق",
  T_40_XXJ_WS_GREEN: "أخضر",
  T_40_XXJ_WS_HALFEXTENTS_DESCKEY: "نصف أبعاد شكل ثلاثي الأبعاد",
  T_40_XXJ_WS_HEAD_DESCKEY: "رأس",
  T_40_XXJ_WS_HEAD_NAMEKEY: "الرأس",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_DESCKEY: "كيان تأثير نبضات القلب",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_NAMEKEY: "كيان تأثير نبضات القلب",
  T_40_XXJ_WS_HEIGHT_DESCKEY: "الإرتفاع",
  T_40_XXJ_WS_HINTBUTTONHUD_DESCKEY: "زر التلميح",
  T_40_XXJ_WS_HINTBUTTONHUD_NAMEKEY: "زر النصائح",
  T_40_XXJ_WS_HITPOINTEFFECT_DESCKEY: "الكيان الذي سيتم عرضه في الموقع المستهدف",
  T_40_XXJ_WS_HITPOINTEFFECT_NAMEKEY: "الكيان المستهدف",
  T_40_XXJ_WS_HITPOS_DESCKEY: "البقعة التي تم ضربها",
  T_40_XXJ_WS_HORIZONTALBAR_DESCKEY: "نوع العرض الأفقي",
  T_40_XXJ_WS_HORIZONTALBAR_NAMEKEY: "نوع العرض الأفقي",
  T_40_XXJ_WS_HOSTENTITYFOLLOW_DESCKEY: "الكيان الذي يتبع كيانًا آخر",
  T_40_XXJ_WS_HOSTENTITYLOOK_DESCKEY: "الكيان الذي ينظر إلى كيان آخر",
  T_40_XXJ_WS_HPITEMHUD_NAMEKEY: "تبديل HUD لشريط الصحة",
  T_40_XXJ_WS_HUDEMPTYPANEL_DESCKEY: "كيان إدخال HUD. هذا هو HUD الذي يقوم اللاعبون بتعديله من المحرر.",
  T_40_XXJ_WS_HUDEMPTYPANEL_NAMEKEY: "مكون اللوحة HUD فارغ",
  T_40_XXJ_WS_HUDENTITY_DESCKEY: "كيان HUD الذي تنتمي إليه",
  T_40_XXJ_WS_HUDGRID_DESCKEY: "كيان إخال HUD. إنه HUD الذي يقوم اللاعب بتحريره باستخدام المحرر.",
  T_40_XXJ_WS_HUDGRID_NAMEKEY: "مكون شبكة HUD",
  T_40_XXJ_WS_HUDPANEL_DESCKEY: "كيان إخال HUD. إنه HUD الذي يقوم اللاعب بتحريره باستخدام المحرر.",
  T_40_XXJ_WS_HUDPANEL_NAMEKEY: "مكون لوحة HUD",
  T_40_XXJ_WS_HUDSCROLLVIEW_DESCKEY: "كيان إخال HUD. إنه HUD الذي يقوم اللاعب بتحريره باستخدام المحرر.",
  T_40_XXJ_WS_HUDSCROLLVIEW_NAMEKEY: "مكون عرض التمرير HUD",
  T_40_XXJ_WS_HUMANMODELID_NAMEKEY: "معرف النموذج البشري",
  T_40_XXJ_WS_ICON_DESCKEY: "اسم مورد الأيقونة",
  T_40_XXJ_WS_ICON_NAMEKEY: "أيقونة",
  T_40_XXJ_WS_ICON1_DESCKEY: "حدد أيقونة",
  T_40_XXJ_WS_ICONENTITY_DESCKEY: "كيان الأيقونة يمثل الأيقونة التي سيتم عرضها",
  T_40_XXJ_WS_ICONPATH_DESCKEY: "مسار الموارد. المورد المدمج في:المسار. المورد المخصص خارج:المسار. فارغ بشكل افتراضي.",
  T_40_XXJ_WS_ICONSPRITENAME_DESCKEY: "اسم الأيقونة",
  T_40_XXJ_WS_ICONSPRITENAME_NAMEKEY: "اسم الأيقونة",
  T_40_XXJ_WS_ICONTYPE_DESCKEY: "مسار الموارد. فارغ بشكل افتراضي.",
  T_40_XXJ_WS_INCLUDETRIGGER_DESCKEY: "ما إذا كان يمكنه البحث عن الزناد",
  T_40_XXJ_WS_INDEX_DESCKEY: "مؤشر الفرع يقع تحت المؤشر الرئيسي",
  T_40_XXJ_WS_INITIALVALUE_NAMEKEY: "القيمة الأولية [0، 1]",
  T_40_XXJ_WS_INTVALUE_DESCKEY: "قيمة العدد الصحيح",
  T_40_XXJ_WS_IS3D: "تأثير الصوت ثلاثي الأبعاد",
  T_40_XXJ_WS_ISBILLBOARD_DESCKEY: "دائمًا مواجهاً للكاميرا",
  T_40_XXJ_WS_ISBOLD_NAMEKEY: "غامق",
  T_40_XXJ_WS_ISBYORDER_D: "اكتشف ما إذا كان يجب على اللاعبين تشغيل عنصر المرحلة بترتيب زمني",
  T_40_XXJ_WS_ISFEBUTTON_NAMEKEY: "هو زر FirEditor",
  T_40_XXJ_WS_ISHIT_DESCKEY: "ما إذا كان خط الكاميرا قد أصاب الكيان",
  T_40_XXJ_WS_ISINCULLINGMASK_DESCKEY: "ما إذا كان مرئيًا لطبقة معينة",
  T_40_XXJ_WS_ISITALIC_NAMEKEY: "مائل",
  T_40_XXJ_WS_ISSHOWSCAN_DESCKEY: "ما إذا كان قد تم تمييزه بالمسح الضوئي",
  T_40_XXJ_WS_ISSHOWSCAN_NAMECKEY: "ممسوحة أم لا",
  T_40_XXJ_WS_ISSHOWTAG_DESCKEY: "ما إذا تم تمييزه بواسطة زر الإشارة",
  T_40_XXJ_WS_ISTRIGGER: "الزناد",
  T_40_XXJ_WS_ISUNDERLINE_NAMEKEY: "مسطر",
  T_40_XXJ_WS_ITEMID_DESCKEY: "معرف العنصر المقابل للكيان",
  T_40_XXJ_WS_ITEMID_NAMEKEY: "معرف العنصر",
  T_40_XXJ_WS_ITEMID1_DESCKEY: "معرّف العنصر (يتوفر معرّف السلاح فقط في الإصدار الحالي)",
  T_40_XXJ_WS_ITEMID2_DESCKEY: "معرف العنصر للسلاح",
  T_40_XXJ_WS_ITEMID3_DESCKEY: "معرف العنصر",
  T_40_XXJ_WS_JAILBREAKAREA_DESCKEY: "منطقة متروبوليس",
  T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY: "منطقة متروبوليس",
  T_40_XXJ_WS_JUMP_NAMEKEY: "قفز",
  T_40_XXJ_WS_KEY_DESCKEY: "قيمة المفتاح",
  T_40_XXJ_WS_KEY_NAMEKEY: "مفتاح",
  T_40_XXJ_WS_KEYNAME_DESCKEY: "اسم المفتاح لاجتيازه. يمكنك استخدام هذا للحصول على قيمة مفتاح في عامل محلي.",
  T_40_XXJ_WS_KILLINGTIPS_NAMEKEY: "إعلان الإقصاء",
  T_40_XXJ_WS_LABELCOLOR_NAMEKEY: "لون الخط",
  T_40_XXJ_WS_LANDMINEOBJ: "الكيان بعد إنشاء الألغام الأرضية",
  T_40_XXJ_WS_LAYERMASK_DESCKEY: "قناع طبقة الاصطدام. لن يتم تضمين الطبقات التي لم يتم تحديدها في المسح. عندما تكون فارغة، سيتم تضمين جميع الطبقات في المسح.",
  T_40_XXJ_WS_LAYERSEDIT: "تعديل الطبقات",
  T_40_XXJ_WS_LAYERSETTING: "إعدادات الطبقة المرئية",
  T_40_XXJ_WS_LAYERTYPE_DESCKEY: "طبقة الاصطدام للكشف عن خط الكاميرا",
  T_40_XXJ_WS_LAYERTYPE_NAMEKEY: "طبقة",
  T_40_XXJ_WS_LAYOUTTYPE_DESCKEY: "نوع التخطيط",
  T_40_XXJ_WS_LAYOUTTYPE_NAMEKEY: "نوع التخطيط",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD: "مكون HUD للوحة النتائج",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD_D: "كيان HUD في لوحة النتائج. سيؤثر تعديل خصائص الكيان على المحتوى الذي سيتم عرضه في واجهة المستخدم المقابلة.",
  T_40_XXJ_WS_LEADERBOARDNAME: "اسم قائمة المتصدرين",
  T_40_XXJ_WS_LEADERBOARDNAME_DESC: "اسم جدول قائمة المتصدرين في قاعدة البيانات.",
  T_40_XXJ_WS_LEAVEACCELERATION_DESCKEY: "التسريع عند التأرجح",
  T_40_XXJ_WS_LEAVEACCELERATION_NAMEKEY: "ترك التسريع",
  T_40_XXJ_WS_LEFTARM_DESCKEY: "الذراع اليسرى",
  T_40_XXJ_WS_LEFTARM_NAMEKEY: "الذراع اليسرى",
  T_40_XXJ_WS_LEFTCOLOR_DESCKEY: "لون اليسار",
  T_40_XXJ_WS_LEFTCOLOR_NAMEKEY: "لون اليسار",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_DESCKEY: "ما إذا كان سيتم عرض التأثيرات الخاصة على اليسار",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_NAMEKEY: "عرض التأثير الأيسر أم لا",
  T_40_XXJ_WS_LEFTFOOT_DESCKEY: "القدم اليسرى",
  T_40_XXJ_WS_LEFTFOOT_NAMEKEY: "القدم اليسرى",
  T_40_XXJ_WS_LEFTHAND_DESCKEY: "اليد اليسرى",
  T_40_XXJ_WS_LEFTHAND_NAMEKEY: "اليد اليسرى",
  T_40_XXJ_WS_LEFTICON_DESCKEY: "الأيقونة اليسرى",
  T_40_XXJ_WS_LEFTICON_NAMEKEY: "الأيقونة اليسرى",
  T_40_XXJ_WS_LEFTLEG_DESCKEY: "الساق اليسرى",
  T_40_XXJ_WS_LEFTLEG_NAMEKEY: "الساق اليسرى",
  T_40_XXJ_WS_LEFTSCORETEXT_DESCKEY: "نص النتيجة اليسرى",
  T_40_XXJ_WS_LEFTSCORETEXT_NAMEKEY: "نص النتيجة اليسرى",
  T_40_XXJ_WS_LEFTTEXT_DESCKEY: "النص الأيسر",
  T_40_XXJ_WS_LEFTTEXT_NAMEKEY: "النص الأيسر",
  T_40_XXJ_WS_LERP_DESCKEY: "تقع t بين 0 و 1. عندما تكون t = 0، العودة من. عندما تكون t = 1، العودة إلى. عندما تكون t = 0.5، عد متوسط القيم من و إلى.",
  T_40_XXJ_WS_LEVELOBJECT: "عنصر المرحلة",
  T_40_XXJ_WS_LINESPACING_NAMEKEY: "تباعد الأسطر",
  T_40_XXJ_WS_LISTFINDMAX_DESCKEY: "قارن القيم في قائمة وأعد أكبرها",
  T_40_XXJ_WS_LISTFINDMIN_DESCKEY: "قارن القيم في قائمة وأعد أصغرها",
  T_40_XXJ_WS_LISTORMAP_NAMEKEY: "قائمة أو قاموس",
  T_40_XXJ_WS_LOCALPOSITION: "الموقف المحلي",
  T_40_XXJ_WS_LOCALROTA: "زوايا أويلر المحلية",
  T_40_XXJ_WS_LOCALROTATIONQ: "دوران الرباعي المحلي",
  T_40_XXJ_WS_LOCALSACLE: "المقياس المحلي",
  T_40_XXJ_WS_LOCSWITCH_NAMEKEY: "تبديل الترجمة",
  T_40_XXJ_WS_LOOPRANGE_DESCKEY: "الحاوية لاجتيازها",
  T_40_XXJ_WS_MALE: "ذكر",
  T_40_XXJ_WS_MAPCLEAR_DESCKEY: "قم بإزالة القاموس",
  T_40_XXJ_WS_MAPGETLENGTH_DESCKEY: "احصل على طول القاموس",
  T_40_XXJ_WS_MAPGETVALUE_DESCKEY: "احصل على قيمة المفتاح المعين في عنصر القاموس",
  T_40_XXJ_WS_MAPREMOVEVALUE_DESCKEY: "قم بإزالة زوج المفتاح والقيمة المعين في القاموس",
  T_40_XXJ_WS_MAPSETVALUE_DESCKEY: "تكوين قيمة مفتاح معين في القاموس",
  T_40_XXJ_WS_MAPSIZE_DESCKEY: "حجم الخريطة المصغرة. عرضه وارتفاعه متساويان.",
  T_40_XXJ_WS_MAPSIZE_NAMEKEY: "حجم الخريطة",
  T_40_XXJ_WS_MAPT: "نموذج القاموس",
  T_40_XXJ_WS_MAPT_D: "نموذج البيانات للقاموس. يمكنك تعيين نوع المحتوى من خلال T1 و T2.",
  T_40_XXJ_WS_MAPVALUE_D: "حاوية بيانات للقاموس. العنصر هو زوج يتكون من مفتاح وقيمة.",
  T_40_XXJ_WS_MAPVALUE_DESCKEY: "القاموس الهدف",
  T_40_XXJ_WS_MAPVALUE_NAMEKEY: "قاموس",
  T_40_XXJ_WS_MASKNAME_DESCKEY: "نوع القناع هو اسم الصورة المستخدم عند التقنيع",
  T_40_XXJ_WS_MASKNAME_NAMEKEY: "اسم القناع",
  T_40_XXJ_WS_MASS_DESCKEY: "الكتلة (في كج)",
  T_40_XXJ_WS_MASS_NAMEKEY: "الكتلة (كج)",
  T_40_XXJ_WS_MAX_DESCKEY: "قارن بين قيمتين وأعد القيم الأكبر",
  T_40_XXJ_WS_MAXLENGTH_NAMEKEY: "الطول الأقصى",
  T_40_XXJ_WS_MAXNUM_DESCKEY: "القيمة القصوى",
  T_40_XXJ_WS_MAXWIDGETID_DESCKEY: "معرّف المكون الأكبر",
  T_40_XXJ_WS_MAXWIDGETID_NAMEKEY: "أقصى معرّف للواجهة",
  T_40_XXJ_WS_MEDICALPROPSHUD_NAMEKEY: "عناصر الشفاء",
  T_40_XXJ_WS_MIN_DESCKEY: "قارن بين قيمتين وأعد القيم الأصغر",
  T_40_XXJ_WS_MINIMAP_NAMEKEY: "مكون الخريطة المصغرة",
  T_40_XXJ_WS_MINIMAPBIT_NAMEKEY: "بكسل الخريطة المصغرة",
  T_40_XXJ_WS_MINIMAPICON_NAMEKEY: "أيقونة الخريطة المصغرة",
  T_40_XXJ_WS_MINMAPHUD_NAMEKEY: "خريطة مصغرة",
  T_40_XXJ_WS_MINNUM_DESCKEY: "الحد الأدنى للقيمة",
  T_40_XXJ_WS_MOMENTUMAMOUNT_DESCKEY: "عامل الزخم. كلما زادت القيمة، زاد الزخم أثناء التمرير.",
  T_40_XXJ_WS_MOMENTUMAMOUNT_NAMEKEY: "عامل الزخم",
  T_40_XXJ_WS_MOVINGJOYSTICK_NAMEKEY: "حركة آلة التحكم",
  T_40_XXJ_WS_MRESULT_DESCKEY: "نتيجة المباراة",
  T_40_XXJ_WS_NEWENTITY_D: "كيان العنصر الجديد بعد الإنشاء (قد يكون فارغًا)",
  T_40_XXJ_WS_NEWMAP_DESCKEY: "أنشئ قاموسًا جديدًا",
  T_40_XXJ_WS_NEWMAP_NAMEKEY: "القاموس الجديد",
  T_40_XXJ_WS_NORMAL1_DESCKEY: "الاتجاه الطبيعي للضربة",
  T_40_XXJ_WS_NORMALIZEDPOSITION_DESCKEY: "موضع HUD [0،1]",
  T_40_XXJ_WS_NORMALIZEDPOSITION_NAMEKEY: "موضع HUD",
  T_40_XXJ_WS_NUMLIST_DESCKEY: "قائمة لتحويل المؤشرات إلى أرقام",
  T_40_XXJ_WS_OBJECT_DESCKEY: "العنصر الذي يضربه مسدس الرش",
  T_40_XXJ_WS_OBSOLETE: "تم الحذف، لأسباب تتعلق بالسلامة، يرجى استبدال هذه الكتلة.",
  T_40_XXJ_WS_OFFSET_DESCKEY: "موضع العرض. عندما يكون هناك هدف متبوع، يكون هذا هو الإزاحة بين الموضع الجديد والموضع الأصلي. عندما لا يكون هناك هدف متبع، تكون إحداثيات الشاشة (الافتراضي هو المتجه 3 (0)).",
  T_40_XXJ_WS_OFFSET2_DESCKEY: "إحداثيات الشاشة (الافتراضي هو المتجه 3 (0)).",
  T_40_XXJ_WS_OFFSET3_DESCKEY: "موضع العرض. عندما يكون هناك هدف متبوع، يكون هذا هو الإزاحة بين الموضع الجديد والموضع الأصلي. عندما لا يكون هناك هدف متبع، تكون إحداثيات الشاشة (الافتراضي هو المتجه 3 (0)).",
  T_40_XXJ_WS_OFFSET4_DESCKEY: "موضع العرض (المرساة في الزاوية اليمنى العليا)",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_DESCKEY: "الإزاحة الأفقية",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_NAMEKEY: "الإزاحة الأفقية",
  T_40_XXJ_WS_OFFSETUPDOWN_DESCKEY: "الإزاحة العمودية",
  T_40_XXJ_WS_OFFSETUPDOWN_NAMEKEY: "الإزاحة العمودية",
  T_40_XXJ_WS_OK_DESCKEY: "التحويل ناجح",
  T_40_XXJ_WS_ONAISTARTATTACK_DESCKEY: "قم بتشغيل هذا الحدث عندما يدخل الكيان المنطقة المجاورة للهجوم",
  T_40_XXJ_WS_ONAISTARTCHASE_DESCKEY: "قم بتشغيل هذا الحدث عندما يدخل الكيان إلى منطقة المطاردة المجاورة",
  T_40_XXJ_WS_ONAISTOPATTACK_DESCKEY: "قم بتشغيل هذا الحدث عندما يغادر الكيان المنطقة المجاورة للهجوم",
  T_40_XXJ_WS_ONAISTOPCHASE_DESCKEY: "قم بتشغيل هذا الحدث عندما يغادر الكيان المنطقة المجاورة للهجوم",
  T_40_XXJ_WS_ONCLIENTCAMERARAYCAST_DESCKEY: "قم بتشغيل اكتشاف خط الكاميرا من خلال العميل",
  T_40_XXJ_WS_ONCOLLISION_D: "الكيانات التي لديها مكون المصادم الملحق فقط تدعم هذا الحدث",
  T_40_XXJ_WS_ONSPRAYENTITY_DESCKEY: "قم بتشغيل هذا الحدث عندما يضرب مسدس الرش كيانًا",
  T_40_XXJ_WS_ONSTOPFIRE_DESCKEY: "عندما يتوقف إطلاق النار",
  T_40_XXJ_WS_ONSWITCHPLAYERAREA_DESCKEY: "عندما يقوم اللاعب بتبديل منطقة المشهد",
  T_40_XXJ_WS_OPENSTATE_DESCKEY: "عرض عندما تكون الحالة المفتوحة صحيحة، أو مغلقة بخلاف ذلك",
  T_40_XXJ_WS_OPENSTATE_NAMEKEY: "افتح الحالة",
  T_40_XXJ_WS_ORANGE: "أورانج",
  T_40_XXJ_WS_ORDER_DESC: "التصنيف على قائمة المتصدرين",
  T_40_XXJ_WS_ORDER1: "تصنيف البداية",
  T_40_XXJ_WS_ORDER2: "التصنيف النهائي",
  T_40_XXJ_WS_ORIGINAL: "احتفظ بالمنطق الأصلي",
  T_40_XXJ_WS_OVERFLOW_NAMEKEY: "طريقة الفائض",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_DESCKEY: "عند إعطاء الأولوية، ستحل سمات سلاح اللاعب محل سمات السلاح الأصلية",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_NAMEKEY: "إعطاء الأولوية لغلاف سلاح اللاعب",
  T_40_XXJ_WS_OWNER_DESCKEY: "اللاعب الذي يملك هذا الكيان",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_DESCKEY: "UID العالمي لمشهد الفرع الذي ينتمي إليه",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_NAMEKEY: "UID العالمي من مشهد الفرع",
  T_40_XXJ_WS_PARENT_DESCKEY: "الكيان الرئيسي",
  T_40_XXJ_WS_PARENT_NAMEKEY: "الرئيس",
  T_40_XXJ_WS_PARENTENTITYID_NAMEKEY: "معرف كيان المكون الرئيسي",
  T_40_XXJ_WS_PARENTWIDGETFILEID_DESCKEY: "معرف ملف المكون الرئيسي",
  T_40_XXJ_WS_PASSENGERS_DESCKEY: "جميع الركاب في المركبة",
  T_40_XXJ_WS_PASSENGERS_NAMEKEY: "راكب",
  T_40_XXJ_WS_PHYSICALLAYER: "الطبقة المادية",
  T_40_XXJ_WS_PHYSICALLAYERMATRIX: "مصفوفة الطبقة المادية",
  T_40_XXJ_WS_PHYSICALTIP1: "الاسم موجود بالفعل",
  T_40_XXJ_WS_PHYSICALTIP2: "قم بإزالة اسم طبقة واجعله غير مرئي في مصفوفة الطبقة المادية وتعداد الطبقة، لكن عناصر الكيان داخل تلك الطبقة لن تتأثر.",
  T_40_XXJ_WS_PHYSICS: "المادية",
  T_40_XXJ_WS_PICKUPLISTHUD_NAMEKEY: "مفتاح تبديل لقائمة النهب HUD",
  T_40_XXJ_WS_PLAYABLE_DESCKEY: "كيان قابل للعب",
  T_40_XXJ_WS_PLAYABLELOOKAT_DESCKEY: "يواجه الكيان دائمًا كيانًا آخر",
  T_40_XXJ_WS_PLAYABLEPOSFOLLOW_DESCKEY: "يتبع الكيان كيانًا آخر",
  T_40_XXJ_WS_PLAYABLETRAJECTORY_DESCKEY: "الرسوم المتحركة لمسار الرصاصة هي محاكاة لمسار الرصاصة",
  T_40_XXJ_WS_PLAYER1_DESCKEY: "اللاعب الذي يتلقى الرسالة",
  T_40_XXJ_WS_PLAYERAVATAR_DESCKEY: "الصورة المستخدمة من قبل اللاعب",
  T_40_XXJ_WS_PLAYERAVATARINFO_DESCKEY: "الزي المجهز من قبل اللاعب",
  T_40_XXJ_WS_PLAYERAVATARINFO_NAMEKEY: "زي اللاعب",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_DESCKEY: "نوع HUD للاعب",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_NAMEKEY: "نوع HUD للاعب",
  T_40_XXJ_WS_PLAYERIDINFAC: "رقم الفصيل المسلسل",
  T_40_XXJ_WS_PLAYERLOG_DESCKEY: "اللاعب المطلوب التسجيل في السجل",
  T_40_XXJ_WS_PLAYERREMOVETOKEN_DESCKEY: "استهلك توكن لاعب معين",
  T_40_XXJ_WS_PLAYERSKILLS_DESCKEY: "قائمة مهارات اللاعب",
  T_40_XXJ_WS_PLAYERSTATETYPE_DESCKEY: "حالة اللاعب: على قيد الحياة أو السقوط أو الإقصاء",
  T_40_XXJ_WS_PLAYSPEED_DESCKEY: "سرعة التشغيل",
  T_40_XXJ_WS_PLAYSPEED_NAMEKEY: "سرعة التشغيل",
  T_40_XXJ_WS_PLAYSPEED1_DESCKEY: "المثال، 1.25 تعني 25% أسرع من السرعة الأصلية",
  T_40_XXJ_WS_POS_DESCKEY: "الإحداثيات للنقل الآني",
  T_40_XXJ_WS_PRESENTEFFECTTEXTYPE_DESCKEY: "نوع الملصق المؤثرات الخاصة",
  T_40_XXJ_WS_PRESSEDCOLOR_NAMEKEY: "اللون عند الضغط",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_DESCKEY: "ينفذ عملية اجتياز للحاوية للحصول على زوج المفتاح والقيمة. يتضمن عملية فرعية، وهي الحلقة.",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY: "زيارة القاموس الحلقي",
  T_40_XXJ_WS_PROGRESS_DESCKEY: "التقدم [0,1]",
  T_40_XXJ_WS_PROGRESS_NAMEKEY: "التقدم [0,1]",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_DESCKEY: "الزر لتقدم المهارة",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_NAMEKEY: "زر تقدم المهارة",
  T_40_XXJ_WS_QUATERNION: "دوران الرباعي",
  T_40_XXJ_WS_QUICKCHATHUD_NAMEKEY: "تبديل HUD للرسائل السريعة",
  T_40_XXJ_WS_QUICKCHATSHOWHUD_NAMEKEY: "الرسائل بجانب قائمة الفريق",
  T_40_XXJ_WS_RADIUS_DESCKEY: "نصف قطر نصف دائرة لشكل حبوب منع الحمل",
  T_40_XXJ_WS_READCELL: "اقرأ الخلية A",
  T_40_XXJ_WS_READCSV: "قراءة محتوى الجدول",
  T_40_XXJ_WS_READCSV_DESC: "اقرأ المحتوى على الجدول بأكمله. إرجاع مجموعة ثنائية الأبعاد.",
  T_40_XXJ_WS_READCSVCELL: "اقرأ حسب رقم الصف واسم العمود",
  T_40_XXJ_WS_READCSVCOL_DESC: "اقرأ محتوى عمود معين على الجدول. إرجاع مجموعة.",
  T_40_XXJ_WS_READCSVROW_DESC: "اقرأ محتوى صف معين على الجدول. إرجاع مجموعة.",
  T_40_XXJ_WS_READLEADERBOARD: "اقرأ قيمة قائمة المتصدرين",
  T_40_XXJ_WS_READLEADERBOARD_DESC: "اقرأ القيمة المقابلة لمعرف معين في جدول قائمة المتصدرين في قاعدة البيانات.",
  T_40_XXJ_WS_READLEADERBOARD2: "قراءة حسب نطاق التصنيف",
  T_40_XXJ_WS_READLEADERBOARD2_DESC: "اقرأ قيمة الفرق بين تصنيف معين إلى تصنيف معين على قائمة المتصدرين في قاعدة البيانات.",
  T_40_XXJ_WS_RED: "أحمر",
  T_40_XXJ_WS_RELOAD: "إعادة التحميل",
  T_40_XXJ_WS_RENDERTYPE_DESCKEY: "طريقة العرض",
  T_40_XXJ_WS_RESETPLAYERCLOTHES_DESCKEY: "استعادة الزي الافتراضي للاعب",
  T_40_XXJ_WS_RESETPLAYERWEAPONSKINBYWEAPONID_DESCKEY: "استعادة الغلاف الافتراضي لسلاح اللاعب",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_DESCKEY: "ما إذا كان السحب مقيدًا بمنطقة العرض. محدد بشكل افتراضي.",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_NAMEKEY: "تقييد السحب أم لا",
  T_40_XXJ_WS_RESULT_DESCKEY: "نتيجة القراءة",
  T_40_XXJ_WS_RESULT_NAMEKEY: "النتيجة",
  T_40_XXJ_WS_RESULT1_DESCKEY: "ما إذا كان سيتم العثور على أكبر رقم في القائمة",
  T_40_XXJ_WS_RESULT2_DESCKEY: "ما إذا كان سيتم العثور على أصغر رقم في القائمة",
  T_40_XXJ_WS_RESULTVALUE_DESCKEY: "ابحث عن أصغر رقم في القائمة",
  T_40_XXJ_WS_RESULTVALUE1_DESCKEY: "ابحث عن أكبر رقم في القائمة",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_DESCKEY: "نقطة إنعاش اللاعب. إذا لم تكن هناك نقاط تسجيل، فاستخدم نقطة إنعاش. خلاف ذلك استخدام نقاط التسجيل.",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_NAMEKEY: "نقطة الإحياء",
  T_40_XXJ_WS_RIGHTARM_DESCKEY: "الذراع اليمنى",
  T_40_XXJ_WS_RIGHTARM_NAMEKEY: "الذراع اليمنى",
  T_40_XXJ_WS_RIGHTCOLOR_DESCKEY: "لون اليمين",
  T_40_XXJ_WS_RIGHTCOLOR_NAMEKEY: "لون اليمين",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_DESCKEY: "ما إذا كان سيتم عرض التأثيرات الخاصة على اليمين",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_NAMEKEY: "عرض التأثير الأيمن أم لا",
  T_40_XXJ_WS_RIGHTFOOT_DESCKEY: "القدم اليمنى",
  T_40_XXJ_WS_RIGHTFOOT_NAMEKEY: "القدم اليمنى",
  T_40_XXJ_WS_RIGHTHAND_DESCKEY: "اليد اليمنى",
  T_40_XXJ_WS_RIGHTHAND_NAMEKEY: "اليد اليمنى",
  T_40_XXJ_WS_RIGHTICON_DESCKEY: "الأيقونة اليمنى",
  T_40_XXJ_WS_RIGHTICON_NAMEKEY: "الأيقونة اليمنى",
  T_40_XXJ_WS_RIGHTLEG_DESCKEY: "الساق اليمنى",
  T_40_XXJ_WS_RIGHTLEG_NAMEKEY: "الساق اليمنى",
  T_40_XXJ_WS_RIGHTSCORETEXT_DESCKEY: "نص النتيجة اليمنى",
  T_40_XXJ_WS_RIGHTSCORETEXT_NAMEKEY: "نص النتيجة اليمنى",
  T_40_XXJ_WS_RIGHTTEXT_DESCKEY: "النص الأيمن",
  T_40_XXJ_WS_RIGHTTEXT_NAMEKEY: "النص الأيمن",
  T_40_XXJ_WS_RIGIDBODY_DESCKEY: "مكون نوع الجسم الصلب",
  T_40_XXJ_WS_RIGIDBODY_NAMEKEY: "مكون الجسم الصلب",
  T_40_XXJ_WS_RIGIDBODYTYPE_DESCKEY: "تعداد نوع الجسم الصلب",
  T_40_XXJ_WS_RIGIDBODYTYPE_NAMEKEY: "تعداد نوع الجسم الصلب",
  T_40_XXJ_WS_ROW_DECS: "الصف للقراءة.",
  T_40_XXJ_WS_ROWVALUE: "محتوى الصف",
  T_40_XXJ_WS_SCALE_DESCKEY: "تكوين مقياس التكبير للعنصر",
  T_40_XXJ_WS_SCALE_NAMEKEY: "حجم",
  T_40_XXJ_WS_SCALE0_DESCKEY: "مقياس التكبير لسلسلة الإحداثيات في العالم",
  T_40_XXJ_WS_SCALE1_DESCKEY: "مقياس التكبير. 1 افتراضيًا.",
  T_40_XXJ_WS_SCALECALUE_DESCKEY: "قيمة المقياس",
  T_40_XXJ_WS_SCENENAME_DESCKEY: "اسم المنطقة",
  T_40_XXJ_WS_SCOREBARHUD_DESCKEY: "شريط النتائج",
  T_40_XXJ_WS_SCOREBARHUD_NAMEKEY: "شريط النتائج",
  T_40_XXJ_WS_SCROLLDIRECTION_DESCKEY: "يدعم اتجاهات التمرير المتعددة",
  T_40_XXJ_WS_SCROLLDIRECTION_NAMEKEY: "اتجاه التمرير",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_DESCKEY: "عامل التمرير. كلما زادت القيمة، زادت سرعة التمرير.",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_NAMEKEY: "عامل التمرير",
  T_40_XXJ_WS_SETCAMERACULLINGMASK_DESCKEY: "تكوين cullingMask الكاميرا",
  T_40_XXJ_WS_SETGLOBAL: "تعيين عالمي",
  T_40_XXJ_WS_SETPARENT_D: "يدعم فقط الكيانات التي تحتوي على مكون التحويل",
  T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "تكوين معرف الزي الخاص باللاعب",
  T_40_XXJ_WS_SETPLAYERCLOTHIDS_DESCKEY: "قم بتعديل ملابس اللاعبين المتعددة",
  T_40_XXJ_WS_SETPLAYERFORWAR: "ضبط اتجاه اللاعب",
  T_40_XXJ_WS_SETPLAYERHUBSWITCH_DESCKEY: "تكوين تبديل HUD للاعب",
  T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "تكوين مظهر سلاح اللاعب",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_DESCKEY: "ما إذا كان سيتم عرض الكيانات في الموقع المستهدف",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_NAMEKEY: "عرض الكيان على الهدف",
  T_40_XXJ_WS_SHOWPLAYER: "عرض الكيان",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD: "كيان HUD لتفاصيل مباراة اللاعب الفردي",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD_D: "كيان HUD للمباريات الفردية. سيؤثر تعديل خصائص الكيان على المحتوى الذي سيتم عرضه في واجهة المستخدم المقابلة.",
  T_40_XXJ_WS_SIZEDELTA: "حجم دلتا صندوق المرساة والعنصر",
  T_40_XXJ_WS_SKELETON: "هيكل عظمي",
  T_40_XXJ_WS_SKELETON_D: "يستخدم المحور للوصول إلى قناع الهيكل العظمي",
  T_40_XXJ_WS_SKELETONPART_NAMEKEY: "جزء الهيكل العظمي",
  T_40_XXJ_WS_SKILLBUTTONHUD: "كيان HUD لزر المهارة",
  T_40_XXJ_WS_SLOT_DESCKEY: "فتحة السلاح",
  T_40_XXJ_WS_SMOOTHDRAGSTART_DESCKEY: "عند التحديد، ستكون هناك حركة بطيئة عند السحب. عند عدم التحديد، يتوافق السحب مع سرعة الماوس.",
  T_40_XXJ_WS_SMOOTHDRAGSTART_NAMEKEY: "الحركة السلسة أم لا",
  T_40_XXJ_WS_SOFTNESS_DESCKEY: "نعومة",
  T_40_XXJ_WS_SOFTNESS_NAMEKEY: "نعومة",
  T_40_XXJ_WS_SOUNDNTITY_NAMEKEY: "كيان الصوت",
  T_40_XXJ_WS_SPACE_DESCKEY: "مساحة",
  T_40_XXJ_WS_SPACE_NAMEKEY: "تباعد الخلايا الفرعية",
  T_40_XXJ_WS_SPAWNPOSVEC3_DESCKEY: "إحداثيات نقطة إنعاش الذكاء الاصطناعي",
  T_40_XXJ_WS_SPAWNPOSVEC3_NAMEKEY: "إحداثيات نقطة الإنعاش",
  T_40_XXJ_WS_SPEED_DESCKEY: "سرعة",
  T_40_XXJ_WS_SPEED_NAMEKEY: "سرعة",
  T_40_XXJ_WS_SPEEDUP_NAMEKEY: "اركض",
  T_40_XXJ_WS_SPHERERADIUS_DESCKEY: "نصف قطر الكرة",
  T_40_XXJ_WS_SPRAYCOLOR_DESCKEY: "لون الرش",
  T_40_XXJ_WS_SPRAYCOLOR_NAMEKEY: "لون الرش",
  T_40_XXJ_WS_SPRAYRESULTHUD_DESCKEY: "نتيجة الرش",
  T_40_XXJ_WS_SPRAYRESULTHUD_NAMEKEY: "نتيجة الرش",
  T_40_XXJ_WS_SPRAYRIFLE_DESCKEY: "مسدس الرش (سلاح اتوماتيكي)",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY: "بندقية رش",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY_01: "السرعة الأولية",
  T_40_XXJ_WS_SPRITEFLIP_NAMEKEY: "اقلب الملصق",
  T_40_XXJ_WS_SPRITEID: "معرف أصول النقش المتحرك",
  T_40_XXJ_WS_SPRITEID_D: "المعرف المستخدم لوصف أصل النقش المتحرك",
  T_40_XXJ_WS_SPRITETYPE_NAMEKEY: "نوع الملصق",
  T_40_XXJ_WS_STARGETENTITY_DESCKEY: "الكيان المستهدف لتوليد إلى بكسل ثابت",
  T_40_XXJ_WS_STARTPOSITION_D: "إحداثيات المركز الهندسي للشكل",
  T_40_XXJ_WS_STAY_D: "الاحتفاظ بالموقع العالمي الحالي، والتناوب، وتوسيع نطاق الفرع؟ يتم تعيين هذا بشكل عام على أنه صحيح، وإعدادات واجهة المستخدم غير فعالة لهذا الخيار.",
  T_40_XXJ_WS_STRING_NAMEKEY: "سلسلة",
  T_40_XXJ_WS_STRING2FLOAT_DESCKEY: "تحويل سلسلة إلى قيمة طافية",
  T_40_XXJ_WS_STRING2INT_DESCKEY: "تحويل سلسلة إلى عدد صحيح",
  T_40_XXJ_WS_STYLE_DESCKEY: "طريقة اللعب من الاستيفاء. تتضمن الخيارات التشغيل مرة واحدة والتكرار واللعب مرة أخرى.",
  T_40_XXJ_WS_SWITCHPLAYERAREA_DESCKEY: "تبديل منطقة اللاعب",
  T_40_XXJ_WS_SWITCHVALUE_DESCKEY: "تبديل القيمة",
  T_40_XXJ_WS_SWITCHWEAPONBYSLOT_DESCKEY: "تبديل الأسلحة وفقاً لفتحة اللاعب",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_DESCKEY: "قم بتبديل فتحة العنصر",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_NAMEKEY: "تبديل العنصر",
  T_40_XXJ_WS_TABLENAME_DESC: "يتم عرضه كاسم للجدول ولكنه في الواقع UID",
  T_40_XXJ_WS_TABLEVALUE: "محتوى الجدول",
  T_40_XXJ_WS_TAGSLIST_DESCKEY: "قائمة العلامات",
  T_40_XXJ_WS_TARGET_DESCKEY: "الكيان المستهدف لإنشاء بكسل الخريطة. فارغ بشكل افتراضي.",
  T_40_XXJ_WS_TARGET_NAMEKEY: "كيان لإنشاء خريطة بكسل",
  T_40_XXJ_WS_TARGETATK_DESCKEY: "اهجم الهدف",
  T_40_XXJ_WS_TARGETENTITY_DESCKEY: "الكيان المستهدف",
  T_40_XXJ_WS_TARGETENTITY_NAMEKEY: "الكيان",
  T_40_XXJ_WS_TARGETENTITY1_DESCKEY: "الكيان الذي توجد فيه الوظيفة المخصصة",
  T_40_XXJ_WS_TARGETENTITYAPLAYER_DESCKEY: "الكيان الذي هاجمه الذكاء الاصطناعي",
  T_40_XXJ_WS_TARGETENTITYFOLLOW_DESCKEY: "الكيان المستهدف لمتابعة",
  T_40_XXJ_WS_TARGETENTITYITEM_DESCKEY: "كيان العنصر (يمكن أن يكون فارغًا)",
  T_40_XXJ_WS_TARGETENTITYLOOK_DESCKEY: "الكيان المستهدف للنظر إليه",
  T_40_XXJ_WS_TARGETENTITYSOUND_DESCKEY: "كيان الصوت المطلوب وقفة",
  T_40_XXJ_WS_TARGETENTITYSOUND2_DESCKEY: "كيان الصوت الذي سيتم تشغيله بعد الإيقاف المؤقت",
  T_40_XXJ_WS_TARGETENTITYSOUND3_DESCKEY: "كيان الصوت المطلوب حذفه",
  T_40_XXJ_WS_TEAMMATESINFO_NAMEKEY: "معلومات أعضاء الفريق",
  T_40_XXJ_WS_TELEPORTA_D: "انتقال فوري للاعب إلى مكان محدد مع اتجاه محدد",
  T_40_XXJ_WS_TEXT_NAMEKEY: "نص تلميح",
  T_40_XXJ_WS_TEXTCOLOR_NAMEKEY: "لون نص الإشعار",
  T_40_XXJ_WS_TEXTENTITY_DESCKEY: "كيان النص يمثل النص الذي سيتم عرضه",
  T_40_XXJ_WS_TEXTKEY_DESCKEY: "مفاتيح النص لعرضها",
  T_40_XXJ_WS_TEXTKEY_NAMEKEY: "مفتاح النص",
  T_40_XXJ_WS_TIMESTAMP_DESCKEY: "الطابع الزمني",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_DESCKEY: "نمط العرض لسلسلة مترجمة",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_NAMEKEY: "نمط عرض الطابع الزمني",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_DESCKEY: "سلسلة النص المترجمة للطابع الزمني",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_NAMEKEY: "الطابع الزمني لسلسلة النص المترجمة",
  T_40_XXJ_WS_TIPHUD_DESCKEY: "تلميح",
  T_40_XXJ_WS_TIPHUD_NAMEKEY: "نصيحة",
  T_40_XXJ_WS_TOKENCOUNT_DESCKEY: "مقدار العنصر القابل للنهب",
  T_40_XXJ_WS_TOKENID_DESCKEY: "معرّف العنصر القابل للنهب",
  T_40_XXJ_WS_TOWSPEED_DESCKEY: "سرعة السحب للاعب",
  T_40_XXJ_WS_TRANSITIONTYPE_NAMEKEY: "نوع الترجمة",
  T_40_XXJ_WS_TWEENENTITY_DESCKEY: "كيان الرسوم المتحركة الاستيفاء",
  T_40_XXJ_WS_TYPE_DESCKEY: "هذا هو نوع الوصف. سيؤدي استخدام النوع إلى إرجاع نوعه.",
  T_40_XXJ_WS_TYPE_NAMEKEY: "نوع الجسم الصلب",
  T_40_XXJ_WS_TYPE2_DESCKEY: "أنواع مختلفة من الأجسام الصلبة لها وظائف مختلفة",
  T_40_XXJ_WS_TYPE3_DESCKEY: "العملات الأساسية فقط المدعومة في الإصدار الحالي",
  T_40_XXJ_WS_USEDEPTHMAP_DESCKEY: "ما إذا كان سيتم تمكين عرض عمق الخريطة المصغرة",
  T_40_XXJ_WS_USEDEPTHMAP_NAMEKEY: "استخدم خريطة العمق",
  T_40_XXJ_WS_USEGRAVITY_DESCKEY: "ما إذا كان يتبع قانون الجاذبية",
  T_40_XXJ_WS_USEGRAVITY_NAMEKEY: "الجاذبية أم لا",
  T_40_XXJ_WS_UUID_DESCKEY: "المعرف الفريد للاعب",
  T_40_XXJ_WS_UUID_NAMEKEY: "UUID",
  T_40_XXJ_WS_VALUE_DESCKEY: "القيمة",
  T_40_XXJ_WS_VALUE_NAMEKEY: "قيمة",
  T_40_XXJ_WS_VALUE01_NAMEKEY: "القيمة [0، 1]",
  T_40_XXJ_WS_VALUE1_DESCKEY: "القيمة الأولى",
  T_40_XXJ_WS_VALUE2_DESCKEY: "القيمة الثانية",
  T_40_XXJ_WS_VALUE6_DESCKEY: "القيمة [0،1]",
  T_40_XXJ_WS_VALUEA_DESCKEY: "قيمة البداية",
  T_40_XXJ_WS_VALUEB_DESCKEY: "القيمة المستهدفة",
  T_40_XXJ_WS_VALUENAME_DESCKEY: "اسم القيمة المراد اجتيازها. يمكنك استخدام هذا للحصول على القيمة في عامل محلي.",
  T_40_XXJ_WS_VALUET_DESCKEY: "تقدم الاستيفاء. تقع بين 0 و 1.",
  T_40_XXJ_WS_VARTYPE_NAMEKEY: "نوع العامل",
  T_40_XXJ_WS_VERTICALBAR_DESCKEY: "نوع العرض العمودي",
  T_40_XXJ_WS_VERTICALBAR_NAMEKEY: "نوع العرض العمودي",
  T_40_XXJ_WS_VISIBILITYLAYER_DESCKEY: "مستوى رؤية العنصر",
  T_40_XXJ_WS_VISIBILITYLAYER_NAMEKEY: "الطبقة المرئية",
  T_40_XXJ_WS_WARDROBETYPE_DESCKEY: "تشمل الملابس الحزمة، والرأس، والقناع، وطلاء الوجه، والعلوي، والسفلي، والأحذية",
  T_40_XXJ_WS_WARDROBETYPE_NAMEKEY: "نوع الزي",
  T_40_XXJ_WS_WARDROBETYPE6_DESCKEY: "فتحة الزي",
  T_40_XXJ_WS_WEAPONHUD_NAMEKEY: "الأسلحة",
  T_40_XXJ_WS_WEAPONSKINID_DESCKEY: "معرف غلاف السلاح",
  T_40_XXJ_WS_WEAPONSKINID_NAMEKEY: "معرف غلاف السلاح",
  T_40_XXJ_WS_WEAPONSKINID1_DESCKEY: "معرف غلاف السلاح",
  T_40_XXJ_WS_WEAPONSKINID6_DESCKEY: "غلاف سلاح اللاعب",
  T_40_XXJ_WS_WIDGETTYPEENUM: "تعداد نوع المكون",
  T_40_XXJ_WS_WIDTH_DESCKEY: "العرض",
  T_40_XXJ_WS_WORDWRAP_NAMEKEY: "التفاف الكلمات",
  T_40_XXJ_WS_WRITELEADERBOARD: "اكتب قيمة قائمة المتصدرين",
  T_40_XXJ_WS_WRITELEADERBOARD_DESC: "اكتب قيمة مقابلة لمفتاح معين على جدول لوحة متصدرين معين في قاعدة البيانات.",
  T_40_XYL_WS_BUMPERFACTORY: "مصنع سيارات التصادم",
  T_40_XYL_WS_BURNDAMAGE: "ضرر الاحتراق",
  T_40_XYL_WS_BURNINTERVAL: "فترة ضرر الاحتراق (ث)",
  T_40_XYL_WS_BURNTIME: "وقت الاحتراق بعد الانفجار",
  T_40_XYL_WS_COLORFULSKY: "السماء الملونة",
  T_40_XYL_WS_CRANEMACHINE: "مخلب كرين",
  T_40_XYL_WS_CRASHMAXDAMAGE: "الحد الأقصى من ضرر التصادم",
  T_40_XYL_WS_CRASHMAXSPEED: "الحد الأقصى لسرعة ضرر التصادم",
  T_40_XYL_WS_CRASHMESS: "معلمة الكتلة أثناء الانهيار",
  T_40_XYL_WS_CRASHMINDAMAGE: "الحد الأدنى من ضرر التصادم",
  T_40_XYL_WS_DISPLAYBOARD: "لوحة إعلانات",
  T_40_XYL_WS_EXPLODEDAMAGE: "أضرار الانفجار",
  T_40_XYL_WS_EXPLODEDELAY: "وقت تأخير الانفجار",
  T_40_XYL_WS_EXPLODERANGE: "نطاق الانفجار",
  T_40_XYL_WS_FERRISWHEEL: "دولاب هواء",
  T_40_XYL_WS_FOODTRUCK002: "شاحنة الطعام B",
  T_40_XYL_WS_GEARSHIFTDELAY: "وقت تغيير المعدات (ث)",
  T_40_XYL_WS_ICAROUSEL001: "مكون الدوار A",
  T_40_XYL_WS_ICAROUSEL002: "مكون الدوار B",
  T_40_XYL_WS_ICAROUSEL003: "الدوار",
  T_40_XYL_WS_ICEDANCEDOOL: "الدمية الزرقاء",
  T_40_XYL_WS_IDLEBRAKEINPUT: "نسبة وقوف قوة الحصان غير المنضبطة",
  T_40_XYL_WS_LOLLIPOP: "المصاصة العملاقة",
  T_40_XYL_WS_NEWHOOKGUN: "مسدس الخطاف السوبر",
  T_40_XYL_WS_OPENSWING: "زر التأرجح",
  T_40_XYL_WS_OPENTRACTION: "زر السحب",
  T_40_XYL_WS_PODIUM: "المنصة",
  T_40_XYL_WS_SKYCITY: "مدينة",
  T_40_XYL_WS_SKYSCRAPER_A001: "ناطحة سحاب A المكون A",
  T_40_XYL_WS_SKYSCRAPER_A002: "ناطحة سحاب A المكون B",
  T_40_XYL_WS_SKYSCRAPER_A003: "ناطحة سحاب A المكون C",
  T_40_XYL_WS_SKYSCRAPER_B001: "ناطحة سحاب B المكون A",
  T_40_XYL_WS_SKYSCRAPER_B002: "ناطحة سحاب B المكون B",
  T_40_XYL_WS_SKYSCRAPER_B003: "ناطحة سحاب B المكون C",
  T_40_XYL_WS_SKYSCRAPER_C001: "ناطحة سحاب C المكون A",
  T_40_XYL_WS_SKYSCRAPER_C002: "ناطحة سحاب C المكون B",
  T_40_XYL_WS_SKYSCRAPER_C003: "ناطحة سحاب C المكون C",
  T_40_XYL_WS_SKYSCRAPER_D001: "ناطحة سحاب D المكون A",
  T_40_XYL_WS_SKYSCRAPER_D002: "ناطحة سحاب D المكون B",
  T_40_XYL_WS_SKYSCRAPER_D003: "ناطحة سحاب D المكون C",
  T_40_XYL_WS_SKYSCRAPER_E001: "ناطحة سحاب E المكون A",
  T_40_XYL_WS_SKYSCRAPER_E002: "ناطحة سحاب E المكون B",
  T_40_XYL_WS_SKYSCRAPER_E003: "ناطحة سحاب E المكون C",
  T_40_XYL_WS_STEERANGLE: "نصف قطر الدوران عالي السرعة",
  T_40_XYL_WS_STEERSPEED: "السرعة القصوى أثناء التحول عالي السرعة",
  T_40_XYL_WS_SWINGSPEED: "سرعة التأرجح",
  T_40_XYL_WS_TARGETOBJECT: "مرساة الحركة",
  T_40_XYL_WS_TRACTIONSPEED: "سرعة السحب",
  T_40_XYL_WS_TRIGGERCAPSULE: "كبسولة الزناد المخصصة",
  T_40_XYL_WS_TRIGGERSPHERE: "مشغل الكرة المخصص",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT: "العنصر المخصص",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT_DESC: "مكون عنصر فارغ يمكن استخدامه مع مكون العرض ومكون الاصطدام.",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER: "مكون العرض المخصص",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER_DESC: "مكون عرض مخصص، يُستخدم للعرض باستخدام موارد النموذج المخصصة.",
  T_41_B_SKILL_DESC_ASSASSINGIRL: "العلامات الخاصة بأعدائك تحمل قيمة جائزة. أي عضو في فريقك الذي يقضي على عدو محدد سيكسب [FFB300]{0}عملة في المباراة[-]. ستكسب إضافياً[FFB300]100[-] عند قضائك على عدو. احصل على [FFB300]{1} عملات فري فاير إضافية[-] من آلات العملات في مباريات باتل رويال.",
  T_41_B_SKILL_NAME_ASSASSINGIRL: "علامة المال",
  T_41_CJ_A_ESPORTS_TH: "محترف FFTC (قناع)",
  T_41_CJ_B_ESPORTS_TH: "محترف FFTC (سفلي)",
  T_41_CJ_H_ESPORTS_TH: "محترف FFTC (رأس)",
  T_41_CJ_S_ESPORTS_TH: "محترف FFTC (حذاء)",
  T_41_CJ_T_ESPORTS_TH: "محترف FFTC (علوي)",
  T_41_CJ_T_FFSI: "قميص بطولة دعوة آسيا",
  T_41_CJ_T_FOOTBALL_EU01: "قميص انفجار الشمس",
  T_41_CJ_T_FOOTBALL_EU02: "القميص الأحمر الجريء",
  T_41_CJ_T_FOOTBALL_EU03: "قميص التاج المهيب",
  T_41_CJ_T_FOOTBALL_EU04: "قميص التيتان الشرس",
  T_41_H_CHARACTER_ASSASSINGIRL_N: "سوزي",
  T_41_LXW_TabName_Items: "عنصر",
  T_41_R_CD_COIL: "تقليص المنطقة",
  T_41_SJ_WS_SPECIALITEM_ENABLE_DES: "ما إذا كان سيتم تنشيط هذا الجهاز أم لا",
  T_41_SJ_WS_SPECIALITEM_NAME: "جهاز",
  T_41_SW_SKILL_DESC_DELIVERY: "عند الإصابة من العدو في نطاق [FFB300]{0}م[-]، يتم تمييز المهاجم المذكور لمدة [FFB300]{1}ث[-] (تتم مشاركة المعلومات مع الزملاء). الحد الأقصى [FFB300]{2} علامات[-].",
  T_41_SW_SKILL_DESC_GANGLEADER: "الحصول على [FFB300]{0} نقاط درع إضافية[-] في بداية المباراة. يستعيد نقاط الدرع بعد البقاء على قيد الحياة في القتال.",
  T_41_SW_SKILL_DESC_JUNKENGINEER: "عند استخدام مهارة نشطة، تمنح [FFB300]{1} نقاط درع[-] لنفسك ولزملائك في نطاق [FFB300]{0}م[-]. تتناقص نقاط الدرع بعد [FFB300]{2}ث[-]، وبعد ذلك يمكن للاعبين الحصول على التأثيرات مرة أخرى. وقت التهدئة: [FFB300]{3}ث[-].",
  T_41_SW_SKILL_DESC_WINTERGUY: "تستعيد جدران الجلو المنتشرة [FFB300]{0}[-] متانة في الثانية عند الضرب، وخلالها يستعيد أعضاء الفريق في نطاق [FFB300]{1}متر[-] [FFB300]{2}نقاط صحة/ثانية[-]. الحد الأقصى [FFB300]{3}نقاط صحة[-] لكل عضو في الفريق من كل جدار جلو.",
  T_41_SY_PETSKIN_CACTUS_SUGARSKULL23_N: "سكن الحيوان الأليف: صبار الجمجمة",
  T_41_SY_PETSKIN_HAWK_INKPAINTING_N: "سكن الحيوان الأليف: فالكو محبر",
  T_41_WCL_CREDITSCORE_PENALTY_HISTORY_TYPE: "نوع",
  T_41_WT_SKILL_DESC_FIREBOY: "ينشر شاشة ملتهبة بعرض [FFB300]{1}متر[-] تدوم [FFB300]{0}ث[-] وتتحرك للأمام بسرعة [FFB300]{2}متر/ثانية[-] لمدة تصل إلى [FFB300]{3}ث[-]. أثناء تفعيلها، استخدم المهارة مرة أخرى لإيقاف الشاشة. [FFB300]الأعداء (أو جدران جلو)[-] الذين يلامسونها سيأخذون على الفور [FFB300]{4}[-] (أو{5}) ضرر[-]، ثم يأخذون [FFB300]{6} (أو {7}) ضرر[-]/ث. يدوم [FFB300]{8}ث[-]. تهدئة: [FFB300]{9}ث[-]. يمكن تخزين ما يصل إلى [FFB300]{10}[-] استخدامات المهارة، مع فترة تهدئة [FFB300]{11}ثانية[-] بين كل استخدام.",
  T_41_WT_SKILL_NAME_FIREBOY: "سراب اللهب",
  T_41_WZY_WS_CHARGEMAX: "الحد الأقصى لشحن صانع جدار الجلو",
  T_41_WZY_WS_CROSSBOWNAME: "القوس",
  T_41_WZY_WS_DECELERATIONRATIO: "التباطؤ % في الماء",
  T_41_WZY_WS_DEICEWALLPARAM1: "نصف قطر منطقة الذوبان",
  T_41_WZY_WS_DEICEWALLPARAM2: "مدة الذوبان",
  T_41_WZY_WS_EXPPERCHIP: "نقاط الخبرة من رقاقة الجلو",
  T_41_WZY_WS_EXPPERDAMAGE: "نقاط الخبرة من التعامل مع الضرر",
  T_41_WZY_WS_EXPPERMOVEMILE: "نقاط الخبرة من كل متر سافر",
  T_41_WZY_WS_EXPPERSECOND: "نقاط الخبرة في الثانية",
  T_41_WZY_WS_GRENADEEXPTIME: "تأخير الانفجار",
  T_41_WZY_WS_GRENADELAUNCHNAME: "متفجرات",
  T_41_WZY_WS_GRENADEMAX: "أقصى ضرر",
  T_41_WZY_WS_GRENADEMIN: "أدنى ضرر",
  T_41_WZY_WS_GRENADERANGE: "معدل الانفجار",
  T_41_WZY_WS_GRENADERATIOCEHICLE: "معامل الضرر على المركبات",
  T_41_WZY_WS_GRENADERATIOSELF: "معامل الضرر على النفس",
  T_41_WZY_WS_GRENADERATIOTEAMMATE: "معامل الضرر على أعضاء الفريق",
  T_41_WZY_WS_GRENADTHROWSPEED: "سرعة السفر المتفجرة",
  T_41_WZY_WS_HANDCANNONNAME: "مدفع يدوي",
  T_41_XXJ_WS_ACCELERATION: "التسريع",
  T_41_XXJ_WS_ACCELERATION_D: "قم بإنشاء تأثير تسريع معين",
  T_41_XXJ_WS_ACTION: "عقدة الإجراء",
  T_41_XXJ_WS_ACTION_D: "محور العمل",
  T_41_XXJ_WS_ADDHP: "عناصر الشفاء",
  T_41_XXJ_WS_ADDPLAYERMAXHP: "أضف الحد الأقصى من نقاط الصحة",
  T_41_XXJ_WS_AICASTSKILL_D: "مهارة إطلاق الذكاء الاصطناعي",
  T_41_XXJ_WS_AIMASSISTCENTEROFFSET: "إزاحة مركز مساعدة التصويب",
  T_41_XXJ_WS_AIMASSISTDISTANCE: "مسافة مساعدة الهدف",
  T_41_XXJ_WS_AIMASSISTENTITY: "كيان مساعدة التصويب",
  T_41_XXJ_WS_AIMASSISTENTITY_D: "الكيان الذي يمكن مساعدته على التصويب",
  T_41_XXJ_WS_AISKILLTYPE: "نوع مهارة الزومبي",
  T_41_XXJ_WS_AISKILLTYPE_D: "نوع مهارة الزومبي",
  T_41_XXJ_WS_ALLITEMGOODSTYPE: "كل العناصر",
  T_41_XXJ_WS_ALLITEMGOODSTYPE_D: "كل العناصر",
  T_41_XXJ_WS_AMMOCLIPSIZE: "تعديل حجم الذخيرة",
  T_41_XXJ_WS_AMMOCLIPSIZE_D: "الرصاص في الذخيرة",
  T_41_XXJ_WS_ANCHORPOSITION_D: "ينسق المرساة فيما يتعلق بالرئيس",
  T_41_XXJ_WS_ANGLE_D: "زاوية دوران المحور ض",
  T_41_XXJ_WS_ANGULARDRAG: "السحب الزاوي",
  T_41_XXJ_WS_ANGULARVELOCITY: "السرعة الزاوية",
  T_41_XXJ_WS_ANIMATIONCLIP: "حالة الرسوم المتحركة",
  T_41_XXJ_WS_ANIMATIONCONTROLLER: "متحكم الرسوم المتحركة",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE: "كيان الرسوم المتحركة",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE_D: "الملف والمورد المستخدمان لإدارة وحدة تحكم الرسوم المتحركة",
  T_41_XXJ_WS_ANIMATIONCONTROLLERRESUUID: "UUID موارد تحكم الرسوم المتحركة",
  T_41_XXJ_WS_ANIMATIONOVERRIDELOOPTYPE: "تعداد نوع التكرار",
  T_41_XXJ_WS_ANIMATIONSTATE: "حالة الرسوم المتحركة",
  T_41_XXJ_WS_ARITHMETICTYPE_D: "العملية، حيث يتم دعم جميع أنواع تخصيص القيمة، كما تدعم الأنواع الرقمية الزيادة الذاتية والطرح الذاتي والضرب الذاتي والقسمة الذاتية",
  T_41_XXJ_WS_ATTACHMENT: "المرفق",
  T_41_XXJ_WS_ATTACHMENT_D: "المرفق",
  T_41_XXJ_WS_ATTACHTARGET: "الكيان المرتبط",
  T_41_XXJ_WS_BAG: "الحقيبة",
  T_41_XXJ_WS_BAG_D: "مكون حقيبة الظهر",
  T_41_XXJ_WS_BANNERID: "معرف الراية",
  T_41_XXJ_WS_BANNERID_D: "معرف الراية",
  T_41_XXJ_WS_BEHAVIOURTREE: "شجرة السلوك",
  T_41_XXJ_WS_BEHAVIOURTREE_D: "شجرة السلوك",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE: "كيان شجرة السلوك القابل للتركيب",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE_D: "كيان شجرة سلوك يمكن تركيبه",
  T_41_XXJ_WS_BEHAVIOURTREENODE: "عقدة شجرة السلوك المخصصة",
  T_41_XXJ_WS_BEHAVIOURTREENODE_D: "محور شجرة السلوك المخصص",
  T_41_XXJ_WS_BODY: "جسم",
  T_41_XXJ_WS_BORDERLR: "الحدود (يسار ويمين)",
  T_41_XXJ_WS_BORDERLR_D: "الحد الأيسر والأيمن",
  T_41_XXJ_WS_BORDERTB: "الحدود (أعلى وأسفل)",
  T_41_XXJ_WS_BORDERTB_D: "الحد العلوي والسفلي",
  T_41_XXJ_WS_BRPEAKRANK: "أعلى تصنيف باتل رويال",
  T_41_XXJ_WS_BRPEAKRANK_D: "أعلى تصنيف باتل رويال",
  T_41_XXJ_WS_BRRANK: "باتل رويال - المصنف",
  T_41_XXJ_WS_BRRANK_D: "باتل رويال - المصنف",
  T_41_XXJ_WS_BTCUSTOMNODETYPE: "نوع عقدة شجرة السلوك",
  T_41_XXJ_WS_BTCUSTOMNODETYPE_D: "نوع محور شجرة السلوك",
  T_41_XXJ_WS_BTREE: "شجرة السلوك",
  T_41_XXJ_WS_BTREENODESTATE: "حالة عقدة شجرة السلوك",
  T_41_XXJ_WS_BTREENODESTATE_D: "حالة التشغيل لمحور شجرة السلوك",
  T_41_XXJ_WS_BUFFABLEENTITY: "كيان ممكن للتعزيز",
  T_41_XXJ_WS_BUFFABLEENTITY_D: "تمكن من إضافة النقوية، وإزالة التقوية، والحصول على تقويات مضافة",
  T_41_XXJ_WS_BUILDINGICEWALL: "جدار جلو",
  T_41_XXJ_WS_CAMOUFLAGE: "العناصر الوظيفية",
  T_41_XXJ_WS_CAMOUFLAGE_D: "مزلاجة، تمويه...",
  T_41_XXJ_WS_CAPICITY_D: "القدرة الأولية",
  T_41_XXJ_WS_CENTERINVISIBLE: "غير مرئي للمركز",
  T_41_XXJ_WS_CENTERINVISIBLE_D: "غير مرئي للمركز",
  T_41_XXJ_WS_COLOR: "لون",
  T_41_XXJ_WS_COLOR_D: "اللون",
  T_41_XXJ_WS_CONDITION: "عقدة الشرط",
  T_41_XXJ_WS_CONDITION_D: "الشروط هي نوع منطقي خاص",
  T_41_XXJ_WS_CONDITION1_D: "محور الشرط",
  T_41_XXJ_WS_CONSTRAIN: "قيد RigidBody",
  T_41_XXJ_WS_CONSTRAIN_D: "أضف قيودًا إلى RigidBody. هذا تجميع لنوع قيد RigidBody.",
  T_41_XXJ_WS_COUNT_D: "المقدار",
  T_41_XXJ_WS_CROSSBOW_D: "القوس",
  T_41_XXJ_WS_CSPEAKRANK: "أعلى تصنيف كلاش سكواد",
  T_41_XXJ_WS_CSPEAKRANK_D: "أعلى تصنيف كلاش سكواد",
  T_41_XXJ_WS_CSRANK: "كلاش سكواد - المصنف",
  T_41_XXJ_WS_CSRANK_D: "كلاش سكواد - المصنف",
  T_41_XXJ_WS_CSVNAME_D: "ملف csv ضمن SceneData يتوافق مع الوضع. ينتهي في .csv. تتم كتابة الرؤوس بأحرف صغيرة.",
  T_41_XXJ_WS_CURCAPACITY: "السعة المستخدمة",
  T_41_XXJ_WS_CURPROGRESS: "التقدم الحالي",
  T_41_XXJ_WS_CURRENTCLIP: "المقطع الحالي",
  T_41_XXJ_WS_CURRENTCLIPPROGRESS: "تقدم المقطع الحالي",
  T_41_XXJ_WS_CURRENTSTATE: "الحالة الحالية",
  T_41_XXJ_WS_CUSTOMHUDID: "معرف HUD المخصص",
  T_41_XXJ_WS_CUSTOMHUDID_D: "المعرف المستخدم لوصف أصل HUD مخصص",
  T_41_XXJ_WS_DASHATTACK: "هجوم الاندفاع",
  T_41_XXJ_WS_DEBUG: "ابدأ تصحيح الأخطاء",
  T_41_XXJ_WS_DEBUG_D: "اصلح",
  T_41_XXJ_WS_DECELERATIONRATIO_D: "التباطؤ%: التباطؤ عندما يكون الجسم في الماء (النطاق مضبوط مؤقتا على 0-100)",
  T_41_XXJ_WS_DEPTH_D: "العمق",
  T_41_XXJ_WS_DRAG: "معامل السحب",
  T_41_XXJ_WS_DRAG_D: "كلما زاد المعامل، زادت سرعة تباطؤ سرعة الحركة",
  T_41_XXJ_WS_DUMMY: "دمية",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE: "تفعيل وضع الجرافيكس المنخفض",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE_D: "عندما يكون معدل الإطارات في الثانية منخفضًا، ستعمل اللعبة بمعدل 15 إطارًا في الثانية؛ أو 30 إطارًا في الثانية",
  T_41_XXJ_WS_ENTITYLIST: "تم إنشاء قائمة كيان العودة",
  T_41_XXJ_WS_ENTITYNAME: "اسم العنصر",
  T_41_XXJ_WS_ENTITYNAME_D: "اسم العنصر المخصص من قبل اللاعب",
  T_41_XXJ_WS_ENTITYORPREFABID_D: "الكيان المنطقي أو المعرف الجاهز",
  T_41_XXJ_WS_EQUIPANDBAG: "السترة الواقية و الحقيبة",
  T_41_XXJ_WS_EQUIPMENTSLOT: "تعداد فتحة المعدات",
  T_41_XXJ_WS_EQUIPMENTSLOT_D: "تعداد فتحة المعدات",
  T_41_XXJ_WS_EXPLODE: "تنفجر الذات",
  T_41_XXJ_WS_EXPLOSIVEWEAPON_D: "السلاح المتفجر",
  T_41_XXJ_WS_FASTAUTORELOADSPEED: "سرعة إعادة التحميل التلقائي",
  T_41_XXJ_WS_FILEID: "المعرف الداخلي",
  T_41_XXJ_WS_FILEID_D: "المعرف الداخلي للتحكم في الجاهز",
  T_41_XXJ_WS_FILLAMOUNT: "كمية التعبئة",
  T_41_XXJ_WS_FILLAMOUNT_D: "قيمة التعبئة",
  T_41_XXJ_WS_FILLDIR: "اتجاه التعبئة",
  T_41_XXJ_WS_FILLDIR_D: "اتجاه التعبئة",
  T_41_XXJ_WS_FILLDIR_D1: "تعداد اتجاه التعبئة",
  T_41_XXJ_WS_FILLTYPE: "نوع التعبئة",
  T_41_XXJ_WS_FILLTYPE_D: "نوع التعبئة",
  T_41_XXJ_WS_FILLTYPE_D1: "تعداد نوع التعبئة",
  T_41_XXJ_WS_FINDSTRAIGHTPATH_D: "ابحث عن المسار",
  T_41_XXJ_WS_FINISH: "اكتمل",
  T_41_XXJ_WS_FIREINTERVAL: "فاصل إطلاق النار",
  T_41_XXJ_WS_FIREINTERVAL_D: "الفترة الفاصلة للهجوم",
  T_41_XXJ_WS_FLIP: "طريقة الوجه",
  T_41_XXJ_WS_FLIP_D: "طريقة الوجه",
  T_41_XXJ_WS_FLYBOMBBEE: "الزومبي الطائر",
  T_41_XXJ_WS_FORCE: "قوة",
  T_41_XXJ_WS_FORCE_D: "إنشئ قوة ذات شدة معينة",
  T_41_XXJ_WS_FORCETYPE: "نوع القوة",
  T_41_XXJ_WS_FORCETYPE_D: "أنواع القوى المختلفة على RigidBody. ملاحظة. فعال فقط على أنواع RigidBody الديناميكية.",
  T_41_XXJ_WS_FREEZEALL: "توقف الحركة والدوران",
  T_41_XXJ_WS_FREEZEPOSITION: "توقف الحركة الخطية",
  T_41_XXJ_WS_FREEZEPOSITIONX: "توقف المحور س",
  T_41_XXJ_WS_FREEZEPOSITIONY: "توقف المحور ص",
  T_41_XXJ_WS_FREEZEPOSITIONZ: "توقف المحور ض",
  T_41_XXJ_WS_FREEZEROTATION: "توقف كل الدوران",
  T_41_XXJ_WS_FREEZEROTATIONX: "توقف الدوران س",
  T_41_XXJ_WS_FREEZEROTATIONY: "توقف الدوران ص",
  T_41_XXJ_WS_FREEZEROTATIONZ: "توقف الدوران ض",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE: "المسافة لأقصى ضرر",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE_D: "المسافة لأقصى ضرر",
  T_41_XXJ_WS_GAMEID_D: "معرف المهمة",
  T_41_XXJ_WS_GIVEJAILBREAKITEM_D: "أعط عنصر متروبوليس",
  T_41_XXJ_WS_GRADIENT: "تدرج",
  T_41_XXJ_WS_GRADIENT_D: "التدرج",
  T_41_XXJ_WS_GRADIENTBOTTOM: "التدرج في الأسفل",
  T_41_XXJ_WS_GRADIENTBOTTOM_D: "التدرج في الأسفل",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA: "الشفافية في الجزء السفلي",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA_D: "الشفافية السفلية",
  T_41_XXJ_WS_GRADIENTTOP: "التدرج في الأعلى",
  T_41_XXJ_WS_GRADIENTTOP_D: "التدرج في الأعلى",
  T_41_XXJ_WS_GRADIENTTOPALPHA: "الشفافية في الجزء العلوي",
  T_41_XXJ_WS_GRADIENTTOPALPHA_D: "الشفافية العلوية",
  T_41_XXJ_WS_GRAPHID: "معرف النص",
  T_41_XXJ_WS_GRAPHID_D: "المعرف المستخدم لوصف أصل البرنامج النصي",
  T_41_XXJ_WS_GRENADEDEICEWALL_D: "مكون مذيب الجلو",
  T_41_XXJ_WS_GRENADEEXPLOSIONTIME_D: "تأخير الانفجار",
  T_41_XXJ_WS_GRENADELAUNCHER_D: "قابل للرمي",
  T_41_XXJ_WS_GRENADEMAXDAMAGE_D: "أقصى ضرر",
  T_41_XXJ_WS_GRENADEMINDAMAGE_D: "الحد الأدنى من الضرر",
  T_41_XXJ_WS_GRENADERANGE_D: "معدل الانفجار",
  T_41_XXJ_WS_GRENADERATIOSELF_D: "مضاعف الضرر الذاتي",
  T_41_XXJ_WS_GRENADERATIOTEAMMATE_D: "مضاعف حليف الضرر",
  T_41_XXJ_WS_GRENADERATIOVEHICLE_D: "مضاعف ضرر المركبة",
  T_41_XXJ_WS_GRENADETHROWSPEED_D: "سرعة الرمية",
  T_41_XXJ_WS_GRENADEWEAPON: "فئة قابلة للرمي",
  T_41_XXJ_WS_GRENADEWEAPON_D: "الأنواع الأساسية للرمي",
  T_41_XXJ_WS_HANDCANNON_D: "عناصر قابلة للرمي",
  T_41_XXJ_WS_HEAD: "رأس",
  T_41_XXJ_WS_HEADID: "معرف الصورة",
  T_41_XXJ_WS_HEADID_D: "معرف الصورة",
  T_41_XXJ_WS_HEAVYWEAPON_D: "سلاح ثقيل",
  T_41_XXJ_WS_HELMET_D: "الخوذة الحالية",
  T_41_XXJ_WS_HELMET1_D: "خوذة",
  T_41_XXJ_WS_HELMET2_D: "كيان الخوذة",
  T_41_XXJ_WS_HITBODYPART_D: "الجزء المصاب من الجسم",
  T_41_XXJ_WS_HITBPDYPART: "ضرب جزء من الجسم",
  T_41_XXJ_WS_HITENTITY_D: "كيان الضرب",
  T_41_XXJ_WS_HOSTHUDENTITY_D: "كيان HUD الذي تنتمي إليه",
  T_41_XXJ_WS_HUD3DCONTAINER: "حاوية محتوى ثلاثي الأبعاد",
  T_41_XXJ_WS_HUD3DCONTAINER_D: "كيان حاوية HUD ثلاثية الأبعاد. هذه هي HUD التي يقوم اللاعبون بتعديلها من المحرر.",
  T_41_XXJ_WS_HUDGRID: "مراقبة (لوحة) التخطيط المخصص",
  T_41_XXJ_WS_HUDLAYOUT: "التحكم في التخطيط",
  T_41_XXJ_WS_HUDLAYOUT_D: "كيان إدخال HUD. هذا هو HUD الذي يقوم اللاعبون بتعديله من المحرر.",
  T_41_XXJ_WS_HUDPROFILEINFO: "التحكم في الصورة المخصصة",
  T_41_XXJ_WS_HUDPROFILEINFO_D: "كيان معلومات الملف الشخصي في HUD. هذه هي HUD التي يعدلها اللاعبون من المحرر.",
  T_41_XXJ_WS_HUDTEXTURE: "التحكم في الملمس",
  T_41_XXJ_WS_HUDTEXTURE_D: "كيان نسيج HUD. هذا هو HUD الذي يقوم اللاعبون بتعديله من المحرر.",
  T_41_XXJ_WS_HUDTRANSFORM: "مكون تحكم UITransform",
  T_41_XXJ_WS_HUDTRANSFORM_D: "كيان تحكم UITransform",
  T_41_XXJ_WS_IMPULSE: "اضرب",
  T_41_XXJ_WS_IMPULSE_D: "اصنع إضرابًا بقوة معينة",
  T_41_XXJ_WS_INITIALWORLDPOS: "إحداثيات العالم الأولية",
  T_41_XXJ_WS_INTERNALBUFFTYPE: "تعداد التقويات",
  T_41_XXJ_WS_INTERNALBUFFTYPE_D: "يتوافق مع عمود المعرف في BuffData.csv. قبل إضافة محتوى جديد، يرجى التحقق أولاً من التوافق مع GPP.",
  T_41_XXJ_WS_INVERTFILL: "عكس التعبئة",
  T_41_XXJ_WS_INVERTFILL_D: "عكس التعبئة",
  T_41_XXJ_WS_ISLOOP: "تكرار",
  T_41_XXJ_WS_ISLOOP_D: "ما إذا كان يتم التكرار أم لا. الافتراضي هو خطأ.",
  T_41_XXJ_WS_ISNAVMESHSTATIC: "إنشاء NavMesh الثابت",
  T_41_XXJ_WS_ISNAVMESHSTATIC_D: "تُستخدم فقط للتحقق من إنشاء NavMesh الثابت عند تحميل عناصر ثابتة",
  T_41_XXJ_WS_ISSUCCESS_D: "مدمرة أم لا",
  T_41_XXJ_WS_ITEMENTITY_D: "كيان العنصر",
  T_41_XXJ_WS_ITEMID: "معرف العنصر",
  T_41_XXJ_WS_ITEMID_D: "معرف العنصر",
  T_41_XXJ_WS_ITEMID_D1: "معرف العنصر المقابل للمرفق",
  T_41_XXJ_WS_ITEMLIST: "قائمة العناصر",
  T_41_XXJ_WS_ITEMTYPE_D: "نوع العنصر",
  T_41_XXJ_WS_JUMPATTACK: "هجوم القفز",
  T_41_XXJ_WS_LANDMINE: "لغم أرضي",
  T_41_XXJ_WS_LENGTH: "طول المقطع",
  T_41_XXJ_WS_LENGTH_D: "طول شريط التقدم. القيمة الافتراضية هي الطول على واجهة المستخدم الجاهزة.",
  T_41_XXJ_WS_LIMB: "أطراف",
  T_41_XXJ_WS_LISTLENGTHOVERLIMIT: "فشلت إضافة عنصر لأن طول القائمة تجاوز السعة",
  T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE: "قائمة التقويات",
  T_41_XXJ_WS_LOOP: "عقدة",
  T_41_XXJ_WS_LOOP_D: "عقدة",
  T_41_XXJ_WS_MAXCAPACITY: "السعة",
  T_41_XXJ_WS_MAXCAPACITY_D: "سعة حقيبة الظهر",
  T_41_XXJ_WS_MAXPROGRESS: "التقدم الأقصى",
  T_41_XXJ_WS_MELEEWEAPON_D: "سلاح المشاجرة",
  T_41_XXJ_WS_MINDAMAGEDISTANCE: "المسافة للحد الأدنى من الضرر",
  T_41_XXJ_WS_MINDAMAGEDISTANCE_D: "المسافة للحد الأدنى من الضرر",
  T_41_XXJ_WS_MINISENTRY: "البرج الأوتوماتيكي",
  T_41_XXJ_WS_NAME: "الاسم",
  T_41_XXJ_WS_NAME_D: "اسم زر المهارة. يستخدم لإرسال المعلمة أثناء حوادث OnClick، لذلك يجب ضمان التفرد.",
  T_41_XXJ_WS_NAME1_D: "اسم البضائع",
  T_41_XXJ_WS_NAME2_D: "اسم قائمة البضائع",
  T_41_XXJ_WS_NAME3_D: "اسم آلة البيع",
  T_41_XXJ_WS_NICKNAME: "اللقب",
  T_41_XXJ_WS_NICKNAME_D: "اسم اللاعب",
  T_41_XXJ_WS_NOCHANGE: "لا توجد تغييرات",
  T_41_XXJ_WS_NONE: "لا توجد قيود",
  T_41_XXJ_WS_NONE1: "لا شيء",
  T_41_XXJ_WS_OFFSET: "إزاحة",
  T_41_XXJ_WS_OFFSET_D: "إزاحة",
  T_41_XXJ_WS_OFFSET1_D: "قيمة الإزاحة المكتوبة",
  T_41_XXJ_WS_ONCE: "مرة واحدة",
  T_41_XXJ_WS_ONCE_D: "مرة واحدة",
  T_41_XXJ_WS_ONHIDE: "عندما تكون الواجهة مغلقة",
  T_41_XXJ_WS_ONHIDE_D: "عندما تكون الواجهة مغلقة",
  T_41_XXJ_WS_ONNODEENTER_D: "عندما يدخل المحور",
  T_41_XXJ_WS_ONSHOW: "عندما تكون الواجهة مفتوحة",
  T_41_XXJ_WS_ONSHOW_D: "عندما تكون الواجهة مفتوحة",
  T_41_XXJ_WS_ONSYNCINPUTTEXT_D: "يتم تشغيله عند تغيير مربع النص",
  T_41_XXJ_WS_PERSONALUAV: "الدرون-لايت",
  T_41_XXJ_WS_PINID: "معرف الدبوس",
  T_41_XXJ_WS_PINID_D: "معرف الدبوس",
  T_41_XXJ_WS_PLAYERBAG: "كيان حقيبة ظهر اللاعب",
  T_41_XXJ_WS_PLAYERBAG_D: "كيان حقيبة اللاعب",
  T_41_XXJ_WS_PLAYERBAGENTITY: "حقيبة ظهر اللاعب",
  T_41_XXJ_WS_PLAYERBAGENTITY_D: "حقيبة اللاعب",
  T_41_XXJ_WS_PLAYERSPEEDFACTORAIMING: "معامل السرعة المعدل أثناء التصويب",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING: "تأثير سرعة الحركة أثناء إطلاق النار",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING_D: "تأثير سرعة الحركة أثناء إطلاق النار",
  T_41_XXJ_WS_PREFABID: "معرف الجاهزة",
  T_41_XXJ_WS_PREFABID_D: "المعرّف المستخدم لوصف أصل جاهز",
  T_41_XXJ_WS_PREFABID1_D: "كيان نموذج HUD الذي يمثله هذا المف",
  T_41_XXJ_WS_PRIMARYWEAPON1_D: "السلاح الرئيسي 1",
  T_41_XXJ_WS_PRIMARYWEAPON2_D: "السلاح الرئيسي 2",
  T_41_XXJ_WS_PROFILEINFO: "الملف الشخصي للاعب",
  T_41_XXJ_WS_PROFILEINFO_D: "سيرة اللاعب",
  T_41_XXJ_WS_PROGRESSICON_D: "أيقونة التقدم",
  T_41_XXJ_WS_PROGRESSICONSPRITENAME: "اسم أيقونة التقدم",
  T_41_XXJ_WS_QUITJAILBREAKMINIGAME_D: "توقف عن لعبة متروبوليس المصغرة",
  T_41_XXJ_WS_RANGE: "نطاق إطلاق النار",
  T_41_XXJ_WS_RANGE_D: "نطاق الهجوم",
  T_41_XXJ_WS_RANGE_D1: "معدل الانفجار",
  T_41_XXJ_WS_RANGE_D2: "نطاق البرج",
  T_41_XXJ_WS_READCSVDATAALLOVERMODE_D: "اقرأ المحتوى على الجدول بأكمله. إرجاع مجموعة ثنائية الأبعاد.",
  T_41_XXJ_WS_READCSVDATACELLOVERMODE_D: "اقرأ محتوى خلية معينة",
  T_41_XXJ_WS_READCSVDATACOLOVERMODE_D: "اقرأ محتوى عمود معين. إرجاع مجموعة.",
  T_41_XXJ_WS_READCSVDATAROWOVERMODE_D: "اقرأ محتوى صف معين. إرجاع مجموعة.",
  T_41_XXJ_WS_READDBACCUMULATEDDATA: "قراءة قاعدة البيانات المتراكمة",
  T_41_XXJ_WS_READDBACCUMULATEDDATA_D: "اقرأ القيمة المطابقة لمفتاح في جدول بقاعدة البيانات المجمعة",
  T_41_XXJ_WS_RECOVERPLAYERHP: "استعادة الصحة باستمرار",
  T_41_XXJ_WS_RELOADSPEED: "سرعة إعادة التحميل",
  T_41_XXJ_WS_RELOADSPEED_D: "سرعة إعادة التحميل (السرعة الأساسية × المضاعف)",
  T_41_XXJ_WS_RESOURCEID: "الموارد UUID",
  T_41_XXJ_WS_RESOURCEID_D: "الموارد UUID",
  T_41_XXJ_WS_RESUUID: "معرف المورد",
  T_41_XXJ_WS_RESUUID_D: "المورد المعين UUID لتقديمه",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE: "نوع قيد RigidBody",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE_D: "يتم تعريف كل قيد بواسطة علامة بت ويمكن استخدامه كمجموعة",
  T_41_XXJ_WS_ROTATION: "الدوران",
  T_41_XXJ_WS_ROTATION_D: "زاوية الدوران في إحداثيات العالم. يُشير س، ص، ض إلى الانحراف والملعب واللف على التوالي.",
  T_41_XXJ_WS_ROTATION1_D: "الدوران",
  T_41_XXJ_WS_RUNNING: "الجري",
  T_41_XXJ_WS_SCALE: "حجم",
  T_41_XXJ_WS_SCALE_D: "حجم",
  T_41_XXJ_WS_SCALE1_D: "يتدرج على طول محور معين. يمكن أن يكون مزيجًا من ثلاثة محاور.",
  T_41_XXJ_WS_SCATTERMAX: "مبعثر الرصاص الأقصى",
  T_41_XXJ_WS_SCATTERMAX_D: "القيمة التي تبدأ عندها انتشار الرصاصة",
  T_41_XXJ_WS_SCATTERMOVE1: "حجم الانتشار عند التحرك",
  T_41_XXJ_WS_SCATTERRECOVERSPEED: "سرعة استعادة الانتشار",
  T_41_XXJ_WS_SCATTERRECOVERSPEED_D: "سرعة استعادة الانتشار",
  T_41_XXJ_WS_SCATTERSPEED: "سرعة زيادة الانتشار",
  T_41_XXJ_WS_SCATTERSPEED_D: "سرعة زيادة الانتشار (0.1 = يتوسع التقاطع بنسبة 10% لكل زيادة انفجار واحد)",
  T_41_XXJ_WS_SCATTERSPEEDCROUCHCREEP: "ينتشر أقل في الانبطاح والانحناء",
  T_41_XXJ_WS_SECONDARYWEAPON_D: "سلاح ثانوى",
  T_41_XXJ_WS_SHADERNAME: "اسم شادر",
  T_41_XXJ_WS_SHADERNAME_D: "اسم شادر",
  T_41_XXJ_WS_SHIELDBROKEN: "هجوم تحطيم الدرع",
  T_41_XXJ_WS_SHIELDUP: "هجوم الدرع",
  T_41_XXJ_WS_SHOCKWAVE: "الموجة الصدمة",
  T_41_XXJ_WS_SHOWNAME: "عرض اللقب",
  T_41_XXJ_WS_SHOWNAME_D: "عرض اللقب",
  T_41_XXJ_WS_SHOWPIN: "عرض دبوس",
  T_41_XXJ_WS_SHOWPIN_D: "عرض دبوس",
  T_41_XXJ_WS_SHOWRANK: "عرض التصنيف",
  T_41_XXJ_WS_SHOWRANK_D: "عرض التصنيف",
  T_41_XXJ_WS_SHOWTYPE: "التصميم",
  T_41_XXJ_WS_SHOWTYPE_D: "نوع",
  T_41_XXJ_WS_SHRINKSPEED: "سرعة التقليص",
  T_41_XXJ_WS_SIGHTAIMASSIST: "تمكين مساعدة التصويب على النطاق",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTFALLOFF: "مساعدة التصويب على حساسية التقاطع مع المسافة (0-1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOCOEF: "معامل عند تحديد أولويات المسافة لمساعدة التصويب (≥ 1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMAX: "أقصى مسافة لتحديد أولوية المسافة للمساعدة في التصويب",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMIN: "أدنى مسافة لتحديد أولوية المسافة للمساعدة في التصويب",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIORITY: "تحديد أولويات المسافة للمساعدة في التصويب",
  T_41_XXJ_WS_SIGHTAIMASSISTSNAPRANGE: "مساعدة التصويب على حساسية التقاطع (0-1)",
  T_41_XXJ_WS_SIGHTAMPLIFYRATIO: "عامل تكبير النطاق",
  T_41_XXJ_WS_SIGHTFOVAMPLIFYRATIO: "عامل التكبير FOV",
  T_41_XXJ_WS_SIGHTROTSENSITIVENESS: "معامل حساسية دوران النطاق",
  T_41_XXJ_WS_SIGHTSHOOTMINDAMAGE: "المعامل المعدل للحد الأدنى من الضرر",
  T_41_XXJ_WS_SIGHTUIACTIONEXPAND: "نطاق في إطلاق واجهة المستخدم لتكبير الوقت (ثانية)",
  T_41_XXJ_WS_SIGHTUIACTIONRATIO: "تم تحديده في إطلاق عامل تكبير واجهة المستخدم",
  T_41_XXJ_WS_SIGHTUIACTIONRECOVERY: "تحديد نطاق في وقت (ثانية) استئناف واجهة المستخدم",
  T_41_XXJ_WS_SPEED: "سرعة التشغيل",
  T_41_XXJ_WS_SPEEQUIP: "المعدات الوظيفية",
  T_41_XXJ_WS_SPEITEM: "الأجهزة",
  T_41_XXJ_WS_STATICGRAPHID: "معرف النص الثابت",
  T_41_XXJ_WS_STATICGRAPHID_D: "المعرّف المستخدم لوصف أصل برنامج نصي ثابت",
  T_41_XXJ_WS_STATICWAINING: "فشل تعديل نوع Rigidbody الثابت",
  T_41_XXJ_WS_TARGETTREE: "كيان شجرة السلوك",
  T_41_XXJ_WS_TARGETTREE_D: "كيان شجرة السلوك",
  T_41_XXJ_WS_TEAMINDEX: "الرقم التسلسلي للفريق",
  T_41_XXJ_WS_TEAMINDEX_D: "مؤشر الفريق، والذي يتزامن مع مؤشر الفريق في الغرفة",
  T_41_XXJ_WS_TEAMINDEX_D1: "رقم فصيل الفريق",
  T_41_XXJ_WS_TEMPLATEPREFABID: "معرف النموذج الجاهز",
  T_41_XXJ_WS_TEXT_D: "محتوى",
  T_41_XXJ_WS_TEXTURENAME: "اسم الملمس",
  T_41_XXJ_WS_TEXTURENAME_D: "اسم الملمس",
  T_41_XXJ_WS_THROWATTACK: "قنبلة",
  T_41_XXJ_WS_TICKINTERVAL: "تحديث الفاصل",
  T_41_XXJ_WS_TICKINTERVAL_D: "تحديث الفاصل. كلما زاد الرقم، زادت مدة التحديث.",
  T_41_XXJ_WS_TOGGLESPECIALITEMSTATE_D: "تمكين الأجهزة الخاصة في حقيبة ظهر اللاعب",
  T_41_XXJ_WS_UVRECTWH: "عرض وارتفاع الأشعة فوق البنفسجية",
  T_41_XXJ_WS_UVRECTWH_D: "عرض وارتفاع الأشعة فوق البنفسجية",
  T_41_XXJ_WS_UVRECTXY: "إزاحة الأشعة فوق البنفسجية",
  T_41_XXJ_WS_UVRECTXY_D: "إزاحة الأشعة فوق البنفسجية",
  T_41_XXJ_WS_VELOCITY: "سرعة",
  T_41_XXJ_WS_VELOCITY_D: "امتنع عن تغيير سرعة RigidBody مباشرة. يمكنك تغييرها باستخدام APIs المرتبطة.",
  T_41_XXJ_WS_VEST_D: "السترة الحالية",
  T_41_XXJ_WS_VEST1_D: "سترة",
  T_41_XXJ_WS_WIDGETID: "معرف التحكم",
  T_41_XXJ_WS_WIDGETID_D: "المعرّف المستخدم لوصف عنصر تحكم في أصول الواجهة. يجب إقرانه بمعرف HUD المخصص للتأكد من أنه يتوافق مع معرف تحكم فريد.",
  T_41_XXJ_WS_WINDATTACK: "هجوم تورنادو",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET: "اكتب إزاحة قاعدة البيانات المتراكمة",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET_D: "اكتب الإزاحة المقابلة لمفتاح في جدول في قاعدة البيانات المتراكمة",
  T_41_XXJ_WS_ZONEDURATION_D: "مدة الوقف",
  T_41_XXJ_WS_ZONEDURATION1_D: "مدة مذيب الجلو",
  T_41_XXJ_WS_ZONERADIUS_D: "قطر منطقة الوقف",
  T_41_XXJ_WS_ZONERADIUS1_D: "نصف قطر مذيب الجلو",
  T_41_XYL_WS_BOT12: "حفار الأرض",
  T_41_XYL_WS_BOT9: "الزومبي المتحول المرمي",
  T_41_XYL_WS_ITEM262: "لوحة الصلب المجمدة A",
  T_41_XYL_WS_ITEM263: "الحاوية المجمدة A",
  T_41_XYL_WS_ITEM264: "حاوية الإمداد المجمدة",
  T_41_XYL_WS_ITEM265: "البوابة المعدنية المجمدة",
  T_41_XYL_WS_ITEM266: "الحاوية المجمدة B",
  T_41_XYL_WS_ITEM267: "الحجر المجمد A",
  T_41_XYL_WS_ITEM268: "الحجر المجمد B",
  T_41_XYL_WS_ITEM269: "الحجر المجمد C",
  T_41_XYL_WS_ITEM270: "الحجر المجمد D",
  T_41_XYL_WS_ITEM271: "سيارة مترو المهجورة",
  T_41_XYL_WS_MODELMATCHNAME: "لوحة المسابقة",
  T_41_XYL_WS_NAVMESH: "ديناميكي navmesh",
  T_41_XYL_WS_REFCUBE: "مكعب عاكس",
  T_41_XYL_WS_SNOWSKY: "المجرة المثلجة",
  T_41_XYL_WS_TOYCUBE: "مكعب اللعبة",
  T_42_CJ_F_B_VOCATIONAL: "مخططة ميكانيكية (سفلي)",
  T_42_CJ_F_H_VOCATIONAL: "مخططة ميكانيكية (رأس)",
  T_42_CJ_F_S_VOCATIONAL: "مخططة ميكانيكية (حذاء)",
  T_42_CJ_F_T_VOCATIONAL: "مخططة ميكانيكية (علوي)",
  T_42_CJ_HA_THUNDER_GOLD: "طلاء الوجه البرق",
  T_42_CJ_M_B_VOCATIONAL: "ماستر ميكانيكي (سفلي)",
  T_42_CJ_M_H_VOCATIONAL: "ماستر ميكانيكي (رأس)",
  T_42_CJ_M_S_VOCATIONAL: "ماستر ميكانيكي (حذاء)",
  T_42_CJ_M_T_VOCATIONAL: "ماستر ميكانيكي (علوي)",
  T_42_H_CHARACTER_SUPERTEEN_N: "إغنيس",
  T_42_H_GLOO_EVOTIGER_N: "جدار جلو - غضب النمر",
  T_42_H_GRENADE_SMUDGE_N: "قنبلة - ظل القطة",
  T_42_H_M1917_EMPIRE_N: "M1917 - القائد المتوج",
  T_42_HJ_WS_VFX_INK: "الحبر",
  T_42_JH_WS_BANMATCHMAKING: "التوفيق غير مسموح به لهذه الخريطة",
  T_42_JH_WS_BANROOMCREATE: "غير قادر على إنشاء غرفة",
  T_42_JH_WS_FPS: "منظور الشخص الأول",
  T_42_JH_WS_SKILLSETALOKAWAKEN: "حفلة ريمكس (ألوك)",
  T_42_JH_WS_SKILLSETFIREWALL: "جدار اللهب (إغنيس)",
  T_42_JH_WS_SKILLSETSANTINO: "فاصل شكلي (سانتينو)",
  T_42_JH_WS_SKILLSETSONIA: "درع الحياة (سونيا)",
  T_42_JH_WS_TAG1: "قتال الصقيع",
  T_42_JH_WS_TAG10: "المسابق اللانهاي",
  T_42_JH_WS_TAG11: "سباق السرعة",
  T_42_JH_WS_TAG12: "سباق السيارات",
  T_42_JH_WS_TAG13: "استبعاد من الشعبية",
  T_42_JH_WS_TAG14: "خط المواجهة",
  T_42_JH_WS_TAG15: "حرب الزومبي",
  T_42_JH_WS_TAG16: "أسطورة الإرث",
  T_42_JH_WS_TAG2: "جزيرة الصداقة 1.0",
  T_42_JH_WS_TAG3: "جزيرة الصداقة 2.0",
  T_42_JH_WS_TAG4: "اللعب معًا",
  T_42_JH_WS_TAG5: "ناجي الخراب",
  T_42_JH_WS_TAG6: "حفلة المفترسة",
  T_42_JH_WS_TAG7: "حفلة المفترسة",
  T_42_JH_WS_TAG8: "معركة فورت 2.0",
  T_42_JH_WS_TAG9: "صيد الجوائز",
  T_42_RW_PORTALSFORPERSONAL_DESC: "ضع بوابة في أي مكان وانتقل بعيدًا!",
  T_42_RW_PORTALSPERSONAL_NAME: "بوابة الذهاب",
  T_42_SJ_WS_ACCESSORIESITEM: "تجهيز المرفق",
  T_42_SJ_WS_AUTOPLAY: "التشغيل التلقائي",
  T_42_SJ_WS_CLIMB: "تسلق",
  T_42_SJ_WS_CLOCK_EVENTS: "تجميع الأحداث",
  T_42_SJ_WS_CLOCK_IS_COUNTDOWN: "العد التنازلي أم لا",
  T_42_SJ_WS_CLOCK_LOOP_COUNT: "الحلقات",
  T_42_SJ_WS_CLOCK_PAUSE_EVENT: "إيقاف الحدث مؤقتا",
  T_42_SJ_WS_CLOCK_START_EVENT: "بدء الحدث",
  T_42_SJ_WS_CLOCK_START_TIME: "وقت بدء العد التنازلي",
  T_42_SJ_WS_CLOCK_STATE: "حالة ساعة الإيقاف",
  T_42_SJ_WS_CLOCK_STOP_EVENT: "إيقاف الحدث",
  T_42_SJ_WS_DAMRATIOHEAD: "تغير معامل ضرر طلقة الرأس",
  T_42_SJ_WS_DAMRATIOLIMB: "تغير معامل ضرر الأطراف",
  T_42_SJ_WS_DAMREDUCEXPLODE: "معامل التخفيض من الأضرار المتفجرة",
  T_42_SJ_WS_DRIVE: "قيادة",
  T_42_SJ_WS_ENTITYITEXT_DEPTH: "عرض الطبقات",
  T_42_SJ_WS_EXTRABAGCAPACITY: "سعة حقيبة الظهر الإضافية",
  T_42_SJ_WS_EXTRAHPRATIO: "نسبة نقاط الصحة",
  T_42_SJ_WS_GETOFF_DRIVE: "خروج المركبة",
  T_42_SJ_WS_GETON_DRIVE: "أدخل المركبة",
  T_42_SJ_WS_KNIFEITEM: "الخنجر",
  T_42_SJ_WS_KNIFEITEMPICK: "خنجر (نهب الأرض)",
  T_42_SJ_WS_MARKBTNHUD: "زر الإشارة على HUD",
  T_42_SJ_WS_MARKBTNHUD_D: "يمكنك تمكين أو تعطيل زر الإشارة",
  T_42_SJ_WS_MAXDISTANCE: "الحد الأقصى للمسافة",
  T_42_SJ_WS_MAXDURARATIO: "نسبة المتانة القصوى",
  T_42_SJ_WS_MICBTNHUD: "مفتاح الميكروفون على HUD",
  T_42_SJ_WS_MICBTNHUD_D: "يمكنك تمكين أو تعطيل زر الميكروفون",
  T_42_SJ_WS_MINDISTANCE: "الحد الأدنى للمسافة",
  T_42_SJ_WS_OPE_VEHICLE: "تشغيل المركبة",
  T_42_SJ_WS_PLANE_DESC: "شبكة أساسية يمكن تعديل حجمها بحرية",
  T_42_SJ_WS_PLANENAME: "الطائرة الأساسية",
  T_42_SJ_WS_PRIORITY: "الأفضلية",
  T_42_SJ_WS_REPLACEPRIORITY: "استبدال الأفضلية",
  T_42_SJ_WS_SETBTNHUD: "زر الإعدادات على HUD",
  T_42_SJ_WS_SETBTNHUD_D: "يمكنك تمكين أو تعطيل زر الإعدادات",
  T_42_SJ_WS_SIGNALBTNHUD: "زر اتصال الشبكة على HUD",
  T_42_SJ_WS_SIGNALBTNHUD_D: "يمكنك تمكين أو تعطيل زر الاتصال بالشبكة",
  T_42_SJ_WS_SPEAKERBTNHUD: "زر البوق على HUD",
  T_42_SJ_WS_SPEAKERBTNHUD_D: "يمكنك تمكين أو تعطيل زر بوق المركبة",
  T_42_SJ_WS_START_TIME: "وقت البدء (ث)",
  T_42_SW_SKILL_DESC_ARMSDEALER: "احصل على [FFB300]{0}[-] سعة إضافية لحقيبة الظهر للذخيرة، باستثناء قاذفة القنابل. ([FFB300]{1}[-] ذخيرة AR، [FFB300]{2}[-] ذخيرة SMG، [FFB300]{3}[-] ذخيرة القناصة، [FFB300]{4}[-] ذخيرة SG)",
  T_42_SW_SKILL_DESC_Bodyguard: "تزيد سرعة إعادة التحميل بنسبة [FFB300]{0}%[-]. في كل مرة يضرب فيها مستخدم المهارة عدوًا، سيحصل الهدف المذكور على [FFB300]{1}%[-] خصم شفاء يستمر لمدة [FFB300]{3}ث[-] (الحد الأقصى للخصم: [FFB300]{2}%[-].",
  T_42_SW_SKILL_DESC_Playboy: "يصبح محصنًا من التأثيرات التخريبية (مثل التباطؤ ووضع العلامات وإسكات المهارات) ويتمتع [FFB300]{1}%[-] زيادة في سرعة الحركة لمدة [FFB300]{2}ث[-]. التهدئة: [FFB300]{0}ث[-].",
  T_42_SW_SKILL_DESC_SwatGuy: "بعد إسقاط عدو أو استخدام مهارة نشطة، تتم إعادة تحميل [FFB300]{0}%[-] من مخزن السلاح تلقائيًا",
  T_42_SW_SKILL_NAME_Playboy: "ملعقة فضية",
  T_42_SY_BACKPACK_EMPIRE_N: "حقيبة - الزئير المتوج",
  T_42_SY_PETSKIN_RABBIT_WINTERFEST23_N: "سكن الحيوان الأليف: هوب الجليدي",
  T_42_SY_VEHICLESKIN_MOTOBIKE_URBAN_BW_N: "دراجة نارية - سكوتر الحضرية",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_AFF_N: "أفينتادور ألتيما بوياه",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_ASILVER_N: "أفينتادور ألتيما الفضي",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VBLACK_N: "فينينو الأسود",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VRED_N: "فينينو الأحمر",
  T_42_TYC_CST_LOSE_MONEY_1: "مبلغ نقود كلاش سكواد الذي تم الحصول عليه بعد خسارة الجولة",
  T_42_TYC_CST_LOSE_MONEY_2: "مبلغ نقود كلاش سكواد الذي تم الحصول عليه بعد جولتين من الخسارة المتتالية",
  T_42_TYC_CST_LOSE_MONEY_3: "مبلغ نقود كلاش سكواد الذي تم الحصول عليه بعد 3 جولات من الخسارة المتتالية",
  T_42_WH_ITEM_HEALUAV: "درون-لايت العلاج",
  T_42_WH_ITEM_HEALUAV_DESC: "ينشر درون لايت يطير للأمام ويعمل باستمرار على شفاء زملاء الفريق ضمن النطاق أدناه",
  T_42_WH_ITEM_SKILLCARD: "المهارة: {0}",
  T_42_WH_ITEM_SKILLCARD_DESC: `استخدم لإطلاق المهارة النشطة [ffba00]{0}[-]: [ffba00]{1}[-].
{2}`,
  T_42_XXJ_WS_AMMOTYPE: "نوع الذخيرة",
  T_42_XXJ_WS_AMMOTYPE_D: "نوع الذخيرة",
  T_42_XXJ_WS_ASSETCONFIGID: "معرف الغلاف",
  T_42_XXJ_WS_ASSETCONFIGID_D: "غلاف",
  T_42_XXJ_WS_ATTACKSTATUS: "حالة الهجوم",
  T_42_XXJ_WS_AUTOPLAY: "التشغيل التلقائي",
  T_42_XXJ_WS_AUTOPLAY_D: "التشغيل التلقائي",
  T_42_XXJ_WS_AVATARABLE: "مكون المظهر القابل للتعديل",
  T_42_XXJ_WS_AVATARABLE_D: "تغيير المظهر وفقًا للأجزاء",
  T_42_XXJ_WS_AVATARRESUUID: "مظهر الموارد UUID",
  T_42_XXJ_WS_AXISANGLETOQUATERNION_D: "تحويل تمثيل زاوية المحور للدوران إلى الرباعي",
  T_42_XXJ_WS_B_D: "قيمة اللون B",
  T_42_XXJ_WS_BASEVALUE_D: "أساس المنطق",
  T_42_XXJ_WS_BEZIERCURVE: "منحنى بيزيه",
  T_42_XXJ_WS_BEZIERCURVE_D: "منحنى بيزيه",
  T_42_XXJ_WS_BOTDIFFICULTY: "صعوبة الروبوت",
  T_42_XXJ_WS_BOUNCE_COMBINE: "طريقة الجمع للمرونة",
  T_42_XXJ_WS_BOUNCINES: "المرونة",
  T_42_XXJ_WS_BTREEID: "معرف شجرة السلوك",
  T_42_XXJ_WS_BTREEID_D: "معرف شجرة السلوك",
  T_42_XXJ_WS_CANPURCHAS: "قابلة للشراء أم لا",
  T_42_XXJ_WS_CANPURCHAS_D: "قابلة للشراء أم لا",
  T_42_XXJ_WS_CLIMBSTATUS: "سلوك التسلق",
  T_42_XXJ_WS_CLOCK: "عنصر الموقت",
  T_42_XXJ_WS_CLOCK_D: "عنصر الموقت",
  T_42_XXJ_WS_CLOCK_D1: "المؤقت",
  T_42_XXJ_WS_CONTAINER: "حاوية",
  T_42_XXJ_WS_CONTROLPOINTS: "نقاط التحكم",
  T_42_XXJ_WS_CONTROLPOINTS_D: "نقاط التحكم",
  T_42_XXJ_WS_COROUTINEID: "مقبض التنفيذ المتواصل",
  T_42_XXJ_WS_COROUTINEID_D: "يشير معرف التنفيذ المتواصل إلى مقبض التنفيذ المتواصل محدد. يسمح بإجراء عمليات مختلفة على المقبض.",
  T_42_XXJ_WS_CREATESELFRELATIVE_D: "أنشئ نسبي ذاتي",
  T_42_XXJ_WS_CREATESELFRELATIVEFRAME_D: "أنشئ نسبي ذاتي",
  T_42_XXJ_WS_CREATESOUND: "أنشئ تأثير صوتي",
  T_42_XXJ_WS_CREATESOUND_D: "قم بتشغيل المؤثرات الصوتية المحددة. إذا كان هناك المزيد من الخصائص لتعيينها، فيمكنك القيام بذلك عن طريق تكوين خصائص الكيان.",
  T_42_XXJ_WS_CUSTOMMISSIONCOMPLETE_D: "اكمل المهمة المخصصة",
  T_42_XXJ_WS_DAMAGELIST_D: "قائمة زيادة الضرر",
  T_42_XXJ_WS_DAMAGERATIOHEAD_D: "نسبة ضرر طلقة الرأس",
  T_42_XXJ_WS_DAMAGEREDUCTIONFACTOREXPLODE_D: "مضاعف تقليل ضرر الانفجار",
  T_42_XXJ_WS_DEFAULT_PHYMAT: "المادة المادية الافتراضية",
  T_42_XXJ_WS_DEFAULTFIST_D: "القبضة الإفتراضية",
  T_42_XXJ_WS_DELTA: "ديلتا",
  T_42_XXJ_WS_DELTA_D: "ديلتا",
  T_42_XXJ_WS_DELTATIME: "الفاصل الزمني المنطقي للإطار",
  T_42_XXJ_WS_DELTATIME_D: "الفاصل بين تحديثي الإطار المنطقي لـ GS",
  T_42_XXJ_WS_DEPTH: "طبقة",
  T_42_XXJ_WS_DEPTH_D: "عرض الطبقات على الأيقونة",
  T_42_XXJ_WS_DISABLEPICKUPITEMS: "قائمة الغنائم الأرضية المعطلة",
  T_42_XXJ_WS_DISABLEPICKUPITEMS_D: "قائمة العناصر التي لا تعتبر نهبًا أرضيًا",
  T_42_XXJ_WS_DRIVER: "مقعد السائق",
  T_42_XXJ_WS_DRIVINGSTATUS: "قيادة",
  T_42_XXJ_WS_DURATION_D1: "مدة العد التنازلي في ثواني",
  T_42_XXJ_WS_DURATION_D2: "المدة في ثواني",
  T_42_XXJ_WS_DURATION_D3: "المدة",
  T_42_XXJ_WS_DURATION_D4: "مدة الحصانة في ثوان",
  T_42_XXJ_WS_DURATIONTIMES: "المدة الزمنية",
  T_42_XXJ_WS_DURATIONTIMES_D: "المدة في ثواني",
  T_42_XXJ_WS_DYNAMIC_FRICTION: "الاحتكاك الديناميكي",
  T_42_XXJ_WS_EASY: "سهل جدًا",
  T_42_XXJ_WS_ENDTIMES: "وقت النهاية",
  T_42_XXJ_WS_ENDTIMES_D: "وقت الانتهاء على المؤقت بالثواني",
  T_42_XXJ_WS_ENERGYTHRESHOLD: "عتبة الطاقة العالمية",
  T_42_XXJ_WS_ENTITYVARNAME_D: "الكيان النسبي الذاتي",
  T_42_XXJ_WS_EQUIPMENTATTACHMENT_D: "تجهيز المرفق",
  T_42_XXJ_WS_EULERANGLETOQUATERNION_D: "حول زوايا أويلر المعطاة إلى الرباعي",
  T_42_XXJ_WS_EXPONENTIATION_D: "الأس",
  T_42_XXJ_WS_EXTRABAGCAPACITY_D: "سعة حقيبة الظهر الإضافية",
  T_42_XXJ_WS_FIST: "قبضة",
  T_42_XXJ_WS_FONTTYPE: "تعداد الخط",
  T_42_XXJ_WS_FONTTYPE_D: "تعداد الخط",
  T_42_XXJ_WS_FORCESYNCVALUE: "فرض مزامنة حالة GS",
  T_42_XXJ_WS_FORCESYNCVALUE_D: "قيمة مزامنة القوة",
  T_42_XXJ_WS_FORCESYNCVALUE_D1: "معلومات الموقع. من مزامنة قوة GS",
  T_42_XXJ_WS_FORCESYNCVALUE1: "معلومات الموقع من مزامنة القوة",
  T_42_XXJ_WS_FORMULABLEENTITY_D: "كيان يمكنه صياغة الخصائص",
  T_42_XXJ_WS_FORWARD_D: "متجه الاتجاه",
  T_42_XXJ_WS_FRICTION_COMBINE: "طريقة الجمع الاحتكاك",
  T_42_XXJ_WS_FUNCPOINT: "مؤشر الوظيفة",
  T_42_XXJ_WS_FUNCPOINT_D: "مؤشر يشير إلى مثيل للوظيفة. يتم استخدامه لتنفيذ الوظائف الافتراضية أو آليات التفويض.",
  T_42_XXJ_WS_GETMAPID_D: "احصل على معرف الخريطة",
  T_42_XXJ_WS_GETOFFVEHICLESTATUS: "خروج المركبة",
  T_42_XXJ_WS_GETONASDRIVERSTATUS: "أدخل المركبة (السائق)",
  T_42_XXJ_WS_GETONASPASSENGERSTATUS: "أدخل المركبة (الركاب)",
  T_42_XXJ_WS_GETPLAYERTOKENCOUNTTODAY_D: "ابحث عن بيانات التوكن للاعب اليوم",
  T_42_XXJ_WS_GRAVITY: "الجاذبية العالمية",
  T_42_XXJ_WS_HANDHELDITEM: "الجهاز المحمول الحالي",
  T_42_XXJ_WS_HANDHELDITEM_D: "الجهاز المحمول الحالي",
  T_42_XXJ_WS_HARD: "صعب",
  T_42_XXJ_WS_HASCOMPONENT_D: "ما إذا كان هناك مكون",
  T_42_XXJ_WS_HEIGHTLIST_D: "قائمة زيادة الارتفاع",
  T_42_XXJ_WS_INDEXLIST_D: "قم بالوصول إلى قائمة المؤشر الخاصة بالسلسلة",
  T_42_XXJ_WS_INSCENE: "في المشهد",
  T_42_XXJ_WS_INSCENE_D: "في المشهد",
  T_42_XXJ_WS_IS3D_D: "سواء كانت موسيقى ثلاثية الأبعاد",
  T_42_XXJ_WS_ISCOUNTDOWN_D: "العد التنازلي أو ساعة الإيقاف",
  T_42_XXJ_WS_ISLOOP: "تكرار أم لا",
  T_42_XXJ_WS_ISLOOP_D: "قيادة IsLoop",
  T_42_XXJ_WS_ISREPLAY_D: "ما إذا كان يجب البدء من البداية أم لا",
  T_42_XXJ_WS_ISSWITCH_D: "عند ضبطه على صحيح، يمكن دمجه مع الحركة النسبية. عند ضبطه على خطأ، يمكن دمجه مع الحركة المطلقة.",
  T_42_XXJ_WS_JEEP: "سيارة جيب",
  T_42_XXJ_WS_JUMPSTATUS: "حالة القفز",
  T_42_XXJ_WS_LEFTVALUE: "القيمة اليسرى",
  T_42_XXJ_WS_LEFTVALUE_D: "أساسي",
  T_42_XXJ_WS_LOGARITHM_D: "المنطق",
  T_42_XXJ_WS_LOOPABLE: "قابل للتكرار",
  T_42_XXJ_WS_LOOPABLE_D: "قابل للتكرار",
  T_42_XXJ_WS_MAPGETALLKEYS_D: "احصل على جميع المفاتيح من القاموس",
  T_42_XXJ_WS_MAPVALUE_D: "القاموس الهدف",
  T_42_XXJ_WS_MARKBTNHUD: "زر الدبوس على HUD",
  T_42_XXJ_WS_MATHE: "e",
  T_42_XXJ_WS_MATHPI: "pi",
  T_42_XXJ_WS_MAXDISTANCE_D: "الحد الأقصى للمسافة",
  T_42_XXJ_WS_MICROPHONEBTNHUD: "مفتاح الميكروفون الموجود على HUD",
  T_42_XXJ_WS_MINDISTANCE_D: "الحد الأدنى للمسافة",
  T_42_XXJ_WS_MISSIONID_D: "معرف المهمة",
  T_42_XXJ_WS_MISSIONPROGRESS_D: "التقدم (لا يمكن أن يكون رقمًا سالبًا)",
  T_42_XXJ_WS_MODERATE: "معتدل",
  T_42_XXJ_WS_MONSTERTRUCK: "شاحنة متوحشة",
  T_42_XXJ_WS_MOTORBIKE: "دراجة نارية",
  T_42_XXJ_WS_MOVEMENTSTATUS: "حالة الحركة",
  T_42_XXJ_WS_MULTIPLYQUATERNION_D: "ضرب اثنين من الرباعي (يمثل تراكب الدوران)",
  T_42_XXJ_WS_NORMAL: "عادية",
  T_42_XXJ_WS_OBSOLETE: "تم التخلص منها",
  T_42_XXJ_WS_OPENPLAYERVIEW: "تمكين منظور اللاعب",
  T_42_XXJ_WS_OPENPLAYERVIEW_D: "تمكين منظور اللاعب",
  T_42_XXJ_WS_ORIGINWEAPONTYPE: "نوع السلاح",
  T_42_XXJ_WS_ORIGINWEAPONTYPE_D: "نوع السلاح",
  T_42_XXJ_WS_OVERLOADPLAYERSKIN: "الأفضلية لتكوين اللاعب",
  T_42_XXJ_WS_PARAMSARRAY: "مجموعة المعلمات",
  T_42_XXJ_WS_PARAMSARRAY_D: "مجموعة المعلمات هي قائمة المعلمات المشاركة في الإخراج. يجب أن يتطابق مع رقم %v في وصف التنسيق.",
  T_42_XXJ_WS_PARAMSARRAY_D1: "قائمة المعلمات الفعلية التي تم تمريرها إلى الوظائف المخصصة.",
  T_42_XXJ_WS_PARTVISABLEMASK1: "قناع الرؤية الجزء 1",
  T_42_XXJ_WS_PARTVISABLEMASK2: "قناع الرؤية الجزء 2",
  T_42_XXJ_WS_PARTVISABLEMASK3: "قناع الرؤية الجزء 3",
  T_42_XXJ_WS_PARTVISABLEMASK4: "قناع الرؤية الجزء 4",
  T_42_XXJ_WS_PASSENGER1: "مقعد الراكب 1",
  T_42_XXJ_WS_PASSENGER2: "مقعد الراكب 2",
  T_42_XXJ_WS_PASSENGER3: "مقعد الراكب 3",
  T_42_XXJ_WS_PHYMAT: "المادة المادية",
  T_42_XXJ_WS_PLAYABLEENTITIES_D: "كيان",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME: "الحركة النسبية الذاتية في كل إطار",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME_D: "الحركة النسبية الذاتية في كل إطار",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE: "الحركة النسبية الذاتية",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE_D: "الحركة النسبية الذاتية",
  T_42_XXJ_WS_PLAYER_D: "اللاعب الذي يحتاج إلى دخول المركبة",
  T_42_XXJ_WS_PLAYERBEHAVIOR: "كيان مزامنة خاصية سلوك اللاعب",
  T_42_XXJ_WS_PLAYERBEHAVIOR_D: "كيان مزامنة خاصية سلوك اللاعب",
  T_42_XXJ_WS_PRIORITY_D: "الأفضلية",
  T_42_XXJ_WS_PROPID_D: "معرف الخاصية",
  T_42_XXJ_WS_QUATERNION: "رباعي",
  T_42_XXJ_WS_QUATERNION_D: "رباعي هو متجه خاص رباعي الأبعاد يستخدم فقط لتمثيل الدوران",
  T_42_XXJ_WS_QUATERNIONTOAXISANGLE_D: "تحويل الشكل الرباعي المعطى إلى تمثيل زاوية المحور",
  T_42_XXJ_WS_QUATERNIONTOEULERANGLE_D: "تحويل الرباعيات المعطاة إلى زوايا أويلر. إذا كانت الرباعيات لا تفي بالمعيار، قم بإرجاع (0,0,0).",
  T_42_XXJ_WS_REPEATTIMES_D: "عدد مرات اللعب. الافتراضي هو 1.",
  T_42_XXJ_WS_RESETPLAYABLE_D: "إعادة ضبط",
  T_42_XXJ_WS_RIGHTVALUE: "القيمة اليمنى",
  T_42_XXJ_WS_RIGHTVALUE_D: "قوة",
  T_42_XXJ_WS_SEATTYPE: "تعداد مقعد المركبة",
  T_42_XXJ_WS_SEPSTR_D: "السلسلة المستخدمة للفصل",
  T_42_XXJ_WS_SETPLAYERFALLINGDAMAGE_D: "تعيين ضرر سقوط اللاعب",
  T_42_XXJ_WS_SETTINGSBTNHUD: "زر الإعدادات على HUD",
  T_42_XXJ_WS_SHOWPOSITION: "عرض الموقع",
  T_42_XXJ_WS_SHOWPOSITION_D: "عرض الموقع",
  T_42_XXJ_WS_SIGNALICOHUD: "زر اتصال الشبكة على HUD",
  T_42_XXJ_WS_SIMPLE: "سهل",
  T_42_XXJ_WS_SLERPQUATERNION_D: "استيفاء الرباعي الكروي من A إلى B",
  T_42_XXJ_WS_SOUNDENTITY_D: "يمثل كيان المؤثر الصوتي مؤثرًا صوتيًا يتم تشغيله",
  T_42_XXJ_WS_SPEAKERBTNHUD: "زر البوق على HUD",
  T_42_XXJ_WS_SPLITSTRING_D: "استخدم سلسلة معينة كفاصل لتقسيم السلسلة إلى شريحة",
  T_42_XXJ_WS_SPORTSCAR: "سيارة رياضية",
  T_42_XXJ_WS_SPRINTSTATUS: "حالة الركض",
  T_42_XXJ_WS_SRCVAL_D: "قيمة المصدر",
  T_42_XXJ_WS_STARTTICKCOUNT: "اللحظة التي تبدأ فيها GS في وضع علامة",
  T_42_XXJ_WS_STARTTICKCOUNT_D: "اللحظة التي تبدأ فيها GS في وضع علامة",
  T_42_XXJ_WS_STARTTIME_D: "وقت البداية",
  T_42_XXJ_WS_STARTTIME_D1: "وقت البداية",
  T_42_XXJ_WS_STATE_D: "حالة اللاعب: نشط، تم إسقاطه، تم القضاء عليه",
  T_42_XXJ_WS_STATE_D1: "تحقق مما إذا كان هذا المؤثر الصوتي قيد التشغيل",
  T_42_XXJ_WS_STATIC_FRICTION: "الاحتكاك الثابت",
  T_42_XXJ_WS_STRELEMS_D: "مجموعة السلسلة المستهدفة",
  T_42_XXJ_WS_STRINGFINDAT_D: "قم بإرجاع السلسلة المدمجة النهائية وفقًا لقائمة المؤشر",
  T_42_XXJ_WS_STRINGJOIN_D: "انضم إلى السلاسل باستخدام معرف محدد",
  T_42_XXJ_WS_STRINGLOWER_D: "تحويل كل الأحرف في السلسلة إلى أحرف صغيرة",
  T_42_XXJ_WS_STRINGSTRIP_D: "قم بإزالة أحرف المسافة البيضاء من كلا جانبي السلسلة",
  T_42_XXJ_WS_STRINGUPPER_D: "تحويل كل الأحرف في السلسلة إلى أحرف كبيرة",
  T_42_XXJ_WS_STYLE_D: "كيف يتم لعبها",
  T_42_XXJ_WS_SUV: "شاحنة",
  T_42_XXJ_WS_SWITCH: "تبديل",
  T_42_XXJ_WS_SWITCH_D: 'عند ضبطه على صحيح، يمكن دمجه مع الحركة النسبية. عند ضبطها على "خطأ"، يجب دمجها مع الحركة المطلقة، وإلا فلن يتم تفعيل الخصائص بشكل صحيح.',
  T_42_XXJ_WS_TARGETENTITY_D: "الكيان المستهدف",
  T_42_XXJ_WS_TEAMROUNDSCOREBANNERHUD: "راية نتيجة جولة الفريق",
  T_42_XXJ_WS_TEAMSEQ_D: "الرقم التسلسلي للفريق الذي يتوافق مع خاصية الرقم التسلسلي لكيان الفريق",
  T_42_XXJ_WS_TEMPORARYSHIELD: "نقاط الدرع المؤقتة",
  T_42_XXJ_WS_TEMPORARYSHIELD_D: "نقاط الدرع المؤقتة",
  T_42_XXJ_WS_TEXT_D: "النص الأصلي لإجراء تصفية الكلمات النابية",
  T_42_XXJ_WS_THREESTATESWITCH: "3-تبديل الحالة",
  T_42_XXJ_WS_THROWINGKNIFE_D: "خنجر (غنائم الأرض)",
  T_42_XXJ_WS_THROWINGKNIFEBR_D: "الخنجر",
  T_42_XXJ_WS_TUKTUK: "سيارة توك توك",
  T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD: "تفاصيل مباراة الفرق",
  T_42_XXJ_WS_UNIQUEID: "معرف فريد",
  T_42_XXJ_WS_UNIQUEID_D: "معرف فريد",
  T_42_XXJ_WS_VALUE_D: "القيمة",
  T_42_XXJ_WS_VECTOR3TOEULERANGLES_D: "متجه الاتجاه إلى زوايا أويلر",
  T_42_XXJ_WS_VEHICLEID: "معرف المركبة",
  T_42_XXJ_WS_VEHICLESKINID: "معرف غلاف المركبة",
  T_42_XXJ_WS_VERYHARD: "صعب جدًا",
  T_42_XXJ_WS_VOLUME_D: "حجم الصوت. الافتراضي هو 50.",
  T_42_XXJ_WS_WEAPONTYPE_D: "النوع الرئيسي للسلاح",
  T_42_XXJ_WS_WORKSHOPCODE: "رمز الخريطة",
  T_42_XXJ_WS_WORKSHOPCODE_D: "رمز الخريطة الذي يتوافق مع البيانات الموجودة في قاعدة البيانات",
  T_42_XXJ_WS_WORLDPOSITION: "إحداثيات العالم",
  T_42_XXJ_WS_WORLDPOSITION_D: "إحداثيات العالم",
  T_42_XYL_WS_ITEM275: "خزان الوقود",
  T_42_XYL_WS_ITEM276: "كيس الرمل A",
  T_42_XYL_WS_ITEM277: "كيس الرمل B",
  T_42_XYL_WS_ITEM278: "كيس الرمل C",
  T_42_XYL_WS_ITEM279: "كيس الرمل",
  T_42_XYL_WS_ITEM280: "فيلا مزدوجة الطابقين",
  T_42_XYL_WS_ITEM281: "مصنع الأسلحة",
  T_42_XYL_WS_ITEM282: "الجدار الحجري A",
  T_42_XYL_WS_ITEM283: "الجدار الحجري B",
  T_42_XYL_WS_ITEM284: "الجدار الحجري C",
  T_42_XYL_WS_ITEM285: "الجدار الحجري D",
  T_42_XYL_WS_ITEM286: "صندوق الإمداد العسكري A",
  T_42_XYL_WS_ITEM287: "عملة نحاسية",
  T_42_XYL_WS_ITEM288: "العملة الفضية",
  T_42_XYL_WS_ITEM289: "العملة الذهبية",
  T_42_XYL_WS_ITEM290: "الجوهرة",
  T_42_XYL_WS_ITEM291: "قطع الجواهر",
  T_42_XYL_WS_ITEM292: "الياقوت",
  T_42_XYL_WS_ITEM293: "الزمرد",
  T_42_XYL_WS_ITEM294: "الياقوت",
  T_42_XYL_WS_ITEM295: "علامة تحذير",
  T_42_XYL_WS_ITEM297: "خراب",
  T_42_XYL_WS_ITEM297TRUE: "جهاز التحكم",
  T_42_XYL_WS_ITEM298: "حاوية الإمداد B",
  T_42_XYL_WS_ITEM299: "كومة الثلج",
  T_42_XYL_WS_ITEM300: "جدار التكنولوجيا A",
  T_42_XYL_WS_ITEM301: "جدار التكنولوجيا B",
  T_42_XYL_WS_ITEM302: "الحجر المجمد F",
  T_42_XYL_WS_ITEM303: "الحجر المجمد E",
  T_42_XYL_WS_ITEM304: "منصة التكنولوجيا A",
  T_42_XYL_WS_ITEM305: "درج التكنولوجيا A",
  T_42_XYL_WS_ITEM306: "مصباح الاستكشاف A",
  T_42_XYL_WS_ITEM307: "حاجز الخراب A",
  T_42_XYL_WS_ITEM308: "حاجز الخراب B",
  T_42_XYL_WS_ITEM309: "الخراب قوس الصلب A",
  T_42_XYL_WS_ITEM310: "حجر الخراب A",
  T_42_XYL_WS_ITEM311: "حجر الخراب B",
  T_42_XYL_WS_ITEM312: "حجر الخراب C",
  T_42_XYL_WS_ITEM313: "المصباح A",
  T_42_XYL_WS_ITEM314: "خراب حديد التسليح A",
  T_42_XYL_WS_LOGICALOBJECT: "منطق",
  T_42_XYL_WS_THEMEHIGHTECH: "مستقبلي",
  T_42_XYL_WS_THEMEICE: "الجليدي",
  T_42_XYL_WS_THEMEMILITARY: "عسكري",
  T_42_XYL_WS_THEMEOBJECTS: "العنصر الموضوعي",
  T_42_XYL_WS_TIMERCONTINUE: "حادث استئناف المؤقت",
  T_42_XYL_WS_TIMERCYCLE: "عدد الحلقات",
  T_42_XYL_WS_TIMERDOWN: "العد التنازلي",
  T_42_XYL_WS_TIMEREND: "حادث انتهاء المؤقت",
  T_42_XYL_WS_TIMEREVENT: "حادث المؤقت المخصص",
  T_42_XYL_WS_TIMEREVENT1: "مؤقت التحكم",
  T_42_XYL_WS_TIMEREVENT2: "ضبط حوادث المؤقت",
  T_42_XYL_WS_TIMERORDER: "طريقة التوقيت",
  T_42_XYL_WS_TIMERPAUSE: "حادث إيقاف المؤقت",
  T_42_XYL_WS_TIMERSTART1: "وقت بدء المؤقت",
  T_42_XYL_WS_TIMERSTART2: "حادث بدء المؤقت",
  T_42_XYL_WS_TIMERUP: "العد التصاعدي",
  T_42_XYL_WS_TRIGGERTIME_MS: "وقت الزناد (بالمللي ثانية)",
  T_42_ZZ_GUILDWAR_AIRCRAFTDESC: "أجنحة يمكنها استيعاب عدة لاعبين.",
  T_42_ZZ_GUILDWAR_PERSONALSCORE: "النتيجة الفردية",
  T_42_ZZ_GUILDWAR_SCORE: "النتيجة",
  T_43_B_SKILL_DESC_MONKEYGOD: "يتحول إلى شجيرة تدوم لمدة [FFB300]{1}ث[-]. وقت التهدئة: [FFB300]{0}ث[-]. مهاجمة الآخرين أو التعرض للهجوم ستعيد ووكونج إلى حالته الأصلية. يتم إعادة تعيين التهدئة عند إسقاط عدو.",
  T_43_B_SKILL_DESC_Nanoscientist: "بعد التعرض لأضرار قاتلة، أدخل حالة غير معرضة للخطر وغير متحركة لـ [FFB300]{0}ث[-]. بعد ذلك، احصل على [FFB300]{1} درع الصحة[-] الذي  يستمر لمدة [FFB300]{2}ث[-]. سيتم القضاء على مستخدم المهارة عندما يختفي الدرع. وقت التهدئة: [FFB300]{3}ث[-].",
  T_43_B_SKILL_DESC_ORION: "يستبدل EP [FFB300]{0} بطاقة العقرب[-]. تستهلك [FFB300]{1} طاقة العقرب[-] لتنشيط الحماية، والتي لا يمكنك خلالها إلحاق الضرر أو مهاجمة الأعداء وستمتص [FFB300]{4} الصحة[-] (تجاهل نقاط درع العدو) من الأعداء في نطاق [FFB300]{3}م[-]. يستمر لمدة [FFB300]{2}ث[-]، وخلالها ستنخفض سرعة حركتك بمقدار [FFB300]{6}%[-]. وقت التهدئة: [FFB300]{5}ث[-].",
  T_43_CJ_F_A_RACER: "معززة التوربو (قناع)",
  T_43_CJ_F_B_RACER: "معززة التوربو (سفلي)",
  T_43_CJ_F_H_RACER: "معززة التوربو (رأس)",
  T_43_CJ_F_HA_RACER: "معززة التوربو (طلاء وجه)",
  T_43_CJ_F_S_RACER: "معززة التوربو (حذاء)",
  T_43_CJ_F_T_RACER: "معززة التوربو (علوي)",
  T_43_CJ_M_A_RACER: "المسابق التوربو (قناع)",
  T_43_CJ_M_B_MACHINERY: "الميكانيكي الفيروز (سفلي)",
  T_43_CJ_M_B_RACER: "المسابق التوربو (سفلي)",
  T_43_CJ_M_H_MACHINERY: "الميكانيكي الفيروز (رأس)",
  T_43_CJ_M_H_RACER: "المسابق التوربو (رأس)",
  T_43_CJ_M_HA_MACHINERY: "الميكانيكي الفيروز (طلاء وجه)",
  T_43_CJ_M_S_MACHINERY: "الميكانيكي الفيروز (حذاء)",
  T_43_CJ_M_S_RACER: "المسابق التوربو (حذاء)",
  T_43_CJ_M_T_MACHINERY: "الميكانيكي الفيروز (علوي)",
  T_43_CJ_M_T_RACER: "المسابق التوربو (علوي)",
  T_43_H_CHARACTER_GEEK_N: "رايدن",
  T_43_H_VSK94_MAMBAS_N: "VSK94 - لسعة المامبا",
  T_43_HJ_WS_OPTION8: "أخرى",
  T_43_HJ_WS_TEXTURE_BAMBOO: "بامبو",
  T_43_HJ_WS_TEXTURE_BEACH: "الشاطئ",
  T_43_HJ_WS_TEXTURE_BRICK1: "جدار من الطوب A",
  T_43_HJ_WS_TEXTURE_BRICK2: "جدار من الطوب B",
  T_43_HJ_WS_TEXTURE_BRICK3: "جدار من الطوب C",
  T_43_HJ_WS_TEXTURE_CEMENT: "أرضية خرسانية",
  T_43_HJ_WS_TEXTURE_CEMENT2: "خرساني",
  T_43_HJ_WS_TEXTURE_CRYSTAL: "كريستال",
  T_43_HJ_WS_TEXTURE_GLASSLAND1: "العشب A",
  T_43_HJ_WS_TEXTURE_GLASSLAND2: "العشب B",
  T_43_HJ_WS_TEXTURE_ICE: "كتلة الجليد",
  T_43_HJ_WS_TEXTURE_IRON: "الأرضية المعدنية",
  T_43_HJ_WS_TEXTURE_IRON2: "حاوية",
  T_43_HJ_WS_TEXTURE_LAVA: "حمم",
  T_43_HJ_WS_TEXTURE_MARBLE: "الأرضية الرخامية",
  T_43_HJ_WS_TEXTURE_NONE: "فارغ",
  T_43_HJ_WS_TEXTURE_STONE: "حجر",
  T_43_HJ_WS_TEXTURE_TEXTILE1: "مفرش المائدة A",
  T_43_HJ_WS_TEXTURE_TEXTILE2: "مفرش المائدة B",
  T_43_HJ_WS_TEXTURE_WOOD: "خشب",
  T_43_HJ_WS_TEXTURE_WOODEN: "الأرضية الخشبية A",
  T_43_HJ_WS_TEXTURE_WOODEN2: "الأرضية الخشبية B",
  T_43_JH_WS_MAPTAG1: "مبتدئ-ودية",
  T_43_JH_WS_MAPTAG10: "محتوى جديد ممل",
  T_43_JH_WS_MAPTAG11: "القليل من الشعور بالمكافأة",
  T_43_JH_WS_MAPTAG12: "مكافأة عدم التوازن",
  T_43_JH_WS_MAPTAG13: "انخفاض الشعور بالتقدم",
  T_43_JH_WS_MAPTAG14: "مبتدئ-غير ودية",
  T_43_JH_WS_MAPTAG15: "تعليمي مربك",
  T_43_JH_WS_MAPTAG16: "نقص في الدروس التعليمية",
  T_43_JH_WS_MAPTAG17: "اللاعبون يتركون كثيراً",
  T_43_JH_WS_MAPTAG18: "ضوابط معقدة",
  T_43_JH_WS_MAPTAG19: "واجهة مزدحمة",
  T_43_JH_WS_MAPTAG2: "المحتوى الجديد المفضل",
  T_43_JH_WS_MAPTAG20: "تصميم خريطة ضعيف",
  T_43_JH_WS_MAPTAG21: "إطلاق النار المثيرة",
  T_43_JH_WS_MAPTAG22: "سريع الخطى",
  T_43_JH_WS_MAPTAG23: "العالم المفتوح",
  T_43_JH_WS_MAPTAG24: "غنية بالقصص",
  T_43_JH_WS_MAPTAG25: "التقدم",
  T_43_JH_WS_MAPTAG26: "محاكاة الرياضة",
  T_43_JH_WS_MAPTAG27: "مهمة التعاونية",
  T_43_JH_WS_MAPTAG28: "اجتماعي",
  T_43_JH_WS_MAPTAG29: "حالات متنوعة",
  T_43_JH_WS_MAPTAG3: "اللاعبين النشطين",
  T_43_JH_WS_MAPTAG30: "استكشاف مجاني",
  T_43_JH_WS_MAPTAG31: "تحدي التصنيف",
  T_43_JH_WS_MAPTAG32: "الإنجاز",
  T_43_JH_WS_MAPTAG33: "استرداد العملة",
  T_43_JH_WS_MAPTAG4: "خريطة جيدة التصميم",
  T_43_JH_WS_MAPTAG40: "مكافآت كثيرة",
  T_43_JH_WS_MAPTAG41: "تقدم مرضٍ",
  T_43_JH_WS_MAPTAG42: "ساحة التدريب الشعبية",
  T_43_JH_WS_MAPTAG43: "سولو تاور الشعبي",
  T_43_JH_WS_MAPTAG44: "منطقة الحرب الشعبية",
  T_43_JH_WS_MAPTAG5: "تأتأة",
  T_43_JH_WS_MAPTAG6: "تعاون صعب",
  T_43_JH_WS_MAPTAG7: "مليئة بالأخطاء",
  T_43_JH_WS_MAPTAG8: "تحديثات قليلة",
  T_43_JH_WS_MAPTAG9: "أحداث مملة داخل المباراة",
  T_43_JH_WS_SKILLSETAUTOPATHBOMB: "فخ العنكبوت (رايدن)",
  T_43_SJ_WS_AIRDROP_ITEMS: "عنصر الإنزال الجوي",
  T_43_SJ_WS_AIRDROP_NAME: "إنزال جوي",
  T_43_SJ_WS_AIRDROP_TIME: "بدء وقت الإسقاط",
  T_43_SJ_WS_AIRDROP_UI_ITEM: "عنصر الإنزال الجوي",
  T_43_SJ_WS_ANITRIGGER_AUTO: "التشغيل التلقائي",
  T_43_SJ_WS_ANITRIGGER_CENTER: "موقف المركز",
  T_43_SJ_WS_ANITRIGGER_CLIP: "معرف مقطع الرسوم المتحركة",
  T_43_SJ_WS_ANITRIGGER_LOOP: "تكرار",
  T_43_SJ_WS_ANITRIGGER_NAME: "HUD الزناد الرسوم المتحركة",
  T_43_SJ_WS_RESET_ROUND: "إعادة تعيين لكل جولة",
  T_43_SJ_WS_START_DROPTIME: "بدء وقت الإسقاط (ملي ثانية)",
  T_43_SJ_WS_TRIGGER_ANIMA: "مشغل الرسوم المتحركة",
  T_43_SY_PETSKIN_AXOLOTL_WATERFEST24_N: "سكن الحيوان الأليف: مياو مياو زاسيل",
  T_43_SY_VEHICLESKIN_MOTOBIKE_FIGHTER_N: "دراجة نارية - السرعة المتجسدة",
  T_43_WH_ITEM_SUPPLYBOX_DESC: "يحتوي على لإمدادات المعركة الأساسية مثل الذخيرة والمواد الطبية",
  T_43_WH_ITEM_SUPPLYBOX_NAME: "صندوق الإمداد",
  T_43_WT_SKILL_DESC_DUMMY_REWORK: "قم بإنشاء تمثال [FFB300]{1} نقاط صحة[-] الذي ينتقل بشكل مستقل لمدة [FFB300]{0}ث[-]. عندما يكون التمثال ضمن [FFB300]{3}م[-]، استخدم المهارة مرة أخرى لتبديل مواضعه. يمكنك التبديل مرة واحدة فقط خلال [FFB300]{4}ث[-]، حتى [FFB300]{2} مرة [-] إجمالاً. سيتم وضع علامة على اللاعب الذي يدمر التمثال لمدة [FFB300]{5}ث[-]. وقت التهدئة: [FFB300]{6}ث[-].",
  T_43_WT_W_VSK94: "VSK94",
  T_43_XXJ_WS_ACTIVITYSKILL: "المهارة النشطة",
  T_43_XXJ_WS_AIRDROP: "الإنزال الجوي والزومبي",
  T_43_XXJ_WS_ALPHA: "ألفا",
  T_43_XXJ_WS_ALPHA_D: "الشفافية العامة لـ HUD، بنطاق من 0 إلى 1.",
  T_43_XXJ_WS_ANIMATIONCTRLID: "معرف وحدة التحكم في الرسوم المتحركة",
  T_43_XXJ_WS_ANIMATIONCTRLID_D: "المعرف المستخدم لوصف أصل وحدة التحكم في الرسوم المتحركة",
  T_43_XXJ_WS_AUDIOID: "معرف الصوت",
  T_43_XXJ_WS_AUDIOID_D: "الهوية المستخدمة لوصف الأصول الصوتية",
  T_43_XXJ_WS_BACKGRCOLOR: "لون الخلفية",
  T_43_XXJ_WS_BACKGRCOLOR_D: "لون شريط الصحة والخلفية غير الواضحة",
  T_43_XXJ_WS_BURNING: "حرق",
  T_43_XXJ_WS_CSVID: "معرف CSV",
  T_43_XXJ_WS_CSVID_D: "المعرف المستخدم لوصف أصل جدول التكوين",
  T_43_XXJ_WS_CURRENTHP: "نقاط الصحة الحالية",
  T_43_XXJ_WS_CURRENTHP_D: "قيمة الصحة الحالية",
  T_43_XXJ_WS_DAMAGEMAKER_D: "كيان اللعبة الذي يلحق الضرر",
  T_43_XXJ_WS_DAMAGEZONE: "منطقة الضرر",
  T_43_XXJ_WS_DEFAULT: "الإفتراضي",
  T_43_XXJ_WS_DEFAULT_D: "الإفتراضي",
  T_43_XXJ_WS_EFFECTID: "معرف التأثير",
  T_43_XXJ_WS_EFFECTID_D: "المعرف المستخدم لوصف أصل ذو تأثير خاص",
  T_43_XXJ_WS_FIGHTINGENTITY_D: "كيان قابل للقتال (المثال قادر على الهجوم، والضرب، والقتل، وإلخ)",
  T_43_XXJ_WS_FOLLOWTARGET: "اتبع الهدف",
  T_43_XXJ_WS_FOLLOWTARGET_D: "يجب أن يتبع كيانًا بمكون تحويل",
  T_43_XXJ_WS_GAINHPCOLOR: "لون كسب الصحة",
  T_43_XXJ_WS_GAINHPCOLOR_D: "سيظهر الجزء المتزايد من الصحة بهذا اللون لفترة قصيرة",
  T_43_XXJ_WS_ISNOFALLDAMAGE: "لا يوجد ضرر السقوط",
  T_43_XXJ_WS_ISOPENTWEEN: "محرك التوين مفتوح",
  T_43_XXJ_WS_ISOPENTWEEN_D: "قم بتمكين هذا لإظهار تغييرات الصحة بألوان مختلفة",
  T_43_XXJ_WS_KNOCKDOWN_D1: "اللاعب في حالة السقوط",
  T_43_XXJ_WS_KNOCKDOWN_D2: "إعدادات الاستجابة لحالة السقوط عند تم القضاء",
  T_43_XXJ_WS_KNOCKDOWN_D3: "نوع مصدر الإحياء. يمكن إنعاش اللاعب أثناء سقوطه.",
  T_43_XXJ_WS_KNOCKDOWNSTATE: "حالة السقوط",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE: "نوع حالة السقوط",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE_D: "الاستجابة لحالة السقوط: الحفاظ على المنطق الافتراضي، وتخطي حالة السقوط، أو فرض السقوط.",
  T_43_XXJ_WS_LEVEL: "المستوى",
  T_43_XXJ_WS_LEVEL_D: "المستوى",
  T_43_XXJ_WS_LEVEL_D1: "مستوى الزومبي الحالي",
  T_43_XXJ_WS_LINESPACING: "تباعد الأسطر",
  T_43_XXJ_WS_LINESPACING_D: "لا يتم عرضه عندما تكون نقاط الصحة المجزأة بين فاصلين ≤ 0",
  T_43_XXJ_WS_LOSEHPCOLOR: "لون فقدان الصحة",
  T_43_XXJ_WS_LOSEHPCOLOR_D: "الجزء المخفض من الصحة سيظهر بهذا اللون لفترة قصيرة",
  T_43_XXJ_WS_MAINCOLOR: "اللون الرئيسي",
  T_43_XXJ_WS_MAINCOLOR_D: "لون الصحة، المستويات، والحدود",
  T_43_XXJ_WS_MINISENTRY: "البرج",
  T_43_XXJ_WS_MINISENTRYATTACKTARGETTYPE_D: "تعداد أنواع الأهداف التي يمكن أن يهاجمها البرج",
  T_43_XXJ_WS_MISSILEEXPLODE: "انفجار الصاروخ",
  T_43_XXJ_WS_MUSTKNOCKDOWN: "يجب الضربة القاضية",
  T_43_XXJ_WS_MUSTKNOCKDOWN_D: "فرض السقوط",
  T_43_XXJ_WS_OFFSET: "إزاحة",
  T_43_XXJ_WS_OFFSET_D: "الإزاحة بالنسبة للهدف المتبع",
  T_43_XXJ_WS_OILDRUMEXPLODE: "انفجار برميل النفط",
  T_43_XXJ_WS_ONCONTROLLERCOLLIDERHIT_D: "يتم تشغيله فقط عندما تبدأ وحدة التحكم في الحركة",
  T_43_XXJ_WS_PLAYER_D: "كيان اللاعب داخل اللعبة. كل لاعب لديه واحد.",
  T_43_XXJ_WS_PLAYERHEADHUD: "HUD رأس اللاعب",
  T_43_XXJ_WS_PLAYERHEADHUD_D: "المعلومات المعروضة فوق رأس اللاعب",
  T_43_XXJ_WS_PLAYERNAME: "اسم اللاعب",
  T_43_XXJ_WS_PLAYERNAME_D: "يعرض اسم مالك شريط الصحة الحالي",
  T_43_XXJ_WS_PLAYERORVEHICLE: "لاعب أو مركبة",
  T_43_XXJ_WS_PLAYERORVEHICLE_D: "الاسم المستعار لنوع كيان اللاعب/المركبة",
  T_43_XXJ_WS_SCALE: "حجم",
  T_43_XXJ_WS_SCALE_D: "يحدد الحجم الإجمالي لمقياس HUD، مع تحديد الخط ليتناسب.",
  T_43_XXJ_WS_SHOWDAMAGENUMBER: "إظهار رقم الضرر",
  T_43_XXJ_WS_SHOWDAMAGENUMBER_D: "صحيح بشكل افتراضي. يعرض رقم الضرر.",
  T_43_XXJ_WS_SKIPKNOCKDOWN: "تخطي السقوط",
  T_43_XXJ_WS_SKIPKNOCKDOWN_D: "تخطي حالة السقوط وتم القضاء على الفور",
  T_43_XXJ_WS_SKIPSTAGGERANIMATION: "هو تخطي إزاحة الرسوم المتحركة",
  T_43_XXJ_WS_TEAM_D: "(مهمل. يرجى استخدام معرف الفريق.)",
  T_43_XXJ_WS_TERRAIN: "تضاريس",
  T_43_XXJ_WS_TERRAIN_D: "مكون التضاريس الذي لا يمكن تعديل سماته. يستخدم لاختبار الوظائف فقط.",
  T_43_XXJ_WS_TOTALHP: "إجمالي الصحة",
  T_43_XXJ_WS_TOTALHP_D: "إجمالي قيمة الصحة",
  T_43_XXJ_WS_TWEENENTITY: "كيان محرك التوين",
  T_43_XXJ_WS_VEHICLEEXPLODE: "انفجار المركبة",
  T_43_XXJ_WS_WIDTH: "العرض",
  T_43_XXJ_WS_WIDTH_D: "عرض شريط الصحة المعروض",
  T_43_XXJ_WS_ZOMBIE: "الزومبي",
  T_43_XYL_WS_DROIDFIST: "قبضة (صعود الروبوتات)",
  T_43_XYL_WS_DROIDFLAME: "قاذف اللهب (صعود الروبوتات)",
  T_43_XYL_WS_JAPANESE: "النمط الياباني",
  T_43_YU_WS_ADDGAMEEVENTLOGMAP_D: "تخصيص سجلات أحداث المباراة. تستخدم لتحليل تجربة المستخدم.",
  T_43_YU_WS_AIRDROPSTATE: "حالة الإنزال الجوي",
  T_43_YU_WS_AIRDROPSTATE_D: "حالة الإنزال الجوي (1: جاهز، 2: إسقاط، 3: هبوط)",
  T_43_YU_WS_ANIMATIONCLIPID: "معرف مقطع الرسوم المتحركة",
  T_43_YU_WS_ANIMATIONCLIPID_D: "تخصيص معرف مقطع الرسوم المتحركة",
  T_43_YU_WS_ASKBUYTARGET: "اسأل شراء الهدف",
  T_43_YU_WS_ASKBUYTARGET_D: "يحدد الهدف ويرسل طلب الشراء",
  T_43_YU_WS_ASKEDLIST: "قائمة الأسئلة",
  T_43_YU_WS_ASKEDLIST_D: "قائمة العناصر المطلوبة",
  T_43_YU_WS_BACKGROUNDCOLOR1: "لون الخلفية 1",
  T_43_YU_WS_BACKGROUNDCOLOR1_D: "لون الخلفية العلوي",
  T_43_YU_WS_BACKGROUNDCOLOR2: "لون الخلفية 2",
  T_43_YU_WS_BACKGROUNDCOLOR2_D: "لون الخلفية السفلي",
  T_43_YU_WS_BATCHCOMBINERENDER: "دفعة الجمع بين التقديم",
  T_43_YU_WS_BINDMONEYENTITYLIST: "ربط قائمة كيانات المال",
  T_43_YU_WS_BINDMONEYENTITYLIST_D: "قائمة كيانات العملة المرتبطة",
  T_43_YU_WS_BINDWALLETENTITYID: "ربط معرف كيان المحفظة",
  T_43_YU_WS_BINDWALLETENTITYID_D: "معرف كيان المحفظة المرتبط",
  T_43_YU_WS_CENTEROFFSET: "إزاحة المركز",
  T_43_YU_WS_CENTEROFFSET_D: "قيمة الإزاحة لمصادم الكبسولة",
  T_43_YU_WS_COLLECTIONID: "معرف المجموعة",
  T_43_YU_WS_COLLECTIONID_D: "معرف المجموعة المستخدم لجمع معلومات الأصول",
  T_43_YU_WS_CREATEAIRDROPENTITY_D: "أنشئ إنزالًا جويًا",
  T_43_YU_WS_CREATEUGCDAMAGENUM_D: "أنشى رقم الضرر",
  T_43_YU_WS_CROSSPLATFORM_D: "عند الاختيار، أرسل إلى العميل إذا تم استدعاؤه على الخادم والعكس صحيح.",
  T_43_YU_WS_CSROUNDRESULTHUD: "HUD نتيجة جولة كلاش سكواد",
  T_43_YU_WS_CSROUNDRESULTHUD_D: "يتم عرض النتائج في نهاية كل جولة",
  T_43_YU_WS_CURRENTEMOTECLIP: "مقطع الرقصة الحالي",
  T_43_YU_WS_CURRENTEMOTECLIP_D: "معرف مقطع الرقصة الحالي",
  T_43_YU_WS_DAMAGE_D: "الضرر خارج المنطقة",
  T_43_YU_WS_DICTIONARY: "قاموس",
  T_43_YU_WS_DIRECTIONRULERHUD: "HUD حاكم الاتجاه",
  T_43_YU_WS_DIRECTIONRULERHUD_D: "البوصلة في الأعلى",
  T_43_YU_WS_DOTWEEN_D: "ما إذا كان سيتم تنفيذ رسوم متحركة توين",
  T_43_YU_WS_DROPITEMS_D: "العناصر في الإنزال الجوي",
  T_43_YU_WS_DURATION: "المدة",
  T_43_YU_WS_ENERGY: "طاقة",
  T_43_YU_WS_ENERGY_D: "قيمة تعديل EP",
  T_43_YU_WS_EPHYSXPOSE_CREEPING: "انبطح",
  T_43_YU_WS_EPHYSXPOSE_CROUCHING: "انحن",
  T_43_YU_WS_EPHYSXPOSE_DASHING: "الركض",
  T_43_YU_WS_EPHYSXPOSE_STANDING: "وقف",
  T_43_YU_WS_EVENTID: "معرف الحدث",
  T_43_YU_WS_EVENTID_D: "يمثل حدثًا",
  T_43_YU_WS_FACTION: "فصيل",
  T_43_YU_WS_FACTION_D: "كيان الفصيل",
  T_43_YU_WS_FACTION_D1: "اطلب من الفصيل المساعدة في الشراء",
  T_43_YU_WS_FINALRADIUS_D: "نصف القطر النهائي للمنطقة الآمنة",
  T_43_YU_WS_FIRSTAIDKIT: "معدات طبية",
  T_43_YU_WS_FIRSTAIDKIT_D: "معدات طبية",
  T_43_YU_WS_FIRSTPERSONMODEL: "نموذج الشخص الأول",
  T_43_YU_WS_FIRSTPERSONMODEL_D: "كاميرا الشخص الأول",
  T_43_YU_WS_FONTCOLOR_D: "لون الخط",
  T_43_YU_WS_FONTSIZE_D: "حجم الخط",
  T_43_YU_WS_FORBIDEN: "محظور",
  T_43_YU_WS_FORBIDEN_D: "قم بتعطيل HUD لطلب الشراء",
  T_43_YU_WS_FREEZINGTIME: "تجميد الوقت",
  T_43_YU_WS_FREEZINGTIME_D: "المدة التي يظل فيها الهدف المصاب مجمداً",
  T_43_YU_WS_GRAVITY: "جاذبية",
  T_43_YU_WS_GRAVITY_D: "تسارع الجاذبية. يؤثر فقط على وحدة تحكم اللاعب.",
  T_43_YU_WS_HANDCATAPULT: "لوحة القفز",
  T_43_YU_WS_HANDCATAPULT_D: "لوحة القفز",
  T_43_YU_WS_HEALTH: "صحة",
  T_43_YU_WS_HEALTH_D: "قيمة استعادة متانة الدرع",
  T_43_YU_WS_HEIGHT: "طول",
  T_43_YU_WS_HELPEDPLAYER_D: "اللاعب الذي يتم مساعدته",
  T_43_YU_WS_HELPPLAYER_D: "اللاعب الذي يساعد في عملية الشراء",
  T_43_YU_WS_HORIZONTALMAXANGLE: "الزاوية القصوى الأفقية",
  T_43_YU_WS_HORIZONTALMINANGLE: "الزاوية الدنيا الأفقية",
  T_43_YU_WS_HUDTOGGLE: "HUD تبديل",
  T_43_YU_WS_HUDTOGGLE_D: "كيان تبديل HUD الذي يمكن للاعبين تحريره في محرر HUD",
  T_43_YU_WS_INHALER: "المستنشق",
  T_43_YU_WS_INHALER_D: "المستنشق",
  T_43_YU_WS_INITRADIUS_D: "نصف القطر الأولي للمنطقة الآمنة",
  T_43_YU_WS_INT64: "Int64",
  T_43_YU_WS_INT64_D: "عدد صحيح موقع 64-bit",
  T_43_YU_WS_ISAPPLYSHADOW: "يتم تطبيق الظل",
  T_43_YU_WS_ISBOTTOMCOLLIDING: "هو الاصطدام السفلي",
  T_43_YU_WS_ISCURRENTEMOTELOOP: "هي حلقة الرقصة الحالية",
  T_43_YU_WS_ISCURRENTEMOTELOOP_D: "ما إذا كان سيتم تعيين الرسوم المتحركة الرقصة الحالية على التكرار",
  T_43_YU_WS_ISSIDECOLLIDING: "هو الاصطدام الجانبي",
  T_43_YU_WS_ISSLIDING: "ينزلق",
  T_43_YU_WS_ISTOPCOLLIDING: "هو الاصطدام العلوي",
  T_43_YU_WS_ITEM331: "الجهاز المستقبلي A",
  T_43_YU_WS_ITEM332: "الصخرة المتوهجة A",
  T_43_YU_WS_ITEM333: "الشاشة المستقبلية A",
  T_43_YU_WS_ITEM334: "الحاوية المستقبلية A",
  T_43_YU_WS_ITEM335: "الحاوية المستقبلية A",
  T_43_YU_WS_ITEM336: "أريكة الحجر A",
  T_43_YU_WS_ITEM337: "التبديل المستقبلي A",
  T_43_YU_WS_ITEM338: "الأنابيب المستقبلية A",
  T_43_YU_WS_ITEM339: "المنصة المعدنية A",
  T_43_YU_WS_ITEM340: "الطاولة المستقبلية A",
  T_43_YU_WS_ITEM341: "الطاولة المستقبلية B",
  T_43_YU_WS_ITEM342: "الطاولة المستقبلية C",
  T_43_YU_WS_ITEM343: "الكمبيوتر المستقبلي A",
  T_43_YU_WS_ITEM344: "الحجر A",
  T_43_YU_WS_ITEM345: "الحجر B",
  T_43_YU_WS_ITEM346: "الحجر C",
  T_43_YU_WS_ITEM347: "الحجر D",
  T_43_YU_WS_ITEM348: "الحجر E",
  T_43_YU_WS_ITEM349: "الحجر F",
  T_43_YU_WS_ITEM350: "الحجر G",
  T_43_YU_WS_ITEM351: "ستار بنمط ياباني A",
  T_43_YU_WS_ITEM352: "ستار بنمط ياباني B",
  T_43_YU_WS_ITEM353: "ستار بنمط ياباني C",
  T_43_YU_WS_ITEM354: "سلالم بنمط ياباني A",
  T_43_YU_WS_ITEM355: "سياج بنمط ياباني A",
  T_43_YU_WS_ITEM356: "سياج بنمط ياباني B",
  T_43_YU_WS_ITEM357: "سياج بنمط ياباني C",
  T_43_YU_WS_ITEM358: "منصة بنمط ياباني A",
  T_43_YU_WS_ITEM359: "جدار بنمط ياباني B",
  T_43_YU_WS_ITEM360: "بوابة بنمط ياباني B",
  T_43_YU_WS_ITEM361: "الجدار المستقبلي D",
  T_43_YU_WS_ITEM362: "الجدار المستقبلي B",
  T_43_YU_WS_ITEM363: "لوح زاوية التكنولوجيا",
  T_43_YU_WS_LEFTCOLOR: "لون اليسار",
  T_43_YU_WS_LEFTCOLOR_D: "لون الجانب الأيسر",
  T_43_YU_WS_LEFTPLAYERARRAY: "مجموعة اللاعب الأيسر",
  T_43_YU_WS_LEFTPLAYERARRAY_D: "مجموعة اللاعب الأيسر",
  T_43_YU_WS_LEFTSCORE: "النتيجة اليسرى",
  T_43_YU_WS_LEFTSCORE_D: "النتيجة الجانب الأيسر",
  T_43_YU_WS_LEFTSCOREAFTER: "النتيجة اليسرى بعد",
  T_43_YU_WS_LEFTSCOREAFTER_D: "النتيجة النهائية للجانب الأيسر. تستخدم في الرسوم المتحركة الانتقال النتيجة.",
  T_43_YU_WS_LEVELOBJECTID: "معرف عنصر المرحلة",
  T_43_YU_WS_LEVELOBJECTID_D: "يصف نوع الكائن. يتطلب التحليل من خلال جدول تكوين SceneEditPrefab قبل التحميل.",
  T_43_YU_WS_LOCALPOSITION_D: "الإحداثيات في نظام الإحداثيات المحلي",
  T_43_YU_WS_LOCALPOSITION_D1: "الموقف النسبي",
  T_43_YU_WS_LOCALPOSITION_D2: "الموضع بالنسبة إلى المرساة اليمنى السفلية",
  T_43_YU_WS_LOCALPOSITION_D3: "الموقف بالنسبة للمرساة",
  T_43_YU_WS_LOCALROTATION_D: "زوايا الدوران في نظام الإحداثيات المحلي (X: ياو، Y: خطوة، وZ: لفة)",
  T_43_YU_WS_LOCALROTATIONQ_D: "الرباعي في نظام الإحداثيات المحلي",
  T_43_YU_WS_LOCALSCALE_D: "حجم المقياس في نظام الإحداثيات العالمي",
  T_43_YU_WS_MASS: "الكتلة",
  T_43_YU_WS_MATERIALS: "مواد",
  T_43_YU_WS_MATERIALS_D: "قائمة المواد المستخدمة للتقديم",
  T_43_YU_WS_MAXSPEED: "السرعة القصوى",
  T_43_YU_WS_MAXSPEED_D: "لن يتم توليد المزيد من قوة الحصان بعد الوصول إلى السرعة القصوى، لكن سرعة المركبة قد تتجاوز الحد (المثال، من خلال التسارع عند النزول من التل).",
  T_43_YU_WS_MESHID: "معرف الشبكة",
  T_43_YU_WS_MESHID_D: "يصف نوع الشبكة",
  T_43_YU_WS_MESHID1: "معرف الشبكة",
  T_43_YU_WS_MESHID1_D: "الشبكة المستخدمة في التقديم",
  T_43_YU_WS_MINMOVEDISTANCE: "الحد الأدنى لمسافة الحركة",
  T_43_YU_WS_MINMOVEDISTANCE_D: "لن يتم تنفيذ الحركة بمسافة أقصر من هذه القيمة. يوصى بتعيينه على 0 ما لم تكن هناك متطلبات خاصة.",
  T_43_YU_WS_MODULE_AI: "الذكاء الاصطناعي",
  T_43_YU_WS_MODULE_AIRDROP: "إنزال جوي",
  T_43_YU_WS_MODULE_ANIMATION: "الرسوم المتحركة",
  T_43_YU_WS_MODULE_AVATAR: "صورة",
  T_43_YU_WS_MODULE_BASEATTRIBUTES: "السمات الأساسية",
  T_43_YU_WS_MODULE_BEHAVIOURTREE: "شجرة السلوك",
  T_43_YU_WS_MODULE_BUFF: "تقوية",
  T_43_YU_WS_MODULE_CAMERA: "كاميرا",
  T_43_YU_WS_MODULE_CHATCHANNEL: "قناة الدردشة",
  T_43_YU_WS_MODULE_CHECKPOINT: "نقطة تسجيل",
  T_43_YU_WS_MODULE_COLLECTION: "مجموعة",
  T_43_YU_WS_MODULE_COMBAT: "قتال",
  T_43_YU_WS_MODULE_COMPONENT: "مكون",
  T_43_YU_WS_MODULE_CONVERT: "تحويل",
  T_43_YU_WS_MODULE_CUSTOMIZEROOMPARAMETERS: "تخصيص معلمات الغرفة",
  T_43_YU_WS_MODULE_DATABASE: "مخزن البيانات",
  T_43_YU_WS_MODULE_DYEING: "صبغ",
  T_43_YU_WS_MODULE_DYNAMICNAVMESH: "ديناميكي NavMesh",
  T_43_YU_WS_MODULE_ECONOMY: "اقتصاد",
  T_43_YU_WS_MODULE_FF_PLATFORM: "منصة FF",
  T_43_YU_WS_MODULE_FOOTBALL: "كرة القدم",
  T_43_YU_WS_MODULE_FRAMERATEMODE: "وضع معدل الإطار",
  T_43_YU_WS_MODULE_GAMERESULT: "نتائج اللعبة",
  T_43_YU_WS_MODULE_GLOBAL: "عالمي",
  T_43_YU_WS_MODULE_GLOBALSCRIPTS: "البرامج النصية العالمية",
  T_43_YU_WS_MODULE_HANGUPANDCHEAT: "التوقف عن اللعب والغش",
  T_43_YU_WS_MODULE_HUD: "HUD",
  T_43_YU_WS_MODULE_INPUTSYSTEM: "نظام الإدخال",
  T_43_YU_WS_MODULE_ITEMS: "العناصر",
  T_43_YU_WS_MODULE_LEVELOBJECT: "عنصر المرحلة",
  T_43_YU_WS_MODULE_LIST: "قائمة",
  T_43_YU_WS_MODULE_MAP: "الخريطة",
  T_43_YU_WS_MODULE_MATCHING: "مباراة",
  T_43_YU_WS_MODULE_MATH: "حساب",
  T_43_YU_WS_MODULE_MECHANISM: "معلمات الآلية",
  T_43_YU_WS_MODULE_MINIMAP: "خريطة مصغرة",
  T_43_YU_WS_MODULE_MORPH: "تحول",
  T_43_YU_WS_MODULE_OTHER: "أخرى",
  T_43_YU_WS_MODULE_PET: "حيوان أليف",
  T_43_YU_WS_MODULE_PHYSICS: "المادية",
  T_43_YU_WS_MODULE_PLAYABLE: "قابلة للعب",
  T_43_YU_WS_MODULE_PLAYER: "لاعب",
  T_43_YU_WS_MODULE_PLAYERSCRIPTS: "نصوص اللاعب",
  T_43_YU_WS_MODULE_PRESETCHARACTER: "الإعداد المسبق للشخصية",
  T_43_YU_WS_MODULE_PROFILE: "الملف الشخصي",
  T_43_YU_WS_MODULE_PROPERTYFORMULA: "صيغة الملكية",
  T_43_YU_WS_MODULE_SAFEZONE: "منطقة آمنة",
  T_43_YU_WS_MODULE_SCENE: "مشهد",
  T_43_YU_WS_MODULE_SKILL: "مهارة",
  T_43_YU_WS_MODULE_STATICSCRIPTS: "البرامج النصية الثابتة",
  T_43_YU_WS_MODULE_STATISTICALREPORT: "بلاغ",
  T_43_YU_WS_MODULE_STDLIBRARY: "مكتبة STD",
  T_43_YU_WS_MODULE_STRINGS: "سلاسل",
  T_43_YU_WS_MODULE_TEAM: "فريق",
  T_43_YU_WS_MODULE_WORKFLOW: "سير العمل",
  T_43_YU_WS_MONEYICON: "أيقونة المال",
  T_43_YU_WS_MONEYICON_D: "أيقونة العملة",
  T_43_YU_WS_MONEYICONCOLOR: "لون أيقونة المال",
  T_43_YU_WS_MONEYICONCOLOR_D: "لون أيقونة العملة",
  T_43_YU_WS_MOVESAFEZONE_D: "يحرك المنطقة الآمنة بسلاسة من موضع البداية إلى موضع النهاية. سيتعرض اللاعبون خارج المنطقة لقدر معين من الضرر.",
  T_43_YU_WS_NEWVECTOR2: "المتجه 2 الجديد",
  T_43_YU_WS_NEWVECTOR2_D: "يحصل على متجه جديد ثنائي الأبعاد",
  T_43_YU_WS_OFFSET_D: "إزاحة الموقع العالمي بالنسبة للكيان المستهدف",
  T_43_YU_WS_ONSHOPREQUESTFILLED_D: "عند تلبية طلب شراء اللاعب",
  T_43_YU_WS_ONSHOPREQUESTPURCHASE_D: "عندما يطلب اللاعب المساعدة في الشراء في المتجر",
  T_43_YU_WS_ONTOGGLECHANGE_D: "يتم تشغيله عندما تتغير حالة مكون التبديل",
  T_43_YU_WS_OPENSTATE: "الحالة المفتوحة",
  T_43_YU_WS_OPENSTATE_D: "يتم عرضه عند التعيين على صحيح ويخفي إذا لم يكن كذلك",
  T_43_YU_WS_PACEMAKER: "هوريزالين",
  T_43_YU_WS_PACEMAKER_D: "هوريزالين",
  T_43_YU_WS_PARAMS_D: "قائمة المعلمات",
  T_43_YU_WS_PARENT_D: "معرف الكيان المسجل أثناء التسلسل",
  T_43_YU_WS_PHYSICALCCT: "CCT المادي",
  T_43_YU_WS_PHYSICALCCT_D: "وحدة تحكم اللاعب ذات التأثيرات الجسدية",
  T_43_YU_WS_PLAYER_D: "اللاعب المشتري",
  T_43_YU_WS_PLAYERDATAID: "معرف بيانات اللاعب",
  T_43_YU_WS_PLAYERDATAID_D: "تخصيص معرف أصول الشخصية",
  T_43_YU_WS_PLAYERPHYSXPOSETYPE: "نوع وضع PhysX لللاعب",
  T_43_YU_WS_POSITION: "موضع",
  T_43_YU_WS_POSITION_D: "الإحداثيات في نظام الإحداثيات العالمي",
  T_43_YU_WS_POSITION_D1: "الإحداثيات في نظام الإحداثيات العالمي. فعالة فقط للموسيقى ثلاثية الأبعاد.",
  T_43_YU_WS_PRESSEDSPRITE: "النقش المتحرك المضغوط",
  T_43_YU_WS_PRESSEDSPRITE_D: "النقش المتحرك المضغوط",
  T_43_YU_WS_PRESSEDSPRITETYPE: "نوع النقش المتحرك المضغوط",
  T_43_YU_WS_PRESSEDSPRITETYPE_D: "نوع النقش المتحرك المضغوط",
  T_43_YU_WS_PRETIME: "وقت مبكر",
  T_43_YU_WS_RADIUS: "نصف القطر",
  T_43_YU_WS_RANDOMRANGE_D: "قم بتصحيح الموضع المحدد بناءً على نطاق عشوائي",
  T_43_YU_WS_REQUESTPURCHASETYPE: "نوع طلب الشراء",
  T_43_YU_WS_REQUESTPURCHASETYPE_D: "طلب الشراء في المتجر",
  T_43_YU_WS_REQUESTTYPE: "نوع الطلب",
  T_43_YU_WS_REQUESTTYPE_D: "نوع الهدف الذي يطلبه لاعب HUD الحالي",
  T_43_YU_WS_RESPLAYERUUID: "نوع لاعب الإعداد المسبق",
  T_43_YU_WS_RESPLAYERUUID_D: "معرف أصول اللاعب",
  T_43_YU_WS_RESUUID: "الأصول UUID",
  T_43_YU_WS_RESUUID_D: "يحدد UUID لأصول الدفعة التي سيتم تقديمها",
  T_43_YU_WS_RIGHTCOLOR: "لون اليمين",
  T_43_YU_WS_RIGHTCOLOR_D: "لون الجانب الأيمن",
  T_43_YU_WS_RIGHTPLAYERARRAY: "مجموعة اللاعب الأيمن",
  T_43_YU_WS_RIGHTPLAYERARRAY_D: "مجموعة اللاعب الأيمن",
  T_43_YU_WS_RIGHTSCORE: "النتيجة اليمنى",
  T_43_YU_WS_RIGHTSCORE_D: "النتيجة الجانب الأيمن",
  T_43_YU_WS_RIGHTSCOREAFTER: "النتيجة اليمنى بعد",
  T_43_YU_WS_RIGHTSCOREAFTER_D: "النتيجة النهائية للجانب الأيمن. تستخدم في الرسوم المتحركة الانتقال النتيجة.",
  T_43_YU_WS_ROTATIONQ_D: "الرباعي في نظام الإحداثيات العالمي",
  T_43_YU_WS_ROUNDINFOHUD: "HUD معلومات الجولة",
  T_43_YU_WS_ROUNDINFOHUD_D: "المعلومات المعروضة في بداية الجولة",
  T_43_YU_WS_SELECTEDCOLOR: "اللون المحدد",
  T_43_YU_WS_SELECTEDCOLOR_D: "لون النقش المتحرك المحدد",
  T_43_YU_WS_SELECTEDSPRITE: "النقش المتحرك المحدد",
  T_43_YU_WS_SELECTEDSPRITE_D: "النقش المتحرك المحدد",
  T_43_YU_WS_SELECTEDTYPE: "النوع المحدد",
  T_43_YU_WS_SELECTEDTYPE_D: "نوع النقش المتحرك المحدد",
  T_43_YU_WS_SHADOWCOLOR: "لون الظل",
  T_43_YU_WS_SHADOWOFFSET: "إزاحة الظل",
  T_43_YU_WS_SHOWTAG: "إظهار العلامة",
  T_43_YU_WS_SHOWTAG_D: "إظهار علامات الفريق/الفصيل",
  T_43_YU_WS_SHRINKDURATION_D: "تقلص مدة المنطقة الآمنة",
  T_43_YU_WS_SIMPLERENDER_D: "مكون عرض الانتقال المستخدم للعرض باستخدام النماذج المضمنة",
  T_43_YU_WS_SKINWIDTH: "عرض الغلاف",
  T_43_YU_WS_SKINWIDTH_D: "عمق الاختراق داخل الكبسولة لمنع الشخصية من التعثر أو الاهتزاز",
  T_43_YU_WS_SLOPELIMIT: "حد المنحدر",
  T_43_YU_WS_SLOPELIMIT_D: "العناصر الموضوعة على المنحدر والتي تزيد عن هذا الزاوية ستنزلق إلى الأسفل",
  T_43_YU_WS_SPEED: "سرعة",
  T_43_YU_WS_STARTDROPTIME_D: "وقت وصول الإنزال الجوي بالمللي ثانية",
  T_43_YU_WS_STARTPOS_D: "موقف البداية للمنطقة الآمنة",
  T_43_YU_WS_STATICICONCOLORS: "ألوان الأيقونات الثابتة",
  T_43_YU_WS_STATICICONCOLORS_D: "ألوان الأيقونة تظهر على المسطرة",
  T_43_YU_WS_STATICICONS: "أيقونات ثابتة",
  T_43_YU_WS_STATICICONS_D: "الأيقونات المعروضة على المساطر",
  T_43_YU_WS_STEPOFFSET: "إزاحة الخطوة",
  T_43_YU_WS_STEPOFFSET_D: "فقط العقبات التي تتجاوز هذا الارتفاع سيكون لها تأثير مانع",
  T_43_YU_WS_SUBTITLE: "العنوان الفرعي",
  T_43_YU_WS_SUBTITLE_D: "العنوان الفرعي",
  T_43_YU_WS_TARGET: "هدف",
  T_43_YU_WS_TARGET_D: "الكيان المستهدف لرقم الضرر المعروض",
  T_43_YU_WS_TARGETICONCOLORS: "ألوان أيقونة الهدف",
  T_43_YU_WS_TARGETICONCOLORS_D: "ألوان الأيقونة التي يظهرها الهدف المميز",
  T_43_YU_WS_TARGETICONS: "أيقونات الهدف",
  T_43_YU_WS_TARGETICONS_D: "الأيقونات التي تظهرها الأهداف المحددة",
  T_43_YU_WS_TARGETPOS_D: "الموضع النهائي المستهدف للمنطقة الآمنة",
  T_43_YU_WS_TEAM: "فريق",
  T_43_YU_WS_TEAM_D: "كيان الفريق في اللعبة. كل فريق لديه كيان واحد.",
  T_43_YU_WS_TEAM_D1: "اطلب من الفريق المساعدة في الشراء",
  T_43_YU_WS_TIMEOFSTAY_D: "مدة العرض بالمللي ثانية",
  T_43_YU_WS_TITLE: "العنوان",
  T_43_YU_WS_TITLE_D: "العنوان الرئيسي",
  T_43_YU_WS_TRANSFORM_D: "التدوير والقياس وسجل الوالدين والطفل",
  T_43_YU_WS_UNSELECTEDCOLOR: "اللون غير المحدد",
  T_43_YU_WS_UNSELECTEDCOLOR_D: "لون النقش المتحرك غير المحدد",
  T_43_YU_WS_UNSELECTEDSPRITE: "النقش المتحرك غير المحدد",
  T_43_YU_WS_UNSELECTEDSPRITE_D: "النقش المتحرك غير المحدد",
  T_43_YU_WS_UNSELECTEDTYPE: "النوع غير المحدد",
  T_43_YU_WS_UNSELECTEDTYPE_D: "نوع النقش المتحرك غير المحدد",
  T_43_YU_WS_USEPHYSICALCCT: "استخدم CCT المادي",
  T_43_YU_WS_VALUE_D: "المحتوى المعروض",
  T_43_YU_WS_VECTOR2ADD: "إضافة المتجه 2",
  T_43_YU_WS_VECTOR2GETX: "المتجه 2 الحصول على X",
  T_43_YU_WS_VECTOR2GETY: "المتجه 2 الحصول على Y",
  T_43_YU_WS_VECTOR2SCALE: "مقياس المتجه 2",
  T_43_YU_WS_VECTOR2SETX: "المتجه 2 مجموعة X",
  T_43_YU_WS_VECTOR2SETY: "المتجه 2 مجموعة Y",
  T_43_YU_WS_VECTOR2SUB: "المتجه 2 الفرعي",
  T_43_YU_WS_VELOCITY: "سرعة",
  T_43_YU_WS_VERTICALMAXANGLE: "الزاوية القصوى العمودية",
  T_43_YU_WS_VERTICALMINANGLE: "الزاوية الدنيا العمودية",
  T_43_YU_WS_VISIBILITY_D: "يشير إلى ما إذا كان يمكن ضبط الرؤية",
  T_43_YU_WS_VISIBLE_D: "إعداد الرؤية. إذا تم تعيينه على غير مرئي، فسيتوقف العميل عن عرض الهدف.",
  T_43_YU_WS_X: "X",
  T_43_YU_WS_X_D: "X",
  T_43_YU_WS_Y: "Y",
  T_43_YU_WS_Y_D: "Y",
  T_43_ZY_WS_ITEM319: "الجدار المستقبلي A",
  T_43_ZY_WS_ITEM320: "الجدار المستقبلي C",
  T_43_ZY_WS_ITEM321: "نافذة التكنولوجيا",
  T_43_ZY_WS_ITEM322: "الباب المستقبلي",
  T_43_ZY_WS_ITEM323: "سقف بزاوية مستقبلية",
  T_43_ZY_WS_ITEM324: "سقف دائري مستقبلي",
  T_43_ZY_WS_ITEM325: "لوح التكنولوجيا",
  T_43_ZY_WS_ITEM326: "اللوح الدائري المستقبلي",
  T_43_ZY_WS_ITEM327: "السلالم المستقبلية",
  T_43_ZY_WS_ITEM328: "الزخرفة المستقبلية A",
  T_43_ZY_WS_ITEM329: "مبنى التكنولوجيا A",
  T_43_ZY_WS_ITEM330: "مبنى التكنولوجيا B",
  T_44_CJ_M_B_SPORT_TH: "زي رياضي (سفلي)",
  T_44_CJ_M_H_SPORT_TH: "زي رياضي (رأس)",
  T_44_CJ_M_S_SPORT_TH: "زي رياضي (حذاء)",
  T_44_CJ_M_T_SPORT_TH: "زي رياضي (علوي)",
  T_44_CJ_W_AIRBURST: "M590",
  T_44_H_CHARACTER_DUALMAN_N: "كايروس",
  T_44_H_M24_ONIMUSHA_N: "M24 - هجوم وهج مستنقعي",
  T_44_H_USP45_CARNIVORE_N: "USP - الأسنان السامة",
  T_44_H_VEHICLESKIN_MOTOBIKE_COLLAGE_N: "الدراجة النارية - ضربات رعدية",
  "T_44_HH_GOLD_AUG-I": "AUG-I",
  "T_44_HH_GOLD_AUG-II": "AUG-II",
  "T_44_HH_GOLD_AUG-III": "AUG-III",
  T_44_JH_WS_CLHALF1: "فرض البدء مع الحد الأدنى من اللاعبين",
  T_44_JH_WS_HALFWAYKEY1: "إعطاء الأولوية للبدء بفريق كامل",
  T_44_PD_PVE_DRAGON_NAME: "التنين الميكانيكي",
  T_44_QL_GRENADE_DRAGON: "تجميد التنين",
  T_44_QL_GRENADE_DRAGON_DES: "فلاش المتجمد المحسن الذي سينفجر ثلاث مرات متتالية عند الاصطدام",
  T_44_QL_JUMPSHOESX: "العداءون التنين",
  T_44_QL_JUMPSHOESX_DES: "حذاء قفز خاص يسمح بالركض في الهواء أثناء القفزة المزدوجة",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME: "وقت إغلاق المنطقة الآمنة",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME_D: "الوقت الذي تختفي فيه المنطقة الآمنة. إذا كان وقت إغلاق المنطقة الآمنة أقل من وقت بدء المنطقة الآمنة، فلن يتم إنشاء منطقة آمنة.",
  T_44_SJ_WS_SAFEZONE_COLOR: "لون منطقة آمنة",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME: "الفاصل الزمني للضرر",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME_D: "الفاصل الزمني للضرر",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE: "قيمة الضرر",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE_D: "الضرر الذي لحق بلاعب خارج المنطقة في حالة واحدة",
  T_44_SJ_WS_SAFEZONE_DESC: "كائن قابل للوضع خارج المنطقة",
  T_44_SJ_WS_SAFEZONE_END_RADIUS: "نصف القطر النهائي خارج المنطقة",
  T_44_SJ_WS_SAFEZONE_END_RADIUS_D: "نصف القطر النهائي للمنطقة خارج المنطقة",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS: "قائمة لاعبي منطقة الأمان",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS_D: "احصل على قائمة اللاعبين في منطقة الأمان",
  T_44_SJ_WS_SAFEZONE_NAME: "المنطقة خارج المنطقة",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME: "مدة التقليص (ث)",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME_D: "المدة يستغرقها تقلص المنطقة",
  T_44_SJ_WS_SAFEZONE_START_RADIUS: "نصف القطر الأولي خارج المنطقة",
  T_44_SJ_WS_SAFEZONE_START_RADIUS_D: "نصف القطر الأولي للمنطقة خارج المنطقة",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME: "بداية وقت التقليص",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME_D: "وقت بداية تقلص المنطقة",
  T_44_SJ_WS_SAFEZONE_STARTTIME: "وقت بداية المنطقة الآمنة",
  T_44_SJ_WS_SAFEZONE_STARTTIME_D: "وقت ظهور المنطقة الآمنة في كل جولة داخل المباراة. الافتراضي هو 0.",
  T_44_WT_W_FGG: "FGL-24",
  T_44_WT_W_REWORKHEAT_NAME_X: "بلازما-X",
  T_44_XXJ_WS_ACTIVATEDALPHA: "ألفا المفعلة",
  T_44_XXJ_WS_ACTIVATEDALPHA_D: "ألفا المفعلة",
  T_44_XXJ_WS_ACTIVESKILLBTNHUD: "HUD لزر المهارة النشطة",
  T_44_XXJ_WS_ADDCOMPONENT_D: "إضافة مكون إلى كيان. يدعم فقط المكونات المخصصة. (لن تتم إضافة مكون مرة أخرى إذا كان موجودًا بالفعل.)",
  T_44_XXJ_WS_ALLMEMBERS: "جميع الأعضاء",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE: "السماح بالضغط بالخارج",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE_D: "السماح بالتشغيل خارج المنطقة المخصصة",
  T_44_XXJ_WS_ARROWIMAGE: "صورة السهم",
  T_44_XXJ_WS_ARROWIMAGE_D: "صورة السهم",
  T_44_XXJ_WS_ARROWOFFSET: "إزاحة السهم",
  T_44_XXJ_WS_ARROWOFFSET_D: "إزاحة السهم",
  T_44_XXJ_WS_ARROWSIZE: "حجم السهم",
  T_44_XXJ_WS_ARROWSIZE_D: "حجم السهم",
  T_44_XXJ_WS_AUTOPLAY_D: "اللعب تلقائيا عند الإنشاء",
  T_44_XXJ_WS_BACKGROUNDIMAGE: "صورة الخلفية",
  T_44_XXJ_WS_BACKGROUNDIMAGE_D: "الصورة الأساسية",
  T_44_XXJ_WS_BACKGROUNDRADIUS: "نصف قطر الخلفية",
  T_44_XXJ_WS_BACKGROUNDRADIUS_D: "نصف القطر الأساسي",
  T_44_XXJ_WS_BAGSKINID: "معرف غلاف حقيبة",
  T_44_XXJ_WS_BAGSKINID_D: "معرف غلاف الحقيبة",
  T_44_XXJ_WS_BONEPOSITION: "موضع العظام",
  T_44_XXJ_WS_BONEPOSITION_D: "الإحداثيات العالمية للعقدة العظمية",
  T_44_XXJ_WS_CCTMOVE: "تحريك CCT",
  T_44_XXJ_WS_COLLIDER: "المصادم",
  T_44_XXJ_WS_COLLIDERCOLLECTION: "مجموعة المصادم",
  T_44_XXJ_WS_COLLIDERCOLLECTION_D: "المكون المستخدم لوصف شكل الاصطدام",
  T_44_XXJ_WS_COLOR: "لون",
  T_44_XXJ_WS_CONTENT: "المحتوى",
  T_44_XXJ_WS_CONTENT_D: "محتوى المحفظة عبارة عن مجموعة من العملات",
  T_44_XXJ_WS_CONTEXT_D: "المحتوى المراد طباعته",
  T_44_XXJ_WS_CROSSHAIRSHUD: "HUD لعلامة التصويب",
  T_44_XXJ_WS_CURVE_D: "منحنى",
  T_44_XXJ_WS_EFFECTCOLOR_D: "لون نسيج السطح",
  T_44_XXJ_WS_ENABLE: "تمكين",
  T_44_XXJ_WS_ENTITY_D: "كيان",
  T_44_XXJ_WS_GETBAGSKINID_D: "الحصول على تكوين غلاف حقيبة اللاعب",
  T_44_XXJ_WS_GETFACTION_D: "الحصول على فصيل",
  T_44_XXJ_WS_GETLOADEDSCENE_D: "احصل على المشاهد المحمّلة التي لم يتم إلغاء تثبيتها",
  T_44_XXJ_WS_GETLOCALPLAYER_D: "احصل على اللاعب المحلي",
  T_44_XXJ_WS_GROUPID: "معرف مجموعة",
  T_44_XXJ_WS_GROUPID_D: "للمنطق الداخلي",
  T_44_XXJ_WS_HUDJOYSTICK: `لأداة جويستيك
 HUD`,
  T_44_XXJ_WS_HUDJOYSTICK_D: "كيان الجويستيك. يمكن لللاعبين تعديل واجهة HUD عبر محرر HUD.",
  T_44_XXJ_WS_HUDTOUCHPAD: "HUD لأداة لوحة اللمس",
  T_44_XXJ_WS_HUDTOUCHPAD_D: "HUD لأداة لوحة اللمس التي يمكن للاعبين تحريرها في محرر HUD",
  T_44_XXJ_WS_HUDWIDGETORCUSTOMHUD: "HUD المخصصة أو آلة HUD",
  T_44_XXJ_WS_ICON: "أيقونة",
  T_44_XXJ_WS_ICONISALWAYSSHOWN: "عرض العلامة دائماً",
  T_44_XXJ_WS_ICONISALWAYSSHOWN_D: "أظهر دائمًا العلامات على البوصلة",
  T_44_XXJ_WS_INACTIVATEDALPHA: "ألفا غير مفعل",
  T_44_XXJ_WS_INACTIVATEDALPHA_D: "ألفا غير مفعل",
  T_44_XXJ_WS_INVOKE_ARGS_MISMATCH: "عند الاتصال، لا يتطابق عدد المعلمات الفعلية مع عدد المعلمات الرسمية. الرقم المتوقع هو {0}، بينما الرقم الفعلي هو {1}.",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE: "هو عائق ديناميكي",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE_D: "يمثل عقبة ديناميكية لـ NavMesh",
  T_44_XXJ_WS_ISEND: "انتهى",
  T_44_XXJ_WS_ISEND_D: "ينتهي",
  T_44_XXJ_WS_ISSERVERDRIVEN: "يحركها الخادم",
  T_44_XXJ_WS_ISSERVERDRIVEN_D: "إذا كانت القيمة خاطئة، فلن يتمكن من التحكم في العناصر المخصصة عبر واجهات البرمجة التطبيقية.",
  T_44_XXJ_WS_ISSUC_D: "إرجاع نتيجة التنفيذ",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS: "نصف قطر سحب الجويستيك",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS_D: "نصف قطر سحب الجوستيك",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE: "صورة الجويستيك",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE_D: "صورة الجويستيك",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS: "نصف قطر الجويستيك",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS_D: "نصف قطر الجويستيك",
  T_44_XXJ_WS_LISTT_PLAYERSKILLID: "قائمة معرفات مهارات الشخصية",
  T_44_XXJ_WS_LOOPTYPE_D: "نوع الحلقة",
  T_44_XXJ_WS_MIDGAMEEXITCONFIG: "تكوين خروج في منتصف الطريق",
  T_44_XXJ_WS_MOUNTABLE: "الهرمية",
  T_44_XXJ_WS_MOUNTABLE_D: "كيان قادر على تركيب العقد الفرعية",
  T_44_XXJ_WS_MOVEMENT: "حركة",
  T_44_XXJ_WS_NAME_D: "اسم",
  T_44_XXJ_WS_NATURALCONST: "ثابت طبيعي",
  T_44_XXJ_WS_NATURALCONST_D: "تعداد الثوابت الطبيعية لتقليل التعريفات الزائدة عن الحاجة",
  T_44_XXJ_WS_NOTIFYICONANIMATION_D: "تشغيل الرسوم المتحركة للأيقونات",
  T_44_XXJ_WS_OFFSET_D: "الإزاحة الأساسية الافتراضية",
  T_44_XXJ_WS_ONFIRE_D: "يُشغِّل الحدث في كل مرة يطلق فيها اللاعب النار، أو يهاجم باستخدام قبضته، أو يهاجم باستخدام سلاح المشاجرة.",
  T_44_XXJ_WS_ONPLAYERSTANDUP_D: "تشغيل الحدث عندما يقف اللاعب من وضعية الانبطاح/الانحناء",
  T_44_XXJ_WS_ONSTARTFIRE_D: "تشغيل الحدث عندما ينقر اللاعب على زر إطلاق النار",
  T_44_XXJ_WS_OPTION: "خيارات",
  T_44_XXJ_WS_PASSIVESKILLHUD: "مهارة ثانوية HUD",
  T_44_XXJ_WS_PHYSICALMOVER: "المحرك الجسدي",
  T_44_XXJ_WS_PHYSICALMOVER_D: "سيتابع اللاعبون على هذه المنصة الحركة والدوران تلقائيًا",
  T_44_XXJ_WS_PHYSICALOBJECT: "كائن مادي",
  T_44_XXJ_WS_PHYSICALOBJECT_D: "يمكن تطبيق القوة عليها",
  T_44_XXJ_WS_PI: "باي",
  T_44_XXJ_WS_PI_D: "الثابت الرياضي π (Pi)",
  T_44_XXJ_WS_PLAYERS: "قائمة اللاعبين",
  T_44_XXJ_WS_PLAYERS_D: "قائمة اللاعبين",
  T_44_XXJ_WS_PLAYERSKILLID: "معرف مهارة الشخصية",
  T_44_XXJ_WS_PLAYERSKILLID_D: "معرف مهارة الشخصية في AvatarSkill.csv",
  T_44_XXJ_WS_PREPHYSXPOSE_D: "الوضعية السابقة قبل أن يقوم اللاعب",
  T_44_XXJ_WS_PRINT: "طباعة",
  T_44_XXJ_WS_PRINTERROR: "خطأ في الطباعة",
  T_44_XXJ_WS_PRINTERROR_D: "طباعة البيانات المستهدفة كخطأ إلى وحدة التحكم",
  T_44_XXJ_WS_PRINTWARNING: "تحذير الطباعة",
  T_44_XXJ_WS_PRINTWARNING_D: "طباعة البيانات المستهدفة كتحذير لوحدة التحكم",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN: "إعطاء الأولوية لتكوين سكن اللاعب",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN_D: "إعطاء الأولوية لتكوين سكن اللاعب خارج المباراة",
  T_44_XXJ_WS_READCSVROWBYKEY_D: "اقرأ محتوى الخلايا في صف وفقًا لرقم العمود والمفتاح",
  T_44_XXJ_WS_REMOVEBAGSKINID_D: "مسح تكوين غلاف حقيبة اللاعب",
  T_44_XXJ_WS_REMOVECOMPONENT_D: "إزالة مكون من كيان. يدعم فقط المكونات المخصصة.",
  T_44_XXJ_WS_RESETBAGSKINID_D: "إعادة تعيين تكوين غلاف حقيبة اللاعب إلى تكوينه الافتراضي خارج المباراة.",
  T_44_XXJ_WS_SETBAGSKINID_D: "تعيين تكوين غلاف حقيبة اللاعب",
  T_44_XXJ_WS_SETPARENTCLIENT_D: "الكيانات التي تدعم مكونات Transform و SkeletonPart و Player و MountPoint",
  T_44_XXJ_WS_SHOWBACKGROUND: "عرض الخلفية",
  T_44_XXJ_WS_SKINID_D: "معرف غلاف الحقيبة وتكوين الغلاف",
  T_44_XXJ_WS_SPEED_D: "سرعة التشغيل",
  T_44_XXJ_WS_TARGET: "هدف",
  T_44_XXJ_WS_TARGET_D: "العنصر المستهدف",
  T_44_XXJ_WS_TITLE: "عنوان",
  T_44_XXJ_WS_TYPEID_D: "معرف نوع المكون. يدعم فقط المكونات المخصصة.",
  T_44_XXJ_WS_UPLOADMATCHRESULT_D: "رفع نتائج المطابقة المخصصة",
  T_44_XXJ_WS_WARNINGCSVTYPE: "عدم تطابق نوع. غير قادر على قراءة محتوى الجدول.",
  T_44_XXJ_WS_X_D: "إحداثية المحور الأفقي",
  T_44_XXJ_WS_Y_D: "إحداثية المحور العمودي",
  T_44_XYL_WS_CTZSAFEZONE: "منطقة آمنة مخصصة",
  T_44_XYL_WS_CTZSAFEZONEDESC: "يولد نقطة البداية والنهاية لمنطقة آمنة بناءً على المواقع والخصائص المحددة",
  T_44_XYL_WS_HEMISPHERICALSHELL: "قذيفة نصف كروية",
  T_44_XYL_WS_QUARTERCYLINDER: "ربع سلندر",
  T_44_XYL_WS_SQUAREPYRAMID: "الهرم المربع",
  T_44_XYL_WS_TORUS: "تورس",
  T_44_XYL_WS_TRIANGULARPYRAMID: "الهرم الثلاثي",
  T_44_YU_WS_ADDGAMEEVENTLOGMAP: "إضافة خريطة سجل أحداث اللعبة",
  T_44_YU_WS_ADDUSEREVENTLOGMAP: "إضافة سجل أحداث المستخدم",
  T_44_YU_WS_ADDUSEREVENTLOGMAP_D: "سجل حدث المباراة المخصص المستخدم لتحليل بيانات تجربة المستخدم",
  T_44_YU_WS_ITEM366: "الجدار العسكري A",
  T_44_YU_WS_ITEM367: "الجدار العسكري B",
  T_44_YU_WS_ITEM368: "الجدار العسكري C",
  T_44_YU_WS_ITEM369: "الجدار العسكري D",
  T_44_YU_WS_ITEM370: "النافذة العسكرية A",
  T_44_YU_WS_ITEM371: "النافذة العسكرية B",
  T_44_YU_WS_ITEM372: "النافذة العسكرية C",
  T_44_YU_WS_ITEM373: "الباب العسكري A",
  T_44_YU_WS_ITEM374: "الباب العسكري B",
  T_44_YU_WS_ITEM375: "سقف مائل عسكري A",
  T_44_YU_WS_ITEM376: "سقف مائل عسكري B",
  T_44_YU_WS_ITEM377: "السلالم العسكرية A",
  T_44_YU_WS_ITEM378: "السلالم العسكرية B",
  T_44_YU_WS_ITEM379: "الركن العسكري A",
  T_44_YU_WS_ITEM380: "الدرابزين العسكري A",
  T_45_C_WEAPON_CUST_ENTRANCE: "تخصيص",
  T_45_CJ_TREATMENTGUN_Y_N: "مسدس العلاج-Y",
  T_45_H_CHARACTER_ELECTRICGIRL_N: "كاسي",
  T_45_H_EMOTE_MVPDANCE_N: "مسيرة البطل",
  "T_45_HH_GOLD_MAC10-I": "MAC10-I",
  "T_45_HH_GOLD_MAC10-II": "MAC10-II",
  "T_45_HH_GOLD_MAC10-III": "MAC10-III",
  T_45_HJ_CAMERA_INSPECTOR: "فحص",
  T_45_HL_Moderation_fail_1: "للأسف، لم ينجح مشروعك المقدم في الاختبار.",
  T_45_HL_Moderation_fail_2: "تنطوي",
  T_45_HL_Moderation_fail_3: "الأسباب المتضمنة:",
  T_45_HL_Moderation_fail_Location_1: "محتوى اللعبة",
  T_45_HL_Moderation_fail_reason_1: "المحتوى السام",
  T_45_HL_Moderation_fail_reason_10: "انتهاك إرشادات المجتمع",
  T_45_HL_Moderation_fail_reason_11: "التأثيرات السلبية على اقتصاديات اللعبة وانتهاكات الملكية الافتراضية",
  T_45_HL_Moderation_fail_reason_2: "محتوى غير لائق",
  T_45_HL_Moderation_fail_reason_3: "حساسة سياسياً",
  T_45_HL_Moderation_fail_reason_4: "معلومات خاطئة",
  T_45_HL_Moderation_fail_reason_5: "انتهاك حقوق الملكية",
  T_45_HL_Moderation_fail_reason_6: "انتهاك الخصوصية",
  T_45_HL_Moderation_fail_reason_7: "المخاوف الأمنية",
  T_45_HL_Moderation_fail_reason_8: "خطاب الكراهية",
  T_45_HL_Moderation_fail_reason_9: "البريد العشوائي",
  T_45_HL_Moderation_fail_reason_999: "قضايا أخرى",
  T_45_JH_WS_CLEMPTYOBJECT: "مجموعة الكائنات",
  T_45_JH_WS_PETSWITCH1: "سواء لإظهار الحيوانات الأليفة في المباراة",
  T_45_QL_CSFPP_DES: "قم بقتل جميع الأعداء من خلال منظور الشخص الأول في وضع كلاش سكواد الخاص!",
  T_45_QL_CSFPP_NAME: "كلاش سكواد: منظور الشخص الأول",
  T_45_QL_CSFPP_RANKNAME: "الشخص الأول",
  T_45_SJ_WS_REVIEW_23: "محتوى اللعبة",
  T_45_SJ_WS_REVIEW_24: "{0} يتضمن {1}",
  T_45_SJ_WS_REVIEW_25: "{0} {1} يتضمن {2}",
  T_45_SJ_WS_REVIEW_26: "[FFBA00]انقر لعرض التفاصيل >>[-]",
  T_45_SJ_WS_REVIEW_27: "غير مقبول",
  T_45_SJ_WS_REVIEW_28: "مراجعة الملاحظات",
  T_45_SJ_WS_REVIEW_29: "يتضمن المحتوى {0} انتهاكًا (انتهاكات)",
  T_45_SJ_WS_REVIEW_31: "غير مقبول",
  T_45_SJ_WS_REVIEW_32: "فشلت المراجعة بسبب استثناءات الخادم",
  T_45_SJ_WS_REVIEW_TITLE: "تفاصيل المخالفة",
  T_45_SJ_WS_VAULTTRIGGER_DES: "يفعل القفز (القفز فوق العقبات)",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE: "مسافة القفز",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE_DES: "تعديل مسافة القفز",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT: "ارتفاع القفزة",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT_DES: "يتحكم في ارتفاع الحركة لأعلى ولأسفل عند القفز",
  T_45_SJ_WS_VAULTTRIGGER_NAME: "مفعل القفز",
  T_45_TYC_CL_TEMPLATE_WS: `وضع القتل حيث يقوم اللاعبون بالقضاء على جميع الفرق المنافسة في معركة فوضوية للفوز.
يمكنك ضبط قواعد اللعب وتحرير معلمات اللعب كما تريد.`,
  T_45_W_SPEEDMODE_FLIGHT_N: "مدفع السماء",
  T_45_XXJ_WS_ACTIONTYPE_D: "0 = هجوم تلقائي، 1 = هجوم دفاعي، 2 = عدم الهجوم",
  T_45_XXJ_WS_ADDFRIEND: "إضافة صديق",
  T_45_XXJ_WS_API: "API",
  T_45_XXJ_WS_AUTO: "التلقائي",
  T_45_XXJ_WS_BASEDATA: "البيانات الأساسية",
  T_45_XXJ_WS_BOTH: "كلا",
  T_45_XXJ_WS_BYHIERARCHY: "حسب التسلسل الهرمي",
  T_45_XXJ_WS_BYPRIORITYHIGHTOLOW: "حسب الأولوية من الأعلى إلى الأقل",
  T_45_XXJ_WS_BYPRIORITYLOWTOHIGH: "حسب الأولوية من الأقل إلى الأعلى",
  T_45_XXJ_WS_CAMERA: "كاميرا",
  T_45_XXJ_WS_CAMERATYPE: "نوع الكاميرا",
  T_45_XXJ_WS_CENTERINVISIBLE: "المركز غير مرئي",
  T_45_XXJ_WS_CLIENT: "عميل",
  T_45_XXJ_WS_COLLIDERID: "معرف المصادم",
  T_45_XXJ_WS_COLLIDERID_D: "معرف المصادم",
  T_45_XXJ_WS_COMPONENT: "مكون",
  T_45_XXJ_WS_CURRENTCAMERA: "كاميرا الحالية",
  T_45_XXJ_WS_CUSTOMPUSHFORCE: "قوة الدفع المخصصة",
  T_45_XXJ_WS_DOUBLE: "مزدوج",
  T_45_XXJ_WS_DUMP: "الرمي",
  T_45_XXJ_WS_ENABLEMOVEINMIDAIR: "تمكين التحرك في الجو",
  T_45_XXJ_WS_ENABLEROTATEWITHGRAVITY: "تمكين التدوير مع الجاذبية",
  T_45_XXJ_WS_ENUM: "تعداد",
  T_45_XXJ_WS_EVENT: "حدث",
  T_45_XXJ_WS_FILLAMOUNT: "ملء العدد",
  T_45_XXJ_WS_FILLDIR: "ملء الاتجاه",
  T_45_XXJ_WS_FIRETYPE: "نوع الطلقة",
  T_45_XXJ_WS_FIRETYPE_D: "نوع إطلاق النار",
  T_45_XXJ_WS_FIXEDDELTATIME: "توقيت دلتا الثابت",
  T_45_XXJ_WS_FIXEDDELTATIME_D: "الفاصل الزمني المحدد لتحديثات الإطار بالمللي ثانية",
  T_45_XXJ_WS_FORWARD: "للأمام",
  T_45_XXJ_WS_FORWARD_D: "اتجاه المحور z في نظام الإحداثيات المحلي",
  T_45_XXJ_WS_FUNCTIONTYPE: "نوع الوظيفة",
  T_45_XXJ_WS_FUNCTIONTYPE_D: "نوع الوظيفة",
  T_45_XXJ_WS_GETLOCALAIMDIRECTION_D: "اتجاه التصويب للاعب المحلي",
  T_45_XXJ_WS_GETLOCALTIMESTAMP_D: "احصل على الطابع الزمني المحلي",
  T_45_XXJ_WS_GRADIENT: "التدرج",
  T_45_XXJ_WS_GRADIENTBOTTOM: "التدرج السفلي",
  T_45_XXJ_WS_GRADIENTBOTTOMALPHA: "التدرج السفلي ألفا",
  T_45_XXJ_WS_GRADIENTTOP: "التدرج الأعلى",
  T_45_XXJ_WS_GRADIENTTOPALPHA: "التدرج الأعلى ألفا",
  T_45_XXJ_WS_HITPOSITION_D: "الموقع العالمي للهدف الذي أصيب بالرصاص",
  T_45_XXJ_WS_HUDSOCIALBUTTONWIDGET: "أداة واجهة الزر الاجتماعي",
  T_45_XXJ_WS_INVERTFILL: "عكس الملء",
  T_45_XXJ_WS_ISGROUNDED: "مؤرض",
  T_45_XXJ_WS_ISSILENCE: "هو الصمت",
  T_45_XXJ_WS_ISSILENCE_D: "إذا تم الصمت أم لا",
  T_45_XXJ_WS_ISSINGLESHOT: "هي طلقة واحدة",
  T_45_XXJ_WS_ISSINGLESHOT_D: "إذا كانت طلقة واحدة أم لا",
  T_45_XXJ_WS_JUMPHEIGHT: "ارتفاع القفزة",
  T_45_XXJ_WS_JUMPHEIGHT_D: "ارتفاع القفزة",
  T_45_XXJ_WS_LAYOUTSORTTYPE: "تخطيط الترتيب حسب النوع",
  T_45_XXJ_WS_LIGHT_D: "أضواء",
  T_45_XXJ_WS_LOCAL: "محلي",
  T_45_XXJ_WS_MAXMULTIJUMPNUM: "الحد الأقصى لعدد القفزات",
  T_45_XXJ_WS_MODULE: "وحدة",
  T_45_XXJ_WS_NONE: "لا أحد",
  T_45_XXJ_WS_ONBEFOREHURT_D: "تنفيذ الأمر في كل مرة قبل أن يتسبب الكيان في حدوث ضرر",
  T_45_XXJ_WS_ONDISABLE_D: "يتم التنفيذ عند تمكين الكيان",
  T_45_XXJ_WS_ONEACHLOOP_D: "تُنفَّذ في كل مرة يتم تكرار القابلة للعب. فعَّالة فقط على الجانب العميل للكيانات مثل تأثير الصوت والتأثير الخاص.",
  T_45_XXJ_WS_ONENABLE_D: "يتم التنفيذ عند تمكين الكيان",
  T_45_XXJ_WS_ONFIXEDUPDATE_D: "عند الدخول إلى إطار بمعدل ثابت قدره 30 إطارًا في الثانية",
  T_45_XXJ_WS_ONFRIENDRELATIONCHANGE_D: "تشغيل حدث العميل عندما يقوم اللاعب بإضافة صديق أو حذفه",
  T_45_XXJ_WS_ONGAMEPAUSE_D: "تشغيل الحدث عندما يتم إيقاف اللعبة مؤقتًا بسبب واجهة برمجة التطبيقات المسماة",
  T_45_XXJ_WS_ONGAMERESUME_D: "قم بتشغيل الحدث عند استمرار اللعبة بسبب واجهة برمجة التطبيقات المسماة",
  T_45_XXJ_WS_ONPLAYERSTOPDASH_D: "عندما يتوقف اللاعب عن الركض",
  T_45_XXJ_WS_ONPLAYERSTOPSWIMSURFING_D: "عندما يقف اللاعب عن التزلج على الأمواج",
  T_45_XXJ_WS_ONPLAYERSWIMSURFING_D: "عندما يقوم اللاعب بالتزلج على الأمواج",
  T_45_XXJ_WS_PHYSICALLAYER_D: "الطبقة المادية المخصصة ضمن نطاق من 0 إلى 31",
  T_45_XXJ_WS_PLATFORMTYPE: "نوع المنصة",
  T_45_XXJ_WS_PLATFORMTYPE_D: "نوع المنصة",
  T_45_XXJ_WS_PLAYER: "لاعب",
  T_45_XXJ_WS_PLAYERCCT: "CCT لاعب",
  T_45_XXJ_WS_PLAYERCCT_D: "متحكم الشخصية بتأثيرات فيزيائية مستخدم لشخصيات فري فاير فقط",
  T_45_XXJ_WS_PRIORITY: "أولوية",
  T_45_XXJ_WS_REMAINMULTINUM: "عدد القفزات المتبقية",
  T_45_XXJ_WS_REPORT: "إبلاغ",
  T_45_XXJ_WS_RIGHT: "يمين",
  T_45_XXJ_WS_RIGHT_D: "اتجاه المحور x في نظام الإحداثيات المحلي",
  T_45_XXJ_WS_SERVER: "الخادم",
  T_45_XXJ_WS_SINGLE: "وحيد",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE: "نوع نمط الزر الاجتماعي",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE_D: "نمط الزر الاجتماعي",
  T_45_XXJ_WS_SOCIALBUTTONTYPE: "نوع الزر الاجتماعي",
  T_45_XXJ_WS_SOCIALBUTTONTYPE_D: "نوع الزر الاجتماعي",
  T_45_XXJ_WS_SORTTYPE_D: "أنواع الترتيب: تصاعدي غير صفري، وتنازلي، وتصاعدي",
  T_45_XXJ_WS_SPEEDWHILEAIMING: "سرعة التحرك أثناء التصويب",
  T_45_XXJ_WS_SPEEDWHILEAIMING_D: "سرعة الحركة أثناء التصويب نحو الأسفل",
  T_45_XXJ_WS_STRINGORLOCSTRING: "سلسلة أو سلسلة مترجمة",
  T_45_XXJ_WS_TRIPLE: "ثلاثية",
  T_45_XXJ_WS_UP: "أعلى",
  T_45_XXJ_WS_UP_D: "اتجاه المحور y في نظام الإحداثيات المحلي",
  T_45_XXJ_WS_USECUSTOMPUSHFORCE: "استخدم قوة الدفع المخصصة",
  T_45_XXJ_WS_Z: "Z",
  T_45_XXJ_WS_Z_D: "Z",
  T_45_ZD_VEHICLEDROP_R_DESC: "ألقِ شعلة إشارة باتجاه المنطقة المحددة لاستدعاء مركبة عشوائية",
  T_45_ZD_VEHICLEDROP_R_NAME: "مركبة غامضة",
  T_46_H_CHARACTER_MISCHIEFGIRL_N: "ليلا",
  T_46_HJ_SHARE_GAMEDURATION: "وقت اللعب",
  T_46_HJ_WS_SHAREBY: "بواسطة {0}",
  T_46_HJ_WS_SHAREGAMEMODE: "وضع اللعبة",
  T_46_HJ_WS_SHARETEAM: "فريق",
  T_46_HJ_WS_SHARETEAMVS: "{0} ضد {1}",
  T_46_HX_B_SCHOOL_VN: "الأول في الصف (سفلي)",
  T_46_HX_H_SCHOOL_VN: "الأول في الصف (رأس)",
  T_46_HX_S_SCHOOL_VN: "الأول في الصف (حذاء)",
  T_46_HX_T_SCHOOL_VN: "الأول في الصف (علوي)",
  T_46_JH_WS_CLGUIDE_TUTORIAL: "الدليل التعليمي",
  T_46_LYF_RANKBOARD_TIPS_OTHERS: "أخرى",
  T_46_XXJ_WS_ACTUALPOSITION: "الموقع الفعلي",
  T_46_XXJ_WS_ADDSPECIALFOLLOW_D: "أضف العنصر للمراقبة مع تزامن AOI خارج خط الرؤية",
  T_46_XXJ_WS_APPEARANCE: "مظهر",
  T_46_XXJ_WS_APPEARANCERES: "مصدر المظهر",
  T_46_XXJ_WS_BECOME: "تفعيل",
  T_46_XXJ_WS_BRAKETORQUE_D: "القوة الحصانية المُعطاة للمركبة عند استخدام فرامل/الرجوع للخلف",
  T_46_XXJ_WS_CAMERAVIEWINGANGLERESTRICTIONTYPE: "نوع قيود زاوية دوران الكاميرا",
  T_46_XXJ_WS_CLEANSPECIALFOLLOW_D: "إزالة جميع العناصر المراقبة من الهدف",
  T_46_XXJ_WS_CRASHMAXDAMAGE_D: "أقصى ضرر اصطدام مستخدم لحساب الضرر",
  T_46_XXJ_WS_CRASHMAXSPEED: "معامل كتلة الاصطدام",
  T_46_XXJ_WS_CRASHMAXSPEED_D: "يُستخدم لحساب ضرر الاصطدام. عند تجاوز هذه السرعة، لن يُضاف المزيد من الضرر.",
  T_46_XXJ_WS_CRASHMESSFACTOR: "معامل كتلة الاصطدام",
  T_46_XXJ_WS_CRASHMESSFACTOR_D: "مُعامِل مستخدم في صيغة حساب ضرر الاصطدام",
  T_46_XXJ_WS_CRASHMINDAMAGE_D: "أقل ضرر اصطدام مستخدم لحساب الضرر",
  T_46_XXJ_WS_DB_OVERLIMIT_D: "تم تجاوز حد القراءة والكتابة لتخزين البيانات",
  T_46_XXJ_WS_DB_PARAMERROR_D: "استثناء المُعامل",
  T_46_XXJ_WS_DB_TIMEOUT_D: "انتهت مهلة تخزين البيانات. ينطبق بشكل رئيسي على القراءة والكتابة الآن.",
  T_46_XXJ_WS_DELTA: "دلتا",
  T_46_XXJ_WS_EDITNPCCOLLIDERTIPS: "تعديل المظهر",
  T_46_XXJ_WS_ENDVALUE_D: "قيمة الوجهة",
  T_46_XXJ_WS_ENGINETORQUE_D: "القوة الحصانية المُعطاة للمركبة عند استخدام دواسة الوقود",
  T_46_XXJ_WS_ERRORCODE_D: "تعداد رموز الخطأ",
  T_46_XXJ_WS_EULARANGLETOVECTOR3: "تحويل زاوية أويلر إلى المتجه 3",
  T_46_XXJ_WS_EULARANGLETOVECTOR3_D: "تحويل زاوية أويلر إلى متجه ثلاثي الأبعاد",
  T_46_XXJ_WS_EXPIRE: "انتهاء الصلاحية",
  T_46_XXJ_WS_FEMALEAVATAR: "شخصية أنثى",
  T_46_XXJ_WS_GETPREMIUMEXPIREDATE: "احصل على تاريخ انتهاء العضوية",
  T_46_XXJ_WS_HASSPECIALFOLLOW_D: "إذا كان المراقب يتابع عنصرًا أم لا",
  T_46_XXJ_WS_HELICOPTER: "مدفع السماء",
  T_46_XXJ_WS_HELICOPTER_D: "نوع من المركبات الطائرة",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE: "قيود التوجيه عالية السرعة",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE_D: "أقصى زاوية توجيه أثناء حالة السرعة العالية",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED: "زاوية القيادة عالية السرعة عند السرعة",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED_D: "عتبة السرعة لأقصى زاوية توجيه عالية السرعة",
  T_46_XXJ_WS_IDLE: "حركة الانتظار",
  T_46_XXJ_WS_IDLEBRAKEINPUT: "إدخال فرامل الخمول",
  T_46_XXJ_WS_IDLEBRAKEINPUT_D: "عند عدم قيادة مركبة، قم بإبطائها بـ (إدخال فرامل الخمول) × (عزم الفرامل).",
  T_46_XXJ_WS_INTTOFLOAT: "تحويل من صحيح إلى طفو",
  T_46_XXJ_WS_INTTOFLOAT_D: "تحويل عدد صحيح إلى رقم بنظام عائم",
  T_46_XXJ_WS_ISPREMIUM: "هي العضوية",
  T_46_XXJ_WS_LEADERBOARDNAME_D: "اسم قائمة المتصدرين في قاعدة البيانات",
  T_46_XXJ_WS_MALEAVATAR: "شخصية ذكر",
  T_46_XXJ_WS_MODULE_AICHARACTOR: "الذكاء الاصطناعي بيرسونا",
  T_46_XXJ_WS_NEWUMAAPPEARANCE: "مظهر جديد لـ UMA",
  T_46_XXJ_WS_NONE_D: "لا يوجد خطأ",
  T_46_XXJ_WS_NPC: "شخصية غير قابلة للعب",
  T_46_XXJ_WS_NPC_D: "عنصر شخصية غير قابلة للعب",
  T_46_XXJ_WS_NPCCOLLIDERTIPS: "نصائح: عادةً ما يكون لدى الشخصيات غير القابلة للعب ذات الشكل البشري نموذج تصادم مع كبسولة يبلغ ارتفاعها 1.4 متر ونصف قطرها 0.25 متر. عادةً ما يكون لدى الشخصيات غير القابلة للعب ذات الشكل الحيواني نموذج تصادم مع كبسولة يبلغ ارتفاعها 1 متر ونصف قطرها 0.4 متر.",
  T_46_XXJ_WS_OBSERVER_D: "المراقب الذي يتابع العناصر",
  T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER: "عند الانضمام لعضوية أرض الحرف",
  T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER: "عند إلغاء عضوية أرض الحرف",
  T_46_XXJ_WS_OPENPREMIUMCENTER: "افتح عضوية أرض الحرف",
  T_46_XXJ_WS_PERSONA: "بيرسونا",
  T_46_XXJ_WS_PERSONACENTER: "مركز بيرسونا",
  T_46_XXJ_WS_PET: "حيوان أليف",
  T_46_XXJ_WS_PLAYERORTRANSFORM: "اللاعب أو التحويل",
  T_46_XXJ_WS_PLAYERORTRANSFORM_D: "اسم مستعار للاعب وكيان التحويل",
  T_46_XXJ_WS_PREMIUM: "عضوية",
  T_46_XXJ_WS_PREMIUMSTATUS: "حالة العضوية",
  T_46_XXJ_WS_PROXYOBSERVER: "مراقب بديل",
  T_46_XXJ_WS_PROXYOBSERVER_D: "المراقب الوكيل",
  T_46_XXJ_WS_REMOVESPECIALFOLLOW_D: "إزالة العنصر المُراقَب وإلغاء مزامنة منطقة الاهتمام خارج خط الرؤية",
  T_46_XXJ_WS_RENEWAL: "تجديد",
  T_46_XXJ_WS_ROTATEVECTOR: "تدوير فكتور",
  T_46_XXJ_WS_ROTATEVECTOR_D: "تدوير فكتور بناءً على الكواتيرنيون",
  T_46_XXJ_WS_SKIN: "معدات",
  T_46_XXJ_WS_STARTVALUE_D: "قيمة المصدر",
  T_46_XXJ_WS_STATUS: "الحالة",
  T_46_XXJ_WS_SWITCHUSERPROXYOBSERVER_D: "تغيير مراقب البديل للمستخدم",
  T_46_XXJ_WS_TARGET_D: "الهدف المُراقَب",
  T_46_XXJ_WS_USER_D: "المستخدم",
  T_46_XXJ_WS_VALUE: "قيمة",
  T_46_XXJ_WS_VALUE_D: "فكتور",
  T_46_XYL_WS_CTZSAFEZONEEND: "نقطة نهاية منطقة آمنة",
  T_46_XYL_WS_RESOURCETYPE1: "الهياكل الأساسية",
  T_46_XYL_WS_RESOURCETYPE1_1: "الأشكال الهندسية",
  T_46_XYL_WS_RESOURCETYPE1_2: "المرئية والمسموعة",
  T_46_XYL_WS_RESOURCETYPE2: "عناصر المشهد",
  T_46_XYL_WS_RESOURCETYPE2_2: "لوازم المعركة",
  T_46_XYL_WS_RESOURCETYPE3: "الطبيعة",
  T_46_XYL_WS_RESOURCETYPE4: "المكون النمطي",
  T_46_XYL_WS_TYPEOTHERPROP: "متفرقات",
  T_46_XYL_WS_TYPEOTHERPROPBOX: "حاويات وصناديق",
  T_47_CJ_FOREGRIP_SOFT_N: "قبضة أمامية خفيفة",
  T_47_CJ_MAGEZINE_FAST_N: "مخزن سريع",
  T_47_CJ_STOCK_FAST_N: "مخزون الطاقة",
  T_47_GT_WS_USERMANUAL: "دليل المستخدم",
  T_47_HJ_WS_VFX_FOG: "تأثيرات الضباب",
  T_47_HJ_WS_VFX_LIGHTING: "تأثيرات للإضاءة",
  T_47_HJ_WS_VFX_TRAILING: "المؤثرات المتتالية",
  T_47_HL_CL_CREATOR_LABEL1: "موهبة المجتمع",
  T_47_HL_CL_MAP_LABEL1: "محتوى مواهب المجتمع المختارة",
  T_47_JH_WS_MODERATION_REASON12: "متعلق بالمقامرة",
  T_47_RW_NB_GP_GAMEAFFIX_HINT1: "تعاون NARUTO SHIPPUDEN",
  T_47_SD_RES_MATERIAL: "ملف المواد",
  T_47_SD_RES_MESH: "شبكة",
  T_47_SD_WS_MAPTAG_AI: "توليد خريطة الذكاء الاصطناعي",
  T_47_WT_W_NB_GP_KA_EXPLODE_DESC: "سكين خاص يلتصق بنقطة التأثير بعد رميها، مما يؤدي إلى انفجار ناري بعد فترة قصيرة من الوقت لإحداث ضرر حارق.",
  T_47_WT_W_NB_GP_KA_EXPLODE_NAME: "كوناي الناري",
  T_47_WT_W_NB_GP_KA_THUNDER_DESC: "سكين خاص يلتصق بنقطة التأثير بعد رميه، مما يؤدي إلى إحداث ضربة البرق بعد فترة قصيرة من الوقت لشل حركة الهدف.",
  T_47_WT_W_NB_GP_KA_THUNDER_NAME: "كوناي البرق",
  T_47_WT_W_NB_GP_KA_WIND_DESC: "سكين خاص يلتصق بنقطة التأثير بعد رميه، مما يؤدي إلى إثارة عاصفة رياح بعد مدة قصيرة لإبطاء الهدف وحمله بعيدًا.",
  T_47_WT_W_NB_GP_KA_WIND_NAME: "كوناي الرياح",
  T_47_WT_W_NB_GP_SRK_HEAVY_DESC: "نوع من الشوريكن يناسب القتال على المدى المتوسط إلى البعيد. يُطلق قطعة واحدة بسرعة برمية واحدة، مما يُحدث ضررًا كبيرًا.",
  T_47_WT_W_NB_GP_SRK_HEAVY_NAME: "شوريكن ثقيل",
  T_47_WT_W_NB_GP_SRK_LIGHT_DESC: "نوع من الشوريكن يصلح للقتال عن قرب إلى متوسط المدى مع وضعيتي هجوم. إلقاء واحد يطلق ثلاث قطع، يسبب كمية صغيرة من الضرر.",
  T_47_WT_W_NB_GP_SRK_LIGHT_NAME: "شوريكن خفيف",
  T_47_XXJ_WS_ACTION: "إجراء",
  T_47_XXJ_WS_AOISETTING: "إعداد AOI",
  T_47_XXJ_WS_BAGSKINTYPE: "نوع غلاف الحقيبة",
  T_47_XXJ_WS_CLEARMEMORY: "مسح الذاكرة",
  T_47_XXJ_WS_CLNPC: "شخصية غير قابلة للعب المتقدمة",
  T_47_XXJ_WS_CLOTHTYPE: "نوع مظهر الزي",
  T_47_XXJ_WS_COMMON_ERROR: "خطأ شائع",
  T_47_XXJ_WS_CONTENT: "محتوى",
  T_47_XXJ_WS_CREATERANDOMSEED: "إنشاء بذرة عشوائية",
  T_47_XXJ_WS_ELAPSEDPERCENTAGE: "النسبة المئوية المنقضية",
  T_47_XXJ_WS_ENABLEUGCFOGFEATURE: "تفعيل ميزة الضباب",
  T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE: "تفعيل ميزة دوران الضوء",
  T_47_XXJ_WS_ERRORCODE: "كود الخطأ",
  T_47_XXJ_WS_EXPONENTIAL: "أسي",
  T_47_XXJ_WS_EXPONENTIALSQUARED: "تربيع الأسي",
  T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE: "فشل إنشاء الغرفة: لا يوجد معرفات بيرسونا صالحة",
  T_47_XXJ_WS_FOG: "الضباب",
  T_47_XXJ_WS_FOGDENSITY: "كثافة الضباب",
  T_47_XXJ_WS_FOGENDDISTANCE: "مسافة نهاية الضباب",
  T_47_XXJ_WS_FOGMODE: "وضع الضباب",
  T_47_XXJ_WS_FOGMODETYPE: "نوع وضع الضباب",
  T_47_XXJ_WS_FOGSTARTDISTANCE: "مسافة بداية الضباب",
  T_47_XXJ_WS_HEIGHTSCALE: "مقياس الارتفاع",
  T_47_XXJ_WS_ISVISIBLE: "مرئي",
  T_47_XXJ_WS_JOINNEWTEAM: "انضم لفريق جديد",
  T_47_XXJ_WS_JOINTEAM: "انضم للفريق",
  T_47_XXJ_WS_LIGHTROTATE: "دوران خفيف",
  T_47_XXJ_WS_LINEAR: "خطي",
  T_47_XXJ_WS_LLMCHATHUD: "واجهة دردشة بيرسونا",
  T_47_XXJ_WS_NEWTEAM: "فريق جديد",
  T_47_XXJ_WS_NEXT: "التالي",
  T_47_XXJ_WS_NPC_TIP: "يمكنك تعديل مظهر الشخصية غير القابلة للعب وجعلها تؤدي حركات.",
  T_47_XXJ_WS_OBSERVERS: "المراقبون",
  T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA: "عند إرسال اللاعب رسالة عبر دردشة واجهة المستخدم لبيرسونا",
  T_47_XXJ_WS_ONPREMIUMCHANGE: "عند تغيير حالة العضوية",
  T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA: "عند استلام الإجراء من بيرسونا",
  T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA: "عند استلام المحتوى من بيرسونا",
  T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA: "عند استلام الانتهاء من بيرسونا",
  T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA: "عند استلام الحالة من بيرسونا",
  T_47_XXJ_WS_PARTICLESID: "معرف الجسيمات",
  T_47_XXJ_WS_PERSONAAVATAR: "صورة بيرسونا",
  T_47_XXJ_WS_PERSONAID: "معرف بيرسونا",
  T_47_XXJ_WS_PERSONANICKNAME: "لقب بيرسونا",
  T_47_XXJ_WS_PLAYERORNPC: "لاعب أو شخصية غير قابلة للعب",
  T_47_XXJ_WS_PREMIUM_CLOSED: "انتهت العضوية",
  T_47_XXJ_WS_RANDOM: "عشوائي",
  T_47_XXJ_WS_SEED: "بذرة",
  T_47_XXJ_WS_SENDER: "مرسل",
  T_47_XXJ_WS_SETPERSONAOBSERVER: "تعيين مراقب بيرسونا",
  T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY: "تعيين إمكانية خروج اللاعب في منتصف الطريق",
  T_47_XXJ_WS_SHOULDREPLY: "يجب الرد",
  T_47_XXJ_WS_SHOWSYSTEMREPLY: "عرض رد النظام",
  T_47_XXJ_WS_SPOTANGLE: "زاوية البقعة",
  T_47_XXJ_WS_SPOTLIGHT: "الأضواء",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA: "إرسال رسالة النظام إلى بيرسونا",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM: "بث رسائل النظام إلى بيرسونا",
  T_47_XXJ_WS_TARGETTEAM: "فريق الهدف",
  T_47_XXJ_WS_THISENTITY: "هذا الكيان",
  T_47_XXJ_WS_USERAVATAR: "صورة",
  T_47_XXJ_WS_USERMESSAGETOPERSONA: "إرسال رسالة المستخدم إلى بيرسونا",
  T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM: "بث رسائل المستخدم إلى بيرسونا",
  T_47_XXJ_WS_USERNICKNAME: "اللقب",
  T_47_XXJ_WS_VEHICLESKINTYPE: "نوع غلاف المركبة",
  T_47_XXJ_WS_WEAPONSKINTYPE: "نوع سكن السلاح",
  T_47_XYL_NB_UGC_EFFECT001: "تأثيرات راسينجان",
  T_47_XYL_NB_UGC_EFFECT002: "تأثير شيدوري",
  T_47_XYL_NB_UGC_EFFECT003: "تأثير اشتباك ساكورا",
  T_47_XYL_NB_UGC_EFFECT004: "تأثير جوتسو كرة النار",
  T_47_XYL_NB_UGC_EFFECT005: "تأثير جوتسو تنين الماء",
  T_47_XYL_NB_UGC_EFFECT006: "مؤثرات الفجوة العظيمة",
  T_47_XYL_NB_UGC_EFFECT007: "تأثير قنبلة الوحش المذيل",
  T_47_XYL_NB_UGC_EFFECT008: "تأثير علامة لعنة الإحياء",
  T_47_XYL_UGC_CRAFTLANDSHOP: "متجر الأصول",
  T_47_XYL_UGC_DONKEYCART: "عربة حمار",
  T_47_XYL_UGC_SPOTLIGHT: "الإضاءة",
  T_47_XYL_UGC_SPOTLIGHTANGLE: "زاوية الإضاءة",
  T_48_H_EMOTE_WATERFEST25_N: "خطوات سريعة",
  T_48_H_VEHICLESKIN_MOTOBIKE_WATERFEST25_N: "دراجة نارية - زبد البحر",
  T_48_HJ_AC_STATENOTEXIST: "الحالة {0} غير موجودة في وحدة التحكم في الرسوم المتحركة",
  T_48_HL_CODESCRIPT: "كود النص البرمجي",
  T_48_HL_GLOBAL_VAR: "اسم المتغير العام",
  T_48_HL_GRAPH: "منع",
  T_48_HL_HUD: "HUD",
  T_48_HL_LEADERBOARD_NAME: "قائمة المتصدرين",
  T_48_HL_LOCAL_VAR: "اسم المتغير المحلي",
  T_48_HL_LOCALIZATION: "اسم الترجمة",
  T_48_HL_OPEN_ATTRIBUTES: "اسم السمة المفتوحة",
  T_48_HX_A_WATERFEST25: "زبد البحر (قناع)",
  T_48_HX_B_WATERFEST25: "زبد البحر (سفلي)",
  T_48_HX_F_B_BLACKDRESS: "المادة المضادة (سفلي)",
  T_48_HX_F_H_BLACKDRESS: "المادة المضادة (رأس)",
  T_48_HX_F_HA_BLACKDRESS: "المادة المضادة (طلاء الوجه)",
  T_48_HX_F_S_BLACKDRESS: "المادة المضادة (حذاء)",
  T_48_HX_F_T_BLACKDRESS: "المادة المضادة (علوي)",
  T_48_HX_H_WATERFEST25: "زبد البحر (رأس)",
  T_48_HX_HA_WATERFEST25: "زبد البحر (طلاء الوجه)",
  T_48_HX_M_A_BLACKDRESS: "المادة المظلمة (قناع)",
  T_48_HX_M_B_BLACKDRESS: "المادة المظلمة (سفلي)",
  T_48_HX_M_H_BLACKDRESS: "المادة المظلمة (رأس)",
  T_48_HX_M_HA_BLACKDRESS: "المادة المظلمة (طلاء الوجه)",
  T_48_HX_M_S_BLACKDRESS: "المادة المظلمة (حذاء)",
  T_48_HX_M_T_BLACKDRESS: "المادة المظلمة (علوي)",
  T_48_HX_S_WATERFEST25: "زبد البحر (حذاء)",
  T_48_HX_T_WATERFEST25: "زبد البحر (علوي)",
  T_48_JH_WS_STRINGDESC: 'أدخل فقرة نصية أو سلاسل أخرى. يمكن لبعض العناصر عرض نص غني. أضف لونًا إلى النص باستخدام النص الغني باستخدام التنسيق التالي: [#XXXXXX] نص نص [-]. "#XXXXXX" هو اللون الذي تريد عرضه. يرجى ملاحظة أن لون نص العنصر المرتبط يجب تعيينه إلى الأبيض.',
  T_48_M_WS_P_ICON: "الصورة",
  T_48_META_API_10001: "البحث عن الكيان حسب المعرف",
  T_48_META_API_10001_P0: "معرّف الكيان",
  T_48_META_API_1098: "قيمة ورقة قاعدة بيانات القراءة الدفعية",
  T_48_META_API_1098_D: "قراءة دفعية لإدخالات بيانات متعددة من ورقة قاعدة بيانات محددة، حيث تتوافق إدخالات قائمة معرف اللاعب الفريد واحد لواحد مع إدخالات قائمة المفاتيح.",
  T_48_META_API_1098_P1: "معرّفات الحسابات",
  T_48_META_API_1098_P1_D: "قائمة معرفات اللاعب الفريدة، والتي تقرأ البيانات المقابلة للمفاتيح الموجودة بنفس الفهرس في قائمة المفاتيح.",
  T_48_META_API_1098_P2: "المفاتيح",
  T_48_META_API_1098_P2_D: "قائمة المفاتيح، التي تقرأ البيانات المقابلة لمعرفات اللاعب الفريدة بنفس الفهرس في قائمة المعرفات.",
  T_48_META_API_1098_P5: "رموز الحالة",
  T_48_META_API_1098_P5_D: "قائمة أكواد الحالة",
  T_48_META_API_1105: "إشعار بداية الحبكة",
  T_48_META_API_1105_D: "ابدأ تشغيل الحبكة المحددة للاعب المحفز",
  T_48_META_API_1105_P1_D: "معرف الحبكة",
  T_48_META_API_1108: "احصل على اللغة المحلية",
  T_48_META_API_1500_P0: "المتجه",
  T_48_META_API_1505_P1: "Z",
  T_48_META_API_3300: "ضبط وزن أجزاء الجسم",
  T_48_META_API_3300_D: "اضبط وزن جزء الجسم المستهدف عند مزجه مع رسوم متحركة أخرى ذات أولوية أقل",
  T_48_META_API_3300_P0_D: "مكون وحدة التحكم في الرسوم المتحركة القابلة للإضافة التي ينتمي إليها جزء الجسم",
  T_48_META_API_3300_P1: "اسم جزء الجسم",
  T_48_META_API_3300_P1_D: "اسم جزء الجسم",
  T_48_META_API_3300_P2: "الوزن",
  T_48_META_API_3300_P2_D: "الوزن مع نطاق قيمة [0، 1]، يمثل درجة المزج مع الرسوم المتحركة ذات الأولوية الأقل.",
  T_48_META_API_3315: "تشغيل تجاوز رسوم متحركة للشخصية",
  T_48_META_API_3315_D: "تشغيل رسوم متحركة لشخصية مع خيار تجاوز الرسوم المتحركة الافتراضية للعبة",
  T_48_META_API_3315_P3: "تجاوز التحكم في طريقة اللعب",
  T_48_META_API_3315_P3_D: "ما إذا كان سيتم تجاوز الرسوم المتحركة الافتراضية للعبة",
  T_48_META_API_3316: "إيقاف الرسوم المتحركة",
  T_48_META_API_3316_D: "إيقاف تشغيل الرسوم المتحركة للهدف في الحالة المحددة",
  T_48_META_API_90_P1: "يمكن الخروج في المنتصف",
  T_48_META_API_93: "إنشاء حركة على طول المسار",
  T_48_META_API_93_D: "إنشاء حركة مقحمة على طول مسار لجعل الجسم يتحرك على طول المسار المحدد",
  T_48_META_API_93_P1: "مسار",
  T_48_META_API_93_P1_D: "مسار الحركة",
  T_48_META_API_93_P3_D: "مقدار السرعة",
  T_48_META_API_93_P4: "مواجهة المماس",
  T_48_META_API_93_P4_D: "ما إذا كان الكائن يواجه اتجاه الحركة. تظل هذه الخاصية دون تغيير حتى إذا تم تعديل اتجاه الكائن قسرًا بوسائل أخرى.",
  T_48_META_API_96: "تثبيت البنية المسبقة",
  T_48_META_API_96_D: "إنشاء مثيل مسبق مع خيار معالجته بشكل غير متزامن",
  T_48_META_API_96_P2: "تحميل غير متزامن",
  T_48_META_API_96_P2_D: "ما إذا كان التحميل غير متزامن",
  T_48_META_EVT_3140: "على فريق التغيير",
  T_48_META_EVT_3140_D: "يتم تشغيله عند تغيير فريق الكيان الحالي",
  T_48_META_EVT_3140_P0: "الفريق السابق",
  T_48_META_EVT_3140_P0_D: "الفريق الذي كان ينتمي إليه قبل التغيير",
  T_48_META_EVT_3140_P1: "الفريق الحالي",
  T_48_META_EVT_3140_P1_D: "الفريق الذي ينتمي إليه الشخص بعد التغيير",
  T_48_META_EVT_3141: "في بداية الحبكة",
  T_48_META_EVT_3141_D: "يتم تشغيله عندما تبدأ الحبكة في اللعب",
  T_48_META_EVT_3141_P1: "معرف الحبكة",
  T_48_META_EVT_3141_P1_D: "معرف الحبكة",
  T_48_META_EVT_3142: "في نهاية الحبكة",
  T_48_META_EVT_3142_D: "يتم تشغيله عند انتهاء الحبكة",
  T_48_META_EVT_3142_P0_D: "اللاعب الذي يقوم بالتحريك",
  T_48_META_EVT_3142_P1_D: "معرف الحبكة",
  T_48_META_EVT_3143: "خيارات الحبكة على الزناد",
  T_48_META_EVT_3143_D: "يتم تشغيله عند تحديد خيار في الرسم البياني",
  T_48_META_EVT_3143_P1_D: "معرف الحبكة",
  T_48_META_EVT_3143_P2: "معرف الخيار",
  T_48_META_EVT_3143_P2_D: "معرف الخيار المحدد",
  T_48_META_TYP_409_I10: "فشل تغيير الفريق_فريق غير صالح",
  T_48_META_TYP_409_I11: `تغيير الفريق
فشل_إلغاء`,
  T_48_META_TYP_409_I12: "فشل تغيير الفريق_في المركبة",
  T_48_META_TYP_409_I7: "فشل تغيير الفريق_غير مدعوم",
  T_48_META_TYP_409_I8: "فشل تغيير الفريق_في الفريق بالفعل",
  T_48_META_TYP_409_I9: "فشل تغيير الفريق_هدف غير صالح",
  T_48_META_TYP_41_I19: "تعطيل المصادم",
  T_48_META_TYP_417: "الجسيمات",
  T_48_META_TYP_428: "تحويل اللاعب أو زي NPC",
  T_48_META_TYP_431: "حركة على طول المسار",
  T_48_META_TYP_431_I1: "مسار",
  T_48_META_TYP_432: "نقطة مسار المنحنى المخصص",
  T_48_META_TYP_432_I0: "لفافة",
  T_48_META_TYP_432_I1: "المماس",
  T_48_META_TYP_433: "نوع المسار المنحنى المخصص",
  T_48_META_TYP_433_I0: "خطي",
  T_48_META_TYP_433_I1: "سلس",
  T_48_META_TYP_433_I2: "مخصص",
  T_48_META_TYP_434: "مسار المنحنى المخصص",
  T_48_META_TYP_434_I2: "الحلقة المغلقة",
  T_48_META_TYP_434_I3: "نقاط التوجيه",
  T_48_META_TYP_437_I5: "أسماء أنواع النقاط",
  T_48_META_TYP_437_I6: "محتوى النتيجة اليسرى",
  T_48_META_TYP_437_I7: "محتوى النتيجة الصحيحة",
  T_48_META_TYP_438_I1: "اللاعبون",
  T_48_META_TYP_438_I2: "التصنيفات",
  T_48_META_TYP_438_I3: "إجمالي النتائج",
  T_48_META_TYP_438_I4: "أسماء أنواع النقاط",
  T_48_META_TYP_438_I5: "الألوان",
  T_48_META_TYP_438_I6: "النقاط",
  T_48_META_TYP_439: "المجموعة",
  T_48_META_TYP_442_I1: "النتيجة اليسرى",
  T_48_META_TYP_442_I10: "أيقونة المستبعد الصحيحة",
  T_48_META_TYP_442_I2: "النتيجة الصحيحة",
  T_48_META_TYP_442_I3: "رقم قيد الحياةعلى اليسار",
  T_48_META_TYP_442_I4: "الرقم الحي الصحيح",
  T_48_META_TYP_442_I5: "الرقم الذي تم حذفه على اليسار",
  T_48_META_TYP_442_I6: "رقم المستبعد الصحيح",
  T_48_META_TYP_442_I7: "أيقونة قيد الحياةعلى اليسار",
  T_48_META_TYP_442_I8: "الأيقونة الحية الصحيحىة",
  T_48_META_TYP_442_I9: "أيقونة تم حذفها من اليسار",
  T_48_META_TYP_444: "نوع اللغة",
  T_48_META_TYP_444_I0: "الإنجليزية",
  T_48_META_TYP_444_I1: "الصينية المبسطة",
  T_48_META_TYP_444_I10: "الفرنسية",
  T_48_META_TYP_444_I11: "الألمانية",
  T_48_META_TYP_444_I12: "تركي",
  T_48_META_TYP_444_I13: "هندي",
  T_48_META_TYP_444_I14: "اليابانية",
  T_48_META_TYP_444_I15: "الرومانية",
  T_48_META_TYP_444_I16: "العربية",
  T_48_META_TYP_444_I17: "البورمية",
  T_48_META_TYP_444_I18: "الأردية",
  T_48_META_TYP_444_I19: "البنغالية",
  T_48_META_TYP_444_I2: "الصينية التقليدية",
  T_48_META_TYP_444_I3: "تايلاندي",
  T_48_META_TYP_444_I4: "الفيتنامية",
  T_48_META_TYP_444_I5: "الإندونيسية",
  T_48_META_TYP_444_I6: "البرتغالية",
  T_48_META_TYP_444_I7: "الأسبانية",
  T_48_META_TYP_444_I8: "الروسية",
  T_48_META_TYP_444_I9: "الكورية",
  T_48_SD_ERROR_DIVISOR: "لا يمكن أن يكون القاسم 0",
  T_48_SD_ERROR_KEY_NOTINMAP: "المفتاح المحدد غير موجود في الخريطة: {0}",
  T_48_SD_ERROR_LIST_OUTRANGE: "فهرس القائمة خارج النطاق: {0}",
  T_48_SD_SK_WARNING: "لم يتم العثور على {1} في {0}",
  T_48_TYC_WS_WARNING_SERVER_DRIVEN_DISABLED: 'منذ أن تم تعطيل السمة "IsServerDriven" لمتحكم الشخصية في أرض الحرف {0} ، لا يتم تطبيق واجهة برمجة التطبيقات الخادوم ذات الصلة.',
  T_48_XXJ_WS_PARENTERROR: "فشل في تعيين الأصل",
  T_48_XXJ_WS_PERFORMANCE: "أداء",
  T_48_XXJ_WS_TANGENT: "المماس",
  T_48_XXJ_WS_WAYPOINT: "نقطة التوجيه",
  T_48_XYL_UGC_COMPOSITEOJBECTLIST: "قائمة الكائنات",
  T_48_XYL_UGC_CUSTOMIZEMINIMAP: "استخدم الخريطة المصغرة المخصصة",
  T_48_XYL_UGC_HIDEMINIMAP: "إخفاء HUD للخريطة المصغرة",
  T_48_XYL_WS_BASICCUSTOMSURFACE: "السطح المخصص الأساسي",
  T_48_XYL_WS_BASICCYLINDERCUTOUT: "قطع الاسطوانة",
  T_48_XYL_WS_BASICHEMISPHERE: "نصف الكرة الأرضية الأساسي",
  T_48_XYL_WS_BASICQUARTERROUNDEDTORUS: "ربع طارة",
  T_48_XYL_WS_BASICQUARTERTORUS: "ربع مربع طارة",
  T_48_XYL_WS_BASICROUNDEDTORUS: "طارة",
  T_48_XYL_WS_BASICTRIANGLE: "سطح المثلث",
  T_48_XYL_WS_MAPPLAYERSTIPS: "لاعبو المباراة = عدد الفرق × عدد اللاعبين لكل فريق. كلما زاد عدد لاعبي المباراة، كلما طال وقت المطابقة",
  T_48_XYL_WS_MAPPLAYERSWARNING: "قد يؤدي العدد الكبير من اللاعبين المتطابقين إلى إطالة وقت المطابقة",
  T_49_HL_CL_CREATOR_LABEL2: "موهوب مجتمع أرض الحرف",
  T_49_HL_CL_MAPS_LABEL2: "الفائز بالخريطة",
  T_49_HL_CL_MAPS_LABEL3: "الفائز بأسلوب اللعب",
  T_49_HX_T_TUNG: "تونغ تونغ تونغ",
  T_49_HZY_CONTROLLER_TRAJECTORY: "المسار",
  T_49_JH_WS_SKILLKASSIE: "العلاج الكهربائي (كاسي)",
  T_49_JH_WS_SKILLKODA: "رؤية الشفق القطبي (كودا)",
  T_49_JH_WS_SKILLOSCAR: "اندفاعة الشجاع (أوسكار)",
  T_49_LXW_EIGHTHB_EDIT_AITRAIN_ENTRANCE: "توليد الذكاء الاصطناعي",
  T_49_META_API_10065: "تبديل الكاميرا المخصصة",
  T_49_META_API_10067: "احصل على الكاميرا المخصصة الحالية",
  T_49_META_API_10069: "إنشاء كاميرا مخصصة",
  T_49_META_API_10070: "تعيين قناع إعدام الكاميرا المخصص",
  T_49_META_API_10070_D: "قم بتعيين قناع إعدام الكاميرا الهدف للتحكم في الرؤية عبر جميع الطبقات",
  T_49_META_API_10071: "احصل على قناع إعدام الكاميرا المخصص",
  T_49_META_API_10071_D: "احصل على قناع الإعدام للكاميرا المستهدفة",
  T_49_META_API_10072: "تعيين طبقة قناع إعدام الكاميرا المخصص للكاميرا",
  T_49_META_API_10072_D: "تعيين رؤية الكاميرا المستهدفة لطبقة معينة",
  T_49_META_API_10073: "التقاط لقطة شاشة",
  T_49_META_API_10073_D: "التقاط لقطة شاشة (للاختبار الداخلي)",
  T_49_META_API_106: "احصل على الطابع الزمني للخادم (مللي ثانية)",
  T_49_META_API_106_D: "احصل على الطابع الزمني للخادم بدقة مللي ثانية",
  T_49_META_API_107: "الطابع الزمني إلى سلسلة مترجمة (مللي ثانية)",
  T_49_META_API_107_D: "تحويل الطوابع الزمنية (بالمللي ثانية) إلى سلاسل بناءً على تنسيقات معينة",
  T_49_META_API_107_P0: "الطابع الزمني (مللي ثانية)",
  T_49_META_API_107_P0_D: "طابع زمني بالمللي ثانية",
  T_49_META_API_108: "استيفاء خطي المتجه 3",
  T_49_META_API_108_D: "إجراء استيفاء خطي من المتجه ثلاثي الأبعاد A إلى المتجه B",
  T_49_META_API_1089_P2: "معرّف الطلب",
  T_49_META_API_109: "تحديث السياق إلى بيرسونا",
  T_49_META_API_109_D: "حدّث سياق النموذج لبيرسونا محدد في الغرفة الحالية، واستبدل السياق الأصلي بعد التنفيذ. سيؤثر السياق على تفسير بيرسونا للخلفية أو التاريخ أو بعض معلمات الحوار الحالي.",
  T_49_META_API_109_P1: "سياق",
  T_49_META_API_109_P1_D: "تفاصيل السياق",
  T_49_META_API_110: "ردود الفعل على استجابة بيرسونا",
  T_49_META_API_110_D: "إرسال ملاحظات حول محتوى الاستجابة للشخصية، والتي سيتم استخدامها لتحسين نموذجنا.",
  T_49_META_API_110_P1: "معجب",
  T_49_META_API_110_P1_D: "ما إذا كانت الاستجابة معجبة أم لا. صحيح = أعجبني.",
  T_49_META_API_1109: "تعيين موضع اللاعب المحلي",
  T_49_META_API_1109_D: "عندما يستخدم اللاعب شخصيات اللعبة الكلاسيكية، يمكن لهذه الواجهة البرمجية تحديد موضع اللاعب.",
  T_49_META_API_1109_P0_D: "الموضع المستهدف",
  T_49_META_API_111: "استيفاء كروي المتجه 3",
  T_49_META_API_111_D: "قم بإجراء استيفاء كروي من المتجه ثلاثي الأبعاد A إلى المتجه B للحصول على دوران سلس",
  T_49_META_API_1110: "تعيين اللاعب المحلي إلى الأمام",
  T_49_META_API_1110_D: "عندما يستخدم اللاعب شخصيات اللعبة الكلاسيكية، يمكن لواجهة برمجة التطبيقات هذه تعيين الاتجاه الذي يواجهه اللاعب.",
  T_49_META_API_1110_P0_D: "المتجه الأمامي",
  T_49_META_API_112: "استرجاع ذاكرة بيرسونا",
  T_49_META_API_112_D: "استرجاع ذاكرة الشخصية إلى ما قبل معرف الرد المحدد. سيتم مسح جميع ذاكرة الحوارات بما في ذلك الرد وبعده.",
  T_49_META_API_113: "تشغيل صوت اللقطة الواحدة",
  T_49_META_API_113_D: "تشغيل مؤثر صوتي بلقطة واحدة مع مستوى صوت قابل للتعديل",
  T_49_META_API_113_P0_D: "معرف مصدر التأثير الصوتي الذي سيتم تشغيله",
  T_49_META_API_113_P1: "حجم الصوت",
  T_49_META_API_113_P1_D: "مستوى صوت التشغيل للمؤثر الصوتي، يتراوح من 0 إلى 1.",
  T_49_META_API_97: "إنشاء وحدة تحكم في جزء الهيكل العظمي",
  T_49_META_API_97_D: "بعد إنشاء كيان وحدة التحكم في جزء الهيكل العظمي، يمكنك استخدام هذا الكيان للتحكم في جزء الهيكل العظمي المحدد وجعله يواجه دائمًا هدفًا محددًا.",
  T_49_META_API_97_P0_D: "جزء الهيكل العظمي ينظر إلى كيان وحدة التحكم. إذا تم تدمير الكيان، فستتوقف وظيفة النظر إلى وظيفة النظر إلى.",
  T_49_META_API_97_P1_D: "جزء الهيكل العظمي الذي يتم التحكم فيه",
  T_49_META_API_97_P2_D: "الهدف الذي يتم النظر إليه",
  T_49_META_API_98: "الإسقاط",
  T_49_META_API_98_D: "احسب إسقاط المتجه A على المتجه B",
  T_49_META_API_99: "احصل على الطابع الزمني المحلي (مللي ثانية)",
  T_49_META_API_99_D: "احصل على الطابع الزمني للخادم بدقة مللي ثانية",
  T_49_META_EVT_16_P1_D: "بدءاً من 0، سيستهلك كل طلب صادر معرفاً رقمياً متسلسلاً، مثل إنشاء غرفة ومسح الذاكرة.",
  T_49_META_EVT_16_P2: "معرّف الاستجابة",
  T_49_META_EVT_16_P2_D: "سيكون لكل استجابة كاملة معرف فريد",
  T_49_META_TYP_122_I19: "مادة مخصصة",
  T_49_META_TYP_122_I19_D: "السماح باستبدال صندوق السماء بمادة مخصصة",
  T_49_META_TYP_14_I78_D: "احصل على أو عيّن كيان الكاميرا الذي يعرض المشهد حاليًا على عميل المُشغّل. ملاحظة: يُمثّل كيان الكاميرا أساسًا بيانات التكوين للتحكم في كاميرا العميل.",
  T_49_META_TYP_335_I9: "الوقت المنقضي (مللي ثانية)",
  T_49_META_TYP_335_I9_D: "مدة تشغيل المؤثر الصوتي بالمللي ثانية. لا يمكن الوصول إلى هذه الخاصية إلا من جانب العميل.",
  T_49_META_TYP_409_I13: "LLM_نعم",
  T_49_META_TYP_409_I13_D: "LLM_نعم",
  T_49_META_TYP_409_I14: "LLM_فاشل",
  T_49_META_TYP_409_I14_D: "LLM_فاشل",
  T_49_META_TYP_409_I15: "LLM_انتهاء المهلة",
  T_49_META_TYP_409_I15_D: "LLM_انتهاء المهلة",
  T_49_META_TYP_409_I16: "LLM_بيرسونا_خاطئ",
  T_49_META_TYP_409_I16_D: "LLM_بيرسوناأوغرفة_خاطئ",
  T_49_META_TYP_409_I17: "LLM_حد_التوكن",
  T_49_META_TYP_409_I17_D: "LLM_حد_التوكن",
  T_49_META_TYP_409_I18: "LLM_الانتهاك",
  T_49_META_TYP_409_I18_D: "LLM_الطلب_المتكرر",
  T_49_META_TYP_409_I19: "LLM_الطلب_المتكرر",
  T_49_META_TYP_409_I19_D: "LLM_الطلب_المتكرر",
  T_49_META_TYP_441: "معرف الأداء",
  T_49_META_TYP_445: "معرف وحدة التحكم القابلة للتشغيل",
  T_49_META_TYP_446: "وحدة تحكم قابلة للتشغيل قابلة للإرفاق",
  T_49_META_TYP_446_I0: "وحدة التحكم القابلة للتشغيل",
  T_49_META_TYP_447: "وحدة التحكم بالجزء الهيكل العظمي",
  T_49_META_TYP_448: "وحدة التحكم بالهيكل العظمي للجزء الهيكل العظمي",
  T_49_META_TYP_448_I0: "هدف مُتحكم به",
  T_49_META_TYP_448_I1: "التركيز على الهدف",
  T_49_META_TYP_449: "كاميرا مخصصة",
  T_49_META_TYP_449_I2: "الحجم الأرثوغرافي",
  T_49_META_TYP_449_I2_D: "التحكم في حجم المنطقة المرئية للكاميرا",
  T_49_META_TYP_450: "سلسلة الطابع الزمني المترجمة (مللي ثانية)",
  T_49_META_TYPE_449_D: "كاميرا مخصصة يتم التحكم فيها بالكامل من قبل المطور وتحدد ما يراه اللاعب أثناء اللعب",
  T_49_META_TYPE_450_D: "تنسيق الطابع الزمني على مستوى المللي ثانية إلى تنسيق نصي قابل للقراءة",
  T_49_SD_SEARCH_ICONDESC: "الجمعية الذكية",
  T_49_SD_SEARCHKEY_ACTION: "الإجراء",
  T_49_SD_SEARCHKEY_ANICLIPID: "معرف مقطع الرسوم المتحركة",
  T_49_SD_SEARCHKEY_AS: "كما",
  T_49_SD_SEARCHKEY_ATTACHMENTENUM: "معرّف المرفق",
  T_49_SD_SEARCHKEY_AUDIOENUM: "نوع المؤثر الصوتي",
  T_49_SD_SEARCHKEY_BAGSKINID: "غلاف الحقيبة",
  T_49_SD_SEARCHKEY_BEZIER: "منحنى بيزير",
  T_49_SD_SEARCHKEY_BOOL: "منطقي",
  T_49_SD_SEARCHKEY_BREAK: "كسر",
  T_49_SD_SEARCHKEY_BTREEID: "معرف شجرة السلوك",
  T_49_SD_SEARCHKEY_BUTTONCLICK: "عند النقر على الزر",
  T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK: "عند النقر المزدوج على الزر",
  T_49_SD_SEARCHKEY_BUTTONPRESS: "عند الضغط على الزر",
  T_49_SD_SEARCHKEY_BUTTONRELEASE: "عند تحرير الزر",
  T_49_SD_SEARCHKEY_CLOTHENUM: "نوع الزي",
  T_49_SD_SEARCHKEY_COLOR: "لون",
  T_49_SD_SEARCHKEY_COMMENT: "ملاحظة التعليق",
  T_49_SD_SEARCHKEY_COMPARER: "= > < ≠",
  T_49_SD_SEARCHKEY_COMPONENTENUM: "تعداد المكونات",
  T_49_SD_SEARCHKEY_CONCANT: "اتصال",
  T_49_SD_SEARCHKEY_CONTINUE: "متابعة",
  T_49_SD_SEARCHKEY_CUSTOMHUD: "HUD مخصصة",
  T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET: "أداة HUD مخصصة",
  T_49_SD_SEARCHKEY_DYNAMICITEMENUM: "نوع كائن مستوى الإنشاء الديناميكي",
  T_49_SD_SEARCHKEY_E: "ه",
  T_49_SD_SEARCHKEY_EFFECTENUM: "نوع المؤثرات البصرية",
  T_49_SD_SEARCHKEY_ENTITY: "تحديد كائن المشهد",
  T_49_SD_SEARCHKEY_FLOAT: "عائم",
  T_49_SD_SEARCHKEY_FOR: "للفهرس",
  T_49_SD_SEARCHKEY_FOREACH: "لكل",
  T_49_SD_SEARCHKEY_FUNCTION: "الوظيفة",
  T_49_SD_SEARCHKEY_GETCSV: "احصل على CSV",
  T_49_SD_SEARCHKEY_GETREGISTERED: "احصل على الأصول المسجلة حسب المفتاح",
  T_49_SD_SEARCHKEY_GETVALUE: "احصل على قيمة الخاصية",
  T_49_SD_SEARCHKEY_GLOBALVARGET: "احصل على متغير عام",
  T_49_SD_SEARCHKEY_GLOBALVARSET: "تعيين المتغير العام",
  T_49_SD_SEARCHKEY_IF: "إذا كان",
  T_49_SD_SEARCHKEY_IFELSE: "إذا كان غير ذلك",
  T_49_SD_SEARCHKEY_IMGENUM: "نوع النقش المتحرك",
  T_49_SD_SEARCHKEY_INT: "عدد صحيح",
  T_49_SD_SEARCHKEY_INTERNALHUD: "نوع HUD",
  T_49_SD_SEARCHKEY_ITEMENUM: "نوع العنصر",
  T_49_SD_SEARCHKEY_LISTAPPEND: "إلحاق القائمة",
  T_49_SD_SEARCHKEY_LISTAPPENDRANGE: "نطاق إلحاق القائمة",
  T_49_SD_SEARCHKEY_LISTCLEAR: "مسح القائمة",
  T_49_SD_SEARCHKEY_LISTCLONE: "استنساخ القائمة",
  T_49_SD_SEARCHKEY_LISTCONTAIN: "محتوى القائمة",
  T_49_SD_SEARCHKEY_LISTCREATE: "إنشاء القائمة",
  T_49_SD_SEARCHKEY_LISTDELETE: "حذف القائمة",
  T_49_SD_SEARCHKEY_LISTGET: "احصل على قائمة",
  T_49_SD_SEARCHKEY_LISTINDEXOF: "فهرس القائمة",
  T_49_SD_SEARCHKEY_LISTINSERT: "إدراج القائمة",
  T_49_SD_SEARCHKEY_LISTLASTINDEXOF: "فهرس القائمة الأخير من",
  T_49_SD_SEARCHKEY_LISTLENGTH: "طول القائمة",
  T_49_SD_SEARCHKEY_LISTREVERSE: "عکس القائمة",
  T_49_SD_SEARCHKEY_LISTSET: "تعيين القائمة",
  T_49_SD_SEARCHKEY_LISTSHUFFLE: "تبديل القائمة",
  T_49_SD_SEARCHKEY_LOCALKEY: "المفتاح المترجمة",
  T_49_SD_SEARCHKEY_LOCALVAR: "المتغير المحلي",
  T_49_SD_SEARCHKEY_LOGICAL: "و أو",
  T_49_SD_SEARCHKEY_LOGINFO: "طباعة معلومات السجل",
  T_49_SD_SEARCHKEY_MAPALLKEYS: "قاموس الحصول على جميع المفاتيح خريطة الحصول على جميع المفاتيح",
  T_49_SD_SEARCHKEY_MAPCLEAR: "مسح القاموس مسح الخريطة",
  T_49_SD_SEARCHKEY_MAPCONTAIN: "قاموس يحتوي على مفتاح خريطة تحتوي على مفتاح",
  T_49_SD_SEARCHKEY_MAPCREATE: "إنشاء القاموس إنشاء الخريطة",
  T_49_SD_SEARCHKEY_MAPGET: "احصل على قيمة القاموس حسب المفتاح احصل على قيمة الخريطة حسب المفتاح",
  T_49_SD_SEARCHKEY_MAPLENGTH: "طول القاموس طول الخريطة",
  T_49_SD_SEARCHKEY_MAPREMOVE: "إزالة القاموس إزالة الخريطة",
  T_49_SD_SEARCHKEY_MAPSET: "تعيين قيمة القاموس تعيين قيمة الخريطة",
  T_49_SD_SEARCHKEY_MATH: "الجمع والطرح والضرب والقسمة",
  T_49_SD_SEARCHKEY_NEWLIST: "قائمة جديدة",
  T_49_SD_SEARCHKEY_NULL: "لا شيء",
  T_49_SD_SEARCHKEY_NUMTOSTRING: "رقم إلى سلسلة",
  T_49_SD_SEARCHKEY_PARTICLESENUM: "خصائص الجسيمات",
  T_49_SD_SEARCHKEY_PERSONA: "بيرسونا",
  T_49_SD_SEARCHKEY_PI: "ط",
  T_49_SD_SEARCHKEY_PLAYERDATAID: "معرّف بيانات اللاعب",
  T_49_SD_SEARCHKEY_PLAYERSKILLENUM: "نوع مهارة الشخصية",
  T_49_SD_SEARCHKEY_PREEFFECT: "نوع الملصق الخاص",
  T_49_SD_SEARCHKEY_PREFAB: "الأجزاء الجاهزة",
  T_49_SD_SEARCHKEY_RAWID: "المعرف الخام",
  T_49_SD_SEARCHKEY_READSTATIS: "قراءة البيانات المتراكمة",
  T_49_SD_SEARCHKEY_RESOURCEENUM: "معرف uuid",
  T_49_SD_SEARCHKEY_RETURN: "العودة",
  T_49_SD_SEARCHKEY_SCENEENUM: "ملف المشهد",
  T_49_SD_SEARCHKEY_SCRIPTID: "النص",
  T_49_SD_SEARCHKEY_SETVALUE: "تعيين قيمة الخاصية",
  T_49_SD_SEARCHKEY_SPECIALITEMENUM: "نوع معرّف العنصر الخاص",
  T_49_SD_SEARCHKEY_TEXT: "النص",
  T_49_SD_SEARCHKEY_TEXTUREID: "نوع الملمس",
  T_49_SD_SEARCHKEY_THISENTITY: "هذا الكيان",
  T_49_SD_SEARCHKEY_TIMELINE: "الجدول الزمني",
  T_49_SD_SEARCHKEY_TYPEENUM: "أي نوع",
  T_49_SD_SEARCHKEY_V2VCREATE: "إنشاء المتجه 2",
  T_49_SD_SEARCHKEY_V2VGET: "احصل على مكونات المتجه 2",
  T_49_SD_SEARCHKEY_V2VOPERATION: "عملية المتجه 2 جمع طرح ضرب حاصل الضرب النقطي زاوية المسافة",
  T_49_SD_SEARCHKEY_V2VSET: "تعيين مكونات المتجه 2",
  T_49_SD_SEARCHKEY_V3VCREATE: "إنشاء المتجه 3",
  T_49_SD_SEARCHKEY_V3VGET: "احصل على مكونات المتجه 3",
  T_49_SD_SEARCHKEY_V3VOPERATION: "عملية المتجه 3 جمع طرح جمع طرح ضرب حاصل الضرب النقطي المنتج المتقاطع زاوية المسافة",
  T_49_SD_SEARCHKEY_V3VSET: "تعيين مكونات المتجه 3",
  T_49_SD_SEARCHKEY_VEHICLEENUM: "معرّف مظهر المركبة",
  T_49_SD_SEARCHKEY_WEAPONSKINENUM: "معرّف سكن السلاح",
  T_49_SD_SEARCHKEY_WHILE: "بينما",
  T_49_SD_SEARCHKEY_WRITESTATIS: "كتابة إزاحة قاعدة البيانات المتراكمة",
  T_49_SD_SEARCHKEY_WRITESTATISCROSS: "كتابة إزاحة قاعدة البيانات المتراكمة حسب رمز الخريطة",
  T_49_XXJ_WS_DURATIONS: "المدة (بالثواني)",
  T_49_XXJ_WS_EDITPERFORMANCE: "تحرير الأداء",
  T_49_XXJ_WS_PERFORMANCE: "أداء",
  T_49_XXJ_WS_PERFORMANCE_DELETE: "حذف الأداء",
  T_49_XXJ_WS_PERFORMANCE_DELETECONFIRM: "لا يمكن استعادة الأداء المحذوف، هل تريد المتابعة؟",
  T_49_XXJ_WS_PERFORMANCE_EDITING: "تحرير {0}",
  T_49_XXJ_WS_PERFORMANCE_NAME_EXCEPTION: "تم استخدام هذا الاسم بالفعل، يرجى تغييره والمحاولة مرة أخرى",
  T_49_XXJ_WS_PERFORMANCENAME: "اسم الأداء",
  T_49_XXJ_WS_TIMELINE_ADD_KEYFRAME: "إضافة إطار المفتاح",
  T_49_XXJ_WS_TIMELINE_ADD_SUB_TRACK: "إضافة مسار فرعي",
  T_49_XXJ_WS_TIMELINE_ADD_TRACK: "إضافة مسار",
  T_49_XXJ_WS_TIMELINE_DEL_TRACK: "حذف المسار",
  T_49_XXJ_WS_TIMELINE_ENTITY_TRACK: "مسار الممثل",
  T_49_XXJ_WS_TIMELINE_EVENT_TRACK: "مسار الحدث",
  T_49_XXJ_WS_TIMELINE_EXISTED_KEYFRAME: "الإطار الرئيسي موجود بالفعل",
  T_49_XXJ_WS_TIMELINE_EXISTED_TRACK: "مسار الممثل المقابل موجود بالفعل",
  T_49_XXJ_WS_TIMELINE_FRAME_SETTING: "محتوى",
  T_49_XXJ_WS_TIMELINE_NAME_EXCEPTION: "تم اكتشاف أسماء مسارات مكررة. يرجى تغييرها والمحاولة مرة أخرى.",
  T_49_XXJ_WS_TIMELINE_OPEN_RECORD: "يرجى بدء التسجيل أو اختيار إطار رئيسي أولاً",
  T_49_XXJ_WS_TIMELINE_RECORDING: "تسجيل...",
  T_49_XXJ_WS_TIMELINE_REMOVE_KEYFRAME: "حذف إطار مفتاح الحذف",
  T_49_XXJ_WS_TIMELINE_SCENE_EDIT_MODE: "عرض المشهد",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP: "حدد كائنًا لإنشاء مسار أو اضغط على زر إضافة مسار مباشرةً",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP_1: "اضغط على زر إضافة مسار لإنشاء مسار جديد",
  T_49_XXJ_WS_TIMELINE_SUB_TRACK_TITLE: "المسار الفرعي",
  T_49_XXJ_WS_TIMELINE_TRACK: "المسار",
  T_49_XXJ_WS_TIMELINE_TRACK_EDIT_MODE: "عرض المسار",
  T_49_XYL_WS_DAILYPROPS: "الأساسي",
  T_49_XYL_WS_STOREGAMPLAY: "أسلوب اللعب",
  T_49_YU_QCITEM_ALL_11: "تونغ تونغ تونغ سحور!",
  T_50_H_M4A1_VA_N: "M4A1 - أكاديمية المشاكل",
  T_50_H_MACHETE_VA_N: "شفرة - أكاديمية المشاكل",
  T_50_HJ_LEADERBOARD_SETTING_HEADER: "مجالات المتصدرين",
  T_50_HJ_OVERFLOW_RESIZEFREELY: "الفائض",
  T_50_HJ_OVERFLOW_RESIZEHEIGHT: "التفاف",
  T_50_HJ_OVERFLOW_SHRINKCONTENT: "تقليص الخط",
  T_50_HJ_SEARCHKEY_TUPLECREATE: "إنشاء توبيل",
  T_50_HJ_SEARCHKEY_TUPLEGET: "احصل على التوبول",
  T_50_HJ_SEARCHKEY_TUPLESET: "تعيين التوبول",
  T_50_HJ_TEXTOBGJ_H: "الطول",
  T_50_HJ_TEXTOBGJ_OVERFLOW: "خيارات الفائض",
  T_50_HJ_TEXTOBGJ_W: "العرض",
  T_50_HZY_REVIEW_TEXTOBJ: "محتوى كائن النص",
  T_50_JH_WS_HIDEMAPERROR: "لا يمكن إخفاء الخريطة المصغرة بدون صورة غلاف مخصصة",
  T_50_JH_WS_HIDEMAPTIP: "عندما يتم إخفاء الخريطة المصغرة، لن يتم استخدامها كصورة الغلاف بعد الآن.",
  T_50_JH_WS_HIDEMINIMAP: "إخفاء الخريطة المصغرة",
  T_50_META_API_10073_P0: "اسم الملف",
  T_50_META_API_10073_P0_D: "اسم الملف",
  T_50_META_API_10073_P1_D: "نتيجة التنفيذ. تحقق من تعداد رموز الحالة.",
  T_50_META_API_1102: "قراءة قيمة عمود ورقة قاعدة البيانات",
  T_50_META_API_1102_D: "قراءة قيمة عمود معين لمفتاح معين من جدول قاعدة بيانات قياسي",
  T_50_META_API_1102_P3: "فهرس العمود",
  T_50_META_API_1102_P3_D: "فهرس العمود لجدول قاعدة البيانات (0 = العمود الأول)",
  T_50_META_API_1106: "إنشاء الأداء",
  T_50_META_API_1106_D: "إنشاء كيان أداء",
  T_50_META_API_1106_P0_D: "أصل الأداء",
  T_50_META_API_1111: "قراءة قيم جدول قاعدة البيانات للمتصدرين",
  T_50_META_API_1111_D: "قراءة مجموعة القيم من جدول الترتيب والجدول المرتبط به في قاعدة البيانات",
  T_50_META_API_1111_P5: "رمز حالة الارتباط",
  T_50_META_API_1111_P5_D: "رمز خطأ الارتباط",
  T_50_META_API_1112: "قراءة قيم جدول قاعدة البيانات للمتصدرين حسب النطاق",
  T_50_META_API_1112_D: "قراءة القيم من جدول المتصدرين ضمن نطاق ترتيب محدد، وقراءة القيم المقابلة عن طريق استرداد المفاتيح من الجدول المرتبط، ودمجها.",
  T_50_META_API_1112_P6: "رمز حالة الارتباط",
  T_50_META_API_1112_P6_D: "رمز خطأ الارتباط",
  T_50_META_API_1113: "كتابة قيمة ارتباط جدول ترتيب قاعدة البيانات",
  T_50_META_API_1113_D: "اكتب قيمة مفتاح معين في جدول المتصدرين والجدول المرتبط به في قاعدة البيانات",
  T_50_META_API_1113_P5: "رمز حالة الارتباط",
  T_50_META_API_1113_P5_D: "رمز خطأ الارتباط",
  T_50_META_API_114_D: "إنشاء واجهة مستخدم مخصصة",
  T_50_META_API_114_P0_D: "يُستخدم الرمز كاسم معلمة لإنشاء كيان واجهة مستخدم، وتمثل قيمة المتغير المحلي المقابل له كيان واجهة المستخدم الذي تم إنشاؤه.",
  T_50_META_API_114_P1_D: "الكيان الذي ينتمي إليه اللاعب، ولا يظهر إلا للاعب.",
  T_50_META_API_114_P2: "معرف أصل واجهة المستخدم",
  T_50_META_API_114_P2_D: "معرف أصل واجهة المستخدم المخصصة",
  T_50_META_API_115_D: "إنشاء واجهة المستخدم المخصصة المحددة",
  T_50_META_API_116: "تعيين مستوى تمييز الكائن",
  T_50_META_API_116_D: "تعيين حالة تمييز الكائن. قد تتأثر بعوامل أخرى داخل اللعبة.",
  T_50_META_API_116_P0_D: "الكائن المستهدف",
  T_50_META_API_116_P1_D: "حالة التمييز",
  T_50_META_API_117: "البتية المشتركة",
  T_50_META_API_117_D: "تقسيم بتاتي و/أو/xor/تحريك لليسار/تحريك لليمين",
  T_50_META_API_117_P0_D: "القيمة اليسرى",
  T_50_META_API_117_P1_D: "القيمة الصحيحة",
  T_50_META_API_117_P2_D: "نوع العملية",
  T_50_META_API_118: 'عملية "لا" على مستوى البت',
  T_50_META_API_118_D: 'عملية "لا" على مستوى البت، ويعرف أيضًا باسم المكمل على مستوى البت.',
  T_50_META_API_118_P0_D: "القيمة",
  T_50_META_API_119: "قائمة بتية إلى عدد صحيح",
  T_50_META_API_119_D: 'قم بإجراء عملية "أو" على مستوى البتات على جميع عناصر القائمة وحوّل الناتج إلى قيمة عددية.',
  T_50_META_API_119_P0: "مصفوفة بتات",
  T_50_META_API_119_P0_D: "مصفوفة بتية",
  T_50_META_API_120: "عدد صحيح بتوي إلى قائمة",
  T_50_META_API_120_D: "تحويل القيم العشرية الممثلة بالبتات في الموضع 1 من عدد صحيح في شكله الثنائي إلى قائمة",
  T_50_META_API_120_P0_D: "عدد صحيح",
  T_50_META_API_121: "زاوية الرباعي",
  T_50_META_API_121_D: "احسب الزاوية بين اثنين من الرباعيات",
  T_50_META_API_121_P0_D: "الرباعي 1",
  T_50_META_API_121_P1_D: "الرباعي 2",
  T_50_META_API_122: "نقطة الرباعي",
  T_50_META_API_122_D: "احسب حاصل الضرب القياسي لاثنين من الرباعيات",
  T_50_META_API_123: "معكوس الرباعي",
  T_50_META_API_123_D: "احسب معكوس الرباعي",
  T_50_META_API_123_P0_D: "الرباعي",
  T_50_META_API_124: "الرباعي من إلى الدوران",
  T_50_META_API_124_D: "احسب رباعي الدوران من ”من“ إلى ”إلى“",
  T_50_META_API_124_P0_D: "نقطة البداية",
  T_50_META_API_124_P1_D: "نقطة النهاية",
  T_50_META_API_125: "دوران رباعي الاتجاه",
  T_50_META_API_125_D: "احسب رباعي الدوران من ”من“ إلى ”إلى“. درجة الدوران القصوى هي زاوية الدوران القصوى.",
  T_50_META_API_125_P0: "من",
  T_50_META_API_125_P0_D: "الرباعي الأولي",
  T_50_META_API_125_P1: "إلى",
  T_50_META_API_125_P1_D: "الرباعي المستهدف",
  T_50_META_API_125_P2: "الحد الأقصى لدرجة دلتا",
  T_50_META_API_125_P2_D: "زاوية الدوران القصوى",
  T_50_META_API_126: "احصل على اتجاه الجيروسكوب",
  T_50_META_API_126_D: "اتجاه الجهاز في المساحة ثلاثية الأبعاد، يمثل زوايا الدوران حول المحاور الثلاثة.",
  T_50_META_API_127: "احصل على جيروسكوب الجاذبية",
  T_50_META_API_127_D: "مكون الجاذبية الذي يكتشفه المستشعر الموجود على جهازك",
  T_50_META_API_128: "احصل على معدل دوران الجيروسكوب",
  T_50_META_API_128_D: "يشير هذا المصطلح إلى معدل دوران الجهاز. وهو مصطلح متعلق بأجهزة استشعار الجيروسكوب يصف سرعة حركة دوران الجهاز في فضاء ثلاثي الأبعاد.",
  T_50_META_API_129: "احصل على دوران جيروسكوب غير متحيز",
  T_50_META_API_129_D: "يصف معدل دوران الجهاز ويوفر نتيجة أكثر دقة من خلال تعويض الضوضاء أو التحيز في مستشعرات الجهاز.",
  T_50_META_API_130: "احصل على تسارع مستخدم الجيروسكوب",
  T_50_META_API_130_D: "جزء التسارع في الجهاز بعد إزالة مكون الجاذبية، وهو التسارع الناتج عن إجراءات المستخدم أو القوى الخارجية.",
  T_50_META_API_131: "الحصول على معلومات اللمس",
  T_50_META_API_131_D: "احصل على معلومات اللمس المحددة لشاشة الفهرس (بما في ذلك الموضع والإزاحة ووقت التغيير).",
  T_50_META_API_131_P0_D: "توزيع معرّفات نقاط التلامس، بدءًا من 0",
  T_50_META_API_131_P1_D: "موضع اللمس",
  T_50_META_API_131_P2: "موضع دلتا",
  T_50_META_API_131_P2_D: "التغيير في الموضع مقارنة بالإطار الأخير",
  T_50_META_API_131_P3: "وقت دلتا",
  T_50_META_API_131_P3_D: "الوقت المنقضي منذ الإطار الأخير",
  T_50_META_API_132: "احصل على عدد مرات لمس الشاشة",
  T_50_META_API_132_D: "احصل على العدد الحالي لنقاط اللمس على الشاشة",
  T_50_META_API_133: "اهتزاز الجهاز",
  T_50_META_API_133_D: "جعل الجهاز يهتز مرة واحدة",
  T_50_META_API_134_D: "إخطار جهاز اللاعب المستهدف بتشغيل الصوت",
  T_50_META_API_134_P0_D: "اللاعب المستهدف",
  T_50_META_API_134_P1_D: "الأصل الصوتي",
  T_50_META_API_134_P2_D: "سرعة التشغيل (النطاق الصالح: 0.1~3.0؛ 1 = عادي، <1 = إبطاء، >1 = تسريع)",
  T_50_META_API_135_D: "تشغيل ملف الصوت لمرة واحدة",
  T_50_META_API_135_P0_D: "موارد صوتية",
  T_50_META_API_135_P1_D: "سرعة التشغيل",
  T_50_META_API_136: "تنسيق السلاسل",
  T_50_META_API_136_D: "تنسيق السلاسل",
  T_50_META_API_136_P0_D: "سلاسل منسقة تستخدم عناصر التحكم في صيغة Go",
  T_50_META_API_136_P1: "مصفوفة المعلمات",
  T_50_META_API_136_P1_D: "قائمة المعلمات",
  T_50_META_API_137: "لصق المكون",
  T_50_META_API_137_D: "نسخ أو إضافة بيانات المكونات",
  T_50_META_API_137_P0: "المصدر",
  T_50_META_API_137_P0_D: "الكيان المصدر",
  T_50_META_API_137_P1_D: "الكيان المستهدف",
  T_50_META_API_137_P2: "نوع المكون",
  T_50_META_API_137_P2_D: "نوع المكون",
  T_50_META_API_137_P3: "ناجح",
  T_50_META_API_137_P3_D: "سواء كان ناجحًا أم لا",
  T_50_META_API_138: "استرجع في الإطار التالي",
  T_50_META_API_138_D: "استرجع في الإطار التالي",
  T_50_META_API_139: "إزالة في الإطار التالي",
  T_50_META_API_139_D: "تخلص من كيان المعركة في الإطار التالي",
  T_50_META_API_139_P0_D: "كيان المعركة",
  T_50_META_API_140: "إنهاء اللعبة في الإطار التالي",
  T_50_META_API_140_D: "اخرج من اللعبة في الإطار التالي",
  T_50_META_API_141: "احصل على مستوى صوت الميكروفون",
  T_50_META_API_141_D: "احصل على مستوى صوت الميكروفون. أعد الحالة عندما يكون ميكروفون المشغل مغلقًا أو لا يوجد حق وصول.",
  T_50_META_API_141_P0: "حجم",
  T_50_META_API_141_P0_D: "حجم صوت الميكروفون",
  T_50_META_API_141_P1_D: "الميكروفون قيد التشغيل أو إيقاف التشغيل",
  T_50_META_API_142: "احصل على جودة العرض",
  T_50_META_API_142_D: "احصل على جودة العرض الحالية (تعداد: منخفضة/متوسطة/عالية/فائقة)",
  T_50_META_API_143: "احصل على دقة العرض",
  T_50_META_API_143_D: "احصل على دقة العرض الحالية",
  T_50_META_API_144: "ربط لاعب مخصص",
  T_50_META_API_144_D: "تعيين الهدف الذي يرتبط به هذا اللاعب ديناميكيًا والذي سيحل محل الارتباطات الحالية. يُرجع قيمة خاطئة في حالة الفشل.",
  T_50_META_API_144_P0: "لاعب مخصص",
  T_50_META_API_144_P0_D: "بعد ربط هذا اللاعب المخصص باللاعب، سيتم مزامنة البيانات مثل الموقع والاتجاه تلقائيًا.",
  T_50_META_API_144_P1_D: "اللاعب المستهدف",
  T_50_META_API_145: "إلغاء ربط لاعب مخصص",
  T_50_META_API_145_D: "إلغاء الربط. يُرجع قيمة خاطئة في حالة الفشل.",
  T_50_META_API_145_P0: "لاعب مخصص",
  T_50_META_API_145_P0_D: "قم بإلغاء جميع الارتباطات لهذا الهدف. بعد إلغاء الارتباط، لن يتم مزامنة البيانات مثل الموقع والاتجاه تلقائيًا بعد الآن.",
  T_50_META_API_146_P0_D: "لاعب مخصص",
  T_50_META_API_147: "تعيين حالة لاعب مخصصة",
  T_50_META_API_147_D: "تحميل تلقائي إلى الخادم ومزامنة مع جميع العملاء. ترجع قيمة خاطئة في حالة الفشل.",
  T_50_META_API_147_P0: "لاعب مخصص",
  T_50_META_API_147_P1: "الحالة",
  T_50_META_API_147_P1_D: "يستخدم عادةً لحفظ حالات الرسوم المتحركة. احصل على الحالة المتزامنة باستخدام ”الحصول على حالة اللاعب المخصصة”.",
  T_50_META_API_148: "الحصول على حالة اللاعب المخصصة",
  T_50_META_API_148_D: "يتم مزامنة بيانات الحالة تلقائيًا مع الخادم. ترجع قيمة خاطئة في حالة الفشل.",
  T_50_META_API_148_P0: "لاعب مخصص",
  T_50_META_API_148_P1: "الحالة",
  T_50_META_API_148_P1_D: "تعيين الحالة باستخدام ”تعيين حالة اللاعب المخصصة“",
  T_50_META_API_149: "تعيين أحجام المسافة",
  T_50_META_API_149_D: "اضبط نطاقات المسافة بين اللاعبين لضبط مستوى الصوت ديناميكيًا.",
  T_50_META_API_149_P0: "قائمة المسافات",
  T_50_META_API_149_P0_D: "قائمة بنطاقات المسافات، كل منها يتوافق مع عنصر في قائمة الحجم.",
  T_50_META_API_149_P1: "قائمة الأحجام",
  T_50_META_API_149_P1_D: "قائمة الأحجام، كل منها يتوافق مع عنصر في قائمة المسافات.",
  T_50_META_API_150: "احصل على أصدقاء",
  T_50_META_API_150_D: "احصل على قائمة معرفات أصدقاء اللاعب",
  T_50_META_API_151: "احصل على معلومات واجهة المستخدم الافتراضية",
  T_50_META_API_151_D: "احصل على موقع واجهة المستخدم الافتراضي للاعب",
  T_50_META_API_151_P0_D: "الواجهة الافتراضية",
  T_50_META_API_151_P1_D: "الحالة",
  T_50_META_API_151_P2_D: "موقع واجهة المستخدم",
  T_50_META_API_151_P3: "الحجم",
  T_50_META_API_151_P3_D: "حجم واجهة المستخدم",
  T_50_META_API_152: "بث حدث مخصص",
  T_50_META_API_152_D: "بث حدث مخصص لأي كيان لتلقي (الاستماع إلى) هذا الحدث",
  T_50_META_API_153: "إرسال الحدث إلى الكيان",
  T_50_META_API_153_D: "إرسال الحدث المخصص إلى الكيان المستهدف",
  T_50_META_EVT_17: "عند بدء اللمس على الشاشة",
  T_50_META_EVT_17_D: "ابدأ الحدث عند لمس الشاشة",
  T_50_META_EVT_17_P0: "مؤشر اللمس",
  T_50_META_EVT_17_P0_D: "مؤشر نقطة اللمس",
  T_50_META_EVT_17_P1_D: "موضع اللمس",
  T_50_META_EVT_18: "عند نهاية اللمس على الشاشة",
  T_50_META_EVT_18_D: "إنهاء الحدث عند لمس الشاشة",
  T_50_META_EVT_18_P0: "مؤشر اللمس",
  T_50_META_EVT_18_P0_D: "مؤشر نقطة اللمس",
  T_50_META_EVT_18_P1_D: "المواقع التي تلمسها على الشاشة",
  T_50_META_EVT_19: "عند استلام نتيجة إنشاء غرفة بيرسونا",
  T_50_META_EVT_19_D: "تلقى النتيجة المقابلة عند الفشل في إنشاء غرفة دردشة بيرسونا",
  T_50_META_EVT_19_P1: "معرف الغرفة",
  T_50_META_EVT_19_P1_D: "معرف الغرفة",
  T_50_META_EVT_20: "عند خروج المستخدم أو انتهاء مباراة المستخدم",
  T_50_META_EVT_20_D: "يتم تشغيله عندما يخرج المستخدم من المباراة أو عندما تنتهي المباراة",
  T_50_META_TYP_11_I44: "أحجام المسافات",
  T_50_META_TYP_11_I44_D: "ضبط مستوى الصوت ديناميكيًا بناءً على المسافة بين اللاعبين",
  T_50_META_TYP_22_I9_D: "معرف الأصل المستخدم لإنشاء واجهة المستخدم",
  T_50_META_TYP_244_I12_D: "عرض مربع النص",
  T_50_META_TYP_244_I13_D: "ارتفاع مربع النص",
  T_50_META_TYP_244_I14_D: "نوع الفائض",
  T_50_META_TYP_335_I10_D: "سرعة التشغيل (القيمة الصالحة > 0، القيمة الافتراضية = 1)",
  T_50_META_TYP_409_I20: "IO_فشل_إنشاء_ملف",
  T_50_META_TYP_409_I20_D: "فشل عملية IO: حدث خطأ أثناء إنشاء الملف.",
  T_50_META_TYP_409_I21: "IO_اسم_ملف_غيرصالح",
  T_50_META_TYP_409_I21_D: "فشل عملية IO. اسم الملف غير صالح.",
  T_50_META_TYP_448_I0_D: "جزء الهيكل العظمي المتحكم به",
  T_50_META_TYP_448_I1_D: "الهدف الذي ينظر إليه جزء الهيكل العظمي",
  T_50_META_TYP_451: "نوع الفائض",
  T_50_META_TYP_451_D: "طريقة التعامل مع تجاوز النص",
  T_50_META_TYP_452: "معرف أصل واجهة المستخدم المخصص",
  T_50_META_TYP_452_D: "المعرف الذي يصف أصل HUD المخصص",
  T_50_META_TYP_453: "نوع جودة العرض",
  T_50_META_TYP_453_D: "تعداد جودة العرض",
  T_50_META_TYPE_448_D: "يُستخدم هذا الكيان للتحكم في جزء الهيكل العظمي للنظر إلى الهدف",
  T_50_SD_WS_MAPTAG_AI3DGEN: "إنشاء خريطة كائن ثلاثي الأبعاد",
  T_50_SD_WS_MAPTAG_AIRACING: "توليد خريطة السباق باستخدام الذكاء الاصطناعي",
  T_50_XXJ_WS_ANIMATIONSTATENAME: "تعداد اسم حالة الرسوم المتحركة",
  T_50_XXJ_WS_DISABLEFOOTSTEP: "تعطيل اهتزاز خطوات الأقدام",
  T_50_XXJ_WS_NOPERFORMANCE: "لا يوجد ملف أداء حتى الآن",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS: "النسخة التجريبية",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS_DESC: "أعزائي المبدعين، لا يزال محرر الأداء في مرحلة الاختبار. قد يحتوي على أخطاء أو يفتقر إلى ميزات أساسية. يرجى استخدامه بحذر.",
  T_50_XXJ_WS_PERFORMANCE_NEW: "إضافة الأداء",
  T_50_XXJ_WS_TIMELINE_ADD_KEYCLIP: "إضافة مشبك مفتاح",
  T_50_XXJ_WS_TIMELINE_ALONGPATH_TRACK: "على طول المسار",
  T_50_XXJ_WS_TIMELINE_ANIMATION_CLIP: "الرسوم المتحركة",
  T_50_XXJ_WS_TIMELINE_ANIMATION_TRACK: "مسار الرسوم المتحركة",
  T_50_XXJ_WS_TIMELINE_AUDIO_TRACK: "المسار الصوتي",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_HOLD: "امسك",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_LOOPFOREVER: "حلقة إلى الأبد",
  T_50_XXJ_WS_TIMELINE_DURATION: "المدة: {0} ثانية",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_AVATAR: "عدم تطابق بين الرسوم المتحركة والنموذج",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_CLIP_OVERLAP: "تداخل مشبك المفاتيح",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_ENTITY_MISSING: "الكيان المرتبط مفقود",
  T_50_XXJ_WS_TIMELINE_NAME_EMPTY: "لا يمكن أن يكون اسم المسار فارغًا",
  T_50_XXJ_WS_TIMELINE_NPC_TRACK: "تتبع الشخصيات غير القابلة للعب",
  T_50_XXJ_WS_TIMELINE_PROP_TRACK: "تتبع الممتلكات",
  T_50_XXJ_WS_TIMELINE_REMOVE_KEYCLIP: "إزالة مشبك المفتاح",
  T_50_XXJ_WS_TIMELINE_TIME_SUFFIX: "{0}ث",
  T_50_XXJ_WS_TIMELINE_TRACK_MAX_LIMIT: "تجاوز الحد الأقصى لعدد المسارات",
  T_50_XYL_WS_AIGETERATESHOW: "لبنات البناء",
  T_50_YU_F_B_VA_WITCH: "المشكلة الغامضة (سفلي)",
  T_50_YU_F_H_VA_WITCH: "المشكلة الغامضة (رأس)",
  T_50_YU_F_HA_VA_WITCH: "المشكلة الغامضة (طلاء الوجه)",
  T_50_YU_F_S_VA_WITCH: "المشكلة الغامضة (حذاء)",
  T_50_YU_F_T_VA_WITCH: "المشكلة الغامضة (علوي)",
  T_50_ZCS_CLCUSTOMEVE_CUSTOMEVENT: "الحدث المخصص",
  T_51_GT_WS_BASIC: "أساسي",
  T_51_GT_WS_GLOBALEVENT: "حدث عالمي",
  T_51_GT_WS_PRIVATEEVENT: "حدث خاص",
  T_51_GT_WS_STORY: "قصة",
  T_51_GT_WS_UI: "واجهة المستخدم",
  T_51_JH_WS_MINTIP1: "",
  T_51_META_API_1114: "User Message To Persona Voice Response",
  T_51_META_API_1114_D: "Send persona user's message and get a voice response from persona",
  T_51_META_API_1114_P2_D: "If true, the voice response will automically play when received; else, an API is required to play it",
  T_51_META_API_1115: "System Message To Persona Voice Response",
  T_51_META_API_1115_D: "Send persona system message and get a voice response from persona",
  T_51_META_API_1116: "Play Stored Voice From Persona",
  T_51_META_API_1116_D: "Play stored voice reponses from persona. Can store up to 10 responses.",
  T_51_META_API_144_P2_D: "Whether the execution is successful",
  T_51_META_API_154: "Get Type Name",
  T_51_META_API_154_D: "Return the name of the target object's type",
  T_51_META_API_154_P0_D: "The target object to get type name for",
  T_51_META_API_155: "Get Bounding Box",
  T_51_META_API_155_D: "Get the Bounding Box of the scene object",
  T_51_META_API_155_P0_D: "The scene object to get the bounding box for",
  T_51_META_API_155_P1_D: "The center of the bounding box",
  T_51_META_API_155_P2: "Size",
  T_51_META_API_155_P2_D: "The size of the bounding box",
  T_51_META_API_156: "Create Entity",
  T_51_META_API_156_D: "Create an entity. You can specify an owner (a specific player client). In combination with the AddComponent API, you can synchronize data targeted to that particular client.",
  T_51_META_API_156_P0_D: "The target entity to be created",
  T_51_META_API_156_P1_D: "The type of the created custom component",
  T_51_META_API_156_P2_D: "The owner of the entity",
  T_51_META_API_156_P3: "Flag",
  T_51_META_API_156_P3_D: "Entity flag. See Entity Flag enum for more details. Can be used in combination.",
  T_51_META_API_157: "Set Material Property",
  T_51_META_API_157_D: "This API allows you to modify certain properties of an object's material.",
  T_51_META_API_157_P0_D: "The target object to get the material property for",
  T_51_META_API_157_P1: "Property Name",
  T_51_META_API_157_P1_D: "Set the name of the property",
  T_51_META_API_157_P2: "Property Value",
  T_51_META_API_157_P2_D: "Set the value of the property",
  T_51_META_API_157_P3: "Success",
  T_51_META_API_157_P3_D: "Set whether it's successful or not",
  T_51_META_API_158: "Clear Material Property",
  T_51_META_API_158_D: "Clear the set properties",
  T_51_META_API_158_P0_D: "The target object to clear the material property for",
  T_51_META_EVT_21: "On Custom Property Change",
  T_51_META_EVT_21_D: "When a monitored custom property changes, this event will trigger. Note: if a custom property is modified multiple times within a single frame, this event is only triggered once. When the server modifies a custom property, the event is sent to both endpoints; when a client modifies a local entity's custom property, the event is only delivered locally.",
  T_51_META_EVT_21_P0: "Property Index",
  T_51_META_EVT_21_P0_D: "The property's index",
  T_51_META_EVT_21_P1_D: "The property's new value",
  T_51_META_EVT_22: "On Custom Player State Changed",
  T_51_META_EVT_22_D: "This event will trigger when the state of the custom player changes",
  T_51_META_EVT_22_P0: "Custom Player State",
  T_51_META_EVT_22_P0_D: "The state of the custom player",
  T_51_META_EVT_23: "On Receive Voice Response From Persona",
  T_51_META_EVT_23_D: "Trigger this event when persona's voice response is received",
  T_51_META_EVT_24: "On Play Voice Finish From Persona",
  T_51_META_EVT_24_D: "Trigger this event when persona's voice response has finished playing",
  T_51_META_TYP_14_I79: "Bound Custom Player",
  T_51_META_TYP_14_I79_D: "When bound to a Custom Player, the classic character model is hidden, and the target object's position, rotation (facing), and other data are synchronized to it.",
  T_51_META_TYP_15_I6: "Is Show Teammate Name",
  T_51_META_TYP_15_I6_D: "Whether to show teammates' names on the top of their heads",
  T_51_META_TYP_247_I31: "Help Up",
  T_51_META_TYP_247_I31_D: "Help Up",
  T_51_META_TYP_247_I32: "Give Up",
  T_51_META_TYP_247_I32_D: "Give Up",
  T_51_META_TYP_247_I33: "Attack 2",
  T_51_META_TYP_247_I33_D: "Attack 2",
  T_51_META_TYP_247_I34: "Combine Weapon",
  T_51_META_TYP_247_I34_D: "Combine Weapon",
  T_51_META_TYP_247_I35: "Surfboard",
  T_51_META_TYP_247_I35_D: "Surfboard",
  T_51_META_TYP_313_I2_D: "Out-of-zone damage per second",
  T_51_META_TYP_409_I22: "Parameter Error",
  T_51_META_TYP_409_I22_D: "Parameter error",
  T_51_META_TYP_440_I1_D: "Performance asset ID",
  T_51_META_TYP_454: "Material Property",
  T_51_META_TYP_454_D: "Use to set the material property for an object",
  T_51_META_TYP_455: "Entity Flag",
  T_51_META_TYP_455_D: "The property flag for a specific entity, can be used in combination",
  T_51_META_TYP_455_I0_D: "Default property",
  T_51_META_TYP_455_I1: "Static",
  T_51_META_TYP_455_I1_D: "Static entity",
  T_51_META_TYP_455_I2: "Local",
  T_51_META_TYP_455_I2_D: "Localy entity",
  T_51_META_TYP_455_I3: "Render Only",
  T_51_META_TYP_455_I3_D: "Render only",
  T_51_MX_WS_ACTION_BITE: "Crispy Bite",
  T_51_MX_WS_ACTION_BOUNCE: "",
  T_51_MX_WS_ACTION_DOOR_CREAK: "",
  T_51_MX_WS_ACTION_FALL_HIT: "Ground Slam",
  T_51_MX_WS_ACTION_GULP: "",
  T_51_MX_WS_ACTION_RUNAWAY_DUST: "",
  T_51_MX_WS_ACTION_RUNNING_STEPS: "",
  T_51_MX_WS_ACTION_SPIN_LOOP: "",
  T_51_MX_WS_ACTION_STOMACH_GROWL: "Stomach Growling",
  T_51_MX_WS_AMBIENT_BIRDS: "Bird Chirping",
  T_51_MX_WS_AMBIENT_CAFE_AMBIENCE: "Cafe Atmosphere",
  T_51_MX_WS_AMBIENT_CLASSROOM_OFFICE: "Classroom Ambience",
  T_51_MX_WS_AMBIENT_NIGHT_CRICKETS: "",
  T_51_MX_WS_AMBIENT_RAIN: "Raining",
  T_51_MX_WS_AMBIENT_STREET_TRAFFIC: "Street Traffic",
  T_51_MX_WS_AMBIENT_WAVES: "",
  T_51_MX_WS_ATMOSPHERE_APPLAUSE_LAUGH: "",
  T_51_MX_WS_ATMOSPHERE_BASS_DRUM: "",
  T_51_MX_WS_ATMOSPHERE_BELL: "Bell Ringing",
  T_51_MX_WS_ATMOSPHERE_JINGLE: "Bell Jingling",
  T_51_MX_WS_ATMOSPHERE_WIND: "Howling Wind",
  T_51_MX_WS_COMEDY_AIR_WHIP: "",
  T_51_MX_WS_COMEDY_CAMERA_CLICK: "Camera Click",
  T_51_MX_WS_COMEDY_FAIL_WAHWAH: "",
  T_51_MX_WS_COMEDY_FART: "Funny Fart",
  T_51_MX_WS_COMEDY_FUNNY_LAUGH: "Laughter",
  T_51_MX_WS_COMEDY_HEAD_SLAP: "",
  T_51_MX_WS_COMEDY_IDEA_DING: "",
  T_51_MX_WS_COMEDY_RECORD_SCRATCH: "",
  T_51_MX_WS_COMEDY_VICTORY_DING: "",
  T_51_MX_WS_EMOTION_AWKWARD: "",
  T_51_MX_WS_EMOTION_BLINK_SWITCH: "",
  T_51_MX_WS_EMOTION_CONFIDENT_VICTORY: "",
  T_51_MX_WS_EMOTION_CONFUSED: "",
  T_51_MX_WS_EMOTION_HAPPY_NOTIFICATION: "",
  T_51_MX_WS_EMOTION_HEARTBEAT_LOVE: "Heart Beating",
  T_51_MX_WS_EMOTION_PHONE_VIBRATION: "",
  T_51_MX_WS_EMOTION_SIGH_SAD: "Sigh",
  T_51_MX_WS_EMOTION_SNORT: "",
  T_51_MX_WS_EMOTION_SPARKLE: "",
  T_51_MX_WS_EMOTION_SURPRISE_SHOCK: "",
  T_51_MX_WS_EMOTION_TEETH_CHATTER: "Teeth Chattering",
  T_51_MX_WS_FANTASY_MAGIC_CAST: "",
  T_51_MX_WS_FANTASY_TRANSFORM: "",
  T_51_MX_WS_FX_EXPLOSION: "Explosion Impace",
  T_51_MX_WS_FX_FIRE_BURN: "Crackling Flames",
  T_51_MX_WS_FX_ICE_CRACK: "",
  T_51_MX_WS_FX_LIGHTNING: "Lightning",
  T_51_MX_WS_FX_SPLASH: "Splash",
  T_51_MX_WS_MECHANIC_BOX_OPEN: "Unboxing",
  T_51_MX_WS_MECHANIC_GEAR_SPIN: "Gear Rotating",
  T_51_MX_WS_MECHANIC_LOCK_UNLOCK: "",
  T_51_MX_WS_MECHANIC_OPEN_CLOSE: "",
  T_51_MX_WS_MECHANIC_POURING: "",
  T_51_MX_WS_RHYTHM_BREAK_BEAT: "",
  T_51_MX_WS_RHYTHM_CLAP: "Clapping",
  T_51_MX_WS_RHYTHM_DRUM_BEAT: "",
  T_51_MX_WS_SOUNDTYPE_INTERACTION: "",
  T_51_MX_WS_TRANSITION_GLITCH: "",
  T_51_MX_WS_TRANSITION_POPUP: "Window Pop-up",
  T_51_MX_WS_TRANSITION_REVERSE_SUCTION: "",
  T_51_MX_WS_TRANSITION_WHOOSH: "",
  T_51_MX_WS_TRANSPORT_AIRCRAFT: "",
  T_51_MX_WS_TRANSPORT_BIKE_SKATE: "",
  T_51_MX_WS_TRANSPORT_CAR_DRIVE: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHDECEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOOP: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWDECEL: "",
  T_51_MX_WS_TRANSPORT_STREAM_FLOW: "Rushing Water",
  T_51_MX_WS_TRANSPORT_TRAIN_BEEP: "",
  T_51_MX_WS_UI_ACHIEVEMENT_UNLOCK: "",
  T_51_MX_WS_UI_BUTTON_CLICK: "Button Click",
  T_51_MX_WS_UI_CANCEL: "",
  T_51_MX_WS_UI_CONFIRM: "",
  T_51_MX_WS_UI_LIST_SCROLL: "",
  T_51_MX_WS_UI_LOADING: "Loading Progress",
  T_51_TYC_API_OUTLINE: "Set Entity Outline",
  T_51_TYC_API_OUTLINE_ALPHA: "Outline Transparency",
  T_51_TYC_API_OUTLINE_ALPHA_D: "Value between 0 and 1 (0 = fully transparent,1 = fully opaque)",
  T_51_TYC_API_OUTLINE_COLOR: "Outline Color",
  T_51_TYC_API_OUTLINE_COLOR_D: "The color used for drawing the outline",
  T_51_TYC_API_OUTLINE_D: "Specifies an entity to highlight its edges. Supported types include Player, Custom Render, NPC, Appearance, and Basic Appearance.",
  T_51_TYC_API_OUTLINE_TARGET: "Target Entity",
  T_51_TYC_API_OUTLINE_TARGET_D: "The entity to be outlined",
  T_51_TYC_API_OUTLINE_TOPMOST: "Always on Top",
  T_51_TYC_API_OUTLINE_TOPMOST_D: "Makes the outline render through all objects, always visible on top.",
  T_51_TYC_API_OUTLINE_WIDTH: "Outline Width",
  T_51_TYC_API_OUTLINE_WIDTH_D: "Value between 0 and 1 (0 = no outline, 1 = max. outline thickness)",
  T_51_XJ_WS_BASIC_SETTING: "Basic Settings",
  T_51_XJ_WS_GAME_START_TIME_UNIT: "Second",
  T_51_XJ_WS_GMSTART_TIME: "وقت التحضير قبل بدء اللعبة",
  T_51_ZCS_SPAWNPOINT_NAME: "",
  T_OB47_M_WS_READ: "خاصية للقراءة فقط",
  TXT_AVATAR_FEMALE_JACKET_BLACK: "سترة جلد سوداء (نسائي)",
  TXT_AVATAR_FEMALE_PANTS_MARIO: "صائد الفطر",
  TXT_AVATAR_FEMALE_SHOE_COS_HOODSHIRT_BLACK: "ملابس رياضية سوداء (أحذية)",
  TXT_AVATAR_FEMALE_SHORTPANT_COS_GSL_BLACK: "بنطال قصير نجمة قارينا",
  TXT_AVATAR_FEMALE_SKIRT_COS_GSL_BLACK: "تنورة نجمة قارينا",
  TXT_AVATAR_FEMALE_TOP_COS_HOODSHIRT_BLACK: "ملابس رياضية سوداء (هودي)",
  TXT_AVATAR_FEMALE_TOP_COS_SONGKRAN_2018: "قطعة سونغكران علوية (سوداء)",
  TXT_AVATAR_FEMALE_TSHIRT_MARIO: "قطعة علوية للسمكري (نسائي)",
  TXT_AVATAR_FEMALE_VEST_COS_GSL_BLACK: "قميص بدون أكمام نجمة قارينا",
  TXT_AVATAR_MALE_BOTTOM_COS_CNY_RED: "الرفاه الأبيض (لباس سفلي)",
  TXT_AVATAR_MALE_BOTTOM_COS_GANGS_BLACK: "بنطال ركض أسود (رجالي)",
  TXT_AVATAR_MALE_BOTTOM_COS_MOB_YELLOW: "سارق الصيد",
  TXT_AVATAR_MALE_BOTTOM_COS_OUTDOOR_BLACK: "بنطال الصامد",
  TXT_AVATAR_MALE_PANTS_MARIO: "ماماميا",
  TXT_AVATAR_MALE_SHOE_COS_CANVAS_BLACK: "حذاء الصامد",
  TXT_AVATAR_MALE_SHOE_RED: "أحذية بوت حمراء (رجالي)",
  TXT_AVATAR_MALE_TOP_COS_CNY_RED: "الرغد الأبيض (قطعة علوية)",
  TXT_AVATAR_MALE_TOP_COS_GANGS_BLACK: `جيرسي
 البيسبول الأسود`,
  TXT_AVATAR_MALE_TOP_COS_HOODIE_BRICKR: "هودي الثوري",
  TXT_AVATAR_MALE_TOP_COS_HOODSHIRT_BLACK: "ملابس رياضية رائعة (هودي)",
  TXT_AVATAR_MALE_TOP_COS_MOB_DGREEN: "صدرية ملك الجماجم",
  TXT_AVATAR_MALE_TOP_COS_OUTDOOR_GREY: "قميص الناجي",
  TXT_AVATAR_MALE_TSHIRT_MARIO: "قطعة علوية للسمكري (رجالي)",
  TXT_AVATAR_OB10_LZW_FEMALE_TOP_COS_SPONSOR: "سترة المتسابقة",
  TXT_AVATAR_OB10_LZW_MALE_HAIR_COS_CLOWN: "المهرج الليلي (رأس)",
  TXT_AVATAR_OB10_LZW_MALE_TOP_COS_SPONSOR: "سترة المتسابق",
  TXT_AVATAR_OB10_LZW_TOP_SLEEVELESS: "سترة بدون أكمام (خضراء)",
  TXT_AVATAR_OB11_LZW_COS_NYARUKO: "السيد سكويدو",
  TXT_AVATAR_OB11_LZW_MALE_ACCESSORY_COS_ZOMBIE: "ساموراي الزومبي (قناع)",
  TXT_AVATAR_OB11_LZW_MALE_TOP_COS_PINK_JAZZ: "وشم على الذراع بالكامل",
  "TXT_AVATAR_OB7_LZW_FEMALE_A-SKIRT_BLACK": "عناق",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_CNY_RED_OBT7TH: "فكتوريا",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "تصميم ريترو أنيق",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_JAPANESESTYLE_PINK: "قطعة كتسوني سفلية",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_COS_JAPANESESTYLE_PINK: "حذاء الثعلب",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_SPORTS_08: "حذاء رياضي (أزرق)",
  TXT_AVATAR_OB7_LZW_FEMALE_SHORTPANTS_FLAP_BLUE: "شورت دنيم (نسائي)",
  TXT_AVATAR_OB7_LZW_FEMALE_TOP_COS_JAPANESESTYLE_PINK: "روب الثعلب",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_BATTLE_BROWN: "بنطال المعارك (رجالي)",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "بنطال Angelic",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_JAPANESESTYLE_PURPLE: "قطعة سفلية البوشيدو",
  TXT_AVATAR_OB7_LZW_MALE_HOODIE_ZIPPER_GREY: "هودي رمادي بسوستة",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_CASUAL: "حذاء الهيبستر",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_JAPANESESTYLE_PURPLE: "حذاء البوشيدو",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_TECHWEAR_OBT7TH: "حذاء الفضائي",
  TXT_AVATAR_OB7_LZW_MALE_SHORTPANTS_FLAP_BLUE: "شورت دنيم (رجالي)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_BATTLE_BROWN: "صدرية المعارك (رجالي)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_CASUAL: "قطعة علوية الهيبستر",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_JAPANESESTYLE_PURPLE: "أسلوب البوشيدو",
  TXT_AVATAR_OB8_LZW_BALLPANTS_WHITE: "الإعصار الأبيض",
  TXT_AVATAR_OB8_LZW_FEMALE_BOTTOM_COS_BASEBALL_GREEN: "لاعب البيسبول (لباس ضيق)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_ASUS_JACKET: "سترة الدراجة",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_COS_BASEBALL_GREEN: "لاعب البيسبول (سترة)",
  TXT_AVATAR_OB8_LZW_MALE_BOTTOM_COS_BASEBALL_YELLOW: "القائد البارع (بنطال)",
  "TXT_AVATAR_OB8_LZW_MALE_HAIR_COS_HIP-HOP": "الشوارع (رأس)",
  TXT_AVATAR_OB8_LZW_MALE_SHOE_COS_BASEBALL_YELLOW: "القائد الرائع (حذاء)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_ASUS_JACKET: "سترة الدراج",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_BASEBALL_YELLOW: "القائد الرائع (سترة)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_DINOSAUR_GREEN: "الديناصور",
  TXT_AVATAR_OB8_LZW_SHOE_SOCCER_SILVER: "البوت الفضي",
  TXT_AVATAR_OB8_LZW_TSHIRT_ENGLAND_B: "الأسود الثلاثة",
  TXT_AVATAR_OB9_LZW_MALE_ACCESSORY_COS_TUXEDO: "بدلة رسمية للسهرة (قناع)",
  TXT_AVATAR_OB9_LZW_MALE_HAIR_COS_TUXEDO: "بدلة رسمية للسهرة (كشف الوجه)",
  TXT_AVATAR_PARACHUTE_8: "مظلة - مبتسم",
  TXT_AVATAR_SHIRT_PLAID_2: "المبرمجون المفضلون (أحمر)",
  TXT_AVATAR_SHOES_1: "حذاء رياضي (أبيض)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_2: "طالبة (برتقالي)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_3: "طالبة (أحمر)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_4: "طالبة (أصفر)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_5: "طالبة (وردي)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_6: "طالبة (الياسمين)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_7: "طالبة (أزرق)",
  TXT_AVATAR_TSHIRT_WEEK_007: "الأحد المرصع بالنجوم",
  TXT_BANNER_NAME_MISHA: "سرعة",
  TXT_CHARACTER_ADAM_NAME: "بريمس",
  TXT_CHARACTER_BODYGUARD_NAME: "نيكيتا",
  TXT_CHARACTER_COP_NAME: "أندرو",
  TXT_CHARACTER_EVA_NAME: "نولا",
  TXT_CHARACTER_NURSE_NAME: "أوليفيا",
  TXT_CHARACTER_RACERGIRL_NAME: "ميشا",
  TXT_CHARACTER_RUNNER_NAME: "كيلي",
  TXT_CHARACTER_SEAMAN_NAME: "فورد",
  TXT_CLAN_NAME: "الاسم",
  TXT_COLLECTION_DESCRIPTION: "الوصف",
  TXT_COLLECTION_HEADPORTRAIT: "صورة",
  TXT_INVENTORY_TITLE_EQUIPMENT: "العتاد",
  TXT_ITEM_AK: "AK47",
  TXT_ITEM_ARAMMO: "ذخيرة AR",
  TXT_ITEM_AWM: "AWM",
  TXT_ITEM_BAG1: "حقيبة المستوى 1",
  TXT_ITEM_BAG2: "حقيبة المستوى 2",
  TXT_ITEM_BAG3: "حقيبة المستوى 3",
  TXT_ITEM_BASEBALLPOLE: "مضرب",
  TXT_ITEM_BOWAMMO: "سهم القوس",
  TXT_ITEM_CHANGUO: "مقلاة",
  TXT_ITEM_CROSSBOW: "القوس",
  TXT_ITEM_DESC_FLASH: "جهاز تفجير يشوش حواس العدو بصورة مؤقتة.",
  TXT_ITEM_EAGLE: "نسر الصحراء",
  TXT_ITEM_FAK: "معدات طبية",
  TXT_ITEM_FAMAS: "فاماس",
  TXT_ITEM_FIST: "قبضة",
  TXT_ITEM_FLASH: "قنبلة صوت",
  TXT_ITEM_FOREGRIP1: "قبضة أمامية للمستوى 1",
  TXT_ITEM_FOREGRIP2: "قبضة أمامية للمستوى 2",
  TXT_ITEM_FOREGRIP3: "قبضة أمامية للمستوى 3",
  TXT_ITEM_G18: "G18",
  TXT_ITEM_GRENADE: "قنبلة",
  TXT_ITEM_GROZA: "جروزا",
  TXT_ITEM_HANDCANNON: "مدفع يدوي",
  TXT_ITEM_HEATSIGHT: "عدسة قناصة حرارية",
  TXT_ITEM_HELMET1: "خوذة المستوى 1",
  TXT_ITEM_HELMET2: "خوذة المستوى 2",
  TXT_ITEM_HELMET3: "خوذة المستوى 3",
  TXT_ITEM_HGAMMO: "ذخيرة HG",
  TXT_ITEM_KAR98K: "Kar98k",
  TXT_ITEM_LANUNCHERAMMO: "SR عيار 40 مم",
  TXT_ITEM_M1014: "M1014",
  TXT_ITEM_M14: "M14",
  TXT_ITEM_M1873: "M1873",
  TXT_ITEM_M249: "M249",
  TXT_ITEM_M4A1: "M4A1",
  TXT_ITEM_M500: "M500",
  TXT_ITEM_M79: "M79",
  TXT_ITEM_MACHETE: "شفرة",
  TXT_ITEM_MAGEZINE1: "ذخيرة المستوى 1",
  TXT_ITEM_MAGEZINE2: "ذخيرة المستوى 2",
  TXT_ITEM_MAGEZINE3: "ذخيرة المستوى 3",
  TXT_ITEM_MP40: "MP40",
  TXT_ITEM_MP5: "MP5",
  TXT_ITEM_MUZZLE1: "فوهة البندقية المستوى 1",
  TXT_ITEM_MUZZLE2: "فوهة البندقية المستوى 2",
  TXT_ITEM_MUZZLE3: "فوهة البندقية المستوى 3",
  TXT_ITEM_SCAR: "SCAR",
  TXT_ITEM_SGAMMO: "ذخيرة SG",
  TXT_ITEM_SIGHT2: "عدسة 2x",
  TXT_ITEM_SIGHT4: "عدسة 4x",
  TXT_ITEM_SILENCER1: "كاتم صوت",
  TXT_ITEM_SKS: "SKS",
  TXT_ITEM_SMGAMMO: "ذخيرة SMG",
  TXT_ITEM_SNAMMO: "ذخيرة سلاح القنص",
  TXT_ITEM_SPAS12: "SPAS12",
  TXT_ITEM_SVD: "SVD",
  TXT_ITEM_UMP: "UMP",
  TXT_ITEM_USP: "USP",
  TXT_ITEM_VEST1: "سترة المستوى 1",
  TXT_ITEM_VEST2: "سترة المستوى 2",
  TXT_ITEM_VEST3: "سترة المستوى 3",
  TXT_ITEM_VSS: "VSS",
  TXT_ITEM_XM8: "XM8",
  TXT_MATCHRESULT_TITLE: "النتيجة",
  TXT_MESSAGEBOX_ERROR: "خطأ",
  TXT_OB10_HQW_ITEM_BIPOD: "حامل ثنائي",
  TXT_OB10_HQW_ITEM_M60: "م60",
  TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME: "برميل نفط",
  TXT_OB10_JRW_CHARACTER_BRAZILSOLDIER_NAME: "ميجيل",
  TXT_OB10_JRW_SKILL_NAME_BRAZILSOLDIER: "القاتل المجنون",
  TXT_OB10_ZXR_BASEBALLBAT_CORN_NAME: "مضرب - ذرة مشوية مكسيكية",
  TXT_OB10_ZXR_GRENADESKIN_RANGE: "معدل الانفجار",
  TXT_OB10_ZXR_MACHETE_RANKMASTER_NAME: "شفرة - مُنفّذ حكم الإعدام",
  TXT_OB11_HQW_ITEM_MGL140: "MGL140",
  TXT_OB11_HQW_ITEM_P90: "P90",
  TXT_OB11_HQW_LANDMINE: "لغم أرضي",
  TXT_OB11_HQW_LANDMINE_DESC: `لغم ينتشر
 أثره على الأرض. 
احذر! لا تقف عليه!`,
  TXT_OB11_JRW_CHARACTER_RICHGIRL_NAME: "كارولين",
  TXT_OB11_JRW_EMOTE_CLAP_NAME: "تصفيق",
  TXT_OB11_JRW_EMOTE_DAB_NAME: "الداب",
  TXT_OB11_JRW_EMOTE_FUNKYCHICKEN_NAME: "إنه الدجاج",
  TXT_OB11_JRW_EMOTE_HELLO_NAME: "أهلاً!",
  TXT_OB11_JRW_EMOTE_LOL_NAME: "قهقهة",
  TXT_OB11_JRW_EMOTE_PROVOKE_NAME: "إثارة",
  TXT_OB11_JRW_SKILL_DESC_RICHGIRL: "عند حمل الشوتجن، تزيد سرعة الحركة بمعدل [FFB300]{0}%[-].",
  TXT_OB11_JRW_SKILL_NAME_RICHGIRL: "خفة الحركة",
  TXT_OB11_ZXR_SCAR_CHEETAH_NAME: "الفهد: الأنياب",
  TXT_OB11_ZXR_SCAR_TOPGAMER_NAME: "سلاح مستقبلي",
  TXT_OB16_Q_ITEM_ARMORREPAIR: "طقم الإصلاح",
  TXT_OB5_HISTORY_HEADSHOOT: "طلقة بالرأس",
  TXT_OB5_HISTORY_LIVE: "البقاء",
  TXT_OB7_JRW_CHARACTER_FOODIEBOY_NAME: "مكسيم",
  TXT_OB7_JRW_SKILL_DESC_FOODIEBOY: "يقوم بتسريع تناول الفطر و باقي المعدات الطبية بمعدل [FFB300]{0}%[-].",
  TXT_OB7_JRW_SKILL_NAME_FOODIEBOY: "نهم",
  TXT_OB7_ZC_CLAN_NICKNAME: "اللقب",
  TXT_OB7_ZJS_HISTORY_TIME: "الوقت",
  TXT_OB8_HQW_NEWLOADOUT_BONFIRE: "الشعلة",
  TXT_OB8_JYF_PARACHUTE_THUNDER_NAME: "مظلة - مسمار",
  TXT_OB8_SQ_CHARACTER_THAIBOXER_NAME: "كلا",
  TXT_OB8_SQ_SKILL_DESC_THAIBOXER: "يزيد ضرر اللكمة بنسبة [FFB300]{0}%[-]",
  TXT_OB8_SQ_SKILL_NAME_THAIBOXER: "الملاكمة التايلاندية",
  TXT_OB8_ZXR_AWM_CAMO_NAME: "المروج الأرجواني",
  TXT_OB8_ZXR_G18_CAMO_NAME: "المركز الذري",
  TXT_OB8_ZXR_M249_CAMO_NAME: "ذابل",
  TXT_OB8_ZXR_M79_CAMO_NAME: "مركز السماء",
  TXT_OB8_ZXR_USP_CAMO_NAME: "نمر الثلوج",
  TXT_OB9_JRW_CHARACTER_ARMSDEALER_NAME: "بالوما",
  TXT_OB9_JRW_SKILL_NAME_ARMSDEALER: "تجارة السلاح",
  TXT_OB9_JYF_SKYBOARD_BOOYAH_NAME: "مزلاجة - النجمة الخضراء",
  TXT_OB9_SQ_ITEM_GLOOSHIELD: "جدار جلو",
  TXT_OB9_ZXR_AK47_DIGI_CAMO_NAME: "تمويه رقمي",
  TXT_OB9_ZXR_FAMAS_RED_NAME: "أحمر داكن",
  TXT_OB9_ZXR_G18_CAMO_02_NAME: "صياد الصحراء",
  TXT_OB9_ZXR_GROZA_CAMO_NAME: "لهيب أزرق",
  TXT_OB9_ZXR_M1014_CAMO_02_NAME: "موكب أرجواني",
  TXT_OB9_ZXR_M14_CAMO_NAME: "تيار الحياة",
  TXT_OB9_ZXR_M1873_NAME: "أزرق غامق",
  TXT_OB9_ZXR_MACHETE_FISH_NAME: "شفرة - سمك أبو سيف",
  TXT_OB9_ZXR_MP5_CAMO_NAME: "حصاد",
  TXT_OB9_ZXR_SCAR_CAMO_BLUE_NAME: "كوارتز أرجواني",
  TXT_OB9_ZXR_SKS_CAMO_NAME: "أرض محروقة",
  TXT_OPTION_HIGH_BRIGHTNESS: "ساطع",
  TXT_PLAYER_RANK: "التصنيف",
  TXT_ROOM_LOBBY_ID: "إندونيسيا",
  TXT_ROOM_MAP_PARADISE: "برمودا",
  TXT_SETTING_CHANGEWEAPON: "زر تبديل السلاح السريع",
  TXT_SETTING_OB4_NOTREAL: "داكن",
  TXT_SKILL_DESC_COP: "إنخفاض فقدان متانة الدرع بنسبة [FFB300]{0}%[-].",
  TXT_SKILL_DESC_RUNNER: "زيادة سرعة الركض بنسبة [FFB300]{0}%[-].",
  TXT_SKILL_NAME_COP: "أخصائي دروع",
  TXT_SKILL_NAME_NURSE: "لمسة الشفاء",
  TXT_SKILL_NAME_RACERGIRL: "احتراق",
  TXT_SKILL_NAME_RUNNER: "اندفاع",
  TXT_SKILL_NAME_SEAMAN: "إرادة حديدية",
  TXT_TUTORIAL_HUD: "HUD",
  TXT_TUTORIAL_HUD_LABEL10: "الركض",
  TXT_TUTORIAL_PICKUP_LABEL0: "سلاح",
  T_34_M_WS_VFXTYPE: "نوع المؤثرات البصرية",
  T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY: "هدف الهجوم",
  T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY: "نوع واجهة المستخدم للاعب",
  T_41_XXJ_WS_MONSTERSKILLTYPE: "نوع مهاراة الوحش",
  T_45_META_WS_DESCRIPTIVECOLOR: "اللون الوصفي",
  T_45_META_WS_GAMETIME: "وقت اللعب",
  T_45_META_WS_PROPERTY: "الخاصية",
  T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE: "نوع نمط الزر",
  T_45_XXJ_WS_UISOCIALBUTTONTYPE: "واجهة المستخدم لنوع الزر الاجتماعي",
  T_46_META_WS_A_A: "A",
  T_46_META_WS_A_ACCELERATION: "التسارع",
  T_46_META_WS_A_ACCOUNTID: "معرف الحساب",
  T_46_META_WS_A_ACTIONTYPE: "نوع الحركة",
  T_46_META_WS_A_ACTIVE: "نشط",
  T_46_META_WS_A_ANGLE: "الزاوية",
  T_46_META_WS_A_ANY: "أي",
  T_46_META_WS_A_APPEARANCEGROUP: "مجموعة المظهر",
  T_46_META_WS_A_ASSERTIONEXPRESSION: "تعبير التأكيد",
  T_46_META_WS_A_ATTACHMENT: "الإضافات",
  T_46_META_WS_A_ATTACHMENTS: "قائمة الإضافات",
  T_46_META_WS_A_ATTACKABLE: "قابل للهجوم",
  T_46_META_WS_A_ATTACKER: "المهاجم",
  T_46_META_WS_A_ATTACKTARGET: "هدف الهجوم",
  T_46_META_WS_A_AUTOPLAY: "التشغيل التلقائي",
  T_46_META_WS_A_AXIS: "المحور",
  T_46_META_WS_A_B: "B",
  T_46_META_WS_A_BASE: "الأساس",
  T_46_META_WS_A_BOUNDTARGET: "الهدف المرتبط",
  T_46_META_WS_A_BTREE: "شجرة السلوك",
  T_46_META_WS_A_BUFF: "التعزيز (Buff)",
  T_46_META_WS_A_CAMERA: "الكاميرا",
  T_46_META_WS_A_CAPICITY: "السعة",
  T_46_META_WS_A_CENTER: "المركز",
  T_46_META_WS_A_CHANGEROTATION: "تغيير الدوران",
  T_46_META_WS_A_CHANNEL: "القناة",
  T_46_META_WS_A_CHASEENEMY: "مطاردة العدو",
  T_46_META_WS_A_CHILD: "الطفل",
  T_46_META_WS_A_COLOR: "اللون",
  T_46_META_WS_A_COLUMN: "العمود",
  T_46_META_WS_A_COLUMNNAME: "اسم العمود",
  T_46_META_WS_A_COMEBACK: "العودة",
  T_46_META_WS_A_COMPONENT: "المكون",
  T_46_META_WS_A_CONTENT: "المحتوى",
  T_46_META_WS_A_COORDINATESYSTEM: "نظام الإحداثيات",
  T_46_META_WS_A_COUNT: "العدد",
  T_46_META_WS_A_COUNTS: "العدد",
  T_46_META_WS_A_CREATEDENTITY: "الكيان المُنشأ",
  T_46_META_WS_A_CROSSPLATFORM: "عبر المنصات",
  T_46_META_WS_A_CULLINGMASK: "قناع التصفية",
  T_46_META_WS_A_CURVE: "منحنى",
  T_46_META_WS_A_CUSTOMTAG: "علامة مخصصة",
  T_46_META_WS_A_CUTRADIUS: "نصف قطر القطع",
  T_46_META_WS_A_DAMAGE: "الضرر",
  T_46_META_WS_A_DAMAGESEGMENTS: "أجزاء الضرر",
  T_46_META_WS_A_DEGREE: "الدرجة",
  T_46_META_WS_A_DELTA: "دلتا",
  T_46_META_WS_A_DEPTH: "العمق",
  T_46_META_WS_A_DESTVAL: "القيمة المستهدفة",
  T_46_META_WS_A_DIFFICULTY: "الصعوبة",
  T_46_META_WS_A_DIRECTION: "الاتجاه",
  T_46_META_WS_A_DISABLE: "معطل",
  T_46_META_WS_A_DISPLACEMENT: "الإزاحة",
  T_46_META_WS_A_DISTANCE: "المسافة",
  T_46_META_WS_A_DIVINGMAXSPEED: "السرعة القصوى للغوص",
  T_46_META_WS_A_DOTWEEN: "تنفيذ التحريك",
  T_46_META_WS_A_DURATION: "المدة (ثوانٍ)",
  T_46_META_WS_A_EMOTE: "رقصة",
  T_46_META_WS_A_ENABLE: "التفعيل",
  T_46_META_WS_A_ENDAREACENTER: "مركز منطقة النهاية",
  T_46_META_WS_A_ENDAREARANGE: "نطاق منطقة النهاية",
  T_46_META_WS_A_ENDPOSITION: "موقع النهاية",
  T_46_META_WS_A_ENDRANK: "الرتبة النهائية",
  T_46_META_WS_A_EQUIPMENTS: "المعدات",
  T_46_META_WS_A_EVENTID: "معرف الحدث",
  T_46_META_WS_A_EXPONENT: "الأس",
  T_46_META_WS_A_FACTION: "الفصيل",
  T_46_META_WS_A_FACTORTYPE: "نوع العامل",
  T_46_META_WS_A_FILTERTYPE: "نوع الفلتر",
  T_46_META_WS_A_FINALRADIUS: "نصف القطر النهائي",
  T_46_META_WS_A_FINDVALUE: "البحث عن القيمة",
  T_46_META_WS_A_FIXEDRANGE: "النطاق الثابت",
  T_46_META_WS_A_FOLLOWTARGET: "متابعة الهدف",
  T_46_META_WS_A_FONTCOLOR: "لون الخط",
  T_46_META_WS_A_FONTSIZE: "حجم الخط",
  T_46_META_WS_A_FOOTBALL: "كرة القدم",
  T_46_META_WS_A_FORCE: "القوة",
  T_46_META_WS_A_FORCEDPARACHUTEHEIGHT: "ارتفاع فتح المظلة الإجباري",
  T_46_META_WS_A_FORCEMODE: "وضع القوة",
  T_46_META_WS_A_FORWARD: "الأمام",
  T_46_META_WS_A_G: "G",
  T_46_META_WS_A_GAMEID: "معرف اللعبة",
  T_46_META_WS_A_HALFEXTENTS: "نصف الأبعاد",
  T_46_META_WS_A_HEIGHT: "الارتفاع",
  T_46_META_WS_A_HEIGHTSEGMENTS: "أجزاء الارتفاع",
  T_46_META_WS_A_HITDISTANCE: "مسافة الضربة",
  T_46_META_WS_A_HITDISTANCES: "مسافات الضرب",
  T_46_META_WS_A_HITENTITIES: "الكيانات المتضررة",
  T_46_META_WS_A_HITENTITY: "الكيان الذي تم ضربه",
  T_46_META_WS_A_HITNORMAL: "طبيعة الضربة",
  T_46_META_WS_A_HITNORMALS: "الضربات العادية",
  T_46_META_WS_A_HITPOINTS: "نقاط الضرب",
  T_46_META_WS_A_HITPOSITION: "موقع الضربة",
  T_46_META_WS_A_INCLUDETRIGGER: "تضمين المشغل",
  T_46_META_WS_A_INDEX: "الفهرس",
  T_46_META_WS_A_INDEXS: "الفهارس",
  T_46_META_WS_A_INITIALVELOCITY: "السرعة الأولية",
  T_46_META_WS_A_INITRADIUS: "نصف القطر الأولي",
  T_46_META_WS_A_INWALLET: "المحفظة الداخلية",
  T_46_META_WS_A_ISBOTTOMCOLLIDING: "تصادم في الأسفل",
  T_46_META_WS_A_ISEXIST: "موجود",
  T_46_META_WS_A_ISLOOP: "حلقة",
  T_46_META_WS_A_ISMAPPEDINSCREEN: "مُمَثل على الشاشة",
  T_46_META_WS_A_ISPAUSE: "التوقف",
  T_46_META_WS_A_ISSIDECOLLIDING: "هل هناك تصادم جانبي",
  T_46_META_WS_A_ISSUCCESS: "النجاح",
  T_46_META_WS_A_ISTOPCOLLIDING: "هل هناك تصادم علوي",
  T_46_META_WS_A_ITEM: "العنصر",
  T_46_META_WS_A_ITEMID: "معرف العنصر",
  T_46_META_WS_A_ITEMS: "العناصر",
  T_46_META_WS_A_ITEMTYPE: "نوع العنصر",
  T_46_META_WS_A_JERSEYTYPE: "نوع القميص",
  T_46_META_WS_A_KEEPVELOCITY: "الحفاظ على السرعة",
  T_46_META_WS_A_KEY: "المفتاح",
  T_46_META_WS_A_KEYCOLUMN: "العمود الرئيسي",
  T_46_META_WS_A_KEYS: "المفاتيح",
  T_46_META_WS_A_LAYER: "الطبقة",
  T_46_META_WS_A_LAYERMASK: "قناع الطبقة",
  T_46_META_WS_A_LEFT: "اليسار",
  T_46_META_WS_A_LEFTVALUE: "القيمة اليسرى",
  T_46_META_WS_A_LENGTH: "الطول",
  T_46_META_WS_A_LEVELOBJECT: "كائن المستوى",
  T_46_META_WS_A_LOG: "السجل",
  T_46_META_WS_A_LOOKATTARGET: "التركيز على الهدف",
  T_46_META_WS_A_LOOPTYPE: "نوع الحلقة",
  T_46_META_WS_A_MAINCOLOR1: "اللون الرئيسي1",
  T_46_META_WS_A_MAINCOLOR2: "اللون الرئيسي2",
  T_46_META_WS_A_MAPCODE: "رمز الخريطة",
  T_46_META_WS_A_MAPPEDPOSITION: "الموقع المُمَثل",
  T_46_META_WS_A_MAX: "الحد الأقصى",
  T_46_META_WS_A_MAXDISPLACEMENT: "الإزاحة القصوى",
  T_46_META_WS_A_MAXDISTANCE: "أقصى مسافة",
  T_46_META_WS_A_MIN: "الحد الأدنى",
  T_46_META_WS_A_MISSIONID: "معرف المهمة",
  T_46_META_WS_A_MISSIONPROGRESS: "تقدم المهمة",
  T_46_META_WS_A_MODIFYTYPE: "نوع التعديل",
  T_46_META_WS_A_MONEYTYPE: "نوع العملة",
  T_46_META_WS_A_MUST: "يجب",
  T_46_META_WS_A_NAME: "الاسم",
  T_46_META_WS_A_NEWVALUE: "القيمة الجديدة",
  T_46_META_WS_A_NODE: "العقدة",
  T_46_META_WS_A_NORMAL: "العادي",
  T_46_META_WS_A_NOT: "لا",
  T_46_META_WS_A_OBSERVER: "المراقب",
  T_46_META_WS_A_OFFSET: "التعويض",
  T_46_META_WS_A_OLDVALUE: "القيمة القديمة",
  T_46_META_WS_A_OPERATIOMETHOD: "طريقة التشغيل",
  T_46_META_WS_A_OPTIONS: "الخيارات",
  T_46_META_WS_A_OTHERCOLOR: "لون آخر",
  T_46_META_WS_A_OUTFIT: "الزي",
  T_46_META_WS_A_OUTFITS: "قائمة الأزياء",
  T_46_META_WS_A_OUTWALLET: "المحفظة الخارجية",
  T_46_META_WS_A_OWNER: "المالك",
  T_46_META_WS_A_PARACHUTINGMAXSPEED: "السرعة القصوى للهبوط بالمظلة",
  T_46_META_WS_A_PARAMS: "المعلمات",
  T_46_META_WS_A_PARENT: "الأصل",
  T_46_META_WS_A_PARENTWIDGET: "الويدجت الرئيسي",
  T_46_META_WS_A_PATH: "المسار",
  T_46_META_WS_A_PATHPOINTS: "نقاط المسار",
  T_46_META_WS_A_PHASEINDEX: "مؤشر المرحلة",
  T_46_META_WS_A_PLATFORM: "المنصة",
  T_46_META_WS_A_PLAYER: "لاعب",
  T_46_META_WS_A_PLAYSPEED: "سرعة التشغيل",
  T_46_META_WS_A_POSITION: "الموقع",
  T_46_META_WS_A_POSITIONS: "المواقع",
  T_46_META_WS_A_POSTION: "الموقع",
  T_46_META_WS_A_PREFAB: "القالب الجاهز",
  T_46_META_WS_A_PROPERTY: "الخاصية",
  T_46_META_WS_A_PROPERTYID: "معرف الخاصية",
  T_46_META_WS_A_PURSUITTARGET: "هدف الملاحقة",
  T_46_META_WS_A_R: "R",
  T_46_META_WS_A_RADIUS: "نصف القطر",
  T_46_META_WS_A_RANDOMDECAY: "اضمحلال عشوائي",
  T_46_META_WS_A_RANDOMRANGE: "نطاق عشوائي",
  T_46_META_WS_A_RANDOMRATIO: "نسبة عشوائية",
  T_46_META_WS_A_RANGE: "النطاق",
  T_46_META_WS_A_RANK: "الترتيب",
  T_46_META_WS_A_REALCOIN: "العملة الحقيقية",
  T_46_META_WS_A_REALNUMBER: "الرقم الحقيقي",
  T_46_META_WS_A_RESET: "إعادة التعيين",
  T_46_META_WS_A_RESOURCE: "الموارد",
  T_46_META_WS_A_RESULT: "النتيجة",
  T_46_META_WS_A_RIGHT: "اليمين",
  T_46_META_WS_A_RIGHTVALUE: "القيمة اليمنى",
  T_46_META_WS_A_ROTATION: "الدوران",
  T_46_META_WS_A_ROW: "الصف",
  T_46_META_WS_A_SAMPLEPOINT: "نقطة العينة",
  T_46_META_WS_A_SCALE: "المقياس",
  T_46_META_WS_A_SCENEID: "معرف المشهد",
  T_46_META_WS_A_SCORE: "الدرجة",
  T_46_META_WS_A_SCORENAME: "اسم الدرجة",
  T_46_META_WS_A_SCREENPOSITION: "موقع الشاشة",
  T_46_META_WS_A_SCRIPT: "النص البرمجي",
  T_46_META_WS_A_SEAT: "المقعد",
  T_46_META_WS_A_SEP: "الفاصل",
  T_46_META_WS_A_SEPSTR: "الفاصل",
  T_46_META_WS_A_SHEETNAME: "اسم الورقة",
  T_46_META_WS_A_SHOPITEM: "عنصر المتجر",
  T_46_META_WS_A_SHOWBACKGROUND: "عرض الخلفية",
  T_46_META_WS_A_SHOWMATCHRESULT: "عرض نتائج اللعبة",
  T_46_META_WS_A_SHOWMESSAGEWHENCANCEL: "عرض الرسالة عند الإلغاء",
  T_46_META_WS_A_SKILL: "المهارة",
  T_46_META_WS_A_SKILLS: "المهارات",
  T_46_META_WS_A_SKILLTARGET: "هدف المهارة",
  T_46_META_WS_A_SKIN: "غلاف الحقيبة",
  T_46_META_WS_A_SLOT: "الفتحة",
  T_46_META_WS_A_SRCVAL: "القيمة المصدر",
  T_46_META_WS_A_SRCVALUE: "قيمة المصدر",
  T_46_META_WS_A_STARTAREACENTER: "مركز منطقة البداية",
  T_46_META_WS_A_STARTAREARANGE: "نطاق منطقة البداية",
  T_46_META_WS_A_STARTINDEX: "فهرس البدء",
  T_46_META_WS_A_STARTPOSITION: "موضع البداية",
  T_46_META_WS_A_STARTRANK: "الرتبة البداية",
  T_46_META_WS_A_STATE: "الحالة",
  T_46_META_WS_A_STATUS: "الحالة",
  T_46_META_WS_A_STATUSCODE: "رمز الحالة",
  T_46_META_WS_A_STYLE: "النمط",
  T_46_META_WS_A_SURFINGMAXSPEED: "السرعة القصوى للتزلج",
  T_46_META_WS_A_TARGET: "الهدف",
  T_46_META_WS_A_TARGETPOSITION: "موضع الهدف",
  T_46_META_WS_A_TEAMSEQ: "ترتيب الفريق",
  T_46_META_WS_A_THRESHOLD: "العتبة",
  T_46_META_WS_A_TIMESTAMP: "طابع زمني",
  T_46_META_WS_A_TIPS: "النصائح",
  T_46_META_WS_A_TITLE: "العنوان",
  T_46_META_WS_A_TOKENCOUNT: "عدد الرموز المميزة",
  T_46_META_WS_A_TOKENID: "معرف الرمز المميز",
  T_46_META_WS_A_TORQUE: "عزم الدوران",
  T_46_META_WS_A_TOUCHPOINT: "نقطة اللمس",
  T_46_META_WS_A_TRANSITIONTIME: "وقت الانتقال (مللي ثانية)",
  T_46_META_WS_A_TRANSITIONTYPE: "نوع الانتقال",
  T_46_META_WS_A_TRIGGER: "المُشغل",
  T_46_META_WS_A_TYPE: "النوع",
  T_46_META_WS_A_UI: "واجهة المستخدم",
  T_46_META_WS_A_UIID: "معرف الواجهة",
  T_46_META_WS_A_UPWARD: "إلى الأعلى",
  T_46_META_WS_A_VALUE: "القيمة",
  T_46_META_WS_A_VALUEA: "القيمة A",
  T_46_META_WS_A_VALUEB: "القيمة B",
  T_46_META_WS_A_VALUES: "القيم",
  T_46_META_WS_A_VALUET: "القيمة T",
  T_46_META_WS_A_VALUETYPE: "نوع القيمة",
  T_46_META_WS_A_VEHICLE: "المركبة",
  T_46_META_WS_A_VEHICLESKIN: "غلاف المركبة",
  T_46_META_WS_A_VELOCITY: "السرعة",
  T_46_META_WS_A_VELOCITYXZ: "سرعة المحور XZ",
  T_46_META_WS_A_VELOCITYY: "سرعة المحور Y",
  T_46_META_WS_A_VISIBLE: "مرئي",
  T_46_META_WS_A_WAITTIME: "وقت الانتظار (ثوانٍ)",
  T_46_META_WS_A_WALLET: "المحفظة",
  T_46_META_WS_A_WEAPON: "السلاح",
  T_46_META_WS_A_WEAPONSKIN: "مظهر السلاح",
  T_46_META_WS_A_WIDGETID: "معرف الأداة",
  T_46_META_WS_A_WIDGETTYPE: "نوع الويدجت",
  T_46_META_WS_A_WIDTH: "العرض",
  T_46_META_WS_A_WORLDPOSITION: "موقع العالم",
  T_46_META_WS_A_WORLDPOSITIONSTAYS: "يحتفظ بالموقع العالمي",
  T_46_META_WS_A_X: "X",
  T_46_META_WS_A_Y: "Y",
  T_46_META_WS_ABS: "القيمة المطلقة",
  T_46_META_WS_ACOS: "جا عكسي",
  T_46_META_WS_ADDAOISPECIALFOLLOW: "إضافة متابعة خاصة بـ AOI",
  T_46_META_WS_ADDATTACHMENTS: "إضافة ملحقات",
  T_46_META_WS_ADDBUFF: "إضافة مكافأة",
  T_46_META_WS_ADDCOMPONENT: "إضافة مكون",
  T_46_META_WS_ADDFOOTBALLVELOCITY: "إضافة سرعة الكرة",
  T_46_META_WS_ADDFORCE: "إضافة قوة",
  T_46_META_WS_ADDFORCEATPOSITION: "إضافة قوة في موقع",
  T_46_META_WS_ADDFORMULAPROPERTYFACTOR: "إضافة عامل خاصية الصيغة",
  T_46_META_WS_ADDGAMEEVENTLOG: "إضافة سجل أحداث اللعبة",
  T_46_META_WS_ADDHP: "الحصول على منطقة الخادم",
  T_46_META_WS_ADDITEM: "إضافة عنصر",
  T_46_META_WS_ADDITEMINSCENE: "إحياء",
  T_46_META_WS_ADDITEMTOSHOPITEM: "إضافة عنصر إلى عنصر المتجر",
  T_46_META_WS_ADDMONEY: "إضافة المال",
  T_46_META_WS_ADDSCRIPT: "إضافة نص برمجي",
  T_46_META_WS_ADDTAG: "إضافة علامة",
  T_46_META_WS_ADDTOKEN: "إضافة رمز",
  T_46_META_WS_ADDTORQUE: "إضافة عزم دوران",
  T_46_META_WS_ADDUSEREVENTLOG: "إضافة سجل أحداث المستخدم",
  T_46_META_WS_ANGEL: "المسافة",
  T_46_META_WS_APPEND: "إضافة",
  T_46_META_WS_APPENDRANGE: "يحتوي",
  T_46_META_WS_APPLYQUITMIDWAYUICONFIG: "تطبيق تكوين الخروج من المنتصف",
  T_46_META_WS_ASIN: "الحصول على اللون",
  T_46_META_WS_ASSERT: "تأكيد",
  T_46_META_WS_ASSISTPLAYER: "لاعب مساعد",
  T_46_META_WS_ATAN2: "ATan2",
  T_46_META_WS_ATTACKER: "مهاجم",
  T_46_META_WS_ATTACKTARGET: "هدف الهجوم",
  T_46_META_WS_AXISANGLETOQUATERNION: "تحويل زاوية المحور إلى كواتيرنين",
  T_46_META_WS_BOXCAST: "اختبار صندوق",
  T_46_META_WS_BOXOVERLAP: "تداخل صندوق",
  T_46_META_WS_BUTTONNAME: "اسم الزر",
  T_46_META_WS_C_ACTIONTYPE: "نوع نوع الإجراء",
  T_46_META_WS_C_AIMABLE: "يمكن استهدافه",
  T_46_META_WS_C_AIMASSISTABLE: "مساعد التصويب",
  T_46_META_WS_C_AIMASSISTTYPE: "نوع نوع المساعدة في التصويب",
  T_46_META_WS_C_AIRDROP: "إسقاط جوي",
  T_46_META_WS_C_AMMO: "ذخیرہ",
  T_46_META_WS_C_AMMOTYPE: "نوع الذخيرة",
  T_46_META_WS_C_AMPHIBIAN: "برمائي",
  T_46_META_WS_C_ANIMATIONCLIP: "مقطع الرسوم المتحركة",
  T_46_META_WS_C_ANIMATIONCLIPID: "معرف مقطع الرسوم المتحركة",
  T_46_META_WS_C_ANIMATIONCONTROLLER: "وحدة التحكم في الرسوم المتحركة",
  T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE: "وحدة تحكم الرسوم المتحركة القابلة للتثبيت",
  T_46_META_WS_C_ANIMATIONCONTROLLERID: "معرف وحدة التحكم في الرسوم المتحركة",
  T_46_META_WS_C_ANIMATIONSTATE: "حالة الرسوم المتحركة",
  T_46_META_WS_C_ANIMATIONTRIGGER: "زناد الرسوم المتحركة",
  T_46_META_WS_C_APPEARENCE: "المظهر",
  T_46_META_WS_C_ASSETCONFIGID: "معرف تكوين الأصل",
  T_46_META_WS_C_ASSETID: "معرف الأصل",
  T_46_META_WS_C_ATTACHMENT: "ملحق",
  T_46_META_WS_C_ATTACKABLETYPE: "نوع القابل للهجوم",
  T_46_META_WS_C_AUDIOID: "معرف الصوت",
  T_46_META_WS_C_BACKPACK: "حقيبة ظهر",
  T_46_META_WS_C_BACKPACKSKINID: "معرف غلاف الحقيبة",
  T_46_META_WS_C_BASEDATAALIAS: "الاسم المستعار للبيانات الأساسية",
  T_46_META_WS_C_BASICAPPEARANCE: "المظهر الأساسي",
  T_46_META_WS_C_BASICCYLINDER: "أسطوانة أو مخروط أساسي",
  T_46_META_WS_C_BASICSCALABLE: "قابل للتطوير الأساسي",
  T_46_META_WS_C_BASICSPHERE: "كرة أساسية",
  T_46_META_WS_C_BATCHCOMBINERENDER: "مكون دمج الحزمة",
  T_46_META_WS_C_BEVTREE: "شجرة السلوك",
  T_46_META_WS_C_BEVTREEATTACHABLE: "كيان قابل للتثبيت على شجرة السلوك",
  T_46_META_WS_C_BEVTREECUSTOMNODE: "عقدة شجرة السلوك المخصصة",
  T_46_META_WS_C_BEVTREEID: "معرف شجرة السلوك",
  T_46_META_WS_C_BEVTREENODESTATUS: "حالة عقدة شجرة السلوك",
  T_46_META_WS_C_BEVTREENODETYPE: "نوع عقدة شجرة السلوك",
  T_46_META_WS_C_BEZIERCURVE: "منحنى بيفير",
  T_46_META_WS_C_BOOL: "بولياني",
  T_46_META_WS_C_BOTDIFFICULTYTYPE: "نوع صعوبة البوت",
  T_46_META_WS_C_BOUNCINGTIRE: "إطار قافز",
  T_46_META_WS_C_BUFFABLE: "قابل بوف",
  T_46_META_WS_C_BUFFGENERATOR: "مولد تعزيز",
  T_46_META_WS_C_BUFFTYPE: "نوع buff",
  T_46_META_WS_C_BUILTINRENDER: "العرض المدمج",
  T_46_META_WS_C_BUILTINUI: "واجهة المستخدم المدمجة",
  T_46_META_WS_C_BUILTINUITYPE: "نوع واجهة المستخدم المدمج",
  T_46_META_WS_C_CAMERA: "كاميرا",
  T_46_META_WS_C_CAMERABLOCKMODE: "وضع حظر الكاميرا",
  T_46_META_WS_C_CAMERAPROJECTIONMODE: "وضع الإسقاط بالكاميرا",
  T_46_META_WS_C_CAMERARAYCASTUI: "واجهة RayCast للكاميرا",
  T_46_META_WS_C_CAMERATRANSITIONTYPE: "نوع نوع انتقال الكاميرا",
  T_46_META_WS_C_CAMERATYPE: "نوع الكاميرا",
  T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE: "نوع تقييد زاوية رؤية الكاميرا",
  T_46_META_WS_C_CAPSULETRIGGER: "زناد كبسولة",
  T_46_META_WS_C_CAR: "سيارة",
  T_46_META_WS_C_CHARACTERCONTROLLER: "وحدة التحكم في الشخصية",
  T_46_META_WS_C_CHATCHANNEL: "قناة الدردشة",
  T_46_META_WS_C_CHATCHANNELTYPE: "نوع قناة الدردشة",
  T_46_META_WS_C_CHECKPOINTTRIGGER: "مشغل نقطة التحقق",
  T_46_META_WS_C_COINGENERATOR: "مولد عملات",
  T_46_META_WS_C_COLLECTIONID: "معرف المجموعة",
  T_46_META_WS_C_COLLIDER: "جهاز التصادم",
  T_46_META_WS_C_COLLIDERCOLLECTION: "شكل الاصطدام",
  T_46_META_WS_C_COLLIDERCOLLECTIONID: "معرف مجموعة الاصطدامات",
  T_46_META_WS_C_COLORDRUM: "برميل الألوان",
  T_46_META_WS_C_COMBATABLE: "قابل قتال",
  T_46_META_WS_C_COMPONENT: "مكون",
  T_46_META_WS_C_CONDITION: "شرط",
  T_46_META_WS_C_CONTAINER: "حاوية",
  T_46_META_WS_C_COORDINATESYSTEMTYPE: "نوع نظام الإحداثيات",
  T_46_META_WS_C_CROSSBOW: "قاذف القنابل القوسية",
  T_46_META_WS_C_CSVID: "معرف CSV",
  T_46_META_WS_C_CUSTOMIZETRIGGER: "المشغل القابل للتخصيص",
  T_46_META_WS_C_CUSTOMLEVELOBJECT: "عنصر مخصص",
  T_46_META_WS_C_CUSTOMPATH: "المسار المخصص",
  T_46_META_WS_C_CUSTOMUI: "واجهة المستخدم المخصصة",
  T_46_META_WS_C_CUSTOMUIID: "معرف واجهة المستخدم المخصصة",
  T_46_META_WS_C_CUSTOMUIORWIDGET: "واجهة المستخدم المخصصة أو أداة",
  T_46_META_WS_C_CUSTOMUIWIDGETID: "معرف أداة واجهة المستخدم المخصصة",
  T_46_META_WS_C_DAMAGEDBODYPARTTYPE: "نوع الجزء التالف من الجسم",
  T_46_META_WS_C_DAMAGETYPE: "نوع الضرر",
  T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER: "مشغل الموت أو الحصانة",
  T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT: "عنصر قابل للتدمير",
  T_46_META_WS_C_DICE: "نرد",
  T_46_META_WS_C_DOUBLEJUMPSHOES: "حذاء القفز المزدوج",
  T_46_META_WS_C_DRUMMUSIC: "موسيقى الطبل",
  T_46_META_WS_C_DUALWIELDWEAPONTYPE: "نوع الأسلحة المزدوجة",
  T_46_META_WS_C_DUMMYLEVELOBJECT: "عنصر مستوى عام",
  T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE: "نوع العنصر القابل للتكوين الديناميكي",
  T_46_META_WS_C_DYNAMICFENCE: "السياج الديناميكي",
  T_46_META_WS_C_EFFECT: "تأثير",
  T_46_META_WS_C_EFFECTCONTAINER: "حاوية التأثير",
  T_46_META_WS_C_EFFECTID: "معرف التأثير",
  T_46_META_WS_C_EMOTETYPE: "نوع الرقصة",
  T_46_META_WS_C_ENDPOINTTRIGGER: "مشغل النقطة النهائية",
  T_46_META_WS_C_ENTITY: "كيان",
  T_46_META_WS_C_ENTITYORPREFABID: "الكيان أو معرف Prefab",
  T_46_META_WS_C_EQUIPMENTATTACHMENT: "ملحقات المعدات",
  T_46_META_WS_C_EQUIPMENTSLOTTYPE: "نوع فتحة المعدات",
  T_46_META_WS_C_EQUIPMENTTYPE: "نوع المعدات",
  T_46_META_WS_C_EVENTID: "معرف الحدث",
  T_46_META_WS_C_FACTION: "فصيل",
  T_46_META_WS_C_FILLDIRECTIONTYPE: "نوع اتجاه التعبئة",
  T_46_META_WS_C_FILLTYPE: "نوع التعبئة",
  T_46_META_WS_C_FIRETYPE: "نوع النار",
  T_46_META_WS_C_FLOAT: "عدد عشري",
  T_46_META_WS_C_FOLDWING: "جناحي الطي",
  T_46_META_WS_C_FOLLOW: "متابعة",
  T_46_META_WS_C_FONTTYPE: "نوع نوع الخط",
  T_46_META_WS_C_FOOTBALL: "كرة القدم",
  T_46_META_WS_C_FORCETYPE: "نوع القوة",
  T_46_META_WS_C_FORMULABLE: "قابل صياغة",
  T_46_META_WS_C_FRAMESELFRELATIVE: "حركة ذاتية لكل إطار",
  T_46_META_WS_C_GAMERESULTTYPE: "نوع نتيجة اللعبة",
  T_46_META_WS_C_GENDERTYPE: "نوع الجنس",
  T_46_META_WS_C_GENERALSPAWNPOINT: "نقطة ظهور عامة",
  T_46_META_WS_C_GRENADEDEICEWALL: "قنبلة DeIce Wall",
  T_46_META_WS_C_GRENADEFLASHBANG: "قنبلة الفلاش",
  T_46_META_WS_C_GRENADEFROZEN: "قنبلة التجميد",
  T_46_META_WS_C_GRENADELAUNCHER: "قاذفة القنابل",
  T_46_META_WS_C_GRENADESMOKE: "قنبلة الدخان",
  T_46_META_WS_C_GRENADEWEAPON: "قاعدة القنبلة اليدوية",
  T_46_META_WS_C_GRID: "شبكة",
  T_46_META_WS_C_HANDCANNON: "قنبلة اليد بالمدفع",
  T_46_META_WS_C_HELMET: "خوذة",
  T_46_META_WS_C_HIERARCHICAL: "هرمية",
  T_46_META_WS_C_HOOKGUN: "مسدس الخطاف",
  T_46_META_WS_C_HORIZALINE: "الخط الأفقي",
  T_46_META_WS_C_HUDTRANSFORM_DEPRECATED: "تحويل واجهة المستخدم",
  T_46_META_WS_C_HUMANMODELID: "معرف النموذج البشري",
  T_46_META_WS_C_ICEWALL: "جدار الثلج",
  T_46_META_WS_C_ICEWALLCREATED: "الجدار الجليدي الذي تم إنشاؤه",
  T_46_META_WS_C_ICEWALLMAKER: "صانع جدار الثلج",
  T_46_META_WS_C_ICON: "الكيان الرمزي",
  T_46_META_WS_C_ICONTYPE: "نوع الأيقونة",
  T_46_META_WS_C_INHALER: "جهاز الاستنشاق",
  T_46_META_WS_C_INT: "عدد صحيح",
  T_46_META_WS_C_INT64: "عدد صحيح 64 بت",
  T_46_META_WS_C_INTEGERMAPTEMPLATE: "قالب خريطة الأعداد الصحيحة",
  T_46_META_WS_C_INTORINTLIST: "عدد صحيح أو قائمة من الأعداد الصحيحة",
  T_46_META_WS_C_INVENTORYTYPE: "نوع المخزون",
  T_46_META_WS_C_ITEMBASE: "قاعدة البيانات",
  T_46_META_WS_C_ITEMCONTAINER: "حاوية العناصر",
  T_46_META_WS_C_ITEMID: "معرف العنصر",
  T_46_META_WS_C_ITEMIDTYPE: "نوع معرف العنصر",
  "T_46_META_WS_C_JERSEY STYLE": "نمط القميص",
  T_46_META_WS_C_JERSEYMACHINE: "ماكينة القمصان",
  T_46_META_WS_C_JETSHOES: "حذاء نفاث",
  T_46_META_WS_C_KEYBOARD: "لوحة مفاتيح",
  T_46_META_WS_C_KNOCKDOWNTYPE: "نوع النك أوف",
  T_46_META_WS_C_LANDMINE: "لغم",
  T_46_META_WS_C_LANDMINECREATED: "اللغم الذي تم إنشاؤه",
  "T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT": "كائن مستوى منصة الإطلاق",
  T_46_META_WS_C_LAUNCHPAD: "منصة الإطلاق",
  T_46_META_WS_C_LAYOUTSORTTYPE: "نوع فرز التخطيط",
  T_46_META_WS_C_LEAD1MUSIC: "موسيقى Lead1",
  T_46_META_WS_C_LEAD2MUSIC: "موسيقى Lead2",
  T_46_META_WS_C_LEAD3MUSIC: "موسيقى Lead3",
  T_46_META_WS_C_LEVELOBJECTID: "معرف كائن المستوى",
  T_46_META_WS_C_LEVELOBJECTTYPE: "نوع كائن المستوى",
  T_46_META_WS_C_LIST: "قائمة",
  T_46_META_WS_C_LISTORMAP: "قائمة أو خريطة",
  T_46_META_WS_C_LISTT: "قالب قائمة",
  T_46_META_WS_C_LISTT_BOOL: "قائمة القيم البوليانية",
  T_46_META_WS_C_LISTT_CONDITION: "قائمة الشروط",
  T_46_META_WS_C_LISTT_ENTITY: "قائمة الكيانات",
  T_46_META_WS_C_LISTT_FLOAT: "قائمة النقاط العائمة",
  T_46_META_WS_C_LISTT_INT: "قائمة الأعداد الصحيحة",
  T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE: "قائمة العناصر",
  T_46_META_WS_C_LISTT_LEVELOBJECT: "قائمة كائنات المستوى",
  T_46_META_WS_C_LISTT_LOCKEY: "قائمة مفاتيح التوطين",
  T_46_META_WS_C_LISTT_PLAYABLE: "قائمة العناصر القابلة للتشغيل",
  T_46_META_WS_C_LISTT_PLAYER: "قائمة اللاعبين",
  T_46_META_WS_C_LISTT_SKILLID: "قائمة معرف المهارات",
  T_46_META_WS_C_LISTT_SOUNDEFFECT: "قائمة تأثيرات الصوت",
  T_46_META_WS_C_LISTT_STRING: "قائمة السلاسل",
  T_46_META_WS_C_LISTT_TEAM: "قائمة الفرق",
  T_46_META_WS_C_LISTT_TYPE: "قائمة الأنواع",
  T_46_META_WS_C_LISTT_VECTOR3: "قائمة فكتور3",
  T_46_META_WS_C_LOCKEY: "مفتاح الترجمة",
  T_46_META_WS_C_LOOKAT: "نظر إلى",
  T_46_META_WS_C_LOOPABLE: "قابل التكرار",
  T_46_META_WS_C_LOOPTYPE: "نوع حلقة",
  T_46_META_WS_C_LOOTAMMOTYPE: "نوع ذخيرة الغنيمة",
  T_46_META_WS_C_LOOTARMOR: "درع غنيمة",
  T_46_META_WS_C_LOOTARMORTYPE: "نوع درع الغنيمة",
  T_46_META_WS_C_LOOTCONSUMABLE: "مستهلك غنيمة",
  T_46_META_WS_C_LOOTCONSUMABLETYPE: "نوع مستهلك الغنيمة",
  T_46_META_WS_C_LOOTIAMMO: "ذخيرة غنيمة",
  T_46_META_WS_C_LOOTITEMBOXSOCCER: "صندوق لوت كرة القدم",
  T_46_META_WS_C_LOOTSCOPE: "منظار غنيمة",
  T_46_META_WS_C_LOOTSCOPETYPE: "نوع منظار الغنيمة",
  T_46_META_WS_C_LOOTSOCCERTYPE: "نوع لوت كرة القدم",
  T_46_META_WS_C_LOOTTHROWABLE: "عنصر قابل للرمي غنيمة",
  T_46_META_WS_C_LOOTTHROWABLETYPE: "نوع عنصر قابل للرمي الغنيمة",
  T_46_META_WS_C_LOOTWEAPON: "سلاح غنيمة",
  T_46_META_WS_C_LOOTWEAPONTYPE: "نوع سلاح الغنيمة",
  T_46_META_WS_C_LOWGRAVITY: "منطقة جاذبية منخفضة",
  T_46_META_WS_C_MAP: "خريطة",
  T_46_META_WS_C_MAPT: "قالب خريطة",
  T_46_META_WS_C_MATERIALID: "معرف المادة",
  T_46_META_WS_C_MEDKIT: "حقيبة الإسعافات الأولية",
  T_46_META_WS_C_MESHID: "معرف الشبكة",
  T_46_META_WS_C_MIDGAMEEXITCONFIG: "إعداد الخروج أثناء اللعبة",
  T_46_META_WS_C_MINIMAP: "خريطة صغيرة",
  T_46_META_WS_C_MINIMAPICON: "رمز الخريطة الصغيرة",
  T_46_META_WS_C_MINIMAPPIXELRENDERER: "العارض البكسل للخريطة المصغرة",
  T_46_META_WS_C_MINISENTRY: "Mini Sentry",
  T_46_META_WS_C_MINISENTRYATTACKRANGETYPE: "نوع مدى هجوم Mini Sentry",
  T_46_META_WS_C_MINISENTRYCREATED: "Mini Sentry التي تم إنشاؤها",
  T_46_META_WS_C_MONEY: "نقود",
  T_46_META_WS_C_MONEYTYPE: "نوع النقود",
  T_46_META_WS_C_MONSTER: "وحش",
  T_46_META_WS_C_MONSTERSPAWN: "توليد الوحوش",
  T_46_META_WS_C_MONSTERTYPE: "نوع الوحش",
  T_46_META_WS_C_MORPHABLEOBJECT: "عنصر قابل للتحويل",
  T_46_META_WS_C_MORPHOBJECT: "عنصر تحول",
  T_46_META_WS_C_MOTOBIKE: "دراجة نارية",
  T_46_META_WS_C_MOVEPLATFORM: "المنصة المتحركة",
  T_46_META_WS_C_MOVEPLATFORMTYPE: "نوع المنصة المتحركة",
  T_46_META_WS_C_MUSHROOM: "فطر",
  T_46_META_WS_C_NATURALCONSTANTTYPE: "ثابت طبيعي",
  T_46_META_WS_C_NPC: "NPC",
  T_46_META_WS_C_NUMBER: "عدد",
  T_46_META_WS_C_OBJECT: "كائن",
  T_46_META_WS_C_OILDRUM: "برميل زيت",
  T_46_META_WS_C_OUTFITID: "معرف الزي",
  T_46_META_WS_C_OUTFITSLOTTYPE: "نوع فتحة الملابس",
  T_46_META_WS_C_PATHPOINT: "نقطة المسار",
  T_46_META_WS_C_PATROLSTYLETYPE: "نوع نمط الدورية",
  T_46_META_WS_C_PATROLTYPE: "نوع الدورية",
  T_46_META_WS_C_PERSONA: "شخصية",
  T_46_META_WS_C_PHASE: "مرحلة",
  T_46_META_WS_C_PHYSICALMOVER: "جهاز الحركة الفيزيائية",
  T_46_META_WS_C_PHYSICALOBJECT: "الكائن الفيزيائي",
  T_46_META_WS_C_PLATFORMTYPE: "نوع المنصة",
  T_46_META_WS_C_PLAYABLE: "قابل اللعب",
  T_46_META_WS_C_PLAYABLEORPLAYABLES: "قابل للتشغيل أو مجموعة قابلة للتشغيل",
  T_46_META_WS_C_PLAYER: "لاعب",
  T_46_META_WS_C_PLAYERBACKPACK: "حقيبة ظهر اللاعب",
  T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE: "نوع حالة سلوك اللاعب",
  T_46_META_WS_C_PLAYERBEHAVIORTYPE: "نوع سلوك اللاعب",
  T_46_META_WS_C_PLAYERCCT: "وحدة التحكم في الشخصية للاعب",
  T_46_META_WS_C_PLAYERDATAID: "نوع الشخصية المسبق تحديده",
  T_46_META_WS_C_PLAYERORTRANSFORM: "لاعب أو تحويل",
  T_46_META_WS_C_PLAYERORVEHICLE: "لاعب أو مركبة",
  T_46_META_WS_C_PLAYEROUTFIT: "زي اللاعب",
  T_46_META_WS_C_PLAYERPOSETYPE: "نوع وضع اللاعب",
  T_46_META_WS_C_PLAYERREVIVESOURCETYPE: "نوع مصدر إحياء اللاعب",
  T_46_META_WS_C_PLAYERSTATETYPE: "نوع حالة اللاعب",
  T_46_META_WS_C_POINTLIGHT: "ضوء نقطي",
  T_46_META_WS_C_PORTAL: "بوابة",
  T_46_META_WS_C_PREFABID: "معرف البريفاب",
  T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED: "مولد تأثير العرض",
  T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED: "نوع قماش التأثير",
  T_46_META_WS_C_PROFILEPICTUREWIDGET: "عنصر واجهة المستخدم لصورة الملف الشخصي",
  T_46_META_WS_C_PROPERTY: "خاصية",
  T_46_META_WS_C_PROPERTYFORMULA: "صيغة الخصائص",
  T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE: "نوع عامل صيغة الخصائص",
  T_46_META_WS_C_PROPERTYMODIFYTYPE: "نوع تعديل الخصائص",
  T_46_META_WS_C_QUATERNION: "الربعين",
  T_46_META_WS_C_RANKABLE: "قابل ترتيب",
  T_46_META_WS_C_RAYCASTLAYERTYPE: "نوع طبقة كاست الأشعة",
  T_46_META_WS_C_REPAIRKIT: "مجموعة الإصلاح",
  T_46_META_WS_C_RESETABLE: "قابل إعادة تعيين",
  T_46_META_WS_C_RIGIDBODY: "الجسم الصلب",
  T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE: "نوع تقييد الجسم الصلب",
  T_46_META_WS_C_RIGIDBODYTYPE: "نوع الجسم الصلب",
  T_46_META_WS_C_ROUND: "جولة",
  T_46_META_WS_C_SAFEZONE: "منطقة آمنة",
  T_46_META_WS_C_SCOREABLE: "قابل تقييم",
  T_46_META_WS_C_SCRIPTID: "معرف السكربت",
  T_46_META_WS_C_SEATTYPE: "نوع المقعد",
  T_46_META_WS_C_SELFRELATIVE: "ذاتي-مرتبطة",
  T_46_META_WS_C_SHOP: "متجر",
  T_46_META_WS_C_SHOPITEM: "عنصر متجر",
  T_46_META_WS_C_SHOPSHELF: "رف متجر",
  T_46_META_WS_C_SKATEBOARD: "لوح التزلج",
  T_46_META_WS_C_SKELETON: "هيكل عظمي",
  T_46_META_WS_C_SKELETONPART: "جزء الهيكل العظمي",
  T_46_META_WS_C_SKILLID: "معرف المهارة",
  T_46_META_WS_C_SKYBLASTER: "مدفع السماء",
  T_46_META_WS_C_SKYBOX: "صندوق السماء",
  T_46_META_WS_C_SKYBOXTYPE: "نوع السماء",
  T_46_META_WS_C_SOCIALISLANDSNOWBALL: "كرة الثلج في جزيرة اجتماعية",
  T_46_META_WS_C_SORTTYPE: "نوع الترتيب",
  T_46_META_WS_C_SOUNDDRUMTYPE: "نوع صوت الطبل",
  T_46_META_WS_C_SOUNDEFFECT: "تأثير الصوت",
  T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST: "تأثير الصوت أو قائمة تأثيرات الصوت",
  T_46_META_WS_C_SOUNDEFFECTTYPE: "نوع تأثير الصوت",
  T_46_META_WS_C_SOUNDLEAD1TYPE: "نوع صوت Lead1",
  T_46_META_WS_C_SOUNDLEAD2TYPE: "نوع صوت Lead2",
  T_46_META_WS_C_SOUNDLEAD3TYPE: "نوع صوت Lead3",
  T_46_META_WS_C_SOUNDPIANOTYPE: "نوع صوت البيانو",
  T_46_META_WS_C_SPAWN: "مولد",
  T_46_META_WS_C_SPAWNABLE: "قابل تفعيل",
  T_46_META_WS_C_SPAWNBOX: "منطقة الاستدعاء",
  T_46_META_WS_C_SPAWNPOSITION: "نقطة التوليد",
  T_46_META_WS_C_SPECIALITEMIDTYPE: "نوع معرف العنصر الخاص",
  T_46_META_WS_C_SPHERETRIGGER: "زناد كروي",
  T_46_META_WS_C_SPORTSCAR: "سيارة رياضية",
  T_46_META_WS_C_SPRAYCOLOR: "لون الرش",
  T_46_META_WS_C_SPRAYGUN: "رشاش",
  T_46_META_WS_C_SPRAYRESULTUI: "واجهة نتائج الرش",
  T_46_META_WS_C_SPRAYRIFLE: "رشاش بندقية",
  T_46_META_WS_C_SPRITEID: "معرف الصورة",
  T_46_META_WS_C_STATICSCRIPTID: "معرف السكربت الثابت",
  T_46_META_WS_C_STRING: "سلسلة",
  T_46_META_WS_C_STRINGORLOCSTRING: "سلسلة أو سلسلة محلية",
  T_46_META_WS_C_SUPPLYBOXTRIGGER: "مشغل صندوق الإمدادات",
  T_46_META_WS_C_SWINGGUN: "سلاح التأرجح",
  T_46_META_WS_C_SWITCHEQUIPSLOT: "التبديل بين فتحات المعدات",
  T_46_META_WS_C_TEAM: "فريق",
  T_46_META_WS_C_TERRAIN: "تضاريس",
  T_46_META_WS_C_TEXT: "الكيان النصي",
  T_46_META_WS_C_TEXTUREID: "معرف الملمس",
  T_46_META_WS_C_TEXTURETYPE: "قماش الكائن",
  T_46_META_WS_C_TIMER: "مؤقت",
  T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE: "نوع تنسيق الطابع الزمني",
  T_46_META_WS_C_TIMESTAMPLOCSTRING: "سلسلة توقيت الترجمة المحلية",
  T_46_META_WS_C_TRAJECTORY: "مسار",
  T_46_META_WS_C_TRANSFORM: "تحويل",
  T_46_META_WS_C_TUKTUK: "توك توك",
  T_46_META_WS_C_TURRET: "برج",
  T_46_META_WS_C_TWEEN: "Tween",
  T_46_META_WS_C_TWEENCURVE_DEPRECATED: "منحنى Tween",
  T_46_META_WS_C_TWEENSTYLE: "نوع نمط Tween",
  T_46_META_WS_C_TYPE: "نوع",
  T_46_META_WS_C_TYPEENUM: "نوع تعداد",
  T_46_META_WS_C_TYPEORTYPELIST: "نوع أو قائمة الأنواع",
  T_46_META_WS_C_UIADDSCORE: "واجهة المستخدم لإضافة النقاط",
  T_46_META_WS_C_UIANITRIGGERHUD: "HUD لمشغل الرسوم المتحركة",
  T_46_META_WS_C_UIBUILTINSWITCH: "مفتاح واجهة المستخدم المدمج",
  T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER: "وحدة تحكم واجهة المستخدم المدمجة",
  T_46_META_WS_C_UICARDSELECTIONPANEL: "شريط اختيار البطاقات",
  T_46_META_WS_C_UICHECKPOINTINDICATOR: "مؤشر نقطة التحقق",
  T_46_META_WS_C_UICOMPASS: "البوصلة لواجهة المستخدم",
  T_46_META_WS_C_UICOUNTDOWN5: "واجهة المستخدم للعد التنازلي لخمس ثوانٍ",
  T_46_META_WS_C_UICOUNTDOWNHINT: "واجهة المستخدم لتلميحات العد التنازلي",
  T_46_META_WS_C_UICOUNTDOWNREMINDER: "تذكير العد التنازلي",
  T_46_META_WS_C_UIFOLLOWHEADLTHBAR: "شريط الصحة فوق رأس الشخصية",
  T_46_META_WS_C_UIHEALTHBAR: "واجهة المستخدم لشريط الصحة",
  T_46_META_WS_C_UIHEARTBEAT: "نبضات القلب",
  T_46_META_WS_C_UIICONNOTIFICATION: "واجهة المستخدم لإشعار الأيقونة",
  T_46_META_WS_C_UIIDENTITYNOTIFICATION: "الإشعار بالهوية",
  T_46_META_WS_C_UIINTERACTIONBUTTON: "واجهة المستخدم لزر التفاعل",
  T_46_META_WS_C_UILEADERBOARDBUTTON: "واجهة المستخدم لزر لوحة المتصدرين",
  T_46_META_WS_C_UIMATCHSUBTITLE: "واجهة المستخدم للعناوين الفرعية للمباراة",
  T_46_META_WS_C_UIMONSTERLEVEL: "واجهة المستخدم لمستوى الوحش",
  T_46_META_WS_C_UIMONSTERUI: "مكون واجهة المستخدم للمؤثرات الخاصة بالوحوش",
  T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD: "لوحة المتصدرين لفرق متعددة",
  T_46_META_WS_C_UIMULTITEAMRESULTPANEL: "واجهة المستخدم للوحة نتائج الفرق المتعددة",
  T_46_META_WS_C_UIOPENINGBANNER: "راية البدء",
  T_46_META_WS_C_UIPANEL: "لوحة واجهة المستخدم",
  T_46_META_WS_C_UIPANELEMPTY: "لوحة فارغة",
  T_46_META_WS_C_UIPHASETIMER: "مؤقت المرحلة",
  T_46_META_WS_C_UIPROGRESSBAR: "شريط التقدم",
  T_46_META_WS_C_UIPROGRESSCIRCLE: "واجهة المستخدم لدائرة التقدم",
  T_46_META_WS_C_UIPROGRESSSKILLBUTTON: "زر تقدم المهارة",
  T_46_META_WS_C_UIREQUESTPURCHASETYPE: "نوع طلب الشراء",
  T_46_META_WS_C_UIROUNDINFOBANNER: "واجهة المستخدم لمعلومات الجولة",
  T_46_META_WS_C_UIROUNDNUMBER: "واجهة المستخدم لرقم الجولة",
  T_46_META_WS_C_UIROUNDRESULTBANNER: "راية نتائج الجولة",
  T_46_META_WS_C_UIROUNDSTARTBANNER: "راية بدء الجولة",
  T_46_META_WS_C_UIROUNDTRANSITION: "الانتقال بين الجولات",
  T_46_META_WS_C_UISCOREBAR: "شريط النقاط",
  T_46_META_WS_C_UISCROLLPANEL: "لوحة التمرير لواجهة المستخدم",
  T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER: "راية نقاط الجولة لفريق",
  T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER: "راية البدء البسيط للجولة",
  T_46_META_WS_C_UISIMPLETIP: "التلميحات البسيطة",
  T_46_META_WS_C_UISIMPLEVERSUSBANNER: "راية المواجهة البسيطة",
  T_46_META_WS_C_UISKILLBUTTON: "واجهة المستخدم لزر المهارات",
  T_46_META_WS_C_UISOCIALBUTTONWIDGET: "عنصر واجهة زر الوظائف الاجتماعية",
  T_46_META_WS_C_UISOLOLEADERBOARD: "واجهة المستخدم للوحة المتصدرين الفردية",
  T_46_META_WS_C_UISTORE: "واجهة المستخدم للمتجر",
  T_46_META_WS_C_UITEAMMATCHINFO: "واجهة المستخدم لمعلومات مباراة الفريق",
  T_46_META_WS_C_UITEXTTIP: "التلميحات النصية",
  T_46_META_WS_C_UITIMERINFO: "معلومات المؤقت",
  T_46_META_WS_C_UITIPBUTTON: "زر التلميحات",
  T_46_META_WS_C_UITITLEBANNER: "راية العنوان",
  T_46_META_WS_C_UITWEENTIP: "التلميحات المتحركة",
  T_46_META_WS_C_UITWOTEAMBRIEFINFO: "المعلومات المختصرة لفريقين",
  T_46_META_WS_C_UITWOTEAMINFO: "مكون واجهة المستخدم لمعلومات المباراة لفريقين",
  T_46_META_WS_C_UITWOTEAMLEADERBOARD: "واجهة المستخدم للوحة المتصدرين لفريقين",
  T_46_META_WS_C_UITWOTEAMRESULTPANEL: "شريط نتائج الجولة لفريقين",
  T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER: "راية نقاط الجولة لفريقين",
  T_46_META_WS_C_UITWOTEAMSCOREPANEL: "لوحة نقاط الفريقين",
  T_46_META_WS_C_UIVERSUSBANNER: "راية المواجهة",
  T_46_META_WS_C_UIWIDGET: "أداة واجهة المستخدم",
  T_46_META_WS_C_UIWIDGETBUTTON: "زر واجهة المستخدم",
  T_46_META_WS_C_UIWIDGETCONTAINER: "حاوية واجهة المستخدم",
  T_46_META_WS_C_UIWIDGETEMPTY: "أداة واجهة المستخدم الفارغ",
  T_46_META_WS_C_UIWIDGETIMAGE: "صورة أداة واجهة المستخدم",
  T_46_META_WS_C_UIWIDGETINPUTLABLE: "أداة إدخال التسمية",
  T_46_META_WS_C_UIWIDGETJOYSTICK: "أداة جويستيك",
  T_46_META_WS_C_UIWIDGETLABEL: "تسمية أداة واجهة المستخدم",
  T_46_META_WS_C_UIWIDGETLAYOUT: "أداة التخطيط",
  T_46_META_WS_C_UIWIDGETPROFILE: "أداة الملف الشخصي",
  T_46_META_WS_C_UIWIDGETTEXTURE: "أداة النسيج",
  T_46_META_WS_C_UIWIDGETTOGGLE: "أداة التبديل",
  T_46_META_WS_C_UIWIDGETTOUCHPAD: "عنصر واجهة المستخدم للوحة اللمس",
  T_46_META_WS_C_UIWINORLOSEBANNER: "راية الفوز أو الخسارة",
  T_46_META_WS_C_UNITSPAWN: "توليد الوحدات",
  T_46_META_WS_C_UUID: "المعرف الفريد العالمي",
  T_46_META_WS_C_VAULTTRIGGER: "كائن منطق تسلق النافذة",
  T_46_META_WS_C_VECTOR2: "فكتور 2",
  T_46_META_WS_C_VECTOR3: "فكتور 3",
  T_46_META_WS_C_VEHICLE: "مركبة",
  T_46_META_WS_C_VEHICLEIDTYPE: "نوع معرّف المركبة",
  T_46_META_WS_C_VEHICLESKINID: "معرف غلاف المركبة",
  T_46_META_WS_C_VENDINGMACHINE: "ماكينة بيع",
  T_46_META_WS_C_VEST: "سترة",
  T_46_META_WS_C_VFXREPLACETEXTPRESENT: "كيان نسيج مؤثرات بصرية قابل للاستبدال",
  T_46_META_WS_C_VFXTEXTURE: "نسيج المؤثرات البصرية",
  T_46_META_WS_C_VISIBILITY: "الرؤية",
  T_46_META_WS_C_WALLET: "محفظة",
  T_46_META_WS_C_WALLETHUD: "واجهة محفظة",
  T_46_META_WS_C_WATERZONE: "منطقة ماء",
  T_46_META_WS_C_WAVECOUNTTYPE: "نوع عدد الموجات",
  T_46_META_WS_C_WAVEINTERVALTYPE: "نوع فترة الموجات",
  T_46_META_WS_C_WEAPON: "سلاح",
  T_46_META_WS_C_WEAPONGENERATOR: "مولد الأسلحة",
  T_46_META_WS_C_WEAPONSKINID: "معرف غلاف السلاح",
  T_46_META_WS_C_WEAPONTYPE: "نوع السلاح",
  T_46_META_WS_C_WIDGETTYPE: "نوع الواجهة",
  T_46_META_WS_C_ZIPLINE: "حبل زيب",
  T_46_META_WS_CAMERADIRECTION: "اتجاه الكاميرا",
  T_46_META_WS_CAMERAPOSITION: "موقع الكاميرا",
  T_46_META_WS_CAPSULECAST: "اختبار كبسولة",
  T_46_META_WS_CAPSULEOVERLAP: "تداخل كبسولة",
  T_46_META_WS_CEIL: "التقريب للأعلى",
  T_46_META_WS_CHATCHANNEL: "قناة الدردشة",
  T_46_META_WS_CHECKTRIGGERBYORDER: "الحصول على موقع ولادة عشوائي",
  T_46_META_WS_CLAMP: "التقييد",
  T_46_META_WS_CLEAR: "مسح",
  T_46_META_WS_CLEARALLCHILDREN: "مسح جميع الأطفال",
  T_46_META_WS_CLEARAOISPECIALFOLLOW: "مسح متابعة خاصة بـ AOI",
  T_46_META_WS_CLEARBACKPACK: "مسح الحقيبة",
  T_46_META_WS_CLEARFORMULAPROPERTYFACTOR: "مسح عامل خاصية الصيغة",
  T_46_META_WS_CLEARRESIDUALLEVELOBJECTS: "مسح كائنات المستوى المتبقية",
  T_46_META_WS_CLIPNAME: "اسم المقطع",
  T_46_META_WS_CLONE: "استنساخ",
  T_46_META_WS_COLLIDEDENTITY: "كيان متصادم",
  T_46_META_WS_COLORGET: "ظل",
  T_46_META_WS_COMPLETECUSTOMMISSION: "إكمال المهمة المخصصة",
  T_46_META_WS_CONNECT: "اتصال",
  T_46_META_WS_CONSUMABLEID: "معرف العنصر",
  T_46_META_WS_CONTAIN: "إنشاء عنصر في المشهد",
  T_46_META_WS_CONTAINKEY: "احتواء المفتاح",
  T_46_META_WS_COPYTOMORPH: "نسخ إلى التحول",
  T_46_META_WS_COS: "جا",
  T_46_META_WS_COSTMONEY: "تكلفة المال",
  T_46_META_WS_COSTTOKEN: "استهلاك رمز",
  T_46_META_WS_CREATEAIRDROP: "إنشاء صندوق إسقاط جوي",
  T_46_META_WS_CREATEBOT: "إنشاء بوت",
  T_46_META_WS_CREATEBUILTINUI: "إنشاء واجهة مستخدم المضمنة",
  T_46_META_WS_CREATEBUILTINUICLIENT: "إنشاء واجهة مستخدم المضمنة",
  T_46_META_WS_CREATECAMERA: "إنشاء كاميرا",
  T_46_META_WS_CREATECURVE: "إنشاء منحنى",
  T_46_META_WS_CREATECUSTOMUI: "إنشاء واجهة المستخدم المخصصة",
  T_46_META_WS_CREATECUSTOMUICLIENT: "إنشاء واجهة مستخدم مخصصة",
  T_46_META_WS_CREATECUSTOMUIWIDGET: "إنشاء أداة واجهة المستخدم المخصصة",
  T_46_META_WS_CREATEDAMAGENUM: "إنشاء رقم الضرر",
  T_46_META_WS_CREATEEFFECT: "إنشاء تأثير",
  T_46_META_WS_CREATEEFFECTCLIENT: "إنشاء تأثير",
  T_46_META_WS_CREATEFACTION: "إنشاء فصيل",
  T_46_META_WS_CREATEFOLLOW: "إنشاء متابعة",
  T_46_META_WS_CREATEFRAMESELFRELATIVE: "إنشاء علاقة ذاتية لكل إطار",
  T_46_META_WS_CREATEFROMPREFAB: "إنشاء من نموذج أولي",
  T_46_META_WS_CREATELEVELOBJECT: "إنشاء كائن مستوى",
  T_46_META_WS_CREATELOOKAT: "إنشاء نظر إلى",
  T_46_META_WS_CREATEMINIMAPICON: "إنشاء رمز مصغر للخريطة",
  T_46_META_WS_CREATEMINIMAPPIXEL: "إنشاء بكسل مصغر للخريطة",
  T_46_META_WS_CREATEMONSTER: "إنشاء وحش",
  T_46_META_WS_CREATEMORPH: "إنشاء تحول",
  T_46_META_WS_CREATESELFRELATIVE: "إنشاء علاقة ذاتية",
  T_46_META_WS_CREATESHOP: "إنشاء متجر",
  T_46_META_WS_CREATESHOPITEM: "إنشاء عنصر متجر",
  T_46_META_WS_CREATESHOPSHELF: "إنشاء رف المتجر",
  T_46_META_WS_CREATESOUND: "إنشاء صوت",
  T_46_META_WS_CREATESOUNDCLIENT: "إنشاء صوت",
  T_46_META_WS_CREATETOKENINSCENE: "إنشاء رمز في المشهد",
  T_46_META_WS_CREATETRAJECTORY: "إنشاء مسار حركة",
  T_46_META_WS_CREATETWEEN: "إنشاء انتقال",
  T_46_META_WS_CREATEWALLET: "إنشاء محفظة",
  T_46_META_WS_CROSS: "النقطة",
  T_46_META_WS_CSVCOLUMNNAMETOINT: "تحويل اسم عمود CSV إلى عدد صحيح",
  T_46_META_WS_CURRENTAMMOCOUNT: "عدد الطلقات الحالي",
  T_46_META_WS_DAMAGE: "ضرر",
  T_46_META_WS_DAMAGEDBODYPART: "جزء الجسم المتضرر",
  T_46_META_WS_DAMAGEDPLAYERS: "اللاعبون المتضررون",
  T_46_META_WS_DAMAGETYPE: "نوع الضرر",
  T_46_META_WS_DEALDAMAGE: "تطور الزومبي المصاب",
  T_46_META_WS_DELETE: "حذف",
  T_46_META_WS_DELETEAT: "حذف عند",
  T_46_META_WS_DELETECUSTOMUI: "إزالة واجهة المستخدم مخصصة",
  T_46_META_WS_DELETEFROMDATABASE: "حذف من قاعدة البيانات",
  T_46_META_WS_DELETEFROMDATASTORE: "حذف من قاعدة البيانات",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY: "حذف من قاعدة بيانات لوحة الصدارة حسب المفتاح",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK: "حذف من قاعدة بيانات لوحة الصدارة حسب الترتيب",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY: "حذف من قاعدة بيانات لوحة المتصدرين حسب المفتاح",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK: "حذف من قاعدة بيانات لوحة المتصدرين حسب الترتيب",
  T_46_META_WS_DELETETAG: "حذف علامة",
  T_46_META_WS_DELTA: "دلتا",
  T_46_META_WS_DESTROY: "تدمير",
  T_46_META_WS_DESTROYBOT: "تدمير بوت",
  T_46_META_WS_DESTROYBUILTINUI: "تدمير واجهة المستخدم المضمنة",
  T_46_META_WS_DESTROYEQUIPMENT: "تدمير المعدات",
  T_46_META_WS_DESTROYITEM: "إضافة HP",
  T_46_META_WS_DIRECTIONTOEULERANGLE: "الاتجاه إلى زاوية أويلر",
  T_46_META_WS_DISABLESAFEZONE: "تعطيل منطقة الأمان",
  T_46_META_WS_DISPATCHEVENT: "إرسال حدث",
  T_46_META_WS_DISPATCHEVENTWITHPLATFORM: "إرسال حدث مع المنصة",
  T_46_META_WS_DISTANCE: "الحجم",
  T_46_META_WS_DOT: "الدوران",
  T_46_META_WS_DROPITEM: "إلقاء العنصر",
  T_46_META_WS_DYEATAREA: "صب على المنطقة",
  T_46_META_WS_DYEATPLANE: "صب على الطائرة",
  T_46_META_WS_DYEATPOSITION: "صب في الموقع",
  T_46_META_WS_E_ABNORMALGRAVZONE: "منطقة الجاذبية المنخفضة",
  T_46_META_WS_E_AC80: "AC80",
  T_46_META_WS_E_ACCELERATION: "تسارع",
  T_46_META_WS_E_ACTIONNODE: "عقدةالفعل",
  T_46_META_WS_E_ACTIVE: "نشط",
  T_46_META_WS_E_ACTIVESKILL: "مهارة نشطة",
  T_46_META_WS_E_ADBOARD: "لافتات إعلانات",
  T_46_META_WS_E_ADD: "أضف",
  T_46_META_WS_E_ADDFRIEND: "إضافة صديق",
  T_46_META_WS_E_AGENCYFB: "AgencyFB",
  T_46_META_WS_E_AIM: "تصويب",
  T_46_META_WS_E_AIR: "هواء",
  T_46_META_WS_E_AIRCONDITIONERA: "مكيف الهواء",
  T_46_META_WS_E_AIRDROP: "إنزال جوي، انتحار زومبي",
  T_46_META_WS_E_AK: "AK",
  T_46_META_WS_E_AK2: "AK2",
  T_46_META_WS_E_ALIVE: "حي",
  T_46_META_WS_E_AMMO: "تأثيرات الرصاص",
  T_46_META_WS_E_AMPHIBIANCAR: "مركبة برمائية",
  T_46_META_WS_E_AN94: "AN94",
  T_46_META_WS_E_APPARITION: "الأطفال يلعبون",
  T_46_META_WS_E_AR: "بندوق",
  T_46_META_WS_E_AR15: "AR15",
  T_46_META_WS_E_ARAMMO: "ذخيرة AR",
  T_46_META_WS_E_ARMAGAZINE: "ذخيرة AR",
  T_46_META_WS_E_ARMOR: "درع",
  T_46_META_WS_E_ARMORBUFF: "بوف الدروع",
  T_46_META_WS_E_ARMORLV1: "درع Lv1",
  T_46_META_WS_E_ARMORLV2: "درع Lv2",
  T_46_META_WS_E_ARMORLV3: "درع Lv3",
  T_46_META_WS_E_ARMORPIERCING: "تدمير درع",
  T_46_META_WS_E_ARMORSPECIALIST: "مهارة 1",
  T_46_META_WS_E_ARROW: "سهم",
  T_46_META_WS_E_ASC: "ترتيب تصاعدي",
  T_46_META_WS_E_ASCIGNOREZERO: "ترتيب تصاعدي بدون أصفار",
  T_46_META_WS_E_ATMOSPHEREEXPLOSION: "انفجار غاز",
  T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY: "ملحق1 للتوافق",
  T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY: "ملحق4 للتوافق",
  T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY: "ملحق5 للتوافق",
  T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY: "ملحق6 للتوافق",
  T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY: "ملحق8 للتوافق",
  T_46_META_WS_E_ATTACK: "هجوم",
  T_46_META_WS_E_ATTACKGRENADE: "قنبلة هجومية",
  T_46_META_WS_E_AUG: "AUG",
  T_46_META_WS_E_AUTO: "تلقائي",
  T_46_META_WS_E_AWM: "AWM",
  T_46_META_WS_E_AWM2: "AWM2",
  T_46_META_WS_E_BACK: "العودة",
  T_46_META_WS_E_BACKANDFORTH: "ذهاب وإياب",
  T_46_META_WS_E_BAG: "حقيبة",
  T_46_META_WS_E_BAG1: "حقيبة1",
  T_46_META_WS_E_BAG2: "حقيبة2",
  T_46_META_WS_E_BAG3: "حقيبة3",
  T_46_META_WS_E_BAMBOOA: "خيزران A",
  T_46_META_WS_E_BANANATREE: "شجرة الموز",
  T_46_META_WS_E_BASEBALLPOLE: "عمود البيسبول",
  T_46_META_WS_E_BASECOEFFICIENT: "معامل أساسي",
  T_46_META_WS_E_BASIC: "أساسي",
  T_46_META_WS_E_BASICCONE: "مخروط أساسي",
  T_46_META_WS_E_BASICCYLINDER: "أسطوانة أساسية",
  T_46_META_WS_E_BASICSPHERE: "Bola dasar",
  T_46_META_WS_E_BATTLEINSTYLE: "قتال بأسلوب",
  T_46_META_WS_E_BELL: "جرس",
  T_46_META_WS_E_BENCH: "مقعد",
  T_46_META_WS_E_BIGHEADHAMMER: "مطرقة كبيرة",
  T_46_META_WS_E_BILLBOARD: "شاشة كبيرة",
  T_46_META_WS_E_BIPOD: "ثنائي القوائم",
  T_46_META_WS_E_BISGRAFFITIWALL: "جدار موضوع BIS",
  T_46_META_WS_E_BIZON: "Bizon",
  T_46_META_WS_E_BLACKHOLE: "تأثيرات الانفجار الثقب الأسود",
  T_46_META_WS_E_BLACKHOLEBOOM: "تأثيرات كرة الكريستال",
  T_46_META_WS_E_BLAST: "انفجار",
  T_46_META_WS_E_BLOCK: "مربع",
  T_46_META_WS_E_BLOODBALL: "تأثير الثقب الأسود",
  T_46_META_WS_E_BLT: "BLT",
  T_46_META_WS_E_BLT2: "BLT2",
  T_46_META_WS_E_BLUE: "أزرق",
  T_46_META_WS_E_BLUEDOLL: "دمية الثلج",
  T_46_META_WS_E_BOARD: "منصة متحركة",
  T_46_META_WS_E_BODY: "جسم",
  T_46_META_WS_E_BOMBINDICATION: "تحذير قنبلة",
  T_46_META_WS_E_BOMBPLIERS: "كماشة القنابل",
  T_46_META_WS_E_BONFIRE: "نار المخيم المشتعلة",
  T_46_META_WS_E_BOOM: "انفجار",
  T_46_META_WS_E_BOOYAH: "انتصار",
  T_46_META_WS_E_BOTH: "كلاهما",
  T_46_META_WS_E_BOUNCETIRE: "إطار",
  T_46_META_WS_E_BOWAMMO: "ذخيرة قوس",
  T_46_META_WS_E_BREAKABLEBOX: "صندوق خشبي قابل للتدمير",
  T_46_META_WS_E_BREAKABLECONTAINER: "حاوية قابلة للتدمير",
  T_46_META_WS_E_BREAKABLEFENCE: "سياج قابل للتدمير",
  T_46_META_WS_E_BRICKA: "طوبة A",
  T_46_META_WS_E_BRICKB: "طوبة B",
  T_46_META_WS_E_BRICKC: "طوبة C",
  T_46_META_WS_E_BRICKHOUSEA: "منزل صغير A",
  T_46_META_WS_E_BRIGHT: "فاتح",
  T_46_META_WS_E_BUBBLE: "فقاعة",
  T_46_META_WS_E_BUFFGENERATOR: "مولد البوف",
  T_46_META_WS_E_BULLETBUFF: "بوف الرصاص",
  T_46_META_WS_E_BULLETHITTING: "إصابة الرصاص",
  T_46_META_WS_E_BUMPERCAR: "سيارة التصادم",
  T_46_META_WS_E_BUMPERCARFACTORY: "مصنع سيارات الاصطدام",
  T_46_META_WS_E_BURNING: "ضرر الحرق عند انفجار المركبة",
  T_46_META_WS_E_BUSHES: "شجيرات",
  T_46_META_WS_E_BUSSTOP: "محطة حافلات",
  T_46_META_WS_E_BUTTOM: "الملابس السفلية",
  T_46_META_WS_E_BUTTONWIDGET: "زر العنصر",
  T_46_META_WS_E_BYHIERARCHY: "حسب التسلسل",
  T_46_META_WS_E_CABINET: "خزانة",
  T_46_META_WS_E_CACTUS: "صبار",
  T_46_META_WS_E_CAMOUFLAGE: "مهارة 6",
  T_46_META_WS_E_CAPSULETRIGGER: "مشغل الكبسولة",
  T_46_META_WS_E_CARDIOTONIC: "مقوٍّ للقلب",
  T_46_META_WS_E_CASUALGAMEBGM: "موسيقى خلفية للعبة ترفيهية",
  T_46_META_WS_E_CEMENTA: "أسمنت A",
  T_46_META_WS_E_CG15: "CG15",
  T_46_META_WS_E_CHANNELA: "قناة A",
  T_46_META_WS_E_CHANNELB: "قناة B",
  T_46_META_WS_E_CHANNELC: "قناة C",
  T_46_META_WS_E_CHANNELD: "قناة D",
  T_46_META_WS_E_CHANNELE: "قناة E",
  T_46_META_WS_E_CHANNELF: "قناة F",
  T_46_META_WS_E_CHARACTERSKILL: "مهارة الشخصية",
  T_46_META_WS_E_CHARACTOR: "شخصية",
  T_46_META_WS_E_CHARGE: "شحن 1",
  T_46_META_WS_E_CHARGEBUSTER: "ChargeBuster",
  T_46_META_WS_E_CHECKPOINT: "نقطة تفتيش",
  T_46_META_WS_E_CHEER: "تشجيع",
  T_46_META_WS_E_CHERRYBLOSSOM: "شجرة الكرز",
  T_46_META_WS_E_CIRCLE: "دائرة",
  T_46_META_WS_E_CIRCLEBACK: "حلقة",
  T_46_META_WS_E_CIRCLEOFHEAT: "شعاع قدم",
  T_46_META_WS_E_CITY: "مدينة",
  T_46_META_WS_E_CLAPS: "تصفيق",
  T_46_META_WS_E_CLEAR: "مسح",
  T_46_META_WS_E_CLIENT: "عميل",
  T_46_META_WS_E_CLONE: "مغير المظهر",
  T_46_META_WS_E_CLONEKILL: "موت النسخ",
  T_46_META_WS_E_CLOSE: "إغلاق",
  T_46_META_WS_E_CLOTHES: "ملابس",
  T_46_META_WS_E_COINGENERATOR: "مولد الذهب",
  T_46_META_WS_E_COLDAIR: "ضباب",
  T_46_META_WS_E_COLORBLOCK: "كتلة مصبوغة",
  T_46_META_WS_E_COLOROILBARREL: "برميل مدهون",
  T_46_META_WS_E_COMBINEALL: "دمج الكل",
  T_46_META_WS_E_COMBINESELF: "دمج مع الذات",
  T_46_META_WS_E_COMBOKEYA1: "ملاحظات موسيقية - سنتيساير A",
  T_46_META_WS_E_COMBOKEYA2: "ملاحظات موسيقية - سنتيساير A",
  T_46_META_WS_E_COMBOKEYB1: "ملاحظات موسيقية - سنتيساير B",
  T_46_META_WS_E_COMBOKEYB2: "ملاحظات موسيقية - سنتيساير B",
  T_46_META_WS_E_COMBOKEYC1: "ملاحظات موسيقية - سنتيساير C",
  T_46_META_WS_E_COMBOKEYC2: "ملاحظات موسيقية - سنتيساير C",
  T_46_META_WS_E_CONCRETEPILLAR: "عمود خرساني",
  T_46_META_WS_E_CONDITIONNODE: "عقدةالشرط",
  T_46_META_WS_E_CONTAINERA: "حاوية A",
  T_46_META_WS_E_CONTAINERB: "حاوية شحن ب",
  T_46_META_WS_E_CONTAINERC: "حاوية شحن ج",
  T_46_META_WS_E_CONTAINERWIDGET: "أداة الحاوية",
  T_46_META_WS_E_CONTINUOUS: "مستمر",
  T_46_META_WS_E_COUNTDOWN: "عد تنازلي",
  T_46_META_WS_E_COUNTDOWNDENGDENG: "العد التنازلي",
  T_46_META_WS_E_COUNTDOWNDIDI: "صافرة العد التنازلي",
  T_46_META_WS_E_COUNTDOWNMECHANICAL: "العد التنازلي",
  T_46_META_WS_E_COUNTDOWNWITHINGAME: "العد التنازلي 3",
  T_46_META_WS_E_CROSS: "صليب",
  T_46_META_WS_E_CROSSBOW: "قوس السهم",
  T_46_META_WS_E_CROSSHAIR: "نقطة استهداف",
  T_46_META_WS_E_CROSSHAIRS: "تقاطع الهدف",
  T_46_META_WS_E_CROUCH: "القرفصاء",
  T_46_META_WS_E_CROUCHING: "جلوس",
  T_46_META_WS_E_CROWCAW: "صرخات الغربان",
  T_46_META_WS_E_CROWN: "تاج",
  T_46_META_WS_E_CUBE: "آلية الكتلة",
  T_46_META_WS_E_CURSE: "تعويذة",
  T_46_META_WS_E_CURSEEXPLOSION: "انفجار تعويذة",
  T_46_META_WS_E_CUSTOM: "كاميرا مخصصة",
  T_46_META_WS_E_CUSTOMTRIGGER: "مشغل مخصص",
  T_46_META_WS_E_CUSTOMWATERZONE: "الجسم المائي المخصص",
  T_46_META_WS_E_CYCLICCOMBUSTION: "احتراق مستمر",
  T_46_META_WS_E_CYLIC: "دوري",
  T_46_META_WS_E_DAGGER: "سكين رمي",
  T_46_META_WS_E_DAMAGEDTRUCK: "شاحنة تالفة",
  T_46_META_WS_E_DAMAGEZONE: "منطقة ضرر",
  T_46_META_WS_E_DANGERALARM: "خطر 2",
  T_46_META_WS_E_DANGERVIBRATING: "خطر 1",
  T_46_META_WS_E_DARK: "داكن",
  T_46_META_WS_E_DARKNESS: "ظلام",
  T_46_META_WS_E_DASHATTACK: "هجوم الاندفاع",
  T_46_META_WS_E_DATASTORAGELIMITEXCEEDED: "تجاوز حد تخزين البيانات",
  T_46_META_WS_E_DATASTORAGEPARAMETERERROR: "خطأ في معلمة تخزين البيانات",
  T_46_META_WS_E_DATASTORAGETIMEOUT: "مهلة تخزين البيانات",
  T_46_META_WS_E_DATETIME: "التاريخ والوقت",
  T_46_META_WS_E_DAY: "نهار",
  T_46_META_WS_E_DEAD: "ميت",
  T_46_META_WS_E_DEATH: "ميت",
  T_46_META_WS_E_DEFAULT: "افتراضي",
  T_46_META_WS_E_DEFAULTFIST: "قبضة",
  T_46_META_WS_E_DEFENCEGRENADE: "قنبلة دفاعية",
  T_46_META_WS_E_DESC: "ترتيب تنازلي",
  T_46_META_WS_E_DIALOGUE: "حوار",
  T_46_META_WS_E_DIAMOND: "جوهرة",
  T_46_META_WS_E_DIRECTIONSIGN: "لافتة",
  T_46_META_WS_E_DIRVEVEHICLE: "قيادة المركبة",
  T_46_META_WS_E_DISABLE: "تعطيل",
  T_46_META_WS_E_DISABLED: "معاق",
  T_46_META_WS_E_DISAPPEARNOTIFICATION: "تنبيه اختفاء",
  T_46_META_WS_E_DISCONNECT: "فصل الاتصال",
  T_46_META_WS_E_DISGUISE: "نسخة",
  T_46_META_WS_E_DOGHOUSE: "بيت الكلب",
  T_46_META_WS_E_DOOR: "باب",
  T_46_META_WS_E_DOUBLE: "مزدوج",
  T_46_META_WS_E_DOUBLEDOOR: "باب مزدوج",
  T_46_META_WS_E_DOUBLEJUMPSHOE: "حذاء قفزة مزدوجة",
  T_46_META_WS_E_DOUBLEMAGEZINE: "مخزن مزدوج",
  T_46_META_WS_E_DRAW: "تعادل",
  T_46_META_WS_E_DRILLZOMBIE: "زومبي الحفار",
  T_46_META_WS_E_DRIVE: "قيادة",
  T_46_META_WS_E_DRIVER: "سائق",
  T_46_META_WS_E_DROPBEAT: "مهارة 4",
  T_46_META_WS_E_DRUMKEY1: "ملاحظات موسيقية - طبل",
  T_46_META_WS_E_DRUMKEY2: "ملاحظات موسيقية - طبل",
  T_46_META_WS_E_DUEL: "معركة",
  T_46_META_WS_E_DUMMY: "دمية",
  T_46_META_WS_E_DUMMYGRENADE: "قنبلة وهمية",
  T_46_META_WS_E_DUMP: "مخلفات",
  T_46_META_WS_E_DUSK: "غروب",
  T_46_META_WS_E_DUST: "دخان وغبار",
  T_46_META_WS_E_DYNAMIC: "ديناميكي",
  T_46_META_WS_E_E: "الثابت الطبيعي",
  T_46_META_WS_E_EAGLE: "EAGLE",
  T_46_META_WS_E_EASY: "سهل",
  T_46_META_WS_E_ELECTRICSHOCK: "صدمة كهربائية",
  T_46_META_WS_E_ELECTRICSURFBOARD: "لوح تزلج كهربائي",
  T_46_META_WS_E_ELECTRICZONE: "منطقة كهربائية",
  T_46_META_WS_E_ELECTRONICBGM: "موسيقى خلفية خيالية إلكترونية لطيفة",
  T_46_META_WS_E_ELIMINATEDBOSS: "عزل قائد الرابطة",
  T_46_META_WS_E_ELIMINATIONNOTIFICATION: "تحذير القتل",
  T_46_META_WS_E_EMOTE: "رقصة",
  T_46_META_WS_E_ENABLE: "تفعيل",
  T_46_META_WS_E_ENERGETIC: "نشيط",
  T_46_META_WS_E_ENTERVEHICLE: "دخول المركبة",
  T_46_META_WS_E_EP: "الطاقة (EP)",
  T_46_META_WS_E_EXCLAMATIONMARK: "علامة تعجب",
  T_46_META_WS_E_EXIT: "خروج",
  T_46_META_WS_E_EXITVEHICLE: "خروج من المركبة",
  T_46_META_WS_E_EXPLODE: "تدمير ذاتي",
  T_46_META_WS_E_EXPLOSION: "تأثيرات الانفجار",
  T_46_META_WS_E_EXPLOSIVEBLAZE: "لهيب الانفجار",
  T_46_META_WS_E_EXPLOSIVEPAINTSKILL: "مهارة كرة الطاقة",
  T_46_META_WS_E_EXPLOSIVEZOMBIE: "زومبي المتفجر",
  T_46_META_WS_E_EYE: "نظارات",
  T_46_META_WS_E_FACEPAINT: "طلاء الوجه",
  T_46_META_WS_E_FACTION: "طائفة",
  T_46_META_WS_E_FALLING: "سقوط",
  T_46_META_WS_E_FALLINGSTAR: "الحصول على مستهلك",
  T_46_META_WS_E_FALSE: "لا",
  T_46_META_WS_E_FAMAS: "FAMAS",
  T_46_META_WS_E_FAN: "آلية المروحة",
  T_46_META_WS_E_FAR: "بعيد",
  T_46_META_WS_E_FEATHER: "ريشة",
  T_46_META_WS_E_FEMALE: "أنثى",
  T_46_META_WS_E_FENCE: "سياج",
  T_46_META_WS_E_FGL24: "FGL24",
  T_46_META_WS_E_FIGHTINGENTITY: "كيانالقتال",
  T_46_META_WS_E_FILLED: "ممتلئ",
  T_46_META_WS_E_FINISH: "إنهاء",
  T_46_META_WS_E_FINISHINGPOINT: "نقطة النهاية",
  T_46_META_WS_E_FINISHLINEARCH: "لافتة النهاية",
  T_46_META_WS_E_FIRE: "نار",
  T_46_META_WS_E_FIRECHARGE: "كرة نارية",
  T_46_META_WS_E_FIREWORK: "ألعاب نارية",
  T_46_META_WS_E_FIRINGEFFECT: "تأثيرات إطلاق النار",
  T_46_META_WS_E_FIRSTPERSON: "منظور الشخص الأول",
  T_46_META_WS_E_FIRSTPERSONCLASSIC: "منظور الشخص الأول الكلاسيكي",
  T_46_META_WS_E_FIST: "قبضة",
  T_46_META_WS_E_FIT: "يناسب",
  T_46_META_WS_E_FLAG: "علم",
  T_46_META_WS_E_FLAME: "نار",
  T_46_META_WS_E_FLAMEGUN: "مسدس اللهب",
  T_46_META_WS_E_FLAMETHROWER: "مسدس اللهب",
  T_46_META_WS_E_FLASH: "قنبلة مضيئة",
  T_46_META_WS_E_FLASHBANG: "قنبلة مضيئة",
  T_46_META_WS_E_FLASHBANGSPARKS: "دخان قنبلة فلاش",
  T_46_META_WS_E_FLASHFREEZE: "تجميد سريع",
  T_46_META_WS_E_FLEXWALL: "الجدار القابل للسحب",
  T_46_META_WS_E_FLICKER: "وميض",
  T_46_META_WS_E_FLOWER: "زهرة",
  T_46_META_WS_E_FLYBOMBBEE: "نحلة القنبلة الطائرة",
  T_46_META_WS_E_FLYPAN: "آلية المقلاة",
  T_46_META_WS_E_FLYSHOE: "حذاء طائر",
  T_46_META_WS_E_FOLDER: "مجلد",
  T_46_META_WS_E_FOLDWINGS: "أجنحة قابلة للطي",
  T_46_META_WS_E_FOODTRUCK: "شاحنة طعام",
  T_46_META_WS_E_FOODTRUCKB: "شاحنة طعام B",
  T_46_META_WS_E_FOOTBALL: "كرة القدم",
  T_46_META_WS_E_FOOTBALLGUN: "بندقية كرة القدم",
  T_46_META_WS_E_FOOTBALLICE: "كرة قدم جليدية",
  T_46_META_WS_E_FOOTBALLSHIELD: "FootballShield",
  T_46_META_WS_E_FOOTBALLSHOOTER: "رامي كرة القدم",
  T_46_META_WS_E_FORCE: "قوة",
  T_46_META_WS_E_FOREGRIP_MR: "مقبض أمامي MR",
  T_46_META_WS_E_FOREGRIP1: "مقبض أمامي1",
  T_46_META_WS_E_FOREGRIP2: "مقبض أمامي2",
  T_46_META_WS_E_FOREGRIP3: "مقبض أمامي3",
  T_46_META_WS_E_FORWARD: "تقدم للأمام",
  T_46_META_WS_E_FOUNTAIN: "نافورة",
  T_46_META_WS_E_FREE: "كاميرا حرة",
  T_46_META_WS_E_FREEZEALL: "تجميد الكل",
  T_46_META_WS_E_FREEZEPOSITION: "تجميد الموضع",
  T_46_META_WS_E_FREEZEPOSITIONX: "تجميد الموضع X",
  T_46_META_WS_E_FREEZEPOSITIONY: "تجميد الموضع Y",
  T_46_META_WS_E_FREEZEPOSITIONZ: "تجميد الموضع Z",
  T_46_META_WS_E_FREEZEROTATION: "تجميد التدوير",
  T_46_META_WS_E_FREEZEROTATIONX: "تجميد التدوير X",
  T_46_META_WS_E_FREEZEROTATIONY: "تجميد التدوير Y",
  T_46_META_WS_E_FREEZEROTATIONZ: "تجميد التدوير Z",
  T_46_META_WS_E_FREEZEZONE: "منطقة متجمدة",
  "T_46_META_WS_E_FROST GALAXY": "مجرة صقيعية",
  T_46_META_WS_E_FROZEN: "تجميد",
  T_46_META_WS_E_FROZENGRENADE: "قنبلة تجميد",
  T_46_META_WS_E_FUNCTIONALITEMS: "عناصر وظيفية",
  T_46_META_WS_E_FZLANTINGHEI: "FZLanTingHei",
  T_46_META_WS_E_G18: "G18",
  T_46_META_WS_E_G36: "G36",
  T_46_META_WS_E_GAME: "لعبة",
  T_46_META_WS_E_GAMEOVER: "انتهاء اللعبة 2",
  T_46_META_WS_E_GAMESTART: "بدء اللعبة",
  T_46_META_WS_E_GARAGE: "كراج",
  T_46_META_WS_E_GATLING: "Gatling",
  T_46_META_WS_E_GEARSWITCHEDON: "تفعيل الآلية",
  T_46_META_WS_E_GENTLETAP: "لمسة خفيفة",
  T_46_META_WS_E_GETITEM: "الحصول على مستهلك 2",
  T_46_META_WS_E_GFFLATIN: "GFFLatin",
  T_46_META_WS_E_GHOST: "شبح",
  T_46_META_WS_E_GIANTDICE: "نرد",
  T_46_META_WS_E_GIANTLOLLIPOP: "مصاصة عملاقة",
  T_46_META_WS_E_GIFT: "هدية",
  T_46_META_WS_E_GLOOWALL: "جدار لاصق",
  T_46_META_WS_E_GOLD_HEATGUN_I: "GOLD_HEATGUN_I",
  T_46_META_WS_E_GOLD_HEATGUN_II: "GOLD_HEATGUN_II",
  T_46_META_WS_E_GOLD_HEATGUN_III: "GOLD_HEATGUN_III",
  T_46_META_WS_E_GOLD_M1014_I: "GOLD_M1014_I",
  T_46_META_WS_E_GOLD_M1014_II: "M1014 الذهبي II",
  T_46_META_WS_E_GOLD_M1014_III: "M1014 الذهبي III",
  T_46_META_WS_E_GOLD_SCAR_I: "GOLD_SCAR_I",
  T_46_META_WS_E_GOLD_SCAR_II: "GOLD_SCAR_II",
  T_46_META_WS_E_GOLD_SCAR_III: "GOLD_SCAR_III",
  T_46_META_WS_E_GOLDAWM: "GoldAWM",
  T_46_META_WS_E_GOLDFAMAS_I: "فاماس الذهبي I",
  T_46_META_WS_E_GOLDFAMAS_II: "فاماس الذهبي II",
  T_46_META_WS_E_GOLDFAMAS_III: "فاماس الذهبي III",
  T_46_META_WS_E_GOLDGROZA: "جروزا الذهبي",
  T_46_META_WS_E_GOLDKAR98K_I: "GoldKar98K_I",
  T_46_META_WS_E_GOLDKAR98K_II: "GoldKar98K_II",
  T_46_META_WS_E_GOLDKAR98K_III: "GoldKar98K_III",
  T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION: "GoldKar98K_III_ForInfection",
  T_46_META_WS_E_GOLDM14_I: "M14 الذهبي I",
  T_46_META_WS_E_GOLDM14_II: "M14 الذهبي II",
  T_46_META_WS_E_GOLDM14_III: "M14 الذهبي III",
  T_46_META_WS_E_GOLDM14_III_FORINFECTION: "M14 الذهبي III للعدوى",
  T_46_META_WS_E_GOLDM4A1_I: "M4A1 الذهبي I",
  T_46_META_WS_E_GOLDM4A1_II: "M4A1 الذهبي II",
  T_46_META_WS_E_GOLDM4A1_III: "M4A1 الذهبي III",
  T_46_META_WS_E_GOLDM4A1_III_FORINFECTION: "M4A1 الذهبي III للعدوى",
  T_46_META_WS_E_GOLDM60_I: "M60 I الذهبي",
  T_46_META_WS_E_GOLDM60_II: "M60 II الذهبي",
  T_46_META_WS_E_GOLDM60_III: "M60 III الذهبي",
  T_46_META_WS_E_GOLDM60_III_FORINFECTION: "M60 III الذهبي للعدوى",
  T_46_META_WS_E_GOLDMP5_I: "MP5 الذهبي I",
  T_46_META_WS_E_GOLDMP5_II: "MP5 الذهبي II",
  T_46_META_WS_E_GOLDMP5_III: "MP5 الذهبي III",
  T_46_META_WS_E_GOLDMP5_III_FORINFECTION: "MP5 الذهبي III للعدوى",
  T_46_META_WS_E_GOLDSVD: "SVD الذهبي",
  T_46_META_WS_E_GOLDVSS_I: "GoldVSS_I",
  T_46_META_WS_E_GOLDVSS_II: "GoldVSS_II",
  T_46_META_WS_E_GOLDVSS_III: "GoldVSS_III",
  T_46_META_WS_E_GRAFFITIFLOWERBED: "فراش زهور موضوع BIS",
  T_46_META_WS_E_GRAFFITIWALL: "جدار جرافيتي",
  T_46_META_WS_E_GRAPPLINGHOOKGUN: "بندقية الخطاف",
  T_46_META_WS_E_GREATCONDUCTOR: "قائد عظيم",
  T_46_META_WS_E_GREEN: "أخضر",
  T_46_META_WS_E_GRENADE: "قنبلة",
  T_46_META_WS_E_GRID: "شبكة",
  T_46_META_WS_E_GROZA: "جروزا",
  T_46_META_WS_E_GROZA2: "جروزا2",
  T_46_META_WS_E_GUARDTOWER: "برج المراقبة",
  T_46_META_WS_E_GUILD: "رابطة",
  T_46_META_WS_E_GUN: "سلاح",
  T_46_META_WS_E_GUNFIRE: "إطلاق نار",
  T_46_META_WS_E_HALO: "هالة",
  T_46_META_WS_E_HAMMER: "آلية المطرقة العملاقة",
  T_46_META_WS_E_HANDCANNON: "HandCannon",
  T_46_META_WS_E_HANGER: "رف تجفيف الملابس",
  T_46_META_WS_E_HARD: "صعب",
  T_46_META_WS_E_HATTRICK: "مهارة 8",
  T_46_META_WS_E_HAYSTACK: "كومة قش",
  T_46_META_WS_E_HEAD: "غطاء الرأس",
  T_46_META_WS_E_HEADSHOOT: "طلقة الرأس",
  T_46_META_WS_E_HEALINGGUN_SNIPER: "Healinggun_Sniper",
  T_46_META_WS_E_HEALINGPISTOL_X: "مسدس العلاج X",
  T_46_META_WS_E_HEALPISTOL: "مسدس شفاء",
  T_46_META_WS_E_HEART: "قلب",
  T_46_META_WS_E_HEARTBEAT: "نبض القلب",
  T_46_META_WS_E_HEATGUN: "HeatGun",
  T_46_META_WS_E_HEAVYWEAPON: "سلاح ثقيل",
  T_46_META_WS_E_HELL: "صعب جدا",
  T_46_META_WS_E_HELMET: "خوذة",
  T_46_META_WS_E_HELMET1: "خوذة1",
  T_46_META_WS_E_HELMET2: "خوذة2",
  T_46_META_WS_E_HELMET3: "خوذة3",
  T_46_META_WS_E_HEXAGON: "مسدس الأضلاع",
  T_46_META_WS_E_HGAMMO: "ذخيرة HG",
  T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER: "مسدس اللهب للغميضة",
  T_46_META_WS_E_HIDERKILL: "القاتل المختبئ",
  T_46_META_WS_E_HIHATS: "هايت هات",
  T_46_META_WS_E_HINDSILIGURI: "هند سيليجوري",
  T_46_META_WS_E_HITBLUNT: "ضربة مملة",
  T_46_META_WS_E_HITEFFECT: "تأثيرات إصابة الرصاص",
  T_46_META_WS_E_HITFEEDBACK: "ملاحظات إطلاق النار",
  T_46_META_WS_E_HOOK: "خطاف",
  T_46_META_WS_E_HOOKGUN: "HookGun",
  T_46_META_WS_E_HOOKGUNAMMO: "ذخيرة بندقية الخطاف",
  T_46_META_WS_E_HORIZALINE: "أفق",
  T_46_META_WS_E_HORIZONTAL: "أفقي",
  T_46_META_WS_E_HORN: "مكبر صوت",
  T_46_META_WS_E_HORROR: "رعب",
  T_46_META_WS_E_HOURGLASS: "ساعة رملية",
  T_46_META_WS_E_HOUSE: "منزل",
  T_46_META_WS_E_HOUSEA: "منزل من طابق واحد",
  T_46_META_WS_E_HOUSEB: "منزل ذو طابقين",
  T_46_META_WS_E_HOUSEC: "منزل من ثلاثة طوابق",
  T_46_META_WS_E_HP: "الصحة (HP)",
  T_46_META_WS_E_HPBUFF: "بوف الصحة",
  T_46_META_WS_E_HUT: "كابينة",
  T_46_META_WS_E_ICEA: "ثلج A",
  T_46_META_WS_E_ICEGUN: "IceGun",
  T_46_META_WS_E_ICEWALLMAKER: "صانع جدران الجليد",
  T_46_META_WS_E_ICONOBJECT: "رمز",
  T_46_META_WS_E_IMAGEWIDGET: "صورة العنصر",
  T_46_META_WS_E_IMPULSE: "دَفْع",
  T_46_META_WS_E_INHALER: "جهاز استنشاق",
  T_46_META_WS_E_INJUREDFEMALE: "صرخات أنثوية عند الضرب",
  T_46_META_WS_E_INJUREDMALE: "صرخات ذكورية عند الضرب",
  T_46_META_WS_E_INK: "تأثير الحبر",
  T_46_META_WS_E_INPUTLABLEWIDGET: "ملصق الإدخال",
  T_46_META_WS_E_INSECTCHIRPING: "زقزوق الحشرات",
  T_46_META_WS_E_INTERVAL10SECONDS: "10 ثوانٍ",
  T_46_META_WS_E_INTERVAL15SECONDS: "15 ثانية",
  T_46_META_WS_E_INTERVAL30SECONDS: "30 ثانية",
  T_46_META_WS_E_INTERVAL3SECONDS: "3 ثوانٍ",
  T_46_META_WS_E_INTERVAL5SECONDS: "5 ثوانٍ",
  T_46_META_WS_E_INTERVAL9999SECONDS: "9999 ثانية",
  T_46_META_WS_E_INVISIBLE: "غير مرئي",
  T_46_META_WS_E_IPIPE: "أنبوب I",
  T_46_META_WS_E_IRONFENCE: "سياج",
  T_46_META_WS_E_IRONFENCEB: "سياج B",
  T_46_META_WS_E_IRONPLATFORM: "منصة حديدية",
  T_46_META_WS_E_ITEMENTITY: "مولد المستهلكات",
  T_46_META_WS_E_JEEP: "جيب",
  T_46_META_WS_E_JERRYCAN: "برميل زيت",
  T_46_META_WS_E_JERSEYMACHINE: "آلة الجيرسي",
  T_46_META_WS_E_JOINEDGAMEDULL: "الانضمام إلى المعركة",
  T_46_META_WS_E_JOINGAME: "انضم إلى اللعبة",
  T_46_META_WS_E_JOYSTICKWIDGET: "أداة عصا التحكم",
  T_46_META_WS_E_JUMP: "قفز",
  T_46_META_WS_E_JUMPATTACK: "هجوم القفز",
  T_46_META_WS_E_JUSTPATROL: "دورية فقط",
  T_46_META_WS_E_KAR98K: "Kar98K",
  T_46_META_WS_E_KATANA: "Katana",
  T_46_META_WS_E_KEY: "مفتاح",
  T_46_META_WS_E_KICK: "طبل",
  T_46_META_WS_E_KILLINGTIPS: "نصائح القتل",
  T_46_META_WS_E_KILLZONE: "منطقة موت",
  T_46_META_WS_E_KINEMATIC: "حركي",
  T_46_META_WS_E_KNIFE: "سكين",
  T_46_META_WS_E_KNOCKDOWN: "مطروح أرضاً",
  T_46_META_WS_E_KNOCKEDDOWN: "سقط",
  T_46_META_WS_E_KORD: "Kord",
  T_46_META_WS_E_LABELWIDGET: "ملصق العنصر",
  T_46_META_WS_E_LANDINGA: "هبوط الدرج A",
  T_46_META_WS_E_LANDINGB: "هبوط الدرج B",
  T_46_META_WS_E_LANDINGC: "هبوط الدرج C",
  T_46_META_WS_E_LANDMINE: "لغم أرضي",
  T_46_META_WS_E_LANUNCHERAMMO: "ذخيرة قاذفة",
  T_46_META_WS_E_LASER: "تأثيرات الليزر",
  T_46_META_WS_E_LASERSKILL: "مهارة الليزر",
  T_46_META_WS_E_LATTICESCREEN: "شاشة",
  T_46_META_WS_E_LAWNA: "عشب A",
  T_46_META_WS_E_LAWNB: "عشب B",
  T_46_META_WS_E_LAYOUTWIDGET: "أداة التخطيط",
  T_46_META_WS_E_LEAD1A2: "Lead1A2",
  T_46_META_WS_E_LEAD1A2SHARP: "Lead1A2#",
  T_46_META_WS_E_LEAD1B2: "Lead1B2",
  T_46_META_WS_E_LEAD1C2: "Lead1C2",
  T_46_META_WS_E_LEAD1C2SHARP: "Lead1C2#",
  T_46_META_WS_E_LEAD1D2: "Lead1D2",
  T_46_META_WS_E_LEAD1D2SHARP: "Lead1D2#",
  T_46_META_WS_E_LEAD1E2: "Lead1E2",
  T_46_META_WS_E_LEAD1F2: "Lead1F2",
  T_46_META_WS_E_LEAD1F2SHARP: "Lead1F2#",
  T_46_META_WS_E_LEAD1G2: "Lead1G2",
  T_46_META_WS_E_LEAD1G2SHARP: "Lead1G2#",
  T_46_META_WS_E_LEAD2A2: "Lead2A2",
  T_46_META_WS_E_LEAD2A2SHARP: "Lead2A2#",
  T_46_META_WS_E_LEAD2B2: "Lead2B2",
  T_46_META_WS_E_LEAD2C2: "Lead2C2",
  T_46_META_WS_E_LEAD2C2SHARP: "Lead2C2#",
  T_46_META_WS_E_LEAD2D2: "Lead2D2",
  T_46_META_WS_E_LEAD2D2SHARP: "Lead2D2#",
  T_46_META_WS_E_LEAD2E2: "Lead2E2",
  T_46_META_WS_E_LEAD2F2: "Lead2F2",
  T_46_META_WS_E_LEAD2F2SHARP: "Lead2F2#",
  T_46_META_WS_E_LEAD2G2: "Lead2G2",
  T_46_META_WS_E_LEAD2G2SHARP: "Lead2G2#",
  T_46_META_WS_E_LEAD3A2: "Lead3A2",
  T_46_META_WS_E_LEAD3A2SHARP: "Lead3A2#",
  T_46_META_WS_E_LEAD3B2: "Lead3B2",
  T_46_META_WS_E_LEAD3C2: "Lead3C2",
  T_46_META_WS_E_LEAD3C2SHARP: "Lead3C2#",
  T_46_META_WS_E_LEAD3D2: "Lead3D2",
  T_46_META_WS_E_LEAD3D2SHARP: "Lead3D2#",
  T_46_META_WS_E_LEAD3E2: "Lead3E2",
  T_46_META_WS_E_LEAD3F2: "Lead3F2",
  T_46_META_WS_E_LEAD3F2SHARP: "Lead3F2#",
  T_46_META_WS_E_LEAD3G2: "Lead3G2",
  T_46_META_WS_E_LEAD3G2SHARP: "Lead3G2#",
  T_46_META_WS_E_LEAFLESSTREE: "خشب ميت",
  T_46_META_WS_E_LEVELMAXED: "أقصى مستوى",
  T_46_META_WS_E_LEVELUP: "ترقية التصنيف",
  T_46_META_WS_E_LEVELUPDISCARDED: "زيادة في الرتبة",
  T_46_META_WS_E_LIGHTBEAM: "شعاع ضوء",
  T_46_META_WS_E_LIGHTBEAMPREDISCARDED: "شعاع ضوء",
  T_46_META_WS_E_LIGHTEFFECT: "تأثير الضوء",
  T_46_META_WS_E_LIGHTNING: "برق",
  T_46_META_WS_E_LIMB: "أطراف",
  T_46_META_WS_E_LINE: "خط",
  T_46_META_WS_E_LIQUID: "سائل",
  T_46_META_WS_E_LOCAL: "محلي",
  T_46_META_WS_E_LOCALPOSITION: "موضع محلي",
  T_46_META_WS_E_LOCK: "قفل",
  T_46_META_WS_E_LONGBOX: "صندوق خشبي طويل",
  T_46_META_WS_E_LOOP: "حلقة",
  T_46_META_WS_E_LOOTITEMBOX: "السلاح الموجود في اللوت",
  T_46_META_WS_E_LOOTITEMBOXAMMO: "الذخيرة الموجودة في اللوت",
  T_46_META_WS_E_LOOTITEMBOXARMOR: "دروع اللوت",
  T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM: "المواد الاستهلاكية الموجودة في اللوت",
  T_46_META_WS_E_LOOTITEMBOXPROJECTILE: "المواد القابلة للرمي الموجودة في اللوت",
  T_46_META_WS_E_LOOTITEMBOXSIGHT: "منظار اللوط",
  T_46_META_WS_E_LOOTITEMBOXSOCCER: "Loot Soccer",
  T_46_META_WS_E_LOOTSOCCERICE: "نهب كرة القدم الجليد",
  T_46_META_WS_E_LOOTSOCCERRANDOM: "غنيمة كرة قدم عشوائية",
  T_46_META_WS_E_LOOTSOCCERSHIELD: "درع كرة القدم",
  T_46_META_WS_E_LOOTWEAPONRANDOM: "غنيمة سلاح عشوائي",
  T_46_META_WS_E_LOSE: "هزيمة",
  T_46_META_WS_E_LOUDSPEAKER: "مكبر صوت",
  T_46_META_WS_E_LOWFALLING: "سقوط منخفض",
  T_46_META_WS_E_M1014: "M1014",
  T_46_META_WS_E_M10142: "M10142",
  T_46_META_WS_E_M14: "M14",
  T_46_META_WS_E_M1873: "M1873",
  T_46_META_WS_E_M1887: "M1887",
  T_46_META_WS_E_M18872: "M18872",
  T_46_META_WS_E_M1887X: "M1887X",
  T_46_META_WS_E_M1917: "M1917",
  T_46_META_WS_E_M21A5: "M21A5",
  T_46_META_WS_E_M24: "M24",
  T_46_META_WS_E_M249: "M249",
  T_46_META_WS_E_M2492: "M2492",
  T_46_META_WS_E_M4A1: "M4A1",
  T_46_META_WS_E_M500: "M500",
  T_46_META_WS_E_M60: "M60",
  T_46_META_WS_E_M79: "M79",
  T_46_META_WS_E_M79AMMO: "قنبلة M79",
  T_46_META_WS_E_M79AMMO_EXCLUSIVE: "قنبلة متخصصة M79",
  T_46_META_WS_E_MAC10: "MAC10",
  T_46_META_WS_E_MACHETE: "Machete",
  T_46_META_WS_E_MACHINEGUN: "رشاش",
  T_46_META_WS_E_MAG7: "MAG7",
  T_46_META_WS_E_MAG72: "MAG72",
  T_46_META_WS_E_MAGEZINE1: "مخزن1",
  T_46_META_WS_E_MAGEZINE2: "مخزن2",
  T_46_META_WS_E_MAGEZINE3: "مخزن3",
  T_46_META_WS_E_MAGMAA: "حمم A",
  T_46_META_WS_E_MAGNIFYINGGLASS: "مكبر",
  T_46_META_WS_E_MALE: "ذكر",
  T_46_META_WS_E_MARK: "علامة",
  T_46_META_WS_E_MARKER: "علامة",
  T_46_META_WS_E_MASK: "إكسسوار الوجه",
  T_46_META_WS_E_MAXVALUE: "الحد الأقصى",
  T_46_META_WS_E_MECHANICAL: "تصادم سريع 2",
  T_46_META_WS_E_MECHANICALDEVICEECHO: "صدى الجهاز الميكانيكي",
  T_46_META_WS_E_MEDICALPROPS: "أدوات طبية",
  T_46_META_WS_E_MEDICALTENT: "خيمة طبية",
  T_46_META_WS_E_MEDIUMHEARTBEAT: "ضربات قلب متوسطة",
  T_46_META_WS_E_MEDKIT: "مجموعة الإسعافات الأولية",
  T_46_META_WS_E_MELEE: "الأسلحة القتالية",
  T_46_META_WS_E_MELEEWEAPONS: "سلاح مشاجرة",
  T_46_META_WS_E_MGL140: "MGL140",
  T_46_META_WS_E_MICROPHONE: "ميكروفون",
  T_46_META_WS_E_MIDDLE: "وسط",
  T_46_META_WS_E_MINIHANDLE: "مقبض صغير",
  T_46_META_WS_E_MINIMAP: "خريطة مصغرة",
  T_46_META_WS_E_MINISENTRY: "مصفاة صغيرة",
  T_46_META_WS_E_MINVALUE: "الحد الأدنى",
  T_46_META_WS_E_MISSILEEXPLODE: "سلاح من نوع صاروخي",
  T_46_META_WS_E_MISSIONCOMPLETE: "نجاح المهمة 1",
  T_46_META_WS_E_MISTAKE: "خطأ",
  T_46_META_WS_E_MODERATE: "معتدل",
  T_46_META_WS_E_MONEY: "نقود",
  T_46_META_WS_E_MONSTER: "وحش",
  T_46_META_WS_E_MONSTERSPAWN: "نقطة استدعاء الوحش",
  T_46_META_WS_E_MONSTERTRUCK: "شاحنة الوحش",
  T_46_META_WS_E_MOON: "قمر",
  T_46_META_WS_E_MOSQUITO: "بعوضة",
  T_46_META_WS_E_MOTIONTRAIL: "مسار الحركة",
  T_46_META_WS_E_MOTOBIKE: "دراجة نارية",
  T_46_META_WS_E_MOTORBIKE: "دراجة نارية",
  T_46_META_WS_E_MOVE: "تحريك",
  T_46_META_WS_E_MOVEMENT: "حركة",
  T_46_META_WS_E_MOVINGJOYSTICK: "عصا التحكم المتحركة",
  T_46_META_WS_E_MP40: "MP40",
  T_46_META_WS_E_MP402: "MP402",
  T_46_META_WS_E_MP5: "MP5",
  T_46_META_WS_E_MRV: "السيد V",
  T_46_META_WS_E_MULTIPLIER: "المضاعف",
  T_46_META_WS_E_MULTIPLY: "ضرب",
  T_46_META_WS_E_MULTIPLYACCUMULATE: "مضاعف وجمع",
  T_46_META_WS_E_MUSHROOM1: "فطر1",
  T_46_META_WS_E_MUSHROOM2: "فطر2",
  T_46_META_WS_E_MUSHROOM3: "فطر3",
  T_46_META_WS_E_MUSHROOM4: "فطر4",
  T_46_META_WS_E_MUSHSHADE: "مجموعة الفطر العملاقة",
  T_46_META_WS_E_MUSIC: "موسيقى",
  T_46_META_WS_E_MUZZLE1: "كابح1",
  T_46_META_WS_E_MUZZLE2: "كابح2",
  T_46_META_WS_E_MUZZLE3: "كابح3",
  T_46_META_WS_E_NEAR: "قريب",
  T_46_META_WS_E_NIGHT: "ليل",
  T_46_META_WS_E_NOATTACK: "لا هجوم",
  T_46_META_WS_E_NODUALWIELDING: "لا استخدام أكيمبو",
  T_46_META_WS_E_NOERROR: "بدون خطأ",
  T_46_META_WS_E_NONE: "لا شيء",
  T_46_META_WS_E_NORMAL: "عادي",
  T_46_META_WS_E_NOSKIPKNOCKDOWN: "عدم تخطي السقوط",
  T_46_META_WS_E_NOTONASTALIQURDU: "NotoNastaliqUrdu",
  T_46_META_WS_E_NUTTYMOVEMENT: "مهارة 7",
  T_46_META_WS_E_OBTAINEDCOINS: "الحصول على ذهب متوسط",
  T_46_META_WS_E_OBTAINEDMANYCOINS: "الحصول على ذهب كبير",
  T_46_META_WS_E_OBTAINEDSOMECOINS: "الحصول على ذهب صغير",
  T_46_META_WS_E_OILDRUMEXPLODE: "انفجار برميل النفط",
  T_46_META_WS_E_ONCE: "مرة واحدة",
  T_46_META_WS_E_ONEWAY: "اتجاه واحد",
  T_46_META_WS_E_OPENFOLDER: "مجلد مفتوح",
  T_46_META_WS_E_OPENHIHATS: "هيهات مفتوحة",
  T_46_META_WS_E_OPENINGBOX: "فتح صندوق",
  T_46_META_WS_E_OPENINGGUILDSUPPLY: "إمدادات الرابطة",
  T_46_META_WS_E_OPENINGWARCHEST: "حفظ المستودع",
  T_46_META_WS_E_ORANGE: "برتقالي",
  T_46_META_WS_E_ORTHOGONAL: "متعامد",
  T_46_META_WS_E_OUTPOST: "بيت الحراسة",
  T_46_META_WS_E_P90: "P90",
  T_46_META_WS_E_P902: "P902",
  T_46_META_WS_E_PAINTEDWALLS: "جدار مطلي",
  T_46_META_WS_E_PAINTSHIELDSKILL: "مهارة بركة الدم",
  T_46_META_WS_E_PALM: "ورقة",
  T_46_META_WS_E_PANEL: "لوحة",
  T_46_META_WS_E_PARAFAL: "بارافال",
  T_46_META_WS_E_PARAFAL2: "بارافال2",
  T_46_META_WS_E_PASSENGERA: "راكب A",
  T_46_META_WS_E_PASSENGERB: "راكب B",
  T_46_META_WS_E_PASSENGERC: "راكب C",
  T_46_META_WS_E_PASSIVE: "سلبي",
  T_46_META_WS_E_PASSIVESKILL: "مهارة سلبية",
  T_46_META_WS_E_PATROLWHILEATTACK: "دورية وهجوم",
  T_46_META_WS_E_PERSONALUAV: "درون شخصي",
  T_46_META_WS_E_PERSPECTIVE: "منظور",
  T_46_META_WS_E_PETTABBG: "حيوان أليف",
  T_46_META_WS_E_PHASESTART: "بداية المرحلة",
  T_46_META_WS_E_PHONEBOOTH: "كابينة الهاتف",
  T_46_META_WS_E_PI: "Π",
  T_46_META_WS_E_PIANOA3: "PianoA3",
  T_46_META_WS_E_PIANOA3SHARP: "PianoA3#",
  T_46_META_WS_E_PIANOA4: "PianoA4",
  T_46_META_WS_E_PIANOA4SHARP: "PianoA4#",
  T_46_META_WS_E_PIANOB3: "PianoB3",
  T_46_META_WS_E_PIANOB4: "PianoB4",
  T_46_META_WS_E_PIANOC3: "PianoC3",
  T_46_META_WS_E_PIANOC3SHARP: "PianoC3#",
  T_46_META_WS_E_PIANOC4: "PianoC4",
  T_46_META_WS_E_PIANOC4SHARP: "PianoC4#",
  T_46_META_WS_E_PIANOD3: "PianoD3",
  T_46_META_WS_E_PIANOD3SHARP: "PianoD3#",
  T_46_META_WS_E_PIANOD4: "PianoD4",
  T_46_META_WS_E_PIANOD4SHARP: "PianoD4#",
  T_46_META_WS_E_PIANOE3: "PianoE3",
  T_46_META_WS_E_PIANOE4: "PianoE4",
  T_46_META_WS_E_PIANOF3: "PianoF3",
  T_46_META_WS_E_PIANOF3SHARP: "PianoF3#",
  T_46_META_WS_E_PIANOF4: "PianoF4",
  T_46_META_WS_E_PIANOF4SHARP: "PianoF4#",
  T_46_META_WS_E_PIANOG3: "PianoG3",
  T_46_META_WS_E_PIANOG3SHARP: "PianoG3#",
  T_46_META_WS_E_PIANOG4: "PianoG4",
  T_46_META_WS_E_PIANOG4SHARP: "PianoG4#",
  T_46_META_WS_E_PIANOKEY1: "ملاحظات موسيقية - بيانو",
  T_46_META_WS_E_PIANOKEY2: "ملاحظات موسيقية - بيانو",
  T_46_META_WS_E_PICKUPS: "التقاطات",
  T_46_META_WS_E_PICKUPTRUCK: "SUV",
  T_46_META_WS_E_PILLAR: "عمود خرساني",
  T_46_META_WS_E_PIN: "تعليق",
  T_46_META_WS_E_PINGPONG: "تنس الطاولة",
  T_46_META_WS_E_PIPECORNER: "أنبوب كوع",
  T_46_META_WS_E_PIPEINTERSECTION: "أنبوب تقاطع",
  T_46_META_WS_E_PISTOL: "مسدس",
  T_46_META_WS_E_PISTOLAMMO: "ذخيرة مسدس",
  T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE: "بلوك المتنزه المربعات",
  T_46_META_WS_E_PLASMA_X: "PLASMA_X",
  T_46_META_WS_E_PLAYER: "لاعب",
  T_46_META_WS_E_PLUS: "زائد",
  T_46_META_WS_E_PODIUM: "المنصة",
  T_46_META_WS_E_POISONGAS: "غاز سام",
  T_46_META_WS_E_POISONGASPREDISCARDED: "غاز سام",
  T_46_META_WS_E_PORTAL: "بوابة",
  T_46_META_WS_E_POSTACCUMULATOR: "المجمع اللاحق",
  T_46_META_WS_E_POT: "Pot",
  T_46_META_WS_E_POUNDINGHEART: "ضربات قلب سريعة",
  T_46_META_WS_E_PREACCUMULATOR: "المجمع السابق",
  T_46_META_WS_E_PRIMARYWEAPONA: "السلاح الأساسي A",
  T_46_META_WS_E_PRIMARYWEAPONB: "السلاح الأساسي B",
  T_46_META_WS_E_PRIOREXPLOSION: "قبل انفجار القنبلة",
  T_46_META_WS_E_PROFILEWIDGET: "أداة الملف الشخصي",
  T_46_META_WS_E_PRONE: "على البطن",
  T_46_META_WS_E_PUMPKIN: "اليقطين",
  T_46_META_WS_E_PURPLE: "بنفسجي",
  T_46_META_WS_E_QUADRILATERAL: "رباعي الأضلاع",
  T_46_META_WS_E_QUESTIONMARK: "علامة استفهام",
  T_46_META_WS_E_QUICKCHAT: "دردشة سريعة",
  T_46_META_WS_E_QUICKCHATSHOW: "عرض الدردشة السريعة",
  T_46_META_WS_E_RADIAL180: "شعاعي 180°",
  T_46_META_WS_E_RADIAL360: "شعاعي 360°",
  T_46_META_WS_E_RADIAL90: "شعاعي 90°",
  T_46_META_WS_E_RAMPAGE: "الإبادة",
  T_46_META_WS_E_RANDOM: "عشوائي",
  T_46_META_WS_E_RANDOMBUFF: "عشوائي بوف",
  T_46_META_WS_E_RANKDOWN: "انخفاض في التصنيف",
  T_46_META_WS_E_REACTION: "استجابة",
  T_46_META_WS_E_RECOVER: "استرداد",
  T_46_META_WS_E_RECYCLE: "إعادة تدوير",
  T_46_META_WS_E_RED: "أحمر",
  T_46_META_WS_E_REFINERYTANK: "إبريق الماء",
  T_46_META_WS_E_REFLECTIVECUBE: "الكتلة الأساسية ذات اللون الصلب العاكس 1",
  T_46_META_WS_E_REFRESH: "تحديث",
  T_46_META_WS_E_RELEASINGSKILL: "تأثيرات استخدام المهارة",
  T_46_META_WS_E_RELOAD: "إعادة التحميل",
  T_46_META_WS_E_REMINDER: "تذكير",
  T_46_META_WS_E_REPAIR: "إصلاح",
  T_46_META_WS_E_REPAIREQUIP: "إصلاح المعدات",
  T_46_META_WS_E_REPAIRKIT: "مجموعة إصلاح",
  T_46_META_WS_E_REPLACER: "بديل",
  T_46_META_WS_E_REPORT: "تقرير",
  T_46_META_WS_E_REST: "راحة",
  T_46_META_WS_E_RG550: "RG550",
  T_46_META_WS_E_RIDES: "رايد",
  T_46_META_WS_E_RIDICULE: "سخرية",
  T_46_META_WS_E_RIDICULEFUNNY: "سخرية مضحكة",
  T_46_META_WS_E_RIFLE: "بندقية",
  T_46_META_WS_E_RIFLEAMMO: "ذخيرة بندقية",
  T_46_META_WS_E_RIGHT: "صحيح",
  T_46_META_WS_E_RIGHTTRAPEZOID: "شبه منحرف قائم الزاوية",
  T_46_META_WS_E_RING: "آلية الحلقة",
  T_46_META_WS_E_RINGPREDISCARDED: "حلقة",
  T_46_META_WS_E_RIPTIDERHYTHM: "مهارة 9",
  T_46_META_WS_E_RISINGPARTICLE: "جزيئات صاعدة",
  T_46_META_WS_E_ROADBLOCK: "حاجز",
  T_46_META_WS_E_ROTATE: "دوران",
  T_46_META_WS_E_RUNNING: "جاري",
  T_46_META_WS_E_RUSHTIME: "الإبادة",
  T_46_META_WS_E_SAMURAI: "ساموراي",
  T_46_META_WS_E_SANDA: "رمل A",
  T_46_META_WS_E_SANDSTRUCTURE: "تمثال رمل",
  T_46_META_WS_E_SCALE: "مقياس",
  T_46_META_WS_E_SCAR: "SCAR",
  T_46_META_WS_E_SCAR2: "SCAR2",
  T_46_META_WS_E_SCARECROW: "فزاعة",
  T_46_META_WS_E_SCISSORS: "مقص",
  T_46_META_WS_E_SCOPE2X: "2x منظار",
  T_46_META_WS_E_SCOPE4X: "4x منظار",
  T_46_META_WS_E_SCROLLPANEL: "لوحة التمرير",
  T_46_META_WS_E_SECONDARYWEAPON: "السلاح الثانوي",
  T_46_META_WS_E_SENSESSHOCKWAVE: "مهارة 10",
  T_46_META_WS_E_SERVER: "خادم",
  T_46_META_WS_E_SET: "بذلة",
  T_46_META_WS_E_SETTING: "إعدادات",
  T_46_META_WS_E_SETTINGS: "إعدادات",
  T_46_META_WS_E_SG: "بندوق مروحية",
  T_46_META_WS_E_SGAMMO: "ذخيرة SN",
  T_46_META_WS_E_SHARPMECHANICAL: "تصادم سريع 1",
  T_46_META_WS_E_SHIELD: "دفاع",
  T_46_META_WS_E_SHIELDBROKEN: "الدرع مكسور",
  T_46_META_WS_E_SHIELDGUN: "ShieldGun",
  T_46_META_WS_E_SHIELDUP: "رفع الدرع",
  T_46_META_WS_E_SHOCKWAVE: "موجة صاعقة",
  T_46_META_WS_E_SHOES: "أحذية",
  T_46_META_WS_E_SHOOTINGTARGET: "الهدف المتحرك",
  T_46_META_WS_E_SHORTDATE: "تاريخ قصير",
  T_46_META_WS_E_SHORTDATETIME: "تاريخ ووقت قصير",
  T_46_META_WS_E_SHORTTIME: "وقت قصير",
  T_46_META_WS_E_SHOTGUN: "بندقية خرطوش",
  T_46_META_WS_E_SHOTGUNAMMO: "ذخيرة شوتجن",
  T_46_META_WS_E_SHOTGUNMUZZLE: "كابح شوتجن",
  T_46_META_WS_E_SHOW: "عرض",
  T_46_META_WS_E_SHRUB: "صندوق خشبي طويل مغطى بالشجيرات",
  T_46_META_WS_E_SICKLE: "منجل",
  T_46_META_WS_E_SIDESCROLLING: "التمرير الجانبي",
  T_46_META_WS_E_SIGNAL: "إشارة",
  T_46_META_WS_E_SIGNOUT: "خروج",
  T_46_META_WS_E_SILENCER: "كاتم الصوت",
  T_46_META_WS_E_SIMPLE: "بسيط",
  T_46_META_WS_E_SIMPLEWIDGET: "عنصر بسيط",
  T_46_META_WS_E_SIMPLIFIEDARABIC: "العربية المبسطة",
  T_46_META_WS_E_SINGLE: "فردي",
  T_46_META_WS_E_SITEHUT: "بيت الحاوية",
  T_46_META_WS_E_SKILLCHARGINGCOMPLETE: "اكتمال شحن المهارة",
  T_46_META_WS_E_SKILLRECOVER: "استعادة المهارات",
  T_46_META_WS_E_SKIPKNOCKDOWN: "تخطي السقوط",
  T_46_META_WS_E_SKS: "SKS",
  T_46_META_WS_E_SLICED: "مقطع",
  T_46_META_WS_E_SLOPE: "ميل",
  T_46_META_WS_E_SLOWHEARTBEAT: "ضربات قلب بطيئة",
  T_46_META_WS_E_SMG: "مسدس رشاش",
  T_46_META_WS_E_SMGAMMO: "ذخيرة رشاش",
  T_46_META_WS_E_SMGMUZZLE: "كابح الرشاش",
  T_46_META_WS_E_SMILEY: "وجه مبتسم",
  T_46_META_WS_E_SMOKE: "دخان",
  T_46_META_WS_E_SMOKEGRENADE: "قنبلة دخان",
  T_46_META_WS_E_SMOKEY: "دخان",
  T_46_META_WS_E_SMOOTH: "سلس",
  T_46_META_WS_E_SNAMMO: "ذخيرة SN",
  T_46_META_WS_E_SNARES: "طبل السناج",
  T_46_META_WS_E_SNEAKERS: "تأثيرات الأحذية الرياضية",
  T_46_META_WS_E_SNIPER: "بندقية قناصة",
  T_46_META_WS_E_SNIPERAMMO: "ذخيرة بندقية قناصة",
  T_46_META_WS_E_SNOWA: "ثلج A",
  T_46_META_WS_E_SNOWFLAKE: "رقاقات ثلجية",
  T_46_META_WS_E_SOCCER: "كرة القدم",
  T_46_META_WS_E_SOCIALBUTTONWIDGET: "أداة الزر الاجتماعي",
  T_46_META_WS_E_SOLARPANEL: "لوحة شمسية",
  T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW: "حسب الأولوية من الأعلى إلى الأدنى",
  T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH: "حسب الأولوية من الأدنى إلى الأعلى",
  T_46_META_WS_E_SPAS12: "SPAS12",
  T_46_META_WS_E_SPAS122: "SPAS122",
  T_46_META_WS_E_SPAWNPOINT: "تأثيرات نقطة الظهور",
  T_46_META_WS_E_SPEAKER: "مكبر الصوت",
  T_46_META_WS_E_SPECIALFIRINGSOUND: "صوت سلاح خاص",
  T_46_META_WS_E_SPECIALGUN: "سلاح خاص",
  T_46_META_WS_E_SPHERE: "كرة",
  T_46_META_WS_E_SPHERETRIGGER: "مشغل الاصطدام الكروي",
  T_46_META_WS_E_SPIDERWEB: "تأثيرات المهارة",
  T_46_META_WS_E_SPORTSCAR: "سيارة رياضية",
  T_46_META_WS_E_SPOTLIGHT: "ضوء",
  T_46_META_WS_E_SPREADOFPOISONGAS: "انتشار الغاز السام",
  T_46_META_WS_E_SPRINT: "انطلاق سريع",
  T_46_META_WS_E_SQUARE: "مربع",
  T_46_META_WS_E_SQUAREBOX: "صندوق خشبي مربع",
  T_46_META_WS_E_SR: "بندقية قناصة",
  T_46_META_WS_E_STABLE: "كوخ القش",
  T_46_META_WS_E_STAIRS: "سلم",
  T_46_META_WS_E_STANDING: "وقوف",
  T_46_META_WS_E_STAR: "نجم",
  T_46_META_WS_E_STATIC: "ثابت",
  T_46_META_WS_E_STATUSTRIGGER: "مشغل الموت أو المناعة",
  T_46_META_WS_E_STEP: "خطوات",
  T_46_META_WS_E_STEPTRIGGER: "تفعيل آلية",
  T_46_META_WS_E_STOCK_S: "مخزون S",
  T_46_META_WS_E_STOCK_SR: "مخزون SR",
  T_46_META_WS_E_STOCK1: "مخزون 1",
  T_46_META_WS_E_STOCK2: "مخزون 2",
  T_46_META_WS_E_STOCK3: "مخزون 3",
  T_46_META_WS_E_STONE: "صخرة",
  T_46_META_WS_E_STONEBRIDGE: "جسر قوس حجري",
  T_46_META_WS_E_STONELANTERN: "مصباح القصر",
  T_46_META_WS_E_STONESPLASH: "حطام طائر",
  T_46_META_WS_E_STORE: "متجر",
  T_46_META_WS_E_STREETLAMP: "مصباح الشارع",
  T_46_META_WS_E_STYLEA: "نمط A",
  T_46_META_WS_E_STYLEB: "نمط B",
  T_46_META_WS_E_STYLEC: "نمط C",
  T_46_META_WS_E_SUBMACHINEGUN: "رشاش",
  T_46_META_WS_E_SUBMACHINEGUNAMMO: "ذخيرة رشاش",
  T_46_META_WS_E_SUCCESSFULHIT: "ضربة",
  T_46_META_WS_E_SUN: "شمس",
  T_46_META_WS_E_SUNSHADE: "طقم فناء مع مظلة",
  T_46_META_WS_E_SUPERCAR: "سيارة رياضية",
  T_46_META_WS_E_SUPERMARKET: "سوبرماركت",
  T_46_META_WS_E_SURPRISEFIND: "اكتشاف المفاجأة",
  T_46_META_WS_E_SUV: "SUV",
  T_46_META_WS_E_SVD: "SVD",
  T_46_META_WS_E_SVD2: "SVD2",
  T_46_META_WS_E_SWEAPWEAPONQUICK: "تبديل السلاح بسرعة",
  T_46_META_WS_E_SWIMRING: "حلقة سباحة",
  T_46_META_WS_E_SWORD: "سيف",
  T_46_META_WS_E_SYMBOLIC: "علامة أرضية",
  T_46_META_WS_E_TANKZOMBIE: "زومبي الدبابة",
  T_46_META_WS_E_TAP: "نقر",
  T_46_META_WS_E_TAPPINGBUTTON: "زر النقر",
  T_46_META_WS_E_TAPPINGDISABLEDBUTTON: "نقر على زر التعطيل",
  T_46_META_WS_E_TEAM: "فريق",
  T_46_META_WS_E_TEAMMATESINFO: "معلومات الزملاء",
  T_46_META_WS_E_TELEPORT: "النقل الفضائي",
  T_46_META_WS_E_TELEPORTCORRECT: "إشعار الوجهة الصحيحة",
  T_46_META_WS_E_TELEPORTWRONG: "إشعار الوجهة الخاطئة",
  T_46_META_WS_E_TEXT: "نص",
  T_46_META_WS_E_TEXTOBJECT: "نص",
  T_46_META_WS_E_TEXTUREWIDGET: "أداة الملمس",
  T_46_META_WS_E_THERMALSCOPE: "منظار حراري",
  T_46_META_WS_E_THIRDPERSON: "كاميرا من منظور الشخص الثالث",
  T_46_META_WS_E_THIRDPERSONCLASSIC: "منظور الشخص الثالث الكلاسيكي",
  T_46_META_WS_E_THIRDPERSONLOCK: "كاميرا من منظور الشخص الثالث مغلقة",
  T_46_META_WS_E_THOMPSON: "طومسون",
  T_46_META_WS_E_THOMPSON2: "طومسون2",
  T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY: "سكين رمي2 للتوافق",
  T_46_META_WS_E_THRILLBATTLE: "مهارة 5",
  T_46_META_WS_E_THROWATTACK: "هجوم رمي",
  T_46_META_WS_E_THROWINGKNIFE: "سكين الرمي",
  T_46_META_WS_E_THROWREDZOMBIE: "زومبي الرامي الأحمر",
  T_46_META_WS_E_THROWZOMBIE: "زومبي الرامي",
  T_46_META_WS_E_THUMBSUP: "إعجاب",
  T_46_META_WS_E_THUNDER: "صدمة كهربائية",
  T_46_META_WS_E_TILEA: "بلاط A",
  T_46_META_WS_E_TILEB: "بلاط B",
  T_46_META_WS_E_TILEC: "بلاط C",
  T_46_META_WS_E_TILED: "مبلط",
  T_46_META_WS_E_TIPSSOUND: "عرض النصائح",
  T_46_META_WS_E_TOGGLEWIDGET: "أداة التبديل",
  T_46_META_WS_E_TOILETBOWL: "مرحاض",
  T_46_META_WS_E_TONEA: "حجر A",
  T_46_META_WS_E_TOP: "الملابس العلوية",
  T_46_META_WS_E_TOPDOWN: "كاميرا من الأعلى",
  T_46_META_WS_E_TORII: "توري",
  T_46_META_WS_E_TOUCHPADWIDGET: "أداة لوحة اللمس",
  T_46_META_WS_E_TOWER: "قلعة",
  T_46_META_WS_E_TPIPE: "أنبوب T",
  T_46_META_WS_E_TRACINGSTEPS: "مهارة 3",
  T_46_META_WS_E_TRAILER: "مقطورة",
  T_46_META_WS_E_TRANSFORMATION: "تغيير الشكل",
  T_46_META_WS_E_TRANSPARENT: "شفاف",
  T_46_META_WS_E_TRAPEZOID: "شبه منحرف",
  T_46_META_WS_E_TRASHCAN: "سلة المهملات",
  T_46_META_WS_E_TRIANGLE: "مثلث",
  T_46_META_WS_E_TRIGGERS: "زناد",
  T_46_META_WS_E_TRIPLE: "3 جولات انفجارية",
  T_46_META_WS_E_TROPHY: "كأس",
  T_46_META_WS_E_TRUE: "نعم",
  T_46_META_WS_E_TUKTUK: "توك توك",
  T_46_META_WS_E_TUTUCAR: "توك توك",
  T_46_META_WS_E_TYRANTZOMBIE: "زومبي الطاغية",
  T_46_META_WS_E_UAVLITE: "طائرة UAV خفيفة",
  T_46_META_WS_E_UIFINISH: "نهاية",
  T_46_META_WS_E_UITAP: "اضغط",
  T_46_META_WS_E_UMP: "UMP",
  T_46_META_WS_E_UMP2: "UMP2",
  T_46_META_WS_E_UNITGENERATOR: "مولد الوحدة",
  T_46_META_WS_E_UPWARDTURBULENCE: "تيار صاعد",
  T_46_META_WS_E_USP: "USP",
  T_46_META_WS_E_USP_2: "USP_2",
  T_46_META_WS_E_UZI: "أوزي",
  T_46_META_WS_E_VAULTOVER: "قفزة النافذة",
  T_46_META_WS_E_VECTOR: "فكتور",
  T_46_META_WS_E_VEHICLE: "مركبة",
  T_46_META_WS_E_VEHICLEEXPLODE: "انفجار مركبة",
  T_46_META_WS_E_VELOCITY: "سرعة",
  T_46_META_WS_E_VENDINGMACHINE: "آلة البيع",
  T_46_META_WS_E_VERTICAL: "عمودي",
  T_46_META_WS_E_VEST: "سترة",
  T_46_META_WS_E_VEST1: "سترة1",
  T_46_META_WS_E_VEST2: "سترة2",
  T_46_META_WS_E_VEST3: "سترة3",
  T_46_META_WS_E_VEST4: "سترة4",
  T_46_META_WS_E_VISUALEFFECTS: "التأثيرات البصرية",
  T_46_META_WS_E_VSK94: "VSK94",
  T_46_META_WS_E_VSS: "VSS",
  T_46_META_WS_E_WALLA: "الجدار A",
  T_46_META_WS_E_WALLBRAWL: "مهارة 2",
  T_46_META_WS_E_WARNING: "تحذير",
  T_46_META_WS_E_WATERRING: "رش ماء",
  T_46_META_WS_E_WAVE1: "موجة1",
  T_46_META_WS_E_WAVE2: "موجة2",
  T_46_META_WS_E_WAVE3: "موجة3",
  T_46_META_WS_E_WEAPONGENERATOR: "سلاح",
  T_46_META_WS_E_WEAPONSLOT: "خانة السلاح",
  T_46_META_WS_E_WHISTLE: "هزيمة العدو",
  T_46_META_WS_E_WIDERANGE: "نطاق واسع",
  T_46_META_WS_E_WIN: "انتصار",
  T_46_META_WS_E_WINDATTACK: "هجوم الإعصار",
  T_46_META_WS_E_WOODA: "خشب A",
  T_46_META_WS_E_WOODCUTZOMBIE: "زومبي قاطع الخشب",
  T_46_META_WS_E_WOODENPLANK: "جسر خشبي",
  T_46_META_WS_E_WORLDPOSITION: "إحداثيات عالمية",
  T_46_META_WS_E_WRECKEDBUS: "حافلة مدمرة",
  T_46_META_WS_E_WRECKEDCAR: "سيارة مدمرة",
  T_46_META_WS_E_WRONG: "خطأ",
  T_46_META_WS_E_XM8: "XM8",
  T_46_META_WS_E_XM82: "XM82",
  T_46_META_WS_E_ZOMBIE: "زومبي",
  T_46_META_WS_E_ZOMBIES: "زومبي",
  T_46_META_WS_E_ZOOM: "تقريب",
  T_46_META_WS_ELIMINATE: "القضاء",
  T_46_META_WS_ELIMINATEDENTITY: "كيان تم استبعاده",
  T_46_META_WS_ELIMINATEDPLAYER: "لاعب تم استبعاده",
  T_46_META_WS_ENABLEDEFAULTBTREE: "تفعيل شجرة السلوك الافتراضية",
  T_46_META_WS_ENABLEMOVINGSAFEZONE: "تفعيل منطقة الأمان المتحركة",
  T_46_META_WS_ENABLESAFEZONE: "تفعيل منطقة الأمان",
  T_46_META_WS_ENDCURRENTPHASE: "إنهاء المرحلة الحالية",
  T_46_META_WS_ENDMORPH: "إنهاء التحول",
  T_46_META_WS_ENDPOSITION: "الموقع النهائي",
  T_46_META_WS_ENTERVEHICLE: "دخول المركبة",
  T_46_META_WS_ENTITY: "كيان",
  T_46_META_WS_EQUIPMENTID: "معرف المعدات",
  T_46_META_WS_EULERANGLETOQUATERNION: "تحويل زاوية أويلر إلى كواتيرنين",
  T_46_META_WS_EXITVEHICLE: "الخروج من المركبة",
  T_46_META_WS_EXPONENTIATION: "الترفيع",
  T_46_META_WS_FILTERENTITY: "تصفية الكائن",
  T_46_META_WS_FILTERLEVELOBJECTS: "تصفية كائنات المستوى",
  T_46_META_WS_FIND: "العثور على",
  T_46_META_WS_FINDAT: "العثور على في",
  T_46_META_WS_FINDPATH: "العثور على المسار",
  T_46_META_WS_FLOOR: "الأساس",
  T_46_META_WS_FOOTBALLGOAL: "هدف كرة القدم",
  T_46_META_WS_FORMAT: "تنسيق",
  T_46_META_WS_GETALLKEYS: "الحصول على جميع المفاتيح",
  T_46_META_WS_GETALLPLAYERS: "الحصول على جميع اللاعبين",
  T_46_META_WS_GETALLSHOPS: "الحصول على جميع المتاجر",
  T_46_META_WS_GETALLTEAMS: "الحصول على جميع الفرق",
  T_46_META_WS_GETATTACKABLEENTITY: "الحصول على الكائن القابل للهجوم",
  T_46_META_WS_GETATTACKABLEFACTIONS: "الحصول على الفصائل القابلة للهجوم",
  T_46_META_WS_GETBACKPACKSKIN: "الحصول على مظهر حقيبة الظهر",
  T_46_META_WS_GETBLACKBOARDVALUE: "الحصول على قيمة السبورة السوداء",
  T_46_META_WS_GETBUFFS: "الحصول على المكافآت",
  T_46_META_WS_GETCHATCHANNEL: "الحصول على قناة الدردشة",
  T_46_META_WS_GETCHILDBYINDEX: "الحصول على طفل حسب الفهرس",
  T_46_META_WS_GETCHILDBYNAME: "الحصول على طفل حسب الاسم",
  T_46_META_WS_GETCHILDREN: "الحصول على الأطفال",
  T_46_META_WS_GETCOLORCHANNEL: "الحصول على قناة اللون",
  T_46_META_WS_GETCONSUMABLES: "الحصول على المستهلكات",
  T_46_META_WS_GETCULLINGMASK: "الحصول على قناع التصفية",
  T_46_META_WS_GETCURRENTCAMERA: "الحصول على الكاميرا الحالية",
  T_46_META_WS_GETCURRENTCHATCHANNEL: "الحصول على قناة الدردشة الحالية",
  T_46_META_WS_GETCUSTOMMISSIONPROGRESS: "الحصول على تقدم المهمة المخصصة",
  T_46_META_WS_GETDYEDCOUNT: "الحصول على عدد الألوان",
  T_46_META_WS_GETDYEDSTATUS: "الحصول على حالة الصب",
  T_46_META_WS_GETEQUIPMENTS: "الحصول على المعدات",
  T_46_META_WS_GETFACTION: "الحصول على الفصيل",
  T_46_META_WS_GETGLOBALSLEEPTHRESHOLD: "الحصول على عتبة النوم العالمية",
  T_46_META_WS_GETITEMCOUNT: "تدمير العنصر",
  T_46_META_WS_GETLOADEDSCENES: "الحصول على المشاهد المحملة",
  T_46_META_WS_GETLOCALAIMDIRECTION: "الحصول على اتجاه التهديف المحلي",
  T_46_META_WS_GETLOCALPLAYER: "الحصول على اللاعب المحلي",
  T_46_META_WS_GETLOCALTIMESTAMP: "الحصول على الطابع الزمني المحلي",
  T_46_META_WS_GETMAPID: "الحصول على معرف الخريطة",
  T_46_META_WS_GETMINIMAP: "الحصول على الخريطة المصغرة",
  T_46_META_WS_GETMONEY: "الحصول على المال",
  T_46_META_WS_GETMONEYCOUNT: "الحصول على عدد المال",
  T_46_META_WS_GETMORPH: "الحصول على التحول",
  T_46_META_WS_GETNODEVARIABLE: "الحصول على متغير العقدة",
  T_46_META_WS_GETOUTFIT: "الحصول على زي",
  T_46_META_WS_GETOWNER: "إعلام بعرض النصائح",
  T_46_META_WS_GETPARENT: "الحصول على الوالد",
  T_46_META_WS_GETPOSITIONNEARTEAMMATE: "الانتقال",
  T_46_META_WS_GETRANDOMSPAWNPOSITION: "الحصول على موقع قريب من الزميل",
  T_46_META_WS_GETRESULTFROMCURVE: "الحصول على نتيجة من المنحنى",
  T_46_META_WS_GETSCENESKYBOX: "الحصول على سماء المشهد",
  T_46_META_WS_GETSERVERREGION: "الحصول على الطابع الزمني للخادم",
  T_46_META_WS_GETSERVERTIMESTAMP: "ظل عكسي",
  T_46_META_WS_GETSKELETONPARTBYNAME: "الحصول على جزء الهيكل العظمي حسب الاسم",
  T_46_META_WS_GETSKILLS: "الحصول على المهارات",
  T_46_META_WS_GETSLEEPTHRESHOLD: "الحصول على عتبة النوم",
  T_46_META_WS_GETTOKENCOUNT: "الحصول على عدد الرموز",
  T_46_META_WS_GETTOKENCOUNTTODAY: "الحصول على عدد الرموز اليوم",
  T_46_META_WS_GETTYPE: "الحصول على النوع",
  T_46_META_WS_GETVEHICLESKIN: "الحصول على غلاف المركبة",
  T_46_META_WS_GETWALLET: "الحصول على المحفظة",
  T_46_META_WS_GETWEAPONSKIN: "الحصول على جلد السلاح",
  T_46_META_WS_GETWIDGETBYPATH: "الحصول على الودجت من المسار",
  T_46_META_WS_GETWIDGETFROMCUSTOMUI: "الحصول على أداة من واجهة المستخدم المخصصة",
  T_46_META_WS_GIVEJAILBREAKITEM: "تقديم عنصر كسر السجن",
  T_46_META_WS_GIVEJAILBREAKREWARD: "تقديم مكافأة كسر السجن",
  T_46_META_WS_HASAOISPECIALFOLLOW: "هل هناك متابعة خاصة بـ AOI",
  T_46_META_WS_HASCOMPONENT: "يحتوي على مكون",
  T_46_META_WS_HASSCRIPT: "هل يحتوي على نص برمجي",
  T_46_META_WS_HASTAG: "هل يحتوي على علامة",
  T_46_META_WS_HELPEDPLAYER: "اللاعب الذي تم مساعدته",
  T_46_META_WS_HELPPLAYER: "لاعب مساعد",
  T_46_META_WS_HIDEAPPEARANCEGROUP: "إخفاء مجموعة المظهر",
  T_46_META_WS_HITENTITY: "الكيان المصاب",
  T_46_META_WS_HITFLY: "ضرب الطيران",
  T_46_META_WS_HITNORMAL: "الطبيعة العادية للإصابة",
  T_46_META_WS_HITOBJECT: "الكائن المصاب",
  T_46_META_WS_HITPOSITION: "موقع الإصابة",
  T_46_META_WS_INDEXOF: "إضافة النطاق",
  T_46_META_WS_INFECTIONZOMBIEGROWUP: "تحقق من المشغل بالترتيب",
  T_46_META_WS_INSERT: "إدراج",
  T_46_META_WS_ISATTACKABLE: "هل يمكن الهجوم",
  T_46_META_WS_ISCHATCHANNELEMPTY: "هل قناة الدردشة فارغة؟",
  T_46_META_WS_ISEQUAL: "هل يساوي",
  T_46_META_WS_ISFRIEND: "هل هو صديق",
  T_46_META_WS_ISHIT: "هل تم الإصابة",
  T_46_META_WS_ISINSIDEBOX: "داخل الصندوق",
  T_46_META_WS_ISINSIDECYLINDER: "داخل الأسطوانة",
  T_46_META_WS_ISINSIDESECTOR: "داخل القطاع",
  T_46_META_WS_ISINSIDESPHERE: "داخل الكرة",
  T_46_META_WS_ISSLEEPING: "هل هو نائم؟",
  T_46_META_WS_ISSUBTYPEOF: "هو نوع فرعي من",
  T_46_META_WS_ITEM: "كيان",
  T_46_META_WS_ITEMID: "معرف العنصر",
  T_46_META_WS_JOIN: "دمج",
  T_46_META_WS_JOINCHATCHANNEL: "الانضمام إلى قناة الدردشة",
  T_46_META_WS_JOINFACTION: "الانضمام إلى الفصيل",
  T_46_META_WS_LASTINDEXOF: "فهرس",
  T_46_META_WS_LENGTH: "الطول",
  T_46_META_WS_LERP: "التداخل",
  T_46_META_WS_LOADSCENE: "تحميل المشهد",
  T_46_META_WS_LOGARITHM: "اللوغاريتم",
  T_46_META_WS_LOGERROR: "تسجيل خطأ",
  T_46_META_WS_LOGINFO: "تسجيل المعلومات",
  T_46_META_WS_LOGWARNING: "تسجيل تحذير",
  T_46_META_WS_LOOKROTATION: "إنشاء التدوير نحو اتجاه الهدف",
  T_46_META_WS_MAGNITUDE: "تطبيع",
  T_46_META_WS_MAKER: "المنشئ",
  T_46_META_WS_MAX: "الحد الأقصى",
  T_46_META_WS_MECHANISM: "آلية",
  T_46_META_WS_MIN: "الحد الأدنى",
  T_46_META_WS_MONSTERUSESKILL: "استخدام المهارة",
  T_46_META_WS_MORPHOBJECT: "كائن متحول",
  T_46_META_WS_MORPHTO: "التحول إلى",
  T_46_META_WS_MORPHTOBYITEMID: "التحول إلى بواسطة معرف العنصر",
  T_46_META_WS_MOVECCT: "تحريك CCT",
  T_46_META_WS_MOVEPOSITION: "تحريك الموقع",
  T_46_META_WS_MOVEROTATION: "تحريك التدوير",
  T_46_META_WS_MULTIPLYQUATERNION: "ضرب الكوارتز",
  T_46_META_WS_MULTIRAYCAST: "اختبار شعاع متعدد",
  T_46_META_WS_NEGATE: "سالب",
  T_46_META_WS_NEW: "تحويل المتجه 2 إلى متجه 3",
  T_46_META_WS_NODENAME: "اسم العقدة",
  T_46_META_WS_NORMALIZE: "التقاطع",
  T_46_META_WS_NOTIFYPLAYEFFECT: "إيقاف تعبير",
  T_46_META_WS_NOTIFYPLAYICONANIMATION: "إشعار تشغيل الرسوم المتحركة للرمز",
  T_46_META_WS_NOTIFYPLAYSOUND: "إعلام بتشغيل التأثير",
  T_46_META_WS_NOTIFYSHOWTIPS: "إعلام بتشغيل الصوت",
  T_46_META_WS_NUMTOSTRING: "تحويل الرقم إلى نص",
  T_46_META_WS_ONACCESSEQUIPMENT: "الوصول إلى المعدات",
  T_46_META_WS_ONACCESSITEM: "الوصول إلى العنصر",
  T_46_META_WS_ONACCESSWEAPON: "الوصول إلى السلاح",
  T_46_META_WS_ONACE: "تحقيق ACE",
  T_46_META_WS_ONAIMED: "تم التصويب",
  T_46_META_WS_ONAIMING: "التصويب",
  T_46_META_WS_ONASSIST: "مساعدة",
  T_46_META_WS_ONATTACK: "هجوم",
  T_46_META_WS_ONATTACKSTOP: "توقف الهجوم",
  T_46_META_WS_ONAWAKE: "استيقاظ",
  T_46_META_WS_ONBEKNOCKEDDOWN: "تم إسقاطه",
  T_46_META_WS_ONBOUNCEDBYTIRE: "تم القفز بواسطة الإطار",
  T_46_META_WS_ONBOUNCEENTITY: "تم قذف الكيان",
  T_46_META_WS_ONBUILTINBUTTONTAPPED: "تم النقر على زر واجهة المستخدم المدمج",
  T_46_META_WS_ONBULLETHIT: "ضرب الرصاصة",
  T_46_META_WS_ONCAMERARAYCAST: "توجيه الكاميرا",
  T_46_META_WS_ONCHARACTERCONTROLLERHIT: "ضرب وحدة التحكم بالشخصية",
  T_46_META_WS_ONCHASE: "مطاردة",
  T_46_META_WS_ONCHASESTOP: "توقف المطاردة",
  T_46_META_WS_ONCLIPEND: "نهاية المقطع",
  T_46_META_WS_ONCOLLISIONENTER: "بدء الاصطدام",
  T_46_META_WS_ONCOLLISIONEXIT: "نهاية الاصطدام",
  T_46_META_WS_ONCOUNTDOWNFINISHED: "انتهاء العد التنازلي",
  T_46_META_WS_ONCREEP: "الزحف",
  T_46_META_WS_ONCROUCH: "القرفصاء",
  T_46_META_WS_ONDEALDAMAGE: "إلحاق الضرر",
  T_46_META_WS_ONDESTROY: "تدمير",
  T_46_META_WS_ONDISABLE: "تعطيل",
  T_46_META_WS_ONDISCONNECT: "فصل",
  T_46_META_WS_ONDOUBLETAPPED: "تم النقر مرتين",
  T_46_META_WS_ONDRAG: "سحب",
  T_46_META_WS_ONDRAGEND: "نهاية السحب",
  T_46_META_WS_ONDRAGSTART: "بدء السحب",
  T_46_META_WS_ONDRIVED: "تمت القيادة",
  T_46_META_WS_ONDRIVEVEHICLE: "قيادة المركبة",
  T_46_META_WS_ONDROPCONSUMABLE: "إسقاط المواد الاستهلاكية",
  T_46_META_WS_ONDROPPED: "تم إسقاطه",
  T_46_META_WS_ONDROPWEAPON: "إسقاط السلاح",
  T_46_META_WS_ONEACHLOOP: "كل حلقة",
  T_46_META_WS_ONELIMINATE: "القضاء",
  T_46_META_WS_ONELIMINATED: "تم القضاء عليه",
  T_46_META_WS_ONENABLE: "تفعيل",
  T_46_META_WS_ONEND: "نهاية",
  T_46_META_WS_ONENTERED: "دخول",
  T_46_META_WS_ONENTERVEHICLE: "دخول المركبة",
  T_46_META_WS_ONENTITYENTER: "عند دخول المشغّل",
  T_46_META_WS_ONENTITYEXIT: "عند مغادرة المشغّل",
  T_46_META_WS_ONEQUIPARMOR: "تجهيز الدرع",
  T_46_META_WS_ONEQUIPED: "تم تجهيزه",
  T_46_META_WS_ONEQUIPWEAPON: "تجهيز السلاح",
  T_46_META_WS_ONEXPLODE: "انفجار",
  T_46_META_WS_ONFALL: "عند السقوط",
  T_46_META_WS_ONFALLSTOP: "عند انتهاء السقوط",
  T_46_META_WS_ONFIRE: "إطلاق النار",
  T_46_META_WS_ONFIXEDUPDATE: "تحديث ثابت",
  T_46_META_WS_ONFOOTBALLCOLLIDED: "اصطدام بالكرة",
  T_46_META_WS_ONFRIENDSUPDATE: "تحديث حالة الصداقة ",
  T_46_META_WS_ONGAMEEND: "نهاية اللعبة",
  T_46_META_WS_ONGAMEPAUSE: "إيقاف اللعبة مؤقتًا",
  T_46_META_WS_ONGAMERESUME: "استئناف اللعبة",
  T_46_META_WS_ONGAMESTART: "بدء اللعبة",
  T_46_META_WS_ONGOAL: "هدف",
  T_46_META_WS_ONHITBYBULLET: "تم الضرب بالرصاصة",
  T_46_META_WS_ONHITFLY: "تم الضرب أثناء الطيران",
  T_46_META_WS_ONHITFLYENTITY: "ضرب الكيان الطائر",
  T_46_META_WS_ONHOOKGUNFIRE: "إطلاق مسدس الخطاف",
  T_46_META_WS_ONIDLE: "خمول",
  T_46_META_WS_ONJAILBREAKAREABEGIN: "بداية منطقة الهروب",
  T_46_META_WS_ONJAILBREAKAREAEND: "نهاية منطقة الهروب",
  T_46_META_WS_ONJAILBREAKPLAYERJOIN: "اللاعب ينضم إلى منطقة الهروب",
  T_46_META_WS_ONJAILBREAKPLAYERQUIT: "خروج لاعب كسر السجن",
  T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY: "تم الانضمام بنجاح إلى قناة الدردشة",
  T_46_META_WS_ONJOYSTICKMOVE: "تحريك عصا التحكم",
  T_46_META_WS_ONJOYSTICKPRESSED: "تم الضغط",
  T_46_META_WS_ONJOYSTICKRELEASED: "تم الإفراج",
  T_46_META_WS_ONJUMP: "القفز",
  T_46_META_WS_ONJUMPSTOP: "عند انتهاء القفز",
  T_46_META_WS_ONLANDMINEACTIVE: "تم تفعيل اللغم",
  T_46_META_WS_ONLANDMINETRIGGER: "تم تفعيل لغم",
  T_46_META_WS_ONLEAVECHATCHANNEL: "مغادرة قناة الدردشة",
  T_46_META_WS_ONLEAVEVEHICLE: "مغادرة المركبة",
  T_46_META_WS_ONLEFT: "مغادرة",
  T_46_META_WS_ONLEVELOBJECTBEMORPHED: "تم تحويل عنصر المستوى",
  T_46_META_WS_ONMOVE: "التحرك",
  T_46_META_WS_ONNODEENTER: "دخول العقدة",
  T_46_META_WS_ONNODEEXIT: "خروج العقدة",
  T_46_META_WS_ONPAUSE: "إيقاف مؤقت",
  T_46_META_WS_ONPHASEEND: "نهاية المرحلة",
  T_46_META_WS_ONPHASESTART: "بدء المرحلة",
  T_46_META_WS_ONPICKEDUP: "تم التقاطه",
  T_46_META_WS_ONPLAYERASSIST: "مساعدة اللاعب",
  T_46_META_WS_ONPLAYERBEELIMINATED: "تم القضاء على اللاعب",
  T_46_META_WS_ONPLAYERBEKNOCKEDDOWN: "تم إسقاط اللاعب",
  T_46_META_WS_ONPLAYERDEALDAMAGE: "اللاعب يلحق الضرر",
  T_46_META_WS_ONPLAYERELIMINATE: "اللاعب يقضي على",
  T_46_META_WS_ONPLAYERENTER: "دخول اللاعب",
  T_46_META_WS_ONPLAYERJOIN: "دخول اللاعب",
  T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE: "فشل الانضمام إلى قناة الدردشة",
  T_46_META_WS_ONPLAYERLEAVE: "خروج اللاعب",
  T_46_META_WS_ONPLAYERPURCHASEREQUEST: "اللاعب يطلب الشراء",
  T_46_META_WS_ONPLAYERQUIT: "عندما يترك اللاعب اللعبة في منتصفها",
  T_46_META_WS_ONPLAYERRANKCHANGE: "تغيير ترتيب اللاعب",
  T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED: "تم تلبية طلب الشراء",
  T_46_META_WS_ONPLAYERREVIVED: "إحياء اللاعب",
  T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS: "إحياء اللاعب في نقطة الولادة",
  T_46_META_WS_ONPLAYERSCORECHANGE: "تغيير نقاط اللاعب",
  T_46_META_WS_ONPLAYERSWITCHSCENE: "اللاعب يبدل المشهد",
  T_46_META_WS_ONPREDEALDAMAGE: "قبل إلحاق الضرر",
  T_46_META_WS_ONPREPURCHASE: "قبل الشراء",
  T_46_META_WS_ONPRESSED: "تم الضغط",
  T_46_META_WS_ONPRETAKEDAMAGE: "قبل تلقي الضرر",
  T_46_META_WS_ONPURCHASE: "الشراء",
  T_46_META_WS_ONRANKCHANGED: "تغيير ترتيب الكيان",
  T_46_META_WS_ONRECONNECT: "إعادة الاتصال",
  T_46_META_WS_ONRELEASED: "تم الإفراج",
  T_46_META_WS_ONRELOAD: "إعادة التحميل",
  T_46_META_WS_ONRESUME: "استئناف",
  T_46_META_WS_ONREVIVED: "تم إحياؤه",
  T_46_META_WS_ONROUNDEND: "نهاية الجولة",
  T_46_META_WS_ONROUNDSTART: "بدء الجولة",
  T_46_META_WS_ONSCENELOAD: "تحميل المشهد",
  T_46_META_WS_ONSCENESWITCH: "تبديل المشهد",
  T_46_META_WS_ONSCORECHANGE: "تغيير نقاط الكيان",
  T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER: "تم إطلاق النار من قبل لاعب كرة القدم",
  T_46_META_WS_ONSLEEP: "نوم",
  T_46_META_WS_ONSPAWN: "توليد",
  T_46_META_WS_ONSPRAY: "رش",
  T_46_META_WS_ONSPRAYED: "تم الرش",
  T_46_META_WS_ONSPRINT: "الجري السريع",
  T_46_META_WS_ONSPRINTSTOP: "توقف الجري السريع",
  T_46_META_WS_ONSTANDUP: "الوقوف",
  T_46_META_WS_ONSTART: "بدء",
  T_46_META_WS_ONSTARTFIRE: "الهجوم",
  T_46_META_WS_ONSTATEEND: "نهاية الحالة",
  T_46_META_WS_ONSURFING: "ركوب الأمواج",
  T_46_META_WS_ONSURFINGSTOP: "توقف ركوب الأمواج",
  T_46_META_WS_ONSWITCHHANDHELD: "تبديل الجهاز المحمول",
  T_46_META_WS_ONTAKEDAMAGE: "تلقي الضرر",
  T_46_META_WS_ONTAPPED: "تم النقر",
  T_46_META_WS_ONTEAMACE: "تم القضاء على الفريق بالكامل",
  T_46_META_WS_ONTEAMADD: "إضافة الفريق",
  T_46_META_WS_ONTEAMREMOVE: "إزالة الفريق",
  T_46_META_WS_ONTEAMROUNDRANKCHANGE: "تغيير ترتيب الفريق في الجولة",
  T_46_META_WS_ONTEAMSCORECHANGE: "تغيير نقاط الفريق",
  T_46_META_WS_ONTELEPORTENTITY: "نقل الكيان",
  T_46_META_WS_ONTEXTCHANGE: "تغيير النص",
  T_46_META_WS_ONTHROWABLEEXPLODE: "انفجار القذيفة",
  T_46_META_WS_ONTOGGLE: "تبديل",
  T_46_META_WS_ONTOUCHDOWN: "لمس للأسفل",
  T_46_META_WS_ONTOUCHUP: "لمس للأعلى",
  T_46_META_WS_ONUIHIDE: "إخفاء واجهة المستخدم",
  T_46_META_WS_ONUISHOW: "عرض واجهة المستخدم",
  T_46_META_WS_ONUPDATE: "تحديث",
  T_46_META_WS_ONUSEAVATARSKILL: "استخدام مهارة الأفاتار",
  T_46_META_WS_ONUSECONSUMABLE: "استخدام المواد الاستهلاكية",
  T_46_META_WS_ONUSED: "تم استخدامه",
  T_46_META_WS_ONUSEPORTAL: "استخدام البوابة",
  T_46_META_WS_ONWAKEUP: "استيقاظ",
  T_46_META_WS_ONWEAPONBEEQUIPED: "تجهيز السلاح",
  T_46_META_WS_ONWEAPONDEALDAMAGE: "إلحاق الضرر بالسلاح",
  T_46_META_WS_ONWEAPONELIMINATE: "القضاء بالسلاح",
  T_46_META_WS_ONWEAPONSTOPFIRING: "توقف السلاح عن إطلاق النار",
  T_46_META_WS_OWNER: "المالك",
  T_46_META_WS_P_ACCELERATE: "تسارع",
  T_46_META_WS_P_ACCELERATION: "التسارع",
  T_46_META_WS_P_ACCOUNTID: "رقم الحساب",
  T_46_META_WS_P_ACCURACY: "الدقة",
  T_46_META_WS_P_ACTIONTYPE: "نوع العمل",
  T_46_META_WS_P_ACTIVATEDALPHA: "شفافية التفعيل",
  T_46_META_WS_P_ACTIVE: "نشط",
  T_46_META_WS_P_ACTIVEINHIERARCHY: "نشط في التسلسل الهرمي",
  T_46_META_WS_P_ACTIVESELF: "الذات النشطة",
  T_46_META_WS_P_ACTIVETEXT: "النص النشط",
  T_46_META_WS_P_ACTUALPOSITION: "الموقع الفعلي",
  T_46_META_WS_P_AFTERACCUMULATOR: "المجمعات اللاحقة",
  T_46_META_WS_P_AIMASSISTCENTEROFFSET: "انحراف مركز المساعدة في التصويب",
  T_46_META_WS_P_AIMASSISTDISTANCE: "مسافة مساعدة التصويب",
  T_46_META_WS_P_AIMASSISTTYPE: "نوع مساعدة التصويب",
  T_46_META_WS_P_AIRDROPSTATE: "حالة السقوط الجوي",
  T_46_META_WS_P_ALIGNMENTHORIZONTAL: "محاذاة أفقية",
  T_46_META_WS_P_ALIGNMENTVERTICAL: "محاذاة رأسية",
  T_46_META_WS_P_ALLITEMS: "جميع العناصر",
  T_46_META_WS_P_ALLMEMBERS: "جميع الأعضاء",
  T_46_META_WS_P_ALLOWLOCKBYAIMASSIST: "السماح بالقفل بواسطة مساعد التصويب",
  T_46_META_WS_P_ALLOWPRESSEDOUTSIDE: "السماح بالضغط خارج المنطقة",
  T_46_META_WS_P_ALLPLAYERS: "جميع اللاعبين",
  T_46_META_WS_P_ALLTEAMMATES: "جميع زملاء الفريق",
  T_46_META_WS_P_ALPHA: "الشفافية",
  T_46_META_WS_P_ALWAYSSHOWMARK: "عرض العلامة دائمًا",
  T_46_META_WS_P_AMBIENTCOLOR: "لون الإضاءة المحيطة",
  T_46_META_WS_P_AMMOCLIPSIZE: "حجم مخزن الذخيرة",
  T_46_META_WS_P_AMMOMAGSIZE: "حجم مخزن الذخيرة",
  T_46_META_WS_P_AMMOPERSHOT: "ذخيرة لكل طلقة",
  T_46_META_WS_P_AMMOTYPE: "نوع الذخيرة",
  T_46_META_WS_P_ANCHORMAX: "تثبيت الحد الأقصى",
  T_46_META_WS_P_ANCHORMIN: "تثبيت الحد الأدنى",
  T_46_META_WS_P_ANCHOROBJECT: "الكائن المثبت",
  T_46_META_WS_P_ANCHORPOSITION: "موقع التثبيت",
  T_46_META_WS_P_ANCHORTYPE: "تمكين UITweener",
  T_46_META_WS_P_ANGLE: "الزاوية",
  T_46_META_WS_P_ANGLEDOWN: "الزاوية لأسفل",
  T_46_META_WS_P_ANGLEUP: "الزاوية لأعلى",
  T_46_META_WS_P_ANGULARDRAG: "السحب الزاوي",
  T_46_META_WS_P_ANGULARSPEED: "السرعة الزاوية",
  T_46_META_WS_P_ANGULARVELOCITY: "السرعة الزاوية (راد/ث)",
  T_46_META_WS_P_ANIMATIONCLIP: "اسم الرسوم المتحركة",
  T_46_META_WS_P_ANIMATIONCONTROLLER: "جهاز تحكم الرسوم المتحركة",
  T_46_META_WS_P_ANIMATIONCONTROLLERRESID: "معرف مورد وحدة تحكم الرسوم المتحركة",
  T_46_META_WS_P_ARMORPENETRATION: "اختراق الدرع",
  T_46_META_WS_P_ARMORPENETRATIONFACTOR: "عامل اختراق الدرع",
  T_46_META_WS_P_ARMORTYPE: "نوع الدروع",
  T_46_META_WS_P_ARROWOFFSET: "إزاحة السهم",
  T_46_META_WS_P_ARROWSIZE: "حجم السهم",
  T_46_META_WS_P_ARROWSPRITE: "صورة السهم",
  T_46_META_WS_P_ASKBUYTARGET: "هدف طلب شراء",
  T_46_META_WS_P_ATTACHTARGET: "الهدف المرفق",
  T_46_META_WS_P_ATTACKABLEFACTIONS: "الفصائل القابلة للهجوم",
  T_46_META_WS_P_ATTACKDAMAGE: "ضرر الهجوم",
  T_46_META_WS_P_ATTACKINTERVAL: "فترة الهجوم",
  T_46_META_WS_P_ATTACKRANGE: "نطاق الهجوم",
  T_46_META_WS_P_ATTACKTARGET: "هدف الهجوم",
  T_46_META_WS_P_ATTTACKABLETARGETS: "الأهداف القابلة للهجوم",
  T_46_META_WS_P_AUTOPLAY: "حالة التشغيل التلقائي",
  T_46_META_WS_P_AVAILABLEPOINT: "نقطة متاحة",
  T_46_META_WS_P_AVATAR: "الصورة الرمزية",
  T_46_META_WS_P_AVATARID: "معرف الصورة الرمزية",
  T_46_META_WS_P_BACKGROUND: "الخلفية",
  T_46_META_WS_P_BACKGROUNDALPHA: "شفافية الخلفية",
  T_46_META_WS_P_BACKGROUNDCOLOR: "لون الخلفية",
  T_46_META_WS_P_BACKGROUNDCOLOR1: "لون الخلفية 1",
  T_46_META_WS_P_BACKGROUNDCOLOR2: "لون الخلفية 2",
  T_46_META_WS_P_BACKGROUNDFILL: "تعبئة الخلفية",
  T_46_META_WS_P_BACKGROUNDICONNAME: "اسم أيقونة الخلفية",
  T_46_META_WS_P_BACKGROUNDNAME: "اسم الخلفية",
  T_46_META_WS_P_BACKGROUNDOFFSET: "إزاحة الخلفية",
  T_46_META_WS_P_BACKGROUNDRADIUS: "نصف قطر الخلفية",
  T_46_META_WS_P_BACKGROUNDSIZEDELTA: "حجم خلفية دلتا",
  T_46_META_WS_P_BACKGROUNDSPRITE: "صورة الخلفية",
  T_46_META_WS_P_BACKPACK: "حقيبة",
  T_46_META_WS_P_BACKPACKSKINID: "معرّف غلاف الحقيبة",
  T_46_META_WS_P_BACKWARDSPEED: "سرعة الرجوع",
  T_46_META_WS_P_BANNERID: "معرف الشعار",
  T_46_META_WS_P_BASEHORIZONTALSPEED: "السرعة الأفقية الأساسية",
  T_46_META_WS_P_BASEMULTIPLIER: "مضاعف الأساس",
  T_46_META_WS_P_BASETIME: "وقت البداية",
  T_46_META_WS_P_BASEVERTICALSPEED: "السرعة العمودية الأساسية",
  T_46_META_WS_P_BEFOREACCUMULATOR: "المجمعات السابقة",
  T_46_META_WS_P_BEVTREEID: "معرف شجرة السلوك",
  T_46_META_WS_P_BINDPROPERTYID: "معرف خاصية الربط",
  T_46_META_WS_P_BODY: "الجذع",
  T_46_META_WS_P_BODYDAMAGEFACTOR: "عامل ضرر الجسم",
  T_46_META_WS_P_BONEPOSITION: "موضع العظام",
  T_46_META_WS_P_BONESCALE: "تحجيم العظام",
  T_46_META_WS_P_BOOSTCD: "فترة التهدئة للمعزز",
  T_46_META_WS_P_BOOSTDURATION: "مدة التعزيز",
  T_46_META_WS_P_BOOSTSPEED: "سرعة التعزيز",
  T_46_META_WS_P_BORDERLR: "الحدود اليمنى واليسرى",
  T_46_META_WS_P_BORDERTB: "الحدود العليا والسفلى",
  T_46_META_WS_P_BOTTOMALPHA: "ألفا السفلي",
  T_46_META_WS_P_BOUNDWALLET: "نوع مرساة HUD",
  T_46_META_WS_P_BRAKEHORSEPOWER: "قوة المكابح",
  T_46_META_WS_P_BRAKETORQUE: "عزم المكابح",
  T_46_META_WS_P_BRRANK: "تصنيف BR",
  T_46_META_WS_P_BUFFTYPE: "نوع الباف",
  T_46_META_WS_P_BURNDAMAGE: "ضرر الاحتراق",
  T_46_META_WS_P_BURNINGDAMAGEINTERVAL: "فترة ضرر الاحتراق",
  T_46_META_WS_P_BURNTIME: "وقت الاحتراق",
  T_46_META_WS_P_BUTTOM: "أسفل",
  T_46_META_WS_P_BUTTONCOLORS: "ألوان الأزرار",
  T_46_META_WS_P_BUTTONNAMES: "أسماء الأزرار",
  T_46_META_WS_P_BUTTONSTYLE: "نمط الزر",
  T_46_META_WS_P_CAMERABLOCKMODE: "وضع حظر الكاميرا",
  T_46_META_WS_P_CAMERAPROJECTIONMODE: "وضع عرض الكاميرا",
  T_46_META_WS_P_CAMERATYPE: "نوع كاميرا",
  T_46_META_WS_P_CANCELDRAGIFFITS: "إلغاء السحب إذا كان مناسباً",
  T_46_META_WS_P_CANCOSTDURABILITY: "يمكن أن يكلف المتانة",
  T_46_META_WS_P_CANDAMAGED: "يمكن أن تتلف",
  T_46_META_WS_P_CANDESTROY: "يمكن تدمير",
  T_46_META_WS_P_CANDESTROYED: "يمكن تدميره",
  T_46_META_WS_P_CANSELFTRIGGER: "يمكن تفعيله ذاتياً",
  T_46_META_WS_P_CANTEAMTRIGGER: "يمكن تفعيله بواسطة الفريق",
  "T_46_META_WS_P_CANTRIGGEREDBY SELF": "يمكن تفعيله ذاتيًا",
  "T_46_META_WS_P_CANTRIGGEREDBY TEAM": "يمكن تفعيله بواسطة الفريق",
  "T_46_META_WS_P_CANTRIGGEREDBY VEHICLE": "يمكن تفعيله بواسطة المركبة",
  T_46_META_WS_P_CANVEHICLETRIGGER: "يمكن تفعيله بواسطة المركبة",
  T_46_META_WS_P_CELLSIZE: "حجم الخلية",
  T_46_META_WS_P_CELLSPACE: "مساحة الخلية",
  T_46_META_WS_P_CENTER: "المركز",
  T_46_META_WS_P_CENTERINVISIBLE: "المركز غير مرئي",
  T_46_META_WS_P_CENTEROFFSET: "انحراف المركز",
  T_46_META_WS_P_CENTEROFMASS: "مركز الكتلة",
  T_46_META_WS_P_CENTERRANGE: "النطاق المركزي",
  T_46_META_WS_P_CENTRALFLASHTIME: "وقت الوميض المركزي",
  T_46_META_WS_P_CENTRALLINEACTIVE: "الخط المركزي نشط",
  T_46_META_WS_P_CENTRALLINEPOSITION: "موضع الخط المركزي",
  T_46_META_WS_P_CHANNELID: "معرف قناة الدردشة",
  T_46_META_WS_P_CHARGEMAX: "الحد الأقصى للشحن",
  T_46_META_WS_P_CHASETARGET: "هدف المطاردة",
  T_46_META_WS_P_CHATCHANNEL: "قناة الدردشة",
  T_46_META_WS_P_CHECKPOINTID: "معرف نقطة التفتيش",
  T_46_META_WS_P_CHILDINDEX: "فهرس الطفل",
  T_46_META_WS_P_CHIPEXP: "خبرة الشريحة",
  T_46_META_WS_P_CLICKSIZE: "حجم النقر",
  T_46_META_WS_P_CLIPLENGTH: "طول المقطع",
  T_46_META_WS_P_CLIPPINGTYPE: "نوع القص",
  T_46_META_WS_P_COLLIDERID: "معرف الاصطدام",
  T_46_META_WS_P_CONSTRAIN: "القيد",
  T_46_META_WS_P_CONSTRAINT: "القيد",
  T_46_META_WS_P_CONSTRAINTCOUNT: "عدد القيود",
  T_46_META_WS_P_CONSUMABLETYPE: "نوع المستهلك",
  T_46_META_WS_P_CONTENT: "المحتوى",
  T_46_META_WS_P_CONTENTORIGIN: "أصل المحتوى",
  T_46_META_WS_P_CONTROLPOINTS: "نقاط التحكم",
  T_46_META_WS_P_COORDINATESYSTEM: "نظام الإحداثيات",
  T_46_META_WS_P_COUNT: "العدد",
  T_46_META_WS_P_COUNTDOWNENDTIME: "وقت نهاية العد التنازلي (ث)",
  T_46_META_WS_P_COUNTDOWNKEY: "مفتاح العد التنازلي",
  T_46_META_WS_P_COUNTDOWNTIME: "وقت العد التنازلي",
  T_46_META_WS_P_COUNTPERWAVE: "عدد لكل موجة",
  T_46_META_WS_P_CRASHMAXDAMAGE: "الحد الأقصى لضرر الاصطدام",
  T_46_META_WS_P_CRASHMAXSPEED: "الحد الأقصى لسرعة الاصطدام",
  T_46_META_WS_P_CRASHMESSFACTOR: "عامل جودة الاصطدام",
  T_46_META_WS_P_CRASHMINDAMAGE: "الحد الأدنى لضرر الاصطدام",
  T_46_META_WS_P_CRAWLSPEEDSCALE: "مقياس سرعة الحركة عند الزحف",
  T_46_META_WS_P_CREATEDENTITY: "الكيان المنشأ",
  T_46_META_WS_P_CROUCHWALKSPEEDSCALE: "مقياس سرعة الحركة عند الانحناء",
  T_46_META_WS_P_CSRANK: "تصنيف CS",
  "T_46_META_WS_P_CURRENT AMMO": "الذخيرة الحالية",
  T_46_META_WS_P_CURRENTANIMATIONRESOURCE: "مورد الرسوم المتحركة الحالي",
  T_46_META_WS_P_CURRENTCLIP: "المقطع الحالي",
  T_46_META_WS_P_CURRENTCLIPPROGRESS: "تقدم المقطع الحالي",
  T_46_META_WS_P_CURRENTDURABILITY: "المتانة الحالية",
  T_46_META_WS_P_CURRENTENERGY: "الطاقة الحالية",
  T_46_META_WS_P_CURRENTHANDHELDITEM: "العنصر الذي يحمل حاليا",
  T_46_META_WS_P_CURRENTHP: "الصحة الحالية",
  T_46_META_WS_P_CURRENTPHASEINDEX: "مؤشر المرحلة الحالية",
  T_46_META_WS_P_CURRENTPROGRESS: "التقدم الحالي",
  T_46_META_WS_P_CURRENTROUNDINDEX: "مؤشر الجولة الحالية",
  T_46_META_WS_P_CURRENTSTATE: "الحالة الحالية",
  T_46_META_WS_P_CURRENTVALUE: "القيمة الحالية",
  T_46_META_WS_P_CURRENTWAVE: "الموجة الحالية",
  T_46_META_WS_P_CUSTOMCHARACTERRESOURCE: "مورد الشخصية المخصص",
  T_46_META_WS_P_CUSTOMGAMERESULT: "نتيجة اللعبة المخصصة",
  T_46_META_WS_P_CUSTOMGRAVITY: "الجاذبية المخصصة",
  T_46_META_WS_P_CUSTOMPUSHFORCE: "قوة الدفع المخصصة",
  T_46_META_WS_P_CUSTOMXY: "XY مخصص",
  T_46_META_WS_P_DAMAGE: "الضرر",
  "T_46_META_WS_P_DAMAGE RANGE": "المدى",
  T_46_META_WS_P_DAMAGEFACTOR: "عامل الضرر",
  T_46_META_WS_P_DAMAGEINTERVAL: "فترة الضرر (ث)",
  T_46_META_WS_P_DAMAGERADIUS: "نصف قطر الضرر",
  T_46_META_WS_P_DAMAGERATIOHEAD: "نسبة ضرر طلقة الرأس",
  T_46_META_WS_P_DAMAGERATIOLIMB: "نسبة ضرر الأطراف",
  T_46_META_WS_P_DAMAGEREDUCTIONFACTOR: "عامل تقليل الضرر",
  T_46_META_WS_P_DAMAGETAKENPCT: "نسبة الضرر المتلقي",
  T_46_META_WS_P_DAMAGETAKENPERCENT: "نسبة الضرر المتلقى",
  T_46_META_WS_P_DAMAGEVALUE: "قيمة الضرر",
  T_46_META_WS_P_DARKNESS: "الظلام",
  T_46_META_WS_P_DECELERATIONPERCENT: "نسبة التباطؤ",
  T_46_META_WS_P_DEFAULTTEXT: "النص الافتراضي",
  T_46_META_WS_P_DEFENSE: "معدل الدفاع",
  T_46_META_WS_P_DEFENSERATE: "معدل تقليل الضرر",
  T_46_META_WS_P_DELTA: "دلتا",
  T_46_META_WS_P_DELTATIME: "وقت دلتا",
  T_46_META_WS_P_DELTAVALUE: "قيمة دلتا",
  T_46_META_WS_P_DEPTH: "العمق",
  T_46_META_WS_P_DESC: "الوصف",
  T_46_META_WS_P_DESCRIPTION: "الوصف",
  T_46_META_WS_P_DESCRIPTIONKEY: "مفتاح الوصف",
  T_46_META_WS_P_DESCRIPTIONPARAMS: "معلمات الوصف",
  T_46_META_WS_P_DESTVAL: "قيمة الوجهة",
  T_46_META_WS_P_DETECTRANGE: "منطقة المطاردة",
  T_46_META_WS_P_DIFFUSEALPHA: "ألفا التوزيع",
  T_46_META_WS_P_DIFFUSECOLOR: "اللون الموزع",
  T_46_META_WS_P_DIFFUSETEXTURE: "نسيج الانتشار",
  T_46_META_WS_P_DISABLECOLOR: "لون غير مفعل",
  T_46_META_WS_P_DISABLEFALLDAMAGE: "تعطيل الضرر عند السقوط",
  T_46_META_WS_P_DISABLEITEMDROP: "تعطيل إسقاط العناصر",
  T_46_META_WS_P_DISABLEITEMPICKUP: "تعطيل التقاط العناصر",
  T_46_META_WS_P_DISABLEMANUALCLOSING: "تعطيل الإغلاق اليدوي",
  T_46_META_WS_P_DISABLEQUICKCHAT: "تعطيل الدردشة السريعة",
  T_46_META_WS_P_DISABLERECIPROCATING: "تعطيل الحركة المتبادلة",
  T_46_META_WS_P_DISABLEVOICECHAT: "تعطيل الدردشة الصوتية",
  T_46_META_WS_P_DISTANCE: "المسافة",
  T_46_META_WS_P_DOUBLEGUNTYPE: "نوع الأكيمبو",
  T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE: "مقياس سرعة الحركة عند الزحف",
  T_46_META_WS_P_DOWNSPEED: "سرعة الهبوط",
  T_46_META_WS_P_DRAG: "السحب",
  T_46_META_WS_P_DRIVER: "السائق",
  T_46_META_WS_P_DROPITEMS: "العناصر المتساقطة",
  T_46_META_WS_P_DURABILITY: "التحمل",
  T_46_META_WS_P_DURABILITYRECOVERY: "استعادة المتانة",
  T_46_META_WS_P_DURATION: "المدة",
  T_46_META_WS_P_EDGEFLASHTIME: "وقت فلاش الحافة",
  T_46_META_WS_P_EFFECTACTIVE: "تأثير نشط",
  T_46_META_WS_P_EFFECTCOLOR: "لون التأثير",
  T_46_META_WS_P_EFFECTDURATION: "مدة التأثير",
  T_46_META_WS_P_EFFECTIVETIMEINTERVAL: "فترة زمنية فعالة",
  T_46_META_WS_P_EFFECTRESID: "مسار مورد التأثير",
  T_46_META_WS_P_ENABLE: "تمكين",
  T_46_META_WS_P_ENABLEATTACK: "تمكين الهجوم",
  T_46_META_WS_P_ENABLEBOTREVIVE: "تفعيل إحياء البوت",
  T_46_META_WS_P_ENABLEDEPTHMAP: "تفعيل الخريطة العمق",
  T_46_META_WS_P_ENABLEDROPONDEATH: "تمكين السقوط عند الموت",
  T_46_META_WS_P_ENABLELOCALIZATION: "تفعيل الترجمة",
  T_46_META_WS_P_ENABLEMOVEINMIDAIR: "هل يمكن الحركة في الهواء",
  T_46_META_WS_P_ENABLEPLAYERREVIVE: "تمكين إحياء اللاعب",
  T_46_META_WS_P_ENABLEPLAYERVIEW: "تفعيل عرض اللاعب",
  T_46_META_WS_P_ENABLEROTATEWITHGRAVITY: "هل يتبع دوران الجاذبية",
  T_46_META_WS_P_ENABLESKINATTRIBUTES: "تمكين سمات الغلاف",
  T_46_META_WS_P_ENABLESWINGING: "تمكين التأرجح",
  T_46_META_WS_P_ENABLETRACTION: "تمكين الجذب",
  T_46_META_WS_P_ENDPOSITION: "موقع النهاية",
  T_46_META_WS_P_ENDRADIUS: "نصف القطر النهائي",
  T_46_META_WS_P_ENDTIME: "وقت النهاية (ث)",
  T_46_META_WS_P_ENDTIMES: "وقت النهاية ث",
  T_46_META_WS_P_ENDVALUE: "القيمة النهائية",
  T_46_META_WS_P_ENERGY: "الطاقة",
  T_46_META_WS_P_ENERGYCOST: "تكلفة الطاقة",
  T_46_META_WS_P_ENERGYRECOVERY: "استعادة الطاقة",
  T_46_META_WS_P_ENGINEHORSEPOWER: "قوة المحرك",
  T_46_META_WS_P_ENGINETORQUE: "عزم المحرك",
  T_46_META_WS_P_EP: "EP",
  T_46_META_WS_P_EPMAX: "أقصى نقطة القوة",
  T_46_META_WS_P_EPRECOVERYAMOUNT: "كمية استعادة نقطة الطاقة",
  T_46_META_WS_P_EVENTS: "الأحداث",
  T_46_META_WS_P_EXPLODEDAMAGE: "ضرر الانفجار",
  T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR: "عامل تقليل ضرر الانفجار",
  T_46_META_WS_P_EXPLODEDELAY: "تأخير الانفجار",
  T_46_META_WS_P_EXPLODERANGE: "مدى الانفجار",
  T_46_META_WS_P_EXPLOSIONDELAY: "تأخير الانفجار",
  T_46_META_WS_P_EXPLOSIONRANGE: "نطاق الانفجار",
  T_46_META_WS_P_EXPLOSIONTIME: "تأخير الانفجار",
  T_46_META_WS_P_EXPPERDAMAGE: "الخبرة لكل ضرر",
  T_46_META_WS_P_EXPPERMOVEMILE: "الخبرة لكل ميل تم التحرك فيه",
  T_46_META_WS_P_EXPPERSECOND: "الخبرة لكل ثانية",
  T_46_META_WS_P_EXTRABACKPACKCAPACITY: "سعة الحقيبة الإضافية",
  T_46_META_WS_P_EXTRABAGCAPACITY: "المساحة الإضافية للحقائب",
  T_46_META_WS_P_EXTRAHPRATIO: "نسبة الصحة الإضافية",
  T_46_META_WS_P_FACEPAINT: "طلاء الوجه",
  T_46_META_WS_P_FACTION: "فصيل",
  T_46_META_WS_P_FALLINGDAMAGERATIO: "نسبة الضرر عند السقوط",
  T_46_META_WS_P_FALLSPEED: "سرعة السقوط",
  T_46_META_WS_P_FASTAUTORELOADSPEED: "سرعة إعادة التحميل التلقائية",
  T_46_META_WS_P_FILEID: "معرف الملف",
  T_46_META_WS_P_FILL: "التعبئة",
  T_46_META_WS_P_FILLAMOUNT: "قيمة التعبئة",
  T_46_META_WS_P_FILLDIRECTION: "اتجاه التعبئة",
  T_46_META_WS_P_FILLTYPE: "نوع التعبئة",
  T_46_META_WS_P_FIREANGLELIMIT: "حد زاوية الإطلاق",
  T_46_META_WS_P_FIRETYPE: "نوع الإطلاق",
  T_46_META_WS_P_FIRSTSCOREPARAMS: "معلمات الدرجة الأولى",
  T_46_META_WS_P_FIRSTSCORETITLE: "عنوان الدرجة الأولى",
  T_46_META_WS_P_FIRSTSCOREVALUE: "قيمة الدرجة الأولى",
  T_46_META_WS_P_FIXEDDELTATIME: "وقت دلتا الثابت",
  T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH: "تبديل تأثير إصابة القنبلة الوامضة",
  T_46_META_WS_P_FLIP: "الانعكاس",
  T_46_META_WS_P_FLIPTYPE: "نوع التدوير",
  T_46_META_WS_P_FLYMAXHEIGHT: "أقصى ارتفاع للطيران",
  T_46_META_WS_P_FLYSPEEDHORIZONTAL: "سرعة الانزلاق الأفقية",
  T_46_META_WS_P_FLYSPEEDVERTICAL: "سرعة الانزلاق العمودية",
  T_46_META_WS_P_FOGCOLOR: "لون الضباب",
  T_46_META_WS_P_FOLLOWTARGET: "تتبع الهدف",
  T_46_META_WS_P_FONT: "خط",
  T_46_META_WS_P_FONTSIZE: "حجم الخط",
  T_46_META_WS_P_FONTSTYLE: "نمط الخط",
  T_46_META_WS_P_FONTTYPE: "نوع الخط",
  T_46_META_WS_P_FORCESYNCTOCLIENT: "إجبار التزامن مع العميل",
  T_46_META_WS_P_FORWARD: "إلى الأمام",
  T_46_META_WS_P_FORWARDSPEED: "سرعة التقدم",
  T_46_META_WS_P_FOV: "مجال الرؤية",
  T_46_META_WS_P_FREEZEDURATION: "مدة التجميد (ثانية)",
  T_46_META_WS_P_FRIENDFACTIONS: "الفصائل الصديقة",
  T_46_META_WS_P_FRIENDLYPLAYERS: "اللاعبون الودودون",
  T_46_META_WS_P_FULLDAMAGEDISTANCE: "مسافة الضرر الكامل",
  T_46_META_WS_P_FUNCTIONTYPE: "نوع الوظيفة",
  T_46_META_WS_P_GAINHPCOLOR: "لون زيادة الصحة",
  T_46_META_WS_P_GAMEFRAMECOUNT: "عدد الإطارات",
  T_46_META_WS_P_GAMETIMECOUNT: "وقت اللعبة",
  T_46_META_WS_P_GEARSHIFTINGDELAY: "تأخير تغيير الترس",
  T_46_META_WS_P_GENDER: "جنس",
  T_46_META_WS_P_GETONBOOSTCD: "فترة التهدئة بعد الصعود على البوست",
  T_46_META_WS_P_GETONBOOSTCDSWITCH: "مفتاح فترة التهدئة بعد الصعود على البوست",
  T_46_META_WS_P_GETONSKATEBOARDCD: "فترة التهدئة لركوب المزلاجة",
  T_46_META_WS_P_GRADIENT: "التدرج اللوني",
  T_46_META_WS_P_GRADIENTBOTTOM: "تدرج اللون السفلي",
  T_46_META_WS_P_GRADIENTTOP: "تدرج اللون العلوي",
  T_46_META_WS_P_GRAVITY: "الجاذبية",
  T_46_META_WS_P_GRENADEMAXDAMAGE: "الحد الأقصى للضرر بالقنبلة",
  T_46_META_WS_P_GRENADEMINDAMAGE: "الحد الأدنى للضرر بالقنبلة",
  T_46_META_WS_P_GRENADERANGE: "مدى القنبلة",
  T_46_META_WS_P_GROUPID: "معرف المجموعة",
  T_46_META_WS_P_HEAD: "رأس",
  T_46_META_WS_P_HEADDAMAGEFACTOR: "عامل ضرر الرأس",
  T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION: "تقليل ضرر طلقة الرأس",
  T_46_META_WS_P_HEIGHT: "الارتفاع",
  T_46_META_WS_P_HELMET: "خوذة",
  T_46_META_WS_P_HIGHESTBRRANK: "أعلى تصنيف BR",
  T_46_META_WS_P_HIGHESTCSRANK: "أعلى تصنيف CS",
  T_46_META_WS_P_HIGHSHOOTANGLEMIN: "الحد الأدنى لزاوية الارتفاع",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLE: "حد التوجيه عند السرعة العالية",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED: "عتبة حد التوجيه عند السرعة العالية",
  T_46_META_WS_P_HITPOINTEFFECT: "تأثير نقطة الضربة",
  T_46_META_WS_P_HORIZONTALBAR: "شريط أفقي",
  T_46_META_WS_P_HORIZONTALOFFSET: "الإزاحة الأفقية",
  T_46_META_WS_P_HOSTILETEAMS: "فرق العدو",
  T_46_META_WS_P_HOSTTEAM: "الفريق المضيف",
  T_46_META_WS_P_HP: "الصحة",
  T_46_META_WS_P_HPMAX: "الحد الأقصى للـ HP",
  T_46_META_WS_P_HPRECOVERYAMOUNT: "كمية استعادة الصحة",
  T_46_META_WS_P_HPRECOVERYSPEED: "سرعة استعادة نقاط الصحة (مللي ثانية)",
  T_46_META_WS_P_ICON: "الأيقونة",
  T_46_META_WS_P_ICONCOLOR: "لون الأيقونة",
  T_46_META_WS_P_ICONNAME: "اسم الأيقونة",
  T_46_META_WS_P_ICONRESOURCE: "مورد الأيقونة",
  T_46_META_WS_P_ID: "المعرف",
  "T_46_META_WS_P_IDAMAGE NTERVAL": "فترة الضرر (ث)",
  T_46_META_WS_P_IDLEBRAKEINPUT: "نسبة الفرملة الساكنة",
  T_46_META_WS_P_INACTIVATEDALPHA: "شفافية إلغاء التفعيل",
  T_46_META_WS_P_INDEX: "الفهرس",
  T_46_META_WS_P_INITIALMAGCOUNT: "عدد المخازن الأولية",
  T_46_META_WS_P_INITIALSPEED: "السرعة الأولية",
  T_46_META_WS_P_INITIALVALUE: "القيمة الأولية",
  T_46_META_WS_P_INITIALWORLDPOSITION: "موقع العالم الأولي",
  T_46_META_WS_P_INSCENE: "في المشهد",
  T_46_META_WS_P_INSTANCEID: "معرّف الحالة",
  T_46_META_WS_P_INTENSITY: "الكثافة",
  T_46_META_WS_P_INVERTFILL: "عكس التعبئة",
  T_46_META_WS_P_INVINCIBLE: "لا يقهر",
  "T_46_META_WS_P_IS SHOW": "هل يظهر",
  T_46_META_WS_P_IS3D: "هل هو ثلاثي الأبعاد",
  T_46_META_WS_P_ISACE: "تصفية الفريق",
  T_46_META_WS_P_ISACED: "تصفية الفريق",
  T_46_META_WS_P_ISAI: "هو الذكاء الاصطناعي",
  T_46_META_WS_P_ISALWAYSINSCREEN: "دائمًا على الشاشة",
  T_46_META_WS_P_ISAPPLYSHADOW: "تطبيق الظل",
  T_46_META_WS_P_ISATTACKABLE: "يمكن مهاجمته",
  T_46_META_WS_P_ISAUTOCHASEENEMY: "مطاردة العدو تلقائيًا",
  T_46_META_WS_P_ISAUTOPLAY: "التشغيل التلقائي",
  T_46_META_WS_P_ISAUTOTELEPORT: "هل هو الانتقال التلقائي",
  T_46_META_WS_P_ISBILLBOARD: "مواجهة الكاميرا دائمًا",
  T_46_META_WS_P_ISBOLD: "غامق",
  T_46_META_WS_P_ISBOTTOMCOLLIDING: "تصادم في الأسفل",
  T_46_META_WS_P_ISCENTERPOS: "هل هو موقع مركزي",
  T_46_META_WS_P_ISCONSUMEAMMO: "استهلاك الذخيرة",
  T_46_META_WS_P_ISCONTINUOUS: "هل هو مستمر",
  T_46_META_WS_P_ISCOUNTDOWN: "هل هو عد تنازلي",
  T_46_META_WS_P_ISCURRENTANIMATIONLOOP: "حلقة الرسوم المتحركة الحالية",
  T_46_META_WS_P_ISDEADDROP: "دعم الموت",
  T_46_META_WS_P_ISDEATHTRIGGER: "هل هو محفز الموت",
  T_46_META_WS_P_ISDEBUG: "تمكين تصحيح الأخطاء لـ BTree",
  T_46_META_WS_P_ISDEFAULTSPAWNPOINT: "هل هو نقطة ظهور افتراضية",
  T_46_META_WS_P_ISDROPONELIMINATED: "السقوط عند الإصابة",
  T_46_META_WS_P_ISEND: "هل هو نهاية",
  T_46_META_WS_P_ISFEBUTTON: "هل هو زر FE",
  T_46_META_WS_P_ISGREY: "هل هو رمادي",
  T_46_META_WS_P_ISGROUNDED: "هل هو ملامس للأرض",
  T_46_META_WS_P_ISIGNOREDEPTH: "تجاهل العمق",
  T_46_META_WS_P_ISINVINCIBLE: "لا يقهر",
  T_46_META_WS_P_ISITALIC: "مائل",
  T_46_META_WS_P_ISLASTROUND: "هل هي الجولة الأخيرة",
  T_46_META_WS_P_ISLOCALPOS: "هل هو موضع محلي",
  T_46_META_WS_P_ISLOOP: "هل يتكرر",
  T_46_META_WS_P_ISMATCHPOINT: "هل هي نقطة المباراة",
  T_46_META_WS_P_ISMOVEABLE: "تمكين التحرك",
  T_46_META_WS_P_ISOCCUPIED: "هل هو مشغول",
  T_46_META_WS_P_ISOPENTWEEN: "تم تفعيل Tween",
  T_46_META_WS_P_ISPLAYING: "قيد التشغيل",
  T_46_META_WS_P_ISPURCHASABLE: "عناصر المتجر",
  T_46_META_WS_P_ISREVERSE: "عكس",
  T_46_META_WS_P_ISSERVERDRIVEN: "هل يقوده الخادم",
  T_46_META_WS_P_ISSHOW: "عرض",
  T_46_META_WS_P_ISSHOWHUDNAME: "عرض اسم HUD",
  T_46_META_WS_P_ISSHOWMAPINFO: "عرض معلومات الخريطة",
  T_46_META_WS_P_ISSHOWQUICKMESSAGE: "عرض الرسائل السريعة",
  T_46_META_WS_P_ISSHOWSCAN: "عرض المسح",
  T_46_META_WS_P_ISSHOWTAG: "عرض العلامة",
  T_46_META_WS_P_ISSIDECOLLIDING: "هل يحدث تصادم في الجوانب",
  T_46_META_WS_P_ISSILENCE: "تم كتم الصوت",
  T_46_META_WS_P_ISSINGLESHOT: "طلقة واحدة",
  T_46_META_WS_P_ISSKIPSTAGGERANIMATION: "تخطي الرسوم المتحركة المتعثرة",
  T_46_META_WS_P_ISSLIDING: "هل ينزلق",
  T_46_META_WS_P_ISTOPCOLLIDING: "هل يحدث تصادم في الأعلى",
  T_46_META_WS_P_ISUNDERLINE: "خط تحت",
  T_46_META_WS_P_ISVISIBLE: "مرئي",
  T_46_META_WS_P_ITEMBACKGROUNDCOLORS: "ألوان خلفيات البطاقات",
  T_46_META_WS_P_ITEMBACKGROUNDS: "خلفيات البطاقات",
  T_46_META_WS_P_ITEMCOUNTS: "قابلية الشراء",
  T_46_META_WS_P_ITEMDESCRIPTIONS: "أوصاف البطاقات",
  T_46_META_WS_P_ITEMICONS: "أيقونات البطاقات",
  T_46_META_WS_P_ITEMID: "معرّف السلاح",
  T_46_META_WS_P_ITEMIDS: "معرفات العناصر",
  T_46_META_WS_P_ITEMNAMES: "أسماء البطاقات",
  T_46_META_WS_P_ITEMPICKUPBANLIST: "قائمة حظر التقاط العناصر",
  T_46_META_WS_P_JOYSTICKDRAGRADIUS: "نصف قطر سحب غطاء عصا التحكم",
  T_46_META_WS_P_JOYSTICKIMAGE: "صورة غطاء عصا التحكم",
  T_46_META_WS_P_JOYSTICKRADIUS: "نصف قطر غطاء عصا التحكم",
  T_46_META_WS_P_JUMPCD: "فترة التهدئة للقفز",
  T_46_META_WS_P_JUMPHEIGHT: "ارتفاع القفز",
  T_46_META_WS_P_JUMPHEIGHTSCALE: "معدل ارتفاع القفز",
  T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS: "مكافأة ضرر الإسقاط",
  T_46_META_WS_P_KNOCKDOWNSTATUS: "حالة السقوط",
  T_46_META_WS_P_LABEL: "التسمية",
  T_46_META_WS_P_LABELCOLOR: "لون التسمية",
  T_46_META_WS_P_LABELKEY: "مفتاح التسمية",
  T_46_META_WS_P_LABELPARAMS: "معلمات التسمية",
  T_46_META_WS_P_LASTCHECKPOINTID: "معرف النقطة الحالية",
  T_46_META_WS_P_LASTSURVIVALTIME: "آخر وقت للبقاء",
  T_46_META_WS_P_LAYERTYPE: "نوع الطبقة",
  T_46_META_WS_P_LAYOUTTYPE: "نوع التخطيط",
  T_46_META_WS_P_LEFTARM: "الذراع اليسرى",
  T_46_META_WS_P_LEFTBACKGROUNDCOLOR: "لون خلفية الفريق الأيسر",
  T_46_META_WS_P_LEFTCOLOR: "لون اليسار",
  T_46_META_WS_P_LEFTDESCRIPTION: "وصف الفريق الأيسر",
  T_46_META_WS_P_LEFTEFFECTACTIVE: "تأثير اليسار نشط",
  T_46_META_WS_P_LEFTFIRINGARCANGLE: "زاوية إطلاق النار اليسرى",
  T_46_META_WS_P_LEFTFOOT: "القدم اليسرى",
  T_46_META_WS_P_LEFTHAND: "اليد اليسرى",
  T_46_META_WS_P_LEFTICON: "الأيقونة اليسرى",
  T_46_META_WS_P_LEFTICONNAME: "اسم الأيقونة للفريق الأيسر",
  T_46_META_WS_P_LEFTLEG: "الساق اليسرى",
  T_46_META_WS_P_LEFTPLAYERS: "لاعبو الفريق الأيسر",
  T_46_META_WS_P_LEFTSCORE: "الدرجة اليسرى",
  T_46_META_WS_P_LEFTSCOREAFTER: "الدرجة النهائية اليسرى",
  T_46_META_WS_P_LEFTSCORETEXT: "درجة اليسار",
  T_46_META_WS_P_LEFTTEAM: "الفريق الأيمن",
  T_46_META_WS_P_LEFTTEAMINDEX: "مؤشر الفريق الأيسر",
  T_46_META_WS_P_LEFTTEAMMATEALIVENUM: "عدد اللاعبين الأحياء في الفريق الأيسر",
  T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT: "عدد الأعلام للاعبين الأيسر",
  T_46_META_WS_P_LEFTTEAMMATESTATES: "حالة اللاعبين الأيسر",
  T_46_META_WS_P_LEFTTEAMNAME: "اسم الفريق الأيسر",
  T_46_META_WS_P_LEFTTEAMSCORE: "درجة الفريق الأيسر",
  T_46_META_WS_P_LEFTTEXT: "النص اليساري",
  T_46_META_WS_P_LENGTH: "الطول",
  T_46_META_WS_P_LENSFLARE: "بريق العدسة",
  T_46_META_WS_P_LEVEL: "المستوى",
  T_46_META_WS_P_LIFETIME: "مدة الحياة (ث)",
  T_46_META_WS_P_LIGHTCOLOR: "لون الضوء",
  T_46_META_WS_P_LIGHTINTENSITY: "سطوع مصدر الضوء",
  T_46_META_WS_P_LIMBDAMAGEFACTOR: "عامل ضرر الأطراف",
  T_46_META_WS_P_LINESPACING: "تباعد الأسطر",
  T_46_META_WS_P_LOCALPOSITION: "الموقع المحلي",
  T_46_META_WS_P_LOCALROTATION: "الدوران المحلي",
  T_46_META_WS_P_LOCALROTATIONQ: "كواتيرنيون دوران محلي",
  T_46_META_WS_P_LOCALSCALE: "مقياس محلي",
  T_46_META_WS_P_LOCKEY: "مفتاح التوطين",
  T_46_META_WS_P_LOOPCOUNT: "عدد الحلقة",
  T_46_META_WS_P_LOOTSOCCER: "نهب كرة القدم",
  T_46_META_WS_P_LOSEHPCOLOR: "لون فقدان الصحة",
  T_46_META_WS_P_LOSEMVPS: "MVP للخاسرين",
  T_46_META_WS_P_LOSETEXT: "نص الخسارة",
  "T_46_META_WS_P_MAIN CAMERA": "الكاميرا الرئيسية",
  T_46_META_WS_P_MAINCOLOR: "اللون الرئيسي",
  T_46_META_WS_P_MAINSCORELIST: "النقاط الرئيسية",
  T_46_META_WS_P_MAINSCORETITLE: "عنوان النقاط الرئيسية",
  T_46_META_WS_P_MAINWEAPON: "السلاح الرئيسي",
  T_46_META_WS_P_MAPSIZE: "حجم الخريطة",
  T_46_META_WS_P_MASK: "قناع",
  T_46_META_WS_P_MASKNAME: "اسم القناع",
  T_46_META_WS_P_MASS: "الكتلة (كغ)",
  T_46_META_WS_P_MATCHTITLELEFT: "عنوان المباراة اليسار",
  T_46_META_WS_P_MATCHTITLERIGHT: "عنوان المباراة اليمين",
  T_46_META_WS_P_MAXCAPACITY: "السعة القصوى",
  T_46_META_WS_P_MAXCOUNT: "الحد الأقصى للعدد",
  T_46_META_WS_P_MAXDAMAGE: "أقصى ضرر",
  T_46_META_WS_P_MAXDEPRESSIONANGLE: "أقصى زاوية انخفاض",
  T_46_META_WS_P_MAXDISPLACEMENT: "أقصى إزاحة",
  T_46_META_WS_P_MAXDISTANCE: "الحد الأقصى للمسافة",
  T_46_META_WS_P_MAXDURABILITY: "أقصى متانة",
  T_46_META_WS_P_MAXDURABILITYRATIO: "نسبة التحمل القصوى",
  T_46_META_WS_P_MAXENERGY: "أقصى طاقة",
  T_46_META_WS_P_MAXEP: "أقصى نقطة الطاقة",
  T_46_META_WS_P_MAXHP: "الصحة القصوى",
  T_46_META_WS_P_MAXJUMPCOUNT: "أقصى عدد قفزات متتالية",
  T_46_META_WS_P_MAXJUMPHEIGHT: "أقصى ارتفاع للقفز المزدوج",
  T_46_META_WS_P_MAXLENGTH: "الحد الأقصى للطول",
  T_46_META_WS_P_MAXPROGRESS: "أقصى تقدم",
  T_46_META_WS_P_MAXSCATTERRATIO: "نسبة التشتت القصوى",
  T_46_META_WS_P_MAXSPEED: "أقصى سرعة حركة",
  T_46_META_WS_P_MAXTURRETCOUNT: "الحد الأقصى لعدد المدافع",
  T_46_META_WS_P_MAXVALUE: "القيمة القصوى",
  T_46_META_WS_P_MAXWIDGETID: "أقصى معرف Widget",
  T_46_META_WS_P_MINDAMAGE: "الحد الأدنى للضرر",
  T_46_META_WS_P_MINDAMAGEDISTANCE: "الحد الأدنى لمسافة الضرر",
  T_46_META_WS_P_MINDISTANCE: "الحد الأدنى للمسافة",
  T_46_META_WS_P_MINELEVATIONANGLE: "الحد الأدنى لزاوية الارتفاع",
  T_46_META_WS_P_MINENDHEIGHT: "أقل ارتفاع النهاية",
  T_46_META_WS_P_MINFLYHEIGHT: "أدنى ارتفاع للطيران",
  T_46_META_WS_P_MINMOVEDISTANCE: "الحد الأدنى لمسافة الحركة",
  T_46_META_WS_P_MINVALUE: "الحد الأدنى للقيمة",
  T_46_META_WS_P_MISSILEMAXDAMAGE: "أقصى ضرر للصاروخ",
  T_46_META_WS_P_MISSILEMINDAMAGE: "الحد الأدنى من ضرر الصاروخ",
  T_46_META_WS_P_MISSILERANGE: "مدى الصاروخ",
  T_46_META_WS_P_MODEL: "النموذج",
  T_46_META_WS_P_MODELVISIBILITY: "رؤية النموذج",
  T_46_META_WS_P_MODELVISIBLE: "نموذج مرئي",
  T_46_META_WS_P_MONEY: "المال",
  T_46_META_WS_P_MONEYLIST: "قائمة المال",
  T_46_META_WS_P_MONEYS: "المحفظة المرتبطة",
  T_46_META_WS_P_MONEYTYPE: "نوع العملة",
  T_46_META_WS_P_MONSTERTYPE: "نوع الوحش",
  T_46_META_WS_P_MOTIONTYPE: "نوع الحركة",
  T_46_META_WS_P_MOTIONVALUEX: "قيمة الحركة X",
  T_46_META_WS_P_MOTIONVALUEY: "قيمة الحركة Y",
  T_46_META_WS_P_MOTIONVALUEZ: "قيمة الحركة Z",
  T_46_META_WS_P_MOVEMENTDURATION: "مدة الحركة",
  T_46_META_WS_P_MULTIPLIER: "المضاعف",
  T_46_META_WS_P_MUSICELEMENTTYPE: "نوع عنصر الموسيقى",
  T_46_META_WS_P_MUZZLEVELOCITY: "سرعة الفوهة",
  T_46_META_WS_P_MVP: "أفضل لاعب",
  T_46_META_WS_P_NAME: "الاسم",
  T_46_META_WS_P_NEXTROUNDINDEX: "مؤشر الجولة التالية",
  T_46_META_WS_P_NICKNAME: "الاسم المستعار",
  T_46_META_WS_P_NORMALCOLOR: "اللون الافتراضي",
  T_46_META_WS_P_NORMALIZEDPOSITION: "الموضع الطبيعي",
  T_46_META_WS_P_NUMBERINFACTION: "رقم في الفصيل",
  T_46_META_WS_P_OBJECTID: "معرف الكائن",
  T_46_META_WS_P_OFFSET: "الانحراف",
  T_46_META_WS_P_OPTIONS: "الخيارات",
  T_46_META_WS_P_OTHERDAMAGEFACTOR: "عامل ضرر آخر",
  T_46_META_WS_P_OUTFIT: "زيّ",
  T_46_META_WS_P_OVERFLOW: "تجاوز النص",
  T_46_META_WS_P_OVERHEIGHTFALLSPEED: "سرعة السقوط بعد الارتفاع الزائد",
  T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION: "أولوية تكوين اللاعب",
  T_46_META_WS_P_OWNER: "مالك",
  T_46_META_WS_P_PARAMS: "معلمات",
  T_46_META_WS_P_PARENT: "الأصل",
  T_46_META_WS_P_PARENTID: "معرف الأصل",
  T_46_META_WS_P_PARENTUI: "واجهة المستخدم الأصلية",
  T_46_META_WS_P_PARENTWIDGETENTITYID: "معرف كيان الأداة الرئيسية",
  T_46_META_WS_P_PARENTWIDGETFILEID: "معرف ملف عنصر واجهة المستخدم الأب",
  T_46_META_WS_P_PARTMASKA: "قناع الجزء 1",
  T_46_META_WS_P_PASSENGERS: "الركاب",
  T_46_META_WS_P_PATHID: "معرّف المسار",
  T_46_META_WS_P_PAUSEEVENT: "إيقاف الحدث",
  T_46_META_WS_P_PERSONAID: "معرف الشخصية",
  T_46_META_WS_P_PHASEDURATION: "المدة (مللي ثانية)",
  T_46_META_WS_P_PHASEENDTIME: "وقت النهاية (مللي ثانية)",
  T_46_META_WS_P_PHYSICALLAYER: "مستوى الفيزياء",
  T_46_META_WS_P_PINID: "معرف الدبوس",
  T_46_META_WS_P_PITCH: "زاوية الميل",
  T_46_META_WS_P_PIVOT: "محور التدوير",
  T_46_META_WS_P_PLAYER: "اللاعب",
  T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR: "عامل سرعة تصويب اللاعب",
  T_46_META_WS_P_PLAYERLIST: "قائمة اللاعبين",
  T_46_META_WS_P_PLAYERNAME: "اسم اللاعب",
  T_46_META_WS_P_PLAYERRANK: "ترتيب اللاعب",
  T_46_META_WS_P_PLAYERRANKS: "ترتيب اللاعبين",
  T_46_META_WS_P_PLAYERS: "اللاعبون",
  T_46_META_WS_P_PLAYERSCORETYPES: "أنواع نقاط اللاعبين",
  T_46_META_WS_P_PLAYERSPEEDFACTOR: "عامل سرعة اللاعب",
  T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING: "عامل سرعة اللاعب أثناء الإطلاق",
  T_46_META_WS_P_PLAYERSTATUS: "حالة اللاعب",
  T_46_META_WS_P_PLAYERTRACTIONSPEED: "سرعة جذب اللاعب",
  T_46_META_WS_P_PLAYINGSTATUS: "حالة اللعب",
  T_46_META_WS_P_PLAYSPEED: "سرعة التشغيل",
  T_46_META_WS_P_POINTPOSITION: "موقع النقطة",
  T_46_META_WS_P_POINTS: "نقاط",
  T_46_META_WS_P_POSITION: "الموقع",
  T_46_META_WS_P_PREFABID: "معرف النموذج",
  T_46_META_WS_P_PRESSEDCOLOR: "لون مضغوط",
  T_46_META_WS_P_PRESSEDSPRITE: "صورة مضغوطة",
  T_46_META_WS_P_PRESSEDSPRITETYPE: "نوع صورة مضغوطة",
  T_46_META_WS_P_PRICE: "السعر",
  T_46_META_WS_P_PRIORITY: "الأولوية",
  T_46_META_WS_P_PROFILEINFO: "معلومات الملف الشخصي",
  T_46_META_WS_P_PROGRESS: "التقدم [0,1]",
  T_46_META_WS_P_PROGRESSICON: "أيقونة التقدم",
  T_46_META_WS_P_PROGRESSICONNAME: "اسم أيقونة التقدم",
  T_46_META_WS_P_PROPID: "معرف الخاصية",
  T_46_META_WS_P_PURCHASELIMIT: "حد الشراء",
  T_46_META_WS_P_RADIUS: "نصف القطر",
  T_46_META_WS_P_RANGE: "المدى",
  T_46_META_WS_P_RANK: "الرتبة",
  T_46_META_WS_P_RATIOSELFFACTOR: "عامل الضرر الذاتي",
  T_46_META_WS_P_RATIOTEAMMATEFACTOR: "نسبة الضرر للأصدقاء",
  T_46_META_WS_P_RATIOVEHICLEFACTOR: "نسبة عامل المركبة",
  T_46_META_WS_P_REFRESHTIME: "وقت التحديث (ثانية)",
  T_46_META_WS_P_RELOADSPEED: "سرعة إعادة التحميل",
  T_46_META_WS_P_RELOADSPEEDFACTOR: "عامل سرعة إعادة التحميل",
  T_46_META_WS_P_REMAINJUMPCOUNT: "عدد القفزات المتبقية",
  T_46_META_WS_P_REMAINQUANTITY: "الكمية المتبقية",
  T_46_META_WS_P_RENDERTYPE: "نوع العرض",
  T_46_META_WS_P_REPEATTIMES: "الأوقات التي لعبت",
  T_46_META_WS_P_REPLACEMENTPRIORITY: "أولوية الاستبدال",
  T_46_META_WS_P_REQUESTEDITEMLIST: "معرف اللاعب المحفز",
  T_46_META_WS_P_REQUESTTYPE: "قائمة العناصر المطلوبة",
  T_46_META_WS_P_RESETPERROUND: "إعادة تعيين لكل جولة",
  T_46_META_WS_P_RESETPOSITION: "إعادة تعيين الموقع",
  T_46_META_WS_P_RESETTIME: "إعادة ضبط الوقت",
  T_46_META_WS_P_RESOURCE: "المورد",
  T_46_META_WS_P_RESOURCEID: "معرّف المورد",
  T_46_META_WS_P_RESTRICTWITHINPANEL: "تقييد ضمن اللوحة",
  T_46_META_WS_P_RESULT: "النتيجة",
  T_46_META_WS_P_RESULTTYPE: "نوع النتيجة",
  T_46_META_WS_P_REVIVALPOINT: "نقطة الإحياء",
  T_46_META_WS_P_REVIVECD: "فترة التهدئة للإحياء",
  T_46_META_WS_P_RIGHT: "يمين",
  T_46_META_WS_P_RIGHTARM: "الذراع اليمنى",
  T_46_META_WS_P_RIGHTBACKGROUNDCOLOR: "لون خلفية الفريق الأيمن",
  T_46_META_WS_P_RIGHTCOLOR: "لون اليمين",
  T_46_META_WS_P_RIGHTDESCRIPTION: "وصف الفريق الأيمن",
  T_46_META_WS_P_RIGHTEFFECTACTIVE: "تأثير اليمين نشط",
  T_46_META_WS_P_RIGHTFIRINGARCANGLE: "زاوية إطلاق النار اليمنى",
  T_46_META_WS_P_RIGHTFOOT: "القدم اليمنى",
  T_46_META_WS_P_RIGHTHAND: "اليد اليمنى",
  T_46_META_WS_P_RIGHTICON: "الأيقونة اليمنى",
  T_46_META_WS_P_RIGHTICONNAME: "اسم الأيقونة للفريق الأيمن",
  T_46_META_WS_P_RIGHTLEG: "الساق اليمنى",
  T_46_META_WS_P_RIGHTPLAYERS: "لاعبو الفريق الأيمن",
  T_46_META_WS_P_RIGHTSCORE: "الدرجة اليمنى",
  T_46_META_WS_P_RIGHTSCOREAFTER: "الدرجة النهائية اليمنى",
  T_46_META_WS_P_RIGHTSCORETEXT: "درجة اليمنى",
  T_46_META_WS_P_RIGHTTEAM: "العناوين",
  T_46_META_WS_P_RIGHTTEAMINDEX: "مؤشر الفريق الأيمن",
  T_46_META_WS_P_RIGHTTEAMMATEALIVENUM: "عدد اللاعبين الأحياء في الفريق الأيمن",
  T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT: "عدد أعلام الفريق الأيمن",
  T_46_META_WS_P_RIGHTTEAMMATESTATES: "حالة اللاعبين الأيمن",
  T_46_META_WS_P_RIGHTTEAMNAME: "اسم الفريق الأيمن",
  T_46_META_WS_P_RIGHTTEAMSCORE: "درجة الفريق الأيمن",
  T_46_META_WS_P_RIGHTTEXT: "النص اليمني",
  T_46_META_WS_P_RIMALPHA: "ألفا الحافة",
  T_46_META_WS_P_RIMCOLOR: "لون الحافة",
  T_46_META_WS_P_RIMTEXTURE: "نسيج الحافة",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFF: "معامل الاحتكاك المتدحرج",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING: "مضاعف الاحتكاك (التصادم)",
  T_46_META_WS_P_ROTATION: "التدوير",
  T_46_META_WS_P_ROTATIONANGLE: "زاوية الدوران",
  T_46_META_WS_P_ROTATIONQ: "رباعية الدوران",
  T_46_META_WS_P_ROUNDINCOME: "دخل الجولة",
  T_46_META_WS_P_ROUNDINCOMEDETAILNUMS: "أرقام تفاصيل الدخل للجولة",
  T_46_META_WS_P_ROUNDINCOMEDETAILTITLES: "عناوين تفاصيل الدخل للجولة",
  T_46_META_WS_P_ROUNDINCOMETITLE: "عنوان دخل الجولة",
  T_46_META_WS_P_ROUNDNUM: "رقم الجولة",
  T_46_META_WS_P_ROUNDNUMKEY: "مفتاح عدد الجولات",
  T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS: "معلمات مفتاح عدد الجولات",
  T_46_META_WS_P_RUNSPEED: "سرعة الجري",
  T_46_META_WS_P_RUNSPEEDSCALE: "مقياس سرعة الجري",
  T_46_META_WS_P_RUSHDISTANCE: "مسافة الركض",
  T_46_META_WS_P_RUSHENERGYCOST: "تكلفة الطاقة للاندفاع",
  T_46_META_WS_P_RUSHVERTICALSPEED: "سرعة رأسية للاندفاع",
  T_46_META_WS_P_SCALE: "الحجم",
  T_46_META_WS_P_SCATTERINCREASESPEED: "سرعة زيادة التشتت",
  T_46_META_WS_P_SCATTERMAX: "أقصى تشتت",
  T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING: "مضاعف التشتت أثناء الحركة",
  T_46_META_WS_P_SCATTERRECOVERSPEED: "سرعة استعادة التشتت",
  T_46_META_WS_P_SCATTERSPEED: "سرعة التشتت",
  T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE: "سرعة التشتت عند الانحناء/الاستلقاء",
  T_46_META_WS_P_SCATTERTHRESHOLD: "عتبة التشتت",
  T_46_META_WS_P_SCOPETYPE: "نوع المنظار",
  T_46_META_WS_P_SCORE: "النقاط",
  T_46_META_WS_P_SCORES1: "قائمة النقاط 1",
  T_46_META_WS_P_SCORES2: "قائمة النقاط 2",
  T_46_META_WS_P_SCORES3: "قائمة النقاط 3",
  T_46_META_WS_P_SCORES4: "قائمة النقاط 4",
  T_46_META_WS_P_SCORES5: "قائمة النقاط 5",
  T_46_META_WS_P_SCORETEXTKEY: "مفتاح نص النقاط",
  T_46_META_WS_P_SCORETEXTKEYPARAMS: "معلمات نص النقاط",
  T_46_META_WS_P_SCROLLCONTINUITY: "استمرارية التمرير",
  T_46_META_WS_P_SCROLLDIRECTION: "اتجاه التمرير",
  T_46_META_WS_P_SCROLLEFFECT: "تأثير التمرير",
  T_46_META_WS_P_SCROLLWHEELSPEED: "سرعة عجلة التمرير",
  T_46_META_WS_P_SECONDSCORETITLE: "عنوان الدرجة الثانية",
  T_46_META_WS_P_SECONDSCOREVALUE: "قيمة الدرجة الثانية",
  T_46_META_WS_P_SECONDSCOREVALUEPARAMS: "معلمات قيمة الدرجة الثانية",
  T_46_META_WS_P_SELECTEDCOLOR: "لون الصورة المحددة",
  T_46_META_WS_P_SELECTEDINDEX: "الفهرس المحدد",
  T_46_META_WS_P_SELECTEDSPRITE: "الصورة المحددة",
  T_46_META_WS_P_SELECTEDTYPE: "نوع الصورة المحددة",
  T_46_META_WS_P_SELF: "الذات",
  T_46_META_WS_P_SELFDAMAGEFACTOR: "عامل الضرر الذاتي",
  T_46_META_WS_P_SET: "مجموعة",
  T_46_META_WS_P_SHADERNAME: "اسم الظل",
  T_46_META_WS_P_SHADOWCOLOR: "لون الظل",
  T_46_META_WS_P_SHADOWOFFSET: "إزاحة الظل",
  T_46_META_WS_P_SHADOWSTRENGTH: "قوة الظلال",
  T_46_META_WS_P_SHELFS: "إيقاف الإغلاق اليدوي",
  T_46_META_WS_P_SHOES: "أحذية",
  T_46_META_WS_P_SHOOTANGLEMAX: "الحد الأعلى لزاوية الإطلاق",
  T_46_META_WS_P_SHOOTANGLEMIN: "الحد الأدنى لزاوية الإطلاق",
  T_46_META_WS_P_SHOP: "المتجر",
  T_46_META_WS_P_SHOPITEMS: "الرفوف",
  T_46_META_WS_P_SHOWADDFRIEND: "عرض إضافة صديق",
  T_46_META_WS_P_SHOWATTACKGRENADE: "عرض قنبلة الهجوم",
  T_46_META_WS_P_SHOWBACKGROUND: "عرض الخلفية",
  T_46_META_WS_P_SHOWCROUCH: "عرض الانحناء",
  T_46_META_WS_P_SHOWDAMAGENUMBER: "عرض عدد الضرر",
  T_46_META_WS_P_SHOWDEFENCEGRENADE: "عرض قنبلة الدفاع",
  T_46_META_WS_P_SHOWECCONOMY: "عرض الاقتصاد الخارجي",
  T_46_META_WS_P_SHOWECONOMY: "عرض الاقتصاد الخارجي",
  T_46_META_WS_P_SHOWFIRE: "عرض إطلاق النار",
  T_46_META_WS_P_SHOWFRAME: "عرض الإطار",
  T_46_META_WS_P_SHOWGIFT: "عرض الهدايا",
  T_46_META_WS_P_SHOWHITPOINTEFFECT: "عرض تأثير نقطة الضربة",
  T_46_META_WS_P_SHOWJUMP: "عرض القفز",
  T_46_META_WS_P_SHOWLIKE: "عرض الإعجاب",
  T_46_META_WS_P_SHOWLOBBY: "عرض العودة إلى الردهة",
  T_46_META_WS_P_SHOWMAPEVALUATE: "عرض تقييم الخريطة",
  T_46_META_WS_P_SHOWMATCHDETAIL: "عرض تفاصيل المباراة",
  T_46_META_WS_P_SHOWMOVINGJOYSTICK: "عرض عصا التحكم المتحركة",
  T_46_META_WS_P_SHOWNAME: "عرض اللقب",
  T_46_META_WS_P_SHOWPIN: "عرض الدبوس",
  T_46_META_WS_P_SHOWPRONE: "عرض الزحف",
  T_46_META_WS_P_SHOWRANK: "عرض الرتبة",
  T_46_META_WS_P_SHOWREPLAY: "عرض الإعادة",
  T_46_META_WS_P_SHOWREPORT: "عرض التقرير",
  T_46_META_WS_P_SHOWSHARE: "عرض المشاركة",
  T_46_META_WS_P_SHOWSPRINT: "عرض الجري",
  T_46_META_WS_P_SHOWTAG: "عرض العلامة",
  T_46_META_WS_P_SHOWTEAMMATESINFO: "عرض معلومات الزملاء",
  T_46_META_WS_P_SHOWTEAMMATESTATE: "عرض حالة اللاعبين",
  T_46_META_WS_P_SHOWTEAMSCORE: "عرض درجة الفريق",
  T_46_META_WS_P_SHOWTIMETYPE: "نوع العرض",
  T_46_META_WS_P_SHOWTWOTEAMSCORE: "عرض نتيجتين للفريق",
  T_46_META_WS_P_SHRINKDURATION: "مدة الانكماش (مللي ثانية)",
  T_46_META_WS_P_SHRINKENDTIME: "وقت نهاية الانكماش (مللي ثانية)",
  T_46_META_WS_P_SHRINKSPEED: "سرعة الانكماش",
  T_46_META_WS_P_SHRINKSTARTTIME: "وقت بدء التقليص (ث)",
  T_46_META_WS_P_SIGHTAIMASSIST: "السماح بمساعدة التصويب",
  T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF: "معامل توهين المسافة لمساعدة التصويب (0-1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF: "معامل التأثير لمساعد التصويب على مسافة الأولوية (>=1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX: "أقصى مسافة لأولوية مساعدة التصويب",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN: "أقل مسافة لأولوية مساعدة التصويب",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY: "السماح بأولوية المسافة لمساعدة التصويب",
  T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE: "نسبة جذب شاشة الصليب لمساعد التصويب (0-1)",
  T_46_META_WS_P_SIGHTAMPLIFYRATIO: "نسبة تكبير الرؤية",
  T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO: "تكبير زاوية الرؤية (FOV)",
  T_46_META_WS_P_SIGHTROTSENSITIVENESS: "حساسية دوران التصويب",
  T_46_META_WS_P_SIGHTSHOOTMINDAMAGE: "معامل تصحيح أقل مسافة للضرر عند التصويب",
  T_46_META_WS_P_SIGHTUIACTIONEXPAND: "وقت تكبير التصويب (ثانية)",
  T_46_META_WS_P_SIGHTUIACTIONRATIO: "تكبير التصويب",
  T_46_META_WS_P_SIGHTUIACTIONRECOVERY: "وقت استعادة التصويب (ثانية)",
  T_46_META_WS_P_SIZE: "الحجم",
  T_46_META_WS_P_SIZEDELTA: "فرق الحجم",
  T_46_META_WS_P_SKELETON: "هيكل عظمي",
  T_46_META_WS_P_SKIN: "غلاف",
  T_46_META_WS_P_SKINID: "معرف الشكل",
  T_46_META_WS_P_SKINWIDTH: "سمك الجلد",
  T_46_META_WS_P_SKYBOXENV: "صندوق السماء",
  T_46_META_WS_P_SKYBOXRESOURCE: "مورد صندوق السماء",
  T_46_META_WS_P_SLOPELIMIT: "أقصى زاوية صعود",
  T_46_META_WS_P_SMOOTHSCROLLSTART: "بدء التمرير بسلاسة",
  T_46_META_WS_P_SOFTNESS: "النعومة",
  T_46_META_WS_P_SORTTYPE: "نوع الفرز",
  T_46_META_WS_P_SPAWNCOUNTPERWAVE: "عدد التوليد لكل موجة",
  T_46_META_WS_P_SPAWNPOINT: "نقطة إنعاش",
  T_46_META_WS_P_SPAWNPOINTCOUNT: "عدد نقاط الظهور",
  T_46_META_WS_P_SPAWNPOSITION: "موقع الاستدعاء",
  T_46_META_WS_P_SPEED: "السرعة",
  T_46_META_WS_P_SPEEDWHILEAIMING: "مضاعف حساسية التصويب",
  T_46_META_WS_P_SPRAYCOLOR: "لون الرش",
  T_46_META_WS_P_SPRINTENERGYCOST: "تكلفة طاقة الركض",
  T_46_META_WS_P_SPRINTHORIZONTALSPEED: "سرعة أفقي للركض",
  T_46_META_WS_P_SPRINTSPEEDSCALE: "مقياس سرعة الركض",
  T_46_META_WS_P_SPRITENAME: "شكل الصورة",
  T_46_META_WS_P_SPRITERESOURCE: "مورد الصورة",
  T_46_META_WS_P_SRCVAL: "قيمة المصدر",
  T_46_META_WS_P_STARTDROPTIME: "وقت سقوط العناصر (مللي ثانية)",
  T_46_META_WS_P_STARTEVENT: "بدء الحدث",
  T_46_META_WS_P_STARTPOSITION: "موقع البدء",
  T_46_META_WS_P_STARTRADIUS: "نصف القطر الابتدائي",
  T_46_META_WS_P_STARTSPAWNTIME: "وقت بدء الظهور (ثانية)",
  T_46_META_WS_P_STARTTIME: "وقت البدء (ث)",
  T_46_META_WS_P_STARTVALUE: "القيمة الأولية",
  T_46_META_WS_P_STATICICONCOLORS: "ألوان أيقونات ثابتة",
  T_46_META_WS_P_STATICICONS: "أيقونات ثابتة",
  T_46_META_WS_P_STATUS: "حالة البرج الصغير",
  T_46_META_WS_P_STEPOFFSET: "ارتفاع الخطوة",
  T_46_META_WS_P_STOPDURATION: "مدة التوقف",
  T_46_META_WS_P_STOPEVENT: "إيقاف الحدث",
  T_46_META_WS_P_STORE: "المتجر",
  T_46_META_WS_P_STROPID: "معرف الرش",
  T_46_META_WS_P_STYLE: "الأسلوب",
  T_46_META_WS_P_SUBTITLE: "الترجمة الفرعية",
  T_46_META_WS_P_SUMMULTIPLIER: "مجمعات المجموع",
  T_46_META_WS_P_SWINGEXITACCELERATION: "تسريع الخروج المتأرجح",
  T_46_META_WS_P_SWINGINGSPEED: "سرعة التأرجح",
  T_46_META_WS_P_TAGS: "علامات",
  T_46_META_WS_P_TARGETCHECKPOINTID: "معرف نقطة التحقق المستهدفة",
  T_46_META_WS_P_TARGETICONCOLORS: "ألوان أيقونات الهدف",
  T_46_META_WS_P_TARGETICONS: "أيقونات الهدف",
  T_46_META_WS_P_TARGETID: "معرف الهدف",
  T_46_META_WS_P_TARGETITEMID: "معرف العنصر الهدف",
  T_46_META_WS_P_TARGETROTATION: "تدوير الهدف",
  T_46_META_WS_P_TARGETSCALE: "مقياس الهدف",
  T_46_META_WS_P_TEAMCOLOR: "لون الفريق",
  T_46_META_WS_P_TEAMCOLORS: "ألوان الفرق",
  T_46_META_WS_P_TEAMINDEXS: "مؤشرات الفرق",
  T_46_META_WS_P_TEAMMATEDAMAGEFACTOR: "عامل ضرر زميل الفريق",
  T_46_META_WS_P_TEAMMEMBERNUM: "عدد أعضاء الفريق",
  T_46_META_WS_P_TEAMNUM: "عدد الفريق",
  T_46_META_WS_P_TEAMRANK: "ترتيب الفريق",
  T_46_META_WS_P_TEAMRANKDISPLAY: "عرض ترتيب الفريق",
  T_46_META_WS_P_TEAMRANKS: "ترتيب الفرق",
  T_46_META_WS_P_TEAMSCORES: "نقاط الفرق",
  T_46_META_WS_P_TEAMSEQ: "تسلسل الفريق",
  T_46_META_WS_P_TEMPLATEENTITY: "كيان القالب",
  T_46_META_WS_P_TEMPORARYSHIELDPOINTS: "النقاط المؤقتة للدروع",
  T_46_META_WS_P_TERRAINWETNESS: "رطوبة التضاريس",
  T_46_META_WS_P_TEXT: "النص",
  T_46_META_WS_P_TEXTCOLOR: "لون النص",
  T_46_META_WS_P_TEXTKEY: "مفتاح النص",
  T_46_META_WS_P_TEXTKEYPARAMS: "معلمات مفتاح النص",
  T_46_META_WS_P_TEXTURERESOURCE: "مورد الملمس",
  T_46_META_WS_P_THEMECOLOR: "لون الموضوع",
  T_46_META_WS_P_THROWABLETYPE: "نوع القذائف",
  T_46_META_WS_P_THROWINGSPEED: "سرعة الرمي",
  T_46_META_WS_P_THROWSPEED: "سرعة الرمي",
  T_46_META_WS_P_TICKINTERVAL: "تردد التحديث",
  T_46_META_WS_P_TIMEREQUIRED: "الوقت المطلوب (مللي ثانية)",
  T_46_META_WS_P_TIPSTYPE: "نوع النصائح",
  T_46_META_WS_P_TITLE: "العنوان",
  T_46_META_WS_P_TITLELIST: "العناوين",
  T_46_META_WS_P_TITLES: "النقاط1",
  T_46_META_WS_P_TOP: "علوي",
  T_46_META_WS_P_TOPALPHA: "شفافية العلوية",
  T_46_META_WS_P_TOTALHP: "الصحة الإجمالية",
  T_46_META_WS_P_TOTALLEVEL: "المستوى الإجمالي",
  T_46_META_WS_P_TOTALROUNDCOUNT: "إجمالي عدد الجولات",
  T_46_META_WS_P_TOWSPEED: "سرعة السحب",
  T_46_META_WS_P_TRANSITIONSTAGE: "مرحلة الانتقال",
  T_46_META_WS_P_TRANSITIONTYPE: "نوع الانتقال",
  T_46_META_WS_P_TRIGGERPLAYERID: "العملات",
  T_46_META_WS_P_TRIGGERRADIUS: "نطاق الزناد",
  T_46_META_WS_P_TRIGGERRANGE: "نطاق المحفز",
  T_46_META_WS_P_TRIGGERTIME: "وقت التفعيل",
  T_46_META_WS_P_TURNSPEED: "سرعة الدوران",
  T_46_META_WS_P_TWEENERENABLED: "الفريق الأيسر",
  T_46_META_WS_P_TWEENSTYLE: "أسلوب المراهقين",
  T_46_META_WS_P_TYPE: "النوع",
  T_46_META_WS_P_UNSELECTEDCOLOR: "لون الصورة غير المحددة",
  T_46_META_WS_P_UNSELECTEDSPRITE: "الصورة غير المحددة",
  T_46_META_WS_P_UNSELECTEDTYPE: "نوع الصورة غير المحددة",
  T_46_META_WS_P_UP: "لأعلى",
  T_46_META_WS_P_UPDATETYPE: "نوع التحديث",
  T_46_META_WS_P_UPENERGYCOST: "تكلفة الطاقة للأعلى",
  T_46_META_WS_P_UPSPEED: "سرعة الصعود",
  T_46_META_WS_P_USECUSTOMPUSHFORCE: "هل يستخدم قوة دفع مخصصة",
  T_46_META_WS_P_USECUSTOMRESOURCE: "استخدام المورد المخصص",
  T_46_META_WS_P_USEDCAPACITY: "السعة المستخدمة",
  T_46_META_WS_P_USEGRAVITY: "هل يستخدم الجاذبية",
  T_46_META_WS_P_USEPHYSICALCCT: "استخدام CCT المادي",
  T_46_META_WS_P_USERUID: "معرّف المستخدم",
  T_46_META_WS_P_UVOFFSET: "إزاحة UV",
  T_46_META_WS_P_UVSIZE: "حجم UV",
  T_46_META_WS_P_VALUE: "القيمة",
  T_46_META_WS_P_VAULTDISTANCE: "مسافة القفز",
  T_46_META_WS_P_VAULTHEIGHT: "ارتفاع القفز",
  T_46_META_WS_P_VEHICLEDAMAGEFACTOR: "عامل الضرر للمركبة",
  T_46_META_WS_P_VEHICLESKINID: "معرف غلاف المركبة",
  T_46_META_WS_P_VEHICLESKINIDS: "معرف غلاف المركبة",
  T_46_META_WS_P_VELOCITY: "السرعة (م/ث)",
  T_46_META_WS_P_VELOCITYXZ: "السرعة XZ",
  T_46_META_WS_P_VELOCITYY: "السرعة Y",
  T_46_META_WS_P_VERTICALBAR: "شريط عمودي",
  T_46_META_WS_P_VERTICALOFFSET: "الإزاحة الرأسية",
  T_46_META_WS_P_VEST: "السترة",
  T_46_META_WS_P_VFXTEXTURETYPE: "نوع نسيج التأثيرات البصرية",
  T_46_META_WS_P_VIEWINGANGLERESTRICTION: "قيد زاوية الرؤية",
  T_46_META_WS_P_VISIBILITYLAYER: "طبقة الرؤية",
  T_46_META_WS_P_VISIBLE: "مرئي",
  T_46_META_WS_P_VISIBLEONBACK: "مرئية في الخلف",
  T_46_META_WS_P_VISIBLEPLAYERS: "اللاعبين المرئيين",
  T_46_META_WS_P_VOLUME: "مستوى الصوت",
  T_46_META_WS_P_WALLETID: "معرف المحفظة",
  T_46_META_WS_P_WANDERRANGE: "مدى الترحال",
  T_46_META_WS_P_WAVECOUNT: "عدد الموجات",
  T_46_META_WS_P_WAVEINTERVAL: "فترة الموجة",
  T_46_META_WS_P_WEAPONDAMAGERATE: "معدل ضرر الأسلحة",
  T_46_META_WS_P_WEAPONSKINIDS: "معرفات غلاف السلاح",
  T_46_META_WS_P_WEAPONSUBTYPE: "نوع السلاح الفرعي",
  T_46_META_WS_P_WEAPONTYPE: "نوع السلاح",
  T_46_META_WS_P_WIDTH: "العرض",
  T_46_META_WS_P_WINMVPS: "MVP للفائزين",
  T_46_META_WS_P_WINTEXT: "نص الفوز",
  T_46_META_WS_P_WORDWRAP: "التفاف الكلمات",
  T_46_META_WS_P_WORLDPOSITION: "الموقع العالمي",
  T_46_META_WS_P_YAW: "الانحراف",
  T_46_META_WS_PATROLALONG: "الدوريات على طول",
  T_46_META_WS_PATROLTO: "الدوريات إلى",
  T_46_META_WS_PAUSE: "إيقاف",
  T_46_META_WS_PAUSEEMOTE: "ايقاف مؤقت للرقصة",
  T_46_META_WS_PAUSEFIXEDUPDATE: "إيقاف تحديث ثابت",
  T_46_META_WS_PHASE: "مرحلة",
  T_46_META_WS_PLAY: "تشغيل",
  T_46_META_WS_PLAYANIMATION: "تشغيل الرسوم المتحركة",
  T_46_META_WS_PLAYCHARACTERANIMATIONCLIP: "تشغيل مقطع الرسوم المتحركة للشخصية",
  T_46_META_WS_PLAYEMOTE: "تشغيل رقصة",
  T_46_META_WS_PLAYER: "لاعب",
  T_46_META_WS_PORTAL: "بوابة",
  T_46_META_WS_POSE: "وضعية",
  T_46_META_WS_POSITION: "موقع",
  T_46_META_WS_PREPOSE: "الوضعية السابقة ",
  T_46_META_WS_PROFANITYFILTER: "فلتر الكلمات المسيئة",
  T_46_META_WS_PURSUITTARGET: "هدف المطاردة",
  T_46_META_WS_QUATERNIONTOAXISANGLE: "تحويل كواتيرنين إلى زاوية المحور",
  T_46_META_WS_QUATERNIONTOEULERANGLE: "تحويل الكواتيرنين إلى زاوية أويلر",
  T_46_META_WS_QUITCHATCHANNEL: "مغادرة قناة الدردشة",
  T_46_META_WS_QUITFACTION: "مغادرة الفصيل",
  T_46_META_WS_QUITGAME: "مغادرة اللعبة",
  T_46_META_WS_QUITJAILBREAKMINIGAME: "مغادرة لعبة كسر السجن",
  T_46_META_WS_RANDOMFLOAT: "عدد عشري عشوائي",
  T_46_META_WS_RANDOMINT: "عدد صحيح عشوائي",
  T_46_META_WS_RANK: "الترتيب",
  T_46_META_WS_READCSV: "قراءة CSV",
  T_46_META_WS_READCSVCELL: "قراءة خلية CSV",
  T_46_META_WS_READCSVCELLBYNAME: "قراءة خلية CSV حسب الاسم",
  T_46_META_WS_READCSVCELLFROMSERVER: "قراءة خلية CSV من الخادم",
  T_46_META_WS_READCSVCOLUMN: "قراءة عمود CSV",
  T_46_META_WS_READCSVCOLUMNFROMSERVER: "قراءة عمود CSV من الخادم",
  T_46_META_WS_READCSVFROMSERVER: "قراءة CSV من الخادم",
  T_46_META_WS_READCSVROW: "قراءة صف CSV",
  T_46_META_WS_READCSVROWBYKEY: "قراءة صف CSV حسب المفتاح",
  T_46_META_WS_READCSVROWFROMSERVER: "قراءة صف CSV من الخادم",
  T_46_META_WS_READFROMACCUMULATEDDATASTORE: "قراءة من قاعدة البيانات المجمعة",
  T_46_META_WS_READFROMDATASTORE: "قراءة من قاعدة البيانات",
  T_46_META_WS_READFROMLEADBOARDDATASTORE: "قراءة من قاعدة بيانات لوحة المتصدرين",
  T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK: "قراءة من قاعدة بيانات لوحة المتصدرين حسب الترتيب",
  T_46_META_WS_REMOVEAOISPECIALFOLLOW: "إزالة متابعة خاصة بـ AOI",
  T_46_META_WS_REMOVEBACKPACKSKIN: "إزالة مظهر حقيبة الظهر",
  T_46_META_WS_REMOVEBUFF: "إزالة مكافأة",
  T_46_META_WS_REMOVECOMPONENT: "إزالة مكون",
  T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR: "إزالة عامل خاصية الصيغة",
  T_46_META_WS_REMOVEOUTFIT: "إزالة زي",
  T_46_META_WS_REMOVESCRIPT: "إزالة نص برمجي",
  T_46_META_WS_REMOVEVEHICLESKIN: "إزالة غلاف المركبة",
  T_46_META_WS_REMOVEWEAPONSKIN: "إزالة جلد السلاح",
  T_46_META_WS_REPLACE: "استبدال",
  T_46_META_WS_REQUESTMATCHMAKING: "طلب التوفيق",
  T_46_META_WS_RESET: "إعادة تعيين",
  T_46_META_WS_RESETBACKPACKSKIN: "إعادة تعيين مظهر حقيبة الظهر",
  T_46_META_WS_RESETDYEING: "إعادة تعيين الصب",
  T_46_META_WS_RESETJERSEY: "إعادة تعيين القميص",
  T_46_META_WS_RESETOUTFIT: "إعادة تعيين زي",
  T_46_META_WS_RESETVEHICLESKIN: "إعادة تعيين غلاف المركبة",
  T_46_META_WS_RESETWEAPONSKIN: "إعادة تعيين جلد السلاح",
  T_46_META_WS_RESUMEFIXEDUPDATE: "استئناف تحديث ثابت",
  T_46_META_WS_REVERSE: "عكس",
  T_46_META_WS_REVIVALSOURCE: "مصدر الإحياء",
  T_46_META_WS_REVIVE: "إلحاق الضرر",
  T_46_META_WS_ROUND: "التقريب للأسفل",
  T_46_META_WS_ROUNDINDEX: "مؤشر الجولة",
  T_46_META_WS_SAMPLEONCURVE: "أخذ عينة على المنحنى",
  T_46_META_WS_SCENENAME: "اسم المشهد",
  T_46_META_WS_SCORE: "النقاط",
  T_46_META_WS_SCORER: "مسجل الهدف",
  T_46_META_WS_SCORETYPE: "نوع النقاط",
  T_46_META_WS_SCREENMULTIRAYCAST: "اختبار الشعاع لمسة الشاشة (متعدد)",
  T_46_META_WS_SCREENSINGLERAYCAST: "اختبار الشعاع لمسة الشاشة (مفرد)",
  T_46_META_WS_SCREENTOUCHRAY: "الشعاع عند لمس الشاشة",
  T_46_META_WS_SCREENTOWORLDPOINT: "من الشاشة إلى العالم",
  T_46_META_WS_SENDEVENT: "إرسال حدث",
  T_46_META_WS_SETACTIVE: "تعيين النشاط",
  T_46_META_WS_SETALLPLAYERSMOVESTATUS: "تعيين حالة حركة جميع اللاعبين",
  T_46_META_WS_SETATTACKABLEENTITY: "تعيين الكائن القابل للهجوم",
  T_46_META_WS_SETATTACKABLEFACTION: "تعيين الفصيل القابل للهجوم",
  T_46_META_WS_SETATTACKABLETEAM: "تعيين الفريق القابل للهجوم",
  T_46_META_WS_SETBACKPACKSKIN: "تعيين مظهر حقيبة الظهر",
  T_46_META_WS_SETBEHAVIORSTATUS: "تعيين حالة السلوك",
  T_46_META_WS_SETBLACKBOARDVALUE: "تعيين قيمة السبورة السوداء",
  T_46_META_WS_SETBUNDLE: "تعيين حزمة",
  T_46_META_WS_SETCAMERAFOCUS: "تعيين تركيز الكاميرا",
  T_46_META_WS_SETCAMERAFOLLOW: "تعيين متابعة الكاميرا",
  T_46_META_WS_SETCHARACTER: "تعيين الشخصية",
  T_46_META_WS_SETCULLINGMASK: "تعيين قناع التصفية",
  T_46_META_WS_SETCULLINGMASKLAYER: "تعيين طبقة قناع التصفية",
  T_46_META_WS_SETDEFAULTUISTATUS: "تعيين حالة واجهة المستخدم الافتراضية",
  T_46_META_WS_SETDROPSTATUS: "تعيين حالة الإلقاء",
  T_46_META_WS_SETFALLINGDAMAGE: "تعيين ضرر السقوط",
  T_46_META_WS_SETFOOTBALLPOSITION: "تعيين موقع الكرة",
  T_46_META_WS_SETFORMULAPROPERTYABSOLUTE: "تعيين خاصية الصيغة المطلقة",
  T_46_META_WS_SETFORMULAPROPERTYRELATIVE: "تعيين خاصية الصيغة النسبية",
  T_46_META_WS_SETFORWARD: "تعيين الاتجاه",
  T_46_META_WS_SETGLOBALSLEEPTHRESHOLD: "تعيين عتبة النوم العالمية",
  T_46_META_WS_SETINVINCIBILITY: "آخر فهرس",
  T_46_META_WS_SETJERSEY: "تعيين القميص",
  T_46_META_WS_SETOUTFIT: "تعيين زي",
  T_46_META_WS_SETPARENT: "تعيين الأب",
  T_46_META_WS_SETPARENTCLIENT: "تعيين الوالد للعنصر",
  T_46_META_WS_SETPICKUPSTATUS: "تعيين حالة الالتقاط",
  T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS: "تعيين حالة الرسالة السريعة للاعب",
  T_46_META_WS_SETPLAYERVOICESTATUS: "تعيين حالة صوت اللاعب",
  T_46_META_WS_SETPROPERTYSMOOTHLY: "تعيين الخاصية بسلاسة",
  T_46_META_WS_SETSKILLS: "تعيين المهارات",
  T_46_META_WS_SETSKYBOX: "حذف واجهة المستخدم المدمجة",
  T_46_META_WS_SETSLEEPTHRESHOLD: "تعيين عتبة النوم",
  T_46_META_WS_SETSPECIALITEMSTATUS: "تعيين حالة العنصر الخاص",
  T_46_META_WS_SETVEHICLESKIN: "تعيين غلاف المركبة",
  T_46_META_WS_SETWEAPONSKIN: "تعيين جلد السلاح",
  T_46_META_WS_SETWIDGETPARENT: "تعيين الأب",
  T_46_META_WS_SHOPITEM: "عنصر المتجر",
  T_46_META_WS_SHOWAPPEARANCEGROUP: "عرض مجموعة المظهر",
  T_46_META_WS_SHUFFLE: "خلط",
  T_46_META_WS_SIN: "جديد",
  T_46_META_WS_SINGLERAYCAST: "اختبار شعاع واحد",
  T_46_META_WS_SKILL: "مهارة",
  T_46_META_WS_SLEEP: "النوم",
  T_46_META_WS_SLERPQUATERNION: "التداخل بين الكوارتز",
  T_46_META_WS_SPAWNABLES: "عناصر قابلة للتوليد",
  T_46_META_WS_SPAWNEDITEM: "العنصر المنشأ",
  T_46_META_WS_SPAWNNEXTWAVE: "توليد الموجة التالية",
  T_46_META_WS_SPHERECAST: "اختبار كرة",
  T_46_META_WS_SPHEREOVERLAP: "تداخل كرة",
  T_46_META_WS_SPLIT: "تقسيم",
  T_46_META_WS_SQRT: "الجذر التربيعي",
  T_46_META_WS_STARTPARACHUTE: "بدء القفز بالمظلة",
  T_46_META_WS_STARTPOSITION: "الموقع الابتدائي",
  T_46_META_WS_STATENAME: "اسم الحالة",
  T_46_META_WS_STATUS: "الحالة",
  T_46_META_WS_STRINGTOFLOAT: "تحويل السلسلة إلى عدد عشري",
  T_46_META_WS_STRINGTOINT: "تحويل السلسلة إلى عدد صحيح",
  T_46_META_WS_STRIP: "إزالة",
  T_46_META_WS_SUB: "طرح",
  T_46_META_WS_SWITCHAOIPROXYOBSERVER: "تبديل مراقب وكيل AOI",
  T_46_META_WS_SWITCHAPPEARANCEGROUP: "تبديل مجموعة المظهر",
  T_46_META_WS_SWITCHAREA: "تبديل المنطقة",
  T_46_META_WS_SWITCHCAMERA: "تبديل الكاميرا",
  T_46_META_WS_SWITCHPHASE: "تبديل المرحلة",
  T_46_META_WS_SWITCHSCENE: "تبديل المشهد",
  T_46_META_WS_SWITCHWEAPON: "تبديل السلاح",
  T_46_META_WS_TAN: "جيب تمام",
  T_46_META_WS_TARGET: "هدف",
  T_46_META_WS_TEAM: "فريق",
  T_46_META_WS_TELEPORT: "الحصول على المالك",
  T_46_META_WS_TELEPORTCCT: "نقل CCT",
  T_46_META_WS_TEXT: "نص",
  "T_46_META_WS_TIMESTAMPTO LOCALSTRING": "تحويل الطابع الزمني إلى سلسلة محلية",
  T_46_META_WS_TIRE: "إطار",
  T_46_META_WS_TOLOWER: "تحويل إلى أحرف صغيرة",
  T_46_META_WS_TOSTRING: "إلى سلسلة",
  T_46_META_WS_TOUPPER: "تحويل إلى أحرف كبيرة",
  T_46_META_WS_TRANSFERMONEY: "تحويل المال",
  T_46_META_WS_TRIGGER: "المحفز",
  T_46_META_WS_TYPEIS: "النوع هو",
  T_46_META_WS_UNLOADSCENE: "إلغاء تحميل المشهد",
  T_46_META_WS_UPDATEJAILBREAKMISSION: "تحديث مهمة كسر السجن",
  T_46_META_WS_UPLOADGAMERESULT: "تحميل نتيجة اللعبة",
  T_46_META_WS_VALUE: "ضرر",
  T_46_META_WS_VECTOR2ANGLE: "زاوية فكتور 2",
  T_46_META_WS_VECTOR2DISTANCE: "مسافة فكتور 2",
  T_46_META_WS_VECTOR2DOT: "فكتور 2 نقطة",
  T_46_META_WS_VECTOR2MAGNITUDE: "شدة فكتور 2",
  T_46_META_WS_VECTOR2NORMALIZE: "فكتور 2 تطبيع",
  T_46_META_WS_VECTOR2REFLECT: "فكتور 2 انعكاس",
  T_46_META_WS_VECTOR2TOVECTOR3: "تحويل فكتور 3 إلى فكتور 2",
  T_46_META_WS_VECTOR3REFLECT: "انعكاس المتجه 3",
  T_46_META_WS_VECTOR3TOVECTOR2: "تحويل فكتور 2 إلى فكتور 3",
  T_46_META_WS_VEHICLE: "مركبة",
  T_46_META_WS_VELOCITY: "السرعة",
  T_46_META_WS_WAITFORMILESECOND: "الانتظار بالمللي ثانية",
  T_46_META_WS_WAITFORNEXTFRAME: "الانتظار للإطار التالي",
  T_46_META_WS_WAKEUP: "الاستيقاظ",
  T_46_META_WS_WAVES: "موجات",
  T_46_META_WS_WEAPON: "سلاح",
  T_46_META_WS_WORLDTOSCREENPOINT: "من العالم إلى الشاشة",
  T_46_META_WS_WRITETOACCUMULATEDDATASTORE: "كتابة في قاعدة البيانات المجمعة",
  T_46_META_WS_WRITETODATASTORE: "كتابة في قاعدة البيانات",
  T_46_META_WS_WRITETOLEADBOARDDATASTORE: "كتابة في قاعدة بيانات لوحة المتصدرين",
  T_48_META_API_1_D: "احصل على جميع اللاعبين في اللعبة الحالية وارجع إلى قائمة اللاعبين.",
  T_48_META_API_1_R_D: "قائمة اللاعبين",
  T_48_META_API_10_D: "الحصول على كائنات المشهد",
  T_48_META_API_10_P0_D: "ما نوع كائنات المشهد المراد تصفيتها",
  T_48_META_API_10_R_D: "قائمة كائنات المشهد",
  T_48_META_API_100_D: "لن يؤدي تحميل المشاهد إلى إلغاء تحميل المشاهد المحملة بالفعل تلقائيًا.",
  T_48_META_API_100_P0_D: "معرف المشهد للتحميل",
  T_48_META_API_10000_D: "إرجاع الكيان المرتبط بالبرنامج النصي الحالي",
  T_48_META_API_10000_R_D: "الكيان المرتبط بالبرنامج النصي الحالي",
  T_48_META_API_10001_D: "استخدم معرف الكيان للعثور على الكيان المقابل. يتم استخدام واجهة برمجة التطبيقات هذه بواسطة المحرر فقط. ولا يمكن أن يضمن استخدام واجهة برمجة التطبيقات هذه من جانب المستخدم توافقها، مثل الإزالة أو التعديل.",
  T_48_META_API_10001_P0_D: "معرف الكيان المستهدف",
  T_48_META_API_10001_R_D: "كيان",
  T_48_META_API_10002_D: "احصل على الكيان العالمي للعبة",
  T_48_META_API_10002_R_D: "كيان عالمي",
  T_48_META_API_10003_D: "نقل اللاعب فوريًا إلى إحداثيات محددة (قديم، يرجى استخدام النقل الفوري)",
  T_48_META_API_10003_P0_D: "لاعب منقول",
  T_48_META_API_10003_P1_D: "إحداثيات النقطة المنقولة",
  T_48_META_API_10004_D: "احصل على موقع بالقرب من زملائك في الفريق وتجنب وضع اللاعبين الذين لا يستطيعون الوقوف (عفا عليه الزمن، يرجى استخدام GetTeammateNearPosition)",
  T_48_META_API_10004_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_10004_R_D: "الإحداثيات بالقرب من زملائه",
  T_48_META_API_10005_D: "احصل على اللاعب الذي يملك الكيان",
  T_48_META_API_10005_P0_D: "الكيان المستهدف، لن تتم مزامنة الكيان إلا مع اللاعب الذي ينتمي إليه",
  T_48_META_API_10005_R_D: "اللاعب الذي ينتمي إليه الكيان المستهدف",
  T_48_META_API_10006_D: "جعل اللاعب لا يقهر",
  T_48_META_API_10006_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_10006_P1_D: "مدة التأثير الذي لا يقهر، بالثواني",
  T_48_META_API_10007_D: "استنساخ الكيان المحدد وجميع خصائصه في موقعه الأصلي",
  T_48_META_API_10007_P0_D: "تم إنشاء الكيان",
  T_48_META_API_10007_P1_D: "الكيان المراد استنساخه",
  T_48_META_API_10008_D: "يسبب ضررًا للاعب إذا لم يتم تحديد مصدر ضرر، فسيتلقى الهدف ضررًا من النظام.",
  T_48_META_API_10008_P0_D: "كيان اللعبة التالف",
  T_48_META_API_10008_P1_D: "كيان اللعبة الذي يسبب الضرر",
  T_48_META_API_10008_P2_D: "نوع الضرر",
  T_48_META_API_10008_P3_D: "ضرر",
  T_48_META_API_10009_D: "قيامة اللاعب المعين",
  T_48_META_API_10009_P0_D: "لاعب متجدد",
  T_48_META_API_1001_D: "إذا تم استيفاء الشروط، سيتم تشغيل العقدة الموجودة ضمن IF. عندما لا يتم استيفاء الشروط، إذا كان هناك ELSE، قم بتشغيل العقدة الموجودة أسفل ELSE، وإلا قم بإنهاء عبارة IF.",
  T_48_META_API_1001_P0_D: "يجب أن تكون قائمة الشروط متسقة مع عدد قوائم العمليات الفرعية (قوائم الفروع المنطقية)",
  T_48_META_API_10010_D: "إنشاء عنصر أو قائمة عناصر في موقع محدد.",
  T_48_META_API_10010_P0_D: "موقع إنشاء العنصر",
  T_48_META_API_10010_P1_D: "العنصر الذي تم إنشاؤه أو قائمة العناصر",
  T_48_META_API_10010_P2_D: "عدد العناصر التي تم إنشاؤها عند إنشاء قائمة العناصر، يتعين عليك ملء قائمة كمية العناصر المتوافقة مع ترتيب قائمة العناصر.",
  T_48_META_API_10011_D: "دوريات كيان الذكاء الاصطناعي إلى نقطة الهدف",
  T_48_META_API_10011_P0_D: "كيان الذكاء الاصطناعي المستهدف",
  T_48_META_API_10011_P1_D: "نقطة الهدف المتحركة",
  T_48_META_API_10011_P2_D: "ما إذا كان يجب العودة إلى نقطة البداية",
  T_48_META_API_10011_P3_D: "ما إذا كان سيتم اكتشاف الأهداف المعادية ومهاجمتها أثناء القيام بالدوريات",
  T_48_META_API_10012_D: "تقوم كيانات الذكاء الاصطناعي بدوريات بالترتيب وفقًا لقائمة الإحداثيات",
  T_48_META_API_10012_P0_D: "كيان الذكاء الاصطناعي المستهدف",
  T_48_META_API_10012_P1_D: "نقل قائمة نقاط الإحداثيات",
  T_48_META_API_10012_P2_D: "نوع الدورية، يمكنك اختيار رحلة فردية أو ذهابًا وإيابًا أو دراجة",
  T_48_META_API_10012_P3_D: "ما إذا كان سيتم اكتشاف الأهداف المعادية ومهاجمتها أثناء القيام بالدوريات",
  T_48_META_API_10013_D: "يقوم المولد على الفور بتحديث الموجة التالية من كيانات الوحدة",
  T_48_META_API_10013_P0_D: "كيان المولد",
  T_48_META_API_10014_D: "ستقوم عوامل الحساب المضافة للسمات القابلة للحساب بحساب النتيجة النهائية من خلال صيغة مكونة من عوامل.",
  T_48_META_API_10014_P0_D: "الكيان المستهدف",
  T_48_META_API_10014_P1_D: "أنواع الممتلكات القابلة للحساب",
  T_48_META_API_10014_P2_D: "حساب نوع العامل",
  T_48_META_API_10014_P3_D: "حساب قيم العوامل",
  T_48_META_API_10015_D: "مسح عوامل الحساب للخصائص المحسوبة",
  T_48_META_API_10015_P0_D: "الكيان المستهدف",
  T_48_META_API_10015_P1_D: "أنواع الممتلكات القابلة للحساب",
  T_48_META_API_10016_D: "مسح كافة العوامل المحسوبة لجميع الخصائص المحسوبة للكيان المستهدف",
  T_48_META_API_10016_P0_D: "الكيان المستهدف",
  T_48_META_API_10017_D: "تعديل الخصائص",
  T_48_META_API_10017_P0_D: "الكيان المستهدف",
  T_48_META_API_10017_P1_D: "نوع العقار",
  T_48_META_API_10017_P2_D: "طريقة التعديل",
  T_48_META_API_10017_P3_D: "قيمة",
  T_48_META_API_10018_D: "تعيين قيمة الخاصية المحسوبة",
  T_48_META_API_10018_P0_D: "الكيان المستهدف",
  T_48_META_API_10018_P1_D: "نوع العقار",
  T_48_META_API_10018_P2_D: "قيمة",
  T_48_META_API_10019_D: "مسح تعديل خاصية محسوبة واحدة",
  T_48_META_API_10019_P0_D: "الكيان المستهدف",
  T_48_META_API_10019_P1_D: "نوع العقار",
  T_48_META_API_1002_D: "تبدأ المعلمة i من الحد الأدنى للقيمة، وفي كل مرة يتم فيها تشغيل العقدة السفلية، أقوم بزيادة قيمة الخطوة حتى تصبح i أكبر من أو تساوي القيمة القصوى.",
  T_48_META_API_1002_P0_D: "اسم فهرس الحلقة، والذي يمكن استخدامه للحصول على قيمة فهرس الحلقة على المتغير المحلي",
  T_48_META_API_1002_P1_D: "حلقة القيمة الأولية",
  T_48_META_API_1002_P2_D: "قيمة نهاية الحلقة",
  T_48_META_API_1002_P3_D: "حجم خطوة الحلقة، عندما تكون قيمة البداية أقل من القيمة النهائية، يجب أن يكون حجم الخطوة أكبر من 0؛ عندما تكون قيمة البداية أكبر من القيمة النهائية، يجب أن يكون حجم الخطوة أقل من 0",
  T_48_META_API_10020_D: "احصل على جميع الكيانات الموجودة في اللعبة التي تستوفي شروط التصفية",
  T_48_META_API_10020_P0_D: "يجب أن تحتوي نتائج التصفية على النوع الذي تم إدخاله في هذه المعلمة",
  T_48_META_API_10020_P1_D: "يجب ألا تحتوي نتائج التصفية على النوع الذي تم إدخاله في هذه المعلمة",
  T_48_META_API_10020_P2_D: "تحتوي نتائج التصفية على نوع واحد على الأقل من الأنواع المدخلة في هذه المعلمة",
  T_48_META_API_10020_R_D: "تصفية قائمة الكيانات الناتجة",
  T_48_META_API_10021_D: "أضف سرعة إلى كرة القدم، حيث ستتغير السرعة بسبب التسارع في نفس الاتجاه.",
  T_48_META_API_10021_P0_D: "هدف كرة القدم",
  T_48_META_API_10021_P1_D: "تمت إضافة سرعة الفضاء ثلاثية الأبعاد",
  T_48_META_API_10022_D: "تدمير الكيان المحدد",
  T_48_META_API_10022_P0_D: "الكيان المستهدف المراد تدميره",
  T_48_META_API_10023_D: "إضافة علامات إلى الكيانات",
  T_48_META_API_10023_P0_D: "الكيان المستهدف",
  T_48_META_API_10023_P1_D: "تسميات مخصصة",
  T_48_META_API_10024_D: "إزالة التسميات من الكيانات",
  T_48_META_API_10024_P0_D: "الكيان المستهدف",
  T_48_META_API_10024_P1_D: "تسميات مخصصة",
  T_48_META_API_10025_D: "تحديد ما إذا كان الكيان المستهدف يحتوي على العلامة المحددة",
  T_48_META_API_10025_P0_D: "الكيان المستهدف",
  T_48_META_API_10025_P1_D: "تسميات مخصصة",
  T_48_META_API_10025_R_D: "ما إذا كان سيتم تضمين العلامة المحددة",
  T_48_META_API_10026_D: "ضبط موقف كرة القدم",
  T_48_META_API_10026_P0_D: "كيان كرة القدم",
  T_48_META_API_10026_P1_D: "موقع",
  T_48_META_API_10026_P2_D: "الحفاظ على السرعة",
  T_48_META_API_10027_D: "احصل على كيان الكاميرا الذي يستخدمه اللاعب المستهدف حاليًا",
  T_48_META_API_10027_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_10027_R_D: "كيان الكاميرا المستخدم حاليًا",
  T_48_META_API_10028_D: "قم بتحويل كاميرا اللاعب المستهدف إلى كاميرا الهدف،",
  T_48_META_API_10028_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_10028_P1_D: "الكاميرا المستهدفة",
  T_48_META_API_10028_P2_D: "تبديل الوضع، يمكنك اختيار الحفاظ على المنطق الأصلي أو التقدمي",
  T_48_META_API_10028_P3_D: "وقت التبديل هو الوقت المناسب لتبديل الكاميرات في الوضع التقدمي",
  T_48_META_API_10029_D: "إنشاء كاميرا",
  T_48_META_API_10029_P0_D: "تم إنشاء نوع الكاميرا",
  T_48_META_API_10029_P1_D: "تم إنشاء كيان الكاميرا",
  T_48_META_API_1003_D: "تنفيذ اجتياز حاوية البيانات، والحصول على كل عنصر فرعي، واحتواء العمليات الفرعية. وجسم الحلقة هو العملية الفرعية.",
  T_48_META_API_1003_P0_D: "انتقل إلى اسم العنصر الفرعي، ويمكنك استخدامه للحصول على قيمة العنصر الفرعي في المتغير المحلي",
  T_48_META_API_1003_P1_D: "اسم فهرس الحلقة، والذي يمكن استخدامه للحصول على قيمة فهرس الحلقة على المتغير المحلي",
  T_48_META_API_1003_P2_D: "تدعم حاوية البيانات المراد اجتيازها حاليًا الأنواع التالية: نوع المصفوفة",
  T_48_META_API_10030_D: "قتل الكيانات المقاتلة",
  T_48_META_API_10030_P0_D: "الكيان المستهدف، يجب أن يكون كيانًا قابلاً للقتال",
  T_48_META_API_10031_D: "قم بتعيين حالة نشاط الكيان المستهدف وعقده الفرعية سيتم إيقاف تشغيل الكائنات غير النشطة ورؤيتها وتصادمها وما إلى ذلك.",
  T_48_META_API_10031_P0_D: "الكيان المستهدف",
  T_48_META_API_10031_P1_D: "هل هو نشط؟",
  T_48_META_API_10032_D: "قم بتعيين موضع كيان الكاميرا ليتبع الكيان المستهدف دائمًا",
  T_48_META_API_10032_P0_D: "كيان الكاميرا المستهدفة",
  T_48_META_API_10032_P1_D: "الكيان المستهدف للمتابعة",
  T_48_META_API_10032_P2_D: "الإزاحة من إحداثيات الكيان المستهدف",
  T_48_META_API_10032_P3_D: "نظام الإحداثيات الإزاحة",
  T_48_META_API_10033_D: "قم بتعيين كيان الكاميرا ليواجه الكيان المستهدف دائمًا",
  T_48_META_API_10033_P0_D: "كيان الكاميرا المستهدفة",
  T_48_META_API_10033_P1_D: "الكيان المستهدف",
  T_48_META_API_10033_P2_D: "إزاحة نقطة التثبيت من إحداثيات الهدف",
  T_48_META_API_10033_P3_D: "نظام الإحداثيات الإزاحة",
  T_48_META_API_10034_D: "إنشاء فتيات مراهقات",
  T_48_META_API_10034_P0_D: "الكيان المستهدف",
  T_48_META_API_10034_P1_D: "معرف العقار",
  T_48_META_API_10034_P2_D: "سركفال",
  T_48_META_API_10034_P3_D: "ديستفال",
  T_48_META_API_10034_P4_D: "أسلوب",
  T_48_META_API_10034_P5_D: "منحنى",
  T_48_META_API_10034_P6_D: "مدة",
  T_48_META_API_10034_P7_D: "كيان توين",
  T_48_META_API_10035_D: "قم بتعيين العقدة الأصلية، مما يتطلب أن يكون لدى كل من العقدة الأصلية والفرعية مكونات تحويل",
  T_48_META_API_10035_P0_D: "العقدة الأم",
  T_48_META_API_10035_P1_D: "عقدة الطفل",
  T_48_META_API_10035_P2_D: "ما إذا كان سيتم الاحتفاظ بالموضع العالمي الحالي وتدوير العقد الفرعية وتوسيع نطاقها. هذا العنصر غير صالح عند تعيين واجهة المستخدم.",
  T_48_META_API_10036_D: "NewCurve (مهمل، يرجى استخدام CreateTweenCurve)",
  T_48_META_API_10036_P0_D: "نقاط التحكم",
  T_48_META_API_10036_R_D: "TwennCurveEntity",
  T_48_META_API_10037_D: "محاولات تشغيل الكيان المستهدف، الذي يجب أن يحتوي على مكونات قابلة للتشغيل",
  T_48_META_API_10037_P0_D: "الكيان المستهدف القابل للتشغيل",
  T_48_META_API_10037_P1_D: `ما إذا كان سيتم إعادة التشغيل
صحيح: إعادة التشغيل
خطأ: متابعة التشغيل`,
  T_48_META_API_10038_D: "إيقاف الكيان القابل للتشغيل مؤقتًا",
  T_48_META_API_10038_P0_D: "الكيان المستهدف القابل للتشغيل",
  T_48_META_API_10039_D: "إنشاء حركة باليستية، والتي ستعطي الكيان المستهدف سرعة أولية وتسارعًا مع الاتجاه",
  T_48_META_API_10039_P0_D: "الكيان المستهدف",
  T_48_META_API_10039_P1_D: "السرعة الأولية للحركة",
  T_48_META_API_10039_P2_D: "تسارع الحركة",
  T_48_META_API_10039_P3_D: "أقصى مسافة الإزاحة",
  T_48_META_API_10039_P4_D: "تم إنشاء كيان الحركة الباليستية",
  T_48_META_API_10039_P5_D: "ما إذا كان سيتم بدء اللعب تلقائيًا بعد الإنشاء",
  T_48_META_API_1004_D: "مقاطعة عملية الحلقة الحالية والخروج من الحلقة",
  T_48_META_API_10040_D: "قم بإنشاء موضع بعد الحركة، وسيتبع الكيان المستهدف حركة الكائن المحدد",
  T_48_META_API_10040_P0_D: "الكيان المستهدف",
  T_48_META_API_10040_P1_D: "كيانات الكائن التي تتبع الحركة",
  T_48_META_API_10040_P2_D: "تتبع المسافة إزاحة إحداثيات الهدف",
  T_48_META_API_10040_P3_D: "نظام الإحداثيات المستخدم",
  T_48_META_API_10040_P4_D: "تم إنشاء كيان الحركة التالي",
  T_48_META_API_10040_P5_D: "ما إذا كان سيتم بدء اللعب تلقائيًا بعد الإنشاء",
  T_48_META_API_10041_D: "أنشئ حركة تتبع النظرة حيث سيظل الكيان المستهدف مواجهًا للكائن المحدد",
  T_48_META_API_10041_P0_D: "الكيان المستهدف",
  T_48_META_API_10041_P1_D: "كيان الكائن الذي تتم مراقبته",
  T_48_META_API_10041_P2_D: "إزاحة نقطة النظر من كيان الكائن",
  T_48_META_API_10041_P3_D: "نظام الإحداثيات المستخدم",
  T_48_META_API_10041_P4_D: "تم إنشاء كيان حركة يتابع النظرة",
  T_48_META_API_10041_P5_D: "ما إذا كان سيتم بدء اللعب تلقائيًا بعد الإنشاء",
  T_48_META_API_10042_D: "مهمل",
  T_48_META_API_10042_P0_D: "كيان اللاعب",
  T_48_META_API_10042_P1_D: "نتيجة المباراة",
  T_48_META_API_10042_P2_D: "مهمل",
  T_48_META_API_10042_P3_D: "مهمل",
  T_48_META_API_10042_P4_D: "مهمل",
  T_48_META_API_10043_D: "قم بتعيين خصائص الكيان المستهدف بسلاسة. ستتغير الخصائص على الفور، لكن العميل سيلعب أداء انتقال سلس.",
  T_48_META_API_10043_P0_D: "الكيان المستهدف",
  T_48_META_API_10043_P1_D: "سمة الكيان المستهدف",
  T_48_META_API_10043_P2_D: "يجب أن تتوافق القيمة المستهدفة مع النوع المطلوب عند تحديد السمة.",
  T_48_META_API_10044_D: "قم بإجراء اكتشاف الشعاع وإرجاع أول ضربة للكيان في اتجاه الشعاع يحتاج كيان الضربة إلى مكون تصادم إذا تم ملء معلمة المستوى في الفراغ، فيمكن اكتشاف التضاريس.",
  T_48_META_API_10044_P0_D: "إحداثيات موضع البداية",
  T_48_META_API_10044_P1_D: "اتجاه كشف الشعاع",
  T_48_META_API_10044_P2_D: "مسافة كشف الأشعة، يتم قبول القيم الإيجابية فقط",
  T_48_META_API_10044_P3_D: "قناع طبقة كشف الشعاع، فقط المستويات المملوءة ستشارك في الفحص، وترك فارغًا يعني أن جميع المستويات ستشارك في الفحص",
  T_48_META_API_10044_P4_D: "هل من الممكن مسح المشغلات؟",
  T_48_META_API_10044_P5_D: "ضرب الكيان",
  T_48_META_API_10044_P6_D: "إحداثيات نقطة الضرب",
  T_48_META_API_10044_P7_D: "المسافة من نقطة الإصابة إلى نقطة البداية",
  T_48_META_API_10044_P8_D: "ضرب السطح عادي",
  T_48_META_API_10045_D: "قم بإجراء اكتشاف الشعاع وإرجاع جميع الكيانات التي ضربت في اتجاه الشعاع من القريب إلى البعيد إذا تم ملء معلمة المستوى في الفراغ، فيمكن اكتشاف التضاريس.",
  T_48_META_API_10045_P0_D: "إحداثيات موضع البداية",
  T_48_META_API_10045_P1_D: "اتجاه كشف الشعاع",
  T_48_META_API_10045_P2_D: "مسافة كشف الأشعة، يتم قبول القيم الإيجابية فقط",
  T_48_META_API_10045_P3_D: "قناع الطبقة، ستشارك الطبقات المعبأة فقط في الفحص، وترك فارغًا يعني أن جميع الطبقات ستشارك في الفحص",
  T_48_META_API_10045_P4_D: "هل من الممكن الكشف عن المشغلات",
  T_48_META_API_10045_P5_D: "قائمة الكيانات المتضررة",
  T_48_META_API_10045_P6_D: "قائمة الضرب",
  T_48_META_API_10045_P7_D: "ضرب نقطة المسافة قائمة المسافة نقطة البداية",
  T_48_META_API_10045_P8_D: "ضرب السطح عادي",
  T_48_META_API_10046_D: "إنشاء كيانات للقوالب باستخدام المباني الجاهزة",
  T_48_META_API_10046_P0_D: "تم إنشاء الكيان",
  T_48_META_API_10046_P1_D: "معرف الجاهزة",
  T_48_META_API_10047_D: "صباغة",
  T_48_META_API_10047_P0_D: "ضبط الكائن على الوضع الطبيعي",
  T_48_META_API_10047_P1_D: "تعيين نقاط الصباغة",
  T_48_META_API_10047_P2_D: "لون",
  T_48_META_API_10048_D: "حالة تلطيخ",
  T_48_META_API_10048_P0_D: "تعيين نقاط الصباغة",
  T_48_META_API_10048_P1_D: "تحديد الاتجاه",
  T_48_META_API_10048_P2_D: "ضبط المسافة",
  T_48_META_API_10048_R_D: "ColorDesc",
  T_48_META_API_10049_D: "إحصائيات تلطيخ",
  T_48_META_API_10049_P0_D: "لون",
  T_48_META_API_10049_R_D: "كمية الصباغة",
  T_48_META_API_1005_D: "تخطي محتوى الحلقة المتبقية وانتقل مباشرة إلى الحلقة التالية",
  T_48_META_API_10050_D: "تلطيخ نطاق مستو",
  T_48_META_API_10050_P0_D: "ضبط الكائن على الوضع الطبيعي",
  T_48_META_API_10050_P1_D: "تعيين نقاط الصباغة",
  T_48_META_API_10050_P2_D: "ضبط نطاق الصباغة",
  T_48_META_API_10050_P3_D: "لون",
  T_48_META_API_10050_P4_D: "كمية الصباغة",
  T_48_META_API_10051_D: "تلطيخ المنطقة",
  T_48_META_API_10051_P0_D: "ضبط الكائن على الوضع الطبيعي",
  T_48_META_API_10051_P1_D: "تعيين نقاط الصباغة",
  T_48_META_API_10051_P2_D: "ضبط نطاق الصباغة",
  T_48_META_API_10051_P3_D: "لون",
  T_48_META_API_10051_P4_D: "منطقة ملطخة ثابتة",
  T_48_META_API_10051_P5_D: "معامل عشوائي",
  T_48_META_API_10051_P6_D: "معامل التوهين العشوائي",
  T_48_META_API_10051_P7_D: "كمية الصباغة",
  T_48_META_API_10052_D: "احصل على جميع العقد الفرعية لكيان العقدة الأصلية المستهدفة",
  T_48_META_API_10052_P0_D: "كيان العقدة الأم",
  T_48_META_API_10052_R_D: "قائمة العقد التابعة",
  T_48_META_API_10053_D: "احصل على العقدة الفرعية المحددة لكيان العقدة الأصلية المستهدفة بناءً على الفهرس",
  T_48_META_API_10053_P0_D: "كيان العقدة الأم",
  T_48_META_API_10053_P1_D: "مؤشر العقدة الفرعية",
  T_48_META_API_10053_R_D: "كيان العقدة الفرعية",
  T_48_META_API_10054_D: "احصل على العقدة الأصلية لكيان العقدة الفرعية المستهدفة",
  T_48_META_API_10054_P0_D: "كيان العقدة الفرعية",
  T_48_META_API_10054_R_D: "كيان العقدة الأم",
  T_48_META_API_10055_D: "احذف كافة العقد التابعة ضمن كيان العقدة الأصلية المحدد. يجب أن تحتوي العقدة على مكون تحويل",
  T_48_META_API_10055_P0_D: "كيان العقدة الأم",
  T_48_META_API_10056_D: "هدف النقل الفوري إلى الموقع المحدد",
  T_48_META_API_10056_P0_D: "الوحدة التي يتم نقلها فوريًا",
  T_48_META_API_10056_P1_D: "إحداثيات نقطة النقل الفضائي",
  T_48_META_API_10056_P2_D: "اتجاه الوحدة بعد النقل الآني",
  T_48_META_API_10057_D: "احصل على الموقع بالقرب من زملائك في الفريق بشكل عشوائي، وأعد الإحداثيات القريبة منك في حالة عدم وجود زملاء في الفريق، وتجنب موقع اللاعبين الذين لا يستطيعون الوقوف.",
  T_48_META_API_10057_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_10057_R_D: "الإحداثيات بالقرب من زملاء اللاعب المستهدف",
  T_48_META_API_10058_D: "مسح حالة تلطيخ",
  T_48_META_API_10059_D: "قم بتشغيل التأثير الصوتي المحدد إذا كان هناك المزيد من السمات التي تحتاج إلى تعيين، فقم أيضًا بتعيين سمات الكيان الخاص بها من خلال الكيان.",
  T_48_META_API_10059_P0_D: "يتم استخدام الكود لتمثيل اسم المعلمة الرسمية التي تنشئ كيان التأثير الصوتي، وقيمة المتغير المحلي المقابلة لها هي الكيان الذي ينشئ التأثير الصوتي.",
  T_48_META_API_10059_P1_D: "كيان اللاعب الذي ينتمي إليه، مرئي فقط لهذا اللاعب",
  T_48_META_API_10059_P2_D: "نوع التأثير الصوتي، نوع المؤثرات الصوتية التي يمكن للاعبين اختيارها",
  T_48_META_API_1006_D: "قم بإنهاء عملية التنفيذ الحالية والعودة مباشرة إلى موقع الاتصال، ويمكنك العودة بالبيانات.",
  T_48_META_API_1006_P0_D: "البيانات المتوقع إرجاعها إلى موقع الاتصال",
  T_48_META_API_10060_D: "طرد اللاعب المستهدف من اللعبة",
  T_48_META_API_10060_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_10060_P1_D: "ما إذا كان سيتم عرض معلومات الفوترة",
  T_48_META_API_10061_D: "يطلب اللاعب المستهدف مطابقة الخريطة المحددة",
  T_48_META_API_10061_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_10061_P1_D: "رمز ساحة المعركة",
  T_48_META_API_10061_P2_D: "ما إذا كانت النافذة المنبثقة تطالبك بالعودة إلى اللعبة الأصلية عند إلغاء المباراة",
  T_48_META_API_10062_D: "مقاطعة تشغيل كيان تأثير الصوت",
  T_48_META_API_10062_P0_D: "كيان التأثير الصوتي الذي يجب إيقافه مؤقتًا",
  T_48_META_API_10063_D: "الاستمرار في تشغيل المؤثرات الصوتية، يمكنك اختيار ما إذا كنت تريد بدء اللعب من البداية",
  T_48_META_API_10063_P0_D: "كيانات التأثير الصوتي التي تحتاج إلى مواصلة التشغيل بعد إيقافها مؤقتًا",
  T_48_META_API_10063_P1_D: "ما إذا كان يجب البدء من الصفر",
  T_48_META_API_10064_D: "إنشاء عملية إنزال جوي لها ثلاث مراحل: 1. التحضير، 2. السقوط، 3. لا يمكن تعديل سمات الإنزال الجوي إلا في الحالة 1.",
  T_48_META_API_10064_P0_D: "تم إنشاء كيان صندوق الإسقاط الجوي",
  T_48_META_API_1007_D: "قم بتنفيذ حلقة تستمر في التنفيذ بناءً على ما إذا كان الشرط صحيحًا، حتى يصبح الشرط خاطئًا وتنتهي الحلقة.",
  T_48_META_API_1007_P0_D: "عندما يكون الشرط صحيحا، تستمر الحلقة، وعندما يكون الشرط خاطئا، تنتهي الحلقة.",
  T_48_META_API_1008_D: `انتظر حتى بداية الإطار المنطقي التالي
على الخادم، إذا تم تمكين وضع معدل الإطارات المنخفض، فسيكون الانتظار أطول
على العميل، يتأثر وقت الانتظار بأداء الجهاز والتعقيد المنطقي للإطار الحالي
استخدام يجب إعلان وظيفة واجهة برمجة التطبيقات هذه غير متزامنة`,
  T_48_META_API_1009_D: "بعد الانتظار لفترة زمنية معينة، يجب الإعلان عن الوظيفة التي تستخدم واجهة برمجة التطبيقات هذه على أنها غير متزامنة.",
  T_48_META_API_1009_P0_D: "مدة الانتظار بالمللي ثانية",
  T_48_META_API_101_D: "إلغاء تثبيت المشهد المحدد",
  T_48_META_API_101_P0_D: "سيتم إلغاء تثبيت معرف المشهد",
  T_48_META_API_1010: "استدعاء الحدث",
  T_48_META_API_1010_D: "إجراء يتم تشغيله عند وقوع حدث ما",
  T_48_META_API_1010_P0: "أسماء معلمات الحدث",
  T_48_META_API_1010_P0_D: "اسم المعلمة الرسمي لمعلمة الحدث، والذي يمكن من خلاله الحصول على قيمة المعلمة الفعلية على المتغير المحلي",
  T_48_META_API_1011: "كتلة الكود",
  T_48_META_API_1011_D: "كتلة من التعليمات البرمجية التي تحمل مجموعة من واجهات برمجة التطبيقات",
  T_48_META_API_1011_P0: "أسماء المعلمات",
  T_48_META_API_1011_P0_D: "أسماء المعلمات الرسمية عندما تكون كتلة التعليمات البرمجية وظيفة مخصصة",
  T_48_META_API_1012: "البحث عن واجهة برمجة التطبيقات المخصصة واستدعائها باستخدام Serial",
  T_48_META_API_1012_D: "استدعاء الدالة المخصصة بطريقة تسلسلية إذا كان هناك انتظار في الدالة المخصصة، فسوف ينتظر موقع الاستدعاء أيضًا.",
  T_48_META_API_1012_P0_D: "الكيان الذي توجد به الوظيفة المخصصة",
  T_48_META_API_1012_P1: "معرف الرسم البياني",
  T_48_META_API_1012_P1_D: "معرف البرنامج النصي حيث توجد الوظيفة المخصصة",
  T_48_META_API_1012_P2: "معرف الوظيفة",
  T_48_META_API_1012_P2_D: "معرف الوظيفة الذي يستدعيه الهدف",
  T_48_META_API_1012_P3_D: "قائمة الوسائط التي تم تمريرها إلى الوظيفة المخصصة",
  T_48_META_API_1013: "البحث عن واجهة برمجة التطبيقات المخصصة واستدعائها باستخدام Parallel",
  T_48_META_API_1013_D: "استدعاء وظيفة مخصصة بالتوازي بغض النظر عما إذا كان هناك انتظار في الوظيفة المخصصة، فسوف تعود على الفور إلى موقع الاستدعاء وتستمر في التنفيذ.",
  T_48_META_API_1013_P0_D: "الكيان الذي توجد به الوظيفة المخصصة",
  T_48_META_API_1013_P1: "معرف الرسم البياني",
  T_48_META_API_1013_P1_D: "معرف البرنامج النصي حيث توجد الوظيفة المخصصة",
  T_48_META_API_1013_P2: "معرف الوظيفة",
  T_48_META_API_1013_P2_D: "معرف الوظيفة الذي يستدعيه الهدف",
  T_48_META_API_1013_P3_D: "قائمة الوسائط التي تم تمريرها إلى الوظيفة المخصصة",
  T_48_META_API_1014: "البحث عن واجهة برمجة التطبيقات المخصصة واستدعائها باستخدام Serial",
  T_48_META_API_1014_D: "استدعاء الوظيفة المخصصة في البرنامج النصي الحالي في الوضع التسلسلي. إذا كان هناك انتظار في الوظيفة المخصصة، فسوف ينتظر موقع الاتصال أيضًا.",
  T_48_META_API_1014_P0: "معرف الوظيفة",
  T_48_META_API_1014_P0_D: "معرف الوظيفة الذي يستدعيه الهدف",
  T_48_META_API_1014_P1_D: "قائمة الوسائط التي تم تمريرها إلى الوظيفة المخصصة",
  T_48_META_API_1015: "البحث عن واجهة برمجة التطبيقات المخصصة واستدعائها باستخدام Parallel",
  T_48_META_API_1015_D: "استدعاء وظيفة مخصصة بالتوازي بغض النظر عما إذا كان هناك انتظار في الوظيفة المخصصة، فسوف تعود على الفور إلى موقع الاستدعاء وتستمر في التنفيذ.",
  T_48_META_API_1015_P0: "تعيين متغير محلي حسب الفهرس",
  T_48_META_API_1015_P0_D: "معرف الوظيفة الذي يستدعيه الهدف",
  T_48_META_API_1015_P1_D: "قائمة الوسائط التي تم تمريرها إلى الوظيفة المخصصة",
  T_48_META_API_1016_D: "يحصل على نوع الهدف عند استدعاء واجهة برمجة التطبيقات هذه",
  T_48_META_API_1016_P0_D: "الهدف الذي يتم الاستعلام عنه",
  T_48_META_API_1016_R_D: "نوع متغير",
  T_48_META_API_1017_D: "تحديد ما إذا كان المتغير الهدف من النوع المحدد",
  T_48_META_API_1017_P0_D: "الهدف الذي يتم الاستعلام عنه",
  T_48_META_API_1017_P1_D: "النوع الذي تتم مقارنته",
  T_48_META_API_1017_R_D: "هل هو متسق؟",
  T_48_META_API_1018_D: "تحديد ما إذا كان المتغير الهدف هو فئة فرعية من نوع معين، والقيمة المرجعة هي قيمة منطقية",
  T_48_META_API_1018_P0_D: "المتغير الهدف الذي يتم الاستعلام عنه",
  T_48_META_API_1018_P1_D: "النوع الذي تتم مقارنته",
  T_48_META_API_1018_R_D: "سواء كانت فئة فرعية",
  T_48_META_API_1019_D: "اجعل الكيان المستهدف يقوم بتشغيل الحدث المخصص المحدد",
  T_48_META_API_1019_P0_D: "تم إرسال معرف الحدث المخصص",
  T_48_META_API_1019_P1_D: "الكيان المستهدف",
  T_48_META_API_1019_P2_D: "قائمة المعلمات",
  T_48_META_API_102_D: "سيؤدي التبديل إلى المشهد المحدد إلى إلغاء تحميل المشاهد الأخرى المحملة.",
  T_48_META_API_102_P0_D: "معرف المشهد للتبديل إليه",
  T_48_META_API_1020_D: "قم بتنفيذ اجتياز الحاوية واحصل على كل زوج من قيمة المفتاح، بما في ذلك العمليات الفرعية. جسم الحلقة هو العملية الفرعية.",
  T_48_META_API_1020_P0_D: "انتقل إلى اسم المفتاح، ويمكنك استخدامه للحصول على قيمة المفتاح في المتغير المحلي",
  T_48_META_API_1020_P1_D: "انتقل إلى اسم القيمة، والذي يمكن استخدامه للحصول على القيمة في المتغير المحلي",
  T_48_META_API_1020_P2_D: "الحاوية لاجتياز",
  T_48_META_API_1021_D: "تدمير الروبوت المحدد",
  T_48_META_API_1021_P0_D: "لاعبو الروبوتات الذين يحتاجون إلى التدمير",
  T_48_META_API_1022_D: "إجبار اللاعب المستهدف على مغادرة السيارة",
  T_48_META_API_1022_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_1023_D: "إنشاء كلمة القفز الضرر",
  T_48_META_API_1023_P0_D: "تخطي محتوى الكلمة",
  T_48_META_API_1023_P1_D: "حجم الخط",
  T_48_META_API_1023_P2_D: "لون الخط",
  T_48_META_API_1023_P3_D: "مدة البقاء بالمللي ثانية",
  T_48_META_API_1023_P4_D: "الجهة المتضررة",
  T_48_META_API_1023_P5_D: "إزاحة كلمة الانتقال الخاصة بالضرر بالنسبة إلى الإحداثيات العالمية للكيان المستهدف",
  T_48_META_API_1023_P6_D: "حجم نطاق تصحيح الموضع العشوائي مرة أخرى عند موضع قفزة الضرر",
  T_48_META_API_1023_P7_D: "ما إذا كان سيتم تنفيذ الرسوم المتحركة توين",
  T_48_META_API_1024_D: "مهمل",
  T_48_META_API_1024_P0_D: "مهمل",
  T_48_META_API_1024_P1_D: "الكيان المستهدف",
  T_48_META_API_1024_P2_D: "بعد التحديد، إذا تم استدعاؤه على الخادم، فسيتم إرساله إلى العميل، وإذا تم استدعاؤه من قبل العميل، فسيتم إرساله إلى الخادم.",
  T_48_META_API_1024_P3_D: "قائمة المعلمات",
  T_48_META_API_1025_D: "الاستعلام عن تقدم المهمة المخصصة",
  T_48_META_API_1025_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_1025_P1_D: "معرف المهمة المخصصة",
  T_48_META_API_1025_R_D: "تقدم المهمة",
  T_48_META_API_1026_D: "احصل على جلد حقيبة ظهر اللاعب المستهدف",
  T_48_META_API_1026_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_1026_R_D: "معرف جلد حقيبة الظهر",
  T_48_META_API_1027_D: "قم بتعيين جلد حقيبة ظهر اللاعب المستهدف",
  T_48_META_API_1027_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_1027_P1_D: "معرف جلد حقيبة الظهر",
  T_48_META_API_1028_D: "قم باستعادة مظهر حقيبة ظهر اللاعب المستهدف إلى التكوين الخارجي الافتراضي",
  T_48_META_API_1028_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_1029_D: "قم بمسح جلد حقيبة ظهر اللاعب المستهدف",
  T_48_META_API_1029_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_103_D: "قم بتغيير نمط بيئة Skybox للعبة، يمكنك اختيار النهار، الغسق، الليل، إلخ.",
  T_48_META_API_103_P0_D: "نوع سكاي بوكس",
  T_48_META_API_1030_D: "احصل على موقع نقطة تعليق العظام بالاسم",
  T_48_META_API_1030_P0_D: "الكيان المستهدف",
  T_48_META_API_1030_P1_D: "اسم نقطة تعليق العظام",
  T_48_META_API_1030_R_D: "نقطة الهيكل",
  T_48_META_API_1031_D: "قم بتعيين العقدة الأصلية لكيان الكائن، والكيانات الداعمة المثبتة بمكونات Transform وSkeletonPart وPlayer وMountPoint.",
  T_48_META_API_1031_P0_D: "العقدة الأم",
  T_48_META_API_1031_P1_D: "عقدة الطفل",
  T_48_META_API_1031_P2_D: "ما إذا كان سيتم الاحتفاظ بالموضع العالمي الحالي وتدوير العقد الفرعية وتوسيع نطاقها. هذا العنصر غير صالح إذا تم تعيينه بواسطة واجهة المستخدم.",
  T_48_META_API_1032_D: "قم بتشغيل تأثير الرسوم المتحركة للأيقونة، حيث يترجم الرمز من موضع البداية إلى موضع النهاية بسرعة التشغيل",
  T_48_META_API_1032_P0_D: "معرف مورد الرمز",
  T_48_META_API_1032_P1_D: "لون",
  T_48_META_API_1032_P2_D: "تكبير الأيقونة",
  T_48_META_API_1032_P3_D: "مركز موقف البداية",
  T_48_META_API_1032_P4_D: "نطاق منطقة البداية",
  T_48_META_API_1032_P5_D: "مركز الموقف النهائي",
  T_48_META_API_1032_P6_D: "نطاق الموضع النهائي",
  T_48_META_API_1032_P7_D: "سرعة التشغيل هي المسافة التي يتحركها الرمز في الثانية",
  T_48_META_API_1033_D: "إجراء عملية ظل الزاوية للحصول على الزاوية",
  T_48_META_API_1033_P0_D: "إحداثيات المحور ص",
  T_48_META_API_1033_P1_D: "إحداثيات المحور السيني",
  T_48_META_API_1033_R_D: "الزاوية، المدى (-180، 180]",
  T_48_META_API_1034_D: "إضافة مكونات إلى الكيانات يتم دعم المكونات المخصصة التي أنشأها المستخدم فقط.",
  T_48_META_API_1034_P0_D: "الكيان المستهدف",
  T_48_META_API_1034_P1_D: "معرف نوع المكون، يدعم فقط المكونات المخصصة التي أنشأها المستخدم",
  T_48_META_API_1034_P2_D: "سواء تمت إضافتها بنجاح، ستفشل إضافة المكونات الموجودة أو المكونات غير المخصصة.",
  T_48_META_API_1035_D: "قم بإزالة المكونات من الكيانات ودعم المكونات المخصصة فقط",
  T_48_META_API_1035_P0_D: "الكيان المستهدف",
  T_48_META_API_1035_P1_D: "معرف نوع المكون، يدعم فقط المكونات المخصصة التي أنشأها المستخدم",
  T_48_META_API_1035_P2_D: "ما إذا كانت عملية الإزالة ناجحة أم لا. ستفشل عملية إزالة المكونات غير الموجودة أو غير المخصصة.",
  T_48_META_API_1036_D: "قم بتخصيص واجهة خروج اللاعب في منتصف الطريق",
  T_48_META_API_1036_P0_D: "عنوان",
  T_48_META_API_1036_P1_D: "محتوى",
  T_48_META_API_1036_P2_D: "خيارات",
  T_48_META_API_1036_P3_D: "ما إذا كان سيتم عرض الخلفية",
  T_48_META_API_1037_D: "احصل على جميع المشاهد المحملة حاليًا",
  T_48_META_API_1037_R_D: "قائمة المشهد",
  T_48_META_API_1038_D: "احصل على اتجاه التصويب المحلي للاعب",
  T_48_META_API_1038_R_D: "تهدف الاتجاه",
  T_48_META_API_1039_D: "الحصول على الطابع الزمني المحلي",
  T_48_META_API_1039_R_D: "الطابع الزمني",
  T_48_META_API_104_D: "قم بتبديل المشغل إلى الموضع المحدد للمشهد المحدد وسيتم تحميل المشاهد التي تم إلغاء تحميلها تلقائيًا، ولن يتم إلغاء تحميل المشاهد المحملة تلقائيًا.",
  T_48_META_API_104_P0_D: "لاعب",
  T_48_META_API_104_P1_D: "معرف المشهد للتحميل",
  T_48_META_API_104_P2_D: "موقف اللاعب في المشهد الجديد",
  T_48_META_API_104_P3_D: "توجه اللاعب في المشهد الجديد",
  T_48_META_API_1040_D: "إيقاف تحديث الإطار الثابت للنظام الأساسي الحالي مؤقتًا بعد الإيقاف المؤقت، لن يتم تشغيل حدث تحديث الإطار الثابت للنظام الأساسي بعد الآن.",
  T_48_META_API_1041_D: "استئناف تحديث الإطار الثابت للنظام الأساسي الحالي بعد الاسترداد، يبدأ تشغيل حدث تحديث الإطار الثابت للنظام الأساسي مرة أخرى.",
  T_48_META_API_1042_D: "تحديد علاقة الصداقة بين اللاعب المستهدف واللاعب العميل الحالي. العميل الحالي نفسه ليس صديقًا للعميل الحالي.",
  T_48_META_API_1042_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_1042_R_D: "سواء كنت صديقًا للعميل الحالي",
  T_48_META_API_1043_D: "تشغيل حدث مخصص",
  T_48_META_API_1043_P0_D: "معرف الحدث المخصص",
  T_48_META_API_1043_P1_D: "الكيان المستهدف",
  T_48_META_API_1043_P2_D: "النظام الأساسي قيد التشغيل هو الخادم أو العميل",
  T_48_META_API_1043_P3_D: "قائمة المعلمات",
  T_48_META_API_1044_D: "ابدأ بالقفز بالمظلات",
  T_48_META_API_1044_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_1044_P1_D: "تحت هذا الارتفاع، سيتم فتح المظلة",
  T_48_META_API_1044_P2_D: "السرعة عند الانزلاق، يمثل المكون X السرعة الأفقية، ويمثل المكون Y السرعة الرأسية، وعندما يكون المكون Y سالبًا، يهبط اللاعب إلى الأسفل",
  T_48_META_API_1044_P3_D: "السرعة عند الغوص، يمثل المكون X السرعة الأفقية، ويمثل المكون Y السرعة الرأسية، وعندما يكون المكون Y سالبًا، يسقط اللاعب إلى الأسفل؛",
  T_48_META_API_1044_P4_D: "السرعة عند فتح المظلة، والمكون X يمثل السرعة الأفقية، والمكون Y يمثل السرعة الرأسية، وعندما يكون المكون Y سالبًا، يهبط اللاعب للأسفل؛",
  T_48_META_API_1045_D: "اقرأ القيمة المقابلة للمعرف المحدد في جدول البيانات",
  T_48_META_API_1045_P0_D: "اسم الجدول في قاعدة البيانات",
  T_48_META_API_1045_P1_D: "معرف فريد للاعب",
  T_48_META_API_1045_P2_D: "تحديد المعرف",
  T_48_META_API_1045_P3_D: "قراءة النتائج",
  T_48_META_API_1045_P4_D: "يمثل رمز ساحة المعركة المقابل لقاعدة البيانات، والذي يمكن ملؤه بالفراغات، رمز ساحة المعركة للخريطة الحالية",
  T_48_META_API_1045_P5_D: "رمز الخطأ",
  T_48_META_API_1046_D: "اقرأ القيمة المقابلة للمعرف المحدد في جدول بيانات التصنيف",
  T_48_META_API_1046_P0_D: "اسم جدول الترتيب في قاعدة البيانات",
  T_48_META_API_1046_P1_D: "تحديد المعرف",
  T_48_META_API_1046_P2_D: "قراءة النتائج",
  T_48_META_API_1046_P3_D: "يمثل رمز ساحة المعركة المقابل لقاعدة البيانات، والذي يمكن ملؤه بالفراغات، رمز ساحة المعركة للخريطة الحالية",
  T_48_META_API_1046_P4_D: "رمز الخطأ",
  T_48_META_API_1047_D: "اقرأ قيمة فترة التصنيف المحددة في جدول بيانات التصنيف",
  T_48_META_API_1047_P0_D: "اسم جدول الترتيب في قاعدة البيانات",
  T_48_META_API_1047_P1_D: "يجب أن تكون المرتبة الأولية أقل من أو تساوي المرتبة النهائية، وتبدأ المرتبة من 1",
  T_48_META_API_1047_P2_D: "الترتيب النهائي",
  T_48_META_API_1047_P3_D: "قراءة النتائج",
  T_48_META_API_1047_P4_D: "يمثل رمز ساحة المعركة المقابل لقاعدة البيانات، والذي يمكن ملؤه بالفراغات، رمز ساحة المعركة للخريطة الحالية",
  T_48_META_API_1047_P5_D: "رمز الخطأ",
  T_48_META_API_1048_D: "اقرأ القيمة المقابلة للمعرف المحدد في جدول البيانات التراكمية",
  T_48_META_API_1048_P0_D: "اسم جدول البيانات المتراكمة في قاعدة البيانات",
  T_48_META_API_1048_P1_D: "تحديد المعرف",
  T_48_META_API_1048_P2_D: "قراءة النتائج",
  T_48_META_API_1048_P3_D: "يمثل رمز ساحة المعركة المقابل لقاعدة البيانات، والذي يمكن ملؤه بالفراغات، رمز ساحة المعركة للخريطة الحالية",
  T_48_META_API_1048_P4_D: "رمز الخطأ",
  T_48_META_API_1049_D: "اكتب القيمة المقابلة للمعرف المحدد في جدول البيانات",
  T_48_META_API_1049_P0_D: "اسم الجدول في قاعدة البيانات",
  T_48_META_API_1049_P1_D: "معرف فريد للاعب",
  T_48_META_API_1049_P2_D: "تحديد المعرف",
  T_48_META_API_1049_P3_D: "القيمة مكتوبة",
  T_48_META_API_1049_P4_D: "يمثل رمز ساحة المعركة المقابل لقاعدة البيانات، والذي يمكن ملؤه بالفراغات، رمز ساحة المعركة للخريطة الحالية",
  T_48_META_API_1049_P5_D: "رمز الخطأ",
  T_48_META_API_105_D: "احصل على Skybox للمشهد",
  T_48_META_API_105_P0_D: "معرف المشهد",
  T_48_META_API_105_R_D: "com.skybox",
  T_48_META_API_1050_D: "احصل على عدد العناصر في القائمة",
  T_48_META_API_1050_P0_D: "قائمة الهدف",
  T_48_META_API_1050_R_D: "عدد العناصر",
  T_48_META_API_1051_D: "احصل على قيمة العنصر في الفهرس المحدد في القائمة",
  T_48_META_API_1051_P0_D: "قائمة الهدف",
  T_48_META_API_1051_P1_D: "قيمة المؤشر تبدأ من 0",
  T_48_META_API_1051_R_D: "قيمة العنصر",
  T_48_META_API_1052_D: "يضبط قيمة العنصر المطابقة للفهرس المحدد في القائمة",
  T_48_META_API_1052_P0_D: "قائمة الهدف",
  T_48_META_API_1052_P1_D: "قيمة المؤشر تبدأ من 0",
  T_48_META_API_1052_P2_D: "قيمة العنصر",
  T_48_META_API_1053_D: "إلحاق العناصر بنهاية القائمة",
  T_48_META_API_1053_P0_D: "قائمة الهدف",
  T_48_META_API_1053_P1_D: "عناصر لإضافتها",
  T_48_META_API_1054_D: "إزالة العنصر المطابق للفهرس المحدد من القائمة",
  T_48_META_API_1054_P0_D: "قائمة الهدف",
  T_48_META_API_1054_P1_D: "قيمة المؤشر تبدأ من 0",
  T_48_META_API_1055_D: "مسح كافة العناصر في القائمة",
  T_48_META_API_1055_P0_D: "قائمة الهدف",
  T_48_META_API_1056_D: "عكس القائمة المحددة سيتم عكس ترتيب العناصر في القائمة.",
  T_48_META_API_1056_P0_D: "قائمة الهدف",
  T_48_META_API_1057_D: "نسخ قائمة",
  T_48_META_API_1057_P0_D: "قائمة الهدف",
  T_48_META_API_1057_R_D: "تم نسخ القائمة الجديدة",
  T_48_META_API_1058_D: "قم بإدراج عنصر جديد في موضع الفهرس المحدد في القائمة، وسيتم نقل العناصر الموجودة في موضع الفهرس الأصلي وما بعده إلى الخلف بمقدار موضع واحد على التوالي.",
  T_48_META_API_1058_P0_D: "قائمة الهدف",
  T_48_META_API_1058_P1_D: "موضع الفهرس المراد إدراجه، يتم حساب الفهرس من 0",
  T_48_META_API_1058_P2_D: "قيمة العنصر الجديد المراد إدراجه",
  T_48_META_API_1059_D: "إعادة ترتيب العناصر الموجودة في القائمة بشكل عشوائي",
  T_48_META_API_1059_P0_D: "قائمة الهدف",
  T_48_META_API_1060_D: "مقارنة المعلمات على كلا الجانبين وإرجاع صحيح أو خطأ",
  T_48_META_API_1060_P0_D: "القيمة المستخدمة للمقارنة",
  T_48_META_API_1060_P1_D: "تدعم طريقة المقارنة الطرق التالية: >،>=،==،!=،<=،<،و (نوع منطقي محدود)، أو (نوع منطقي محدود)",
  T_48_META_API_1060_P2_D: "القيمة المستخدمة للمقارنة",
  T_48_META_API_1060_R_D: "قارن النتائج",
  T_48_META_API_1061_D: "العمليات الحسابية الأربع الأساسية تشمل الجمع والطرح والضرب والقسمة والباقي. تدعم العملية المتبقية الأعداد الصحيحة فقط، بينما تدعم بقية العمليات الأعداد الصحيحة أو الكسور العشرية.",
  T_48_META_API_1061_P0_D: "قيمة العملية",
  T_48_META_API_1061_P1_D: "أربعة أنواع من العمليات الحسابية، بما في ذلك الجمع والطرح والضرب والقسمة والباقي. العملية المتبقية لا تدعم الكسور العشرية.",
  T_48_META_API_1061_P2_D: "قيمة العملية",
  T_48_META_API_1061_R_D: "نتيجة الحساب",
  T_48_META_API_1062_D: "يتم إنشاء عدد صحيح بشكل عشوائي بين أصغر عدد صحيح (شامل) وأكبر عدد صحيح (حصري)",
  T_48_META_API_1062_P0_D: "الفاصل الزمني الأيسر للنطاق العشوائي، من الممكن الوصول بشكل عشوائي إلى القيمة المملوءة",
  T_48_META_API_1062_P1_D: "لن يكون الفاصل الزمني الصحيح للنطاق العشوائي عشوائيًا بالنسبة للقيمة المملوءة.",
  T_48_META_API_1062_R_D: "نتيجة عشوائية، عدد صحيح",
  T_48_META_API_1063_D: "ينشئ بشكل عشوائي رقمًا عشريًا بين أصغر قيمة عشرية (شاملة) وأكبر قيمة عشرية (حصريًا)",
  T_48_META_API_1063_P0_D: "في الفاصل الزمني الأيسر للنطاق العشوائي، هناك احتمال ضئيل أن تكون القيمة المملوءة عشوائية.",
  T_48_META_API_1063_P1_D: "لن يكون الفاصل الزمني الصحيح للنطاق العشوائي عشوائيًا بالنسبة للقيمة المملوءة.",
  T_48_META_API_1063_R_D: "نتيجة عشوائية، عشرية، دقيقة إلى 7 منازل عشرية",
  T_48_META_API_1064_D: "تحديد ما إذا كان الكائن فارغًا",
  T_48_META_API_1064_P0_D: "الكائن المراد الحكم عليه فارغا",
  T_48_META_API_1064_R_D: "هل هو فارغ",
  T_48_META_API_1065_D: "النفي المنطقي، قيمة الإدخال: صحيح أو خطأ، قيمة الإرجاع: خطأ أو صحيح",
  T_48_META_API_1065_P0_D: "بحاجة إلى العثور على قيمة غير",
  T_48_META_API_1065_R_D: "نتيجة سلبية",
  T_48_META_API_1066_D: "خذ القيمة المطلقة، ويدعم الأعداد الصحيحة والكسور العشرية",
  T_48_META_API_1066_P0_D: "بحاجة إلى العثور على القيمة المطلقة للقيمة",
  T_48_META_API_1066_R_D: "نتيجة أخذ القيمة المطلقة",
  T_48_META_API_1067_D: "احسب الجذر التربيعي",
  T_48_META_API_1067_P0_D: "من الضروري العثور على الجذر التربيعي للقيمة",
  T_48_META_API_1067_R_D: "نتيجة إيجاد الجذر التربيعي",
  T_48_META_API_1068_D: "حساب القيم السلبية",
  T_48_META_API_1068_P0_D: "بحاجة إلى العثور على قيمة سلبية",
  T_48_META_API_1068_R_D: "نتيجة سلبية",
  T_48_META_API_1069_D: "قم بربط سلسلتين معًا",
  T_48_META_API_1069_P0_D: "قيمة السلسلة",
  T_48_META_API_1069_P1_D: "قيمة السلسلة",
  T_48_META_API_1069_R_D: "نتيجة تسلسل السلسلة",
  T_48_META_API_1070_D: "الحصول على طول السلسلة",
  T_48_META_API_1070_P0_D: "خيط",
  T_48_META_API_1070_R_D: "طول السلسلة",
  T_48_META_API_1071_D: "لتقريب القيمة المحددة إلى أقرب عدد صحيح",
  T_48_META_API_1071_P0_D: "القيمة التي يجب تقريبها للأسفل",
  T_48_META_API_1071_R_D: "نتيجة التقريب للأسفل",
  T_48_META_API_1072_D: "لتقريب القيمة المحددة إلى أقرب عدد صحيح",
  T_48_META_API_1072_P0_D: "القيمة التي يجب تقريبها للأعلى",
  T_48_META_API_1072_R_D: "نتيجة التقريب",
  T_48_META_API_1073_D: "لتقريب القيمة المحددة إلى عدد صحيح",
  T_48_META_API_1073_P0_D: "القيم التي يجب تقريبها",
  T_48_META_API_1073_R_D: "نتيجة مدورة",
  T_48_META_API_1074_D: "بعد استبدال جميع السلاسل المحددة في السلسلة الهدف، قم بإخراج السلسلة الجديدة",
  T_48_META_API_1074_P0_D: "سلسلة الهدف",
  T_48_META_API_1074_P1_D: "السلسلة القديمة المراد استبدالها",
  T_48_META_API_1074_P2_D: "السلسلة الجديدة المراد استبدالها",
  T_48_META_API_1074_R_D: "استبدال السلسلة المكتملة",
  T_48_META_API_1075_D: "ابحث في السلسلة الهدف عن التواجد الأول لسلسلة محددة.",
  T_48_META_API_1075_P0_D: "سلسلة الهدف",
  T_48_META_API_1075_P1_D: "السلسلة المحددة للبحث عنها",
  T_48_META_API_1075_P2_D: "ابحث عن السلسلة من موضع البداية، ويتم حساب موضع السلسلة من 0",
  T_48_META_API_1075_R_D: "يحدد موضع التواجد الأول للسلسلة في السلسلة الهدف ويتم حساب موضع السلسلة من 0.",
  T_48_META_API_1076_D: "بعد اعتراض سلسلة ذات طول محدد بدءًا من الموضع المحدد، قم بإخراج سلسلة جديدة",
  T_48_META_API_1076_P0_D: "سلسلة الهدف",
  T_48_META_API_1076_P1_D: "الموضع الذي يبدأ فيه الاعتراض. يتم حساب موضع السلسلة من 0.",
  T_48_META_API_1076_P2_D: "قطع الطول بشكل افتراضي، يتم قطعه إلى نهاية السلسلة.",
  T_48_META_API_1076_R_D: "السلسلة المعترضة",
  T_48_META_API_1077_D: "يقارن ما إذا كانت عناصر القائمتين متطابقة تمامًا أم لا، ولا تؤثر سعة القائمة على نتيجة المقارنة.",
  T_48_META_API_1077_P0_D: "قائمة القيم المستخدمة للمقارنة",
  T_48_META_API_1077_P1_D: "قائمة rالقيم المستخدمة للمقارنة",
  T_48_META_API_1077_R_D: "مقارنة النتائج، إذا كانت المحتويات متسقة، فسيتم إرجاع True؛ وإذا كانت المحتويات غير متسقة، فسيتم إرجاع False.",
  T_48_META_API_1078_D: "باستخدام السلسلة المحددة كمحدد، قم بقص السلسلة المستهدفة إلى عدة شرائح وإخراج سلسلة جديدة سيتم قطع محددات N المتتالية إلى مسافات نصف العرض N-1 وإخراجها كعناصر قائمة سلسلة.",
  T_48_META_API_1078_P0_D: "سلسلة الهدف",
  T_48_META_API_1078_P1_D: "سلسلة الفاصلة",
  T_48_META_API_1078_R_D: "تنتهي قائمة سلسلة الإخراج دائمًا بعنصر مسافة نصف العرض.",
  T_48_META_API_1079_D: "قم باستخراج الأحرف وفقًا لقائمة مواضع السلسلة ودمجها في مخرجات سلسلة جديدة",
  T_48_META_API_1079_P0_D: "سلسلة الهدف",
  T_48_META_API_1079_P1_D: "قائمة مواضع السلسلة، يتم حساب مواضع السلسلة بدءًا من 0",
  T_48_META_API_1079_R_D: "سلسلة الإخراج",
  T_48_META_API_1080_D: "تحويل أحرف السلسلة المستهدفة إلى كافة الأحرف الكبيرة",
  T_48_META_API_1080_P0_D: "سلسلة الهدف",
  T_48_META_API_1080_R_D: "سلسلة الإخراج",
  T_48_META_API_1081_D: "تحويل كافة أحرف السلسلة المستهدفة إلى أحرف صغيرة",
  T_48_META_API_1081_P0_D: "سلسلة الهدف",
  T_48_META_API_1081_R_D: "سلسلة الإخراج",
  T_48_META_API_1082_D: "قم بإزالة كافة المسافات قبل الحرف الأول غير الفراغي وبعد الحرف الأخير غير الفراغي من السلسلة الهدف",
  T_48_META_API_1082_P0_D: "سلسلة الهدف",
  T_48_META_API_1082_R_D: "سلسلة الإخراج",
  T_48_META_API_1083_D: "إخراج سلسلة جديدة بعد الارتباط بالمعرف المحدد",
  T_48_META_API_1083_P0_D: "قائمة سلسلة الهدف",
  T_48_META_API_1083_P1_D: "المعرف المحدد المستخدم لسلسلة السلاسل",
  T_48_META_API_1083_R_D: "سلسلة الإخراج",
  T_48_META_API_1084_D: "اكتب القيمة المقابلة للمعرف المحدد في جدول بيانات التصنيف",
  T_48_META_API_1084_P0_D: "اسم جدول الترتيب في قاعدة البيانات",
  T_48_META_API_1084_P1_D: "تحديد المعرف",
  T_48_META_API_1084_P2_D: "القيمة مكتوبة",
  T_48_META_API_1084_P3_D: "يمثل رمز ساحة المعركة المقابل لقاعدة البيانات، والذي يمكن ملؤه بالفراغات، رمز ساحة المعركة للخريطة الحالية",
  T_48_META_API_1084_P4_D: "رمز الخطأ",
  T_48_META_API_1085_D: "اكتب قيمة الإزاحة المقابلة للمعرف المحدد في جدول البيانات التراكمية",
  T_48_META_API_1085_P0_D: "اسم جدول البيانات المتراكمة في قاعدة البيانات",
  T_48_META_API_1085_P1_D: "تحديد المعرف",
  T_48_META_API_1085_P2_D: "أربعة أنواع من العمليات الحسابية",
  T_48_META_API_1085_P3_D: "قيمة الإزاحة مكتوبة",
  T_48_META_API_1085_P4_D: "يمثل رمز ساحة المعركة المقابل لقاعدة البيانات، والذي يمكن ملؤه بالفراغات، رمز ساحة المعركة للخريطة الحالية",
  T_48_META_API_1085_P5_D: "رمز الخطأ",
  T_48_META_API_1086_D: "احذف القيمة المقابلة للمعرف المحدد في جدول البيانات",
  T_48_META_API_1086_P0_D: "اسم الجدول في قاعدة البيانات",
  T_48_META_API_1086_P1_D: "معرف فريد للاعب",
  T_48_META_API_1086_P2_D: "تحديد المعرف",
  T_48_META_API_1086_P3_D: "يمثل رمز ساحة المعركة المقابل لقاعدة البيانات، والذي يمكن ملؤه بالفراغات، رمز ساحة المعركة للخريطة الحالية",
  T_48_META_API_1086_P4_D: "رمز الخطأ",
  T_48_META_API_1087_D: "احذف القيمة المقابلة للمعرف المحدد في جدول بيانات التصنيف",
  T_48_META_API_1087_P0_D: "اسم جدول الترتيب في قاعدة البيانات",
  T_48_META_API_1087_P1_D: "تحديد المعرف",
  T_48_META_API_1087_P2_D: "يمثل رمز ساحة المعركة المقابل لقاعدة البيانات، والذي يمكن ملؤه بالفراغات، رمز ساحة المعركة للخريطة الحالية",
  T_48_META_API_1087_P3_D: "رمز الخطأ",
  T_48_META_API_1088_D: "حذف القيمة المقابلة للتصنيف المحدد في جدول بيانات التصنيف",
  T_48_META_API_1088_P0_D: "اسم جدول الترتيب في قاعدة البيانات",
  T_48_META_API_1088_P1_D: "تحديد الترتيب",
  T_48_META_API_1088_P2_D: "يمثل رمز ساحة المعركة المقابل لقاعدة البيانات، والذي يمكن ملؤه بالفراغات، رمز ساحة المعركة للخريطة الحالية",
  T_48_META_API_1088_P3_D: "رمز الخطأ",
  T_48_META_API_1089_D: "إرسال رسالة المستخدم إلى شخصية",
  T_48_META_API_1089_P0_D: "معرف الشخصية المستهدف",
  T_48_META_API_1089_P1_D: "محتوى الرسالة",
  T_48_META_API_1090_D: "إرسال رسائل النظام إلى شخصية",
  T_48_META_API_1090_P0_D: "معرف الشخصية المستهدف",
  T_48_META_API_1090_P1_D: "محتوى الرسالة",
  T_48_META_API_1091_D: "مسح ذاكرة الشخصية",
  T_48_META_API_1091_P0_D: "رمز الخطأ",
  T_48_META_API_1092_D: "إثارة مركز الأعضاء",
  T_48_META_API_1092_P0_D: "رمز الخطأ",
  T_48_META_API_1093_D: "الحصول على الطابع الزمني لانتهاء العضوية",
  T_48_META_API_1093_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_1093_P1_D: "الطابع الزمني",
  T_48_META_API_1093_P2_D: "رمز الخطأ",
  T_48_META_API_1094_D: "تحديد ما إذا كان اللاعب عضوًا أم لا",
  T_48_META_API_1094_P0_D: "رمز الخطأ",
  T_48_META_API_1094_P1_D: "هل أنت عضو؟",
  T_48_META_API_1095_D: "الحصول على الطابع الزمني لانتهاء العضوية",
  T_48_META_API_1095_P0_D: "الطابع الزمني",
  T_48_META_API_1095_P1_D: "رمز الخطأ",
  T_48_META_API_1096_D: "تحديد ما إذا كان اللاعب عضوًا أم لا",
  T_48_META_API_1096_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_1096_P1_D: "رمز الخطأ",
  T_48_META_API_1096_P2_D: "هل أنت عضو؟",
  T_48_META_API_1097_D: "إثارة مركز الأعضاء",
  T_48_META_API_1097_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_1097_P1_D: "رمز الخطأ",
  T_48_META_API_1099_D: "قم بإعداد مراقب الشخصية، وسيتم أيضًا إرسال المحادثات اللاحقة مع الشخصية إلى المراقب.",
  T_48_META_API_1099_P0_D: "معرف الشخصية المستهدف",
  T_48_META_API_1099_P1_D: "قائمة المراقبين",
  T_48_META_API_11_D: "إنهاء المرحلة الحالية والدخول إلى المرحلة التالية",
  T_48_META_API_1100_D: "إرسال رسائل المستخدم إلى شخصية باستخدام الدفق",
  T_48_META_API_1100_P0_D: "معرف الشخصية المستهدف",
  T_48_META_API_1100_P1_D: "محتوى الرسالة",
  T_48_META_API_1101_D: "إرسال رسائل النظام إلى شخصية باستخدام الدفق",
  T_48_META_API_1101_P0_D: "معرف الشخصية المستهدف",
  T_48_META_API_1101_P1_D: "محتوى الرسالة",
  T_48_META_API_1101_P2_D: "ما إذا كان يجب الرد أم لا",
  T_48_META_API_1103_D: "إنشاء بذرة عشوائية",
  T_48_META_API_1103_P0_D: "بذرة",
  T_48_META_API_1103_R_D: "مولد رقم عشوائي",
  T_48_META_API_1104_D: "احصل على الرقم العشوائي التالي من منشئ الأرقام العشوائية المحدد، القيمة القصوى هي 32767",
  T_48_META_API_1104_P0_D: "مولد رقم عشوائي",
  T_48_META_API_1104_P1_D: "نطاق الحد الأدنى",
  T_48_META_API_1104_P2_D: "النطاق الأقصى",
  T_48_META_API_1104_R_D: "رقم عشوائي",
  T_48_META_API_1108_D: "احصل على لغة العميل التي يستخدمها اللاعب",
  T_48_META_API_12_D: "طباعة السجل إلى وحدة التحكم",
  T_48_META_API_12_P0_D: "ما يحتاج إلى طباعته",
  T_48_META_API_13_D: "إخراج سلسلة مع المعلمات",
  T_48_META_API_13_P0_D: "استخدم العنصر النائب %v لتمثيل المعلمة. يجب أن يكون عدد %v وعدد المعلمات متسقًا.",
  T_48_META_API_13_P1_D: "يجب أن تكون قائمة المعلمات المشاركة في الإخراج متوافقة مع رقم %v في وصف التنسيق.",
  T_48_META_API_13_R_D: "سلسلة الإخراج",
  T_48_META_API_14_D: "قم بتنظيف بقايا كائن الخريطة، بما في ذلك صناديق الموت، والكائنات التي تم إنشاؤها، والأشياء الموضوعة، وبقايا المقذوفات، وما إلى ذلك.",
  T_48_META_API_15_D: "تخصيص سجل نقاط المنافسة لتحليل بيانات تجربة المستخدم",
  T_48_META_API_15_P0_D: "قائمة أسماء الحقول التي سيتم الإبلاغ عنها",
  T_48_META_API_15_P1_D: "قائمة قيم الحقول المطلوب الإبلاغ عنها",
  T_48_META_API_1500_D: "احصل على المكون X لمتجه ثلاثي الأبعاد",
  T_48_META_API_1500_P0_D: "ناقلات ثلاثية الأبعاد",
  T_48_META_API_1500_R_D: "مكون X ثلاثي الأبعاد",
  T_48_META_API_1501_D: "احصل على المكون Y لمتجه ثلاثي الأبعاد",
  T_48_META_API_1501_P0_D: "ناقلات ثلاثية الأبعاد",
  T_48_META_API_1501_R_D: "مكون Y المتجه ثلاثي الأبعاد",
  T_48_META_API_1502_D: "احصل على المكون Z لمتجه ثلاثي الأبعاد",
  T_48_META_API_1502_P0_D: "ناقلات ثلاثية الأبعاد",
  T_48_META_API_1502_R_D: "مكون Z ثلاثي الأبعاد",
  T_48_META_API_1503_D: "يضبط المكون X لمتجه ثلاثي الأبعاد",
  T_48_META_API_1503_P0_D: "ناقلات ثلاثية الأبعاد",
  T_48_META_API_1503_P1_D: "المكون X",
  T_48_META_API_1504_D: "يضبط المكون Y لمتجه ثلاثي الأبعاد",
  T_48_META_API_1504_P0_D: "ناقلات ثلاثية الأبعاد",
  T_48_META_API_1504_P1_D: "مكون Y",
  T_48_META_API_1505_D: "يضبط المكون Z لمتجه ثلاثي الأبعاد",
  T_48_META_API_1505_P0_D: "ناقلات ثلاثية الأبعاد",
  T_48_META_API_1505_P1_D: "المكون Z",
  T_48_META_API_1506_D: "أضف متجهين ثلاثي الأبعاد",
  T_48_META_API_1506_P0_D: "القيمة اليسرى",
  T_48_META_API_1506_P1_D: "القيمة اليمينية",
  T_48_META_API_1506_R_D: "نتيجة إضافة ناقلات ثلاثية الأبعاد",
  T_48_META_API_1507_D: "اطرح متجهين ثلاثي الأبعاد",
  T_48_META_API_1507_P0_D: "القيمة اليسرى",
  T_48_META_API_1507_P1_D: "القيمة اليمينية",
  T_48_META_API_1507_R_D: "نتيجة طرح قيمة r من قيمة l لمتجه ثلاثي الأبعاد",
  T_48_META_API_1508_D: "تحجيم ناقل ثلاثي الأبعاد",
  T_48_META_API_1508_P0_D: "ناقل ثلاثي الأبعاد ليتم تحجيمه",
  T_48_META_API_1508_P1_D: "كمية تحجيم المتجهات ثلاثية الأبعاد",
  T_48_META_API_1508_R_D: "نتائج تحجيم المتجهات ثلاثية الأبعاد",
  T_48_META_API_1509_D: "المنتج النقطي لمتجهين ثلاثي الأبعاد، ونتيجة المنتج النقطي هي عددية",
  T_48_META_API_1509_P0_D: "القيمة اليسرى",
  T_48_META_API_1509_P1_D: "القيمة اليمينية",
  T_48_META_API_1509_R_D: "نتيجة الضرب بالنقطة",
  T_48_META_API_1510_D: "الضرب التبادلي لمتجهين ثلاثي الأبعاد تكون نتيجة الضرب المتقاطع متجهًا متعامدًا مع المستوى الذي يقع فيه المتجهان.",
  T_48_META_API_1510_P0_D: "القيمة اليسرى",
  T_48_META_API_1510_P1_D: "القيمة اليمينية",
  T_48_META_API_1510_R_D: "نتيجة الضرب الاتجاهي، يكون الاتجاه عموديًا على المستوى الذي يوجد فيه المتجهان المشاركون في العملية.",
  T_48_META_API_1511_D: "تطبيع ناقلات ثلاثية الأبعاد",
  T_48_META_API_1511_P0_D: "ناقلات ثلاثية الأبعاد",
  T_48_META_API_1511_R_D: "إرجاع ناقل طبيعي جديد. طول القالب 1",
  T_48_META_API_1512_D: "Modulo ناقل ثلاثي الأبعاد",
  T_48_META_API_1512_P0_D: "ناقلات ثلاثية الأبعاد",
  T_48_META_API_1512_R_D: "نتيجة المعامل هي طول معامل المتجه",
  T_48_META_API_1513_D: "احسب المسافة الإقليدية لمتجهين ثلاثي الأبعاد",
  T_48_META_API_1513_P0_D: "القيمة اليسرى",
  T_48_META_API_1513_P1_D: "القيمة اليمينية",
  T_48_META_API_1513_R_D: "بعد طرح متجهين، طول وحدة المتجه الناتج",
  T_48_META_API_1514_D: "احسب الزاوية المحصورة بين متجهين ثلاثي الأبعاد",
  T_48_META_API_1514_P0_D: "القيمة اليسرى",
  T_48_META_API_1514_P1_D: "القيمة اليمينية",
  T_48_META_API_1514_R_D: "زاوية المتجهات، نطاق الزاوية 0-180",
  T_48_META_API_1515_D: "إنشاء ناقل ثلاثي الأبعاد",
  T_48_META_API_1515_P0_D: "مكون X لمتجه ثلاثي الأبعاد",
  T_48_META_API_1515_P1_D: "مكون Y لمتجه ثلاثي الأبعاد",
  T_48_META_API_1515_P2_D: "مكون Z لمتجه ثلاثي الأبعاد",
  T_48_META_API_1515_R_D: "تم إنشاء ناقل ثلاثي الأبعاد",
  T_48_META_API_1516_D: "الحصول على نقطة اتجاه تم إنشاؤها حديثًا (مهملة، لا تستخدمها)",
  T_48_META_API_1516_P0_D: "موقع",
  T_48_META_API_1516_P1_D: "تجاه",
  T_48_META_API_1516_R_D: "دايركت بوينت",
  T_48_META_API_1517_D: "الحصول على موضع نقطة الاتجاه (عفا عليه الزمن، من فضلك لا تستخدم)",
  T_48_META_API_1517_P0_D: "نقطة الاتجاه",
  T_48_META_API_1517_R_D: "موضع",
  T_48_META_API_1518_D: "الحصول على اتجاه نقطة الاتجاه (عفا عليه الزمن، من فضلك لا تستخدم)",
  T_48_META_API_1518_P0_D: "نقطة الاتجاه",
  T_48_META_API_1518_R_D: "إلى الأمام",
  T_48_META_API_1519_D: "إنشاء قائمة",
  T_48_META_API_1519_P0_D: "يجب أن يكون الطول الأولي للقائمة أقل من أو يساوي السعة الأولية",
  T_48_META_API_1519_P1_D: "يجب أن تكون السعة الأولية للقائمة أكبر من أو تساوي الطول الأولي. يمكن توسيع السعة ديناميكيًا، ولكنها ستستهلك قدرًا معينًا من الأداء. يوصى بتعيين قيمة مناسبة عند الإنشاء.",
  T_48_META_API_1519_R_D: "القائمة التي تم إنشاؤها",
  T_48_META_API_1520_D: "التحقق مما إذا كانت القائمة تحتوي على العنصر المحدد",
  T_48_META_API_1520_P0_D: "قائمة الهدف",
  T_48_META_API_1520_P1_D: "العنصر المحدد للتحقق",
  T_48_META_API_1520_R_D: "ما إذا كان سيتم احتواء العنصر المحدد",
  T_48_META_API_1521_D: "إلحاق عناصر متعددة بنهاية القائمة المستهدفة",
  T_48_META_API_1521_P0_D: "قائمة الهدف",
  T_48_META_API_1521_P1_D: "إلحاق القائمة",
  T_48_META_API_1522_D: "إزالة العنصر المحدد من القائمة",
  T_48_META_API_1522_P0_D: "قائمة الهدف",
  T_48_META_API_1522_P1_D: "قيمة العنصر المراد إزالته",
  T_48_META_API_1523_D: "احصل على فهرس الموضع الذي يظهر فيه العنصر في القائمة لأول مرة، إذا لم يكن هناك عنصر مستهدف في القائمة، فسيتم إرجاع -1.",
  T_48_META_API_1523_P0_D: "قائمة الهدف",
  T_48_META_API_1523_P1_D: "قيمة العنصر",
  T_48_META_API_1523_R_D: "مؤشر الموقع",
  T_48_META_API_1524_D: "الحصول على فهرس آخر تواجد للعنصر في القائمة، إذا لم يكن هناك عنصر مستهدف في القائمة، فسيتم إرجاع -1.",
  T_48_META_API_1524_P0_D: "قائمة الهدف",
  T_48_META_API_1524_P1_D: "قيمة العنصر",
  T_48_META_API_1524_R_D: "مؤشر الموقع",
  T_48_META_API_1525_D: "أوجد جيب الزاوية",
  T_48_META_API_1525_P0_D: "الزاوية 360 تمثل 360 درجة",
  T_48_META_API_1525_R_D: "قيمة جيبية",
  T_48_META_API_1526_D: "أوجد جيب تمام الزاوية",
  T_48_META_API_1526_P0_D: "الزاوية 360 تمثل 360 درجة",
  T_48_META_API_1526_R_D: "جيب التمام",
  T_48_META_API_1527_D: "أوجد ظل الزاوية",
  T_48_META_API_1527_P0_D: "الزاوية 360 تمثل 360 درجة",
  T_48_META_API_1527_R_D: "الظل",
  T_48_META_API_1528_D: "أنشئ قيمة لون مع تثبيت الشفافية عند الرقم العشري 255. قم أولاً بتحويل القناة إلى رقم ثنائي. تمثل كل 8 بتات قناة. قم بربطها وفقًا لـ R وG وB والشفافية، ثم قم بتحويل الرقم الثنائي إلى نوع Int32 إعادته.",
  T_48_META_API_1528_P0_D: "قيمة القناة الحمراء للون، نطاق القيمة هو [0,255]. إذا تجاوز النطاق، فسيتم تثبيته على قيمة قانونية.",
  T_48_META_API_1528_P1_D: "قيمة القناة الخضراء للون، نطاق القيمة هو [0,255]. إذا تجاوز النطاق، فسيتم تثبيته على قيمة قانونية.",
  T_48_META_API_1528_P2_D: "قيمة القناة الزرقاء للون، نطاق القيمة هو [0,255]. إذا تجاوز النطاق، فسيتم تثبيته على قيمة قانونية.",
  T_48_META_API_1528_R_D: "قيمة اللون المبنية",
  T_48_META_API_1529_D: "إجراء عملية قوس الجيب للحصول على الزاوية",
  T_48_META_API_1529_P0_D: "قيمة عملية أركسين، نطاق القيمة هو [-1,1]",
  T_48_META_API_1529_R_D: "زاوية",
  T_48_META_API_1530_D: "إجراء عملية جيب التمام القوسية للحصول على الزاوية",
  T_48_META_API_1530_P0_D: "قيمة عملية جيب التمام القوسية، نطاق القيمة هو [-1,1]",
  T_48_META_API_1530_R_D: "زاوية",
  T_48_META_API_1531_D: "إجراء عملية ظل الزاوية للحصول على الزاوية",
  T_48_META_API_1531_P0_D: "القيمة التي سيتم إجراء عملية ظل الزاوية عليها",
  T_48_META_API_1531_R_D: "زاوية",
  T_48_META_API_1532_D: "تحديد ما إذا كان الكيان المستهدف ضمن نطاق المجال المحدد إذا لم يكن للكيان سمة موضع، فسيتم إرجاع خطأ.",
  T_48_META_API_1532_P0_D: "الكيان المستهدف",
  T_48_META_API_1532_P1_D: "يحدد مركز الكرة",
  T_48_META_API_1532_P2_D: "يحدد نصف قطر الكرة",
  T_48_META_API_1532_R_D: "نتيجة الحكم",
  T_48_META_API_1533_D: "تحديد ما إذا كان الكيان المستهدف يقع ضمن نطاق الأسطوانة المحدد. إذا لم يكن للكيان سمة موضع، فسيتم إرجاع خطأ.",
  T_48_META_API_1533_P0_D: "الكيان المستهدف",
  T_48_META_API_1533_P1_D: "يحدد النقطة المركزية للأسطوانة",
  T_48_META_API_1533_P2_D: "يحدد نصف قطر المقطع العرضي للأسطوانة",
  T_48_META_API_1533_P3_D: "يحدد ارتفاع الاسطوانة",
  T_48_META_API_1533_P4_D: "تحدد زاوية أويلر ثلاثية الأبعاد لدوران الأسطوانة حول النقطة المركزية",
  T_48_META_API_1533_R_D: "نتيجة الحكم",
  T_48_META_API_1534_D: "تحديد ما إذا كان الكيان المستهدف يقع ضمن نطاق المكعب المحدد",
  T_48_META_API_1534_P0_D: "الكيان المستهدف",
  T_48_META_API_1534_P1_D: "يحدد النقطة المركزية للمكعب",
  T_48_META_API_1534_P2_D: "يحدد طول المكعب",
  T_48_META_API_1534_P3_D: "يحدد عرض المكعب",
  T_48_META_API_1534_P4_D: "يحدد ارتفاع المكعب",
  T_48_META_API_1534_P5_D: "يحدد زاوية أويلر للدوران ثلاثي الأبعاد للمكعب حول نقطة المركز",
  T_48_META_API_1534_R_D: "نتيجة الحكم",
  T_48_META_API_1535_D: "تحديد ما إذا كان الكيان المستهدف يقع ضمن نطاق أسطوانة القطاع المحدد",
  T_48_META_API_1535_P0_D: "الكيان المستهدف",
  T_48_META_API_1535_P1_D: "يحدد مركز القسم الأوسط للأسطوانة ذات الشكل القطاعي",
  T_48_META_API_1535_P2_D: "يحدد نصف قطر القسم الأوسط للأسطوانة ذات الشكل القطاعي",
  T_48_META_API_1535_P3_D: "نصف قطر المقطع العرضي للأسطوانة ذات الشكل القطاعي الذي لم يتم اختباره، مع اعتبار النقطة المركزية مركز الدائرة، لن يتم اختبار مساحة الأسطوانة الصغيرة ذات الشكل القطاعي، فقط الفرق بين الأسطوانة ذات الشكل القطاعي المحدد و سيتم الكشف عن الموضوع الصغير على شكل",
  T_48_META_API_1535_P4_D: "يحدد ارتفاع اسطوانة القطاع",
  T_48_META_API_1535_P5_D: "الزاوية المركزية لقسم الاسطوانة القطاعية للكشف إذا كانت أكبر من 360 يتم الكشف عنها بشكل أسطواني وإذا كانت أقل من 0 يكون حجم منطقة الكشف 0.",
  T_48_META_API_1535_P6_D: "يحدد زاوية أويلر ثلاثية الأبعاد لدوران أسطوانة القطاع حول النقطة المركزية",
  T_48_META_API_1535_R_D: "نتيجة الحكم",
  T_48_META_API_1536_D: "يقارن قيم رقمين ويعيد الرقم الأكبر",
  T_48_META_API_1536_P0_D: "القيمة اليسرى",
  T_48_META_API_1536_P1_D: "القيمة اليمينية",
  T_48_META_API_1536_R_D: "عدد أكبر",
  T_48_META_API_1537_D: "إرجاع الحد الأقصى للقيمة في القائمة",
  T_48_META_API_1537_P0_D: "القائمة المستهدفة، تقبل فقط نوع عنصر القائمة كرقم",
  T_48_META_API_1537_P1_D: "نتائج المقارنة إذا كانت هناك أرقام غير في القائمة، تفشل المقارنة وترجع خطأ.",
  T_48_META_API_1537_P2_D: "إرجاع أكبر قيمة في القائمة في حالة نجاح المقارنة، وإرجاع 0 في حالة فشل المقارنة.",
  T_48_META_API_1538_D: "يقارن قيم رقمين ويعيد الرقم الأصغر",
  T_48_META_API_1538_P0_D: "القيمة اليسرى",
  T_48_META_API_1538_P1_D: "القيمة اليمينية",
  T_48_META_API_1538_R_D: "عدد أصغر",
  T_48_META_API_1539_D: "إرجاع الحد الأدنى للقيمة في القائمة.",
  T_48_META_API_1539_P0_D: "القائمة المستهدفة، تقبل فقط نوع عنصر القائمة كرقم",
  T_48_META_API_1539_P1_D: "نتائج المقارنة إذا كانت هناك أرقام غير في القائمة، تفشل المقارنة وترجع خطأ.",
  T_48_META_API_1539_P2_D: "إرجاع أصغر قيمة في القائمة في حالة نجاح المقارنة، وإرجاع 0 في حالة فشل المقارنة.",
  T_48_META_API_1540_D: "الاستيفاء الخطي، يُرجع القيمة المقابلة لتقدم الاستيفاء بين قيمة البداية والقيمة المستهدفة، معامل الاستيفاء [0,1]",
  T_48_META_API_1540_P0_D: "قيمة البداية للاستكمال الخطي يتم إرجاع هذه القيمة عندما يكون تقدم الاستيفاء 0.",
  T_48_META_API_1540_P1_D: "قيمة هدف الاستيفاء الخطي، يتم إرجاع هذه القيمة عندما يكون تقدم الاستيفاء 1",
  T_48_META_API_1540_P2_D: "تقدم الاستيفاء، نطاق القيمة [0،1]، عندما تكون القيمة 0، يتم إرجاع قيمة البداية، عندما تكون القيمة 1، يتم إرجاع القيمة المستهدفة، عندما تكون القيمة 0.5، متوسط قيمة البداية والهدف يتم إرجاع القيمة",
  T_48_META_API_1540_R_D: "قيمة إرجاع الاستيفاء الخطي",
  T_48_META_API_1541_D: "تحديد نطاق القيمة المستهدفة والحصول على القيمة الوسطى بين معلمات الإدخال الثلاثة؛ وتتمثل وظيفتها في تحديد القيمة المستهدفة إلى النطاق المحدد. إذا كانت القيمة المستهدفة أصغر من القيمة الدنيا، فسيتم إرجاع القيمة الدنيا القيمة المستهدفة أكبر من القيمة القصوى",
  T_48_META_API_1541_P0_D: "القيمة المستهدفة",
  T_48_META_API_1541_P1_D: "الحد الأدنى لقيمة النطاق المحدود",
  T_48_META_API_1541_P2_D: "الحد الأقصى لقيمة النطاق المحدود",
  T_48_META_API_1541_R_D: "إرجاع القيمة بعد التقييد",
  T_48_META_API_1542_D: "احصل على قيم القناة للون المستهدف",
  T_48_META_API_1542_P0_D: "اللون المستهدف",
  T_48_META_API_1542_P1_D: "قيمة R للون، النطاق [0، 255]",
  T_48_META_API_1542_P2_D: "قيمة G للون، النطاق [0، 255]",
  T_48_META_API_1542_P3_D: "قيمة B للون، النطاق [0، 255]",
  T_48_META_API_1542_P4_D: "قيمة اللون، النطاق [0، 255]",
  T_48_META_API_1543_D: "الأسي",
  T_48_META_API_1543_P0_D: "قاعدة",
  T_48_META_API_1543_P1_D: "فِهرِس",
  T_48_META_API_1543_R_D: "نتيجة الحساب",
  T_48_META_API_1544_D: "العمليات اللوغاريتمية",
  T_48_META_API_1544_P0_D: "قاعدة",
  T_48_META_API_1544_P1_D: "رقم حقيقي",
  T_48_META_API_1544_R_D: "نتيجة الحساب",
  T_48_META_API_1545_D: "متجه الاتجاه لزاوية أويلر",
  T_48_META_API_1545_P0_D: "ناقلات الاتجاه",
  T_48_META_API_1545_R_D: "زوايا أويلر",
  T_48_META_API_1546_D: "متجه اتجاه دوران زاوية أويلر",
  T_48_META_API_1546_P0_D: "زوايا أويلر",
  T_48_META_API_1546_R_D: "ناقلات الاتجاه",
  T_48_META_API_1547_D: "عدد صحيح إلى رقم النقطة العائمة",
  T_48_META_API_1547_P0_D: "عدد صحيح",
  T_48_META_API_1547_R_D: "رقم النقطة العائمة",
  T_48_META_API_1548_D: "قم بتدوير المتجه المستهدف وفقًا لـ quaternion",
  T_48_META_API_1548_P0_D: "ناقلات الهدف",
  T_48_META_API_1548_P1_D: "تدوير الرباعي",
  T_48_META_API_1548_R_D: "ناقلات استدارة",
  T_48_META_API_1549_D: "تحويل الرقم المستهدف إلى سلسلة",
  T_48_META_API_1549_P0_D: "الرقم الهدف المراد تحويله إلى سلسلة",
  T_48_META_API_1549_P1_D: "تنسيق سلسلة رقمية الإخراج",
  T_48_META_API_1549_R_D: "خيط",
  T_48_META_API_1598_D: "الحصول على الطابع الزمني للخادم",
  T_48_META_API_1598_R_D: "إرجاع عدد الثواني منذ 0:00:00 في 1 يناير 1970",
  T_48_META_API_1599_D: "الحصول على منطقة الخادم",
  T_48_META_API_1599_R_D: "إرجاع اختصار المنطقة (BR، SAC، ID، NA، US، IND، SG، BD، VN، TH، ME، RU، EU، PK، TW)",
  T_48_META_API_16_D: "سجلات تتبع المستخدم المخصصة لتحليل بيانات تجربة المستخدم",
  T_48_META_API_16_P0_D: "سيتم الإبلاغ عن اللاعبين",
  T_48_META_API_16_P1_D: "قائمة أسماء الحقول التي سيتم الإبلاغ عنها",
  T_48_META_API_16_P2_D: "قائمة قيم الحقول المطلوب الإبلاغ عنها",
  T_48_META_API_1601_D: "إنشاء قاموس",
  T_48_META_API_1601_R_D: "القاموس الذي تم إنشاؤه",
  T_48_META_API_1602_D: "احصل على القيمة المقابلة للمفتاح المحدد في القاموس",
  T_48_META_API_1602_P0_D: "القاموس الهدف",
  T_48_META_API_1602_P1_D: "مفتاح",
  T_48_META_API_1602_R_D: "قيمة",
  T_48_META_API_1603_D: "يضبط القيمة المقابلة للمفتاح المحدد في القاموس",
  T_48_META_API_1603_P0_D: "القاموس الهدف",
  T_48_META_API_1603_P1_D: "مفتاح",
  T_48_META_API_1603_P2_D: "قيمة",
  T_48_META_API_1604_D: "قم بإزالة زوج القيمة الرئيسية المحدد من القاموس",
  T_48_META_API_1604_P0_D: "القاموس الهدف",
  T_48_META_API_1604_P1_D: "مفتاح",
  T_48_META_API_1605_D: "امسح جميع أزواج القيمة الرئيسية في القاموس",
  T_48_META_API_1605_P0_D: "القاموس الهدف",
  T_48_META_API_1606_D: "احصل على عدد أزواج القيمة الرئيسية في القاموس",
  T_48_META_API_1606_P0_D: "القاموس الهدف",
  T_48_META_API_1606_R_D: "طول القاموس",
  T_48_META_API_1607_D: "تحديد ما إذا كان هناك مفتاح موجود في القاموس",
  T_48_META_API_1607_P0_D: "القاموس الهدف",
  T_48_META_API_1607_P1_D: "مفتاح",
  T_48_META_API_1607_R_D: "هل يوجد",
  T_48_META_API_1608_D: "يحصل على كافة مفاتيح القاموس، ويتم إرجاعها كقائمة",
  T_48_META_API_1608_P0_D: "القاموس الهدف",
  T_48_META_API_1608_R_D: "قائمة بجميع القيم الأساسية",
  T_48_META_API_17_D: "استخدم منطقة على شكل مربع ذات حركة خطية للكشف، وأعد جميع الكيانات التي تمت مواجهتها على مسار المنطقة على شكل مربع من القريب إلى البعيد إذا كانت في البداية ضمن نطاق الشكل الصندوقي، فلن يتم اكتشافها؛ إذا تم ملء المعلمات الهرمية في الفراغات، فيمكن اكتشاف التضاريس",
  T_48_META_API_17_P0_D: "نصف طول الجوانب الثلاثة لمنطقة الصندوق، وتقبل القيم الموجبة فقط",
  T_48_META_API_17_P1_D: "النقطة المركزية لمنطقة الصندوق",
  T_48_META_API_17_P2_D: "دوران منطقة الصندوق",
  T_48_META_API_17_P3_D: "اتجاه السفر لمنطقة الصندوق",
  T_48_META_API_17_P4_D: "مسافة السفر لمنطقة الصندوق، يتم قبول القيم الإيجابية فقط",
  T_48_META_API_17_P5_D: "قناع الطبقة، ستشارك الطبقات المعبأة فقط في الفحص، وترك فارغًا يعني أن جميع الطبقات ستشارك في الفحص",
  T_48_META_API_17_P6_D: "هل من الممكن الكشف عن المشغلات",
  T_48_META_API_17_P7_D: "قائمة الكيانات المتضررة",
  T_48_META_API_1700_D: "تحويل السلسلة المحددة إلى عدد صحيح",
  T_48_META_API_1700_P0_D: "سلسلة الهدف",
  T_48_META_API_1700_P1_D: "النتيجة عدد صحيح",
  T_48_META_API_1700_P2_D: "هل التحويل ناجح؟",
  T_48_META_API_1701_D: "تحويل السلسلة المحددة إلى رقم النقطة العائمة",
  T_48_META_API_1701_P0_D: "سلسلة الهدف",
  T_48_META_API_1701_P1_D: "تعويم النتيجة",
  T_48_META_API_1701_P2_D: "هل التحويل ناجح؟",
  T_48_META_API_18_D: "استخدم منطقة كروية متحركة بخط مستقيم للكشف، وقم بإرجاع جميع الكيانات التي تمت مواجهتها على مسار المنطقة الكروية من القريب إلى البعيد إذا كانت في البداية في المنطقة الكروية، فلن يتم اكتشافها إذا تم ملء معلمة المستوى في الفراغ ، يمكن الكشف عن التضاريس",
  T_48_META_API_18_P0_D: "نصف قطر المنطقة الكروية، يتم قبول القيم الإيجابية فقط",
  T_48_META_API_18_P1_D: "النقطة المركزية للمنطقة الكروية",
  T_48_META_API_18_P2_D: "اتجاه السفر لمنطقة كروية",
  T_48_META_API_18_P3_D: "المسافة التي تقطعها المنطقة الكروية، يتم قبول القيم الموجبة فقط",
  T_48_META_API_18_P4_D: "قناع الطبقة، ستشارك الطبقات المعبأة فقط في الفحص، وترك فارغًا يعني أن جميع الطبقات ستشارك في الفحص",
  T_48_META_API_18_P5_D: "هل من الممكن الكشف عن المشغلات",
  T_48_META_API_18_P6_D: "قائمة الكيانات المتضررة",
  T_48_META_API_19_D: "استخدم منطقة كبسولة متحركة خطيًا للكشف، وأعد جميع الكيانات التي تمت مواجهتها على طريق منطقة الكبسولة من القريب إلى البعيد إذا كانت في البداية داخل منطقة الكبسولة، فلن يتم اكتشافها إذا تم ملء معلمة المستوى يمكن الكشف عن التضاريس",
  T_48_META_API_19_P0_D: "نصف قطر نصف الكرة الأرضية على طرفي منطقة الكبسولة، يتم قبول القيم الإيجابية فقط",
  T_48_META_API_19_P1_D: "المسافة بين مراكز نصفي الكرة الأرضية عند طرفي منطقة الكبسولة يجب أن تكون أكبر من ضعف نصف قطر الكرة الأرضية عند كلا الطرفين.",
  T_48_META_API_19_P2_D: "النقطة المركزية لمنطقة الكبسولة",
  T_48_META_API_19_P3_D: "دوران منطقة الكبسولة",
  T_48_META_API_19_P4_D: "اتجاه السفر لمنطقة الكبسولة",
  T_48_META_API_19_P5_D: "المسافة التي تم مهارتها في منطقة الكبسة، يتم قبول القيم الإيجابية فقط",
  T_48_META_API_19_P6_D: "قناع الطبقة، ستشارك الطبقات المعبأة فقط في الفحص، وترك فارغًا يعني أن جميع الطبقات ستشارك في الفحص",
  T_48_META_API_19_P7_D: "هل من الممكن الكشف عن المشغلات",
  T_48_META_API_19_P8_D: "قائمة الكيانات المتضررة",
  T_48_META_API_2_D: "احصل على جميع الفرق في اللعبة الحالية وارجع إلى قائمة الفريق.",
  T_48_META_API_2_R_D: "قائمة الفريق",
  T_48_META_API_20_D: "استخدم منطقة ثابتة على شكل مربع للكشف عن جميع الكيانات الموجودة داخل المنطقة على شكل مربع وإرجاعها، إذا تم ملء معلمات المستوى في الفراغات، فيمكن اكتشاف التضاريس.",
  T_48_META_API_20_P0_D: "نصف طول الجوانب الثلاثة لمنطقة الصندوق، وتقبل القيم الموجبة فقط",
  T_48_META_API_20_P1_D: "النقطة المركزية لمنطقة الصندوق",
  T_48_META_API_20_P2_D: "دوران منطقة الصندوق",
  T_48_META_API_20_P3_D: "قناع الطبقة، ستشارك الطبقات المعبأة فقط في الفحص، وترك فارغًا يعني أن جميع الطبقات ستشارك في الفحص",
  T_48_META_API_20_P4_D: "هل من الممكن الكشف عن المشغلات",
  T_48_META_API_20_P5_D: "قائمة الكيانات المتضررة",
  T_48_META_API_2000_D: "قم بتعيين قيمة السمة للكيان الهدف، الأمر الذي يتطلب تحديد السمة",
  T_48_META_API_2000_P0_D: "الكيان المستهدف",
  T_48_META_API_2000_P1_D: "سمة الكيان المستهدف",
  T_48_META_API_2000_P2_D: "يجب أن تتوافق القيمة المستهدفة مع النوع المطلوب عند تحديد السمة.",
  T_48_META_API_2000_P3_D: "وضع التشغيل، جميع الأنواع تدعم التعيين، كما تدعم الأنواع الرقمية الجمع الذاتي والطرح الذاتي والضرب الذاتي والقسمة الذاتية والباقي الذاتي.",
  T_48_META_API_2001_D: "الحصول على قيمة السمة للكيان",
  T_48_META_API_2001_P0_D: "الكيان المستهدف",
  T_48_META_API_2001_P1_D: "معرف السمة للكيان",
  T_48_META_API_2001_R_D: "قيمة السمة",
  T_48_META_API_2002: "تعيين خاصية الرسم البياني",
  T_48_META_API_2002_D: "تعيين متغيرات البرنامج النصي",
  T_48_META_API_2002_P0_D: "الكيان المستهدف",
  T_48_META_API_2002_P1: "معرف الرسم البياني",
  T_48_META_API_2002_P1_D: "معرف البرنامج النصي الهدف",
  T_48_META_API_2002_P2: "معرف العقار",
  T_48_META_API_2002_P2_D: "معرف سمة العضو المحدد في البرنامج النصي",
  T_48_META_API_2002_P3: "قيمة العقار",
  T_48_META_API_2002_P3_D: "يجب أن تتوافق القيمة المستهدفة مع النوع المطلوب عند تحديد السمة.",
  T_48_META_API_2002_P4_D: "وضع التشغيل، جميع الأنواع تدعم التعيين، كما تدعم الأنواع الرقمية الجمع الذاتي والطرح الذاتي والضرب الذاتي والقسمة الذاتية والباقي الذاتي.",
  T_48_META_API_2003: "الحصول على خاصية الرسم البياني",
  T_48_META_API_2003_D: "الحصول على متغيرات البرنامج النصي",
  T_48_META_API_2003_P0_D: "الكيان المستهدف",
  T_48_META_API_2003_P1: "معرف الرسم البياني",
  T_48_META_API_2003_P1_D: "معرف البرنامج النصي الهدف",
  T_48_META_API_2003_P2: "معرف العقار",
  T_48_META_API_2003_P2_D: "معرف السمة الهدف",
  T_48_META_API_2003_R_D: "قيمة السمة",
  T_48_META_API_2004_D: "تحديد وتهيئة متغير محلي نطاق المتغير المحلي هو من موضع الإعلان إلى نهاية كتلة البيان.",
  T_48_META_API_2004_P0_D: "اسم متغير",
  T_48_META_API_2004_P1_D: "القيمة الأولية المتغيرة",
  T_48_META_API_2004_P2_D: "نوع الإعلان المتغير عند تعيين قيمة، يجب أن يتوافق مع النوع المعلن.",
  T_48_META_API_2005_D: "قم بتعيين قيمة المتغير المحلي. نطاق المتغير المحلي هو من موضع الإعلان إلى نهاية كتلة البيان.",
  T_48_META_API_2005_P0_D: "اسم متغير",
  T_48_META_API_2005_P1: "قيمة المتغير",
  T_48_META_API_2005_P1_D: "قيمة متغيرة",
  T_48_META_API_2005_P2_D: "وضع التشغيل، جميع الأنواع تدعم التعيين، كما تدعم الأنواع الرقمية الجمع الذاتي والطرح الذاتي والضرب الذاتي والقسمة الذاتية والباقي الذاتي.",
  T_48_META_API_2006: "الحصول على متغير محلي",
  T_48_META_API_2006_D: "احصل على قيمة المتغير المحلي. نطاق المتغير المحلي هو من موضع الإعلان إلى نهاية كتلة البيان.",
  T_48_META_API_2006_P0: "اسم المتغير",
  T_48_META_API_2006_P0_D: "اسم متغير",
  T_48_META_API_2006_R_D: "قيمة متغيرة",
  T_48_META_API_2009: "البحث عن واجهة برمجة التطبيقات العالمية المخصصة واستدعائها باستخدام Serial",
  T_48_META_API_2009_D: "استدعاء الدالة المخصصة العامة بطريقة تسلسلية إذا كان هناك انتظار في الدالة المخصصة، فسوف ينتظر موقع الاستدعاء أيضًا.",
  T_48_META_API_2009_P0: "معرف الرسم البياني",
  T_48_META_API_2009_P0_D: "معرف البرنامج النصي حيث توجد الوظيفة المخصصة",
  T_48_META_API_2009_P1: "معرف الوظيفة",
  T_48_META_API_2009_P1_D: "تم استدعاء معرف الوظيفة المخصصة",
  T_48_META_API_2009_P2_D: "قائمة المعلمات التي تم تمريرها إلى الوظيفة المخصصة",
  T_48_META_API_2010: "البحث عن واجهة برمجة التطبيقات العالمية المخصصة واستدعائها باستخدام Parallel",
  T_48_META_API_2010_D: "استدعاء الوظيفة المخصصة العامة بالتوازي بغض النظر عما إذا كان هناك انتظار في الوظيفة المخصصة، فسوف تعود على الفور إلى موقع الاستدعاء وتستمر في التنفيذ.",
  T_48_META_API_2010_P0: "معرف الرسم البياني",
  T_48_META_API_2010_P0_D: "معرف البرنامج النصي حيث توجد الوظيفة المخصصة",
  T_48_META_API_2010_P1: "معرف الوظيفة",
  T_48_META_API_2010_P1_D: "تم استدعاء معرف الوظيفة المخصصة",
  T_48_META_API_2010_P2_D: "قائمة المعلمات التي تم تمريرها إلى الوظيفة المخصصة",
  T_48_META_API_2013: "تعيين خاصية الرسم البياني الذاتي",
  T_48_META_API_2013_D: "تعيين المتغيرات للبرنامج النصي الحالي",
  T_48_META_API_2013_P0: "معرف العقار",
  T_48_META_API_2013_P0_D: "معرف السمة الهدف",
  T_48_META_API_2013_P1: "قيمة العقار",
  T_48_META_API_2013_P1_D: "القيمة المستهدفة",
  T_48_META_API_2013_P2_D: "وضع التشغيل، جميع الأنواع تدعم التعيين، كما تدعم الأنواع الرقمية الجمع الذاتي والطرح الذاتي والضرب الذاتي والقسمة الذاتية والباقي الذاتي.",
  T_48_META_API_2014: "الحصول على خاصية الرسم البياني الذاتي",
  T_48_META_API_2014_D: "الحصول على متغيرات البرنامج النصي الحالي",
  T_48_META_API_2014_P0: "معرف العقار",
  T_48_META_API_2014_P0_D: "معرف السمة الهدف",
  T_48_META_API_2014_R_D: "قيمة السمة",
  T_48_META_API_21_D: "استخدم منطقة كروية ثابتة للكشف وإرجاع جميع الكيانات داخل المنطقة الكروية إذا تم ملء معلمة المستوى في الفراغات، فيمكن اكتشاف التضاريس.",
  T_48_META_API_21_P0_D: "نصف قطر المنطقة الكروية، يتم قبول القيم الإيجابية فقط",
  T_48_META_API_21_P1_D: "النقطة المركزية للمنطقة الكروية",
  T_48_META_API_21_P2_D: "قناع الطبقة، ستشارك الطبقات المعبأة فقط في الفحص، وترك فارغًا يعني أن جميع الطبقات ستشارك في الفحص",
  T_48_META_API_21_P3_D: "هل من الممكن الكشف عن المشغلات",
  T_48_META_API_21_P4_D: "قائمة الكيانات المتضررة",
  T_48_META_API_22_D: "استخدم منطقة كبسولة ثابتة للكشف عن جميع الكيانات الموجودة داخل منطقة الكبسولة وإرجاعها، إذا تم ملء معلمة المستوى، فيمكن اكتشاف التضاريس.",
  T_48_META_API_22_P0_D: "نصف قطر نصف الكرة الأرضية على طرفي منطقة الكبسولة، يتم قبول القيم الإيجابية فقط",
  T_48_META_API_22_P1_D: "المسافة بين مراكز نصفي الكرة الأرضية عند طرفي منطقة الكبسولة يجب أن تكون أكبر من ضعف نصف قطر الكرة الأرضية عند كلا الطرفين.",
  T_48_META_API_22_P2_D: "النقطة المركزية لمنطقة الكبسولة",
  T_48_META_API_22_P3_D: "دوران منطقة الكبسولة",
  T_48_META_API_22_P4_D: "قناع الطبقة، ستشارك الطبقات المعبأة فقط في الفحص، وترك فارغًا يعني أن جميع الطبقات ستشارك في الفحص",
  T_48_META_API_22_P5_D: "هل من الممكن الكشف عن المشغلات",
  T_48_META_API_22_P6_D: "قائمة الكيانات المتضررة",
  T_48_META_API_23_D: "قم بتعيين حالة العنصر الخاص للاعب، يمكنك الحصول على عنصر خاص واحد فقط.",
  T_48_META_API_23_P0_D: "لاعب",
  T_48_META_API_23_P1_D: "معرف العنصر",
  T_48_META_API_23_P2_D: "ما إذا كان سيتم تمكين هذا العنصر",
  T_48_META_API_23_P3_D: "كيان البند الخاص",
  T_48_META_API_24_D: "قم بتطبيق قوة على الهدف، والذي يجب أن يكون جسمًا ماديًا",
  T_48_META_API_24_P0_D: "الهدف المادي",
  T_48_META_API_24_P1_D: "ناقلات القوة",
  T_48_META_API_24_P2_D: "نوع القوة",
  T_48_META_API_25_D: "قم بتطبيق قوة مرة واحدة عند نقطة معينة، ويجب أن يكون الهدف جسمًا صلبًا",
  T_48_META_API_25_P0_D: "استهداف الجسم الصلب",
  T_48_META_API_25_P1_D: "ناقلات القوة",
  T_48_META_API_25_P2_D: "موقف تطبيق القوة",
  T_48_META_API_25_P3_D: "نوع القوة",
  T_48_META_API_26_D: "قم بتطبيق عزم الدوران على الهدف، والذي يجب أن يكون جسمًا صلبًا",
  T_48_META_API_26_P0_D: "استهداف الجسم الصلب",
  T_48_META_API_26_P1_D: "عزم الدوران",
  T_48_META_API_26_P2_D: "نوع القوة",
  T_48_META_API_27_D: "حرك الجسم الصلب المستهدف إلى الموضع المحدد",
  T_48_META_API_27_P0_D: "استهداف الجسم الصلب",
  T_48_META_API_27_P1_D: "تحديد الموقع",
  T_48_META_API_28_D: "تدوير الهدف الجسم الصلب",
  T_48_META_API_28_P0_D: "استهداف الجسم الصلب",
  T_48_META_API_28_P1_D: "تدوير الرباعي",
  T_48_META_API_29_D: "قم بإنشاء حركة محرفة، وسوف تتحرك السمات المحددة للكيان المستهدف بسلاسة وفقًا للإعدادات",
  T_48_META_API_29_P0_D: "الكيان المستهدف",
  T_48_META_API_29_P1_D: "معرف السمة التي تحتاج إلى تغيير",
  T_48_META_API_29_P2_D: "قيمة بداية السمة",
  T_48_META_API_29_P3_D: "القيمة النهائية للسمة",
  T_48_META_API_29_P4_D: "يمكنك اختيار حركة واحدة، أو حركة دائرية، أو حركة ترددية. تعني الحركة الدائرية أنه بعد كل حركة، سيعود الكيان إلى نقطة البداية. أما الحركة الترددية، فتعني أنه بعد انتهاء الحركة من نقطة البداية إلى نقطة الهدف، سيعود الكيان إلى نقطة البداية، ثم يكرر العملية.",
  T_48_META_API_29_P5_D: "نقاط التحكم في منحنى بيزيير",
  T_48_META_API_29_P6_D: "مدة التغيير، بالمللي ثانية",
  T_48_META_API_29_P7_D: "تم إنشاء كيان حركة محرف",
  T_48_META_API_29_P8_D: "ما إذا كان سيتم بدء اللعب تلقائيًا بعد الإنشاء",
  T_48_META_API_3_D: "قم بتحويل اللعبة إلى المرحلة المستهدفة، والجولة هي أيضًا مرحلة خاصة. عند التبديل إلى مرحلة داخل دورة، يكون عدد الدورات هو 0.",
  T_48_META_API_3_P0_D: "مؤشر الجولة أو المرحلة المستهدفة",
  T_48_META_API_30_D: "إجبار اللاعب المستهدف على دخول السيارة المعينة",
  T_48_META_API_30_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_30_P1_D: "كيان المركبة",
  T_48_META_API_30_P2_D: "رقم المقعد",
  T_48_META_API_30_P3_D: "ما إذا كان قد تم السماح للاعب بالدخول إلى السيارة بنجاح",
  T_48_META_API_3001_D: "يتسبب في قيام اللاعب المستهدف بإسقاط العناصر",
  T_48_META_API_3001_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3001_P1_D: "كيان العنصر",
  T_48_META_API_3002_D: "احصل على الإحداثيات المتاحة ضمن نقطة النشر العشوائية المتوفرة حاليًا والتي ليست مشغولة بالكامل (قديمة، يرجى استخدام GetRandomSpawnPosition)",
  T_48_META_API_3002_P0_D: "اللاعبون الذين يحتاجون إلى تخصيص منطقة تفرخ",
  T_48_META_API_3002_R_D: "إحداثيات نقطة عشوائية المعينة بشكل عشوائي",
  T_48_META_API_3003_D: "احصل على قيمة النقاط الإجمالية لنوع النقطة المحدد للاعب",
  T_48_META_API_3003_P0_D: "لاعب",
  T_48_META_API_3003_P1_D: "نوع النقطة",
  T_48_META_API_3003_R_D: "قيمة النقاط",
  T_48_META_API_3004_D: "قم بتعيين قيمة النقطة المستديرة لنوع النقطة المحدد للاعب",
  T_48_META_API_3004_P0_D: "كيان اللاعب",
  T_48_META_API_3004_P1_D: "نوع النقطة",
  T_48_META_API_3004_P2_D: "قيمة النقاط",
  T_48_META_API_3005_D: "احصل على قيمة إجمالي النقاط لنوع النقطة المحدد للفريق",
  T_48_META_API_3005_P0_D: "كيان الفريق",
  T_48_META_API_3005_P1_D: "نوع النقطة",
  T_48_META_API_3005_R_D: "قيمة النقاط",
  T_48_META_API_3006_D: "قم بتعيين قيمة النقطة المستديرة لنوع النقطة المحدد للفريق",
  T_48_META_API_3006_P0_D: "كيان الفريق",
  T_48_META_API_3006_P1_D: "نوع النقطة",
  T_48_META_API_3006_P2_D: "قيمة النقاط",
  T_48_META_API_3007_D: "احصل على نقاط اللاعب للجولة المحددة ونوع النقطة",
  T_48_META_API_3007_P0_D: "كيان اللاعب",
  T_48_META_API_3007_P1_D: "مؤشر مستدير",
  T_48_META_API_3007_P2_D: "نوع النقطة",
  T_48_META_API_3007_R_D: "قيمة النقاط",
  T_48_META_API_3008_D: "احصل على نقاط الفريق للجولة المحددة ونوع النقطة",
  T_48_META_API_3008_P0_D: "كيان الفريق",
  T_48_META_API_3008_P1_D: "مؤشر مستدير",
  T_48_META_API_3008_P2_D: "نوع النقطة",
  T_48_META_API_3008_R_D: "قيمة النقاط",
  T_48_META_API_3009_D: "احصل على الترتيب الإجمالي للعبة اللاعب",
  T_48_META_API_3009_P0_D: "كيان اللاعب",
  T_48_META_API_3009_R_D: "تصنيف",
  T_48_META_API_3011_D: "احصل على الترتيب العام للعبة الفريق",
  T_48_META_API_3011_P0_D: "مهمل",
  T_48_META_API_3011_R_D: "تصنيف",
  T_48_META_API_3013_D: "احصل على تصنيف الجولة المحدد للاعب",
  T_48_META_API_3013_P0_D: "كيان اللاعب",
  T_48_META_API_3013_P1_D: "مؤشر مستدير",
  T_48_META_API_3013_R_D: "تصنيف",
  T_48_META_API_3014_D: "احصل على ترتيب الجولة المعينة للفريق",
  T_48_META_API_3014_P0_D: "مهمل",
  T_48_META_API_3014_P1_D: "مؤشر مستدير",
  T_48_META_API_3014_R_D: "تصنيف",
  T_48_META_API_3015_D: "الحصول على محفظة الجهة المستهدفة",
  T_48_META_API_3015_P0_D: "الكيان المستهدف",
  T_48_META_API_3015_P1_D: "هل المحفظة موجودة؟",
  T_48_META_API_3015_P2_D: "تم الحصول على كيان المحفظة",
  T_48_META_API_3016_D: "قم بإنشاء محفظة للاعب المستهدف، إذا كان اللاعب لديه محفظة بالفعل، فستكون غير صالحة.",
  T_48_META_API_3016_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3016_P1_D: "الجهة المرتبطة بالمحفظة، مالك المحفظة",
  T_48_META_API_3016_P2_D: "كيان المحفظة",
  T_48_META_API_3017_D: "إضافة العملة إلى المحفظة المحددة",
  T_48_META_API_3017_P0_D: "المحفظة المستهدفة",
  T_48_META_API_3017_P1_D: "أنواع العملات المضافة",
  T_48_META_API_3017_P2_D: "زيادة مبلغ العملة",
  T_48_META_API_3018_D: "تقليل العملة للمحفظة المحددة",
  T_48_META_API_3018_P0_D: "المحفظة المستهدفة",
  T_48_META_API_3018_P1_D: "أنواع العملات المخفضة",
  T_48_META_API_3018_P2_D: "انخفاض كمية المال",
  T_48_META_API_3019_D: "تحويل العملة من محفظة إلى أخرى",
  T_48_META_API_3019_P0_D: "المحفظة لتحويل العملة منها",
  T_48_META_API_3019_P1_D: "نوع العملة المحولة",
  T_48_META_API_3019_P2_D: "حجم العملة المحولة",
  T_48_META_API_3019_P3_D: "المحفظة لتحويل العملة إليها",
  T_48_META_API_3020_D: "احصل على مبلغ نوع العملة المحدد في المحفظة المحددة",
  T_48_META_API_3020_P0_D: "المحفظة المستهدفة",
  T_48_META_API_3020_P1_D: "الاستعلام عن نوع العملة",
  T_48_META_API_3020_R_D: "كمية العملة",
  T_48_META_API_3021_D: "احصل على كيان نوع العملة المحدد في المحفظة المحددة",
  T_48_META_API_3021_P0_D: "المحفظة المستهدفة",
  T_48_META_API_3021_P1_D: "الاستعلام عن نوع العملة",
  T_48_META_API_3021_R_D: "كيان نقدي",
  T_48_META_API_3022_D: "احصل على جميع المتاجر الموجودة في اللعبة، وإرجاعها كقائمة",
  T_48_META_API_3022_R_D: "قائمة كيانات المتجر",
  T_48_META_API_3023_D: "استبدل مظهر اللاعب المستهدف بمظهر كائن المشهد المحدد",
  T_48_META_API_3023_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3023_P1_D: "استبدال كائن المشهد المستهدف",
  T_48_META_API_3023_P2_D: "تم إنشاء مكون تمويه تحويل اللاعب بعد الاستبدال",
  T_48_META_API_3024_D: "قم بإلغاء حالة تمويه اللاعب",
  T_48_META_API_3024_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3025_D: "قم بإنشاء نسخة من كيان المشهد عند اللاعب المستهدف",
  T_48_META_API_3025_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3025_P1_D: "كيانات المشهد المستخدمة للصور الرمزية",
  T_48_META_API_3025_P2_D: "تم إنشاء كيان استنساخ",
  T_48_META_API_3026_D: "احصل على كيان تمويه اللاعب",
  T_48_META_API_3026_P0_D: "لاعب",
  T_48_META_API_3026_R_D: "كيان اللاعب المقنع",
  T_48_META_API_3027_D: "احصل على كيان قناة الدردشة بناءً على الفهرس",
  T_48_META_API_3027_P0_D: "فهرس قناة الدردشة، النطاق [1،8]",
  T_48_META_API_3027_R_D: "كيان قناة الدردشة",
  T_48_META_API_3028_D: "احصل على كيان قناة الدردشة حيث يوجد اللاعب المحدد حاليًا",
  T_48_META_API_3028_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3028_R_D: "كيان قناة الدردشة",
  T_48_META_API_3029_D: "اسمح للاعب بالانضمام إلى قناة الدردشة المحددة إذا كان اللاعب موجودًا بالفعل في قناة دردشة أخرى، فسوف يتحول إلى القناة المستهدفة.",
  T_48_META_API_3029_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3029_P1_D: "كيان قناة الدردشة",
  T_48_META_API_3030_D: "يتسبب في خروج اللاعب من القناة الحالية ثم يصبح في حالة عدم وجوده في أي قناة دردشة",
  T_48_META_API_3030_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3031_D: "مهمل",
  T_48_META_API_3031_P0_D: "كيان قناة الدردشة، يكون فارغًا عند عدم وجود لاعبين في القناة",
  T_48_META_API_3032_D: "ضبط حالة سلوك اللاعب",
  T_48_META_API_3032_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3032_P1_D: "نوع سلوك اللاعب",
  T_48_META_API_3032_P2_D: `ممكّن: يوجد زر HUD ويمكن استخدامه بشكل طبيعي
معطل: زر HUD معطل ولا يمكنه الدخول إلى الحالة السلوكية بشكل نشط أو سلبي
الدرع: زر HUD مخفي ولا يمكنه الدخول بشكل نشط إلى الحالة السلوكية، ولكن يمكنه الدخول بشكل سلبي إلى الحالة السلوكية الحالة السلوكية`,
  T_48_META_API_3033_D: "يتحول اللاعب إلى كائن مشهد محدد",
  T_48_META_API_3033_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3033_P1_D: "الكائن المراد التحول إليه",
  T_48_META_API_3033_P2_D: "الكيان الذي تم إنشاؤه بعد التحويل",
  T_48_META_API_3034_D: "يقوم اللاعبون بإنشاء نسخة من أنفسهم",
  T_48_META_API_3034_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3034_P1_D: "تم إنشاء كيان استنساخ",
  T_48_META_API_3035_D: "قم بإنشاء متجر مخصص حيث يكون المستوى التالي من المتجر هو الرفوف",
  T_48_META_API_3035_P0_D: "تم إنشاء كيان المتجر",
  T_48_META_API_3036_D: "قم بإنشاء رف مخصص. المستوى العلوي من الرف هو المتجر والمستوى التالي هو المنتج.",
  T_48_META_API_3036_P0_D: "تم إنشاء كيان الرف",
  T_48_META_API_3037_D: "قم بإنشاء منتج مخصص يمكنه إضافة عناصر",
  T_48_META_API_3037_P0_D: "كيان المنتج الذي تم إنشاؤه",
  T_48_META_API_3038_D: "إضافة عناصر إلى منتج يمكن إضافة عناصر متعددة إلى منتج واحد باستخدام هذا البدائي عدة مرات.",
  T_48_META_API_3038_P0_D: "كيان سلعي",
  T_48_META_API_3038_P1_D: "العناصر المراد إضافتها",
  T_48_META_API_3038_P2_D: "كمية السلعة",
  T_48_META_API_3039_D: "منح مكافآت الهروب من السجن",
  T_48_META_API_3039_P0_D: "كيان اللاعب",
  T_48_META_API_3039_P1_D: "كمية",
  T_48_META_API_3039_P2_D: "أموال حقيقية",
  T_48_META_API_3040_D: "تحديث مهام الهروب من السجن",
  T_48_META_API_3040_P0_D: "كيان اللاعب",
  T_48_META_API_3040_P1_D: "معرف المهمة",
  T_48_META_API_3040_P2_D: "قيمة",
  T_48_META_API_3041_D: "سيكون الحصول على إحداثيات نقطة النشر العشوائية عشوائيًا فقط من نقاط النشر المتاحة غير المشغولة بالكامل.",
  T_48_META_API_3041_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3041_R_D: "إحداثيات نقطة الميلاد العشوائية في حالة عدم وجود نقطة ميلاد مستوفية للشروط، سيتم إرجاع الموقع القريب من (0، 0، 0).",
  T_48_META_API_3042_D: "اخرج من لعبة الهروب من السجن المصغرة",
  T_48_META_API_3042_P0_D: "كيان اللاعب",
  T_48_META_API_3042_P1_D: "معرف المهمة",
  T_48_META_API_3043_D: "بناء على الدعائم الهروب من السجن",
  T_48_META_API_3043_P0_D: "كيان اللاعب",
  T_48_META_API_3043_P1_D: "نوع الدعامة",
  T_48_META_API_3043_P2_D: "معرف الدعامة",
  T_48_META_API_31_D: "قم بإنشاء حركة ذاتية نسبية، ويتغير الكيان المستهدف بالنسبة لقيمة السمة الحالية الخاصة به في كل مرة",
  T_48_META_API_31_P0_D: "الكيان المستهدف",
  T_48_META_API_31_P1_D: "السمات التي تتطلب تغييرات الحركة",
  T_48_META_API_31_P2_D: "مقدار التغيير لكل حركة",
  T_48_META_API_31_P3_D: "نقاط التحكم في منحنى بيزيير",
  T_48_META_API_31_P4_D: `فردي: توقف عندما تغير السمة مقدار دلتا
حلقة: كرر الحركة، في كل مرة تغير فيها السمة مقدار دلتا`,
  T_48_META_API_31_P5_D: "مدة التغيير، بالمللي ثانية",
  T_48_META_API_31_P6_D: "الكيان النسبي المتحرك ذاتيًا",
  T_48_META_API_31_P7_D: "ما إذا كان سيتم بدء اللعب تلقائيًا بعد الإنشاء",
  T_48_META_API_3100_D: "يقوم الهدف بتشغيل الرسوم المتحركة في الحالة المحددة",
  T_48_META_API_3100_P0_D: "مكون كيان يمكن تركيبه باستخدام وحدة تحكم الرسوم المتحركة لتشغيل الرسوم المتحركة",
  T_48_META_API_3100_P1_D: "الحالة المحددة لوحدة التحكم في الرسوم المتحركة",
  T_48_META_API_3100_P2_D: "تحجيم سرعة تشغيل الرسوم المتحركة",
  T_48_META_API_3100_P3_D: "نوع الحلقة، يمكنك الاحتفاظ بالمنطق الأصلي للرسوم المتحركة، أو تشغيله مرة واحدة فقط، أو تشغيله في حلقة",
  T_48_META_API_3101_D: "قم بتشغيل الرسوم المتحركة للشخصية ودعم موارد الرسوم المتحركة المخصصة",
  T_48_META_API_3101_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3101_P1_D: "معرف مورد الرسوم المتحركة المخصص",
  T_48_META_API_3101_P2_D: "سواء للحلقة",
  T_48_META_API_3102_D: "قم بتعيين موارد الشخصية للاعب المحدد",
  T_48_META_API_3102_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3102_P1_D: "معرف مورد الدور المخصص",
  T_48_META_API_3109_D: "قم بتشغيل المنطقة الآمنة التي ستتحرك بسلاسة إلى نقطة النهاية",
  T_48_META_API_3109_P0_D: "موقف البداية للمنطقة الآمنة",
  T_48_META_API_3109_P1_D: "موضع نهاية منطقة الأمان",
  T_48_META_API_3109_P2_D: "النطاق الأولي للمنطقة الآمنة",
  T_48_META_API_3109_P3_D: "نصف القطر النهائي للمنطقة الآمنة",
  T_48_META_API_3109_P4_D: "الوقت اللازم للمنطقة الآمنة للوصول إلى حالتها النهائية، بالثواني",
  T_48_META_API_3109_P5_D: "مقدار الضرر الذي يتم تلقيه في الثانية خارج المنطقة الآمنة",
  T_48_META_API_3110_D: "تبديل مجموعة مظهر الشخصية",
  T_48_META_API_3110_P0_D: "هدف",
  T_48_META_API_3110_P1_D: "مجموعة المظهر",
  T_48_META_API_3111_D: "إظهار مجموعة مظهر الشخصية",
  T_48_META_API_3111_P0_D: "هدف",
  T_48_META_API_3111_P1_D: "مجموعة المظهر",
  T_48_META_API_3112_D: "إخفاء مجموعة مظهر الشخصية",
  T_48_META_API_3112_P0_D: "هدف",
  T_48_META_API_3112_P1_D: "مجموعة المظهر",
  T_48_META_API_3121_D: "إرسال نتائج التأكيد إلى استخدام إحصائيات Craftland Studio PC",
  T_48_META_API_3121_P0_D: "تعبير التأكيد",
  T_48_META_API_3121_P1_D: "تَلمِيح",
  T_48_META_API_32_D: "احصل على بيانات الرمز المميز للاعب اليوم",
  T_48_META_API_32_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_32_P1_D: "معرف الرمز المميز",
  T_48_META_API_32_P2_D: "عدد الرموز",
  T_48_META_API_32_P3_D: "ما إذا كان تم استدعاء البدائية بنجاح",
  T_48_META_API_3200_D: "إضافة عناصر إلى اللاعب وإرجاع قائمة العناصر الصادرة",
  T_48_META_API_3200_P0_D: "لاعب",
  T_48_META_API_3200_P1_D: "معرف العنصر",
  T_48_META_API_3200_P2_D: "كمية السلعة",
  T_48_META_API_3200_P3_D: "قائمة العناصر المضافة للاعب، يتم إرجاعها كقائمة حتى لو تمت إضافة عنصر واحد فقط",
  T_48_META_API_3201_D: "استعادة حجم الدم للاعب المحدد دون تجاوز الحد الأعلى لحجم الدم.",
  T_48_META_API_3201_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3201_P1_D: "يتم قبول قيمة إضافة الدم للاعب.",
  T_48_META_API_3202_D: "قم بتعيين قائمة مهارات اللاعب المستهدف",
  T_48_META_API_3202_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3202_P1_D: "قائمة المهارات",
  T_48_META_API_3203_D: "احصل على قائمة مهارات اللاعب المستهدف",
  T_48_META_API_3203_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3203_R_D: "قائمة المهارات",
  T_48_META_API_3205_D: "حذف عدد معين من العناصر من المشغل",
  T_48_META_API_3205_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3205_P1_D: "نوع العنصر المراد حذفه",
  T_48_META_API_3205_P2_D: "الكمية المراد حذفها، إذا تجاوزت الكمية التي يحتفظ بها اللاعب، فسيتم حذف العناصر الموجودة فقط.",
  T_48_META_API_3206_D: "احصل على عدد العناصر المحددة التي يحتفظ بها اللاعب",
  T_48_META_API_3206_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3206_P1_D: "نوع العنصر",
  T_48_META_API_3206_R_D: "المبلغ الذي يحتفظ به اللاعب",
  T_48_META_API_3207_D: "تحقق مما إذا كان بإمكان اللاعب تشغيل نقطة التفتيش الحالية",
  T_48_META_API_3207_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3207_P1_D: "مشغل",
  T_48_META_API_3207_R_D: "صحيح: يمكن تشغيله، خطأ: لا يمكن تشغيله",
  T_48_META_API_3208_D: "تطور وضع العدوى الزومبي",
  T_48_META_API_3208_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3209_D: "تقوم كيانات الذكاء الاصطناعي بإيقاف/تنفيذ شجرة السلوك الافتراضية",
  T_48_META_API_3209_P0_D: "لتمكين أهداف شجرة السلوك",
  T_48_META_API_3209_P1_D: "ما إذا كان سيتم تنفيذ شجرة السلوك الافتراضية",
  T_48_META_API_3210_D: "تقوم كيانات الذكاء الاصطناعي بمطاردة الأهداف المحددة",
  T_48_META_API_3210_P0_D: "كيان الذكاء الاصطناعي الذي يقوم بالمطاردة",
  T_48_META_API_3210_P1_D: "الهدف الذي يتم متابعته",
  T_48_META_API_3211_D: "تدمير عناصر اللاعب (مهمل، استخدم حذف المعدات)",
  T_48_META_API_3211_P0_D: "اللاعب الذي تم تدمير أغراضه",
  T_48_META_API_3211_P1_D: "نوع العنصر المدمر",
  T_48_META_API_3211_P2_D: "فتحة السلاح، فعالة فقط للأسلحة",
  T_48_META_API_3212_D: "تغيير جيرسي",
  T_48_META_API_3212_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3212_P1_D: "نمط الملابس",
  T_48_META_API_3212_P2_D: "اللون الرئيسي واحد",
  T_48_META_API_3212_P3_D: "اللون الرئيسي الثاني",
  T_48_META_API_3212_P4_D: "إعدادات",
  T_48_META_API_3213_D: "إعادة قميص اللاعب إلى حالته الأصلية",
  T_48_META_API_3213_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3214_D: "قم بتشغيل وإيقاف الدردشة الصوتية للاعب",
  T_48_META_API_3214_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3214_P1_D: "ما إذا كان سيتم إيقاف تشغيل الدردشة الصوتية، صحيح: إيقاف تشغيل الخطأ: تشغيل",
  T_48_META_API_3215_D: "تبديل الدردشة السريعة بين اللاعبين",
  T_48_META_API_3215_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3215_P1_D: "ما إذا كان سيتم إغلاق الدردشة السريعة أم لا، صحيح: إغلاق خطأ: مفتوح",
  T_48_META_API_3216_D: "قم بتعيين ما إذا كان بإمكان اللاعب المستهدف التقاط العناصر",
  T_48_META_API_3216_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3216_P1_D: "ما إذا كان سيتم منع التقاط العناصر، صحيح: ممنوع التقاط العناصر، خطأ: يمكن التقاطها",
  T_48_META_API_3217_D: "قم بتعيين ما إذا كان بإمكان اللاعب المستهدف إسقاط العناصر",
  T_48_META_API_3217_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3217_P1_D: "هل يمنع إسقاط الأشياء، صحيح: ممنوع من الالتقاط، خطأ: يمكن التقاطه",
  T_48_META_API_3218_D: "قم بتدمير السلاح في الفتحة المخصصة للاعب",
  T_48_META_API_3218_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3218_P1_D: "فتحة سلاح للتدمير",
  T_48_META_API_3218_P2_D: "الكمية المراد تدميرها",
  T_48_META_API_3218_P3_D: "سواء تم تدميره بنجاح أم لا، إذا لم يكن هناك سلاح مجهز في فتحة السلاح، فسوف يفشل التدمير.",
  T_48_META_API_3219_D: "امسح جميع العناصر من حقيبة ظهر اللاعب المستهدف، بما في ذلك العناصر المجهزة",
  T_48_META_API_3219_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3220_D: "ضبط اتجاه اللاعب",
  T_48_META_API_3220_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3220_P1_D: "اتجاه اللاعب",
  T_48_META_API_3221_D: "(مهمل، يرجى عدم استخدامه. للحصول على معلومات ذات صلة، راجع السمة <Player>:Skeleton)",
  T_48_META_API_3221_P0_D: "كيان اللاعب",
  T_48_META_API_3221_P1_D: "جزء التكبير",
  T_48_META_API_3221_P2_D: "قيمة التكبير",
  T_48_META_API_3222_D: "إعطاء اللاعب تأثير الدفع، سينزل اللاعب الهدف بسرعة ثابتة، وسيتوقف تأثير الدفع بقوة عند التصادم في الهواء",
  T_48_META_API_3222_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3222_P1_D: "اتجاه الطيران",
  T_48_META_API_3222_P2_D: "مدة الضربة القاضية",
  T_48_META_API_3222_P3_D: "السرعة الأولية للمحور Y عند الطيران",
  T_48_META_API_3222_P4_D: "السرعة الأولية للطائرة XZ أثناء الطيران",
  T_48_META_API_3222_P5_D: "ما إذا كان سيتم تغيير اتجاه اللاعب",
  T_48_META_API_3223_D: "احصل على معرف ملابس اللاعب المستهدف أو الشخصية غير القابلة للعب",
  T_48_META_API_3223_P0_D: "اللاعب المستهدف أو NPC",
  T_48_META_API_3223_P1_D: "نوع الملابس",
  T_48_META_API_3223_R_D: "معرف الملابس",
  T_48_META_API_3224_D: "قم بتعيين معرف الملابس للاعب المستهدف أو NPC",
  T_48_META_API_3224_P0_D: "اللاعب المستهدف أو NPC",
  T_48_META_API_3224_P1_D: "معرف الملابس",
  T_48_META_API_3225_D: "يستعيد الملابس الافتراضية للاعب المستهدف، والتي لا يمكن تطبيقها على الشخصيات غير القابلة للعب.",
  T_48_META_API_3225_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3226_D: "يهاجم كيان الذكاء الاصطناعي الهدف المحدد",
  T_48_META_API_3226_P0_D: "كيان الذكاء الاصطناعي الذي ينفذ الهجوم",
  T_48_META_API_3226_P1_D: "هدف الهجوم",
  T_48_META_API_3227_D: "قم بتبديل سلاح اللاعب إلى السلاح الموجود في الفتحة المحددة",
  T_48_META_API_3227_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3227_P1_D: "فتحة سلاح للتبديل",
  T_48_META_API_3227_P2_D: "سواء كان التبديل ناجحًا أم لا، إذا لم يكن هناك سلاح مجهز في فتحة السلاح، فسوف يفشل التبديل.",
  T_48_META_API_3228_D: "احصل على مظهر السلاح الخاص باللاعب المستهدف أو الشخصية غير القابلة للعب",
  T_48_META_API_3228_P0_D: "اللاعب المستهدف أو NPC",
  T_48_META_API_3228_P1_D: "معرف جلد السلاح",
  T_48_META_API_3228_R_D: "معرف جلد السلاح",
  T_48_META_API_3229_D: "قم بتعيين مظهر السلاح الخاص باللاعب المستهدف أو الشخصية غير القابلة للعب",
  T_48_META_API_3229_P0_D: "اللاعب المستهدف أو NPC",
  T_48_META_API_3229_P1_D: "معرف جلد السلاح",
  T_48_META_API_3230_D: "يستعيد مظهر السلاح الافتراضي للاعب المستهدف، والذي لا يمكن تطبيقه على الشخصيات غير القابلة للعب.",
  T_48_META_API_3230_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3230_P1_D: "معرف السلاح",
  T_48_META_API_3231_D: "قم بإعداد ملابس اللاعب",
  T_48_META_API_3231_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3231_P1_D: "قائمة الزي",
  T_48_META_API_3232_D: "يزيل جميع الملابس من نوع الملابس المحدد من اللاعب المستهدف أو الشخصية غير القابلة للعب",
  T_48_META_API_3232_P0_D: "اللاعب المستهدف أو NPC",
  T_48_META_API_3232_P1_D: "نوع الملابس",
  T_48_META_API_3233_D: "قم بإزالة مظهر السلاح المحدد من قبل اللاعب أو الشخصية غير القابلة للعب",
  T_48_META_API_3233_P0_D: "اللاعب المستهدف أو NPC",
  T_48_META_API_3233_P1_D: "معرف السلاح",
  T_48_META_API_3234_D: "إضافة برتقالي إلى الهدف",
  T_48_META_API_3234_P0_D: "يجب أن يكون الكيان المستهدف كيانًا يمكنه إضافة التعزيزات",
  T_48_META_API_3234_P1_D: "معرف برتقالي",
  T_48_META_API_3235_D: "إزالة برتقالي من الهدف",
  T_48_META_API_3235_P0_D: "يجب أن يكون الكيان المستهدف كيانًا يمكنه إضافة التعزيزات",
  T_48_META_API_3235_P1_D: "معرف برتقالي",
  T_48_META_API_3236_D: "احصل على التعزيز الحالي للهدف",
  T_48_META_API_3236_P0_D: "يجب أن يكون الكيان المستهدف كيانًا يمكنه إضافة التعزيزات",
  T_48_META_API_3236_R_D: "قائمة برتقالي",
  T_48_META_API_3237_D: "احصل على العناصر الموجودة في مخزون حقيبة ظهر اللاعب المستهدف",
  T_48_META_API_3237_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3237_P1_D: "قائمة الدعائم",
  T_48_META_API_3238_D: "أضف الملحقات إلى السلاح في الفتحة المحددة ستفشل في إضافتها، لكن الملحقات المكررة ستحل محل الملحقات الأصلية إلى حقيبة ظهر اللاعب سيتم إضافة الملحقات الأصلية في الموقع الحالي للاعب",
  T_48_META_API_3238_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3238_P1_D: "فتحة المعدات",
  T_48_META_API_3238_P2_D: "مُكَمِّلات",
  T_48_META_API_3238_P3_D: `ما إذا كان قد تمت إضافة الملحق بنجاح
صحيح: تم تجهيز الملحق للسلاح الموجود في الفتحة المقابلة
خطأ: فشلت إضافة الملحق ولن يظهر في حقيبة ظهر اللاعب`,
  T_48_META_API_3238_P4_D: "الملحقات المضافة، فارغة إذا فشلت",
  T_48_META_API_3239_D: "احصل على المعدات في عمود معدات حقيبة الظهر",
  T_48_META_API_3239_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3239_P1_D: "فتحة المعدات",
  T_48_META_API_3239_P2_D: "المعدات الموجودة في الفتحة المحددة إذا لم تكن هناك معدات، فستكون فارغة.",
  T_48_META_API_3239_P3_D: "جميع الملحقات لهذا الجهاز",
  T_48_META_API_3240_D: "خذ المكون X لمتجه ثنائي الأبعاد",
  T_48_META_API_3240_P0_D: "ناقل ثنائي الأبعاد",
  T_48_META_API_3240_R_D: "مكون X ثنائي الأبعاد",
  T_48_META_API_3241_D: "خذ المركبة Y لمتجه ثنائي الأبعاد",
  T_48_META_API_3241_P0_D: "ناقل ثنائي الأبعاد",
  T_48_META_API_3241_R_D: "مكون Y المتجه ثنائي الأبعاد",
  T_48_META_API_3242_D: "يقوم المتجه ثنائي الأبعاد بتعيين المكون X",
  T_48_META_API_3242_P0_D: "ناقل ثنائي الأبعاد",
  T_48_META_API_3242_P1_D: "مكون X ثنائي الأبعاد",
  T_48_META_API_3243_D: "يقوم المتجه ثنائي الأبعاد بتعيين المكون Y",
  T_48_META_API_3243_P0_D: "ناقل ثنائي الأبعاد",
  T_48_META_API_3243_P1_D: "مكون Y المتجه ثنائي الأبعاد",
  T_48_META_API_3244_D: "أضف متجهين ثنائي الأبعاد",
  T_48_META_API_3244_P0_D: "القيمة اليسرى",
  T_48_META_API_3244_P1_D: "القيمة اليمينية",
  T_48_META_API_3244_R_D: "نتيجة إضافة ناقلات ثنائية الأبعاد",
  T_48_META_API_3245_D: "اطرح متجهين ثنائي الأبعاد",
  T_48_META_API_3245_P0_D: "القيمة اليسرى",
  T_48_META_API_3245_P1_D: "القيمة اليمينية",
  T_48_META_API_3245_R_D: "نتيجة الطرح ناقلات ثنائية الأبعاد",
  T_48_META_API_3246_D: "ضرب المتجهات ثنائية الأبعاد",
  T_48_META_API_3246_P0_D: "ناقل ثنائي الأبعاد",
  T_48_META_API_3246_P1_D: "قيمة تحجيم المتجهات ثنائية الأبعاد",
  T_48_META_API_3246_R_D: "نتيجة ضرب المتجهات ثنائية الأبعاد",
  T_48_META_API_3247_D: "حاصل الضرب النقطي لمتجهين ثنائي الأبعاد. نتيجة الضرب النقطي هي عددية تمثل الزاوية بين المتجهين.",
  T_48_META_API_3247_P0_D: "القيمة اليسرى",
  T_48_META_API_3247_P1_D: "القيمة اليمينية",
  T_48_META_API_3247_R_D: "نتيجة الضرب بالنقطة",
  T_48_META_API_3248_D: "احسب المسافة الإقليدية لمتجهين ثنائي الأبعاد",
  T_48_META_API_3248_P0_D: "القيمة اليسرى",
  T_48_META_API_3248_P1_D: "القيمة اليمينية",
  T_48_META_API_3248_R_D: "بعد طرح متجهين، طول وحدة المتجه الناتج",
  T_48_META_API_3249_D: "احسب الزاوية المحصورة بين متجهين ثنائيي الأبعاد",
  T_48_META_API_3249_P0_D: "القيمة اليسرى",
  T_48_META_API_3249_P1_D: "القيمة اليمينية",
  T_48_META_API_3249_R_D: "زاوية المتجهات، نطاق الزاوية 0-180",
  T_48_META_API_3250_D: "تطبيع ناقل ثنائي الأبعاد",
  T_48_META_API_3250_P0_D: "ناقل ثنائي الأبعاد",
  T_48_META_API_3250_R_D: "والنتيجة الطبيعية هي متجه بطول 1 متر في نفس الاتجاه.",
  T_48_META_API_3251_D: "Modulo ناقل ثنائي الأبعاد",
  T_48_META_API_3251_P0_D: "ناقل ثنائي الأبعاد",
  T_48_META_API_3251_R_D: "والنتيجة modulo هي طول المتجه",
  T_48_META_API_3252_D: "احسب متجه المتجه ثنائي الأبعاد المنعكس بخط مستقيم عمودي عادي",
  T_48_META_API_3252_P0_D: "ناقل الحادث 2D",
  T_48_META_API_3252_P1_D: "ناقل عادي ثنائي الأبعاد",
  T_48_META_API_3252_R_D: "انعكاس ناقلات 2D",
  T_48_META_API_3253_D: "احسب متجه المتجه ثلاثي الأبعاد المنعكس في مستوى عمودي على العمودي",
  T_48_META_API_3253_P0_D: "حادث ناقل ثلاثي الأبعاد",
  T_48_META_API_3253_P1_D: "ناقل ثلاثي الأبعاد عادي",
  T_48_META_API_3253_R_D: "انعكاس ناقلات 3D",
  T_48_META_API_3254_D: "تحويل متجه ثلاثي الأبعاد إلى متجه ثنائي الأبعاد وحذف المكون Z للمتجه ثلاثي الأبعاد",
  T_48_META_API_3254_P0_D: "الهدف ناقلات 3D",
  T_48_META_API_3254_R_D: "تحويل ناقلات ثنائية الأبعاد",
  T_48_META_API_3255_D: "قم بتحويل متجه ثنائي الأبعاد إلى متجه ثلاثي الأبعاد، وقم بتعيين المكون Z للمتجه ثلاثي الأبعاد على 0",
  T_48_META_API_3255_P0_D: "الهدف ناقلات 2D",
  T_48_META_API_3255_R_D: "تحويل ناقلات ثلاثية الأبعاد",
  T_48_META_API_3256_D: "إنشاء ناقل ثنائي الأبعاد",
  T_48_META_API_3256_P0_D: "مكون X لمتجه ثنائي الأبعاد",
  T_48_META_API_3256_P1_D: "مكون Y لمتجه ثنائي الأبعاد",
  T_48_META_API_3256_R_D: "تم إنشاء ناقل ثنائي الأبعاد",
  T_48_META_API_3257_D: "تخصيص سجل نقاط المنافسة لتحليل بيانات تجربة المستخدم",
  T_48_META_API_3257_P0_D: "سجل",
  T_48_META_API_3258_D: "تخصيص سجل نقاط المنافسة لتحليل بيانات تجربة المستخدم",
  T_48_META_API_3258_P0_D: "سيتم الإبلاغ عن اللاعبين",
  T_48_META_API_3258_P1_D: "سجل",
  T_48_META_API_33_D: "مرشح الكلمات القذرة",
  T_48_META_API_33_P0_D: "النص الأصلي الذي يحتاج إلى تصفيته بحثًا عن الكلمات البذيئة",
  T_48_META_API_33_R_D: "النص الذي تمت تصفيته",
  T_48_META_API_3301_D: "إنشاء كيان المخيم",
  T_48_META_API_3301_P0_D: "كيان الفصائل",
  T_48_META_API_3302_D: "انضمام الكيان المستهدف إلى المعسكر المحدد",
  T_48_META_API_3302_P0_D: "الكيان المستهدف",
  T_48_META_API_3302_P1_D: "كيان الفصائل",
  T_48_META_API_3303_D: "احصل على معسكر المخيم القابل للهجوم",
  T_48_META_API_3303_P0_D: "مهاجمة المعسكر",
  T_48_META_API_3303_R_D: "قائمة كيانات الفصائل",
  T_48_META_API_3304_D: "قم بتعيين معسكر المخيم القابل للهجوم",
  T_48_META_API_3304_P0_D: "مهاجمة المعسكر",
  T_48_META_API_3304_P1_D: "المعسكر المستهدف",
  T_48_META_API_3304_P2_D: "هل هو قابل للهجوم؟",
  T_48_META_API_3305_D: "إعداد لمهاجمة اللاعبين",
  T_48_META_API_3305_P0_D: "لاعب",
  T_48_META_API_3305_P1_D: "يستطيع مهاجمة اللاعبين",
  T_48_META_API_3305_P2_D: "هل هو قابل للهجوم؟",
  T_48_META_API_3306_D: "تعيين الفرق القابلة للهجوم من الفريق",
  T_48_META_API_3306_P0_D: "الفريق المهاجم",
  T_48_META_API_3306_P1_D: "الفريق المستهدف",
  T_48_META_API_3306_P2_D: "هل هو قابل للهجوم؟",
  T_48_META_API_3307_D: "مهمل",
  T_48_META_API_3307_P0_D: "مهمل",
  T_48_META_API_3307_R_D: "قائمة كيانات اللاعب",
  T_48_META_API_3308_D: "الكيان المحدد يخرج من المعسكر الحالي",
  T_48_META_API_3308_P0_D: "الكيان المستهدف",
  T_48_META_API_3309_D: "احصل على فصيل الهدف",
  T_48_META_API_3309_P0_D: "الكيان المستهدف",
  T_48_META_API_3309_R_D: "كيان الفصائل",
  T_48_META_API_3310_D: "تحديد ما إذا كان يمكن مهاجمة الهدف",
  T_48_META_API_3310_P0_D: "مهاجم",
  T_48_META_API_3310_P1_D: "الكيان المستهدف",
  T_48_META_API_3310_R_D: "هل هو قابل للهجوم؟",
  T_48_META_API_3311_D: "تحديد أهداف قابلة للهجوم للكيانات",
  T_48_META_API_3311_P0_D: "مهاجم",
  T_48_META_API_3311_P1_D: "الكيان المستهدف",
  T_48_META_API_3311_P2_D: "هل هو قابل للهجوم؟",
  T_48_META_API_3312_D: "يحصل على أهداف قابلة للهجوم للكيان",
  T_48_META_API_3312_P0_D: "مهاجم",
  T_48_META_API_3312_R_D: "قائمة الكيانات القابلة للهجوم",
  T_48_META_API_34_D: "تحديد ما إذا كان الكيان المستهدف يحتوي على مكونات",
  T_48_META_API_34_P0_D: "الكيان المستهدف",
  T_48_META_API_34_P1_D: "نوع المكون",
  T_48_META_API_34_R_D: "هل يوجد",
  T_48_META_API_35_D: "إضافة بوت",
  T_48_META_API_35_P0_D: "مستوى صعوبة البوت",
  T_48_META_API_35_P1_D: "الفريق الذي ينتمي إليه الروبوت",
  T_48_META_API_35_P2_D: "كيان مشغل الروبوت الذي تم إنشاؤه",
  T_48_META_API_3500_D: "احصل على بيانات رمز اللاعب",
  T_48_META_API_3500_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3500_P1_D: "معرف الرمز المميز",
  T_48_META_API_3500_P2_D: "عدد الرموز",
  T_48_META_API_3500_P3_D: "هل هو ناجح؟",
  T_48_META_API_3501_D: "إضافة بيانات الرمز المميز للاعبين",
  T_48_META_API_3501_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3501_P1_D: "معرف الرمز المميز",
  T_48_META_API_3501_P2_D: "عدد الرموز",
  T_48_META_API_3501_P3_D: "ما إذا كان تم استدعاء البدائية بنجاح",
  T_48_META_API_3502_D: "تستهلك رمز اللاعب المستهدف",
  T_48_META_API_3502_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3502_P1_D: "معرف الرمز المميز",
  T_48_META_API_3502_P2_D: "عدد الرموز",
  T_48_META_API_3502_P3_D: "ما إذا كان تم استدعاء البدائية بنجاح",
  T_48_META_API_3503_D: "إضافة رمز مميز في الموقع المحدد",
  T_48_META_API_3503_P0_D: "موقع",
  T_48_META_API_3503_P1_D: "معرف الرمز المميز",
  T_48_META_API_3503_P2_D: "عدد الرموز",
  T_48_META_API_3503_P3_D: "ما إذا كان تم استدعاء البدائية بنجاح",
  T_48_META_API_3504_D: "يطلق الذكاء الاصطناعي المستهدف مهارات محددة",
  T_48_META_API_3504_P0_D: "الهدف الذكاء الاصطناعي",
  T_48_META_API_3504_P1_D: "مهارة",
  T_48_META_API_3504_P2_D: "هدف المهارة",
  T_48_META_API_3504_P3_D: "ما إذا تم إطلاق المهارة بنجاح",
  T_48_META_API_3505_D: "أنشئ مسارًا لتحديد المسار من نقطة البداية إلى نقطة النهاية، والذي سيتجاوز العوائق ويمكن استخدامه لتحديد المسار بواسطة الذكاء الاصطناعي.",
  T_48_META_API_3505_P0_D: "إحداثيات نقطة البداية",
  T_48_META_API_3505_P1_D: "إحداثيات نقطة النهاية",
  T_48_META_API_3505_P2_D: "ما إذا كان قد تم إنشاء مسار العثور على المسار بنجاح",
  T_48_META_API_3505_P3_D: "جمع نقطة تحديد الطريق",
  T_48_META_API_3506_D: "تعيين متغيرات شجرة السلوك على السبورة",
  T_48_META_API_3506_P0_D: "شجرة السلوك المستهدف",
  T_48_META_API_3506_P1_D: "اسم متغير",
  T_48_META_API_3506_P2_D: "قيمة متغيرة",
  T_48_META_API_3507_D: "الحصول على متغيرات شجرة السلوك على السبورة",
  T_48_META_API_3507_P0_D: "شجرة السلوك المستهدف",
  T_48_META_API_3507_P1_D: "اسم متغير",
  T_48_META_API_3507_P2_D: "قيمة متغيرة",
  T_48_META_API_3508_D: "الحصول على معلمات عقدة شجرة السلوك",
  T_48_META_API_3508_P0_D: "عقدة شجرة السلوك المستهدفة",
  T_48_META_API_3508_P1_D: "اسم المعلمة",
  T_48_META_API_3508_P2_D: "قيمة المعلمة",
  T_48_META_API_3509_D: "احصل على مظهر مركبة اللاعب المستهدف",
  T_48_META_API_3509_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3509_P1_D: "معرف المركبة",
  T_48_META_API_3509_R_D: "جلد السيارة",
  T_48_META_API_3510_D: "اضبط مظهر مركبة اللاعب المستهدف",
  T_48_META_API_3510_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3510_P1_D: "معرف جلد السيارة",
  T_48_META_API_3511_D: "مسح جلد المركبة المحددة لللاعب الهدف",
  T_48_META_API_3511_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3511_P1_D: "معرف المركبة",
  T_48_META_API_3512_D: "قم باستعادة مظهر السيارة الافتراضي للاعب المستهدف",
  T_48_META_API_3512_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_3512_P1_D: "معرف المركبة",
  T_48_META_API_36_D: "هدف النوم، لا يمكن استخدامه إلا للأجسام الصلبة من النوع الديناميكي",
  T_48_META_API_36_P0_D: "استهداف الجسم الصلب",
  T_48_META_API_37_D: "تنبيه الهدف، لا يمكن استخدامه إلا للأجسام الصلبة من النوع الديناميكي",
  T_48_META_API_37_P0_D: "استهداف الجسم الصلب",
  T_48_META_API_38_D: "تحقق مما إذا كان الجسم الصلب المستهدف نائماً",
  T_48_META_API_38_P0_D: "استهداف الجسم الصلب",
  T_48_META_API_38_R_D: "هل هو نائم",
  T_48_META_API_39_D: "ضبط عتبة النوم",
  T_48_META_API_39_P0_D: "استهداف الجسم الصلب",
  T_48_META_API_39_P1_D: "عتبة النوم يدخل الجسم الجامد في حالة النوم بعد أن تكون حركته ودورانه أقل من هذه القيمة لفترة من الزمن، ويتوقف الجسم الجامد في حالة النوم عن القيام بالحسابات الجسدية.",
  T_48_META_API_4_D: "قم بتعيين ما إذا كان بإمكان جميع اللاعبين التحرك",
  T_48_META_API_4_P0_D: `صحيح: يمكن نقله
خطأ: لا يمكن نقله`,
  T_48_META_API_40_D: "الحصول على عتبة النوم",
  T_48_META_API_40_P0_D: "استهداف الجسم الصلب",
  T_48_META_API_40_R_D: "عتبة النوم يدخل الجسم الجامد في حالة النوم بعد أن تكون حركته ودورانه أقل من هذه القيمة لفترة من الزمن، ويتوقف الجسم الجامد في حالة النوم عن القيام بالحسابات الجسدية.",
  T_48_META_API_4000_D: "اقرأ محتويات الجدول بأكمله وقم بإرجاع مصفوفة ثنائية الأبعاد بترتيب الصفوف.",
  T_48_META_API_4000_P0_D: "اسم الجدول",
  T_48_META_API_4000_R_D: "محتويات الجدول",
  T_48_META_API_4001_D: "اقرأ محتويات صف من الجدول وقم بإرجاع مصفوفة",
  T_48_META_API_4001_P0_D: "اسم الجدول",
  T_48_META_API_4001_P1_D: "عدد الصفوف المراد قراءتها، بدءًا من 1",
  T_48_META_API_4001_R_D: "يحدد الجدول محتويات الصف",
  T_48_META_API_4002_D: "اقرأ محتويات عمود الجدول وقم بإرجاع مصفوفة",
  T_48_META_API_4002_P0_D: "اسم الجدول",
  T_48_META_API_4002_P1_D: "عدد الأعمدة المراد قراءتها، بدءًا من 1",
  T_48_META_API_4002_R_D: "يحدد الجدول محتويات العمود",
  T_48_META_API_4003_D: "قراءة محتويات خلية الجدول",
  T_48_META_API_4003_P0_D: "اسم الجدول",
  T_48_META_API_4003_P1_D: "عدد الصفوف المراد قراءتها، بدءًا من 1",
  T_48_META_API_4003_P2_D: "عدد الأعمدة المراد قراءتها، بدءًا من 1",
  T_48_META_API_4003_R_D: "محتويات الخلية المحددة في الجدول",
  T_48_META_API_4004_D: "قراءة محتويات خلية معينة في الجدول حسب رقم الصف واسم العمود",
  T_48_META_API_4004_P0_D: "اسم الجدول",
  T_48_META_API_4004_P1_D: "عدد الصفوف المراد قراءتها، بدءًا من 1",
  T_48_META_API_4004_P2_D: "اسم العمود للقراءة",
  T_48_META_API_4004_R_D: "محتويات الخلية المحددة في الجدول",
  T_48_META_API_4005_D: "اقرأ محتويات الجدول بأكمله وقم بإرجاع مصفوفة ثنائية الأبعاد",
  T_48_META_API_4005_P0_D: "اسم الجدول",
  T_48_META_API_4005_R_D: "محتويات الجدول، مجموعة ثنائية الأبعاد",
  T_48_META_API_4006_D: "اقرأ محتويات صف معين من الجدول بأكمله وقم بإرجاع مصفوفة",
  T_48_META_API_4006_P0_D: "اسم الجدول",
  T_48_META_API_4006_P1_D: "عدد الصفوف المراد قراءتها، بدءًا من 1",
  T_48_META_API_4006_R_D: "يحدد الجدول محتويات الصف والمصفوفة",
  T_48_META_API_4007_D: "اقرأ محتويات عمود الجدول بأكمله وقم بإرجاع مصفوفة",
  T_48_META_API_4007_P0_D: "اسم الجدول",
  T_48_META_API_4007_P1_D: "عدد الأعمدة المراد قراءتها، بدءًا من 1",
  T_48_META_API_4007_R_D: "يحدد الجدول محتويات العمود والمصفوفة",
  T_48_META_API_4008_D: "قراءة محتويات خلية الجدول",
  T_48_META_API_4008_P0_D: "اسم الجدول",
  T_48_META_API_4008_P1_D: "عدد الصفوف المراد قراءتها، بدءًا من 1",
  T_48_META_API_4008_P2_D: "عدد الأعمدة المراد قراءتها، بدءًا من 1",
  T_48_META_API_4008_R_D: "محتويات الخلية المحددة في الجدول",
  T_48_META_API_4009_D: "ابحث عن الصف المحدد حسب رقم العمود وقيمة الخلية",
  T_48_META_API_4009_P0_D: "اسم الجدول",
  T_48_META_API_4009_P1_D: "عدد الأعمدة المراد قراءتها",
  T_48_META_API_4009_P2_D: "قيمة الخلية المطلوب العثور عليها",
  T_48_META_API_4009_R_D: "محتوى الصف الموجود، المصفوفة",
  T_48_META_API_4010_D: "الحصول على رقم العمود حسب اسم العمود",
  T_48_META_API_4010_P0_D: "اسم الجدول",
  T_48_META_API_4010_P1_D: "اسم العمود للتحقق من الرقم التسلسلي",
  T_48_META_API_4010_R_D: "عدد الأعمدة، العد من 1",
  T_48_META_API_41_D: "قم بتعيين حد السكون العالمي، والذي يكون صالحًا فقط للأجسام الصلبة من النوع الديناميكي التي تم إنشاؤها حديثًا.",
  T_48_META_API_41_P0_D: "عتبة النوم يدخل الجسم الجامد في حالة النوم بعد أن تكون حركته ودورانه أقل من هذه القيمة لفترة من الزمن، ويتوقف الجسم الجامد في حالة النوم عن القيام بالحسابات الجسدية.",
  T_48_META_API_42_D: "احصل على عتبة النوم العالمية",
  T_48_META_API_42_R_D: "عتبة النوم، الافتراضي هو 0.005، سيدخل الجسم الصلب في حالة النوم بعد أن تكون الحركة والدوران أقل من هذه القيمة لفترة من الوقت، ولن يقوم الجسم الصلب في حالة النوم بإجراء الحسابات الجسدية.",
  T_48_META_API_43_D: "قم بتحويل الرباعي المحدد إلى زوايا أويلر. ترتيب دوران زوايا أويلر هو YXZ إذا كان التمرير في الرباعي غير قانوني، قم بإرجاع (0,0,0).",
  T_48_META_API_43_P0_D: "إدخال الرباعي",
  T_48_META_API_43_R_D: "زوايا أويلر المعادة",
  T_48_META_API_44_D: "حول زوايا أويلر المعطاة إلى كواترنيونات",
  T_48_META_API_44_P0_D: "إدخال زوايا أويلر",
  T_48_META_API_44_R_D: "عاد الربع",
  T_48_META_API_45_D: "تحويل الدوران الذي يمثله زاوية المحور إلى كواترنيون",
  T_48_META_API_45_P0_D: "محور الدوران",
  T_48_META_API_45_P1_D: "زاوية الدوران في اتجاه عقارب الساعة حول محور الدوران",
  T_48_META_API_45_R_D: "عاد الربع",
  T_48_META_API_46_D: "تحويل الكواترنيون إلى تمثيل زاوية المحور",
  T_48_META_API_46_P0_D: "إدخال الرباعي",
  T_48_META_API_46_P1_D: "محور الدوران",
  T_48_META_API_46_P2_D: "زاوية الدوران في اتجاه عقارب الساعة حول محور الدوران",
  T_48_META_API_47_D: "قم بتعيين تقدم إكمال المهمة المخصصة",
  T_48_META_API_47_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_47_P1_D: "معرف المهمة",
  T_48_META_API_47_P2_D: "تقدم الإكمال، الأرقام السالبة غير مسموح بها",
  T_48_META_API_48_D: "قم بإنشاء منحنى Bezier الذي يمكن استخدامه لاستكمال الحركة",
  T_48_META_API_48_P0_D: "نقاط التحكم المنحنية",
  T_48_META_API_48_R_D: "منحنى بيزييه",
  T_48_META_API_49_D: "الحصول على معرف خريطة المشهد",
  T_48_META_API_49_P0_D: "معرف المشهد",
  T_48_META_API_49_R_D: "معرف الخريطة",
  T_48_META_API_5_D: "حذف الكائنات الموضوعة في المشهد (عفا عليه الزمن، يرجى استخدام RemoveEntity)",
  T_48_META_API_5_P0_D: "كيان الكائن المراد حذفه",
  T_48_META_API_50_D: "قم بإنشاء حركة تتعلق بنفسها في كل إطار، يقوم الكيان المستهدف بتغيير سماته الخاصة مرة واحدة في كل إطار، وفي كل مرة يتغير بالنسبة لقيمة السمة الحالية الخاصة به.",
  T_48_META_API_50_P0_D: "الكيان المستهدف",
  T_48_META_API_50_P1_D: "السمات التي تتطلب تغييرات الحركة",
  T_48_META_API_50_P2_D: "مقدار التغيير لكل حركة",
  T_48_META_API_50_P3_D: `التكوين عند استخدامه مع أوضاع الحركة الأخرى
صحيح: يمكن استخدامه مع الحركة النسبية
خطأ: يمكن استخدامه مع الحركة المطلقة`,
  T_48_META_API_50_P4_D: "كيان الحركة الذي تم إنشاؤه بالنسبة إلى نفسه لكل إطار",
  T_48_META_API_50_P5_D: "ما إذا كان سيتم بدء اللعب تلقائيًا بعد الإنشاء",
  T_48_META_API_5000_D: "قراءة القيمة المقابلة لمفتاح في جدول في قاعدة البيانات",
  T_48_META_API_5000_P0_D: "اسم الجدول في قاعدة البيانات",
  T_48_META_API_5000_P1_D: "قم بتمييز اللاعبين والتعامل مع مواقف التزامن",
  T_48_META_API_5000_P2_D: "اسم مخصص يستخدم لتحديد البيانات",
  T_48_META_API_5000_P3_D: "إرجاع نتيجة القراءة",
  T_48_META_API_5000_P4_D: "رمز الميدان المعركة المطابق لقاعدة البيانات",
  T_48_META_API_5001_D: "اكتب القيمة المقابلة لمفتاح في جدول في قاعدة البيانات",
  T_48_META_API_5001_P0_D: "اسم الجدول في قاعدة البيانات",
  T_48_META_API_5001_P1_D: "قم بتمييز اللاعبين والتعامل مع مواقف التزامن",
  T_48_META_API_5001_P2_D: "اسم مخصص يستخدم لتحديد البيانات",
  T_48_META_API_5001_P3_D: "القيمة مكتوبة",
  T_48_META_API_5001_P4_D: "يمثل رمز ساحة المعركة المقابل لقاعدة البيانات، والذي يمكن ملؤه بالفراغات، رمز ساحة المعركة للخريطة الحالية",
  T_48_META_API_5002_D: "حذف القيمة المقابلة لمفتاح معين في جدول معين في قاعدة البيانات",
  T_48_META_API_5002_P0_D: "اسم الجدول في قاعدة البيانات",
  T_48_META_API_5002_P1_D: "قم بتمييز اللاعبين والتعامل مع مواقف التزامن",
  T_48_META_API_5002_P2_D: "اسم مخصص يستخدم لتحديد البيانات",
  T_48_META_API_5002_P3_D: "رمز الميدان المعركة المطابق لقاعدة البيانات",
  T_48_META_API_5003_D: "اقرأ القيمة المقابلة للمفتاح في جدول التصنيف في قاعدة البيانات",
  T_48_META_API_5003_P0_D: "اسم جدول الترتيب في قاعدة البيانات",
  T_48_META_API_5003_P1_D: "اسم مخصص يستخدم لتحديد البيانات",
  T_48_META_API_5003_P2_D: "إرجاع نتيجة القراءة",
  T_48_META_API_5003_P3_D: "رمز الميدان المعركة المطابق لقاعدة البيانات",
  T_48_META_API_5004_D: "اكتب القيمة المقابلة للمفتاح في جدول الترتيب في قاعدة البيانات",
  T_48_META_API_5004_P0_D: "اسم جدول الترتيب في قاعدة البيانات",
  T_48_META_API_5004_P1_D: "اسم مخصص يستخدم لتحديد البيانات",
  T_48_META_API_5004_P2_D: "القيمة مكتوبة",
  T_48_META_API_5004_P3_D: "رمز الميدان المعركة المطابق لقاعدة البيانات",
  T_48_META_API_5005_D: "احذف القيمة المقابلة لمفتاح في جدول الترتيب في قاعدة البيانات",
  T_48_META_API_5005_P0_D: "اسم الجدول في قاعدة البيانات",
  T_48_META_API_5005_P1_D: "اسم مخصص يستخدم لتحديد البيانات",
  T_48_META_API_5005_P2_D: "رمز الميدان المعركة المطابق لقاعدة البيانات",
  T_48_META_API_5006_D: "حذف القيمة المقابلة لتصنيف معين في جدول التصنيف بقاعدة البيانات",
  T_48_META_API_5006_P0_D: "اسم الجدول في قاعدة البيانات",
  T_48_META_API_5006_P1_D: "الموقف في المتصدرين",
  T_48_META_API_5006_P2_D: "رمز الميدان المعركة المطابق لقاعدة البيانات",
  T_48_META_API_5007_D: "اقرأ القيم من تصنيف معين إلى تصنيف معين في جدول التصنيف في قاعدة البيانات",
  T_48_META_API_5007_P0_D: "اسم الجدول في قاعدة البيانات",
  T_48_META_API_5007_P1_D: "رتبة البداية",
  T_48_META_API_5007_P2_D: "الترتيب النهائي",
  T_48_META_API_5007_P3_D: "إرجاع نتيجة القراءة",
  T_48_META_API_5007_P4_D: "رمز الميدان المعركة المطابق لقاعدة البيانات",
  T_48_META_API_5008_D: "اقرأ القيمة المقابلة لمفتاح في جدول في قاعدة البيانات التراكمية",
  T_48_META_API_5008_P0_D: "اسم الجدول في قاعدة البيانات",
  T_48_META_API_5008_P1_D: "اسم مخصص يستخدم لتحديد البيانات",
  T_48_META_API_5008_P2_D: "إرجاع نتيجة القراءة",
  T_48_META_API_5008_P3_D: "رمز الميدان المعركة المطابق لقاعدة البيانات",
  T_48_META_API_5009_D: "اكتب قيمة الإزاحة المقابلة لمفتاح في جدول في قاعدة البيانات التراكمية",
  T_48_META_API_5009_P0_D: "اسم الجدول في قاعدة البيانات",
  T_48_META_API_5009_P1_D: "اسم مخصص يستخدم لتحديد البيانات",
  T_48_META_API_5009_P2_D: "تدعم الأنواع الأربعة من العمليات الحسابية حاليًا الأنواع التالية: نوع Int يدعم الجمع والطرح والضرب والقسمة والباقي؛ ويدعم النوع Float الجمع والطرح والضرب والقسمة",
  T_48_META_API_5009_P3_D: "قيمة الإزاحة مكتوبة",
  T_48_META_API_5009_P4_D: "رمز الميدان المعركة المطابق لقاعدة البيانات",
  T_48_META_API_51_D: "قم بإعادة تعيين الكيان القابل للتشغيل واستعادة الكيان القابل للتشغيل إلى شكله الأولي دون تغيير حالة التشغيل.",
  T_48_META_API_51_P0_D: "الكيان المستهدف القابل للتشغيل",
  T_48_META_API_52_D: "ضرب اثنين من الكواترنيون A*B يعني تدوير A أولاً ثم تدوير B. ستؤدي أوامر الدوران المختلفة إلى نتائج مختلفة.",
  T_48_META_API_52_P0_D: "lالرباعي القيمة",
  T_48_META_API_52_P1_D: "rvalue quaternion",
  T_48_META_API_52_R_D: "النتيجة الرباعية",
  T_48_META_API_53_D: "ينشئ كواترنيونًا دوارًا يواجه الاتجاه المحدد",
  T_48_META_API_53_P0_D: "تحديد الاتجاه",
  T_48_META_API_53_P1_D: "الاتجاه التصاعدي",
  T_48_META_API_53_R_D: "مقدار الدوران المطلوب للمحاذاة في الاتجاه المحدد",
  T_48_META_API_54_D: "الاستيفاء الرباعي الكروي من A إلى B",
  T_48_META_API_54_P0_D: "قيمة",
  T_48_META_API_54_P1_D: "قيمة ب",
  T_48_META_API_54_P2_D: "تقدم الاستيفاء، نطاق القيمة [0،1]، عندما تكون القيمة 0، يتم إرجاع قيمة البداية، عندما تكون القيمة 1، يتم إرجاع القيمة المستهدفة",
  T_48_META_API_54_R_D: "النتيجة الرباعية",
  T_48_META_API_57_D: "قم بطباعة البيانات المستهدفة إلى وحدة التحكم كتحذير",
  T_48_META_API_57_P0_D: "ما يحتاج إلى طباعته",
  T_48_META_API_58_D: "قم بطباعة البيانات المستهدفة إلى وحدة التحكم في نموذج خطأ",
  T_48_META_API_58_P0_D: "ما يحتاج إلى طباعته",
  T_48_META_API_59_D: "احصل على القيمة على المنحنى",
  T_48_META_API_59_P0_D: "منحنى",
  T_48_META_API_59_P1_D: "نقطة أخذ العينات، نطاق القيمة [0,1]",
  T_48_META_API_59_R_D: "نتيجة",
  T_48_META_API_6_D: "إنشاء كائنات المشهد إلى الإحداثيات المحددة",
  T_48_META_API_6_P0_D: "تم إنشاء كيان كائن المشهد",
  T_48_META_API_6_P1_D: "الموقع الذي يتم فيه إنشاء الكائن",
  T_48_META_API_6_P2_D: "عند استخدام معرف نوع الكائن الذي تم إنشاؤه في البرامج النصية للتعليمات البرمجية، فإنك تحتاج إلى تسجيل تعداد كائن المستوى في تسجيل الأصول مسبقًا.",
  T_48_META_API_60_D: "أقحم من المنحنيات",
  T_48_META_API_60_P0_D: "نوع القيمة",
  T_48_META_API_60_P1_D: "قيمة البداية",
  T_48_META_API_60_P2_D: "القيمة المستهدفة",
  T_48_META_API_60_P3_D: "منحنى",
  T_48_META_API_60_P4_D: "نقطة أخذ العينات، نطاق القيمة [0,1]",
  T_48_META_API_60_R_D: "نتيجة",
  T_48_META_API_6000_D: "إضافة برنامج نصي للكيان المستهدف",
  T_48_META_API_6000_P0_D: "الكيان المستهدف",
  T_48_META_API_6000_P1_D: "معرف البرنامج النصي",
  T_48_META_API_6001_D: "إلغاء تثبيت البرنامج النصي للكيان الهدف",
  T_48_META_API_6001_P0_D: "الكيان المستهدف",
  T_48_META_API_6001_P1_D: "معرف البرنامج النصي",
  T_48_META_API_6002_D: "تحقق مما إذا كان البرنامج النصي المحدد موجودًا في الكيان الهدف",
  T_48_META_API_6002_P0_D: "الكيان المستهدف",
  T_48_META_API_6002_P1_D: "معرف البرنامج النصي",
  T_48_META_API_6002_R_D: "ما إذا كان البرنامج النصي المحدد موجودًا",
  T_48_META_API_61_D: "قم بتعيين العقدة الأصلية لعنصر تحكم واجهة المستخدم",
  T_48_META_API_61_P0_D: "العقدة الأصلية، يمكنك تحديد عناصر تحكم واجهة المستخدم أو واجهة المستخدم المخصصة",
  T_48_META_API_61_P1_D: "عقدة الطفل",
  T_48_META_API_62_D: "مهمل",
  T_48_META_API_62_P0_D: "مهمل",
  T_48_META_API_62_P1_D: "مهمل",
  T_48_META_API_62_P2_D: "مهمل",
  T_48_META_API_62_P3_D: "مهمل",
  T_48_META_API_62_P4_D: "مهمل",
  T_48_META_API_63_D: "يقوم بإنشاء شعاع من الكاميرا الحالية إلى نقطة لمس الشاشة",
  T_48_META_API_63_P0_D: "نقاط لمس الشاشة",
  T_48_META_API_63_P1_D: "نقطة البداية",
  T_48_META_API_63_P2_D: "اتجاه راي",
  T_48_META_API_64_D: "تحميل معلومات الفواتير المخصصة",
  T_48_META_API_64_P0_D: "كيان اللاعب",
  T_48_META_API_64_P1_D: "نتيجة المباراة",
  T_48_META_API_64_P2_D: "عنوان النقاط",
  T_48_META_API_64_P3_D: "قيمة النقاط",
  T_48_META_API_65_D: "تشغيل التأثير الصوتي المحدد إذا كان هناك المزيد من الخصائص التي تحتاج إلى تعيين، فيمكنك تعيين خصائص الكيان الخاص به.",
  T_48_META_API_65_P0_D: "تم إنشاء كيان التأثير الصوتي",
  T_48_META_API_65_P1_D: "اللاعب المستهدف، اللاعب المستهدف فقط هو الذي يمكنه سماع التأثير الصوتي",
  T_48_META_API_65_P2_D: "نوع التأثير الصوتي",
  T_48_META_API_65_P3_D: "نوع الحلقة",
  T_48_META_API_65_P4_D: "سواء للعب على الفور",
  T_48_META_API_66_D: "قم بإنشاء تأثير مرئي محدد إذا كان هناك المزيد من الخصائص التي تحتاج إلى تعيين، فيمكنك تعيين خصائص الكيان الخاص به.",
  T_48_META_API_66_P0_D: "تم إنشاء كيان المؤثرات الخاصة",
  T_48_META_API_66_P1_D: "اللاعب المستهدف، اللاعب المستهدف فقط هو الذي يظهر",
  T_48_META_API_66_P2_D: "نوع التأثير الخاص",
  T_48_META_API_66_P3_D: "نوع الحلقة",
  T_48_META_API_66_P4_D: "سواء للعب على الفور",
  T_48_META_API_67_D: "قم بإنشاء التأثير الصوتي المحدد إذا كان هناك المزيد من الخصائص التي تحتاج إلى تعيين، فيمكنك تعيين خصائص الكيان الخاص به.",
  T_48_META_API_67_P0_D: "تم إنشاء كيان التأثير الصوتي",
  T_48_META_API_67_P1_D: "نوع التأثير الصوتي",
  T_48_META_API_67_P2_D: "نوع الحلقة",
  T_48_META_API_67_P3_D: "سواء للعب على الفور",
  T_48_META_API_68_D: "تحويل إحداثيات العالم إلى إحداثيات الشاشة",
  T_48_META_API_68_P0_D: "إحداثيات العالم",
  T_48_META_API_68_P1_D: "ما إذا كان سيتم تعيينه على الشاشة",
  T_48_META_API_68_P2_D: "موقع الخريطة",
  T_48_META_API_69_D: "تحويل إحداثيات الشاشة إلى إحداثيات العالم",
  T_48_META_API_69_P0_D: "إحداثيات الشاشة",
  T_48_META_API_69_P1_D: "المسافة من الشاشة",
  T_48_META_API_69_P2_D: "إحداثيات العالم",
  T_48_META_API_7_D: "تحويل القيمة المستهدفة إلى سلسلة",
  T_48_META_API_7_P0_D: "القيمة الهدف المراد تحويلها إلى سلسلة",
  T_48_META_API_7_R_D: "خيط",
  T_48_META_API_70_D: "قم بإجراء الكشف عن الأشعة من خلال لمس الشاشة وإرجاع كيان الضربة الأول",
  T_48_META_API_70_P0_D: "لمس الشاشة الرئيسية",
  T_48_META_API_70_P1_D: "مسافة الكشف",
  T_48_META_API_70_P2_D: "قناع الطبقة، ستشارك الطبقات المعبأة فقط في الفحص، وترك فارغًا يعني أن جميع الطبقات ستشارك في الفحص",
  T_48_META_API_70_P3_D: "هل من الممكن الكشف عن المشغلات",
  T_48_META_API_70_P4_D: "ضرب الكيان",
  T_48_META_API_70_P5_D: "إحداثيات نقطة الضرب",
  T_48_META_API_70_P6_D: "المسافة من نقطة الإصابة إلى نقطة البداية",
  T_48_META_API_70_P7_D: "ضرب السطح عادي",
  T_48_META_API_71_D: "كشف الأشعة عن طريق لمس الشاشة، وإرجاع جميع الكيانات المصابة",
  T_48_META_API_71_P0_D: "لمس الشاشة الرئيسية",
  T_48_META_API_71_P1_D: "مسافة الكشف",
  T_48_META_API_71_P2_D: "قناع الطبقة، ستشارك الطبقات المعبأة فقط في الفحص، وترك فارغًا يعني أن جميع الطبقات ستشارك في الفحص",
  T_48_META_API_71_P3_D: "هل من الممكن الكشف عن المشغلات",
  T_48_META_API_71_P4_D: "قائمة الكيانات المتضررة",
  T_48_META_API_71_P5_D: "ضرب قائمة إحداثيات النقطة",
  T_48_META_API_71_P6_D: "قائمة المسافات بين نقطة الإصابة ونقطة البداية",
  T_48_META_API_71_P7_D: "ضرب القائمة السطحية العادية",
  T_48_META_API_72_D: "قم بإنشاء تأثير مرئي محدد إذا كان هناك المزيد من الخصائص التي تحتاج إلى تعيين، فيمكنك تعيين خصائص الكيان الخاص به.",
  T_48_META_API_72_P0_D: "تم إنشاء كيان المؤثرات الخاصة",
  T_48_META_API_72_P1_D: "نوع التأثير الخاص",
  T_48_META_API_72_P2_D: "نوع الحلقة",
  T_48_META_API_72_P3_D: "سواء للعب على الفور",
  T_48_META_API_73_D: "قم بإنشاء واجهة مستخدم مضمنة غير متزامنة مع العملاء الآخرين",
  T_48_META_API_73_P0_D: "تم إنشاء كيانات واجهة المستخدم المضمنة",
  T_48_META_API_73_P1_D: "أنواع واجهة المستخدم المضمنة",
  T_48_META_API_74_D: "قم بإنشاء واجهة مستخدم مخصصة لن تتم مزامنتها مع العملاء الآخرين",
  T_48_META_API_74_P0_D: "تم إنشاء كيانات واجهة المستخدم المخصصة",
  T_48_META_API_74_P1_D: "مؤشر واجهة المستخدم المخصصة",
  T_48_META_API_75_D: "احصل على اللاعب المطابق للعميل الحالي",
  T_48_META_API_75_R_D: "كيان اللاعب",
  T_48_META_API_76_D: "إنشاء وحوش منظمة العفو الدولية",
  T_48_META_API_76_P0_D: "الهدف الذكاء الاصطناعي",
  T_48_META_API_76_P1_D: "إنشاء الموقع",
  T_48_META_API_76_P2_D: "نوع الذكاء الاصطناعي",
  T_48_META_API_76_P3_D: "فريق",
  T_48_META_API_76_P4_D: "ما إذا كان سيتم البحث تلقائيًا عن الأعداء أم لا",
  T_48_META_API_76_P5_D: "وضع الهجوم",
  T_48_META_API_76_P6_D: "طريق السفر",
  T_48_META_API_77_D: "قم بتعيين المكون الأول للمتجه",
  T_48_META_API_77_P0_D: "ناقلات",
  T_48_META_API_77_P1_D: "قيمة المكون الأول",
  T_48_META_API_77_R_D: "Vector بعد تعديل المكون الأول",
  T_48_META_API_78_D: "يعين المكون الثاني من المتجه",
  T_48_META_API_78_P0_D: "ناقلات",
  T_48_META_API_78_P1_D: "قيمة المكون الثاني",
  T_48_META_API_78_R_D: "المتجهات بعد تعديل المكون الثاني",
  T_48_META_API_79_D: "يعين المكون الثالث للمتجه",
  T_48_META_API_79_P0_D: "ناقلات",
  T_48_META_API_79_P1_D: "قيمة المكون الثالث",
  T_48_META_API_79_R_D: "المتجهات بعد تعديل المكون الثالث",
  T_48_META_API_8_D: "قم بتشغيل المنطقة الآمنة التي ستتقلص إلى نقطة الإحداثيات المركزية",
  T_48_META_API_8_P0_D: "النقطة المركزية للمنطقة الآمنة",
  T_48_META_API_8_P1_D: "نصف قطر المنطقة الآمنة",
  T_48_META_API_8_P2_D: "وقت الانتظار، بالثواني، وبعدها ستبدأ المنطقة الآمنة في الانكماش باتجاه النقطة المركزية",
  T_48_META_API_8_P3_D: "الوقت اللازم لتقليص المنطقة الآمنة إلى النقطة المركزية، بالثواني",
  T_48_META_API_8_P4_D: "مقدار الضرر الذي يتم تلقيه في الثانية خارج المنطقة الآمنة",
  T_48_META_API_80_D: "يضبط المكون الأول لمتجه ثنائي الأبعاد",
  T_48_META_API_80_P0_D: "ناقل ثنائي الأبعاد",
  T_48_META_API_80_P1_D: "قيمة المكون الأول",
  T_48_META_API_80_R_D: "ناقل ثنائي الأبعاد بعد تعديل المكون الأول",
  T_48_META_API_81_D: "يضبط المكون الثاني لمتجه ثنائي الأبعاد",
  T_48_META_API_81_P0_D: "ناقل ثنائي الأبعاد",
  T_48_META_API_81_P1_D: "قيمة المكون الثاني",
  T_48_META_API_81_R_D: "ناقل ثنائي الأبعاد بعد تعديل المكون الثاني",
  T_48_META_API_82_D: "انقل وحدة التحكم في الشخصية إلى الموضع المحدد إذا كان ذلك يؤثر على اللاعب، فيجب على اللاعب تشغيل وحدة التحكم في اللاعب التي تستخدم التأثيرات المادية حتى تصبح سارية المفعول.",
  T_48_META_API_82_P0_D: "وحدة تحكم الحرف الهدف",
  T_48_META_API_82_P1_D: "تحديد الموقع",
  T_48_META_API_83_D: "احصل على العقدة الفرعية المحددة لكيان العقدة الأصلية المستهدفة بناءً على اسمها",
  T_48_META_API_83_P0_D: "كيان العقدة الأم",
  T_48_META_API_83_P1_D: "اسم العقدة الفرعية",
  T_48_META_API_83_R_D: "كيان العقدة الفرعية",
  T_48_META_API_84_D: "أضف اهتمامًا خاصًا إلى AOI، حيث تتم مزامنته دائمًا بغض النظر عن المسافة",
  T_48_META_API_84_P0_D: "أهداف ذات أهمية خاصة",
  T_48_META_API_84_P1_D: "المراقب",
  T_48_META_API_85_D: "قم بإزالة الاهتمام الخاص بـ AOI وإلغاء مزامنة AOI البعيدة عن الأنظار",
  T_48_META_API_85_P0_D: "أهداف ذات أهمية خاصة",
  T_48_META_API_85_P1_D: "المراقب",
  T_48_META_API_86_D: "مسح كل AOI للهدف المحدد",
  T_48_META_API_86_P0_D: "أهداف ذات أهمية خاصة",
  T_48_META_API_87_D: "تحديد ما إذا كان هناك اهتمام خاص بالهيئة العربية للتصنيع",
  T_48_META_API_87_P0_D: "أهداف ذات أهمية خاصة",
  T_48_META_API_87_P1_D: "مهمل",
  T_48_META_API_87_R_D: "هل يوجد",
  T_48_META_API_88_D: "تبديل المراقب الوكيل للاعب",
  T_48_META_API_88_P0_D: "لاعب",
  T_48_META_API_88_P1_D: "مراقب الوكيل",
  T_48_META_API_89_D: "قم بتبديل وحدة التحكم في الشخصية مرة واحدة إذا كان ذلك يؤثر على اللاعب، فيجب على اللاعب تشغيل وحدة التحكم في اللاعب التي تستخدم التأثيرات المادية حتى تصبح سارية المفعول.",
  T_48_META_API_89_P0_D: "الكائن المستهدف، إذا كان لاعبًا، يجب على اللاعب تشغيل وحدة تحكم اللاعب باستخدام الفيزياء حتى يصبح التأثير ساري المفعول",
  T_48_META_API_89_P1_D: "ناقلات النزوح",
  T_48_META_API_9_D: "قم بإيقاف تشغيل آلية المنطقة الآمنة عندما يتم تقليل المنطقة الآمنة إلى الحد الأدنى، سيستمر تعرض اللاعبين خارج المنطقة الآمنة للأذى. بعد إيقاف تشغيل آلية المنطقة الآمنة، سيكون اللاعبون آمنين مرة أخرى.",
  T_48_META_API_90_D: "قم بتعيين ما إذا كان بإمكان اللاعبين الخروج بحرية",
  T_48_META_API_90_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_90_P1_D: "هل من الممكن الخروج بحرية؟",
  T_48_META_API_9000_D: "قم بإنشاء واجهة مستخدم مضمنة يمكن للاعبين المعينين فقط رؤيتها",
  T_48_META_API_9000_P0_D: "تم إنشاء كيانات واجهة المستخدم المضمنة",
  T_48_META_API_9000_P1_D: "كيان المشغل الذي تنتمي إليه واجهة المستخدم، يكون مرئيًا لهذا اللاعب فقط",
  T_48_META_API_9000_P2_D: "أنواع واجهة المستخدم المضمنة",
  T_48_META_API_9001_D: "قم بإزالة واجهة مستخدم اللعبة المضمنة",
  T_48_META_API_9001_P0_D: "كيان واجهة المستخدم المدمج المراد إزالته",
  T_48_META_API_9002_D: "قم بإنشاء رمز باستخدام نوع الرمز المحدد إذا كان هناك المزيد من الخصائص التي تحتاج إلى تعيين، فقم أيضًا بتعيين خصائص الكيان الخاصة به من خلال الكيان (قديم، يرجى استخدام CreateLevelObject).",
  T_48_META_API_9002_P0_D: "يتم استخدام الكود لتمثيل اسم المعلمة الرسمية التي تنشئ كيان الأيقونة، وقيمة المتغير المحلي المقابلة له هي الكيان الذي ينشئ الأيقونة.",
  T_48_META_API_9002_P1_D: "كيان اللاعب الذي ينتمي إليه، مرئي فقط لهذا اللاعب",
  T_48_META_API_9002_P2_D: "مسار المورد، مسار المورد المتوافق مع الأيقونة التي حددها اللاعب",
  T_48_META_API_9003_D: "قم بإزالة الرمز المحدد (مهمل، يرجى استخدام RemoveEntity)",
  T_48_META_API_9003_P0_D: "كيان الرمز المطلوب إزالته",
  T_48_META_API_9004_D: "قم بإنشاء نص باستخدام محتوى النص المحدد. إذا كان هناك المزيد من الخصائص التي تحتاج إلى تعيين، فقم أيضًا بتعيين خصائص الكيان الخاص به من خلال الكيان (قديم، يرجى استخدام CreateLevelObject).",
  T_48_META_API_9004_P0_D: "يتم استخدام الكود لتمثيل اسم المعلمة الرسمية التي تقوم بإنشاء كيان النص، وقيمة المتغير المحلي المقابلة له هي الكيان الذي يقوم بإنشاء النص.",
  T_48_META_API_9004_P1_D: "كيان اللاعب الذي ينتمي إليه، مرئي فقط لهذا اللاعب",
  T_48_META_API_9004_P2_D: "محتوى النص الذي سيتم تقديمه",
  T_48_META_API_9005_D: "إزالة النص المحدد (مهمل، يرجى استخدام RemoveEntity)",
  T_48_META_API_9005_P0_D: "كيان النص المراد إزالته",
  T_48_META_API_9006_D: "قم بإنشاء رمز باستخدام نوع التأثير المحدد إذا كان هناك المزيد من الخصائص التي تحتاج إلى تعيين، فقم أيضًا بتعيين خصائص الكيان الخاصة بها من خلال الكيان (قديم، يرجى استخدام CreateEffect)",
  T_48_META_API_9006_P0_D: "يتم استخدام الكود لتمثيل اسم المعلمة الرسمية التي تنشئ كيان التأثير الخاص، وقيمة المتغير المحلي المقابلة لها هي الكيان الذي ينشئ التأثير الخاص.",
  T_48_META_API_9006_P1_D: "كيان اللاعب الذي ينتمي إليه، مرئي فقط لهذا اللاعب",
  T_48_META_API_9006_P2_D: "نوع التأثير الخاص، نوع المؤثرات الخاصة التي يمكن للاعبين اختيارها",
  T_48_META_API_9007_D: "إزالة التأثير المحدد (مهمل، يرجى استخدام RemoveEntity)",
  T_48_META_API_9007_P0_D: "كيان التأثير المراد إزالته",
  T_48_META_API_9008_D: "قم بإنشاء واجهة مستخدم مخصصة يمكن للاعبين المعينين فقط رؤيتها",
  T_48_META_API_9008_P0_D: "تم إنشاء كيانات واجهة المستخدم المخصصة",
  T_48_META_API_9008_P1_D: "كيان المشغل الذي تنتمي إليه واجهة المستخدم، يكون مرئيًا لهذا اللاعب فقط",
  T_48_META_API_9008_P2_D: "مؤشر واجهة المستخدم المخصصة",
  T_48_META_API_9009_D: "إزالة واجهة المستخدم المخصصة للعبة",
  T_48_META_API_9009_P0_D: "كيان واجهة المستخدم المخصص المراد إزالته",
  T_48_META_API_9010_D: "احصل على عناصر تحكم واجهة المستخدم من واجهة المستخدم المخصصة",
  T_48_META_API_9010_P0_D: "كيان اللاعب الذي تنتمي إليه واجهة المستخدم",
  T_48_META_API_9010_P1_D: "كيانات واجهة المستخدم المخصصة",
  T_48_META_API_9010_P2_D: "التحكم في الفهرس الفريد",
  T_48_META_API_9010_R_D: "كيان التحكم في واجهة المستخدم",
  T_48_META_API_9011_D: "تشغيل التأثير الصوتي المحدد إذا كان هناك المزيد من الخصائص التي تحتاج إلى تعيين، فقم أيضًا بتعيين خصائص الكيان الخاص به من خلال الكيان (قديم، يرجى استخدام CreateSound).",
  T_48_META_API_9011_P0_D: "يتم استخدام الكود لتمثيل اسم المعلمة الرسمية التي تنشئ كيان التأثير الصوتي، وقيمة المتغير المحلي المقابلة لها هي الكيان الذي ينشئ التأثير الصوتي.",
  T_48_META_API_9011_P1_D: "كيان اللاعب الذي ينتمي إليه، مرئي فقط لهذا اللاعب",
  T_48_META_API_9011_P2_D: "نوع التأثير الصوتي، نوع المؤثرات الصوتية التي يمكن للاعبين اختيارها",
  T_48_META_API_9012_D: "إزالة التأثير الصوتي المحدد (مهمل، يرجى استخدام RemoveEntity)",
  T_48_META_API_9012_P0_D: "كيان الصوت المراد إزالته",
  T_48_META_API_9013_D: "احصل على عنصر تحكم في واجهة المستخدم باستخدام المسار من واجهة المستخدم المخصصة",
  T_48_META_API_9013_P0_D: "كيان اللاعب الذي تنتمي إليه واجهة المستخدم",
  T_48_META_API_9013_P1_D: "واجهة مستخدم مخصصة",
  T_48_META_API_9013_P2_D: "مسار التحكم",
  T_48_META_API_9013_R_D: "كيان التحكم في واجهة المستخدم",
  T_48_META_API_9014_D: "مقاطعة كيان تشغيل الصوت (مهمل، يرجى استخدام PauseSound)",
  T_48_META_API_9014_P0_D: "كيان التأثير الصوتي الذي يجب إيقافه مؤقتًا",
  T_48_META_API_9015_D: "الاستمرار في تشغيل التأثير الصوتي، يمكنك اختيار ما إذا كنت تريد بدء التشغيل من البداية (قديم، يرجى استخدام ResumeSound)",
  T_48_META_API_9015_P0_D: "كيانات التأثير الصوتي التي تحتاج إلى مواصلة التشغيل بعد إيقافها مؤقتًا",
  T_48_META_API_9015_P1_D: "ما إذا كان يجب البدء من الصفر",
  T_48_META_API_9016_D: "إنشاء عناصر تحكم مخصصة لواجهة المستخدم",
  T_48_META_API_9016_P0_D: "تم إنشاء كيان تحكم مخصص",
  T_48_META_API_9016_P1_D: "نوع التحكم الذي تم إنشاؤه",
  T_48_META_API_9016_P2_D: "ينتمي إلى كيان واجهة المستخدم",
  T_48_META_API_9016_P3_D: "عنصر التحكم الأصلي الذي ينتمي إليه، إذا تم تركه فارغًا، فسيكون كيان واجهة المستخدم الذي ينتمي إليه هو العقدة الأصلية.",
  T_48_META_API_9017_D: "قم بتعيين قناع طبقة الكاميرا المستهدفة",
  T_48_META_API_9017_P0_D: "كيان الكاميرا المستهدفة",
  T_48_META_API_9017_P1_D: "قناع الطبقة، سيتم عرض الطبقات المملوءة فقط في الكاميرا المستهدفة، وتركها فارغة يعني أنه سيتم عرض جميع الطبقات.",
  T_48_META_API_9018_D: "احصل على قناع طبقة الكاميرا المستهدفة",
  T_48_META_API_9018_P0_D: "كيان الكاميرا المستهدفة",
  T_48_META_API_9018_R_D: "قناع الطبقة، سيتم عرض الطبقات الموجودة داخل قناع الطبقة فقط في الكاميرا المستهدفة",
  T_48_META_API_9019_D: "قم بتعيين ما إذا كان المستوى المحدد مرئيًا للكاميرا المستهدفة",
  T_48_META_API_9019_P0_D: "كيان الكاميرا المستهدفة",
  T_48_META_API_9019_P1_D: "مستوى الرؤية",
  T_48_META_API_9019_P2_D: "مرئية أم لا",
  T_48_META_API_9020_D: "قم بتعيين حالة رؤية الواجهة الافتراضية للاعب المستهدف",
  T_48_META_API_9020_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_9020_P1_D: "نوع واجهة المشغل نوع واجهة المشغل هو أحد عناصر واجهة المستخدم المستخدمة للتحكم في اللاعبين والمحتوى المتعلق باللاعب.",
  T_48_META_API_9020_P2_D: "تحدد قيمة التبديل رؤية واجهة المشغل.",
  T_48_META_API_9021_D: "إنشاء سلسلة الطابع الزمني المترجمة",
  T_48_META_API_9021_P0_D: "الطابع الزمني",
  T_48_META_API_9021_P1_D: "أسلوب التنسيق",
  T_48_META_API_9021_R_D: "سلسلة توطين الطابع الزمني",
  T_48_META_API_9022_D: "إنشاء أيقونة الصورة المصغرة",
  T_48_META_API_9022_P0_D: "تم إنشاء كيان رمز الخريطة المصغرة",
  T_48_META_API_9022_P1_D: "ينتمي رمز الخريطة المصغرة الذي تم إنشاؤه إلى هذا اللاعب فقط.",
  T_48_META_API_9022_P2_D: "مسار موارد أيقونة الخريطة المصغرة",
  T_48_META_API_9023_D: "قم بإنشاء أيقونة باستخدام نوع التأثير الخاص المحدد إذا كان هناك المزيد من الخصائص التي تحتاج إلى تعيين، فقم أيضًا بتعيين خصائص الكيان الخاصة بها من خلال الكيان.",
  T_48_META_API_9023_P0_D: "يتم استخدام الكود لتمثيل اسم المعلمة الرسمية التي تنشئ كيان التأثير الخاص، وقيمة المتغير المحلي المقابلة لها هي الكيان الذي ينشئ التأثير الخاص.",
  T_48_META_API_9023_P1_D: "كيان اللاعب الذي ينتمي إليه، مرئي فقط لهذا اللاعب",
  T_48_META_API_9023_P2_D: "نوع التأثير الخاص، نوع المؤثرات الخاصة التي يمكن للاعبين اختيارها",
  T_48_META_API_9024_D: "إزالة التأثير المحدد (مهمل، يرجى استخدام RemoveEntity)",
  T_48_META_API_9024_P0_D: "كيان التأثير المراد إزالته",
  T_48_META_API_9025_D: "قم بإنشاء وحدات بكسل ثابتة على الخريطة للكائن المستهدف. لن تتحرك وحدات البكسل الثابتة مع الكائن المستهدف.",
  T_48_META_API_9025_P0_D: "تم إنشاء كيان بكسل ثابت",
  T_48_META_API_9025_P1_D: "ينتمي البكسل الثابت الذي تم إنشاؤه إلى اللاعب فقط",
  T_48_META_API_9025_P2_D: "كيان الكائن المستهدف",
  T_48_META_API_9026_D: "احصل على كيان الخريطة المصغرة للاعب المستهدف",
  T_48_META_API_9026_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_9026_R_D: "الخريطة المصغرة للاعب الحالي",
  T_48_META_API_9027_D: "ضبط الضرر الناتج عن سقوط اللاعب. يمكن ضبط الضرر المختلف وفقًا للارتفاع.",
  T_48_META_API_9027_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_9027_P1_D: "قائمة مجزأة للغاية",
  T_48_META_API_9027_P2_D: "قائمة أجزاء الضرر",
  T_48_META_API_91_D: "ستؤدي إضافة الهدف إلى الفريق المحدد إلى مغادرة الهدف للفريق الأصلي.",
  T_48_META_API_91_P0_D: "الأهداف التي يجب إضافتها للفريق",
  T_48_META_API_91_P1_D: "فرق للانضمام",
  T_48_META_API_91_P2_D: "هل هو ناجح؟",
  T_48_META_API_92_D: "ستؤدي إضافة الهدف إلى فريق جديد إلى مغادرة الهدف للفريق الأصلي.",
  T_48_META_API_92_P0_D: "الأهداف التي يجب إضافتها للفريق",
  T_48_META_API_92_P1_D: "اسم الفريق الجديد",
  T_48_META_API_92_P2_D: "هل هو ناجح؟",
  T_48_META_API_94_D: "تعيين قيمة متغير محلي حسب الفهرس؛ قبل التعيين، يجب تعريف المتغير في عملية الاستدعاء الحالية",
  T_48_META_API_94_P0: "فِهرِس",
  T_48_META_API_94_P0_D: "الحصول على متغير حسب الفهرس",
  T_48_META_API_94_P1: "قيمة المتغير",
  T_48_META_API_94_P1_D: "قيمة المتغير المستهدفة",
  T_48_META_API_94_P2: "نوع الحساب",
  T_48_META_API_94_P2_D: "طريقة التشغيل؛ تدعم جميع الأنواع التعيين، وتدعم الأنواع الرقمية أيضًا عمليات الزيادة والنقصان والضرب والقسمة والمعامل",
  T_48_META_API_94_P3: "اسم المتغير",
  T_48_META_API_94_P3_D: "اسم المتغير المستهدف. يستخدم فقط لإخراج الخطأ",
  T_48_META_API_95: "الحصول على متغير محلي حسب الفهرس",
  T_48_META_API_95_D: "الحصول على قيمة متغير محلي؛ قبل الحصول عليه، يجب تعريف المتغير في عملية الاستدعاء الحالية",
  T_48_META_API_95_P0: "فِهرِس",
  T_48_META_API_95_P0_D: "مؤشر المتغير",
  T_48_META_API_95_P1: "اسم المتغير",
  T_48_META_API_95_P1_D: "اسم المتغير المستهدف. يستخدم فقط لإخراج الخطأ",
  T_48_META_API_9500_D: "قم بإخطار عميل اللاعب المستهدف لتشغيل المؤثرات الخاصة",
  T_48_META_API_9500_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_9500_P1_D: "مسار موارد المؤثرات الخاصة",
  T_48_META_API_9500_P2_D: "لون",
  T_48_META_API_9500_P3_D: "حجم التكبير، الافتراضي هو 1",
  T_48_META_API_9500_P4_D: "كائن ملزم، سيتم إرفاق المؤثرات الخاصة كعقد فرعية له",
  T_48_META_API_9500_P5_D: "إزاحة الإحداثيات العالمية بالنسبة للكائن المنضم",
  T_48_META_API_9501_D: "يخطر عميل اللاعب المستهدف لتشغيل مؤثر صوتي",
  T_48_META_API_9501_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_9501_P1_D: "نوع التأثير الصوتي",
  T_48_META_API_9502_D: 'قم بإعلام عميل اللاعب المستهدف لعرض كلمة "عائم"',
  T_48_META_API_9502_P0_D: "اللاعبين المستهدفين",
  T_48_META_API_9502_P1_D: "محتوى بياوزي",
  T_48_META_API_9502_P2_D: "لون الكلمة العائمة، النوع هو اللون",
  T_48_META_API_9502_P3_D: "مدة الأحرف العائمة بالمللي ثانية",
  T_48_META_API_9503_D: "يؤدي إلى قيام الوحدة المستهدفة بتشغيل تعبير إجراء رقصة مرة واحدة",
  T_48_META_API_9503_P0_D: "الهدف من اللعب Emote",
  T_48_META_API_9503_P1_D: "نوع التعبيرات",
  T_48_META_API_9504_D: "إيقاف مؤقت/استئناف تعبير الإجراء التعبيري الخاص بالوحدة",
  T_48_META_API_9504_P0_D: "إيقاف مؤقت/استئناف أهداف التعبير التعبيري",
  T_48_META_API_9504_P1_D: "صحيح: إيقاف التشغيل مؤقتًا، خطأ: استئناف التشغيل",
  T_48_META_EVT_1_D: "يتم تشغيله عند بدء اللعبة، وسيكون الخادم جاهزًا في وقت أبكر من العميل",
  T_48_META_EVT_10_D: "يتم التشغيل قبل أن يتعرض الكيان الحالي للضرر",
  T_48_META_EVT_10_P0_D: "قد يكون كيان المهاجم فارغًا",
  T_48_META_EVT_10_P1_D: "نوع الضرر",
  T_48_META_EVT_10_P2_D: "حجم الأضرار الناجمة",
  T_48_META_EVT_10_P3_D: "الجزء المصاب",
  T_48_META_EVT_1000_D: "يتم تشغيله عندما تتغير نقاط اللاعب",
  T_48_META_EVT_1000_P0_D: "اللاعبون الذين تغيرت نقاطهم",
  T_48_META_EVT_1000_P1_D: "نوع نقاط التغيير",
  T_48_META_EVT_1000_P2_D: "القيمة التكاملية بعد التغيير التكاملي",
  T_48_META_EVT_1001_D: "يتم تشغيله عند تغيير نقاط الفريق",
  T_48_META_EVT_1001_P0_D: "الفرق التي لديها نقاط التغييرات",
  T_48_META_EVT_1001_P1_D: "نوع نقاط التغيير",
  T_48_META_EVT_1001_P2_D: "القيمة التكاملية بعد التغيير التكاملي",
  T_48_META_EVT_1002_D: "يتم تشغيله عندما يتغير ترتيب اللاعب",
  T_48_META_EVT_1002_P0_D: "اللاعبون الذين يتغير ترتيبهم",
  T_48_META_EVT_1002_P1_D: "الترتيب بعد تغيير الترتيب",
  T_48_META_EVT_1003_D: "مهمل",
  T_48_META_EVT_1003_P0_D: "مهمل",
  T_48_META_EVT_1003_P1_D: "الترتيب بعد تغيير الترتيب",
  T_48_META_EVT_11_D: "يتم تشغيله عندما يخرج اللاعب في منتصف اللعبة",
  T_48_META_EVT_11_P0_D: "اللاعب الذي خرج في منتصف اللعبة",
  T_48_META_EVT_12_D: "يتم تشغيله عندما تلمس وحدة تحكم المشغل كيانًا، وسيتم تشغيله فقط عندما تتحرك وحدة التحكم بشكل نشط.",
  T_48_META_EVT_12_P0_D: "الكيانات التي واجهتها",
  T_48_META_EVT_13_D: "يتم تشغيلها قبل أن يتسبب الكيان الحالي في حدوث ضرر",
  T_48_META_EVT_13_P0_D: "الكيان يتلقى الضرر",
  T_48_META_EVT_13_P1_D: "نوع الضرر",
  T_48_META_EVT_13_P2_D: "حجم الأضرار الناجمة",
  T_48_META_EVT_13_P3_D: "الجزء المصاب",
  T_48_META_EVT_14_D: "يتم تشغيله في كل مرة يتكرر فيها الكيان القابل للتشغيل عندما يكون الكيان القابل للتشغيل مؤثرًا صوتيًا أو مؤثرًا خاصًا وما إلى ذلك، فإن هذا الحدث يسري مفعوله على العميل فقط.",
  T_48_META_EVT_2_D: "يتم تشغيله عند تحديث الإطار المنطقي، وسيختلف تكرار تشغيل هذا الحدث وفقًا للنظام الأساسي والإعدادات.",
  T_48_META_EVT_2002_D: "يتم تشغيله عندما يموت اللاعب",
  T_48_META_EVT_2002_P0_D: "لاعب ميت",
  T_48_META_EVT_2003_D: "يتم تشغيله عندما يساعد اللاعب",
  T_48_META_EVT_2003_P0_D: "اللاعبون الذين تلقوا تمريرات حاسمة",
  T_48_META_EVT_2003_P1_D: "اللاعب المقتول",
  T_48_META_EVT_2004_D: "يتم تشغيله عندما يتسبب اللاعب في حدوث ضرر",
  T_48_META_EVT_2004_P0_D: "اللاعب الذي تسبب في الضرر",
  T_48_META_EVT_2004_P1_D: "اللاعبون الذين تعرضوا للأذى",
  T_48_META_EVT_2004_P2_D: "نوع الضرر",
  T_48_META_EVT_2004_P3_D: "ضرر",
  T_48_META_EVT_2004_P4_D: "الجزء المصاب",
  T_48_META_EVT_2005_D: "يتم تشغيله عندما يتسبب اللاعب في القتل",
  T_48_META_EVT_2005_P0_D: "اللاعب الذي تسبب في القتل",
  T_48_META_EVT_2005_P1_D: "اللاعب المقتول",
  T_48_META_EVT_2005_P2_D: "نوع الضرر",
  T_48_META_EVT_2006_D: "يتم تشغيله عندما ينضم اللاعب إلى اللعبة",
  T_48_META_EVT_2006_P0_D: "اللاعبون الذين ينضمون إلى اللعبة",
  T_48_META_EVT_2007_D: "يتم تشغيله عند إحياء اللاعب",
  T_48_META_EVT_2007_P0_D: "لاعب متجدد",
  T_48_META_EVT_2007_P1_D: "مصدر القيامة",
  T_48_META_EVT_2008_D: "يتم تشغيله عندما يتم إسقاط اللاعب",
  T_48_META_EVT_2008_P0_D: "لاعب سقط",
  T_48_META_EVT_2008_P1_D: "اللاعب المهاجم",
  T_48_META_EVT_2009_D: "يتم إطلاقه عند قطع اتصال اللاعب",
  T_48_META_EVT_2009_P0_D: "لاعب غير متصل",
  T_48_META_EVT_2010_D: "يتم إطلاقه عند إعادة اتصال اللاعب",
  T_48_META_EVT_2010_P0_D: "إعادة ربط اللاعبين",
  T_48_META_EVT_2100_D: "يتم تشغيله عند إزالة الفريق",
  T_48_META_EVT_2100_P0_D: "تمت إزالة الفريق",
  T_48_META_EVT_2101_D: "يتم تشغيله عند إضافة فريق",
  T_48_META_EVT_2101_P0_D: "الفرق المضافة",
  T_48_META_EVT_2102_D: "يتم تشغيله عندما يتم تدمير الفريق",
  T_48_META_EVT_2102_P0_D: "الفريق الذي تم القضاء عليه",
  T_48_META_EVT_3_D: "يتم إطلاقه عند انتهاء اللعبة. يتم إطلاق هذا الحدث قبل انتهاء اللعبة على الخادم.",
  T_48_META_EVT_30_D: "يتم تشغيله عند تحميل المشهد بنجاح",
  T_48_META_EVT_30_P0_D: "اسم المشهد",
  T_48_META_EVT_3000_D: "يتم التشغيل بعد إنشاء الكيان الحالي",
  T_48_META_EVT_3001_D: "يتم تشغيله قبل تدمير الكيان الحالي",
  T_48_META_EVT_3002_D: "يتم إطلاقه عندما يدخل اللاعب إلى الزناد",
  T_48_META_EVT_3002_P0_D: "لاعب يدخل الزناد",
  T_48_META_EVT_3003_D: "يتم إطلاقه عندما يترك اللاعب الزناد",
  T_48_META_EVT_3003_P0_D: "لاعب ترك الزناد",
  T_48_META_EVT_3004_D: "تم إطلاقه بعد النقر فوق زر التحكم في واجهة المستخدم",
  T_48_META_EVT_3004_P0_D: "اللاعب الذي نقر",
  T_48_META_EVT_3005_D: "يتم تشغيله عند النقر فوق زر في واجهة المستخدم المضمنة",
  T_48_META_EVT_3005_P0_D: "اسم زر التحكم الذي تم النقر عليه",
  T_48_META_EVT_3006_D: "يتم تشغيله عندما يستخدم اللاعب لوح التزلج",
  T_48_META_EVT_3007_D: "يتم التشغيل بعد أن يصبح الكيان الحالي متاحًا",
  T_48_META_EVT_3008_D: "يتم التشغيل بعد عدم توفر الكيان الحالي",
  T_48_META_EVT_3009_D: "يتم تشغيله عند دخول كيان إلى مشغل. عند تشغيل حدث مشغل، يتلقى كلا الطرفين الحدث. يجب أن يكون أحد الطرفين جسمًا صلبًا ويجب أن يكون الطرف الآخر مشغلًا. على وجه الخصوص، عندما يكون المشغل كائن مشغل مخصص، سيتلقى المشغل الحدث فقط.",
  T_48_META_EVT_3009_P0_D: "كيان الطرف المقابل عند وقوع الحدث المحفز",
  T_48_META_EVT_3010_D: "يتم تشغيله عندما يترك الكيان المشغل. عند تشغيل الحدث، يتلقى كلا الطرفين الحدث. يجب أن يكون أحد الطرفين جسمًا صلبًا ويجب أن يكون الطرف الآخر مشغلًا. على وجه الخصوص، عندما يكون المشغل كائن مشغل مخصص، سيتلقى المشغل الحدث فقط.",
  T_48_META_EVT_3010_P0_D: "كيان الطرف المقابل عند وقوع الحدث المحفز",
  T_48_META_EVT_3011_D: "يتم تشغيله بعد تدمير الكيان الحالي",
  T_48_META_EVT_3011_P0_D: "قد يكون كيان المهاجم فارغًا",
  T_48_META_EVT_3011_P1_D: "نوع الضرر",
  T_48_META_EVT_3011_P2_D: "الجزء المصاب",
  T_48_META_EVT_3012_D: "يتم تشغيله بعد مهاجمة الكيان الحالي",
  T_48_META_EVT_3012_P0_D: "قد يكون كيان المهاجم فارغًا",
  T_48_META_EVT_3012_P1_D: "نوع الضرر",
  T_48_META_EVT_3012_P2_D: "حجم الأضرار الناجمة",
  T_48_META_EVT_3012_P3_D: "الجزء المصاب",
  T_48_META_EVT_3013_D: "يتم تشغيله بعد أن يتسبب الكيان الحالي في حدوث ضرر",
  T_48_META_EVT_3013_P0_D: "الكيان يتلقى الضرر",
  T_48_META_EVT_3013_P1_D: "نوع الضرر",
  T_48_META_EVT_3013_P2_D: "حجم الأضرار الناجمة",
  T_48_META_EVT_3013_P3_D: "الجزء المصاب",
  T_48_META_EVT_3014_D: "يتم تشغيله بعد قيام الكيان الحالي بتدمير الكيانات الأخرى",
  T_48_META_EVT_3014_P0_D: "الكيان المدمر",
  T_48_META_EVT_3014_P1_D: "الجزء المصاب",
  T_48_META_EVT_3015_D: "يتم تشغيله عند إحياء اللاعب",
  T_48_META_EVT_3015_P0_D: "نوع مصدر قيامة اللاعب",
  T_48_META_EVT_3016_D: "يتم تشغيله عندما يقوم المولد بإنشاء كيان",
  T_48_META_EVT_3016_P0_D: "قائمة الكيانات التي تم إنشاؤها",
  T_48_META_EVT_3016_P1_D: "رقم الموجة",
  T_48_META_EVT_3017_D: "يتم استدعاؤه عندما يدخل اللاعب في وضعية الركوع القاضية",
  T_48_META_EVT_3018_D: "يتم تشغيله عندما يموت جميع أعضاء الفريق",
  T_48_META_EVT_3019_D: "يتم تشغيله عندما يكون مزودًا بخوذة أو درع للجسم أو حقيبة ظهر",
  T_48_META_EVT_3019_P0_D: "معرف المعدات",
  T_48_META_EVT_3020_D: "يتم تشغيله عند الإمساك بسلاح أساسي أو ثانوي أو سلاح مشاجرة، بما في ذلك عند التبديل إلى القبضة",
  T_48_META_EVT_3020_P0_D: "كيان السلاح المجهز عند إطلاقه",
  T_48_META_EVT_3021_D: "يتم تشغيلها بعد استخدام الدعامة التي تتطلب وقتًا، وستؤدي إلى تشغيل هذا الحدث بعد الانتهاء من الاستخدام.",
  T_48_META_EVT_3021_P0_D: "معرف الدعامة",
  T_48_META_EVT_3021_P1_D: "كيان الدعامة، قد يكون فارغًا",
  T_48_META_EVT_3021_P2_D: "قد يكون كيان الخاصية الجديد الذي تم إنشاؤه باستخدام الخاصيات فارغًا",
  T_48_META_EVT_3022_D: "يتم تشغيله عند الحصول على عنصر",
  T_48_META_EVT_3022_P0_D: "نوع العنصر",
  T_48_META_EVT_3022_P1_D: "قد يكون كيان العنصر فارغًا",
  T_48_META_EVT_3023_D: "يتم تشغيله عندما تتغير نقاط الكيان",
  T_48_META_EVT_3023_P0_D: "نوع نقاط التغيير",
  T_48_META_EVT_3023_P1_D: "القيمة التكاملية بعد التغيير التكاملي",
  T_48_META_EVT_3024_D: "يتم تشغيله عندما يتغير ترتيب الكيان",
  T_48_META_EVT_3024_P0_D: "الترتيب بعد تغيير الترتيب",
  T_48_META_EVT_3025_D: "أثار على المساعدة",
  T_48_META_EVT_3025_P0_D: "الكائن الذي قتل",
  T_48_META_EVT_3026_D: "يتم تشغيله عندما يدخل كيان إلى مركبة، بما في ذلك كسائق وراكب",
  T_48_META_EVT_3026_P0_D: "دخول الكيان إلى السيارة",
  T_48_META_EVT_3026_P1_D: "دخول المركبة",
  T_48_META_EVT_3027_D: "يتم تشغيله عندما يغادر الكيان السيارة",
  T_48_META_EVT_3027_P0_D: "مغادرة الكيان للمركبة",
  T_48_META_EVT_3027_P1_D: "المركبة المغادرة",
  T_48_META_EVT_3028_D: "يتم تشغيله عندما يقود الكيان السيارة وهو السائق في السيارة.",
  T_48_META_EVT_3028_P0_D: "الجهة التي تقود المركبة",
  T_48_META_EVT_3028_P1_D: "قيادة السيارة",
  T_48_META_EVT_3029_D: "يتم تشغيله عندما يتم إدخال السيارة بواسطة كيان",
  T_48_META_EVT_3029_P0_D: "كيان الزناد",
  T_48_META_EVT_3030_D: "يتم تشغيله عند مغادرة كيان المركبة",
  T_48_META_EVT_3030_P0_D: "كيان الزناد",
  T_48_META_EVT_3031_D: "يتم تشغيله عندما يتم قيادة السيارة بواسطة كيان",
  T_48_META_EVT_3031_P0_D: "كيان الزناد",
  T_48_META_EVT_3032_D: "يتم تشغيله بعد أن يستخدم الكيان البوابة الإلكترونية للانتقال الفوري (قديم، يرجى استخدام OnBouncesOffTire)",
  T_48_META_EVT_3032_P0_D: "الجهات التي تستخدم البوابات",
  T_48_META_EVT_3032_P1_D: "البوابة المستخدمة",
  T_48_META_EVT_3033_D: "يتم تشغيله عندما يرتد الكيان",
  T_48_META_EVT_3033_P0_D: "كيان الزناد",
  T_48_META_EVT_3033_P1_D: "الكائن المرتد المستخدم",
  T_48_META_EVT_3034_D: "يتم تشغيله بعد قيام البوابة بنقل الكيان فوريًا",
  T_48_META_EVT_3034_P0_D: "الجهة المرسلة",
  T_48_META_EVT_3035_D: "يتم تشغيله بعد أن يرتد الإطار إلى الكيان",
  T_48_META_EVT_3035_P0_D: "الكيان المرتد",
  T_48_META_EVT_3036_D: "يتم تشغيله عندما تضرب الآلية الكيان في الهواء",
  T_48_META_EVT_3036_P0_D: "الكيانات التي تم طردها",
  T_48_META_EVT_3036_P1_D: "الأجسام الميكانيكية",
  T_48_META_EVT_3037_D: "يتم إطلاقه عندما يدخل كيان إلى المشغل",
  T_48_META_EVT_3037_P0_D: "مشغل الدخول",
  T_48_META_EVT_3038_D: "يتم إطلاقه عندما يترك الكيان الزناد",
  T_48_META_EVT_3038_P0_D: "مشغل المغادرة",
  T_48_META_EVT_3039_D: "يتم تشغيله عند الحصول على كيان سلاح",
  T_48_META_EVT_3039_P0_D: "كيان السلاح",
  T_48_META_EVT_3040_D: "يتم تشغيله عندما يتم طرد الكيان بواسطة آلية",
  T_48_META_EVT_3040_P0_D: "الكيانات التي تم طردها",
  T_48_META_EVT_3040_P1_D: "الأجسام الميكانيكية",
  T_48_META_EVT_3041_D: "يتم تشغيله عند استهداف كيان قابل للاستهداف",
  T_48_META_EVT_3041_P0_D: "الكيان المستهدف",
  T_48_META_EVT_3042_D: "يتم تشغيلها عند استهدافها من قبل اللاعب",
  T_48_META_EVT_3042_P0_D: "اللاعب يأخذ الهدف",
  T_48_META_EVT_3043_D: "يتم تشغيله عندما تصيب الرصاصة الهدف",
  T_48_META_EVT_3043_P0_D: "ضرب الهدف",
  T_48_META_EVT_3043_P1_D: "الإحداثيات العالمية للمكان الذي أصابته الرصاصة",
  T_48_META_EVT_3044_D: "يتم تشغيله عند إصابته بسلاح",
  T_48_META_EVT_3044_P0_D: "الأسلحة",
  T_48_META_EVT_3044_P1_D: "الإحداثيات العالمية لمنطقة الضربة",
  T_48_META_EVT_3045_D: "يتم تشغيله عندما يختار اللاعب التحول إلى كائن في هذا المستوى",
  T_48_META_EVT_3045_P0_D: "يتحول اللاعب إلى كيان، وليس إلى كائن المشهد نفسه",
  T_48_META_EVT_3046_D: "يتم تشغيله عندما يعود اللاعب إلى الحياة عند نقطة العودة هذه",
  T_48_META_EVT_3046_P0_D: "تم إحياء اللاعبين في نقطة العودة هذه",
  T_48_META_EVT_3047_D: "يتم تشغيله عندما يسقط اللاعب سلاحًا",
  T_48_META_EVT_3047_P0_D: "كيان السلاح المهملة",
  T_48_META_EVT_3048_D: "يتم تشغيله عندما يسقط اللاعب عنصرًا آخر غير السلاح",
  T_48_META_EVT_3048_P0_D: "نوع العنصر",
  T_48_META_EVT_3048_P1_D: "قد يكون كيان العنصر فارغًا",
  T_48_META_EVT_3049_D: "يتم تشغيله عند ضربه بمسدس كرة القدم",
  T_48_META_EVT_3049_P0_D: "لاعب",
  T_48_META_EVT_3049_P1_D: "السرعة بعد تعرضها للضرب",
  T_48_META_EVT_3050_D: "يتم تشغيله عندما تصطدم كرة القدم بكيان",
  T_48_META_EVT_3050_P0_D: "كائن الاصطدام",
  T_48_META_EVT_3050_P1_D: "السرعة بعد الاصطدام",
  T_48_META_EVT_3051_D: "يتم تشغيله عندما ينضم اللاعب بنجاح إلى القناة الصوتية",
  T_48_META_EVT_3051_P0_D: "كيان القناة الصوتية",
  T_48_META_EVT_3052_D: "يتم تشغيله عندما يفشل اللاعب في الانضمام إلى القناة الصوتية",
  T_48_META_EVT_3052_P0_D: "كيان القناة الصوتية",
  T_48_META_EVT_3053_D: "يتم تشغيله عندما يخرج اللاعب من القناة الصوتية",
  T_48_META_EVT_3053_P0_D: "كيان القناة الصوتية",
  T_48_META_EVT_3054_D: "يتم تشغيله عندما تدخل كرة القدم المرمى",
  T_48_META_EVT_3054_P0_D: "هدف",
  T_48_META_EVT_3054_P1_D: "الهداف، آخر لاعب يلمس الكرة قبل التسجيل",
  T_48_META_EVT_3054_P2_D: "المساعد، اللاعب قبل الأخير الذي يلمس الكرة قبل دخولها المرمى",
  T_48_META_EVT_3055_D: "يتم تشغيله عندما يضغط اللاعب على زر إطلاق النار",
  T_48_META_EVT_3056_D: "يتم تشغيله عندما يقفز اللاعب",
  T_48_META_EVT_3057_D: "يتم تشغيله عندما يكون اللاعب جاثمًا",
  T_48_META_EVT_3058_D: "يتم تشغيله عندما يكون اللاعب منبطحًا",
  T_48_META_EVT_3059_D: "يتم تشغيله عندما يقوم اللاعب بسباقات السرعة",
  T_48_META_EVT_3060_D: "يتم تشغيله عند شراء أحد العناصر بنجاح في المتجر",
  T_48_META_EVT_3060_P0_D: "اللاعبون الذين يشترون البضائع",
  T_48_META_EVT_3060_P1_D: "سلعة",
  T_48_META_EVT_3061_D: "يتم تشغيله عندما يقوم اللاعب بتجهيز السلاح",
  T_48_META_EVT_3061_P0_D: "لاعبين مجهزين بالأسلحة",
  T_48_META_EVT_3062_D: "يتم تشغيله عندما تُقتل وحدة بهذا السلاح",
  T_48_META_EVT_3062_P0_D: "كيان مقتول",
  T_48_META_EVT_3063_D: "يتم تشغيله عند استخدام هذا السلاح لتدمير وحدة",
  T_48_META_EVT_3063_P0_D: "الجهة المتضررة",
  T_48_META_EVT_3063_P1_D: "ضرر",
  T_48_META_EVT_3064_D: "يتم تشغيله عندما يغير السلاح الرصاص",
  T_48_META_EVT_3065_D: "يتم تشغيله عند دخول كيان إلى السيارة، ويمكن تشغيل هذا الحدث كسائق أو راكب.",
  T_48_META_EVT_3065_P0_D: "دخول المركبة",
  T_48_META_EVT_3066_D: "يتم تشغيله عندما يغادر الكيان السيارة",
  T_48_META_EVT_3066_P0_D: "المركبة المغادرة",
  T_48_META_EVT_3067_D: "يتم تشغيله عندما يقود كيان مركبة",
  T_48_META_EVT_3067_P0_D: "قيادة السيارة",
  T_48_META_EVT_3068_D: "يتم تشغيله بعد انتقال كيان ما باستخدام البوابة",
  T_48_META_EVT_3068_P0_D: "البوابة المستخدمة",
  T_48_META_EVT_3069_D: "يتم تشغيله بعد ارتداد الكيان بواسطة الإطار",
  T_48_META_EVT_3069_P0_D: "الإطارات المستخدمة",
  T_48_META_EVT_3070_D: "يتم تشغيله عندما يتم طرد الكيان بواسطة آلية",
  T_48_META_EVT_3070_P0_D: "الأجسام الميكانيكية",
  T_48_META_EVT_3071_D: "يتم تشغيله بعد الضغط على زر التحكم في واجهة المستخدم بواسطة اللاعب",
  T_48_META_EVT_3071_P0_D: "لاعب الزناد",
  T_48_META_EVT_3072_D: "يتم التشغيل بعد رفع زر التحكم في واجهة المستخدم",
  T_48_META_EVT_3072_P0_D: "لاعب الزناد",
  T_48_META_EVT_3073_D: "يتم تشغيله بعد النقر المزدوج على زر واجهة المستخدم بواسطة اللاعب",
  T_48_META_EVT_3073_P0_D: "لاعب الزناد",
  T_48_META_EVT_3074_D: "تبدأ منطقة الهروب من السجن",
  T_48_META_EVT_3075_D: "نهاية منطقة الهروب من السجن",
  T_48_META_EVT_3076_D: "يتم تشغيله عندما يتوقف اللاعب عن استخدام لوح التزلج",
  T_48_META_EVT_3077_D: "يتم تشغيله عندما يقوم المشغل بتغيير محتوى النص الخاص بعنصر تحكم مربع إدخال واجهة المستخدم",
  T_48_META_EVT_3077_P0_D: "لاعب الزناد",
  T_48_META_EVT_3077_P1_D: "تم تغيير محتوى النص",
  T_48_META_EVT_3078_D: "يتم إطلاقه عندما يبدأ كيان قابل للتشغيل في اللعب",
  T_48_META_EVT_3078_P0_D: "كيان قابل للعب",
  T_48_META_EVT_3079_D: "يتم تشغيله عندما ينتهي الكيان القابل للتشغيل من التشغيل عندما يكون الكيان القابل للتشغيل مؤثرًا صوتيًا أو مؤثرًا خاصًا وما إلى ذلك، فإن هذا الحدث يسري على العميل فقط.",
  T_48_META_EVT_3079_P0_D: "كيان قابل للعب",
  T_48_META_EVT_3080_D: "يتم إطلاقه عندما يستمر الكيان القابل للتشغيل في اللعب",
  T_48_META_EVT_3080_P0_D: "كيان قابل للعب",
  T_48_META_EVT_3081_D: "يتم تشغيله عندما يقوم الكيان القابل للتشغيل بإيقاف التشغيل مؤقتًا",
  T_48_META_EVT_3081_P0_D: "كيان قابل للعب",
  T_48_META_EVT_3082_D: "ينضم لاعبو Jailbroken",
  T_48_META_EVT_3082_P0_D: "لاعب الزناد",
  T_48_META_EVT_3083_D: "خروج اللاعبين Jailbroken",
  T_48_META_EVT_3083_P0_D: "لاعب الزناد",
  T_48_META_EVT_3084_D: "الحرائق في نهاية العد التنازلي",
  T_48_META_EVT_3084_P0_D: "الكيان المالك",
  T_48_META_EVT_3085_D: "يتم تشغيله عند التقاط أحد العناصر",
  T_48_META_EVT_3085_P0_D: "اللاعب الذي التقط العنصر",
  T_48_META_EVT_3086_D: "يتم تشغيله عند إسقاط أحد العناصر",
  T_48_META_EVT_3086_P0_D: "اللاعب الذي أسقط العنصر",
  T_48_META_EVT_3087_D: "يتم تشغيله عندما يتم تجهيز هذا العنصر",
  T_48_META_EVT_3088_D: "يتم إطلاقه عندما يبدأ الكائن بعد إنشاء المنجم",
  T_48_META_EVT_3089_D: "يتم إطلاقه عندما يتم تشغيل الكائن بعد إنشاء اللغم",
  T_48_META_EVT_3089_P0_D: "قم بتشغيل هدف الكائن بعد إنشاء اللغم",
  T_48_META_EVT_3090_D: "يتم تشغيله قبل شراء العناصر في المتجر",
  T_48_META_EVT_3090_P0_D: "اللاعبون الذين يشترون البضائع",
  T_48_META_EVT_3090_P1_D: "سلعة",
  T_48_META_EVT_3091_D: "يتم تشغيله عندما يكون هذا الجهاز قيد الاستخدام",
  T_48_META_EVT_3092_D: "يتم تشغيله عند إطلاق النار من مسدس الكلاّب",
  T_48_META_EVT_3093_D: "يتم تشغيله عندما تنفجر القذيفة بعد رميها",
  T_48_META_EVT_3093_P0_D: "نقطة الانفجار",
  T_48_META_EVT_3094_D: "يتم تشغيله عند ضربه بمسدس رش",
  T_48_META_EVT_3094_P0_D: "كيان بندقية رش",
  T_48_META_EVT_3094_P1_D: "نقطة ضرب",
  T_48_META_EVT_3094_P2_D: "ضرب عادي",
  T_48_META_EVT_3095_D: "يتم تشغيله عند ضربه بمسدس الطلاء",
  T_48_META_EVT_3095_P0_D: "ضرب الكائن",
  T_48_META_EVT_3095_P1_D: "نقطة ضرب",
  T_48_META_EVT_3095_P2_D: "ضرب عادي",
  T_48_META_EVT_3096_D: "يتم تشغيله عند انفجار مركبة أو برميل صبغ",
  T_48_META_EVT_3096_P0_D: "اللاعب الذي تسبب في الانفجار",
  T_48_META_EVT_3096_P1_D: "قائمة اللاعبين المتأثرين بالانفجار",
  T_48_META_EVT_3097_D: "يطلق النار عندما يتوقف السلاح عن إطلاق النار",
  T_48_META_EVT_3097_P0_D: "كمية الذخيرة المتبقية في المجلة الحالية عند إيقاف إطلاق النار",
  T_48_META_EVT_3098_D: "يتم تشغيله عندما يدخل هدف المطاردة إلى نطاق المطاردة",
  T_48_META_EVT_3099_D: "يتم تشغيله عندما يغادر هدف المطاردة نطاق المطاردة",
  T_48_META_EVT_31_D: "يتم تشغيله عندما يكون تبديل المشهد ناجحًا",
  T_48_META_EVT_31_P0_D: "اسم المشهد",
  T_48_META_EVT_3100_D: "يتم تشغيله عندما يدخل هدف الهجوم إلى نطاق الهجوم",
  T_48_META_EVT_3101_D: "يتم تشغيله عندما يغادر هدف الهجوم نطاق الهجوم",
  T_48_META_EVT_3102_D: "يتم تشغيل هذا الحدث عندما يتم تشغيل اكتشاف شعاع الكاميرا عبر حدث نقر العميل",
  T_48_META_EVT_3102_P0_D: "لاعب الزناد",
  T_48_META_EVT_3102_P1_D: "ما إذا كان شعاع الكاميرا يضرب الجسم",
  T_48_META_EVT_3102_P2_D: "شعاع الكاميرا يضرب الموقع",
  T_48_META_EVT_3102_P3_D: "اتجاه كاميرا العميل",
  T_48_META_EVT_3102_P4_D: "موقف كاميرا العميل",
  T_48_META_EVT_3102_P5_D: "ضرب الكيان",
  T_48_META_EVT_3103_D: "يتم تشغيله عند فتح واجهة المتجر",
  T_48_META_EVT_3103_P0_D: "لاعب الزناد",
  T_48_META_EVT_3104_D: "يتم تشغيله عند إغلاق واجهة المتجر",
  T_48_META_EVT_3104_P0_D: "لاعب الزناد",
  T_48_META_EVT_3105_D: "يتم تشغيله عندما يدخل منطق شجرة السلوك إلى هذه العقدة",
  T_48_META_EVT_3105_P0_D: "اسم العقدة",
  T_48_META_EVT_3105_P1_D: "الكيان المالك",
  T_48_META_EVT_3106_D: "يتم تشغيله عند خروج منطق شجرة السلوك من العقدة",
  T_48_META_EVT_3106_P0_D: "اسم العقدة",
  T_48_META_EVT_3106_P1_D: "الكيان المالك",
  T_48_META_EVT_3107_D: "يتم تشغيله عندما يتم إيقاظ الجسم الصلب",
  T_48_META_EVT_3108_D: "يتم تحفيزه عندما يذهب الجسم الصلب إلى النوم",
  T_48_META_EVT_3109_D: "يتم تشغيله عندما يتحرك اللاعب",
  T_48_META_EVT_3109_P0_D: "سلوك",
  T_48_META_EVT_3110_D: "يتم تشغيله عندما يكون اللاعب خاملاً",
  T_48_META_EVT_3110_P0_D: "سلوك",
  T_48_META_EVT_3111_D: "يتم تشغيله عندما يستخدم اللاعب مهارة ما",
  T_48_META_EVT_3111_P0_D: "المهارات المستخدمة",
  T_48_META_EVT_3112_D: "يتم تشغيله عندما ينتهي اللاعب من الركض",
  T_48_META_EVT_3113_D: "يتم تشغيله عند الحصول على العنصر المطابق للفتحة ضمن تعداد SwitchEquipSlot",
  T_48_META_EVT_3113_P0_D: "تم الحصول على كيان العنصر",
  T_48_META_EVT_3114_D: "يتم تشغيله عند تبديل العناصر المحمولة باليد، بما في ذلك عند التبديل إلى القبضات",
  T_48_META_EVT_3114_P0_D: "كيان العنصر الذي تم الاحتفاظ به بعد التبديل",
  T_48_META_EVT_3115_D: "يتم تشغيله عندما يطلب أحد اللاعبين في المتجر من الآخرين شراء البضائع",
  T_48_META_EVT_3115_P0_D: "اللاعب الذي طلب المنتج",
  T_48_META_EVT_3115_P1_D: "سلعة",
  T_48_META_EVT_3116_D: "يتم تشغيله عندما يطلب أحد اللاعبين في المتجر من الآخرين شراء سلع ويتم قبول الطلب.",
  T_48_META_EVT_3116_P0_D: "اللاعبون الذين يساعدون في الشراء",
  T_48_META_EVT_3116_P1_D: "اللاعبون يطلبون المساعدة في الشراء",
  T_48_META_EVT_3116_P2_D: "سلعة",
  T_48_META_EVT_3117_D: "يتم تشغيله عند تحديث إطار ثابت، ويكون التردد ثابتًا بمعدل 30 مرة في الثانية",
  T_48_META_EVT_3118_D: "تم تشغيله بعد استدعاء API للعبة الإيقاف المؤقت",
  T_48_META_EVT_3119_D: "تم تشغيله بعد استدعاء واجهة برمجة تطبيقات لعبة السيرة الذاتية",
  T_48_META_EVT_3120_D: "يتم تشغيله عندما يقوم أحد اللاعبين بإضافة أصدقاء أو حذفهم",
  T_48_META_EVT_3121_D: "يتم تشغيله عند تلقي معلومات شخصية",
  T_48_META_EVT_3121_P0_D: "محتوى المعلومات",
  T_48_META_EVT_3121_P1_D: "شخصية المرسل",
  T_48_META_EVT_3122_D: "الحرائق في نهاية قفزة اللاعب",
  T_48_META_EVT_3123_D: "يتم تشغيله عندما يسقط اللاعب",
  T_48_META_EVT_3124_D: "يتم تشغيله عندما ينتهي اللاعب من السقوط",
  T_48_META_EVT_3125_D: "يتم تشغيله عند تلقي سلوك الشخصية",
  T_48_META_EVT_3125_P0_D: "سلوك",
  T_48_META_EVT_3125_P1_D: "شخصية المرسل",
  T_48_META_EVT_3126_D: "يتم تشغيله عندما تتغير معلومات العضو",
  T_48_META_EVT_3126_P0_D: "حالة العضو بعد التغيير",
  T_48_META_EVT_3127_D: "يتم تشغيله عند الدخول إلى مركز الأعضاء",
  T_48_META_EVT_3128_D: "يتم تشغيله عند مغادرة مركز الأعضاء",
  T_48_META_EVT_3129_D: "يتم تشغيله عندما يدخل اللاعب في حالة السقوط",
  T_48_META_EVT_3129_P0_D: "قد يكون كيان المهاجم فارغًا",
  T_48_META_EVT_3130_D: "يتم تشغيله عند تلقي حالة الشخصية",
  T_48_META_EVT_3130_P0_D: "شخصية المرسل",
  T_48_META_EVT_3130_P1_D: "رمز الخطأ",
  T_48_META_EVT_3131_D: "يتم تشغيله عند إرسال المعلومات إلى الشخصية من خلال واجهة المستخدم",
  T_48_META_EVT_3131_P0_D: "محتوى المعلومات",
  T_48_META_EVT_3131_P1_D: "شخصية المرسل",
  T_48_META_EVT_3132_D: "يتم تشغيله عند تلقي نهاية الشخصية",
  T_48_META_EVT_3132_P0_D: "شخصية المرسل",
  T_48_META_EVT_3132_P1_D: "رمز الخطأ",
  T_48_META_EVT_32_D: "يتم تشغيله عندما يقوم اللاعب بتبديل المشاهد",
  T_48_META_EVT_32_P0_D: "اسم المشهد",
  T_48_META_EVT_3200_D: "يتم تشغيله عند انتهاء تشغيل مقطع الرسوم المتحركة",
  T_48_META_EVT_3200_P0_D: "اسم مقطع الرسوم المتحركة",
  T_48_META_EVT_3201_D: "يتم تشغيله عند اكتمال تشغيل حالة الرسوم المتحركة",
  T_48_META_EVT_3201_P0_D: "اسم حالة الرسوم المتحركة",
  T_48_META_EVT_3204_D: "يتم تشغيله عندما تتغير حالة عنصر التحكم Toggle",
  T_48_META_EVT_3204_P0_D: "لاعب الزناد",
  T_48_META_EVT_3204_P1_D: "ولاية",
  T_48_META_EVT_3260_D: "يتم تشغيله عند الضغط على لوحة اللمس بواسطة اللاعب",
  T_48_META_EVT_3260_P0_D: "لاعب الزناد",
  T_48_META_EVT_3260_P1_D: "اضغط على الموقف",
  T_48_META_EVT_3261_D: "يتم تشغيله عند رفع لوحة اللمس",
  T_48_META_EVT_3261_P0_D: "لاعب الزناد",
  T_48_META_EVT_3261_P1_D: "موقف مرفوع",
  T_48_META_EVT_3262_D: "يتم تشغيله عندما تبدأ لوحة اللمس في الانزلاق",
  T_48_META_EVT_3262_P0_D: "لاعب الزناد",
  T_48_META_EVT_3262_P1_D: "ابدأ بوضعية الانزلاق",
  T_48_META_EVT_3263_D: "يتم تشغيله أثناء انزلاق لوحة اللمس أثناء الانزلاق، سيتم تشغيل هذا الحدث مرة واحدة في كل إطار.",
  T_48_META_EVT_3263_P0_D: "لاعب الزناد",
  T_48_META_EVT_3263_P1_D: "ابدأ بوضعية الانزلاق",
  T_48_META_EVT_3263_P2_D: "النزوح",
  T_48_META_EVT_3264_D: "حرائق في نهاية شريحة لوحة اللمس",
  T_48_META_EVT_3264_P0_D: "لاعب الزناد",
  T_48_META_EVT_3264_P1_D: "إنهاء وضع الانزلاق",
  T_48_META_EVT_3265_D: "يتم تشغيله عند الضغط على JoyStick",
  T_48_META_EVT_3265_P0_D: "لاعب الزناد",
  T_48_META_EVT_3266_D: "يشتعل عند رفع JoyStick",
  T_48_META_EVT_3266_P0_D: "لاعب الزناد",
  T_48_META_EVT_3267_D: "يتم تشغيله عند استخدام JoyStick",
  T_48_META_EVT_3267_P0_D: "لاعب الزناد",
  T_48_META_EVT_3267_P1_D: "إزاحة الإخراج",
  T_48_META_EVT_3268_D: "يتم تشغيله عندما يقف اللاعب من موقف آخر",
  T_48_META_EVT_3268_P0_D: "وضعية اللاعب قبل الوقوف",
  T_48_META_EVT_3269_D: "يتم تشغيله عند إطلاق السلاح",
  T_48_META_EVT_4_D: "يتم تفعيلها في بداية كل جولة",
  T_48_META_EVT_4_P0_D: "مؤشر مستدير يبدأ من 0",
  T_48_META_EVT_5_D: "يتم تشغيله في نهاية كل جولة",
  T_48_META_EVT_5_P0_D: "مؤشر مستدير يبدأ من 0",
  T_48_META_EVT_6_D: "يتم تشغيله عند تصادم أحد الكيانات فقط الكيانات التي تحتوي على مكونات جسم صلبة مثبتة هي التي تدعم هذا الحدث.",
  T_48_META_EVT_6_P0_D: "الكيانات التي واجهتها",
  T_48_META_EVT_7_D: "يتم تشغيله في بداية كل مرحلة",
  T_48_META_EVT_7_P0_D: "كيان المرحلة",
  T_48_META_EVT_8_D: "يتم تشغيله في نهاية كل مرحلة",
  T_48_META_EVT_8_P0_D: "كيان المرحلة",
  T_48_META_EVT_9_D: "يتم تشغيله عند نهاية تصادم الكيانات فقط الكيانات التي تحتوي على مكونات جسم صلبة مثبتة تدعم هذا الحدث.",
  T_48_META_EVT_9_P0_D: "الكيانات التي واجهتها",
  T_49_META_TYP_10_I1_D: "قائمة العلامات",
  T_49_META_TYP_10_I2_D: "هل هو متاح؟",
  T_49_META_TYP_10_I3_D: "هل جميع العقد الأصلية متاحة؟",
  T_49_META_TYP_10_I4_D: "هل هو متوفر في المشهد؟",
  T_49_META_TYP_10_I5_D: "هل سيتم تفعيل تحديث المنطق؟ عند تعطيله، سيتوقف البرنامج النصي على الكيان عن تحديث كل إطار.",
  T_49_META_TYP_10_I6_D: "اسم الكيان",
  T_49_META_TYP_10_I7_D: "خيار تصفية المنطقة، 0 يعني ما إذا كان الحساب التلقائي يتم التحكم فيه، 1 يعني أنه غير خاضع للتحكم ومتزامن دائمًا، 2 يعني أنه يتم التحكم فيه",
  T_49_META_TYP_100_I0_D: "ضبط نطاق الزناد",
  T_49_META_TYP_100_I1_D: "رؤية النموذج",
  T_49_META_TYP_101_I0_D: "اللاعب",
  T_49_META_TYP_101_I1_D: "معرف العنصر الهدف",
  T_49_META_TYP_101_I2_D: "تدوير الهدف",
  T_49_META_TYP_101_I3_D: "مقياس الهدف",
  T_49_META_TYP_1010_I1_D: "مدة التوقيت بالثواني",
  T_49_META_TYP_1010_I2_D: "وقت بدء العد التنازلي، بالثواني للعبة",
  T_49_META_TYP_1010_I3_D: "نوع تحديث التوقيت، راجع `EUITimeUpdateType`، اختياري: ثابت، توقيت، عد تنازلي",
  T_49_META_TYP_1010_I4_D: "موضع العرض، عندما يكون هناك هدف يجب متابعته، فهو الإزاحة بالنسبة لأصل الهدف، وعندما لا يكون هناك هدف يجب متابعته، فهو إحداثيات الشاشة",
  T_49_META_TYP_1011_I10_D: "اسم أيقونة التقدم",
  T_49_META_TYP_1011_I2_D: "لون الموضوع",
  T_49_META_TYP_1011_I3_D: "ما إذا كان سيتم تمكين العرض الموضعي",
  T_49_META_TYP_1011_I4_D: "العنوان",
  T_49_META_TYP_1011_I5_D: "الوصف",
  T_49_META_TYP_1011_I6_D: "اسم مورد الأيقونة",
  T_49_META_TYP_1011_I7_D: "أقصى تقدم",
  T_49_META_TYP_1011_I8_D: "التقدم الحالي",
  T_49_META_TYP_1011_I9_D: "أيقونة التقدم",
  T_49_META_TYP_1012_I1_D: "ما إذا كان سيتم تمكين التوطين",
  T_49_META_TYP_1012_I2_D: "نص الرقم الدائري",
  T_49_META_TYP_1012_I3_D: "معلمات مفتاح عدد الجولات",
  T_49_META_TYP_1012_I5_D: "لون اليسار",
  T_49_META_TYP_1012_I6_D: "لون اليمين",
  T_49_META_TYP_1013_I2_D: "نص الرقم الدائري",
  T_49_META_TYP_1013_I3_D: "معلمات مفتاح عدد الجولات",
  T_49_META_TYP_1014_I2_D: "نص عنوان النتيجة الأولى",
  T_49_META_TYP_1014_I3_D: "قيمة النتيجة الأولى",
  T_49_META_TYP_1014_I4_D: "معلمات الدرجة الأولى",
  T_49_META_TYP_1014_I5_D: "نص عنوان النتيجة الثانية",
  T_49_META_TYP_1014_I6_D: "قيمة النتيجة الثانية",
  T_49_META_TYP_1014_I7_D: "معلمات قيمة الدرجة الثانية",
  T_49_META_TYP_1016_I1_D: "عرض الحالة المقابلة وفقًا للقيمة، النصر (1)، الخسارة (2)، التعادل (3)، البوياه (4)",
  T_49_META_TYP_1016_I2_D: "إظهار نتائج فريقين. إذا كانت صحيحة، فسيتم عرضها، وإلا فسيتم إخفاؤها.",
  T_49_META_TYP_1016_I3_D: "درجة الفريق الأيسر",
  T_49_META_TYP_1016_I4_D: "درجة الفريق الأيمن",
  T_49_META_TYP_1016_I5_D: "طابع زمني لنهاية المرحلة",
  T_49_META_TYP_1017_I1_D: "اسم الفريق الأيسر",
  T_49_META_TYP_1017_I2_D: "وصف الفريق الأيسر",
  T_49_META_TYP_1017_I3_D: "اسم الفريق الأيمن",
  T_49_META_TYP_1017_I4_D: "وصف الفريق الأيمن",
  T_49_META_TYP_1018_I1_D: "رقم الجولة",
  T_49_META_TYP_1018_I4_D: "نتيجة الفريق الأيسر",
  T_49_META_TYP_1018_I6_D: "النتيجة الصحيحة للفريق",
  T_49_META_TYP_1019_I1_D: "الفوز والخسارة والتعادل يتوافق مع 1 2 3 على التوالي",
  T_49_META_TYP_102_I0_D: "نوع مصدر القيامة، اللاعب الذي تم إحياؤه من الموت",
  T_49_META_TYP_102_I1_D: "نوع مصدر القيامة، حيث يقوم اللاعب بالبعث من حالة السقوط",
  T_49_META_TYP_1020_I2_D: "مفتاح النص الذي سيتم عرضه",
  T_49_META_TYP_1020_I3_D: "مجموعة المعلمات المقابلة لمفتاح النص",
  T_49_META_TYP_1021_I1_D: "الوقت الأساسي بالثواني",
  T_49_META_TYP_1021_I2_D: "المدة بالثواني",
  T_49_META_TYP_1021_I3_D: "موضع العرض. عند وجود هدف للمتابعة، يكون الإزاحة بالنسبة لأصل الهدف. عند عدم وجود هدف للمتابعة، يكون إحداثي الشاشة. القيمة الافتراضية هي Vector3(0).",
  T_49_META_TYP_1022_I2_D: "مفتاح النص الذي سيتم عرضه",
  T_49_META_TYP_1022_I3_D: "مجموعة المعلمات المقابلة لمفتاح النص",
  T_49_META_TYP_1023_I1_D: "يتم عرض نتائج الفريق عندما يكون الخيار صحيحًا، وإلا يتم إغلاقه",
  T_49_META_TYP_1023_I4_D: "العرض عندما تكون حالة اللاعب صحيحة، وإلا فسيتم إغلاقه",
  T_49_META_TYP_1023_I5_D: "مجموعة حالة اللاعب الأيسر، 0: عدد اللاعبين الأحياء، 1: عدد اللاعبين القتلى، 2: عدد اللاعبين المغادرين",
  T_49_META_TYP_1023_I6_D: "مجموعة حالة اللاعب الأيمن، 0: عدد اللاعبين الأحياء، 1: عدد اللاعبين القتلى، 2: عدد اللاعبين المغادرين",
  T_49_META_TYP_1023_I7_D: "عدد الأعلام للاعبين الأيسر",
  T_49_META_TYP_1023_I8_D: "عدد أعلام الفريق الأيمن",
  T_49_META_TYP_1024_I2_D: "الإزاحة",
  T_49_META_TYP_1024_I3_D: "الرتبة",
  T_49_META_TYP_1024_I4_D: "لون الفريق",
  T_49_META_TYP_1024_I5_D: "اسم الأيقونة",
  T_49_META_TYP_1024_I6_D: "إذا كانت الحدود صحيحة، فسيتم عرضها، وإلا فسيتم إغلاقها.",
  T_49_META_TYP_1024_I7_D: "مفتاح نص النقاط",
  T_49_META_TYP_1024_I8_D: "معلمات نص النقاط",
  T_49_META_TYP_1028_I1_D: "عدد اللاعبين الأحياء في الفريق الأيسر",
  T_49_META_TYP_1028_I2_D: "عدد اللاعبين الأحياء في الفريق الأيمن",
  T_49_META_TYP_1028_I3_D: "لون خلفية الفريق الأيسر",
  T_49_META_TYP_1028_I4_D: "لون خلفية الفريق الأيمن",
  T_49_META_TYP_1028_I5_D: "اسم الأيقونة للفريق الأيسر",
  T_49_META_TYP_1028_I6_D: "اسم الأيقونة للفريق الأيمن",
  T_49_META_TYP_1029_I1_D: "اسم الأيقونة",
  T_49_META_TYP_1029_I2_D: "اسم أيقونة الخلفية",
  T_49_META_TYP_103_I0_D: "السلاح الأساسي A",
  T_49_META_TYP_103_I1_D: "السلاح الأساسي B",
  T_49_META_TYP_103_I10_D: "قنبلة تجميد",
  T_49_META_TYP_103_I11_D: "جدار الجليد",
  T_49_META_TYP_103_I12_D: "لغم",
  T_49_META_TYP_103_I13_D: "برج أوتوماتيكي",
  T_49_META_TYP_103_I14_D: "قنبلة وهمية",
  T_49_META_TYP_103_I16_D: "لوح التزلج، التمويه...",
  T_49_META_TYP_103_I2_D: "السلاح الثانوي",
  T_49_META_TYP_103_I3_D: "الأسلحة المتفجرة",
  T_49_META_TYP_103_I5_D: "سلاح ثقيل",
  T_49_META_TYP_1030_I3_D: "عدد اللاعبين الأحياء في الفريق الأيسر",
  T_49_META_TYP_1030_I4_D: "عدد اللاعبين الأحياء في الفريق الأيمن",
  T_49_META_TYP_1030_I5_D: "اسم أيقونة الفريق على اليسار",
  T_49_META_TYP_1030_I6_D: "اسم أيقونة الفريق على اليمين",
  T_49_META_TYP_1031_I2_D: "وصف المعلومات السريعة",
  T_49_META_TYP_1031_I3_D: "طابع زمني لبدء العد التنازلي بالثواني",
  T_49_META_TYP_1031_I4_D: "معلمات الوصف",
  T_49_META_TYP_1032_I1_D: "نوع النصائح",
  T_49_META_TYP_1032_I3_D: "معلمات",
  T_49_META_TYP_1033_I1_D: "مرحلة التبديل، 0 يعني أن الجولة الحالية قد تم حسمها، 1 يعني أن الجولة التالية تبدأ",
  T_49_META_TYP_1033_I10_D: "نص مطالبة الفشل، اتركه فارغًا للوضع الافتراضي",
  T_49_META_TYP_1033_I11_D: "عنوان دخل الجولة",
  T_49_META_TYP_1033_I12_D: "دخل الجولة",
  T_49_META_TYP_1033_I13_D: "عناوين تفاصيل الدخل للجولة",
  T_49_META_TYP_1033_I14_D: "تتوافق القائمة التفصيلية لقيم الدخل المستديرة مع قائمة العنوان التفصيلية أعلاه.",
  T_49_META_TYP_1033_I15_D: "لقب اللاعب MVP",
  T_49_META_TYP_1033_I16_D: "مؤشر الجولة التالية",
  T_49_META_TYP_1033_I17_D: "هل هي نقطة المباراة",
  T_49_META_TYP_1033_I18_D: "هل هي الجولة الأخيرة",
  T_49_META_TYP_1033_I6_D: "اسم أيقونة الفريق على اليسار",
  T_49_META_TYP_1033_I7_D: "اسم أيقونة الفريق على اليمين",
  T_49_META_TYP_1033_I8_D: "عرض الحالة المقابلة حسب القيمة، النصر (1)، الفشل (2)",
  T_49_META_TYP_1033_I9_D: "نص مطالبة النصر، اتركه فارغًا افتراضيًا",
  T_49_META_TYP_1036_I1_D: "يشير إلى عدد المستويات الموجودة",
  T_49_META_TYP_1036_I2_D: "يشير إلى مستوى الزومبي الحالي",
  T_49_META_TYP_1037_I1_D: "يشير إلى عدد النقاط المعروضة",
  T_49_META_TYP_1039_I3_D: "طابع زمني لبدء العد التنازلي بالثواني",
  T_49_META_TYP_104_I0_D: "نمط A",
  T_49_META_TYP_104_I1_D: "نمط B",
  T_49_META_TYP_104_I2_D: "نمط C",
  T_49_META_TYP_1040_I10_D: "أوصاف البطاقات",
  T_49_META_TYP_1040_I11_D: "مؤشر العنصر المحدد، يبدأ من 0. إذا كان أقل من 0، فهذا يعني إلغاء التحديد.",
  T_49_META_TYP_1040_I12_D: "أسماء الأزرار",
  T_49_META_TYP_1040_I13_D: "ألوان الأزرار",
  T_49_META_TYP_1040_I2_D: "مفتاح العد التنازلي",
  T_49_META_TYP_1040_I3_D: "وقت العد التنازلي",
  T_49_META_TYP_1040_I4_D: "مفتاح الوصف",
  T_49_META_TYP_1040_I5_D: "مجموعة معلمات معلومات الوصف",
  T_49_META_TYP_1040_I6_D: "خلفيات البطاقات",
  T_49_META_TYP_1040_I7_D: "ألوان خلفيات البطاقات",
  T_49_META_TYP_1040_I8_D: "أيقونات البطاقات",
  T_49_META_TYP_1040_I9_D: "أسماء البطاقات",
  T_49_META_TYP_1041_I2_D: "موضع",
  T_49_META_TYP_1041_I3_D: "صورة الأيقونة",
  T_49_META_TYP_1041_I4_D: "التسمية",
  T_49_META_TYP_1041_I5_D: "لون الخلفية",
  T_49_META_TYP_1042_I1_D: "الموقع المحلي",
  T_49_META_TYP_1043_I4_D: "لون النص",
  T_49_META_TYP_1043_I5_D: "مفتاح التسمية",
  T_49_META_TYP_1043_I6_D: "معلمات التسمية",
  T_49_META_TYP_1045_I2_D: "أيقونة الزر",
  T_49_META_TYP_1045_I3_D: "لون الأيقونة",
  T_49_META_TYP_1045_I4_D: "الحجم والعرض والارتفاع متساويان",
  T_49_META_TYP_1045_I5_D: "الموضع بالنسبة لنقطة الربط اليمنى السفلية",
  T_49_META_TYP_1045_I6_D: "كمية الشحنة مخفية إذا كانت أقل من 0",
  T_49_META_TYP_1045_I7_D: "وقت بدء تشغيل القرص المضغوط، بالمللي ثانية",
  T_49_META_TYP_1045_I8_D: "مدة القرص المضغوط بالمللي ثانية",
  T_49_META_TYP_1045_I9_D: "إذا كانت القيمة صحيحة، سيصبح الزر رمادي اللون، وإذا كانت القيمة خاطئة، فسيتم استعادته.",
  T_49_META_TYP_106_I1_D: "تفعيل",
  T_49_META_TYP_106_I2_D: "تعطيل",
  T_49_META_TYP_109_I0_D: "معرف قناة الدردشة",
  T_49_META_TYP_109_I1_D: "قائمة اللاعبين",
  T_49_META_TYP_11_I0_D: "هل اللعبة الحالية في حالة غير قانونية؟ إذا كانت كذلك، فهذا يعني أن اللعبة فقدت قيمتها في المواجهة. يُنصح بإنهاء اللعبة فورًا.",
  T_49_META_TYP_11_I1_D: "مدة اللعبة الحالية، بالمللي ثانية",
  T_49_META_TYP_11_I10_D: "هل يجب إعادة ضبط المعدات في كل جولة؟",
  T_49_META_TYP_11_I11_D: "هل سيتم تفعيل آلية دائرة السم؟",
  T_49_META_TYP_11_I12_D: "حجم المنطقة الآمنة",
  T_49_META_TYP_11_I13_D: "وقت بدء التقليص",
  T_49_META_TYP_11_I14_D: "مدة التقليص",
  T_49_META_TYP_11_I15_D: "الضرر خارج المنطقة",
  T_49_META_TYP_11_I18_D: "نوع الإنعاش",
  T_49_META_TYP_11_I2_D: "مؤشر الجولة الحالية، والذي يمكن من خلاله الحصول على كيان الجولة الحالية",
  T_49_META_TYP_11_I27_D: "إجمالي عدد الجولات",
  T_49_META_TYP_11_I3_D: "مؤشر المرحلة الحالية، والذي يمكن من خلاله الحصول على كيان المرحلة الحالية",
  T_49_META_TYP_11_I32_D: "كمية العملات الذهبية التي تم الحصول عليها في بداية الجولة",
  T_49_META_TYP_11_I33_D: "كمية العملات الذهبية المكتسبة عند القتل",
  T_49_META_TYP_11_I34_D: "كمية العملات الذهبية المكتسبة عند الفوز",
  T_49_META_TYP_11_I35_D: "ما إذا كان سيتم عرض واجهة المستخدم للمحفظة",
  T_49_META_TYP_11_I36_D: "كيان سكاي بوكس",
  T_49_META_TYP_11_I37_D: "الإطارات التراكمية الجارية منذ بدء اللعبة",
  T_49_META_TYP_11_I38_D: "تمكين التحرك",
  T_49_META_TYP_11_I39_D: "ما إذا كان سيتم تخصيص التسوية",
  T_49_META_TYP_11_I4_D: "معرف قالب وضع UGC المحدد مسبقًا",
  T_49_META_TYP_11_I40_D: "هل يجوز الانضمام إلى منتصف الطريق؟",
  T_49_META_TYP_11_I41_D: "قم بتشغيل وضع معدل الإطارات المنخفض، وستعمل اللعبة بمعدل 15 إطارًا في الثانية، وإلا فسيتم تشغيلها بمعدل 30 إطارًا في الثانية",
  T_49_META_TYP_11_I42_D: "الفترة بين تحديثين للإطار المنطقي لخادم اللعبة",
  T_49_META_TYP_11_I43_D: "فترة تحديث الإطار الثابتة بالمللي ثانية",
  T_49_META_TYP_11_I5_D: "إذا تم إيقاف تشغيله، سيتم تعطيل إحياء اللاعب.",
  T_49_META_TYP_11_I6_D: "إذا تم الإغلاق، سيتم تعطيل إحياء الروبوت",
  T_49_META_TYP_11_I7_D: "وقت القيامة بالثواني",
  T_49_META_TYP_11_I8_D: "إجمالي عدد الفرق في اللعبة",
  T_49_META_TYP_11_I9_D: "عدد الأعضاء لكل فريق",
  T_49_META_TYP_110_I0_D: "قناة A",
  T_49_META_TYP_110_I1_D: "قناة B",
  T_49_META_TYP_110_I2_D: "قناة C",
  T_49_META_TYP_110_I3_D: "قناة D",
  T_49_META_TYP_110_I4_D: "قناة E",
  T_49_META_TYP_110_I5_D: "قناة F",
  T_49_META_TYP_111_I1_D: "سباق سريع",
  T_49_META_TYP_111_I2_D: "هجوم",
  T_49_META_TYP_111_I3_D: "قفز",
  T_49_META_TYP_111_I4_D: "قفزة النافذة",
  T_49_META_TYP_111_I5_D: "قيادة",
  T_49_META_TYP_111_I6_D: "دخول المركبة",
  T_49_META_TYP_111_I7_D: "خروج من المركبة",
  T_49_META_TYP_111_I8_D: "قيادة المركبة",
  T_49_META_TYP_112_I0_D: "تفعيل",
  T_49_META_TYP_112_I1_D: "تعطيل",
  T_49_META_TYP_112_I2_D: "غير مرئي",
  T_49_META_TYP_117_I0_D: "تصفيق",
  T_49_META_TYP_117_I1_D: "هايت هات",
  T_49_META_TYP_117_I2_D: "طبل",
  T_49_META_TYP_117_I3_D: "هيهات مفتوحة",
  T_49_META_TYP_117_I4_D: "رايد",
  T_49_META_TYP_117_I5_D: "طبل السناج",
  T_49_META_TYP_118_I0_D: "هل جميع أعضاء المعسكر ماتوا؟",
  T_49_META_TYP_118_I1_D: "قائمة جميع اللاعبين",
  T_49_META_TYP_118_I2_D: "الفصائل المتحالفة",
  T_49_META_TYP_118_I3_D: "الفصائل القابلة للهجوم",
  T_49_META_TYP_118_I4_D: "ما إذا كان سيتم عرض اسم واجهة المستخدم",
  T_49_META_TYP_118_I5_D: "ما إذا كان سيتم عرض معلومات الخريطة",
  T_49_META_TYP_118_I6_D: "هل سيتم العرض",
  T_49_META_TYP_118_I7_D: "هل سيتم العرض",
  T_49_META_TYP_118_I8_D: "جميع الأعضاء",
  T_49_META_TYP_118_I9_D: "عرض الرسائل السريعة",
  T_49_META_TYP_119_I0_D: "نعم",
  T_49_META_TYP_119_I1_D: "لا",
  T_49_META_TYP_120_I1_D: "الكيان المستهدف الذي يجب متابعته، الافتراضي هو فارغ",
  T_49_META_TYP_120_I2_D: "لون واجهة المستخدم",
  T_49_META_TYP_120_I3_D: "طول واجهة المستخدم",
  T_49_META_TYP_120_I4_D: "قيمة التقدم الحالية، من 0 إلى 1.0",
  T_49_META_TYP_120_I5_D: "موضع العرض. عند وجود هدف للمتابعة، يكون الإزاحة بالنسبة لأصل الهدف. عند عدم وجود هدف للمتابعة، يكون إحداثي الشاشة. القيمة الافتراضية هي Vector3(0).",
  T_49_META_TYP_121_I0_D: "3 ثوانٍ",
  T_49_META_TYP_121_I1_D: "5 ثوانٍ",
  T_49_META_TYP_121_I2_D: "10 ثوانٍ",
  T_49_META_TYP_121_I3_D: "15 ثانية",
  T_49_META_TYP_121_I4_D: "30 ثانية",
  T_49_META_TYP_121_I5_D: "9999 ثانية",
  T_49_META_TYP_122_I0_D: "مورد صندوق السماء",
  T_49_META_TYP_122_I1_D: "لون فاتح",
  T_49_META_TYP_122_I10_D: "GUID للمشهد الفرعي",
  T_49_META_TYP_122_I11_D: "مفتاح تأثير الضباب",
  T_49_META_TYP_122_I12_D: "وضع تأثير الضباب",
  T_49_META_TYP_122_I13_D: "كثافة الضباب الأسّي",
  T_49_META_TYP_122_I14_D: "مسافة بداية الضباب الخطي",
  T_49_META_TYP_122_I15_D: "المسافة النهائية للضباب الخطي",
  T_49_META_TYP_122_I16_D: "تمكين ميزة تأثير الضباب",
  T_49_META_TYP_122_I17_D: "زاوية دوران مصدر الضوء الرئيسي",
  T_49_META_TYP_122_I18_D: "تمكين ميزة زاوية دوران مصدر الضوء الرئيسي",
  T_49_META_TYP_122_I2_D: "شدة الضوء",
  T_49_META_TYP_122_I3_D: "الظلام",
  T_49_META_TYP_122_I4_D: "قوة الظل",
  T_49_META_TYP_122_I5_D: "رطوبة التضاريس",
  T_49_META_TYP_122_I6_D: "عدسة مضيئة",
  T_49_META_TYP_122_I7_D: "لون الضباب",
  T_49_META_TYP_122_I8_D: "لون البيئة",
  T_49_META_TYP_123_I0_D: "يوم",
  T_49_META_TYP_123_I1_D: "ليلة",
  T_49_META_TYP_123_I2_D: "الغسق",
  T_49_META_TYP_123_I3_D: "منظر المدينة",
  T_49_META_TYP_123_I4_D: "السماء الملونة",
  T_49_META_TYP_123_I5_D: "قمر الصقيع",
  T_49_META_TYP_124_I0_D: "مدى قريب",
  T_49_META_TYP_124_I1_D: "المسافة المتوسطة",
  T_49_META_TYP_124_I2_D: "مسافة طويلة",
  T_49_META_TYP_125_I0_D: "لون منتشر",
  T_49_META_TYP_125_I2_D: "ملمس منتشر",
  T_49_META_TYP_125_I4_D: "ألفا منتشر",
  T_49_META_TYP_126_I1_D: "الاسم",
  T_49_META_TYP_126_I2_D: "قيمة التقدم الحالية",
  T_49_META_TYP_126_I3_D: "الحد الأقصى لقيمة التقدم",
  T_49_META_TYP_126_I4_D: "إحداثيات الشاشة، الافتراضي هو Vector3(0)",
  T_49_META_TYP_126_I5_D: "طول شريط التقدم. القيمة الافتراضية الحالية هي طول واجهة المستخدم في النموذج الجاهز.",
  T_49_META_TYP_127_I0_D: "الترجمة على طول محور معين، يمكن دمج ثلاثة محاور",
  T_49_META_TYP_127_I1_D: "الدوران على طول محور معين، ويمكن دمج ثلاثة محاور",
  T_49_META_TYP_127_I2_D: "التكبير على طول محور معين، يمكنك الجمع بين ثلاثة محاور",
  T_49_META_TYP_128_I0_D: "شجيرات",
  T_49_META_TYP_128_I1_D: "اليقطين",
  T_49_META_TYP_128_I2_D: "فزاعة",
  T_49_META_TYP_128_I3_D: "خزانة",
  T_49_META_TYP_129_I0_D: "غنائم عشوائية",
  T_49_META_TYP_129_I1_D: "ذخيرة AR",
  T_49_META_TYP_129_I2_D: "ذخيرة رشاش",
  T_49_META_TYP_129_I3_D: "ذخيرة SN",
  T_49_META_TYP_129_I4_D: "ذخيرة HG",
  T_49_META_TYP_129_I5_D: "رصاصة SG",
  T_49_META_TYP_129_I6_D: "ذخيرة قوس",
  T_49_META_TYP_13_I1_D: "إحداثيات المرساة بالنسبة للعقدة الأصلية",
  T_49_META_TYP_13_I10_D: "الفرق بين حجم مربع الأدوات وصندوق المرساة",
  T_49_META_TYP_13_I11_D: "محور التدوير",
  T_49_META_TYP_13_I12_D: "عمق",
  T_49_META_TYP_13_I14_D: "ترتيب جميع العقد الفرعية تحت نفس العقدة الأصلية",
  T_49_META_TYP_13_I15_D: "معرف الأصل",
  T_49_META_TYP_13_I16_D: "معرف فريد",
  T_49_META_TYP_13_I17_D: "الأولوية",
  T_49_META_TYP_13_I18_D: "الموقع الفعلي",
  T_49_META_TYP_13_I2_D: "العرض",
  T_49_META_TYP_13_I4_D: "زاوية دوران المحور Z",
  T_49_META_TYP_13_I6_D: "المعرف الداخلي للتحكم في Prefab",
  T_49_META_TYP_13_I7_D: "كيان واجهة المستخدم",
  T_49_META_TYP_13_I8_D: "تثبيت الحد الأدنى",
  T_49_META_TYP_13_I9_D: "تثبيت الحد الأقصى",
  T_49_META_TYP_130_I0_D: "غنائم المواد الاستهلاكية العشوائية",
  T_49_META_TYP_130_I1_D: "مجموعة الإسعافات الأولية",
  T_49_META_TYP_130_I2_D: "مجموعة الإصلاح",
  T_49_META_TYP_130_I3_D: "أفق",
  T_49_META_TYP_130_I4_D: "جهاز الاستنشاق",
  T_49_META_TYP_131_I0_D: "غنائم دروع عشوائية",
  T_49_META_TYP_131_I1_D: "درع المستوى 1",
  T_49_META_TYP_131_I2_D: "درع المستوى الثاني",
  T_49_META_TYP_131_I3_D: "درع المستوى 3",
  T_49_META_TYP_132_I0_D: "رميات عشوائية للغنائم",
  T_49_META_TYP_132_I1_D: "قنبلة",
  T_49_META_TYP_132_I4_D: "تجميد سريع",
  T_49_META_TYP_133_I0_D: "غنائم نطاق عشوائية",
  T_49_META_TYP_133_I1_D: "2x منظار",
  T_49_META_TYP_133_I2_D: "4x منظار",
  T_49_META_TYP_133_I3_D: "منظار حراري",
  T_49_META_TYP_134_I0_D: "غنيمة سلاح عشوائي",
  T_49_META_TYP_134_I5_D: "بندوق مروحية",
  T_49_META_TYP_134_I8_D: "بندقية كرة القدم",
  T_49_META_TYP_135_I0_D: "غنائم نقاط الرصاص",
  T_49_META_TYP_136_I0_D: "نقاط العناصر الاستهلاكية الغنائم",
  T_49_META_TYP_137_I0_D: "نقاط العناصر الاستهلاكية الغنائم",
  T_49_META_TYP_138_I0_D: "نقطة تكبير الغنائم",
  T_49_META_TYP_139_I0_D: "نهب نقاط الدروع",
  T_49_META_TYP_14_I0_D: "الحالة الصحية الحالية للاعب",
  T_49_META_TYP_14_I1_D: "الحد الأقصى لصحة اللاعب الحالية",
  T_49_META_TYP_14_I11_D: "فصيل اللاعب",
  T_49_META_TYP_14_I12_D: "مضاعف الضرر الذي يلحق باللاعب، مثل 2x، هو 2.0",
  T_49_META_TYP_14_I13_D: "استخدم نفس الهيكل العظمي تمامًا للشخصية الذكرية أو الأنثوية. 0 يعني عدم استبدال النموذج",
  T_49_META_TYP_14_I14_D: "لن يتعارض مع مقياس السرعة الحالي",
  T_49_META_TYP_14_I15_D: "لن يتعارض مع مقياس ارتفاع القفزة الحالي",
  T_49_META_TYP_14_I16_D: "الهوية، 0 لاعب عادي، 1 صياد، 2 أم زومبي، 3 زومبي عادي، 4 زومبي متطور من النوع 1، 5 زومبي متطور من النوع 2، 6 زومبي متطور من النوع 3",
  T_49_META_TYP_14_I17_D: "مستوى الزومبي، 1~3",
  T_49_META_TYP_14_I19_D: "لقب اللاعب",
  T_49_META_TYP_14_I2_D: "حدد ما إذا كان اللاعب الحالي لاعب ذكاء اصطناعي. الذكاء الاصطناعي عادةً ما يكون شخصية غير قابلة للعب أو وحش لاعب ضد بيئة.",
  T_49_META_TYP_14_I20_D: "عند تلقي الضرر، يمكن تقليل نسبة الضرر أو زيادتها.",
  T_49_META_TYP_14_I21_D: "EP الحالي للاعب",
  T_49_META_TYP_14_I22_D: "الحد الأقصى للاعب EP",
  T_49_META_TYP_14_I23_D: "السلاح الرئيسي في متناول اليد حاليا",
  T_49_META_TYP_14_I24_D: "السقوط عند الإصابة",
  T_49_META_TYP_14_I26_D: "نوع نوع المساعدة في التصويب",
  T_49_META_TYP_14_I27_D: "السماح بالقفل بواسطة مساعد التصويب",
  T_49_META_TYP_14_I28_D: "تبديل الدردشة الصوتية: صحيح لإيقاف الصوت، خطأ لتشغيل الصوت",
  T_49_META_TYP_14_I29_D: "تبديل الدردشة السريعة: صحيح لإيقاف الصوت، خطأ لتشغيل الصوت",
  T_49_META_TYP_14_I3_D: "حالة اللاعب",
  T_49_META_TYP_14_I30_D: "القناة",
  T_49_META_TYP_14_I35_D: "تبديل التقاط العنصر: صحيح لتعطيل الاستلام، خطأ لتمكين الاستلام",
  T_49_META_TYP_14_I36_D: "تبديل التخلص من العناصر: صحيح لمنع التخلص من العناصر، خطأ للسماح بالتخلص من العناصر",
  T_49_META_TYP_14_I37_D: "الأهداف القابلة للهجوم",
  T_49_META_TYP_14_I38_D: "اللاعبون الودودون",
  T_49_META_TYP_14_I39_D: "فصيل",
  T_49_META_TYP_14_I4_D: "مدة بقاء اللاعب. في حال وفاته، يُعاد حساب المدة.",
  T_49_META_TYP_14_I40_D: "رقم في الفصيل",
  T_49_META_TYP_14_I41_D: "الكاميرا التي يستخدمها اللاعب",
  T_49_META_TYP_14_I42_D: "الجاذبية المخصصة",
  T_49_META_TYP_14_I43_D: "خوذة",
  T_49_META_TYP_14_I44_D: "السترة",
  T_49_META_TYP_14_I5_D: "لا يقهر اللاعب",
  T_49_META_TYP_14_I52_D: "معرف المستخدم الفريد",
  T_49_META_TYP_14_I53_D: "تقليل ضرر طلقة الرأس",
  T_49_META_TYP_14_I54_D: "الصورة الرمزية المرتبطة باللاعب",
  T_49_META_TYP_14_I55_D: "جنس",
  T_49_META_TYP_14_I56_D: "معرفات غلاف السلاح",
  T_49_META_TYP_14_I57_D: "نقطة ظهور اللاعب",
  T_49_META_TYP_14_I58_D: "نقطة إحياء اللاعب. في حال عدم وجود سجلّ نقطة تفتيش، تُستخدم نقطة الميلاد، وإلاّ، تُستخدم نقطة التفتيش.",
  T_49_META_TYP_14_I59_D: "المركز الحالي للاعب",
  T_49_META_TYP_14_I6_D: "الكيان الذي ينتمي إليه اللاعب",
  T_49_META_TYP_14_I60_D: "الاتجاه الحالي للاعب",
  T_49_META_TYP_14_I61_D: "العقدة المستخدمة للوصول إلى عظام الجلد",
  T_49_META_TYP_14_I62_D: "حقيبة",
  T_49_META_TYP_14_I63_D: "النقاط المؤقتة للدروع",
  T_49_META_TYP_14_I64_D: "معرف غلاف المركبة",
  T_49_META_TYP_14_I65_D: "تخطي الرسوم المتحركة المتعثرة",
  T_49_META_TYP_14_I66_D: "تعطيل الضرر عند السقوط",
  T_49_META_TYP_14_I67_D: "العنصر الذي يحمل حاليا",
  T_49_META_TYP_14_I68_D: "قائمة حظر التقاط العناصر",
  T_49_META_TYP_14_I69_D: "معرف مورد اللاعب",
  T_49_META_TYP_14_I7_D: "معرف نقطة التفتيش الحالية",
  T_49_META_TYP_14_I70_D: "الهدف هو إرسال رسالة طلب شراء إلى",
  T_49_META_TYP_14_I71_D: "معرف مورد Emote الذي يتم تشغيله حاليًا",
  T_49_META_TYP_14_I72_D: "ما إذا كان Emote الذي يتم تشغيله حاليًا يتكرر",
  T_49_META_TYP_14_I73_D: "التعامل مع حالة الإسقاط",
  T_49_META_TYP_14_I74_D: "سواء كنت تريد تمكين قفزة الضرر، فإن الوضع الافتراضي هو True، مما يعني أنه تم تمكينه",
  T_49_META_TYP_14_I76_D: "هل يمكنني التوقف في منتصف الطريق؟",
  T_49_META_TYP_14_I77_D: "معلومات الأزياء التي يجب على اللاعب الاحتفاظ بها عند التحول إلى شخصية أخرى",
  T_49_META_TYP_14_I8_D: "معرف نقطة التفتيش التي يتجه إليها الهدف",
  T_49_META_TYP_140_I0_D: "الموجة 1",
  T_49_META_TYP_140_I1_D: "الموجة الثانية",
  T_49_META_TYP_140_I2_D: "الموجة 3",
  T_49_META_TYP_140_I3_D: "مستمر",
  T_49_META_TYP_141_I0_D: "غنيمة كرة قدم عشوائية",
  T_49_META_TYP_141_I1_D: "درع كرة القدم",
  T_49_META_TYP_141_I2_D: "قنبلة تجميد",
  T_49_META_TYP_142_I0_D: "نهب كرة القدم",
  T_49_META_TYP_143_I0_D: "Lead1C2",
  T_49_META_TYP_143_I1_D: "Lead1C2#",
  T_49_META_TYP_143_I10_D: "Lead1A2#",
  T_49_META_TYP_143_I11_D: "Lead1B2",
  T_49_META_TYP_143_I2_D: "Lead1D2",
  T_49_META_TYP_143_I3_D: "Lead1D2#",
  T_49_META_TYP_143_I4_D: "Lead1E2",
  T_49_META_TYP_143_I5_D: "Lead1F2",
  T_49_META_TYP_143_I6_D: "Lead1F2#",
  T_49_META_TYP_143_I7_D: "Lead1G2",
  T_49_META_TYP_143_I8_D: "Lead1G2#",
  T_49_META_TYP_143_I9_D: "Lead1A2",
  T_49_META_TYP_144_I0_D: "Lead2C2",
  T_49_META_TYP_144_I1_D: "Lead2C2#",
  T_49_META_TYP_144_I10_D: "Lead2A2#",
  T_49_META_TYP_144_I11_D: "Lead2B2",
  T_49_META_TYP_144_I2_D: "Lead2D2",
  T_49_META_TYP_144_I3_D: "Lead2D2#",
  T_49_META_TYP_144_I4_D: "Lead2E2",
  T_49_META_TYP_144_I5_D: "Lead2F2",
  T_49_META_TYP_144_I6_D: "Lead2F2#",
  T_49_META_TYP_144_I7_D: "Lead2G2",
  T_49_META_TYP_144_I8_D: "Lead2G2#",
  T_49_META_TYP_144_I9_D: "Lead2A2",
  T_49_META_TYP_145_I0_D: "Lead3C2",
  T_49_META_TYP_145_I1_D: "Lead3C2#",
  T_49_META_TYP_145_I10_D: "Lead3A2#",
  T_49_META_TYP_145_I11_D: "Lead3B2",
  T_49_META_TYP_145_I2_D: "Lead3D2",
  T_49_META_TYP_145_I3_D: "Lead3D2#",
  T_49_META_TYP_145_I4_D: "Lead3E2",
  T_49_META_TYP_145_I5_D: "Lead3F2",
  T_49_META_TYP_145_I6_D: "Lead3F2#",
  T_49_META_TYP_145_I7_D: "Lead3G2",
  T_49_META_TYP_145_I8_D: "Lead3G2#",
  T_49_META_TYP_145_I9_D: "Lead3A2",
  T_49_META_TYP_146_I0_D: "PianoC3",
  T_49_META_TYP_146_I1_D: "PianoC3#",
  T_49_META_TYP_146_I10_D: "PianoA3#",
  T_49_META_TYP_146_I11_D: "PianoB3",
  T_49_META_TYP_146_I12_D: "PianoC4",
  T_49_META_TYP_146_I13_D: "PianoC4#",
  T_49_META_TYP_146_I14_D: "PianoD4",
  T_49_META_TYP_146_I15_D: "PianoD4#",
  T_49_META_TYP_146_I16_D: "PianoE4",
  T_49_META_TYP_146_I17_D: "PianoF4",
  T_49_META_TYP_146_I18_D: "PianoF4#",
  T_49_META_TYP_146_I19_D: "PianoG4",
  T_49_META_TYP_146_I2_D: "PianoD3",
  T_49_META_TYP_146_I20_D: "PianoG4#",
  T_49_META_TYP_146_I21_D: "PianoA4",
  T_49_META_TYP_146_I22_D: "PianoA4#",
  T_49_META_TYP_146_I23_D: "PianoB4",
  T_49_META_TYP_146_I3_D: "PianoD3#",
  T_49_META_TYP_146_I4_D: "PianoE3",
  T_49_META_TYP_146_I5_D: "PianoF3",
  T_49_META_TYP_146_I6_D: "PianoF3#",
  T_49_META_TYP_146_I7_D: "PianoG3",
  T_49_META_TYP_146_I8_D: "PianoG3#",
  T_49_META_TYP_146_I9_D: "PianoA3",
  T_49_META_TYP_147_I0_D: "FF Classic (تصوير)",
  T_49_META_TYP_147_I1_D: "الشخص الثالث",
  T_49_META_TYP_147_I2_D: "الشخص الأول (مطلق النار)",
  T_49_META_TYP_147_I3_D: "منظر علوي",
  T_49_META_TYP_147_I4_D: "التمرير الأفقي",
  T_49_META_TYP_147_I5_D: "كاميرا مخصصة",
  T_49_META_TYP_147_I6_D: "يطارد",
  T_49_META_TYP_147_I7_D: "كاميرا متحركة بحرية يتحكم بها اللاعب",
  T_49_META_TYP_147_I8_D: "كاميرا جديدة للشخص الأول",
  T_49_META_TYP_148_I0_D: "يوفر مجموعة متنوعة من أنواع الكاميرات المحددة مسبقًا، بالإضافة إلى أنواع الكاميرات المخصصة",
  T_49_META_TYP_148_I1_D: "مجال الرؤية هو زاوية رؤية الكاميرا",
  T_49_META_TYP_148_I10_D: "نوع من الرسوم المتحركة لتبديل الكاميرا",
  T_49_META_TYP_148_I11_D: "لا يُفعّل إلا عندما يكون نوع التبديل سلسًا. وقت الانتقال إلى هذه الكاميرا بالمللي ثانية.",
  T_49_META_TYP_148_I12_D: "عندما يكون هناك عائق بين الكاميرا والهدف الذي يتم متابعته، يتم تغيير وضع حركة الكاميرا",
  T_49_META_TYP_148_I13_D: "كيف تقوم الكاميرا بمعالجة الصورة",
  T_49_META_TYP_148_I14_D: "اتبع نظام إحداثيات مرجع إزاحة الكائن",
  T_49_META_TYP_148_I15_D: "راقب نظام إحداثيات مرجع إزاحة الكائن",
  T_49_META_TYP_148_I16_D: "يمكن لقناع طبقة عرض الكاميرا تصفية الكائنات التي تعرضها الكاميرا حسب مستوى الرؤية",
  T_49_META_TYP_148_I17_D: "قيد زاوية الرؤية",
  T_49_META_TYP_148_I2_D: "يشير هذا المصطلح عمومًا إلى إزاحة موضع الكاميرا بالنسبة لموضع اللاعب الأصلي. ويختلف المعنى المحدد باختلاف أنواع الكاميرات.",
  T_49_META_TYP_148_I3_D: "يشير هذا المصطلح عمومًا إلى إزاحة نقطة تركيز الكاميرا بالنسبة لموضع اللاعب الأصلي. ويختلف المعنى المحدد باختلاف أنواع الكاميرات.",
  T_49_META_TYP_148_I4_D: "زاوية الدوران الرأسي للكاميرا",
  T_49_META_TYP_148_I5_D: "زاوية الدوران الأفقي للكاميرا",
  T_49_META_TYP_148_I7_D: "الهدف الذي تتبعه الكاميرا",
  T_49_META_TYP_148_I8_D: "ما الذي تنظر إليه الكاميرا",
  T_49_META_TYP_148_I9_D: "اللاعب الذي يستخدم الكاميرا حاليًا",
  T_49_META_TYP_15_I0_D: "هل جميع أعضاء الفريق ميتون حاليًا؟",
  T_49_META_TYP_15_I1_D: "قائمة بجميع أعضاء الفريق",
  T_49_META_TYP_15_I3_D: "قائمة الفرق المعادية",
  T_49_META_TYP_15_I4_D: "قائمة الفريق الودية",
  T_49_META_TYP_15_I5_D: "الفريق رقم",
  T_49_META_TYP_150_I0_D: "التحمل",
  T_49_META_TYP_150_I1_D: "نصف قطر نصفي الكرة الأرضية عند طرفي الكبسولة",
  T_49_META_TYP_150_I2_D: "عامل الضرر",
  T_49_META_TYP_152_I1_D: "الجاذبية المخصصة",
  T_49_META_TYP_152_I2_D: "سواء كان سيتم عرض المشغل، فإن True يعني العرض",
  T_49_META_TYP_154_I0_D: "لا يمكن استخدام سلاحين في وقت واحد",
  T_49_META_TYP_154_I1_D: "لا يمكن استخدامه إلا بنفس نوع السلاح",
  T_49_META_TYP_154_I2_D: "يمكن استخدامه مع سلاح آخر أو معك",
  T_49_META_TYP_155_I0_D: "درجة",
  T_49_META_TYP_155_I1_D: "أقصى متانة",
  T_49_META_TYP_155_I2_D: "المتانة الحالية",
  T_49_META_TYP_155_I3_D: "عامل تقليل الضرر",
  T_49_META_TYP_155_I4_D: "عامل تقليل ضرر الانفجار",
  T_49_META_TYP_155_I5_D: "يمكن أن يكلف المتانة",
  T_49_META_TYP_155_I6_D: "يمكن تدمير",
  T_49_META_TYP_156_I1_D: "أقصى متانة",
  T_49_META_TYP_156_I2_D: "المتانة الحالية",
  T_49_META_TYP_156_I3_D: "عامل تقليل الضرر",
  T_49_META_TYP_156_I4_D: "عامل تقليل ضرر الانفجار",
  T_49_META_TYP_156_I5_D: "يمكن أن يكلف المتانة",
  T_49_META_TYP_156_I6_D: "يمكن تدمير",
  T_49_META_TYP_157_I0_D: "لا يوجد رسوم متحركة",
  T_49_META_TYP_157_I1_D: "سلس",
  T_49_META_TYP_158_I2_D: "تعداد نوع مرساة واجهة المستخدم، القيمة الافتراضية هي 9 (المركز)",
  T_49_META_TYP_158_I6_D: "مفتاح التسمية",
  T_49_META_TYP_158_I7_D: "معلمات التسمية",
  T_49_META_TYP_158_I8_D: "الفريق الأيسر",
  T_49_META_TYP_16_I1_D: "معرف العنصر المقابل للكيان",
  T_49_META_TYP_16_I2_D: "يتم استخدامه فقط عند تحميل الكائنات بشكل ثابت لتحديد ما إذا كان يتم إنشاء NavMesh بشكل ثابت",
  T_49_META_TYP_16_I3_D: "سواء كان ذلك حظرًا ديناميكيًا لـ NavMesh",
  T_49_META_TYP_16_I4_D: "التحميل غير المتزامن",
  T_49_META_TYP_160_I0_D: "طوبة A",
  T_49_META_TYP_160_I1_D: "بلاط A",
  T_49_META_TYP_160_I10_D: "رمل A",
  T_49_META_TYP_160_I11_D: "ثلج A",
  T_49_META_TYP_160_I12_D: "خشب A",
  T_49_META_TYP_160_I13_D: "حجر A",
  T_49_META_TYP_160_I14_D: "عشب B",
  T_49_META_TYP_160_I15_D: "طوبة B",
  T_49_META_TYP_160_I16_D: "طوبة C",
  T_49_META_TYP_160_I17_D: "مسح",
  T_49_META_TYP_160_I2_D: "بلاط B",
  T_49_META_TYP_160_I3_D: "بلاط C",
  T_49_META_TYP_160_I4_D: "خيزران A",
  T_49_META_TYP_160_I5_D: "أسمنت A",
  T_49_META_TYP_160_I6_D: "حاوية A",
  T_49_META_TYP_160_I7_D: "عشب A",
  T_49_META_TYP_160_I8_D: "ثلج A",
  T_49_META_TYP_160_I9_D: "حمم A",
  T_49_META_TYP_165_I0_D: "ما إذا كان سيتم تمكين الاصطدام",
  T_49_META_TYP_165_I1_D: "ما إذا كان يعمل كمحفز",
  T_49_META_TYP_165_I2_D: "المستوى المادي، قم بتكوين المستوى في الوحدة المادية، حتى 16",
  T_49_META_TYP_166_I0_D: "إيموت 1",
  T_49_META_TYP_166_I1_D: "إيموت 2",
  T_49_META_TYP_166_I2_D: "إيموت 3",
  T_49_META_TYP_166_I3_D: "إيموت 4",
  T_49_META_TYP_166_I4_D: "إيموت 5",
  T_49_META_TYP_167_I0_D: "نوع نسيج التأثيرات البصرية",
  T_49_META_TYP_170_I0_D: "هل هو مرئي؟ إذا لم يكن مرئيًا، يتوقف العميل عن عرض الهدف.",
  T_49_META_TYP_170_I1_D: "مستوى الرؤية، نطاق القيمة [0،15]، يؤثر على الرؤية في الكاميرا",
  T_49_META_TYP_171_I0_D: "الطاقة",
  T_49_META_TYP_172_I0_D: "عدد الرصاصات",
  T_49_META_TYP_173_I0_D: "سعة الحقيبة الإضافية",
  T_49_META_TYP_173_I1_D: "تكوين جلد اللاعبين خارج اللعبة له الأولوية",
  T_49_META_TYP_173_I2_D: "معرف جلد حقيبة الظهر، تكوين جلد حقيبة الظهر",
  T_49_META_TYP_174_I2_D: "أقصى ضرر",
  T_49_META_TYP_174_I4_D: "سرعة الرمي",
  T_49_META_TYP_174_I5_D: "تأخير الانفجار، بالثواني",
  T_49_META_TYP_174_I6_D: "عامل الضرر الذاتي",
  T_49_META_TYP_174_I7_D: "نسبة الضرر للأصدقاء",
  T_49_META_TYP_174_I8_D: "نسبة عامل المركبة",
  T_49_META_TYP_174_I9_D: "غلاف",
  T_49_META_TYP_175_I0_D: "نصف قطر منطقة التجميد",
  T_49_META_TYP_175_I1_D: "مدة المنطقة المتجمدة، بالثواني",
  T_49_META_TYP_176_I0_D: "النوع الرئيسي من السلاح",
  T_49_META_TYP_176_I1_D: "نوع السلاح الفرعي",
  T_49_META_TYP_177_I0_D: "عندما يكون هناك عائق بين الكاميرا والهدف الذي يتم متابعته، فإن الكاميرا لا تقوم بإجراء أي تغييرات.",
  T_49_META_TYP_177_I1_D: "عندما يكون هناك عائق بين الكاميرا والشيء الذي يتم متابعته، سوف تتحرك الكاميرا أقرب إلى الشيء الذي يتم متابعته.",
  T_49_META_TYP_177_I2_D: "عندما يكون هناك حاجز بين الكاميرا والهدف المتبع، سيصبح الحاجز شفافًا إلى حد ما",
  T_49_META_TYP_178_I0_D: "عندما تراقب الكاميرا جسمًا ما، فإن الأجسام الأقرب تبدو أكبر والأجسام البعيدة تبدو أصغر.",
  T_49_META_TYP_178_I1_D: "عندما تراقب الكاميرا جسمًا ما، تكون الأجسام القريبة والبعيدة بنفس الحجم",
  T_49_META_TYP_184_I0_D: "حدد UUID للمورد الذي سيتم عرضه.",
  T_49_META_TYP_185_I0_D: "تقديم نموذج الشبكة للاستخدام",
  T_49_META_TYP_185_I1_D: "قائمة المواد المستخدمة في العرض",
  T_49_META_TYP_187_I0_D: "معرف العنصر",
  T_49_META_TYP_190_I0_D: "حالة مفتوحة",
  T_49_META_TYP_190_I1_D: "نتائج المباراة",
  T_49_META_TYP_190_I10_D: "قائمة النقاط 1",
  T_49_META_TYP_190_I11_D: "قائمة النقاط 2",
  T_49_META_TYP_190_I12_D: "قائمة النقاط 3",
  T_49_META_TYP_190_I13_D: "MVP للفائزين",
  T_49_META_TYP_190_I14_D: "MVP للخاسرين",
  T_49_META_TYP_190_I15_D: "عرض تفاصيل المباراة",
  T_49_META_TYP_190_I16_D: "عرض تقييم الخريطة",
  T_49_META_TYP_190_I17_D: "عرض الهدايا",
  T_49_META_TYP_190_I18_D: "عرض التقرير",
  T_49_META_TYP_190_I19_D: "عرض الإعادة",
  T_49_META_TYP_190_I20_D: "عرض المشاركة",
  T_49_META_TYP_190_I21_D: "عرض العودة إلى الردهة",
  T_49_META_TYP_190_I22_D: "عرض الإعجاب",
  T_49_META_TYP_190_I23_D: "عرض إضافة صديق",
  T_49_META_TYP_190_I24_D: "عرض الاقتصاد الخارجي",
  T_49_META_TYP_190_I4_D: "الفريق الأيمن",
  T_49_META_TYP_190_I5_D: "العناوين",
  T_49_META_TYP_190_I6_D: "ترتيب اللاعب",
  T_49_META_TYP_190_I9_D: "العناوين",
  T_49_META_TYP_191_I0_D: "النطاق المركزي",
  T_49_META_TYP_191_I4_D: "وقت الوميض المركزي، بالمللي ثانية",
  T_49_META_TYP_191_I5_D: "وقت وميض الحافة، بالمللي ثانية",
  T_49_META_TYP_191_I6_D: "تبديل تأثير إصابة القنبلة الوامضة",
  T_49_META_TYP_192_I3_D: "مدة التأثير الخاص، بالثواني",
  T_49_META_TYP_193_I1_D: "عنوان المباراة اليسار",
  T_49_META_TYP_193_I10_D: "قائمة النقاط 1",
  T_49_META_TYP_193_I11_D: "قائمة النقاط 2",
  T_49_META_TYP_193_I12_D: "قائمة النقاط 3",
  T_49_META_TYP_193_I13_D: "قائمة النقاط 4",
  T_49_META_TYP_193_I14_D: "قائمة النقاط 5",
  T_49_META_TYP_193_I15_D: "MVP للفائزين",
  T_49_META_TYP_193_I16_D: "MVP للخاسرين",
  T_49_META_TYP_193_I17_D: "عرض تفاصيل المباراة",
  T_49_META_TYP_193_I18_D: "عرض تقييم الخريطة",
  T_49_META_TYP_193_I19_D: "عرض الهدايا",
  T_49_META_TYP_193_I2_D: "عنوان المباراة اليمين",
  T_49_META_TYP_193_I20_D: "عرض التقرير",
  T_49_META_TYP_193_I21_D: "عرض الإعادة",
  T_49_META_TYP_193_I22_D: "عرض المشاركة",
  T_49_META_TYP_193_I23_D: "عرض العودة إلى الردهة",
  T_49_META_TYP_193_I24_D: "عرض الإعجاب",
  T_49_META_TYP_193_I25_D: "عرض إضافة صديق",
  T_49_META_TYP_193_I26_D: "عرض الاقتصاد الخارجي",
  T_49_META_TYP_193_I3_D: "نتائج المباراة",
  T_49_META_TYP_193_I4_D: "ترتيب الفريق",
  T_49_META_TYP_193_I5_D: "ترتيب اللاعب",
  T_49_META_TYP_193_I6_D: "تصنيف الفريق",
  T_49_META_TYP_193_I7_D: "عنوان النقاط الرئيسية",
  T_49_META_TYP_193_I8_D: "النقاط الرئيسية",
  T_49_META_TYP_193_I9_D: "العناوين",
  T_49_META_TYP_194_I0_D: "الوقت بالثواني عندما يصبح اللغم ساري المفعول",
  T_49_META_TYP_194_I1_D: "نصف قطر الزناد",
  T_49_META_TYP_194_I2_D: "الوقت المطلوب لتفجير لغم ضمن نطاق اللغم، بالثواني",
  T_49_META_TYP_194_I3_D: "يمكن تفعيله ذاتياً",
  T_49_META_TYP_194_I4_D: "يمكن تفعيله بواسطة الفريق",
  T_49_META_TYP_194_I5_D: "يمكن تفعيله بواسطة المركبة",
  T_49_META_TYP_194_I6_D: "مدة بقاء اللغم، الذي سينفجر تلقائيًا بعد انتهائه. يبدأ هذا الوقت من لحظة وضع اللغم، بالثواني.",
  T_49_META_TYP_194_I7_D: "يمكن مهاجمته",
  T_49_META_TYP_194_I8_D: "صحة",
  T_49_META_TYP_195_I0_D: "مرة واحدة",
  T_49_META_TYP_195_I2_D: "متبادل",
  T_49_META_TYP_197_I0_D: "هل هو يلعب؟",
  T_49_META_TYP_197_I1_D: "علامة بت",
  T_49_META_TYP_197_I2_D: "حدد لتشغيل تلقائيًا عند الإنشاء",
  T_49_META_TYP_198_I0_D: "معرف الدعامة المقابل للمرفق",
  T_49_META_TYP_199_I0_D: "أقصى نقطة الطاقة",
  T_49_META_TYP_199_I1_D: "تكلفة الطاقة",
  T_49_META_TYP_199_I10_D: "نسبة الضرر عند السقوط",
  T_49_META_TYP_199_I11_D: "الطاقة الحالية",
  T_49_META_TYP_199_I2_D: "تكلفة الطاقة للأعلى",
  T_49_META_TYP_199_I3_D: "تكلفة طاقة الركض",
  T_49_META_TYP_199_I4_D: "تكلفة الطاقة للاندفاع",
  T_49_META_TYP_199_I5_D: "السرعة الأفقية الأساسية",
  T_49_META_TYP_199_I6_D: "سرعة أفقي للركض",
  T_49_META_TYP_199_I7_D: "السرعة العمودية الأساسية",
  T_49_META_TYP_199_I8_D: "سرعة الركض العمودي",
  T_49_META_TYP_199_I9_D: "مسافة الركض",
  T_49_META_TYP_200_I0_D: "معرف المنطقة",
  T_49_META_TYP_200_I1_D: "معرف اللعبة",
  T_49_META_TYP_201_I0_D: "نسبة التباطؤ: النسبة المئوية التي تتباطأ بها سرعة الأجسام المائية في المياه المفتوحة",
  T_49_META_TYP_203_I0_D: "الكيان المستهدف",
  T_49_META_TYP_203_I1_D: "معرف الخاصية",
  T_49_META_TYP_203_I10_D: "الوقت الذي يبدأ فيه خادم اللعبة في العمل",
  T_49_META_TYP_203_I11_D: "القيمة الأولية",
  T_49_META_TYP_203_I12_D: "القيمة النهائية",
  T_49_META_TYP_203_I13_D: "النسبة المئوية للنجاح",
  T_49_META_TYP_203_I4_D: "أسلوب المراهقين",
  T_49_META_TYP_203_I6_D: "المدة",
  T_49_META_TYP_203_I7_D: "عكس",
  T_49_META_TYP_203_I8_D: "نقاط التحكم",
  T_49_META_TYP_203_I9_D: "فرض مزامنة حالة خادم اللعبة",
  T_49_META_TYP_204_I0_D: "أقصى ارتفاع للقفز المزدوج",
  T_49_META_TYP_204_I1_D: "نسبة الضرر الناتج عن السقوط",
  T_49_META_TYP_204_I2_D: "استعادة الطاقة",
  T_49_META_TYP_204_I3_D: "استهلاك الطاقة",
  T_49_META_TYP_204_I4_D: "أقصى طاقة",
  T_49_META_TYP_205_I0_D: "أدنى ارتفاع للطيران",
  T_49_META_TYP_205_I1_D: "أقل ارتفاع النهاية",
  T_49_META_TYP_205_I2_D: "سرعة الانزلاق الأفقية",
  T_49_META_TYP_205_I3_D: "سرعة الانزلاق العمودية",
  T_49_META_TYP_205_I4_D: "سرعة السقوط",
  T_49_META_TYP_205_I5_D: "سرعة الدوران",
  T_49_META_TYP_205_I6_D: "أقصى ارتفاع للطيران",
  T_49_META_TYP_205_I7_D: "سرعة السقوط بعد الارتفاع الزائد",
  T_49_META_TYP_205_I8_D: "تسارع السرعة المتغيرة",
  T_49_META_TYP_206_I0_D: "السرعة",
  T_49_META_TYP_206_I1_D: "التسارع",
  T_49_META_TYP_206_I10_D: "عند السرعات العالية، أقصى زاوية توجيه",
  T_49_META_TYP_206_I11_D: "معدل قاعدة استيفاء زاوية التوجيه عالية السرعة",
  T_49_META_TYP_206_I2_D: "سرعة التعزيز",
  T_49_META_TYP_206_I3_D: "مدة السباق بالثواني",
  T_49_META_TYP_206_I4_D: "وقت تهدئة العدو السريع، بالثواني",
  T_49_META_TYP_206_I6_D: "قرص مضغوط Jump، في ثوانٍ",
  T_49_META_TYP_206_I7_D: "قرص Sprint CD بعد الصعود على لوح التزلج، الوحدة: ثوانٍ",
  T_49_META_TYP_206_I8_D: "مفتاح فترة التهدئة بعد الصعود على البوست",
  T_49_META_TYP_206_I9_D: "قرص مضغوط للانزلاق على لوح التزلج، في ثوانٍ",
  T_49_META_TYP_207_I1_D: "فهرس البدء",
  T_49_META_TYP_207_I2_D: "موقع النهاية",
  T_49_META_TYP_207_I3_D: "معرف الخط البريدي",
  T_49_META_TYP_207_I4_D: "معرف المجموعة",
  T_49_META_TYP_207_I5_D: "هل انتهى الأمر؟",
  T_49_META_TYP_21_I0_D: "المستوى الأساسي لواجهة المستخدم",
  T_49_META_TYP_210_I1_D: "السرعة الأولية",
  T_49_META_TYP_210_I2_D: "التسارع",
  T_49_META_TYP_210_I3_D: "الإزاحة القصوى",
  T_49_META_TYP_210_I4_D: "موقع العالم الأولي",
  T_49_META_TYP_210_I5_D: "خادم اللعبة يفرض مزامنة معلومات الموقع",
  T_49_META_TYP_211_I0_D: "موضع محلي",
  T_49_META_TYP_211_I1_D: "موقع العالم",
  T_49_META_TYP_212_I0_D: "الذات",
  T_49_META_TYP_212_I2_D: "إحداثيات الإزاحة",
  T_49_META_TYP_213_I0_D: "الذات",
  T_49_META_TYP_213_I2_D: "إحداثيات الإزاحة",
  T_49_META_TYP_215_I0_D: "انتصار",
  T_49_META_TYP_215_I1_D: "هزيمة",
  T_49_META_TYP_215_I2_D: "بويا",
  T_49_META_TYP_215_I3_D: "تعادل",
  T_49_META_TYP_218_I0_D: "الكثافة",
  T_49_META_TYP_218_I1_D: "المدى",
  T_49_META_TYP_218_I2_D: "لون فاتح",
  T_49_META_TYP_22_I0_D: "إذا كانت حالة الفتح صحيحة، فسيتم عرضها، وإلا فسيتم إغلاقها.",
  T_49_META_TYP_22_I1_D: "معرف النموذج",
  T_49_META_TYP_22_I2_D: "معرف التحكم الأقصى الحالي",
  T_49_META_TYP_22_I3_D: "المستوى الأساسي لواجهة المستخدم",
  T_49_META_TYP_22_I4_D: "تفعيل عرض اللاعب",
  T_49_META_TYP_22_I5_D: "موقع العالم",
  T_49_META_TYP_22_I6_D: "هل هو في المشهد؟",
  T_49_META_TYP_22_I7_D: "الدوران في إحداثيات العالم",
  T_49_META_TYP_22_I8_D: "القياس في إحداثيات العالم",
  T_49_META_TYP_221_I0_D: "تأخير تغيير التروس، كلما كانت القيمة أكبر، كانت سرعة تغيير التروس أبطأ",
  T_49_META_TYP_222_I0_D: "تأخير تغيير التروس، كلما كانت القيمة أكبر، كانت سرعة تغيير التروس أبطأ",
  T_49_META_TYP_225_I0_D: "أضرار البرج",
  T_49_META_TYP_225_I1_D: "فترة الضرر (ث)",
  T_49_META_TYP_225_I10_D: "النار داخل الزاوية",
  T_49_META_TYP_225_I11_D: "معدل تقليل الأضرار",
  T_49_META_TYP_225_I12_D: "اختراق الدرع",
  T_49_META_TYP_225_I2_D: "الدقة",
  T_49_META_TYP_225_I3_D: "المدى",
  T_49_META_TYP_225_I4_D: "السرعة الزاوية",
  T_49_META_TYP_225_I5_D: "الزاوية لأعلى",
  T_49_META_TYP_225_I6_D: "الزاوية لأسفل",
  T_49_META_TYP_225_I7_D: "الحد الأقصى للـ HP",
  T_49_META_TYP_225_I8_D: "مدة الحياة (ث)",
  T_49_META_TYP_225_I9_D: "الحد الأقصى لعدد المدافع",
  T_49_META_TYP_226_I0_D: "الحالة الصحية الحالية للبرج",
  T_49_META_TYP_226_I1_D: "تمكين الهجوم",
  T_49_META_TYP_227_I0_D: "عنصر واجهة المستخدم البسيط",
  T_49_META_TYP_227_I1_D: "عنصر واجهة المستخدم للصورة",
  T_49_META_TYP_227_I10_D: "عنصر واجهة المستخدم للقماش",
  T_49_META_TYP_227_I11_D: "عنصر واجهة المستخدم للملف الشخصي",
  T_49_META_TYP_227_I12_D: "عنصر واجهة المستخدم للتبديل",
  T_49_META_TYP_227_I13_D: "عنصر واجهة المستخدم للوحة اللمس",
  T_49_META_TYP_227_I14_D: "عنصر واجهة المستخدم لجويستيك",
  T_49_META_TYP_227_I15_D: "أداة الزر الاجتماعي",
  T_49_META_TYP_227_I2_D: "عنصر واجهة المستخدم للتسمية",
  T_49_META_TYP_227_I3_D: "عنصر واجهة المستخدم للزر",
  T_49_META_TYP_227_I4_D: "عنصر واجهة المستخدم لتسمية الإدخال",
  T_49_META_TYP_227_I5_D: "لوحة",
  T_49_META_TYP_227_I6_D: "لوحة التمرير",
  T_49_META_TYP_227_I7_D: "شبكة",
  T_49_META_TYP_227_I8_D: "عنصر واجهة المستخدم للتخطيط",
  T_49_META_TYP_227_I9_D: "عنصر واجهة المستخدم للحاوية",
  T_49_META_TYP_231_I0_D: "استعادة المتانة",
  T_49_META_TYP_231_I1_D: "الفترة الزمنية لبدء التأثير، بالثواني",
  T_49_META_TYP_233_I2_D: "وقت انتهاء التوقيت، بالثواني",
  T_49_META_TYP_233_I4_D: "اسم مورد الأيقونة",
  T_49_META_TYP_234_I0_D: "وقت التشغيل، بالثواني",
  T_49_META_TYP_234_I1_D: "يمكن تفعيله ذاتياً",
  T_49_META_TYP_234_I10_D: "الحالة الصحية الحالية",
  T_49_META_TYP_234_I2_D: "يمكن تفعيله بواسطة الفريق",
  T_49_META_TYP_234_I3_D: "يمكن تفعيله بواسطة المركبة",
  T_49_META_TYP_234_I4_D: "المدة بالثواني",
  T_49_META_TYP_234_I5_D: "يمكن مهاجمته",
  T_49_META_TYP_234_I6_D: "صحة",
  T_49_META_TYP_235_I0_D: "ماكس هيلث",
  T_49_META_TYP_235_I2_D: "الحد الأقصى للعدد",
  T_49_META_TYP_237_I0_D: "سرعة الرمي",
  T_49_META_TYP_237_I1_D: "سرعة جذب اللاعب",
  T_49_META_TYP_238_I0_D: "لون الرش",
  T_49_META_TYP_239_I0_D: "السرعة الأولية",
  T_49_META_TYP_239_I1_D: "التسارع (مثل الجاذبية)",
  T_49_META_TYP_24_I0_D: "المشاجرة",
  T_49_META_TYP_24_I1_D: "سلاح",
  T_49_META_TYP_24_I10_D: "ضرر الإنزال الجوي، ضرر انتحار الوحش",
  T_49_META_TYP_24_I11_D: "ضرر الحرق عند انفجار المركبة",
  T_49_META_TYP_24_I12_D: "انفجار برميل النفط",
  T_49_META_TYP_24_I13_D: "سلاح من نوع صاروخي",
  T_49_META_TYP_24_I14_D: "وحش",
  T_49_META_TYP_24_I15_D: "منطقة ضرر",
  T_49_META_TYP_24_I17_D: "مهارة الشخصية",
  T_49_META_TYP_24_I2_D: "هجوم رمي",
  T_49_META_TYP_24_I3_D: "منطقة آمنة",
  T_49_META_TYP_24_I4_D: "مركبة",
  T_49_META_TYP_24_I5_D: "سقوط",
  T_49_META_TYP_24_I6_D: "منطقة موت",
  T_49_META_TYP_24_I7_D: "خروج",
  T_49_META_TYP_24_I8_D: "فصل الاتصال",
  T_49_META_TYP_24_I9_D: "انفجار مركبة",
  T_49_META_TYP_241_I0_D: "سرعة الجر",
  T_49_META_TYP_241_I1_D: "سرعة التأرجح",
  T_49_META_TYP_241_I2_D: "قم بتشغيل زر الجر",
  T_49_META_TYP_241_I3_D: "قم بتشغيل زر التأرجح",
  T_49_META_TYP_241_I4_D: "مرساة الحركة",
  T_49_META_TYP_241_I5_D: "تسريع الخروج المتأرجح",
  T_49_META_TYP_242_I2_D: "تأثير اليسار نشط",
  T_49_META_TYP_242_I3_D: "تأثير اليمين نشط",
  T_49_META_TYP_242_I4_D: "الخط المركزي نشط",
  T_49_META_TYP_242_I5_D: "القيمة",
  T_49_META_TYP_242_I7_D: "موضع واجهة المستخدم، فقط مكونات XY صالحة",
  T_49_META_TYP_242_I8_D: "موضع الخط الأوسط [0,1]",
  T_49_META_TYP_243_I0_D: "الملابس العلوية",
  T_49_META_TYP_243_I1_D: "الملابس السفلية",
  T_49_META_TYP_243_I2_D: "أحذية",
  T_49_META_TYP_243_I3_D: "طلاء الوجه",
  T_49_META_TYP_243_I4_D: "غطاء الرأس",
  T_49_META_TYP_243_I5_D: "بذلة",
  T_49_META_TYP_243_I6_D: "إكسسوار الوجه",
  T_49_META_TYP_244_I0_D: "النص المراد عرضه",
  T_49_META_TYP_244_I10_D: "قائمة اللاعبين الذين يمكنهم رؤية هذا الكيان",
  T_49_META_TYP_244_I11_D: "عرض التسلسل الهرمي",
  T_49_META_TYP_244_I2_D: "تتبع الهدف",
  T_49_META_TYP_244_I3_D: "عند تجاهل العمق، يمكن عرضه من خلال الحائط، وإلا فلن يمكن عرضه",
  T_49_META_TYP_244_I4_D: "مواجهة الكاميرا دائمًا",
  T_49_META_TYP_244_I5_D: 'عند ضبطه على "صحيح"، سيتم عرض الموضع على الشاشة عندما يكون خارج الشاشة',
  T_49_META_TYP_244_I6_D: "نمط الخط",
  T_49_META_TYP_244_I7_D: "نوع الخط",
  T_49_META_TYP_244_I8_D: "حجم الخط",
  T_49_META_TYP_245_I0_D: "مسار مورد التأثير",
  T_49_META_TYP_245_I11_D: "عرض التسلسل الهرمي",
  T_49_META_TYP_245_I3_D: "عند تجاهل العمق، يمكن عرضه من خلال الحائط، وإلا فلن يمكن عرضه",
  T_49_META_TYP_245_I4_D: 'عند ضبطه على "صحيح"، سيتم عرض الموضع على الشاشة عندما يكون خارج الشاشة',
  T_49_META_TYP_245_I5_D: "مواجهة الكاميرا دائمًا",
  T_49_META_TYP_245_I6_D: "نوع العرض",
  T_49_META_TYP_245_I7_D: "العرض",
  T_49_META_TYP_246_I0_D: "برتقالي",
  T_49_META_TYP_246_I1_D: "بنفسجي",
  T_49_META_TYP_246_I2_D: "أحمر",
  T_49_META_TYP_246_I3_D: "أخضر",
  T_49_META_TYP_246_I4_D: "أزرق",
  T_49_META_TYP_247_I1_D: "سباق سريع",
  T_49_META_TYP_247_I14_D: "رقصة",
  T_49_META_TYP_247_I15_D: "دردشة سريعة",
  T_49_META_TYP_247_I16_D: "التقاطات",
  T_49_META_TYP_247_I17_D: "عرض الدردشة السريعة",
  T_49_META_TYP_247_I18_D: "الصحة (HP)",
  T_49_META_TYP_247_I19_D: "الطاقة (EP)",
  T_49_META_TYP_247_I2_D: "هجوم",
  T_49_META_TYP_247_I20_D: "درع",
  T_49_META_TYP_247_I21_D: "إعادة التحميل",
  T_49_META_TYP_247_I22_D: "زر تغيير البندقية السريع",
  T_49_META_TYP_247_I23_D: "يمكن تشغيل/إيقاف زر بوق السيارة",
  T_49_META_TYP_247_I24_D: "زر الصوت (الميكروفون) لتشغيل/إيقاف التشغيل",
  T_49_META_TYP_247_I25_D: "زر تبديل العلامة تشغيل/إيقاف",
  T_49_META_TYP_247_I27_D: "يمكن تشغيل/إيقاف زر إشارة الشبكة",
  T_49_META_TYP_247_I28_D: "مهارة نشطة",
  T_49_META_TYP_247_I29_D: "تقاطع الهدف",
  T_49_META_TYP_247_I3_D: "قفز",
  T_49_META_TYP_247_I30_D: "مهارة سلبية",
  T_49_META_TYP_247_I4_D: "نصائح القتل",
  T_49_META_TYP_247_I5_D: "خانة السلاح",
  T_49_META_TYP_247_I6_D: "خريطة مصغرة",
  T_49_META_TYP_247_I7_D: "واجهة مستخدم حقيبة الظهر",
  T_49_META_TYP_247_I8_D: "أدوات طبية",
  T_49_META_TYP_247_I9_D: "إذا كانت صحيحة، سيتم عرضها، وإلا فسيتم إغلاقها.",
  T_49_META_TYP_249_I3_D: "الأسلحة المتفجرة",
  T_49_META_TYP_249_I5_D: "سلاح ثقيل",
  T_49_META_TYP_249_I8_D: "قنبلة تجميد",
  T_49_META_TYP_249_I9_D: "قنبلة وهمية",
  T_49_META_TYP_25_I0_D: "مؤشر المرحلة الحالية، المقابل للمؤشر الموجود في محرر العملية",
  T_49_META_TYP_25_I1_D: "وقت بدء المرحلة الحالية، بالمللي ثانية",
  T_49_META_TYP_25_I2_D: "وقت انتهاء المرحلة الحالية، بالمللي ثانية",
  T_49_META_TYP_25_I3_D: "مدة المرحلة الحالية، بالمللي ثانية",
  T_49_META_TYP_250_I1_D: "لون التأثير الخاص، أربع قنوات RGBA، نطاق قيمة القناة الفردية 0~255، مخزن في Int32",
  T_49_META_TYP_250_I3_D: "نوع نسيج التأثيرات البصرية",
  T_49_META_TYP_250_I4_D: "ألفا منتشر",
  T_49_META_TYP_2500_I1_D: "هل هو نقطة ظهور افتراضية",
  T_49_META_TYP_2500_I3_D: "هل يوجد لاعب ولد بالفعل في منطقة الظهور هذه؟",
  T_49_META_TYP_2500_I4_D: "إحداثيات نقطة الميلاد القابلة للتخصيص حاليًا",
  T_49_META_TYP_2502_I0_D: "سواء كان ذلك محفزًا للموت، إذا لم يكن محفزًا للموت، فهو محفز لا يقهر. (هذه مشكلة موروثة من OB32، يرجى تقسيم الوظيفة في المستقبل!)",
  T_49_META_TYP_2502_I1_D: 'سواء كان سيتم عرض حدود المشغل، فإن "صحيح" يعني العرض',
  T_49_META_TYP_2503_I0_D: "معرف نقطة التفتيش",
  T_49_META_TYP_2503_I2_D: "موقع نقطة التفتيش",
  T_49_META_TYP_2507_I0_D: "لأي معسكر ينتمي برج الدفاع؟ إذا كان من نفس معسكر اللاعب، فلن يُهاجمه.",
  T_49_META_TYP_2507_I1_D: "الصحة",
  T_49_META_TYP_2507_I10_D: "معرف الكائن",
  T_49_META_TYP_2507_I2_D: "الصحة القصوى",
  T_49_META_TYP_2507_I3_D: "ضرر الهجوم، الضرر الذي يمكن أن يسببه هجوم واحد للاعب",
  T_49_META_TYP_2507_I4_D: "الفترة بين الهجمتين، بالثواني",
  T_49_META_TYP_2507_I5_D: "يمكن مهاجمة المنطقة التي يكون فيها المركز هو المركز ونصف قطرها بأي حجم",
  T_49_META_TYP_2507_I6_D: "معدل تقليل الضرر، أقل من 1 برقم عشري. الضرر النهائي هو الضرر مضروبًا في (معدل تقليل الضرر بمقدار 1)",
  T_49_META_TYP_2507_I7_D: "هدف الهجوم",
  T_49_META_TYP_2507_I8_D: "الزاوية",
  T_49_META_TYP_2507_I9_D: "حالة البرج الصغير",
  T_49_META_TYP_2508_I0_D: "عدد الزومبي الذي سيظهر في كل موجة",
  T_49_META_TYP_2508_I1_D: "كم عدد موجات الزومبي التي سيتم إنشاؤها؟",
  T_49_META_TYP_2508_I2_D: "هل سيتم التوليد بشكل مستمر، ولكن سيكون هناك حد على نفس الشاشة",
  T_49_META_TYP_2508_I3_D: "ما هي الموجة التي تم إنشاؤها حاليًا؟",
  T_49_META_TYP_2508_I5_D: "ما نوع الزومبي الذي ظهر في الموجة الحالية؟",
  T_49_META_TYP_2508_I6_D: "هل ستسقط الذكاء الاصطناعي المعدات أو العناصر عندما تموت؟",
  T_49_META_TYP_2508_I7_D: "وقت بدء الظهور (ثانية)",
  T_49_META_TYP_2508_I8_D: "الفترة الزمنية بين الموجة التالية والموجة السابقة",
  T_49_META_TYP_2509_I0_D: "عدد الوحدات التي سيتم إنشاؤها في كل موجة",
  T_49_META_TYP_2509_I1_D: "كم عدد موجات مولدات الوحدات التي سيتم توليدها في المجموع",
  T_49_META_TYP_2509_I2_D: "ما هي الموجة التي تم إنشاؤها حاليًا؟",
  T_49_META_TYP_2509_I4_D: "ما هو الكيان الذي سيتم استخدامه كقالب لكل موجة سيتم إنشاؤها؟",
  T_49_META_TYP_2509_I5_D: "وقت ظهور الوحدة",
  T_49_META_TYP_2509_I6_D: "هل سيتم التوليد بشكل مستمر، ولكن سيكون هناك حد على نفس الشاشة",
  T_49_META_TYP_2509_I7_D: "الفترة الزمنية بين الموجة التالية والموجة السابقة",
  T_49_META_TYP_2509_I8_D: "معرف القالب المسبق",
  T_49_META_TYP_2510_I0_D: "عدد نقاط الظهور",
  T_49_META_TYP_252_I1_D: "الأيقونة اليسرى",
  T_49_META_TYP_252_I2_D: "النص اليساري",
  T_49_META_TYP_252_I3_D: "درجة اليسار",
  T_49_META_TYP_252_I5_D: "الأيقونة اليمنى",
  T_49_META_TYP_252_I6_D: "النص اليمني",
  T_49_META_TYP_252_I7_D: "درجة اليمنى",
  T_49_META_TYP_252_I8_D: "التقدم [0,1]",
  T_49_META_TYP_253_I0_D: "حدد الرمز",
  T_49_META_TYP_253_I1_D: "النص",
  T_49_META_TYP_253_I2_D: "تأثير نشط",
  T_49_META_TYP_253_I3_D: "موقع واجهة المستخدم",
  T_49_META_TYP_254_I1_D: "على سبيل المثال، 1.25 يعني 1.25 مرة السرعة العادية",
  T_49_META_TYP_254_I2_D: "لون",
  T_49_META_TYP_256_I0_D: "ساكنة تماما. الأداء الأكثر اقتصادا",
  T_49_META_TYP_256_I1_D: "استخدم القوة بشكل طبيعي. الأكثر استهلاكا للأداء",
  T_49_META_TYP_256_I2_D: "يمكن التحكم في الحركة من خلال البرامج النصية، ويمكن اعتبار الكتلة غير محدودة",
  T_49_META_TYP_257_I0_D: "أنواع مختلفة من الأجسام الصلبة لها وظائف مختلفة",
  T_49_META_TYP_257_I1_D: "استخدم الجاذبية",
  T_49_META_TYP_257_I2_D: "الكتلة (كجم)، الحد الأدنى للكتلة الفعالة هو 0.001 كجم. إذا كانت 0، فهذا يعني كتلة لا نهائية ولن تتحرك تحت تأثير القوة.",
  T_49_META_TYP_257_I3_D: "موضع مركز الثقل، نظام الإحداثيات المحلي",
  T_49_META_TYP_257_I4_D: "السرعة الخطية لحركة الجسم الصلب",
  T_49_META_TYP_257_I5_D: "السرعة الزاوية لجسم صلب",
  T_49_META_TYP_257_I6_D: "معامل التوهين الطبيعي للسرعة الخطية. كلما زاد المعامل، انخفضت سرعة الحركة بشكل أسرع.",
  T_49_META_TYP_257_I7_D: "معامل التوهين الطبيعي للسرعة الزاوية. كلما زاد المعامل، انخفضت سرعة الحركة بشكل أسرع.",
  T_49_META_TYP_257_I8_D: "القيود المفروضة على الجسم الصلب هي عبارة عن مجموعة من RigidbodyConstrainType",
  T_49_META_TYP_258_I0_D: "2017-10-10 13:38:10 ",
  T_49_META_TYP_258_I1_D: "13:45 ",
  T_49_META_TYP_258_I2_D: "10/10/2017 1:45 PM ",
  T_49_META_TYP_258_I3_D: "10/10/2017",
  T_49_META_TYP_259_I0_D: "الخلفية",
  T_49_META_TYP_259_I1_D: "النص",
  T_49_META_TYP_259_I2_D: "موقع واجهة المستخدم",
  T_49_META_TYP_259_I4_D: "لون النص",
  T_49_META_TYP_260_I0_D: "حدد الرمز",
  T_49_META_TYP_260_I1_D: "لون شريط التقدم",
  T_49_META_TYP_260_I2_D: "القيمة",
  T_49_META_TYP_260_I3_D: "السرعة، م/ث",
  T_49_META_TYP_260_I4_D: "ما إذا كان سيتم عرض المؤثرات الخاصة",
  T_49_META_TYP_260_I5_D: "موضع واجهة المستخدم [0,1]",
  T_49_META_TYP_260_I6_D: "التقدم الأولي للمهارة، القيمة هي [0، 1]. بعد إنشاء واجهة المستخدم، سيتم مزامنة التقدم فورًا مع التقدم الحالي",
  T_49_META_TYP_260_I7_D: "لون التأثير",
  T_49_META_TYP_260_I8_D: "تعيين قيمة مقياس الكائن",
  T_49_META_TYP_265_I1_D: "ما إذا كان سيتم تنفيذ ملء الخلفية",
  T_49_META_TYP_265_I2_D: "اسم الخلفية",
  T_49_META_TYP_265_I3_D: "لون الخلفية",
  T_49_META_TYP_265_I5_D: "بج ألفا",
  T_49_META_TYP_265_I6_D: "نوع القطع",
  T_49_META_TYP_265_I7_D: "نوع القناع هو اسم الصورة المحددة عند وضع القناع",
  T_49_META_TYP_265_I8_D: "وحدة تليين الحواف",
  T_49_META_TYP_267_I0_D: "نقطة بداية التمرير، الافتراضية هي الزاوية اليسرى العليا",
  T_49_META_TYP_267_I1_D: "دعم اتجاهات التمرير المتعددة",
  T_49_META_TYP_267_I10_D: "شريط أفقي",
  T_49_META_TYP_267_I11_D: "موقع العرض",
  T_49_META_TYP_267_I2_D: "اسحب المكون في اتجاه XY",
  T_49_META_TYP_267_I3_D: "دعم تأثيرات السحب المتعددة",
  T_49_META_TYP_267_I4_D: "عامل التمرير، كلما كانت القيمة أكبر، كانت عملية التمرير أسرع",
  T_49_META_TYP_267_I5_D: "عامل القصور الذاتي، كلما كانت القيمة أكبر، كلما كان القصور الذاتي أكبر عند التدحرج.",
  T_49_META_TYP_267_I6_D: "ما إذا كان السحب يقتصر على منفذ العرض، والذي يتم تحديده افتراضيًا",
  T_49_META_TYP_267_I7_D: "عند تحديد هذا المربع، سيبدأ السحب بحركة بطيئة، وإذا لم يتم تحديده، سيبدأ السحب بسرعة حركة الماوس",
  T_49_META_TYP_267_I8_D: "عندما يتناسب مع منفذ العرض، اخرج بالسحب",
  T_49_META_TYP_267_I9_D: "شريط عمودي",
  T_49_META_TYP_268_I0_D: "افتراضي",
  T_49_META_TYP_268_I1_D: "إغلاق",
  T_49_META_TYP_268_I2_D: "عرض",
  T_49_META_TYP_269_I0_D: "مالك",
  T_49_META_TYP_269_I1_D: "معرف المجموعة",
  T_49_META_TYP_269_I2_D: "معرف غطاء الرأس",
  T_49_META_TYP_269_I3_D: "معرف الوجه",
  T_49_META_TYP_269_I4_D: "معرف المكياج",
  T_49_META_TYP_269_I5_D: "معرف الجزء العلوي من الجسم",
  T_49_META_TYP_269_I6_D: "معرف الجزء السفلي من الجسم",
  T_49_META_TYP_269_I7_D: "معرف الحذاء",
  T_49_META_TYP_272_I0_D: "أنثى",
  T_49_META_TYP_272_I1_D: "ذكر",
  T_49_META_TYP_273_I0_D: "إحداثيات العالم المقابلة لمركز الخريطة الصغيرة",
  T_49_META_TYP_273_I1_D: "حجم الخريطة الصغيرة والعرض والارتفاع متماثلان",
  T_49_META_TYP_273_I2_D: "ما إذا كان سيتم تمكين وضع عرض خريطة عمق الخريطة المصغرة",
  T_49_META_TYP_274_I1_D: "القياس",
  T_49_META_TYP_274_I4_D: "مستوى عرض الأيقونة",
  T_49_META_TYP_275_I0_D: "تحجيم العظام",
  T_49_META_TYP_275_I1_D: "إحداثيات العالم لعقدة العظام",
  T_49_META_TYP_276_I0_D: "رأس",
  T_49_META_TYP_276_I1_D: "الذراع اليسرى",
  T_49_META_TYP_276_I2_D: "اليد اليسرى",
  T_49_META_TYP_276_I3_D: "الذراع اليمنى",
  T_49_META_TYP_276_I4_D: "اليد اليمنى",
  T_49_META_TYP_276_I5_D: "الجذع",
  T_49_META_TYP_276_I6_D: "الساق اليسرى",
  T_49_META_TYP_276_I7_D: "القدم اليسرى",
  T_49_META_TYP_276_I8_D: "الساق اليمنى",
  T_49_META_TYP_276_I9_D: "القدم اليمنى",
  T_49_META_TYP_277_I1_D: "مسافة كشف شعاع الكاميرا",
  T_49_META_TYP_277_I2_D: "قناع طبقة الاصطدام لاكتشاف أشعة الكاميرا",
  T_49_META_TYP_277_I3_D: "إزاحة موضع الزر",
  T_49_META_TYP_277_I4_D: "معرف مورد الرمز",
  T_49_META_TYP_277_I5_D: "حجم منطقة النقر",
  T_49_META_TYP_277_I6_D: "ما إذا كان سيتم عرض الكائن عند نقطة الهدف",
  T_49_META_TYP_277_I7_D: "كائن عرض نقطة الهدف",
  T_49_META_TYP_278_I0_D: "الكيان المستهدف لتوليد بكسلات الخريطة",
  T_49_META_TYP_28_I0_D: "هل يمكن إعادة تعيينه في كل جولة؟",
  T_49_META_TYP_280_I0_D: "نصف قطر الكرة",
  T_49_META_TYP_281_I0_D: "نصف قطر نصفي الكرة الأرضية عند طرفي الكبسولة",
  T_49_META_TYP_29_I0_D: "كرة",
  T_49_META_TYP_29_I1_D: "شعاع ضوء",
  T_49_META_TYP_29_I10_D: "يتم الآن استخدام عمود الضوء الموجود على باطن القدم للتغذية الراجعة عند دخول خط النهاية",
  T_49_META_TYP_29_I11_D: "تجميد",
  T_49_META_TYP_29_I12_D: "ضوء",
  T_49_META_TYP_29_I13_D: "تيار صاعد",
  T_49_META_TYP_29_I14_D: "انفجار غاز",
  T_49_META_TYP_29_I15_D: "القاتل المختبئ",
  T_49_META_TYP_29_I16_D: "الإبادة",
  T_49_META_TYP_29_I17_D: "موت النسخ",
  T_49_META_TYP_29_I18_D: "ملاحظات إطلاق النار",
  T_49_META_TYP_29_I19_D: "موت النسخ",
  T_49_META_TYP_29_I2_D: "انفجار",
  T_49_META_TYP_29_I20_D: "نسخة",
  T_49_META_TYP_29_I21_D: "بوابة",
  T_49_META_TYP_29_I22_D: "دخان قنبلة فلاش",
  T_49_META_TYP_29_I23_D: "كرة نارية",
  T_49_META_TYP_29_I24_D: "احتراق مستمر",
  T_49_META_TYP_29_I25_D: "غاز سام",
  T_49_META_TYP_29_I26_D: "قلب",
  T_49_META_TYP_29_I29_D: "باب",
  T_49_META_TYP_29_I30_D: "ألعاب نارية",
  T_49_META_TYP_29_I31_D: "تأثيرات الأحذية الرياضية",
  T_49_META_TYP_29_I32_D: "تأثيرات الانفجار",
  T_49_META_TYP_29_I33_D: "تأثيرات نقطة الظهور",
  T_49_META_TYP_29_I34_D: "تأثيرات الليزر",
  T_49_META_TYP_29_I35_D: "تأثيرات استخدام المهارة",
  T_49_META_TYP_29_I36_D: "تأثيرات الرصاص",
  T_49_META_TYP_29_I37_D: "تأثيرات إصابة الرصاص",
  T_49_META_TYP_29_I38_D: "تأثيرات إطلاق النار",
  T_49_META_TYP_29_I39_D: "تأثيرات المهارة",
  T_49_META_TYP_29_I40_D: "هالة",
  T_49_META_TYP_29_I41_D: "فقاعة",
  T_49_META_TYP_29_I42_D: "دخان وغبار",
  T_49_META_TYP_29_I43_D: "حطام طائر",
  T_49_META_TYP_29_I44_D: "خط",
  T_49_META_TYP_29_I45_D: "وميض",
  T_49_META_TYP_29_I47_D: "جزيئات صاعدة",
  T_49_META_TYP_29_I48_D: "دخان",
  T_49_META_TYP_29_I49_D: "تعويذة",
  T_49_META_TYP_29_I50_D: "منطقة متجمدة",
  T_49_META_TYP_29_I51_D: "ضباب",
  T_49_META_TYP_29_I52_D: "رقاقات ثلجية",
  T_49_META_TYP_29_I53_D: "نار",
  T_49_META_TYP_29_I54_D: "شعاع ضوء",
  T_49_META_TYP_29_I55_D: "انتشار الغاز السام",
  T_49_META_TYP_29_I56_D: "غاز سام",
  T_49_META_TYP_29_I57_D: "لهيب الانفجار",
  T_49_META_TYP_29_I58_D: "تأثير الضوء",
  T_49_META_TYP_29_I59_D: "نجم",
  T_49_META_TYP_29_I6_D: "هالة تحت قدميك",
  T_49_META_TYP_29_I60_D: "نار المخيم المشتعلة",
  T_49_META_TYP_29_I61_D: "رش ماء",
  T_49_META_TYP_29_I62_D: "صدمة كهربائية",
  T_49_META_TYP_29_I63_D: "تأثير الحبر",
  T_49_META_TYP_29_I64_D: "تأثير الثقب الأسود",
  T_49_META_TYP_29_I65_D: "تأثيرات الانفجار الثقب الأسود",
  T_49_META_TYP_29_I66_D: "تأثيرات كرة الكريستال",
  T_49_META_TYP_29_I67_D: "تأثيرات خاصة لرصاصة الليزر",
  T_49_META_TYP_29_I68_D: "تأثير التتبع",
  T_49_META_TYP_29_I69_D: "تأثيرات السحابة",
  T_49_META_TYP_29_I7_D: "علامة أرضية",
  T_49_META_TYP_29_I8_D: "دخان",
  T_49_META_TYP_29_I9_D: "انفجار تعويذة",
  T_49_META_TYP_290_I0_D: "فترة التحديث، كلما كان الرقم أكبر، كانت عملية التحديث أبطأ، بالمللي ثانية",
  T_49_META_TYP_290_I1_D: "ما إذا كان سيتم تمكين التصحيح",
  T_49_META_TYP_291_I0_D: "عقدةالشرط",
  T_49_META_TYP_291_I1_D: "عقدةالفعل",
  T_49_META_TYP_293_I0_D: "معرف شجرة السلوك",
  T_49_META_TYP_293_I1_D: "الهدف المرفق",
  T_49_META_TYP_294_I1_D: "نوع التخطيط",
  T_49_META_TYP_294_I10_D: "نوع الفرز",
  T_49_META_TYP_294_I2_D: "أصل المحتوى",
  T_49_META_TYP_294_I3_D: "اتجاه الترتيب",
  T_49_META_TYP_294_I4_D: "عرض وارتفاع شبكة العناصر الفرعية",
  T_49_META_TYP_294_I5_D: "مساحة الخلية",
  T_49_META_TYP_294_I6_D: "القيد",
  T_49_META_TYP_294_I7_D: "عدد القيود",
  T_49_META_TYP_294_I8_D: "الإزاحة الرأسية",
  T_49_META_TYP_294_I9_D: "الإزاحة الأفقية",
  T_49_META_TYP_295_I2_D: "سرعة التشغيل",
  T_49_META_TYP_296_I1_D: "طول المقطع",
  T_49_META_TYP_297_I0_D: "كائن مرتبط",
  T_49_META_TYP_297_I4_D: "معرف المورد",
  T_49_META_TYP_298_I0_D: "افتراضي",
  T_49_META_TYP_298_I2_D: "مرة واحدة",
  T_49_META_TYP_30_I0_D: "مربع",
  T_49_META_TYP_30_I1_D: "رباعي الأضلاع",
  T_49_META_TYP_30_I10_D: "سهم",
  T_49_META_TYP_30_I11_D: "تعليق",
  T_49_META_TYP_30_I12_D: "صخرة",
  T_49_META_TYP_30_I13_D: "مقص",
  T_49_META_TYP_30_I14_D: "ورقة",
  T_49_META_TYP_30_I15_D: "إعجاب",
  T_49_META_TYP_30_I16_D: "صحيح",
  T_49_META_TYP_30_I17_D: "خطأ",
  T_49_META_TYP_30_I18_D: "زائد",
  T_49_META_TYP_30_I19_D: "البرق",
  T_49_META_TYP_30_I2_D: "شبه منحرف قائم الزاوية",
  T_49_META_TYP_30_I20_D: "قلب",
  T_49_META_TYP_30_I21_D: "نجم",
  T_49_META_TYP_30_I22_D: "قمر",
  T_49_META_TYP_30_I23_D: "شمس",
  T_49_META_TYP_30_I24_D: "نظارات",
  T_49_META_TYP_30_I25_D: "مفتاح",
  T_49_META_TYP_30_I26_D: "كأس",
  T_49_META_TYP_30_I27_D: "علم",
  T_49_META_TYP_30_I28_D: "ساعة رملية",
  T_49_META_TYP_30_I29_D: "مجلد",
  T_49_META_TYP_30_I3_D: "شبه منحرف",
  T_49_META_TYP_30_I30_D: "مجلد مفتوح",
  T_49_META_TYP_30_I31_D: "منزل",
  T_49_META_TYP_30_I32_D: "راحة",
  T_49_META_TYP_30_I33_D: "تحديث",
  T_49_META_TYP_30_I34_D: "حلقة",
  T_49_META_TYP_30_I35_D: "مكبر",
  T_49_META_TYP_30_I36_D: "سلة المهملات",
  T_49_META_TYP_30_I37_D: "العودة",
  T_49_META_TYP_30_I38_D: "جوهرة",
  T_49_META_TYP_30_I39_D: "حلقة سباحة",
  T_49_META_TYP_30_I4_D: "مسدس الأضلاع",
  T_49_META_TYP_30_I40_D: "نقود",
  T_49_META_TYP_30_I41_D: "قفل",
  T_49_META_TYP_30_I42_D: "إعدادات",
  T_49_META_TYP_30_I43_D: "خروج",
  T_49_META_TYP_30_I44_D: "حوار",
  T_49_META_TYP_30_I45_D: "نقطة استهداف",
  T_49_META_TYP_30_I46_D: "بندقية",
  T_49_META_TYP_30_I47_D: "سيف",
  T_49_META_TYP_30_I48_D: "انفجار",
  T_49_META_TYP_30_I49_D: "تصويب",
  T_49_META_TYP_30_I5_D: "دائري",
  T_49_META_TYP_30_I50_D: "صليب",
  T_49_META_TYP_30_I51_D: "دفاع",
  T_49_META_TYP_30_I52_D: "وحش",
  T_49_META_TYP_30_I53_D: "إعادة تدوير",
  T_49_META_TYP_30_I54_D: "هدية",
  T_49_META_TYP_30_I55_D: "ملابس",
  T_49_META_TYP_30_I56_D: "لعبة",
  T_49_META_TYP_30_I57_D: "لاعب",
  T_49_META_TYP_30_I58_D: "متجر",
  T_49_META_TYP_30_I59_D: "مخرج",
  T_49_META_TYP_30_I6_D: "مثلث",
  T_49_META_TYP_30_I60_D: "تحذير",
  T_49_META_TYP_30_I61_D: "نص",
  T_49_META_TYP_30_I62_D: "كائن المؤقت",
  T_49_META_TYP_30_I63_D: "جرس",
  T_49_META_TYP_30_I64_D: "حيوان أليف",
  T_49_META_TYP_30_I65_D: "قنبلة",
  T_49_META_TYP_30_I66_D: "إصلاح",
  T_49_META_TYP_30_I67_D: "وجه مبتسم",
  T_49_META_TYP_30_I68_D: "مكبر صوت",
  T_49_META_TYP_30_I7_D: "علامة تعجب",
  T_49_META_TYP_30_I70_D: "تاج",
  T_49_META_TYP_30_I71_D: "معركة",
  T_49_META_TYP_30_I72_D: "رابطة",
  T_49_META_TYP_30_I73_D: "نبض القلب",
  T_49_META_TYP_30_I74_D: "موسيقى",
  T_49_META_TYP_30_I75_D: "المركبة",
  T_49_META_TYP_30_I76_D: "الأسلحة القتالية",
  T_49_META_TYP_30_I77_D: "مسدس",
  T_49_META_TYP_30_I78_D: "بندوق",
  T_49_META_TYP_30_I79_D: "بندقية قناصة",
  T_49_META_TYP_30_I8_D: "علامة استفهام",
  T_49_META_TYP_30_I80_D: "بندقية خرطوش",
  T_49_META_TYP_30_I81_D: "رشاش",
  T_49_META_TYP_30_I82_D: "مسدس شفاء",
  T_49_META_TYP_30_I83_D: "تدمير درع",
  T_49_META_TYP_30_I84_D: "طلقة الرأس",
  T_49_META_TYP_30_I85_D: "مهارة 1",
  T_49_META_TYP_30_I86_D: "مهارة 2",
  T_49_META_TYP_30_I87_D: "مهارة 3",
  T_49_META_TYP_30_I88_D: "مهارة 4",
  T_49_META_TYP_30_I89_D: "مهارة 5",
  T_49_META_TYP_30_I9_D: "علامة",
  T_49_META_TYP_30_I90_D: "مهارة 6",
  T_49_META_TYP_30_I91_D: "مهارة 7",
  T_49_META_TYP_30_I92_D: "مهارة 8",
  T_49_META_TYP_30_I93_D: "مهارة 9",
  T_49_META_TYP_30_I94_D: "مهارة 10",
  T_49_META_TYP_300_I0_D: "معرف المورد",
  T_49_META_TYP_300_I2_D: "دوران",
  T_49_META_TYP_300_I3_D: "الكيان المُنشأ",
  T_49_META_TYP_301_I1_D: "تدمير ذاتي",
  T_49_META_TYP_301_I2_D: "هجوم الاندفاع",
  T_49_META_TYP_301_I3_D: "موجة صاعقة",
  T_49_META_TYP_301_I4_D: "هجوم الإعصار",
  T_49_META_TYP_301_I5_D: "هجوم القفز",
  T_49_META_TYP_301_I6_D: "رفع الدرع",
  T_49_META_TYP_301_I7_D: "الدرع مكسور",
  T_49_META_TYP_302_I5_D: "حقيبة",
  T_49_META_TYP_302_I7_D: "لوح التزلج، التمويه...",
  T_49_META_TYP_303_I0_D: "إضافة الحد الأقصى من نقاط الصحة للاعب",
  T_49_META_TYP_303_I1_D: "استعادة نقاط صحة اللاعب بشكل مستمر",
  T_49_META_TYP_305_I0_D: "إنهاء",
  T_49_META_TYP_305_I1_D: "جاري",
  T_49_META_TYP_307_I0_D: "الخبرة لكل ضرر",
  T_49_META_TYP_307_I1_D: "الخبرة لكل ميل تم التحرك فيه",
  T_49_META_TYP_307_I2_D: "الخبرة لكل ثانية",
  T_49_META_TYP_307_I3_D: "خبرة الشريحة",
  T_49_META_TYP_307_I4_D: "الحد الأقصى للشحن",
  T_49_META_TYP_308_I0_D: "صانع الجل",
  T_49_META_TYP_31_I0_D: "انفجار قنبلة يدوية",
  T_49_META_TYP_31_I1_D: "طلق ناري",
  T_49_META_TYP_31_I10_D: "تأثير صوتي يسبب الضرر",
  T_49_META_TYP_31_I11_D: "مؤثرات صوتية مطورة",
  T_49_META_TYP_31_I12_D: "تأثير صوت النقر الضعيف",
  T_49_META_TYP_31_I13_D: "خطوات اللاعب على تأثير صوت الآلية",
  T_49_META_TYP_31_I14_D: "تأثير صوتي لإصلاح المعدات",
  T_49_META_TYP_31_I15_D: "تأثير صوتي لإصلاح المعدات",
  T_49_META_TYP_31_I16_D: "المؤثرات الصوتية الخاطئة أو المفقودة",
  T_49_META_TYP_31_I17_D: "تأثير صوتي للتذكير",
  T_49_META_TYP_31_I18_D: "تأثير صوت هبوط كرة القدم",
  T_49_META_TYP_31_I19_D: "تأثير صوت الهتاف",
  T_49_META_TYP_31_I2_D: "صافرة العد التنازلي",
  T_49_META_TYP_31_I20_D: "تأثير صوتي لتحذير القنبلة",
  T_49_META_TYP_31_I21_D: "تأثير صوت انفجار القنبلة",
  T_49_META_TYP_31_I22_D: "يظهر الصياد تأثير الصوت",
  T_49_META_TYP_31_I23_D: "تأثير الصوت النهائي للموسيقى الخلفية",
  T_49_META_TYP_31_I24_D: "تأثير صوت تحديث صندوق الإمدادات",
  T_49_META_TYP_31_I25_D: "مؤثرات صوتية للمسرع",
  T_49_META_TYP_31_I26_D: "تأثير صوتي للتذكير بالاختفاء",
  T_49_META_TYP_31_I27_D: "المؤثرات البصرية والمؤثرات الصوتية",
  T_49_META_TYP_31_I28_D: "مؤثرات صوتية للحشرات الليلية",
  T_49_META_TYP_31_I29_D: "تأثير صوت الضرب باهت",
  T_49_META_TYP_31_I3_D: "اضغط",
  T_49_META_TYP_31_I30_D: "مؤثرات صوتية متجاوبة",
  T_49_META_TYP_31_I31_D: "اكتشف المؤثرات الصوتية المدهشة",
  T_49_META_TYP_31_I32_D: "شبح صغير يلعب تأثيرًا صوتيًا",
  T_49_META_TYP_31_I33_D: "تأثير صوت بدء المرحلة",
  T_49_META_TYP_31_I34_D: "مؤثرات صوتية للزومبي",
  T_49_META_TYP_31_I35_D: "مؤثرات صوتية رعب",
  T_49_META_TYP_31_I36_D: "مؤثرات صوتية للتحول",
  T_49_META_TYP_31_I37_D: "تأثير صوت ضربات القلب السريعة",
  T_49_META_TYP_31_I38_D: "تأثير صوت ضربات القلب متوسطة السرعة",
  T_49_META_TYP_31_I39_D: "تأثير صوت ضربات القلب البطيئة",
  T_49_META_TYP_31_I4_D: "صرخات أنثوية عند الضرب",
  T_49_META_TYP_31_I40_D: "مؤثرات صوتية للغضب",
  T_49_META_TYP_31_I41_D: "تأثير صوت النقر",
  T_49_META_TYP_31_I42_D: "تأثير صوتي لاستعادة المهارة",
  T_49_META_TYP_31_I43_D: "تمت إضافة المؤثرات الصوتية للعبة",
  T_49_META_TYP_31_I44_D: "تأثير صدى الصوت الميكانيكي",
  T_49_META_TYP_31_I45_D: "تأثير صوت البعوض",
  T_49_META_TYP_31_I46_D: "تأثير صوتي مكثف دينغ دينغ دينغ 1",
  T_49_META_TYP_31_I47_D: "المؤثرات الصوتية المكثفة للعبة Ding Ding Ding 2",
  T_49_META_TYP_31_I48_D: "تأثير صوت فتح الآلية",
  T_49_META_TYP_31_I49_D: "تأثير صوت الشحن 1",
  T_49_META_TYP_31_I5_D: "صرخات ذكورية عند الضرب",
  T_49_META_TYP_31_I50_D: "تأثير صوتي لخطوات الأقدام",
  T_49_META_TYP_31_I51_D: "تأثير صوتي لرسالة نجاح المهمة 1",
  T_49_META_TYP_31_I52_D: "صوت تحذير الخطر 1 تأثير صوتي",
  T_49_META_TYP_31_I53_D: "صوت تحذير الخطر 2 تأثير صوتي",
  T_49_META_TYP_31_I54_D: "تأثير صوتي للعد التنازلي 3",
  T_49_META_TYP_31_I55_D: "عرض نصائح تأثير الصوت",
  T_49_META_TYP_31_I56_D: "تأثير صوتي محيطي لنداء الغربان",
  T_49_META_TYP_31_I57_D: "تأثير صوتي للانتقال إلى المنطقة الخاطئة باستخدام جهاز النقل الآني",
  T_49_META_TYP_31_I58_D: "التأثير الصوتي للانتقال الآني إلى المنطقة الصحيحة باستخدام نقطة النقل الآني",
  T_49_META_TYP_31_I59_D: "نقل الصوت",
  T_49_META_TYP_31_I6_D: "تأثير صوتي لالتقاط العملة الذهبية",
  T_49_META_TYP_31_I60_D: "تأثير صوت الصدمة الكهربائية",
  T_49_META_TYP_31_I61_D: "احصل على مؤثرات صوتية دعائية",
  T_49_META_TYP_31_I62_D: "مؤثرات صوتية لموسيقى خلفية إلكترونية حالمة لطيفة",
  T_49_META_TYP_31_I63_D: "مؤثرات صوتية لموسيقى خلفية الألعاب غير الرسمية",
  T_49_META_TYP_31_I64_D: "فتح صندوق",
  T_49_META_TYP_31_I65_D: "ترقية التصنيف",
  T_49_META_TYP_31_I66_D: "أقصى مستوى",
  T_49_META_TYP_31_I67_D: "زر النقر",
  T_49_META_TYP_31_I68_D: "العد التنازلي",
  T_49_META_TYP_31_I69_D: "هزيمة العدو",
  T_49_META_TYP_31_I7_D: "تأثير صوتي محفز لعبور خط النهاية في السباق",
  T_49_META_TYP_31_I70_D: "نهاية",
  T_49_META_TYP_31_I71_D: "تقدم للأمام",
  T_49_META_TYP_31_I72_D: "انتصار",
  T_49_META_TYP_31_I73_D: "نقطة تفتيش قاعدة التدريب",
  T_49_META_TYP_31_I74_D: "العد التنازلي",
  T_49_META_TYP_31_I75_D: "بدء اللعبة",
  T_49_META_TYP_31_I76_D: "الحصول على ذهب كبير",
  T_49_META_TYP_31_I77_D: "الحصول على ذهب متوسط",
  T_49_META_TYP_31_I78_D: "الحصول على ذهب صغير",
  T_49_META_TYP_31_I79_D: "الانضمام إلى المعركة",
  T_49_META_TYP_31_I8_D: "تأثير صوت الزناد",
  T_49_META_TYP_31_I80_D: "إمدادات الرابطة",
  T_49_META_TYP_31_I81_D: "مكبر صوت",
  T_49_META_TYP_31_I82_D: "عزل قائد الرابطة",
  T_49_META_TYP_31_I83_D: "حفظ المستودع",
  T_49_META_TYP_31_I84_D: "صوت سلاح خاص",
  T_49_META_TYP_31_I85_D: "إصابة الرصاص",
  T_49_META_TYP_31_I86_D: "تحريك",
  T_49_META_TYP_31_I87_D: "نقر على زر التعطيل",
  T_49_META_TYP_31_I88_D: "اكتمال شحن المهارة",
  T_49_META_TYP_31_I89_D: "مهارة الليزر",
  T_49_META_TYP_31_I9_D: "المؤثرات الصوتية المتدهورة",
  T_49_META_TYP_31_I90_D: "الحصول على مستهلك 2",
  T_49_META_TYP_31_I91_D: "العد التنازلي 3",
  T_49_META_TYP_31_I92_D: "انتهاء اللعبة 2",
  T_49_META_TYP_31_I93_D: "تحذير القتل",
  T_49_META_TYP_31_I94_D: "انفجار",
  T_49_META_TYP_31_I95_D: "مهارة كرة الطاقة",
  T_49_META_TYP_31_I96_D: "مهارة بركة الدم",
  T_49_META_TYP_311_I1_D: "أقصى ضرر",
  T_49_META_TYP_311_I3_D: "سرعة طيران الجسم المقذوف بعد خروجه من اليد، بوحدة م/ث",
  T_49_META_TYP_311_I4_D: "الفترة الزمنية من لحظة تحرير الكائن الذي تم إلقاؤه إلى لحظة تأثيره، بالثواني",
  T_49_META_TYP_313_I0_D: "نصف قطر المنطقة",
  T_49_META_TYP_313_I1_D: "مدة منطقة العداد، بالثواني",
  T_49_META_TYP_314_I0_D: "معرف مورد وحدة التحكم في الرسوم المتحركة",
  T_49_META_TYP_314_I1_D: "متحكم الرسوم المتحركة",
  T_49_META_TYP_315_I0_D: "مالك حقيبة الظهر",
  T_49_META_TYP_315_I1_D: "مساحة حقيبة الظهر",
  T_49_META_TYP_315_I2_D: "السعة المستخدمة",
  T_49_META_TYP_315_I3_D: "جميع الإمدادات",
  T_49_META_TYP_316_I0_D: "مورد الملمس",
  T_49_META_TYP_316_I1_D: "اسم الظل",
  T_49_META_TYP_316_I11_D: "طريقة التقليب",
  T_49_META_TYP_316_I2_D: "إزاحة UV",
  T_49_META_TYP_316_I3_D: "حجم UV",
  T_49_META_TYP_316_I4_D: "نوع التعبئة",
  T_49_META_TYP_316_I5_D: "الحدود اليمنى واليسرى",
  T_49_META_TYP_316_I6_D: "الحدود العليا والسفلى",
  T_49_META_TYP_317_I0_D: "لا يوجد",
  T_49_META_TYP_317_I1_D: "موقف التجميد X",
  T_49_META_TYP_317_I2_D: "موقف التجميد Y",
  T_49_META_TYP_317_I3_D: "موقف التجميد Z",
  T_49_META_TYP_317_I4_D: "تحديد الدوران حول المحور X",
  T_49_META_TYP_317_I5_D: "تحديد الدوران حول المحور Y",
  T_49_META_TYP_317_I6_D: "الحد من الدوران حول المحور Z",
  T_49_META_TYP_317_I7_D: "موقف التجميد",
  T_49_META_TYP_317_I8_D: "تجميد الدوران",
  T_49_META_TYP_317_I9_D: "تجميد الكل",
  T_49_META_TYP_318_I0_D: "يتراوح",
  T_49_META_TYP_318_I1_D: "مسافة الضرر الكامل",
  T_49_META_TYP_318_I10_D: "عامل سرعة تصويب اللاعب",
  T_49_META_TYP_318_I11_D: "نسبة تكبير الرؤية",
  T_49_META_TYP_318_I12_D: "تكبير زاوية الرؤية (FOV)",
  T_49_META_TYP_318_I13_D: "تكبير التصويب",
  T_49_META_TYP_318_I14_D: "وقت تكبير التصويب (ثانية)",
  T_49_META_TYP_318_I15_D: "وقت استعادة التصويب (ثانية)",
  T_49_META_TYP_318_I16_D: "عامل تصحيح الحد الأدنى لمسافة الضرر للنطاق",
  T_49_META_TYP_318_I17_D: "السماح بمساعدة التصويب",
  T_49_META_TYP_318_I18_D: "نسبة جذب شاشة الصليب لمساعد التصويب (0-1)",
  T_49_META_TYP_318_I19_D: "معامل توهين المسافة لمساعدة التصويب (0-1)",
  T_49_META_TYP_318_I2_D: "الحد الأدنى لمسافة الضرر",
  T_49_META_TYP_318_I20_D: "السماح بأولوية المسافة لمساعدة التصويب",
  T_49_META_TYP_318_I21_D: "أقل مسافة لأولوية مساعدة التصويب",
  T_49_META_TYP_318_I22_D: "أقصى مسافة لأولوية مساعدة التصويب",
  T_49_META_TYP_318_I23_D: "معامل التأثير لمساعد التصويب على مسافة الأولوية (>=1)",
  T_49_META_TYP_318_I24_D: "حساسية دوران التصويب",
  T_49_META_TYP_318_I25_D: "سرعة الانكماش",
  T_49_META_TYP_318_I3_D: "حجم مخزن الذخيرة",
  T_49_META_TYP_318_I4_D: "فترة الهجوم",
  T_49_META_TYP_318_I5_D: "سرعة إعادة التحميل",
  T_49_META_TYP_318_I6_D: "سرعة إعادة التحميل التلقائية",
  T_49_META_TYP_318_I7_D: "سرعة التشتت",
  T_49_META_TYP_318_I8_D: "معدل التشتت عند الانحناء أو الاستلقاء. كل ٠.١ يعني أن نطاق علامة التصويب يزداد بنسبة ١٠٪ لكل رصاصة.",
  T_49_META_TYP_318_I9_D: "أقصى تشتت",
  T_49_META_TYP_319_I0_D: "بسيط",
  T_49_META_TYP_319_I1_D: "مقطع",
  T_49_META_TYP_319_I2_D: "مبلط",
  T_49_META_TYP_319_I3_D: "ممتلئ",
  T_49_META_TYP_319_I4_D: "يناسب",
  T_49_META_TYP_32_I0_D: "اللاعب في حالة نشطة طبيعية",
  T_49_META_TYP_32_I1_D: "اللاعب في حالة سقوط",
  T_49_META_TYP_32_I2_D: "اللاعب في حالة ميتة",
  T_49_META_TYP_320_I0_D: "أفقي",
  T_49_META_TYP_320_I1_D: "عمودي",
  T_49_META_TYP_320_I2_D: "شعاعي 90°",
  T_49_META_TYP_320_I3_D: "شعاعي 180°",
  T_49_META_TYP_320_I4_D: "شعاعي 360°",
  T_49_META_TYP_321_I0_D: "الحد الأقصى للمسافة لتشغيل مساعدة التصويب",
  T_49_META_TYP_321_I1_D: "إزاحة خط التصويب عند تفعيل التصويب المساعد. إذا لم تكن نقطة الإزاحة داخل الكيان، فسيفشل التصويب المساعد.",
  T_49_META_TYP_322_I0_D: "لا أحد",
  T_49_META_TYP_322_I1_D: "رأس",
  T_49_META_TYP_322_I2_D: "جسم",
  T_49_META_TYP_322_I3_D: "أطراف",
  T_49_META_TYP_323_I0_D: "المقياس",
  T_49_META_TYP_323_I1_D: "رقم الحساب",
  T_49_META_TYP_323_I2_D: "معلومات ملف تعريف اللاعب",
  T_49_META_TYP_323_I3_D: "الأسلوب",
  T_49_META_TYP_323_I4_D: "عرض الرتبة",
  T_49_META_TYP_323_I5_D: "عرض الدبوس",
  T_49_META_TYP_323_I6_D: "عرض اللقب",
  T_49_META_TYP_324_I0_D: "يولد قوة ذات مقدار محدد",
  T_49_META_TYP_324_I1_D: "يولد تسارعًا بحجم محدد",
  T_49_META_TYP_324_I2_D: "يولد نبضة بحجم محدد",
  T_49_META_TYP_324_I3_D: "يولد سرعة الحجم المحدد",
  T_49_META_TYP_326_I0_D: "معرف الحساب",
  T_49_META_TYP_326_I1_D: "معرف الصورة الرمزية",
  T_49_META_TYP_326_I2_D: "معرف الشعار",
  T_49_META_TYP_326_I3_D: "معرف الدبوس",
  T_49_META_TYP_326_I4_D: "لقب اللاعب",
  T_49_META_TYP_326_I5_D: "تصنيف BR",
  T_49_META_TYP_326_I6_D: "أعلى تصنيف BR",
  T_49_META_TYP_326_I7_D: "تصنيف CS",
  T_49_META_TYP_326_I8_D: "أعلى تصنيف CS",
  T_49_META_TYP_327_I0_D: "معرف المورد",
  T_49_META_TYP_327_I1_D: "قناع الجزء 1",
  T_49_META_TYP_327_I2_D: "قناع الجزء 2",
  T_49_META_TYP_327_I3_D: "قناع الجزء 3",
  T_49_META_TYP_327_I4_D: "قناع الجزء 4",
  T_49_META_TYP_329_I0_D: "سائق",
  T_49_META_TYP_329_I1_D: "راكب A",
  T_49_META_TYP_329_I2_D: "راكب B",
  T_49_META_TYP_329_I3_D: "راكب C",
  T_49_META_TYP_33_I0_D: "في الترتيب التصاعدي، يتم تجاهل القيم الصفرية ويتم فرزها أخيرًا.",
  T_49_META_TYP_33_I1_D: "تنازلي، من الكبير إلى الصغير",
  T_49_META_TYP_33_I2_D: "تصاعدي، من الصغير إلى الكبير",
  T_49_META_TYP_330_I4_D: "مدة تأثير عدم القابلية للهزيمة (الوحدة: ثانية)",
  T_49_META_TYP_330_I5_D: "نقاط التحكم",
  T_49_META_TYP_330_I8_D: "قيمة دلتا",
  T_49_META_TYP_332_I0_D: "حلقة",
  T_49_META_TYP_333_I0_D: "FZLanTingHei",
  T_49_META_TYP_333_I1_D: "العربية المبسطة",
  T_49_META_TYP_333_I2_D: "NotoNastaliqUrdu",
  T_49_META_TYP_333_I3_D: "GFFLatin",
  T_49_META_TYP_333_I4_D: "AgencyFB",
  T_49_META_TYP_333_I5_D: "سوبرماركت",
  T_49_META_TYP_333_I6_D: "هند سيليجوري",
  T_49_META_TYP_335_I0_D: "مسار المورد، فارغ بشكل افتراضي",
  T_49_META_TYP_335_I1_D: "عدد المسرحيات، الافتراضي هو 1",
  T_49_META_TYP_335_I2_D: "الحجم الافتراضي هو 50",
  T_49_META_TYP_335_I3_D: "الحد الأقصى للمسافة",
  T_49_META_TYP_335_I4_D: "الحد الأدنى للمسافة",
  T_49_META_TYP_335_I5_D: "هل هذه موسيقى ثلاثية الأبعاد؟",
  T_49_META_TYP_335_I6_D: "الأولوية",
  T_49_META_TYP_335_I7_D: "وقت الانتظار قبل البدء، بالثواني",
  T_49_META_TYP_335_I8_D: "قيد التشغيل",
  T_49_META_TYP_338_I0_D: "حالة الهاتف المحمول",
  T_49_META_TYP_338_I1_D: "حالة العدو السريع",
  T_49_META_TYP_338_I2_D: "حالة الهجوم",
  T_49_META_TYP_338_I3_D: "حالة القفز",
  T_49_META_TYP_338_I4_D: "حالة التسلق",
  T_49_META_TYP_338_I5_D: "أدخل السيارة (السائق)",
  T_49_META_TYP_338_I6_D: "دخول السيارة (الراكب)",
  T_49_META_TYP_338_I7_D: "خروج من المركبة",
  T_49_META_TYP_338_I8_D: "قيادة",
  T_49_META_TYP_339_I0_D: "نسبة ضرر الأطراف",
  T_49_META_TYP_339_I1_D: "نسبة ضرر طلقة الرأس",
  T_49_META_TYP_339_I2_D: "نسبة التحمل القصوى",
  T_49_META_TYP_339_I3_D: "نسبة الصحة الإضافية",
  T_49_META_TYP_339_I4_D: "عامل تقليل أضرار الانفجار الإضافي (%)",
  T_49_META_TYP_339_I5_D: "سعة الحقيبة الإضافية",
  T_49_META_TYP_339_I6_D: "أولوية الاستبدال",
  T_49_META_TYP_34_I0_D: "القبضة الافتراضية",
  T_49_META_TYP_34_I1_D: "Kar98K",
  T_49_META_TYP_34_I10_D: "AWM2",
  T_49_META_TYP_34_I100_D: "فاماس-1",
  T_49_META_TYP_34_I101_D: "جروزا-إكس",
  T_49_META_TYP_34_I102_D: "إس في دي-واي",
  T_49_META_TYP_34_I103_D: "G36",
  T_49_META_TYP_34_I104_D: "M24",
  T_49_META_TYP_34_I105_D: "M4A1-I",
  T_49_META_TYP_34_I106_D: "M4A1-II",
  T_49_META_TYP_34_I107_D: "M4A1-III",
  T_49_META_TYP_34_I108_D: "M4A1-III",
  T_49_META_TYP_34_I109_D: "بندقية مشحونة",
  T_49_META_TYP_34_I11_D: "M1014",
  T_49_META_TYP_34_I110_D: "MAC10",
  T_49_META_TYP_34_I111_D: "مدفع يدوي",
  T_49_META_TYP_34_I112_D: "IceGun",
  T_49_META_TYP_34_I113_D: "بندقية الدرع",
  T_49_META_TYP_34_I114_D: "MP5-II",
  T_49_META_TYP_34_I115_D: "MP5-III",
  T_49_META_TYP_34_I116_D: "MP5-III",
  T_49_META_TYP_34_I117_D: "M60-II",
  T_49_META_TYP_34_I118_D: "M60-III",
  T_49_META_TYP_34_I119_D: "M60-III",
  T_49_META_TYP_34_I12_D: "M10142",
  T_49_META_TYP_34_I120_D: "VSS-II",
  T_49_META_TYP_34_I121_D: "VSS-III",
  T_49_META_TYP_34_I122_D: "M14-II",
  T_49_META_TYP_34_I123_D: "M14-III",
  T_49_META_TYP_34_I124_D: "M14-III",
  T_49_META_TYP_34_I125_D: "كار98ك-II",
  T_49_META_TYP_34_I126_D: "كار98ك-III",
  T_49_META_TYP_34_I127_D: "كار98ك-III",
  T_49_META_TYP_34_I128_D: "فاماس-2",
  T_49_META_TYP_34_I129_D: "فاماس-III",
  T_49_META_TYP_34_I13_D: "قنبلة اللهب",
  T_49_META_TYP_34_I133_D: "قنبلة الفلاش",
  T_49_META_TYP_34_I134_D: "قنبلة الدخان",
  T_49_META_TYP_34_I135_D: "قنبلة تجميد",
  T_49_META_TYP_34_I136_D: "سترة واقية من الرصاص المستوى 1",
  T_49_META_TYP_34_I137_D: "سترة واقية من الرصاص المستوى 2",
  T_49_META_TYP_34_I138_D: "سترة واقية من الرصاص المستوى 3",
  T_49_META_TYP_34_I139_D: "خوذة المستوى 1",
  T_49_META_TYP_34_I14_D: "AK",
  T_49_META_TYP_34_I140_D: "خوذة المستوى 2",
  T_49_META_TYP_34_I141_D: "خوذة المستوى 3",
  T_49_META_TYP_34_I142_D: "درع مقاوم للانفجار",
  T_49_META_TYP_34_I143_D: "حقيبة ظهر المستوى 1",
  T_49_META_TYP_34_I144_D: "حقيبة ظهر المستوى 2",
  T_49_META_TYP_34_I145_D: "حقيبة ظهر المستوى 3",
  T_49_META_TYP_34_I146_D: "كمامة المستوى 1",
  T_49_META_TYP_34_I147_D: "كمامة المستوى 2",
  T_49_META_TYP_34_I148_D: "كمامة المستوى 3",
  T_49_META_TYP_34_I149_D: "كاتم الصوت",
  T_49_META_TYP_34_I15_D: "AK2",
  T_49_META_TYP_34_I150_D: "كمامة هجومية",
  T_49_META_TYP_34_I151_D: "كمامة واسعة",
  T_49_META_TYP_34_I152_D: "مجلة المستوى 1",
  T_49_META_TYP_34_I153_D: "مجلة المستوى 2",
  T_49_META_TYP_34_I154_D: "مجلة المستوى 3",
  T_49_META_TYP_34_I155_D: "مجلة الحزمة المزدوجة",
  T_49_META_TYP_34_I156_D: "مجلة السلسلة",
  T_49_META_TYP_34_I157_D: "قبضة المستوى 1",
  T_49_META_TYP_34_I158_D: "قبضة المستوى 2",
  T_49_META_TYP_34_I159_D: "قبضة المستوى 3",
  T_49_META_TYP_34_I16_D: "UMP",
  T_49_META_TYP_34_I160_D: "حامل قابل للطي",
  T_49_META_TYP_34_I161_D: "قبضة بندقية ماركسمان",
  T_49_META_TYP_34_I162_D: "مخزون البندقية",
  T_49_META_TYP_34_I163_D: "مؤخرة بندقية القنص",
  T_49_META_TYP_34_I164_D: "نطاق التصوير الحراري",
  T_49_META_TYP_34_I165_D: "مخزون المستوى 1",
  T_49_META_TYP_34_I166_D: "مخزون المستوى 2",
  T_49_META_TYP_34_I167_D: "مخزون المستوى 3",
  T_49_META_TYP_34_I168_D: "موسع الدرع",
  T_49_META_TYP_34_I169_D: "درع كامل للجسم",
  T_49_META_TYP_34_I17_D: "UMP2",
  T_49_META_TYP_34_I170_D: "طبقة داخلية زائدة",
  T_49_META_TYP_34_I171_D: "طبقة داخلية مقاومة للانفجار",
  T_49_META_TYP_34_I172_D: "توسيع حقيبة الظهر",
  T_49_META_TYP_34_I173_D: "جهاز تنفس علاجي",
  T_49_META_TYP_34_I174_D: "أفق",
  T_49_META_TYP_34_I175_D: "مجموعة الإسعافات الأولية",
  T_49_META_TYP_34_I176_D: "طقم إصلاح الدروع",
  T_49_META_TYP_34_I177_D: "سوف يقوم برج الحراسة ذو الذكاء الاصطناعي المصنوع من مواد عالية التقنية بالبحث بنشاط ومهاجمة الأعداء ضمن نطاق معين.",
  T_49_META_TYP_34_I178_D: "فطر المستوى 1",
  T_49_META_TYP_34_I179_D: "فطر المستوى 2",
  T_49_META_TYP_34_I18_D: "MP5",
  T_49_META_TYP_34_I180_D: "فطر المستوى 3",
  T_49_META_TYP_34_I181_D: "فطر المستوى الرابع",
  T_49_META_TYP_34_I182_D: "درون شخصي",
  T_49_META_TYP_34_I184_D: "منجم القرب",
  T_49_META_TYP_34_I185_D: "أحذية الطيران النفاثة",
  T_49_META_TYP_34_I186_D: "أحذية باونس باور",
  T_49_META_TYP_34_I187_D: "القفز المظلي",
  T_49_META_TYP_34_I188_D: "قنبلة يدوية وهمية",
  T_49_META_TYP_34_I189_D: "لوح تحليق مغناطيسي",
  T_49_META_TYP_34_I19_D: "نسر الصحراء",
  T_49_META_TYP_34_I190_D: "كماشة إبطال القنابل",
  T_49_META_TYP_34_I191_D: "مُطوّر الأسلحة",
  T_49_META_TYP_34_I192_D: "ذخيرة بندقية",
  T_49_META_TYP_34_I193_D: "ذخيرة مسدس",
  T_49_META_TYP_34_I194_D: "ذخيرة بندقية قناصة",
  T_49_META_TYP_34_I195_D: "ذخيرة شوتجن",
  T_49_META_TYP_34_I196_D: "ذخيرة رشاش",
  T_49_META_TYP_34_I197_D: "السهام",
  T_49_META_TYP_34_I198_D: "قنبلة M79",
  T_49_META_TYP_34_I199_D: "رصاصة قاذف اللهب",
  T_49_META_TYP_34_I2_D: "القوس والنشاب",
  T_49_META_TYP_34_I20_D: "G18",
  T_49_META_TYP_34_I200_D: "سكين الرمي 2",
  T_49_META_TYP_34_I201_D: "خطاف",
  T_49_META_TYP_34_I202_D: "بندقية كرة القدم",
  T_49_META_TYP_34_I203_D: "ملاكمة",
  T_49_META_TYP_34_I204_D: "مسدس اللهب",
  T_49_META_TYP_34_I205_D: "بطاقة إله القرد",
  T_49_META_TYP_34_I206_D: "بطاقة MadeManACard",
  T_49_META_TYP_34_I207_D: "بطاقة دي جي مالي",
  T_49_META_TYP_34_I208_D: "بطاقة جرافيتي",
  T_49_META_TYP_34_I209_D: "بطاقة المباحث",
  T_49_META_TYP_34_I21_D: "M14",
  T_49_META_TYP_34_I210_D: "بطاقة الأستاذ",
  T_49_META_TYP_34_I211_D: "بطاقة صائد الجوائز",
  T_49_META_TYP_34_I212_D: "بطاقة سوبر ستار",
  T_49_META_TYP_34_I213_D: "بطاقة إكستريم",
  T_49_META_TYP_34_I214_D: "بطاقة موسيقى",
  T_49_META_TYP_34_I215_D: "بطاقة كينتا",
  T_49_META_TYP_34_I216_D: "بطاقة التتبع",
  T_49_META_TYP_34_I217_D: "بطاقة الفتاة المجنونة",
  T_49_META_TYP_34_I218_D: "بطاقة تسريع التشغيل",
  T_49_META_TYP_34_I219_D: "بطاقة سانتينو",
  T_49_META_TYP_34_I22_D: "SCAR",
  T_49_META_TYP_34_I220_D: "بطاقة الشرير",
  T_49_META_TYP_34_I23_D: "SCAR",
  T_49_META_TYP_34_I24_D: "ندبة-1",
  T_49_META_TYP_34_I25_D: "ندبة-2",
  T_49_META_TYP_34_I26_D: "ندبة-3",
  T_49_META_TYP_34_I27_D: "M1014-I",
  T_49_META_TYP_34_I28_D: "M1014-II",
  T_49_META_TYP_34_I29_D: "M1014-III",
  T_49_META_TYP_34_I3_D: "درع كرة القدم",
  T_49_META_TYP_34_I30_D: "مسدس الطاقة الفائقة الحرارة",
  T_49_META_TYP_34_I31_D: "مسدس الحرارة الزائدة-1",
  T_49_META_TYP_34_I32_D: "مسدس الحرارة الفائقة-II",
  T_49_META_TYP_34_I33_D: "مسدس الحرارة الفائقة-III",
  T_49_META_TYP_34_I34_D: "بلازما-إكس",
  T_49_META_TYP_34_I35_D: "مسدس الشفاء-Y",
  T_49_META_TYP_34_I36_D: "قناص الشفاء",
  T_49_META_TYP_34_I37_D: "مسدس الشفاء",
  T_49_META_TYP_34_I38_D: "VSS",
  T_49_META_TYP_34_I39_D: "جروزا",
  T_49_META_TYP_34_I4_D: "كرة قدم جليدية",
  T_49_META_TYP_34_I40_D: "جروزا",
  T_49_META_TYP_34_I41_D: "MP40",
  T_49_META_TYP_34_I42_D: "MP40",
  T_49_META_TYP_34_I43_D: "مقلاة",
  T_49_META_TYP_34_I44_D: "الساطور",
  T_49_META_TYP_34_I45_D: "SKS",
  T_49_META_TYP_34_I46_D: "M249",
  T_49_META_TYP_34_I47_D: "M249-X",
  T_49_META_TYP_34_I48_D: "M1873",
  T_49_META_TYP_34_I49_D: "M79",
  T_49_META_TYP_34_I5_D: "Bizon",
  T_49_META_TYP_34_I50_D: "FAMAS",
  T_49_META_TYP_34_I51_D: "M500",
  T_49_META_TYP_34_I52_D: "SVD",
  T_49_META_TYP_34_I53_D: "SVD",
  T_49_META_TYP_34_I54_D: "AC80",
  T_49_META_TYP_34_I55_D: "مضرب البيسبول",
  T_49_META_TYP_34_I56_D: "XM8",
  T_49_META_TYP_34_I57_D: "XM8",
  T_49_META_TYP_34_I58_D: "SPAS12",
  T_49_META_TYP_34_I59_D: "SPAS12",
  T_49_META_TYP_34_I6_D: "VSK94",
  T_49_META_TYP_34_I60_D: "M60",
  T_49_META_TYP_34_I61_D: "MGL140",
  T_49_META_TYP_34_I62_D: "P90",
  T_49_META_TYP_34_I63_D: "P90",
  T_49_META_TYP_34_I64_D: "AN94",
  T_49_META_TYP_34_I65_D: "كاتانا",
  T_49_META_TYP_34_I66_D: "CG15",
  T_49_META_TYP_34_I67_D: "RG550",
  T_49_META_TYP_34_I68_D: "جاتلينج",
  T_49_META_TYP_34_I7_D: "M4A1",
  T_49_META_TYP_34_I70_D: "مسدس خطاف قوي",
  T_49_META_TYP_34_I71_D: "سكين FF",
  T_49_META_TYP_34_I72_D: "M1887",
  T_49_META_TYP_34_I73_D: "3 رصاصات 1887",
  T_49_META_TYP_34_I74_D: "M18872",
  T_49_META_TYP_34_I75_D: "طومسون",
  T_49_META_TYP_34_I76_D: "طومسون",
  T_49_META_TYP_34_I77_D: "M82B",
  T_49_META_TYP_34_I78_D: "M82B",
  T_49_META_TYP_34_I79_D: "AUG",
  T_49_META_TYP_34_I8_D: "USP",
  T_49_META_TYP_34_I80_D: "بارافال",
  T_49_META_TYP_34_I81_D: "بارافال",
  T_49_META_TYP_34_I82_D: "نقار الخشب",
  T_49_META_TYP_34_I83_D: "فكتور",
  T_49_META_TYP_34_I84_D: "ماج-7",
  T_49_META_TYP_34_I85_D: "ماج-7",
  T_49_META_TYP_34_I86_D: "منجل",
  T_49_META_TYP_34_I87_D: "مطرقة",
  T_49_META_TYP_34_I88_D: "سكين الرمي (التقاط)",
  T_49_META_TYP_34_I89_D: "Kord",
  T_49_META_TYP_34_I9_D: "AWM",
  T_49_META_TYP_34_I90_D: "M1917",
  T_49_META_TYP_34_I91_D: "USP-2",
  T_49_META_TYP_34_I92_D: "طائر الرفراف",
  T_49_META_TYP_34_I93_D: "أوزي",
  T_49_META_TYP_34_I94_D: "MP5-I",
  T_49_META_TYP_34_I95_D: "M60-I",
  T_49_META_TYP_34_I96_D: "VSS-I",
  T_49_META_TYP_34_I97_D: "M14-I",
  T_49_META_TYP_34_I98_D: "كار98ك-اي",
  T_49_META_TYP_34_I99_D: "AWM_Y",
  T_49_META_TYP_340_I0_D: "سهل",
  T_49_META_TYP_340_I1_D: "بسيط",
  T_49_META_TYP_340_I2_D: "عادي",
  T_49_META_TYP_340_I3_D: "معتدل",
  T_49_META_TYP_340_I4_D: "صعب",
  T_49_META_TYP_340_I5_D: "جحيم",
  T_49_META_TYP_342_I0_D: "بدء الحدث",
  T_49_META_TYP_342_I1_D: "إيقاف الحدث",
  T_49_META_TYP_342_I2_D: "إيقاف الحدث",
  T_49_META_TYP_342_I3_D: "كم من الوقت يجب الانتظار بعد إنشائه لبدء التوقيت، بالمللي ثانية",
  T_49_META_TYP_342_I4_D: "عدد الحلقة",
  T_49_META_TYP_342_I5_D: "الأحداث",
  T_49_META_TYP_342_I6_D: "العد التنازلي أو العد التنازلي",
  T_49_META_TYP_342_I7_D: "حالة اللاعب",
  T_49_META_TYP_342_I8_D: "وقت انتهاء التوقيت، بالثواني",
  T_49_META_TYP_345_I10_D: "مدفع يدوي",
  T_49_META_TYP_345_I12_D: "مسدس جدار الجليد",
  T_49_META_TYP_345_I13_D: "مسدس اللهب",
  T_49_META_TYP_345_I4_D: "بندقية",
  T_49_META_TYP_345_I6_D: "سلاح خاص",
  T_49_META_TYP_345_I8_D: "بندقية الشحن",
  T_49_META_TYP_346_I0_D: "ذخيرة بندقية",
  T_49_META_TYP_346_I1_D: "ذخيرة مسدس",
  T_49_META_TYP_346_I2_D: "ذخيرة بندقية قناصة",
  T_49_META_TYP_346_I3_D: "ذخيرة شوتجن",
  T_49_META_TYP_346_I4_D: "ذخيرة رشاش",
  T_49_META_TYP_346_I5_D: "السهام",
  T_49_META_TYP_346_I6_D: "قنبلة M79",
  T_49_META_TYP_346_I7_D: "خطاف",
  T_49_META_TYP_346_I8_D: "قنبلة متخصصة M79",
  T_49_META_TYP_347_I3_D: "عند الصواب، يُمكن دمجها مع الحركة النسبية. عند الخطأ، يجب دمجها مع الحركة المطلقة، وإلا فلن تُفعّل الخاصية بشكل صحيح.",
  T_49_META_TYP_347_I6_D: "قيمة دلتا",
  T_49_META_TYP_350_I0_D: "سيارة رياضية",
  T_49_META_TYP_350_I1_D: "دراجة نارية",
  T_49_META_TYP_350_I2_D: "جيب",
  T_49_META_TYP_350_I3_D: "SUV",
  T_49_META_TYP_350_I4_D: "شاحنات الوحش",
  T_49_META_TYP_350_I5_D: "توك توك",
  T_49_META_TYP_352_I1_D: "الصورة غير المحددة",
  T_49_META_TYP_352_I2_D: "لم يتم تحديد نوع الصورة",
  T_49_META_TYP_352_I3_D: "لون الصورة غير المحددة",
  T_49_META_TYP_352_I4_D: "الصورة المحددة",
  T_49_META_TYP_352_I5_D: "حدد نوع الصورة",
  T_49_META_TYP_352_I6_D: "لون الصورة المحددة",
  T_49_META_TYP_353_I0_D: "كمية استعادة الصحة",
  T_49_META_TYP_353_I1_D: "سرعة استعادة نقاط الصحة (مللي ثانية)",
  T_49_META_TYP_353_I2_D: "الوقت المطلوب (مللي ثانية)",
  T_49_META_TYP_354_I0_D: "كمية استعادة نقطة الطاقة",
  T_49_META_TYP_355_I0_D: "كمية استعادة الصحة",
  T_49_META_TYP_355_I1_D: "كمية استعادة نقطة الطاقة",
  T_49_META_TYP_355_I2_D: "الوقت المطلوب (مللي ثانية)",
  T_49_META_TYP_356_I0_D: "العناصر المتساقطة",
  T_49_META_TYP_356_I1_D: "وقت إسقاط صندوق الإنزال الجوي بالمللي ثانية",
  T_49_META_TYP_356_I2_D: "حالة السقوط الجوي",
  T_49_META_TYP_357_I0_D: "سطح",
  T_49_META_TYP_357_I1_D: "الحدود",
  T_49_META_TYP_359_I0_D: "هل يجب استخدام وحدة تحكم اللاعب مع الفيزياء؟",
  T_49_META_TYP_359_I1_D: "إذا تم وضعه على منحدر يتجاوز هذه الزاوية، فسوف ينزلق إلى الأسفل",
  T_49_META_TYP_359_I10_D: "ينطبق تسارع الجاذبية هذا على وحدة تحكم اللاعب فقط.",
  T_49_META_TYP_359_I11_D: "الكتلة، كجم",
  T_49_META_TYP_359_I12_D: "إذا تجاوز المنحدر الحد الأقصى لزاوية الصعود، فسوف ينزلق إلى الأسفل.",
  T_49_META_TYP_359_I16_D: "بعد الفتح، تتحكم العناصر البدائية أو البرامج النصية الموجودة على جانب الخادم في الحركة",
  T_49_META_TYP_359_I17_D: "عند تمكينه، يمكن تخصيص القوة التي يطبقها الحرف عند دفع الجسم الصلب",
  T_49_META_TYP_359_I18_D: "كمية القوة المطبقة عندما تدفع الشخصية الجسم الصلب",
  T_49_META_TYP_359_I19_D: "صحيح عندما يلامس الجزء السفلي المصادم، ويستخدم عادة لتحديد ما إذا كان اللاعب على الأرض",
  T_49_META_TYP_359_I2_D: "فقط العوائق التي تتجاوز هذا الارتفاع ستُسبب تأثيرًا مانعًا. نطاق القيمة هو [0، الارتفاع]",
  T_49_META_TYP_359_I20_D: "المستوى المادي المخصص، القيمة [0,15]",
  T_49_META_TYP_359_I21_D: "هل يتبع دوران الجاذبية",
  T_49_META_TYP_359_I3_D: "عمق الكبسولة التي يمكن تضمينها. يمكنه منع الشخصية من التعثر أو الاهتزاز. لا يُنصح بتعديله إلا في حالة الضرورة القصوى. نطاق القيمة (0، نصف القطر)",
  T_49_META_TYP_359_I4_D: "الحد الأدنى لمسافة الحركة. لن يتم تنفيذ أي حركة أقل من هذه القيمة. إذا لم تكن هناك حاجة خاصة، فمن المستحسن الاحتفاظ بها على أنها 0",
  T_49_META_TYP_359_I5_D: "إزاحة مركز صندوق الاصطدام عن أصل الإحداثيات المحلية",
  T_49_META_TYP_359_I6_D: "نصف قطر الكبسولة، الحد الأدنى للقيمة هو 0.01",
  T_49_META_TYP_359_I7_D: "الارتفاع الإجمالي للكبسولة، بما في ذلك نصفي الكرة العلوي والسفلي، بقيمة لا تقل عن 2*نصف القطر",
  T_49_META_TYP_359_I8_D: "السرعة الخطية الحالية، بوحدة م/ث",
  T_49_META_TYP_360_I0_D: "زاوية إطلاق النار اليسرى",
  T_49_META_TYP_360_I1_D: "زاوية إطلاق النار اليمنى",
  T_49_META_TYP_360_I2_D: "الحد الأدنى لزاوية الارتفاع",
  T_49_META_TYP_360_I3_D: "أقصى زاوية انخفاض",
  T_49_META_TYP_360_I4_D: "سرعة الفوهة",
  T_49_META_TYP_362_I0_D: "وقت التجميد بعد ضرب اللاعب، بالثواني",
  T_49_META_TYP_363_I0_D: "تعطيل طلب الشراء HUD",
  T_49_META_TYP_363_I1_D: "اطلب المساعدة من الفريق في الشراء",
  T_49_META_TYP_363_I2_D: "اطلب المساعدة من الفصيل في الشراء",
  T_49_META_TYP_364_I0_D: "هل هو موقع مركزي",
  T_49_META_TYP_364_I1_D: "سواء للحلقة",
  T_49_META_TYP_364_I2_D: "اسم الرسوم المتحركة",
  T_49_META_TYP_364_I3_D: "هل سيتم التشغيل تلقائيًا",
  T_49_META_TYP_364_I4_D: "استخدام المورد المخصص",
  T_49_META_TYP_366_I0_D: "حدد UUID لمورد الدفعة الذي سيتم عرضه",
  T_49_META_TYP_367_I1_D: "عرض العلامة",
  T_49_META_TYP_367_I2_D: "نمط الأيقونات لتمييز الأهداف",
  T_49_META_TYP_367_I3_D: "لون تراكب الرمز المعروض عند تحديد هدف",
  T_49_META_TYP_367_I4_D: "نمط الرمز المعروض على المقياس",
  T_49_META_TYP_367_I5_D: "لون تراكب الأيقونات المعروض على المقياس",
  T_49_META_TYP_367_I6_D: "عرض العلامة دائمًا",
  T_49_META_TYP_370_I0_D: "العنوان الرئيسي",
  T_49_META_TYP_370_I1_D: "الترجمة الفرعية",
  T_49_META_TYP_370_I2_D: "لون الخلفية العلوي",
  T_49_META_TYP_370_I3_D: "لون الخلفية أدناه",
  T_49_META_TYP_371_I2_D: "الدرجة اليسرى",
  T_49_META_TYP_371_I3_D: "الدرجة اليمنى",
  T_49_META_TYP_371_I4_D: "النتيجة الأخيرة على اليسار، تُستخدم لتشغيل الرسوم المتحركة لتبديل النتيجة",
  T_49_META_TYP_371_I5_D: "يتم استخدام النتيجة الأخيرة على اليمين لتشغيل الرسوم المتحركة لتبديل النتيجة",
  T_49_META_TYP_372_I0_D: "وقوف",
  T_49_META_TYP_372_I1_D: "عرض الانحناء",
  T_49_META_TYP_372_I10_D: "السقوط من ارتفاعات عالية",
  T_49_META_TYP_372_I11_D: "السقوط من ارتفاع منخفض، مثل القفز",
  T_49_META_TYP_372_I12_D: "أحذية الطيران",
  T_49_META_TYP_372_I13_D: "القفزة المزدوجة",
  T_49_META_TYP_372_I14_D: "اجلس على كرسي",
  T_49_META_TYP_372_I15_D: "القذف بواسطة المنجنيق",
  T_49_META_TYP_372_I16_D: "مرحلة تحضير المنجنيق",
  T_49_META_TYP_372_I17_D: "الدعائم الانزلاقية الانزلاقية",
  T_49_META_TYP_372_I18_D: "إسقاط الدعامة الانزلاقية",
  T_49_META_TYP_372_I19_D: "ارتدت بواسطة الإطارات",
  T_49_META_TYP_372_I2_D: "جري",
  T_49_META_TYP_372_I20_D: "ارتد بواسطة إطار بشري",
  T_49_META_TYP_372_I21_D: "عمل في منطقة الحفلة",
  T_49_META_TYP_372_I22_D: "خذ طائرة",
  T_49_META_TYP_372_I23_D: "أدخل المدفع",
  T_49_META_TYP_372_I24_D: "عند الخروج من مدفع أو مركبة وما إلى ذلك، إذا كان الجسم الذي تركبه طائرًا، فهذه هي الحالة",
  T_49_META_TYP_372_I25_D: "بعد القفز من منصة القفز",
  T_49_META_TYP_372_I26_D: "انزل من الحبل البريدي",
  T_49_META_TYP_372_I27_D: "لم يتم استخدامه",
  T_49_META_TYP_372_I3_D: "الزحف",
  T_49_META_TYP_372_I4_D: "السباحة السريعة",
  T_49_META_TYP_372_I5_D: "انخفاض عمودي",
  T_49_META_TYP_372_I6_D: "فوق الحائط",
  T_49_META_TYP_372_I7_D: "لم يتم استخدامه",
  T_49_META_TYP_372_I8_D: "سقط ولكن لم يمت",
  T_49_META_TYP_372_I9_D: "استخدم لوح الماء",
  T_49_META_TYP_374_I0_D: "لون الصحة والمستوى والسكتة الدماغية",
  T_49_META_TYP_374_I1_D: "مع انخفاض الصحة، يعرض الجزء المفقود هذا اللون لفترة وجيزة",
  T_49_META_TYP_374_I10_D: "الإزاحة بالنسبة للهدف الذي يجب متابعته",
  T_49_META_TYP_374_I11_D: "لن يتم عرض قيمة الصحة بين كل خطين فاصلين إذا كانت أقل من أو تساوي 0",
  T_49_META_TYP_374_I12_D: "الصحة الإجمالية",
  T_49_META_TYP_374_I13_D: "الصحة الحالية",
  T_49_META_TYP_374_I14_D: "عند التمكين، سيتم عرض التغييرات الصحية بألوان مختلفة",
  T_49_META_TYP_374_I15_D: "عند تمكين ذلك، يتم تحويل خصائص الإزاحة إلى إحداثيات عالمية باستخدام نظام الإحداثيات المحلي.",
  T_49_META_TYP_374_I2_D: "عندما تزيد الصحة، يعرض الجزء المتزايد هذا اللون لفترة وجيزة",
  T_49_META_TYP_374_I3_D: "لون حدود الصحة والجزء السفلي غير الواضح",
  T_49_META_TYP_374_I4_D: "النطاق 0~1، شفافية واجهة المستخدم الشاملة",
  T_49_META_TYP_374_I5_D: "يحدد مقياس واجهة المستخدم الإجمالي، ويتم قياس الخطوط معًا",
  T_49_META_TYP_374_I6_D: "يشير إلى اسم مالك شريط الصحة الحالي",
  T_49_META_TYP_374_I8_D: "طول شريط الصحة المعروض على الشاشة",
  T_49_META_TYP_374_I9_D: "يجب أن يتبع الكيان مكون التحويل",
  T_49_META_TYP_375_I1_D: "كيان قتالي",
  T_49_META_TYP_376_I1_D: "كيان قتالي",
  T_49_META_TYP_38_I0_D: "الشفافية",
  T_49_META_TYP_382_I0_D: "تقصير",
  T_49_META_TYP_382_I1_D: "تخطي حالة الإسقاط والموت مباشرة",
  T_49_META_TYP_382_I2_D: "عدم تخطي السقوط",
  T_49_META_TYP_387_I1_D: "السماح بالضغط خارج المنطقة",
  T_49_META_TYP_389_I0_D: "الإزاحة الافتراضية للقاعدة",
  T_49_META_TYP_389_I1_D: "صورة الخلفية",
  T_49_META_TYP_389_I10_D: "شفافية إلغاء التفعيل",
  T_49_META_TYP_389_I2_D: "نصف قطر الخلفية",
  T_49_META_TYP_389_I3_D: "صورة غطاء عصا التحكم",
  T_49_META_TYP_389_I4_D: "نصف قطر غطاء عصا التحكم",
  T_49_META_TYP_389_I5_D: "نصف قطر سحب غطاء عصا التحكم",
  T_49_META_TYP_389_I6_D: "صورة السهم",
  T_49_META_TYP_389_I7_D: "حجم السهم",
  T_49_META_TYP_389_I8_D: "إزاحة السهم",
  T_49_META_TYP_389_I9_D: "شفافية التفعيل",
  T_49_META_TYP_39_I1_D: "شكل الصورة",
  T_49_META_TYP_39_I10_D: "تدرج اللون العلوي",
  T_49_META_TYP_39_I11_D: "تدرج اللون السفلي",
  T_49_META_TYP_39_I12_D: "شفافية العلوية",
  T_49_META_TYP_39_I13_D: "ألفا السفلي",
  T_49_META_TYP_39_I3_D: "الانعكاس",
  T_49_META_TYP_39_I4_D: "ممتلئ",
  T_49_META_TYP_39_I5_D: "المركز غير مرئي",
  T_49_META_TYP_39_I6_D: "اتجاه التعبئة",
  T_49_META_TYP_39_I7_D: "قيمة التعبئة",
  T_49_META_TYP_39_I8_D: "عكس التعبئة",
  T_49_META_TYP_39_I9_D: "التدرج اللوني",
  T_49_META_TYP_392_I0_D: "الوقت الذي تظهر فيه المنطقة الآمنة في كل جولة في اللعبة، القيمة الافتراضية هي 0، والوحدة هي مللي ثانية",
  T_49_META_TYP_392_I1_D: "الوقت المستغرق لتقليص الدائرة، بالمللي ثانية",
  T_49_META_TYP_392_I10_D: "وقت نهاية الدائرة المتقلصة، بالمللي ثانية",
  T_49_META_TYP_392_I12_D: "نصف قطر نهاية دائرة السم",
  T_49_META_TYP_392_I13_D: "وقت بدء التقليص",
  T_49_META_TYP_392_I14_D: "فترة الضرر (مللي ثانية)",
  T_49_META_TYP_392_I3_D: "كمية الضرر الذي يلحق باللاعبين في دائرة السم.",
  T_49_META_TYP_392_I4_D: "قائمة اللاعبين في المنطقة الآمنة",
  T_49_META_TYP_392_I5_D: "زمن اختفاء المنطقة الآمنة. إذا كان زمن اختفاء المنطقة الآمنة أقل من الزمن الفعلي، فلن يتم إنشاء أي منطقة آمنة.",
  T_49_META_TYP_392_I6_D: "معرف المجموعة",
  T_49_META_TYP_392_I7_D: "دائرة السم تبدأ بنصف قطرها",
  T_49_META_TYP_392_I8_D: "الحالة النهائية",
  T_49_META_TYP_392_I9_D: "الحالة",
  T_49_META_TYP_394_I0_D: "القيمة حوالي 3.1416",
  T_49_META_TYP_394_I1_D: "القيمة حوالي 2.7183",
  T_49_META_TYP_396_I0_D: "العنوان",
  T_49_META_TYP_396_I1_D: "المحتوى",
  T_49_META_TYP_396_I2_D: "الخيارات",
  T_49_META_TYP_396_I3_D: "عرض الخلفية",
  T_49_META_TYP_399_I0_D: "ارتفاع القفز",
  T_49_META_TYP_399_I1_D: "عدد القفزات المتتالية التي يمكنك القيام بها قبل الهبوط",
  T_49_META_TYP_399_I2_D: "يمكنك القيام بالعديد من القفزات قبل الهبوط.",
  T_49_META_TYP_399_I3_D: "هل يمكن الحركة في الهواء",
  T_49_META_TYP_40_I1_D: "التسمية",
  T_49_META_TYP_40_I10_D: "تباعد الأسطر",
  T_49_META_TYP_40_I11_D: "طريقة الفائض",
  T_49_META_TYP_40_I12_D: "نمط الخط",
  T_49_META_TYP_40_I13_D: "تطبيق الظل",
  T_49_META_TYP_40_I14_D: "لون الظل",
  T_49_META_TYP_40_I15_D: "إزاحة الظل",
  T_49_META_TYP_40_I3_D: "مفتاح التوطين، يمكن استخدامه في لغات متعددة",
  T_49_META_TYP_40_I5_D: "تنسيق",
  T_49_META_TYP_40_I6_D: "محاذاة رأسية",
  T_49_META_TYP_40_I7_D: "غامق",
  T_49_META_TYP_40_I8_D: "مائل",
  T_49_META_TYP_40_I9_D: "خط تحت",
  T_49_META_TYP_400_I0_D: "نشط",
  T_49_META_TYP_400_I1_D: "سلبي",
  T_49_META_TYP_400_I2_D: "لا هجوم",
  T_49_META_TYP_401_I0_D: "لا يمكن إطلاق النار",
  T_49_META_TYP_401_I1_D: "يمكن إطلاق النار بشكل مستمر",
  T_49_META_TYP_401_I2_D: "يطلق النار مرة واحدة لكل أمر هجوم",
  T_49_META_TYP_401_I3_D: "كل أمر هجوم يطلق ثلاث مرات",
  T_49_META_TYP_401_I4_D: "كل أمر هجوم يطلق النار مرتين",
  T_49_META_TYP_401_I5_D: "قذيفة",
  T_49_META_TYP_402_I0_D: "هدف لإضافته كصديق",
  T_49_META_TYP_402_I1_D: "نوع الوظيفة",
  T_49_META_TYP_402_I2_D: "الأسلوب",
  T_49_META_TYP_403_I0_D: "إضافة صديق",
  T_49_META_TYP_403_I1_D: "تقرير",
  T_49_META_TYP_404_I0_D: "فاتح",
  T_49_META_TYP_404_I1_D: "داكن",
  T_49_META_TYP_405_I0_D: "حسب التسلسل",
  T_49_META_TYP_405_I1_D: "حسب الأولوية من الأعلى إلى الأدنى",
  T_49_META_TYP_405_I2_D: "حسب الأولوية من الأدنى إلى الأعلى",
  T_49_META_TYP_406_I0_D: "يتحكم في مسافة حركة القفز للاعب",
  T_49_META_TYP_406_I1_D: "التحكم في ارتفاع جسم اللاعب عند الصعود والنزول",
  T_49_META_TYP_407_I0_D: "محلي",
  T_49_META_TYP_407_I1_D: "عميل",
  T_49_META_TYP_407_I2_D: "خادم",
  T_49_META_TYP_407_I3_D: "كلاهما",
  T_49_META_TYP_409_I0_D: "لا يوجد خطأ",
  T_49_META_TYP_409_I1_D: "مهلة تخزين البيانات، خاصة لعمليات القراءة",
  T_49_META_TYP_409_I10_D: "فشل تغيير الفريق - الفريق المستهدف غير صالح",
  T_49_META_TYP_409_I11_D: "فشل تغيير الفريق - لا يُسمح للاعبين المتوفين بتغيير الفرق",
  T_49_META_TYP_409_I12_D: "فشل تغيير الفريق - لا يُسمح بتغيير الفريق في المركبات",
  T_49_META_TYP_409_I2_D: "يتجاوز تردد تخزين البيانات القراءة والكتابة الحد الأقصى",
  T_49_META_TYP_409_I3_D: "شذوذ المعلمات",
  T_49_META_TYP_409_I4_D: "فشل إنشاء الغرفة: لا يوجد معرفات شخصية صالحة",
  T_49_META_TYP_409_I5_D: "حالة خطأ غير محددة",
  T_49_META_TYP_409_I6_D: "تم إغلاق الخدمات التجارية ولم يعد بإمكان المستخدمين استخدام خدمات المطور",
  T_49_META_TYP_409_I7_D: "فشل تغيير الفريق - الوضع غير مدعوم",
  T_49_META_TYP_409_I8_D: "فشل تغيير الفريق - موجود حاليًا بالفعل في الفريق المستهدف",
  T_49_META_TYP_409_I9_D: "فشل تغيير الفريق - كائن غير صالح",
  T_49_META_TYP_41_I0_D: "شكل الصورة",
  T_49_META_TYP_41_I19_D: "تعطيل صندوق الاصطدام",
  T_49_META_TYP_41_I3_D: "لون غير مفعل",
  T_49_META_TYP_41_I4_D: "لون مضغوط",
  T_49_META_TYP_41_I5_D: "نوع التعبئة",
  T_49_META_TYP_41_I6_D: "هل هو زر FE",
  T_49_META_TYP_41_I7_D: "صورة مضغوطة",
  T_49_META_TYP_41_I8_D: "نوع صورة مضغوطة",
  T_49_META_TYP_41_I9_D: "نوع التدوير",
  T_49_META_TYP_411_I0_D: "سرعة التقدم",
  T_49_META_TYP_411_I1_D: "سرعة الرجوع",
  T_49_META_TYP_411_I2_D: "سرعة الصعود",
  T_49_META_TYP_411_I3_D: "سرعة الهبوط",
  T_49_META_TYP_411_I4_D: "الحد الأدنى للضرر بالقنبلة",
  T_49_META_TYP_411_I5_D: "الحد الأقصى للضرر بالقنبلة",
  T_49_META_TYP_411_I6_D: "مدى القنبلة",
  T_49_META_TYP_412_I0_D: "كمية قوة الحصان التي تكتسبها السيارة عند استخدام زر الخانق",
  T_49_META_TYP_412_I1_D: "كمية قوة الحصان التي تكتسبها السيارة عند استخدام زر الرجوع للخلف/الفرامل",
  T_49_META_TYP_412_I2_D: "عند السرعات العالية، أقصى زاوية توجيه",
  T_49_META_TYP_412_I3_D: "عتبة السرعة لتطبيق زاوية التوجيه القصوى للسرعة العالية",
  T_49_META_TYP_412_I4_D: "بعد الوصول إلى السرعة القصوى، لن توفر السيارة أي قوة حصانية إضافية، ولكن قد تتجاوز السيارة هذه السرعة القصوى (على سبيل المثال بالنزول من المنحدر)",
  T_49_META_TYP_412_I5_D: "عندما لا يتم التحكم في السيارة، يتم إبطاء السيارة عن طريق ضرب IdleBrakeInput في BrakeTorque",
  T_49_META_TYP_412_I6_D: "يستخدم لحساب الضرر الناتج عن ضرب الأشخاص، باستخدام معلمات صيغة الضرر",
  T_49_META_TYP_412_I7_D: "يُستخدم لحساب ضرر ضرب الأشخاص. بعد تجاوز هذه السرعة، لن يزداد الضرر.",
  T_49_META_TYP_412_I8_D: "يستخدم لحساب أضرار الاصطدام والحد الأدنى للضرر",
  T_49_META_TYP_412_I9_D: "يستخدم لحساب أضرار الاصطدام والحد الأقصى للضرر",
  T_49_META_TYP_413_I0_D: "ملابس اللاعب (NPC) المتحولة",
  T_49_META_TYP_414_I1_D: "نطاق واسع",
  T_49_META_TYP_415_I0_D: "معرف الشخصية",
  T_49_META_TYP_415_I1_D: "الاسم المستعار",
  T_49_META_TYP_415_I2_D: "الصورة الرمزية",
  T_49_META_TYP_416_I1_D: "شخصية مقيدة",
  T_49_META_TYP_416_I2_D: "الإزاحة",
  T_49_META_TYP_416_I3_D: "ارتفاع",
  T_49_META_TYP_416_I4_D: "ما إذا كان سيتم الرد على رسائل النظام",
  T_49_META_TYP_416_I5_D: "لقب الشخصية",
  T_49_META_TYP_416_I6_D: "شخصية أفاتار",
  T_49_META_TYP_416_I7_D: "اسم المستخدم المستعار",
  T_49_META_TYP_416_I8_D: "صورة المستخدم الرمزية",
  T_49_META_TYP_417_I0_D: "معرف المورد",
  T_49_META_TYP_418_I0_D: "انتهاء صلاحية العضوية",
  T_49_META_TYP_418_I1_D: "كن عضوا",
  T_49_META_TYP_418_I2_D: "تجديد العضوية",
  T_49_META_TYP_42_I0_D: "النص الافتراضي",
  T_49_META_TYP_42_I1_D: "النص النشط",
  T_49_META_TYP_42_I10_D: "الحد الأقصى للطول",
  T_49_META_TYP_42_I14_D: "لون مضغوط",
  T_49_META_TYP_42_I16_D: "مفتاح التوطين، يمكن استخدامه في لغات متعددة",
  T_49_META_TYP_42_I3_D: "تنسيق",
  T_49_META_TYP_42_I4_D: "محاذاة رأسية",
  T_49_META_TYP_42_I5_D: "غامق",
  T_49_META_TYP_42_I6_D: "مائل",
  T_49_META_TYP_42_I7_D: "خط تحت",
  T_49_META_TYP_42_I8_D: "تباعد الأسطر",
  T_49_META_TYP_42_I9_D: "التفاف الكلمات",
  T_49_META_TYP_424_I0_D: "تأثير الضباب الخطي",
  T_49_META_TYP_424_I1_D: "تأثير ضباب المؤشر",
  T_49_META_TYP_424_I2_D: "تأثير الضباب المربع الأسّي",
  T_49_META_TYP_426_I0_D: "الكثافة",
  T_49_META_TYP_426_I1_D: "المدى",
  T_49_META_TYP_426_I2_D: "زاوية مخروط الضوء بالدرجات",
  T_49_META_TYP_426_I3_D: "لون فاتح",
  T_49_META_TYP_428_I0_D: "معرفات غلاف السلاح",
  T_49_META_TYP_428_I2_D: "معرف المجموعة",
  T_49_META_TYP_428_I3_D: "معرف غطاء الرأس",
  T_49_META_TYP_428_I4_D: "معرف الوجه",
  T_49_META_TYP_428_I5_D: "معرف المكياج",
  T_49_META_TYP_428_I6_D: "معرف الجزء العلوي من الجسم",
  T_49_META_TYP_428_I7_D: "معرف الجزء السفلي من الجسم",
  T_49_META_TYP_428_I8_D: "معرف الحذاء",
  T_49_META_TYP_431_I1_D: "مسار الكيان المستهدف",
  T_49_META_TYP_431_I3_D: "سرعة الحركة، الوحدة: م/ث",
  T_49_META_TYP_431_I4_D: `عند الحركة، هل يكون التوجه باتجاه مماس المسار؟
القيمة الافتراضية: False، يظل توجه الكائن ثابتًا.
عند التعيين إلى True، سيتوجه الكائن نحو اتجاه التقدم على المسار.`,
  T_49_META_TYP_431_I5_D: "نسبة اللعب",
  T_49_META_TYP_432_I0_D: "زاوية التدحرج، والتي تؤثر على الدوران الشعاعي للمسار على جانبي هذه النقطة",
  T_49_META_TYP_432_I1_D: "يحدد الموضع النسبي لنقطة التحكم المماسية ونقطة المسار مماس المسار",
  T_49_META_TYP_433_I0_D: "استيفاء الخطوط المستقيمة بين نقاط المسار",
  T_49_META_TYP_433_I1_D: "الاستيفاء المنحني بين نقاط المسار للحصول على حركة سلسة",
  T_49_META_TYP_433_I2_D: "دعم التعديل اليدوي لمماس نقطة المنحنى",
  T_49_META_TYP_434_I0_D: "نوع المسار",
  T_49_META_TYP_434_I1_D: "الطول الإجمالي للمسار",
  T_49_META_TYP_434_I2_D: "هل البداية والنهاية متصلتان",
  T_49_META_TYP_434_I3_D: "مجموعة نقاط الطريق",
  T_49_META_TYP_437_I3_D: "لاعبو الفريق الأيسر",
  T_49_META_TYP_437_I4_D: "لاعبو الفريق الأيمن",
  T_49_META_TYP_437_I5_D: "مجموعة من أسماء الأنواع المتكاملة",
  T_49_META_TYP_437_I6_D: "مجموعة النقاط على اليسار (أدرج بُعدًا واحدًا: اللاعبون؛ أدرج بُعدين: بيانات النقاط المملوءة وفقًا لنوع النقاط المخصص)",
  T_49_META_TYP_437_I7_D: "مجموعة النقاط على اليمين (أدرج بُعدًا واحدًا: اللاعبون؛ أدرج بُعدين: بيانات النقاط المملوءة وفقًا لنوع النقاط المخصص)",
  T_49_META_TYP_438_I1_D: "تجميع مجموعة اللاعبين",
  T_49_META_TYP_438_I2_D: "مصفوفة ترتيب المجموعة",
  T_49_META_TYP_438_I3_D: "مصفوفة نتائج المجموعة",
  T_49_META_TYP_438_I4_D: "مجموعة من أسماء الأنواع المتكاملة",
  T_49_META_TYP_438_I5_D: "مجموعة ألوان مجمعة",
  T_49_META_TYP_438_I6_D: "مجموعة نقاط اللاعب (تتوافق مع الترتيب عندما لا يتم تجميعها)",
  T_49_META_TYP_442_I1_D: "الدرجة اليسرى",
  T_49_META_TYP_442_I10_D: "أيقونة الموت على اليمين",
  T_49_META_TYP_442_I2_D: "الدرجة اليمنى",
  T_49_META_TYP_442_I3_D: "عدد الناجين على اليسار",
  T_49_META_TYP_442_I4_D: "عدد الناجين على اليمين",
  T_49_META_TYP_442_I5_D: "عدد القتلى على اليسار",
  T_49_META_TYP_442_I6_D: "عدد القتلى على اليمين",
  T_49_META_TYP_442_I7_D: "أيقونة البقاء على اليسار",
  T_49_META_TYP_442_I8_D: "أيقونة البقاء على اليمين",
  T_49_META_TYP_442_I9_D: "أيقونة الموت على اليسار",
  T_49_META_TYP_444_I0_D: "إنجليزي",
  T_49_META_TYP_444_I1_D: "الصينية المبسطة",
  T_49_META_TYP_444_I10_D: "فرنسي",
  T_49_META_TYP_444_I11_D: "الألمانية",
  T_49_META_TYP_444_I12_D: "التركية",
  T_49_META_TYP_444_I13_D: "الهندية",
  T_49_META_TYP_444_I14_D: "اليابانية",
  T_49_META_TYP_444_I15_D: "روماني",
  T_49_META_TYP_444_I16_D: "عربي",
  T_49_META_TYP_444_I17_D: "البورمية",
  T_49_META_TYP_444_I18_D: "الأردية",
  T_49_META_TYP_444_I19_D: "البنغالية",
  T_49_META_TYP_444_I2_D: "الصينية التقليدية",
  T_49_META_TYP_444_I3_D: "التايلاندية",
  T_49_META_TYP_444_I4_D: "الفيتنامية",
  T_49_META_TYP_444_I5_D: "الإندونيسية",
  T_49_META_TYP_444_I6_D: "البرتغالية",
  T_49_META_TYP_444_I7_D: "الأسبانية",
  T_49_META_TYP_444_I8_D: "الروسية",
  T_49_META_TYP_444_I9_D: "كوري",
  T_49_META_TYP_51_I0_D: "زومبي عادي",
  T_49_META_TYP_51_I1_D: "زومبي قاطع الخشب",
  T_49_META_TYP_51_I10_D: "نحلة القنبلة الطائرة",
  T_49_META_TYP_51_I11_D: "تنين الزومبي",
  T_49_META_TYP_51_I2_D: "زومبي الرامي",
  T_49_META_TYP_51_I3_D: "زومبي المتفجر",
  T_49_META_TYP_51_I4_D: "زومبي الطاغية",
  T_49_META_TYP_51_I5_D: "زومبي الرامي الأحمر",
  T_49_META_TYP_51_I6_D: "السيد V",
  T_49_META_TYP_51_I7_D: "زومبي الدبابة",
  T_49_META_TYP_51_I8_D: "زومبي الحفار",
  T_49_META_TYP_51_I9_D: "ساموراي",
  T_49_META_TYP_56_I10_D: "تأخير الانفجار",
  T_49_META_TYP_56_I11_D: "مدى الانفجار",
  T_49_META_TYP_56_I12_D: "ضرر الانفجار",
  T_49_META_TYP_56_I13_D: "وقت الاحتراق",
  T_49_META_TYP_56_I14_D: "ضرر الاحتراق",
  T_49_META_TYP_56_I15_D: "فترة ضرر الاحتراق",
  T_49_META_TYP_56_I17_D: "سائق المركبة",
  T_49_META_TYP_56_I18_D: "جميع الركاب على متن الطائرة",
  T_49_META_TYP_56_I19_D: "معرف غلاف المركبة",
  T_49_META_TYP_56_I20_D: "أولوية تكوين اللاعب",
  T_49_META_TYP_56_I21_D: "الصحة القصوى",
  T_49_META_TYP_56_I22_D: "الصحة",
  T_49_META_TYP_57_I0_D: "سواء كان النقل يدويًا أو تلقائيًا (يدويًا بشكل افتراضي)",
  T_49_META_TYP_58_I0_D: "نوع BUFF المُولَّد",
  T_49_META_TYP_58_I1_D: "الوقت من لحظة التقاط BUFF إلى لحظة إنشاء BUFF التالي، بالثواني",
  T_49_META_TYP_59_I0_D: "نوع الحركة",
  T_49_META_TYP_59_I1_D: "قيمة الحركة X",
  T_49_META_TYP_59_I2_D: "قيمة الحركة Y",
  T_49_META_TYP_59_I3_D: "قيمة الحركة Z",
  T_49_META_TYP_59_I4_D: "مدة الحركة",
  T_49_META_TYP_59_I5_D: "مدة التوقف",
  T_49_META_TYP_59_I6_D: "تعطيل الحركة المتبادلة",
  T_49_META_TYP_60_I0_D: "نهب نقاط الأسلحة",
  T_49_META_TYP_61_I0_D: "العملة المرتبطة",
  T_49_META_TYP_61_I1_D: "ضبط نطاق الزناد",
  T_49_META_TYP_61_I2_D: "رؤية النموذج",
  T_49_META_TYP_62_I0_D: "السرعة XZ",
  T_49_META_TYP_62_I1_D: "السرعة Y",
  T_49_META_TYP_64_I0_D: "نوع مكون الموسيقى",
  T_49_META_TYP_66_I0_D: "معرف المثيل",
  T_49_META_TYP_66_I1_D: "نقطة المسار",
  T_49_META_TYP_68_I0_D: "الوضع الصحي الحالي للذكاء الاصطناعي",
  T_49_META_TYP_68_I1_D: "الحد الأقصى الحالي لصحة الذكاء الاصطناعي",
  T_49_META_TYP_68_I10_D: "هل ستسقط الذكاء الاصطناعي المعدات أو العناصر عندما تموت؟",
  T_49_META_TYP_68_I11_D: "هل الذكاء الاصطناعي في حالة لا تقهر حاليًا",
  T_49_META_TYP_68_I12_D: "عند تلقي الضرر، يمكن تقليل نسبة الضرر أو زيادتها.",
  T_49_META_TYP_68_I13_D: "أنواع الذكاء الاصطناعي",
  T_49_META_TYP_68_I14_D: "ما إذا كان سيتم البحث تلقائيًا عن الأعداء أم لا",
  T_49_META_TYP_68_I15_D: "0 يعني هجوم تلقائي، 1 يعني هجوم دفاعي، 2 يعني عدم وجود أي هجوم على الإطلاق",
  T_49_META_TYP_68_I16_D: "معرّف المسار",
  T_49_META_TYP_68_I17_D: "هدف المطاردة",
  T_49_META_TYP_68_I18_D: "هدف الهجوم",
  T_49_META_TYP_68_I19_D: "إحداثيات نقطة ظهور الذكاء الاصطناعي",
  T_49_META_TYP_68_I2_D: "احصل على كيان الفريق الذي ينتمي إليه الذكاء الاصطناعي",
  T_49_META_TYP_68_I20_D: "رقم فصيل الفريق",
  T_49_META_TYP_68_I4_D: "لا يمكن تعديل سوى قوة هجوم الهجمات العادية، ولا يتم احتساب قوة هجوم المهارات.",
  T_49_META_TYP_68_I7_D: "نطاق حركة الذكاء الاصطناعي الحر. يمكنك تعديل القيمة الأساسية فقط. في حال وجود مكافأة إضافية، فسيتم إضافتها بناءً على القيمة.",
  T_49_META_TYP_68_I8_D: "يكتشف الذكاء الاصطناعي مدى العدو، ولا يمكنه تعديل إلا القيمة الأساسية. في حال وجود مكافأة إضافية، فسيتم إضافتها بناءً على القيمة.",
  T_49_META_TYP_68_I9_D: "سرعة الحركة الفعلية. في حال وجود تسارع في المهارة، تُضاعف سرعتها.",
  T_49_META_TYP_70_I0_D: "معرف الكيان المستهدف للصيغة، المستخدم داخليًا وغير مرئي للاعب.",
  T_49_META_TYP_70_I1_D: "معرف سمة الكيان المستهدف للصيغة، المستخدم داخليًا وغير مرئي للاعب.",
  T_49_META_TYP_70_I2_D: "الحد الأدنى للقيمة المسموح بها",
  T_49_META_TYP_70_I3_D: "الحد الأقصى للقيمة المسموح بها",
  T_49_META_TYP_70_I4_D: "معامل أساسي",
  T_49_META_TYP_70_I5_D: "المجمع السابق",
  T_49_META_TYP_70_I6_D: "المضاعف",
  T_49_META_TYP_70_I7_D: "مضاعف وجمع",
  T_49_META_TYP_70_I8_D: "المجمع اللاحق",
  T_49_META_TYP_71_I0_D: "رقم المنتج",
  T_49_META_TYP_71_I1_D: "السعر",
  T_49_META_TYP_71_I10_D: "عناصر المتجر",
  T_49_META_TYP_71_I2_D: "نوع العملة",
  T_49_META_TYP_71_I3_D: "حد الشراء الإجمالي",
  T_49_META_TYP_71_I4_D: "قيود الشراء الإجمالية الحالية",
  T_49_META_TYP_71_I5_D: "اسم المنتج",
  T_49_META_TYP_71_I6_D: "وصف المنتج",
  T_49_META_TYP_71_I7_D: "قائمة عناصر المنتج",
  T_49_META_TYP_71_I8_D: "قابلية الشراء",
  T_49_META_TYP_71_I9_D: "مسار المورد، فارغ بشكل افتراضي",
  T_49_META_TYP_72_I1_D: "الرفوف",
  T_49_META_TYP_73_I1_D: "إيقاف الإغلاق اليدوي",
  T_49_META_TYP_74_I0_D: "السلاح",
  T_49_META_TYP_74_I1_D: "خوذة",
  T_49_META_TYP_74_I2_D: "سترة",
  T_49_META_TYP_74_I3_D: "قنبلة",
  T_49_META_TYP_75_I0_D: "اتجاه واحد",
  T_49_META_TYP_75_I1_D: "ذهاب وإياب",
  T_49_META_TYP_76_I0_D: "دورية فقط، لا تهاجم الأهداف على طول الطريق",
  T_49_META_TYP_76_I1_D: "دورية وهجوم",
  T_49_META_TYP_79_I0_D: "قوة هجوم السلاح",
  T_49_META_TYP_79_I1_D: "نطاق الهجوم",
  T_49_META_TYP_79_I10_D: "عدد بداية انتشار الرصاصة",
  T_49_META_TYP_79_I11_D: "معرّف السلاح",
  T_49_META_TYP_79_I12_D: "الحد الأدنى لوقت الانتظار بين طلقتين، بالثواني. كل طلقة قد تُطلق عدة رصاصات، حسب نوع الإطلاق.",
  T_49_META_TYP_79_I13_D: "اللاعبون الذين يمتلكون هذا السلاح",
  T_49_META_TYP_79_I14_D: "استهلاك الذخيرة",
  T_49_META_TYP_79_I15_D: "نوع الاستخدام المزدوج (0: لا يوجد استخدام مزدوج، 1: امتلاك، 2: أي سلاح)",
  T_49_META_TYP_79_I16_D: "معامل ضرر الدروع",
  T_49_META_TYP_79_I17_D: "سرعة حركة اللاعب",
  T_49_META_TYP_79_I18_D: "نسبة الضرر لضربات الجذع",
  T_49_META_TYP_79_I19_D: "نسبة الضرر للرصاصات في الرأس",
  T_49_META_TYP_79_I2_D: "الحد الأدنى لوقت الانتظار بين رصاصتين، بالثواني",
  T_49_META_TYP_79_I20_D: "نسبة الضرر للأطراف",
  T_49_META_TYP_79_I21_D: "نسبة الضرر الإضافي (السيارة، جدار الجليد لبرميل النفط)",
  T_49_META_TYP_79_I22_D: "مرئية في الخلف",
  T_49_META_TYP_79_I23_D: "اضرب الأرض للحصول على ضرر إضافي",
  T_49_META_TYP_79_I24_D: "ذخيرة لكل طلقة",
  T_49_META_TYP_79_I25_D: "سرعة إعادة التحميل (السرعة الأساسية * المعامل)",
  T_49_META_TYP_79_I26_D: "عدد الطلقات الحالي",
  T_49_META_TYP_79_I27_D: "معرف جلد السلاح",
  T_49_META_TYP_79_I28_D: "عندما يتم إعطاء الأولوية لتكوين اللاعب، فإن تكوين مظهر سلاح اللاعب سيتجاوز سمات مظهر سلاح اللاعب نفسه",
  T_49_META_TYP_79_I29_D: "عند كتابة خصائص غلاف السلاح إلى سلاح، فإن القيمة الأساسية للسلاح سوف تتأثر بغطاء السلاح",
  T_49_META_TYP_79_I3_D: "حجم مخزن الذخيرة",
  T_49_META_TYP_79_I30_D: "معدل زيادة الانتشار (0.1 = كل دفعة إضافية من اللقطات تزيد من علامة التصويب بنسبة 10٪)",
  T_49_META_TYP_79_I31_D: "سرعة استرداد التشتت",
  T_49_META_TYP_79_I32_D: "سرعة اللاعب عند التصويب تؤثر",
  T_49_META_TYP_79_I33_D: "حجم الانتشار عند التحرك (1.5 = 1.5 * حجم التقاطع الأساسي)",
  T_49_META_TYP_79_I34_D: "نوع السلاح",
  T_49_META_TYP_79_I36_D: "نوع النار",
  T_49_META_TYP_79_I37_D: "طلقة واحدة",
  T_49_META_TYP_79_I38_D: "تم كتم الصوت",
  T_49_META_TYP_79_I39_D: "مضاعف حساسية التصويب",
  T_49_META_TYP_79_I4_D: "عدد المخازن الأولية",
  T_49_META_TYP_79_I5_D: "اختراق الدرع",
  T_49_META_TYP_79_I6_D: "مسافة الضرر الكامل",
  T_49_META_TYP_79_I7_D: "الحد الأدنى لمسافة الضرر",
  T_49_META_TYP_79_I8_D: "الحد الأدنى للضرر",
  T_49_META_TYP_79_I9_D: "عدد الرصاصات التي يمكن إطلاقها قبل أن يبدأ التشتت",
  T_49_META_TYP_80_I1_D: "عندما يكون هذا صحيحًا، يُحظر الإغلاق اليدوي",
  T_49_META_TYP_80_I2_D: "كيان المتجر المرتبط",
  T_49_META_TYP_80_I4_D: "معرف المحفظة المرتبط",
  T_49_META_TYP_80_I5_D: "نوع الطلب",
  T_49_META_TYP_80_I6_D: "نوع الهدف المطلوب للاعب واجهة المستخدم الحالي",
  T_49_META_TYP_80_I7_D: "معرف اللاعب المحفز",
  T_49_META_TYP_81_I0_D: "عشوائي بوف",
  T_49_META_TYP_81_I1_D: "بوف الصحة",
  T_49_META_TYP_81_I2_D: "بوف الرصاص",
  T_49_META_TYP_81_I3_D: "بوف الدروع",
  T_49_META_TYP_82_I1_D: "أيقونة الزر",
  T_49_META_TYP_82_I3_D: "الموضع بالنسبة لنقطة الارتكاز",
  T_49_META_TYP_83_I1_D: "العملات",
  T_49_META_TYP_83_I2_D: "تمرير المعلمات",
  T_49_META_TYP_86_I0_D: "الحد الأدنى",
  T_49_META_TYP_86_I1_D: "الحد الأقصى",
  T_49_META_TYP_86_I2_D: "معامل الأساس، مضروبًا في القيمة الأصلية قبل جميع الحسابات",
  T_49_META_TYP_86_I3_D: "مُراكم مسبق، يُراكم قبل الضرب ويشارك في حساب الضرب",
  T_49_META_TYP_86_I4_D: "المضاعف المستمر، الضرب المستمر، على سبيل المثال (التخفيض إلى 90%، التعزيز إلى 110%) يكون التأثير هو القيمة * 90% * 110%",
  T_49_META_TYP_86_I5_D: "على سبيل المثال، فإن مُراكم الضرب (أضف 10%، أضف 5%) له تأثير القيمة*(1+10%+5%)",
  T_49_META_TYP_86_I6_D: "تراكم لاحق، لا يشارك في حساب الضرب، ويضاف في النهاية",
  T_49_META_TYP_88_I0_D: "النوع الأساسي، عملة اللعبة الأساسية، نوع تسعير السلع العامة في الإصدار الحالي",
  T_49_META_TYP_89_I0_D: "حاليًا، لا يوجد سوى العملة الأساسية في الإصدار",
  T_49_META_TYP_89_I1_D: "كمية العملة",
  T_49_META_TYP_89_I2_D: "أيقونات العملة",
  T_49_META_TYP_89_I3_D: "لون أيقونة العملة",
  T_49_META_TYP_90_I0_D: "محتويات المحفظة عبارة عن مجموعة من العملات",
  T_49_META_TYP_92_I0_D: "صندوق خشبي مربع",
  T_49_META_TYP_92_I1_D: "صندوق خشبي طويل",
  T_49_META_TYP_92_I10_D: "برج المراقبة",
  T_49_META_TYP_92_I100_D: "سلم",
  T_49_META_TYP_92_I101_D: "هبوط الدرج B",
  T_49_META_TYP_92_I102_D: "هبوط الدرج A",
  T_49_META_TYP_92_I103_D: "كابينة الهاتف",
  T_49_META_TYP_92_I104_D: "جدار موضوع BIS",
  T_49_META_TYP_92_I105_D: "فراش زهور موضوع BIS",
  T_49_META_TYP_92_I106_D: "آلة البيع",
  T_49_META_TYP_92_I107_D: "كيان الوحش",
  T_49_META_TYP_92_I108_D: "مولد الوحدة",
  T_49_META_TYP_92_I109_D: "سيارة رياضية",
  T_49_META_TYP_92_I11_D: "بيت الحراسة",
  T_49_META_TYP_92_I110_D: "توك توك",
  T_49_META_TYP_92_I111_D: "صندوق خشبي قابل للتدمير",
  T_49_META_TYP_92_I112_D: "SUV",
  T_49_META_TYP_92_I113_D: "دراجة نارية",
  T_49_META_TYP_92_I114_D: "شاحنات الوحش",
  T_49_META_TYP_92_I115_D: "مولد الذهب",
  T_49_META_TYP_92_I116_D: "هبوط الدرج C",
  T_49_META_TYP_92_I117_D: "لافتة",
  T_49_META_TYP_92_I118_D: "سياج",
  T_49_META_TYP_92_I119_D: "آلة الجيرسي",
  T_49_META_TYP_92_I12_D: "منزل ذو طابقين",
  T_49_META_TYP_92_I121_D: "عمود خرساني",
  T_49_META_TYP_92_I122_D: "صندوق لوت كرة القدم",
  T_49_META_TYP_92_I123_D: "برميل زيت",
  T_49_META_TYP_92_I124_D: "منطقة جاذبية منخفضة",
  T_49_META_TYP_92_I125_D: "سلاح",
  T_49_META_TYP_92_I126_D: "سياج B",
  T_49_META_TYP_92_I127_D: "منزل صغير A",
  T_49_META_TYP_92_I128_D: "شاحنة تالفة",
  T_49_META_TYP_92_I129_D: "كرة أساسية",
  T_49_META_TYP_92_I13_D: "تمثال رمل",
  T_49_META_TYP_92_I130_D: "مخروط أساسي",
  T_49_META_TYP_92_I131_D: "أسطوانة أساسية",
  T_49_META_TYP_92_I132_D: "مولد المستهلكات",
  T_49_META_TYP_92_I133_D: "الجسم المائي المخصص",
  T_49_META_TYP_92_I134_D: "سهم",
  T_49_META_TYP_92_I135_D: "كتلة مصبوغة",
  T_49_META_TYP_92_I136_D: "برميل مدهون",
  T_49_META_TYP_92_I137_D: "نص",
  T_49_META_TYP_92_I138_D: "رمز",
  T_49_META_TYP_92_I139_D: "دمية الثلج",
  T_49_META_TYP_92_I14_D: "نافورة",
  T_49_META_TYP_92_I140_D: "زناد كبسولة",
  T_49_META_TYP_92_I141_D: "مشغل الاصطدام الكروي",
  T_49_META_TYP_92_I142_D: "الكتلة الأساسية ذات اللون الصلب العاكس 1",
  T_49_META_TYP_92_I143_D: "مصنع سيارات الاصطدام",
  T_49_META_TYP_92_I144_D: "بلوك المتنزه المربعات",
  T_49_META_TYP_92_I145_D: "شاشة كبيرة",
  T_49_META_TYP_92_I146_D: "المنصة",
  T_49_META_TYP_92_I147_D: "مصاصة عملاقة",
  T_49_META_TYP_92_I148_D: "شاحنة طعام B",
  T_49_META_TYP_92_I15_D: "شجرة الكرز",
  T_49_META_TYP_92_I16_D: "منزل من طابق واحد",
  T_49_META_TYP_92_I17_D: "منزل من ثلاثة طوابق",
  T_49_META_TYP_92_I18_D: "شجرة الموز",
  T_49_META_TYP_92_I19_D: "مرحاض",
  T_49_META_TYP_92_I2_D: "صندوق خشبي طويل مغطى بالشجيرات",
  T_49_META_TYP_92_I20_D: "سياج",
  T_49_META_TYP_92_I21_D: "حاوية قابلة للتدمير",
  T_49_META_TYP_92_I22_D: "سياج قابل للتدمير",
  T_49_META_TYP_92_I23_D: "إطار",
  T_49_META_TYP_92_I24_D: "سيارة التصادم",
  T_49_META_TYP_92_I25_D: "مركبة برمائية",
  T_49_META_TYP_92_I26_D: "جيب",
  T_49_META_TYP_92_I27_D: "سلة المهملات",
  T_49_META_TYP_92_I28_D: "خيمة طبية",
  T_49_META_TYP_92_I29_D: "كراج",
  T_49_META_TYP_92_I3_D: "كومة قش",
  T_49_META_TYP_92_I30_D: "جدار مطلي",
  T_49_META_TYP_92_I31_D: "توري",
  T_49_META_TYP_92_I32_D: "منصة حديدية",
  T_49_META_TYP_92_I33_D: "بيت الحاوية",
  T_49_META_TYP_92_I34_D: "مقطورة",
  T_49_META_TYP_92_I35_D: "الجدار A",
  T_49_META_TYP_92_I36_D: "ملاحظات موسيقية - بيانو",
  T_49_META_TYP_92_I37_D: "ملاحظات موسيقية - بيانو",
  T_49_META_TYP_92_I38_D: "ملاحظات موسيقية - طبل",
  T_49_META_TYP_92_I39_D: "ملاحظات موسيقية - طبل",
  T_49_META_TYP_92_I4_D: "سيارة مدمرة",
  T_49_META_TYP_92_I40_D: "ملاحظات موسيقية - سنتيساير A",
  T_49_META_TYP_92_I41_D: "ملاحظات موسيقية - سنتيساير A",
  T_49_META_TYP_92_I42_D: "ملاحظات موسيقية - سنتيساير B",
  T_49_META_TYP_92_I43_D: "ملاحظات موسيقية - سنتيساير B",
  T_49_META_TYP_92_I44_D: "ملاحظات موسيقية - سنتيساير C",
  T_49_META_TYP_92_I45_D: "ملاحظات موسيقية - سنتيساير C",
  T_49_META_TYP_92_I46_D: "مولد تعزيز",
  T_49_META_TYP_92_I47_D: "آلية المروحة",
  T_49_META_TYP_92_I48_D: "آلية مقلاة",
  T_49_META_TYP_92_I49_D: "مصيدة الكتل",
  T_49_META_TYP_92_I5_D: "حافلة مدمرة",
  T_49_META_TYP_92_I50_D: "آلية الحلقة",
  T_49_META_TYP_92_I51_D: "فخ المطرقة العملاقة",
  T_49_META_TYP_92_I52_D: "لوحة متنقلة",
  T_49_META_TYP_92_I53_D: "هدف متحرك",
  T_49_META_TYP_92_I54_D: "جدار تلسكوبي",
  T_49_META_TYP_92_I55_D: "مكونات سلاح نقاط الغنائم",
  T_49_META_TYP_92_I56_D: "مكون رصاصة نقطة الغنائم",
  T_49_META_TYP_92_I57_D: "مكونات العناصر الاستهلاكية لنقاط الغنائم",
  T_49_META_TYP_92_I58_D: "مكون عنصر رمي نقاط الغنائم",
  T_49_META_TYP_92_I59_D: "مكون تكبير نقطة الغنائم",
  T_49_META_TYP_92_I6_D: "حاوية A",
  T_49_META_TYP_92_I60_D: "مكونات درع نقاط الغنائم",
  T_49_META_TYP_92_I61_D: "أنبوب I",
  T_49_META_TYP_92_I62_D: "أنبوب T",
  T_49_META_TYP_92_I63_D: "أنبوب تقاطع",
  T_49_META_TYP_92_I64_D: "أنبوب كوع",
  T_49_META_TYP_92_I65_D: "مجموعة الفطر العملاقة",
  T_49_META_TYP_92_I66_D: "رف تجفيف الملابس",
  T_49_META_TYP_92_I67_D: "جسر خشبي",
  T_49_META_TYP_92_I68_D: "شاشة",
  T_49_META_TYP_92_I69_D: "عمود خرساني",
  T_49_META_TYP_92_I7_D: "حاوية شحن ب",
  T_49_META_TYP_92_I70_D: "صبار",
  T_49_META_TYP_92_I71_D: "خشب ميت",
  T_49_META_TYP_92_I72_D: "مصباح القصر",
  T_49_META_TYP_92_I73_D: "مصباح الشارع",
  T_49_META_TYP_92_I74_D: "لوحة شمسية",
  T_49_META_TYP_92_I75_D: "مكيف الهواء",
  T_49_META_TYP_92_I76_D: "مربع",
  T_49_META_TYP_92_I77_D: "ميل",
  T_49_META_TYP_92_I78_D: "شاحنة طعام",
  T_49_META_TYP_92_I79_D: "مشغل الموت أو المناعة",
  T_49_META_TYP_92_I8_D: "حاوية شحن ج",
  T_49_META_TYP_92_I80_D: "نقطة تفتيش",
  T_49_META_TYP_92_I81_D: "موقع النهاية",
  T_49_META_TYP_92_I82_D: "نرد",
  T_49_META_TYP_92_I83_D: "مقعد",
  T_49_META_TYP_92_I84_D: "محطة حافلات",
  T_49_META_TYP_92_I85_D: "بيت الكلب",
  T_49_META_TYP_92_I86_D: "لافتات إعلانات",
  T_49_META_TYP_92_I87_D: "إبريق الماء",
  T_49_META_TYP_92_I88_D: "جدار جرافيتي",
  T_49_META_TYP_92_I89_D: "كوخ القش",
  T_49_META_TYP_92_I9_D: "كابينة",
  T_49_META_TYP_92_I90_D: "جسر قوس حجري",
  T_49_META_TYP_92_I91_D: "طقم فناء مع مظلة",
  T_49_META_TYP_92_I92_D: "لافتة النهاية",
  T_49_META_TYP_92_I93_D: "قلعة",
  T_49_META_TYP_92_I94_D: "نقطة استدعاء الوحش",
  T_49_META_TYP_92_I95_D: "علامة",
  T_49_META_TYP_92_I97_D: "مشغل مخصص",
  T_49_META_TYP_92_I98_D: "باب مزدوج",
  T_49_META_TYP_92_I99_D: "حاجز",
  T_49_META_TYP_94_I0_D: "أضف",
  T_49_META_TYP_94_I1_D: "ضرب",
  T_49_META_TYP_95_I0_D: "نوع العملة",
  T_49_META_TYP_95_I1_D: "كمية العملة",
  T_49_META_TYP_96_I0_D: "الحصول على المحفظة",
  T_49_META_TYP_96_I1_D: "موضع العرض (نقطة التثبيت هي الزاوية اليمنى العليا)",
  T_49_META_TYP_97_I0_D: "الموقع في إحداثيات العالم",
  T_49_META_TYP_97_I1_D: "زاوية الدوران في نظام إحداثيات العالم، مكونات XYZ هي زاوية الميل، وزاوية الانحراف، وزاوية التدحرج، وترتيب الدوران هو YXZ.",
  T_49_META_TYP_97_I10_D: "اتجاه محور الإحداثيات المحلي x",
  T_49_META_TYP_97_I11_D: "اتجاه محور الإحداثيات المحلي z",
  T_49_META_TYP_97_I2_D: "القياس في إحداثيات العالم",
  T_49_META_TYP_97_I3_D: "العقدة الأصلية لهذه العقدة",
  T_49_META_TYP_97_I4_D: "الدوران في إحداثيات العالم، معبرًا عنه على شكل رباعيات",
  T_49_META_TYP_97_I5_D: "الموقع في نظام الإحداثيات المحلي",
  T_49_META_TYP_97_I6_D: "الدوران في نظام الإحداثيات المحلي، معبرًا عنه على شكل رباعية",
  T_49_META_TYP_97_I7_D: "زاوية الدوران في نظام الإحداثيات المحلي، ومكونات XYZ هي زاوية الميل، وزاوية الانحراف، وزاوية التدحرج، وترتيب الدوران هو YXZ.",
  T_49_META_TYP_97_I8_D: "حجم المقياس في نظام الإحداثيات المحلي",
  T_49_META_TYP_97_I9_D: "اتجاه محور الإحداثيات المحلي y",
  T_49_META_TYP_99_I0_D: "دائرة كرة القدم",
  T_49_META_TYP_99_I1_D: "معامل الاحتكاك في الظروف العادية",
  T_49_META_TYP_99_I2_D: "معامل الاحتكاك تحت التأثير",
  T_49_META_TYP_99_I3_D: "الحد الأدنى لزاوية الإطلاق",
  T_49_META_TYP_99_I4_D: "الحد الأدنى لزاوية الارتفاع",
  T_49_META_TYP_99_I5_D: "إعادة ضبط الوقت",
  T_49_META_TYP_99_I6_D: "الحد الأعلى لزاوية الإطلاق",
  T_49_META_TYP_99_I7_D: "إعادة تعيين الموقع",
  T_49_META_TYPE_0_D: "الكائن، جذر التسلسل الهرمي للنوع",
  T_49_META_TYPE_1_D: "القائمة عبارة عن حاوية لمجموعة من البيانات",
  T_49_META_TYPE_10_D: "مكون قاعدة الكيان، سيتم دمج جميع المكونات مع هذا المكون",
  T_49_META_TYPE_100_D: "ماكينة القمصان",
  T_49_META_TYPE_101_D: "عنصر تحول",
  T_49_META_TYPE_1010_D: "معلومات المؤقت",
  T_49_META_TYPE_1011_D: "لافتة الافتتاح",
  T_49_META_TYPE_1012_D: "شعار الفريقين في بداية الجولة. تعديل خصائص الشعار سيؤثر على محتوى العرض في واجهة المستخدم المقابلة.",
  T_49_META_TYPE_1013_D: "بشكل عام، كيان اللافتة في بداية الجولة، تعديل خصائص الكيان سيؤثر على محتوى العرض على واجهة المستخدم المقابلة",
  T_49_META_TYPE_1014_D: "كيان لافتة نتيجة جولة الفريق. تعديل سمات الكيان سيؤثر على محتوى العرض في واجهة المستخدم المقابلة.",
  T_49_META_TYPE_1015_D: "كيان مدير نقاط التفتيش. تعديل سمات الكيان سيؤثر على محتوى العرض في واجهة المستخدم المقابلة.",
  T_49_META_TYPE_1016_D: "سيتم عرض الكيان في نهاية الجولة. تعديل سمات الكيان سيؤثر على محتوى العرض في واجهة المستخدم المقابلة.",
  T_49_META_TYPE_1017_D: "إذا كان هناك فريقان في البداية، اعرض لافتة الفريقين اللذين يتقاتلان ضد بعضهما البعض",
  T_49_META_TYPE_1018_D: "نتيجة كلا الفريقين",
  T_49_META_TYPE_1019_D: "النتيجة النهائية: فوز، خسارة، تعادل",
  T_49_META_TYPE_102_D: "نوع مصدر القيامة: الموت، السقوط",
  T_49_META_TYPE_1020_D: "تحويل رقم الكيان، وتعديل سمات الكيان سيؤثر على محتوى العرض على واجهة المستخدم المقابلة",
  T_49_META_TYPE_1021_D: "كيان العد التنازلي للمراحل. تعديل سمات الكيان سيؤثر على محتوى العرض في واجهة المستخدم المقابلة.",
  T_49_META_TYPE_1022_D: "عنوان فرعي لمعلومات اللعبة. تعديل سمات الكيان سيؤثر على محتوى العرض في واجهة المستخدم المقابلة.",
  T_49_META_TYPE_1023_D: "معلومات عن كيانات لعب الفريقين. تعديل سمات الكيان سيؤثر على محتوى العرض في واجهة المستخدم المقابلة.",
  T_49_META_TYPE_1024_D: "واجهة مستخدم معلومات مباراة الفريق. تعديل سمات الكيان سيؤثر على محتوى العرض في واجهة المستخدم المقابلة.",
  T_49_META_TYPE_1027_D: "يصف نوع النوع، والذي يتم إرجاعه عند استخدام Typeof",
  T_49_META_TYPE_1028_D: "كيان معلومات الفصيل. تعديل سمات الكيان سيؤثر على محتوى العرض في واجهة المستخدم المقابلة.",
  T_49_META_TYPE_1029_D: "يطالب الرمز بمعلومات الكيان، وتعديل سمات الكيان سيؤثر على محتوى العرض على واجهة المستخدم المقابلة",
  T_49_META_TYPE_103_D: "تعداد نوع فتحة العنصر",
  T_49_META_TYPE_1030_D: "كيان مُبسَّط لمعلومات مباراة الفريقين. تعديل سمات الكيان سيؤثر على محتوى العرض في واجهة المستخدم المقابلة.",
  T_49_META_TYPE_1031_D: "كيان واجهة مطالبة التوقيت، تعديل سمات الكيان سيؤثر على محتوى العرض على واجهة المستخدم المقابلة",
  T_49_META_TYPE_1032_D: "يُطالب النص العائم الكيان. سيؤثر تعديل سمات الكيان على محتوى العرض في واجهة المستخدم المقابلة.",
  T_49_META_TYPE_1033_D: "يتضمن كيان تبديل الدور معلومات تسوية الدور الحالي وبداية الدور التالي. سيؤثر تعديل سمات الكيان على محتوى العرض في واجهة المستخدم المقابلة.",
  T_49_META_TYPE_1035_D: "افتح زر لوحة النتائج في واجهة المستخدم. تعديل سمات هذا الزر سيؤثر على محتوى العرض في واجهة المستخدم المقابلة.",
  T_49_META_TYPE_1036_D: "وضع العدوى، واجهة المستخدم تُظهر مستوى الزومبي الحالي",
  T_49_META_TYPE_1037_D: "أضف عنصر واجهة مستخدم ذي تأثير ديناميكي للنقاط. سيؤثر تعديل سمات هذا العنصر على محتوى العرض في واجهة المستخدم المقابلة.",
  T_49_META_TYPE_1038_D: "تأثيرات واجهة مستخدم وضع العدوى الزومبي",
  T_49_META_TYPE_1039_D: "كيان موجه النص العائم للعد التنازلي، وتعديل سمات الكيان سيؤثر على محتوى العرض على واجهة المستخدم المقابلة",
  T_49_META_TYPE_104_D: "نمط القميص",
  T_49_META_TYPE_1040_D: "شريط اختيار البطاقات",
  T_49_META_TYPE_1041_D: "الإشعار بالهوية",
  T_49_META_TYPE_1042_D: "واجهة المستخدم للعد التنازلي لخمس ثوانٍ",
  T_49_META_TYPE_1043_D: "راية العنوان",
  T_49_META_TYPE_1044_D: "مفتاح واجهة المستخدم المدمج",
  T_49_META_TYPE_1045_D: "واجهة المستخدم لزر المهارات",
  T_49_META_TYPE_105_D: "هدف كرة القدم",
  T_49_META_TYPE_106_D: "نوع مساعدة التصويب",
  T_49_META_TYPE_107_D: "يمكن استهدافه وضربه، ولكن لن يتعرض بالضرورة للأضرار",
  T_49_META_TYPE_108_D: "نوع صحيح، عدد صحيح موقّع 64 بت",
  T_49_META_TYPE_109_D: "كيان قناة الدردشة عبارة عن حاوية تحتوي على معرف القناة والمشغلات الخاصة بها.",
  T_49_META_TYPE_11_D: "كيان عالمي، فريد من نوعه في اللعبة بأكملها",
  T_49_META_TYPE_110_D: "قناة الصوت الخامل",
  T_49_META_TYPE_111_D: "نوع السلوك",
  T_49_META_TYPE_112_D: "نوع حالة سلوك اللاعب",
  T_49_META_TYPE_113_D: "موسيقى الطبل",
  T_49_META_TYPE_114_D: "موسيقى Lead1",
  T_49_META_TYPE_115_D: "موسيقى Lead2",
  T_49_META_TYPE_116_D: "موسيقى Lead3",
  T_49_META_TYPE_117_D: "نوع مكون موسيقى الطبل",
  T_49_META_TYPE_118_D: "فصيل",
  T_49_META_TYPE_119_D: "خيارات الهجوم",
  T_49_META_TYPE_12_D: "كيان قتالي يمكنه الهجوم والتعرض للهجوم والقتل وما إلى ذلك.",
  T_49_META_TYPE_120_D: "شريط التقدم",
  T_49_META_TYPE_121_D: "كل فترة زمنية للموجة",
  T_49_META_TYPE_122_D: "صندوق السماء",
  T_49_META_TYPE_123_D: "تعداد نوع قاعدة Skybox",
  T_49_META_TYPE_124_D: "نطاق البحث",
  T_49_META_TYPE_125_D: "يمكنك تعديل المظهر الأساسي للأشياء، مثل القوام والشفافية",
  T_49_META_TYPE_126_D: "شريط الصحة",
  T_49_META_TYPE_127_D: "كيفية تحريك الأشياء",
  T_49_META_TYPE_128_D: "عنصر قابل للتحويل",
  T_49_META_TYPE_129_D: "نوع ذخيرة الغنيمة",
  T_49_META_TYPE_13_D: "كيان التحكم في واجهة المستخدم",
  T_49_META_TYPE_130_D: "نوع مستهلك الغنيمة",
  T_49_META_TYPE_131_D: "نوع درع الغنيمة",
  T_49_META_TYPE_132_D: "نوع عنصر قابل للرمي الغنيمة",
  T_49_META_TYPE_133_D: "نوع منظار الغنيمة",
  T_49_META_TYPE_134_D: "نوع سلاح الغنيمة",
  T_49_META_TYPE_135_D: "سيؤدي ذلك إلى سقوط نوع الذخيرة المحدد",
  T_49_META_TYPE_136_D: "سوف ينتج نوع محدد من إسقاطات الدعائم",
  T_49_META_TYPE_137_D: "سيؤدي إلى سقوط مقذوف من النوع المحدد",
  T_49_META_TYPE_138_D: "سيؤدي ذلك إلى إسقاط نطاق النوع المحدد",
  T_49_META_TYPE_139_D: "سيؤدي إلى سقوط درع النوع المحدد",
  T_49_META_TYPE_14_D: "كيانات اللاعب في اللعبة، كيان واحد لكل مستخدم",
  T_49_META_TYPE_140_D: "موجة",
  T_49_META_TYPE_141_D: "نوع لوت كرة القدم",
  T_49_META_TYPE_142_D: "صندوق لوت كرة القدم",
  T_49_META_TYPE_143_D: "نوع مكون الموسيقى Lead1",
  T_49_META_TYPE_144_D: "نوع مكون الموسيقى Lead2",
  T_49_META_TYPE_145_D: "نوع مكون الموسيقى Lead3",
  T_49_META_TYPE_146_D: "نوع مكون موسيقى لوحة المفاتيح",
  T_49_META_TYPE_147_D: "يوفر مجموعة متنوعة من أنواع الكاميرات المحددة مسبقًا، بالإضافة إلى أنواع الكاميرات المخصصة",
  T_49_META_TYPE_148_D: "مكونات الكاميرا",
  T_49_META_TYPE_149_D: "مفتاح الترجمة",
  T_49_META_TYPE_15_D: "كيانات الفريق في اللعبة، واحدة لكل فريق",
  T_49_META_TYPE_150_D: "برميل زيت",
  T_49_META_TYPE_151_D: "الرباعية هي متجه رباعي الأبعاد خاص يستخدم فقط لتمثيل الدوران.",
  T_49_META_TYPE_152_D: "منطقة جاذبية منخفضة",
  T_49_META_TYPE_153_D: "حاوية الكيان، والتي ستُنشئ كيانات من النوع المقابل في الموقع",
  T_49_META_TYPE_154_D: "نوع الأسلحة المزدوجة",
  T_49_META_TYPE_155_D: "كيان الخوذة",
  T_49_META_TYPE_156_D: "كيان الدروع الواقية للبدن",
  T_49_META_TYPE_157_D: "نوع نوع انتقال الكاميرا",
  T_49_META_TYPE_158_D: "واجهة مطالبة النص",
  T_49_META_TYPE_159_D: "فكتور 2",
  T_49_META_TYPE_16_D: "كيان كائن المستوى",
  T_49_META_TYPE_160_D: "نوع الخريطة",
  T_49_META_TYPE_161_D: "VFX لقماش غير قابل للتبديل",
  T_49_META_TYPE_162_D: "قائمة النوع",
  T_49_META_TYPE_163_D: "نوع أو قائمة النوع",
  T_49_META_TYPE_164_D: "المكون هو الفئة الأساسية لجميع مكونات الكيان أو فئات المكونات المحددة",
  T_49_META_TYPE_165_D: "مكون صندوق الاصطدام",
  T_49_META_TYPE_166_D: "إيموت",
  T_49_META_TYPE_167_D: "يمثل كيان التأثير الخاص تأثيرًا خاصًا معروضًا (محذوفًا وقابلًا لإعادة التدوير وإعادة الاستخدام)",
  T_49_META_TYPE_17_D: "قائمة كائنات المستوى",
  T_49_META_TYPE_170_D: "يشير إلى ما إذا كان من الممكن ضبط الرؤية",
  T_49_META_TYPE_171_D: "فطر",
  T_49_META_TYPE_172_D: "ذخیرہ",
  T_49_META_TYPE_173_D: "حقيبة ظهر",
  T_49_META_TYPE_174_D: "مكونات القنبلة اليدوية",
  T_49_META_TYPE_175_D: "قنبلة التجميد",
  T_49_META_TYPE_176_D: "مولد الأسلحة",
  T_49_META_TYPE_177_D: "عندما يكون هناك عائق بين الكاميرا والهدف الذي يتم متابعته، يتم تغيير وضع حركة الكاميرا",
  T_49_META_TYPE_178_D: "كيف تقوم الكاميرا بمعالجة الصورة",
  T_49_META_TYPE_179_D: "كرة أساسية",
  T_49_META_TYPE_18_D: "(قديم، لا تستخدم)",
  T_49_META_TYPE_180_D: "يشير إلى خاصية مكون",
  T_49_META_TYPE_181_D: "يستخدم لوصف نوع أصول الشبكة",
  T_49_META_TYPE_182_D: "يستخدم لوصف نوع الأصول المادية",
  T_49_META_TYPE_183_D: "يستخدم لوصف نوع أصل الملمس",
  T_49_META_TYPE_184_D: "مكون عرض جسر للعرض باستخدام موارد النموذج المضمنة",
  T_49_META_TYPE_185_D: "مكون عرض مخصص للعرض باستخدام موارد النموذج المخصصة",
  T_49_META_TYPE_186_D: "مكون كائن فارغ يمكن استخدامه مع مكونات العرض ومكونات التصادم وما إلى ذلك.",
  T_49_META_TYPE_187_D: "حاوية",
  T_49_META_TYPE_188_D: "أسطوانة أو مخروط أساسي",
  T_49_META_TYPE_189_D: "قائمة السلاسل المترجمة",
  T_49_META_TYPE_19_D: "قالب القائمة، يمكنك تحديد نوع المحتوى من خلال T",
  T_49_META_TYPE_190_D: "لوحة درجات فريقين",
  T_49_META_TYPE_191_D: "سلاح رمي تكتيكي يمكنه أن يصيب الأعداء بالعمى مؤقتًا ضمن نطاق معين.",
  T_49_META_TYPE_192_D: "بعد الاستخدام، يمكنه إنتاج دخان يخفي الحدث، وهو سلاح قوي لتعطيل هجوم العدو.",
  T_49_META_TYPE_193_D: "لوحة نتائج فرق متعددة",
  T_49_META_TYPE_194_D: "يمكن وضع الألغام التحريضية على الأرض. ستنفجر عند اقتراب العدو. احذر من الدوس عليها.",
  T_49_META_TYPE_195_D: "كيف يتم تشغيل الحركة المداخلة",
  T_49_META_TYPE_197_D: "المكونات القابلة للتشغيل",
  T_49_META_TYPE_198_D: "قاعدة البيانات",
  T_49_META_TYPE_199_D: "معدات مساعدة للقتال الجوي، ولكن عليك الانتباه إلى استهلاك الطاقة في جميع الأوقات",
  T_49_META_TYPE_2_D: "النوع المنطقي، يستخدم لتمثيل الصواب أو الخطأ أو نعم أو لا",
  T_49_META_TYPE_20_D: "تعداد نوع الواجهة المدمج، والذي يتم إنشاؤه تلقائيًا استنادًا إلى نظام النوع",
  T_49_META_TYPE_200_D: "منطقة الهروب من السجن",
  T_49_META_TYPE_201_D: "المناطق التي يمكنك السباحة فيها بعد الدخول",
  T_49_META_TYPE_202_D: "معرف الاصطدام",
  T_49_META_TYPE_203_D: "حركة الاستيفاء",
  T_49_META_TYPE_204_D: "حذاء مزود بجهاز طاقة تكنولوجي يسمح لك بالقفز المزدوج في الهواء",
  T_49_META_TYPE_205_D: "طائرة شراعية معلقة قادرة على التحليق في السماء. يمكن استخدامها للهبوط من ارتفاع عالٍ والانتقال إلى مكان أبعد.",
  T_49_META_TYPE_206_D: "لوح التزلج",
  T_49_META_TYPE_207_D: "خط انزلاقي",
  T_49_META_TYPE_208_D: "قائمة العناصر القابلة للعب",
  T_49_META_TYPE_209_D: "قابلة للتشغيل أو قائمة قابلة للتشغيل",
  T_49_META_TYPE_21_D: "كيان واجهة مدمج، يغلف واجهة وظائف محددة",
  T_49_META_TYPE_210_D: "الرسوم المتحركة الباليستية هي محاكاة للحركة الباليستية.",
  T_49_META_TYPE_211_D: "نظام الإحداثيات",
  T_49_META_TYPE_212_D: "كائن واحد يتبع الآخر",
  T_49_META_TYPE_213_D: "إن واجهة الجسم تواجه دائمًا الجسم الآخر",
  T_49_META_TYPE_214_D: "المعرف المستخدم لوصف أصل العفريت الأطلس",
  T_49_META_TYPE_215_D: "نتيجة المباراة",
  T_49_META_TYPE_216_D: "حاوية بيانات القاموس، عنصر البيانات هو زوج من المفتاح والقيمة",
  T_49_META_TYPE_217_D: "قالب بيانات القاموس، يمكن تحديد نوع المحتوى بواسطة T1 وT2",
  T_49_META_TYPE_218_D: "نوع من مصادر الضوء يصدر ضوءًا بنفس الكثافة في جميع الاتجاهات من موقعه",
  T_49_META_TYPE_219_D: "مركبات الدراجات النارية",
  T_49_META_TYPE_22_D: "الواجهة المخصصة، الواجهة التي أنشأها اللاعب من خلال محرر الواجهة",
  T_49_META_TYPE_220_D: "مركبة توك توك (ذات ثلاث عجلات)",
  T_49_META_TYPE_221_D: "مركبة دراجة نارية برمائية/مدفع رشاش",
  T_49_META_TYPE_222_D: "مركبة ذات أربع عجلات",
  T_49_META_TYPE_224_D: "قائمة أنواع المهارات",
  T_49_META_TYPE_225_D: "سيقوم البرج الذكي المصنوع من مواد عالية التقنية بالبحث بنشاط ومهاجمة الأعداء ضمن نطاق معين.",
  T_49_META_TYPE_226_D: "البرج الذي تم إنشاؤه بعد استخدام دعامة البرج",
  T_49_META_TYPE_227_D: "تعداد نوع عنصر التحكم في واجهة المستخدم المخصصة",
  T_49_META_TYPE_23_D: "تعداد نوع الكائن المستوي، والذي سيتم إنشاؤه تلقائيًا استنادًا إلى نظام النوع",
  T_49_META_TYPE_231_D: "مجموعة الإصلاح",
  T_49_META_TYPE_233_D: "دائرة تقدم",
  T_49_META_TYPE_234_D: "اللغم الذي تم إنشاؤه",
  T_49_META_TYPE_235_D: "جدار لاصق",
  T_49_META_TYPE_236_D: "الجدار الجليدي الذي تم إنشاؤه",
  T_49_META_TYPE_237_D: "مسدس الخطاف",
  T_49_META_TYPE_238_D: "مسدس رش قوس قزح",
  T_49_META_TYPE_239_D: "رشاش بندقية",
  T_49_META_TYPE_24_D: "أنواع الأضرار التي يحددها النظام حاليًا",
  T_49_META_TYPE_240_D: "الكيان هو حامل جميع المكونات. يجب ربط المكونات بالكيان لإنشاء مثيلات.",
  T_49_META_TYPE_241_D: "مسدس خطاف قوي",
  T_49_META_TYPE_242_D: "شريط الدرجات",
  T_49_META_TYPE_243_D: "فتحات الملابس",
  T_49_META_TYPE_244_D: "يمثل كيان النص النص المعروض.",
  T_49_META_TYPE_245_D: "يمثل كيان الأيقونة أيقونة معروضة",
  T_49_META_TYPE_246_D: "لون الرش",
  T_49_META_TYPE_247_D: "نوع واجهة المستخدم للاعب",
  T_49_META_TYPE_248_D: "كيان تبديل واجهة المستخدم العامة",
  T_49_META_TYPE_249_D: "التبديل بين فتحات المعدات",
  T_49_META_TYPE_25_D: "المراحل في عملية اللعبة، مثل بداية اللعبة، وإعداد اللعبة، ونهاية اللعبة، وما إلى ذلك.",
  T_49_META_TYPE_250_D: "يمثل كيان التأثير التأثير المعروض",
  T_49_META_TYPE_2500_D: "نقطة ظهور اللاعب",
  T_49_META_TYPE_2501_D: "تُستخدم المحفزات لتحفيز أحداث دخول وخروج اللاعبين (أو الكائنات الأخرى)",
  T_49_META_TYPE_2502_D: "يتم تشغيل الموت أو عدم القدرة على الهزيمة، عندما يدخل اللاعب، فإنه يتحكم فيما إذا كان تأثير الموت أو عدم القدرة على الهزيمة وفقًا للخاصية",
  T_49_META_TYPE_2503_D: "نقاط تفتيش وضع السباق",
  T_49_META_TYPE_2504_D: "يتم استخدامه عادة في وضع السباق لتحديد اللاعب الذي يدخل خط النهاية المحدد. هذا مُحفِّز مُحدَّد. سيتم فتح المُحفِّزات المُخصَّصة لاحقًا. هذه النقطة النهائية هي مُجرَّد غلاف للمُحفِّز المُخصَّص.",
  T_49_META_TYPE_2505_D: "السياج حول نقطة الظهور، بعد إغلاقه، يمكنك مغادرة نقطة الظهور",
  T_49_META_TYPE_2507_D: "برج",
  T_49_META_TYPE_2508_D: "توليد الوحوش",
  T_49_META_TYPE_2509_D: "يمكن إنشاء حالات من النوع المقابل عند الطلب",
  T_49_META_TYPE_251_D: "حاوية التأثير",
  T_49_META_TYPE_2510_D: "منطقة ظهور اللاعب (المستطيل)",
  T_49_META_TYPE_252_D: "واجهة نتائج الرش",
  T_49_META_TYPE_253_D: "زر التلميح",
  T_49_META_TYPE_254_D: "تأثير نبض القلب",
  T_49_META_TYPE_255_D: "سلسلة توقيت الترجمة المحلية",
  T_49_META_TYPE_256_D: "نوع Rigidbody",
  T_49_META_TYPE_257_D: "مكون الجسم الصلب",
  T_49_META_TYPE_258_D: "نوع تنسيق الطابع الزمني",
  T_49_META_TYPE_259_D: "النصائح",
  T_49_META_TYPE_26_D: "الجولة في اللعبة عادة ما تكون جولة صغيرة، تتكون من عدة مراحل.",
  T_49_META_TYPE_260_D: "زر تقدم المهارة",
  T_49_META_TYPE_261_D: "معرف فريد",
  T_49_META_TYPE_262_D: "معرف غلاف السلاح",
  T_49_META_TYPE_263_D: "معرف الملابس",
  T_49_META_TYPE_264_D: "معرف العنصر، عندما يكون الإصدار يحتوي فقط على معرف السلاح",
  T_49_META_TYPE_265_D: "كيان لوحة واجهة المستخدم",
  T_49_META_TYPE_267_D: "كيان عرض التمرير لواجهة المستخدم، واجهة المستخدم التي يقوم اللاعب بتحريرها من خلال محرر واجهة المستخدم",
  T_49_META_TYPE_268_D: "مفتاح بثلاث حالات، بالإضافة إلى التشغيل والإيقاف، يمكنك اختيار الاحتفاظ بالمنطق الأصلي",
  T_49_META_TYPE_269_D: "معدات اللاعب",
  T_49_META_TYPE_270_D: "معرف الكيان أو الجاهزة",
  T_49_META_TYPE_271_D: "كيان لوحة واجهة المستخدم، واجهة المستخدم التي يقوم اللاعب بتحريرها من خلال محرر واجهة المستخدم",
  T_49_META_TYPE_272_D: "تعداد الجنس",
  T_49_META_TYPE_273_D: "خريطة صغيرة",
  T_49_META_TYPE_274_D: "يمكن للأيقونة المعروضة على الخريطة المصغرة أن تتبع الهدف",
  T_49_META_TYPE_275_D: "عقد الأجزاء الفردية في الهيكل العظمي",
  T_49_META_TYPE_276_D: "العقدة المستخدمة للوصول إلى عظام الجلد",
  T_49_META_TYPE_277_D: "كشف أشعة الكاميرا من جانب العميل",
  T_49_META_TYPE_278_D: "تمثل كتلة البكسل المعروضة على الخريطة الصغيرة حجم تصادم الكائن في هذا الموقع",
  T_49_META_TYPE_279_D: "برميل الألوان",
  T_49_META_TYPE_28_D: "في بداية كل جولة سيتم إعادة تعيين الحالة",
  T_49_META_TYPE_280_D: "زناد كروي",
  T_49_META_TYPE_281_D: "زناد كبسولة",
  T_49_META_TYPE_282_D: "يصف نوع معرف تكوين الأصول، المستخدم للإشارة إلى معرف تكوين الأصول الذي يأتي مع الحزمة الأصلية، والذي يجب تحليله من خلال جدول التكوين قبل التحميل",
  T_49_META_TYPE_283_D: "يصف نوع الأصل، ويُستخدم لتمثيل معرف الأصل، ويمكن تحميله مباشرةً",
  T_49_META_TYPE_284_D: "يمثل مورد نموذجي بشري يمكن استبداله بشخصية لاعب",
  T_49_META_TYPE_285_D: "القائمة أو القاموس، يمكن تكرارها",
  T_49_META_TYPE_286_D: "معرف يصف أصل البرنامج النصي.",
  T_49_META_TYPE_287_D: "معرف يصف أصل البرنامج النصي الثابت.",
  T_49_META_TYPE_288_D: "معرف يصف أصل واجهة المستخدم المخصصة.",
  T_49_META_TYPE_289_D: "المعرف المستخدم لوصف الأصول المحددة مسبقًا",
  T_49_META_TYPE_29_D: "المؤثرات الخاصة",
  T_49_META_TYPE_290_D: "شجرة السلوك",
  T_49_META_TYPE_291_D: "نوع عقدة شجرة السلوك",
  T_49_META_TYPE_292_D: "عقدة شجرة السلوك المخصصة",
  T_49_META_TYPE_293_D: "كيان قابل للتثبيت على شجرة السلوك",
  T_49_META_TYPE_294_D: "كيان تخطيط واجهة المستخدم، واجهة المستخدم التي يقوم اللاعبون بتحريرها من خلال محرر واجهة المستخدم",
  T_49_META_TYPE_295_D: "الحالة",
  T_49_META_TYPE_296_D: "مقطع الرسوم المتحركة",
  T_49_META_TYPE_297_D: "متحكم الرسوم المتحركة",
  T_49_META_TYPE_298_D: "نوع الحلقة",
  T_49_META_TYPE_3_D: "نوع صحيح، عدد صحيح موقّع مكون من 32 بت",
  T_49_META_TYPE_30_D: "الأيقونة",
  T_49_META_TYPE_300_D: "كيان UI3DContainer، واجهة المستخدم التي يقوم اللاعبون بتحريرها من خلال محرر واجهة المستخدم",
  T_49_META_TYPE_301_D: "نوع مهارة الذكاء الاصطناعي",
  T_49_META_TYPE_302_D: "تعداد فتحات المعدات",
  T_49_META_TYPE_303_D: "بالتوافق مع عمود Id في BuffData.csv، يرجى التأكيد مع GPP ما إذا كان ذلك ينطبق قبل إضافة عناصر جديدة",
  T_49_META_TYPE_304_D: "قائمة نوع التعزيز",
  T_49_META_TYPE_305_D: "حالة عقدة شجرة السلوك",
  T_49_META_TYPE_306_D: "يمكنك إضافة تعزيزات، وإزالة تعزيزات، والحصول على قائمة بالتعزيزات المضافة",
  T_49_META_TYPE_307_D: "صانع جدار الثلج",
  T_49_META_TYPE_308_D: "نوع معرف العنصر الخاص",
  T_49_META_TYPE_309_D: "رمي الدعائم",
  T_49_META_TYPE_31_D: "صوت",
  T_49_META_TYPE_310_D: "قوس السهم",
  T_49_META_TYPE_311_D: "قاعدة القنبلة اليدوية",
  T_49_META_TYPE_312_D: "رمي الدعائم",
  T_49_META_TYPE_313_D: "قنبلة DeIce Wall",
  T_49_META_TYPE_314_D: "إدارة وحدات التحكم في الرسوم المتحركة والموارد",
  T_49_META_TYPE_315_D: "حقيبة اللاعب",
  T_49_META_TYPE_316_D: "كيان UITexture، واجهة المستخدم التي تم تحريرها بواسطة اللاعب من خلال محرر واجهة المستخدم",
  T_49_META_TYPE_317_D: "قيود حركة الجسم الصلبة، يمكن استخدام كل قيد في تركيبة",
  T_49_META_TYPE_318_D: "ملحق",
  T_49_META_TYPE_319_D: "تعداد نوع التعبئة",
  T_49_META_TYPE_32_D: "نوع حالة اللاعب",
  T_49_META_TYPE_320_D: "تعداد اتجاه التعبئة",
  T_49_META_TYPE_321_D: "الكيانات التي يمكن استهدافها",
  T_49_META_TYPE_322_D: "نوع الجزء التالف من الجسم",
  T_49_META_TYPE_323_D: "كيان UIProfileInfo، واجهة المستخدم التي يقوم اللاعبون بتحريرها من خلال محرر واجهة المستخدم",
  T_49_META_TYPE_324_D: "هناك عدة تأثيرات مختلفة للقوى على الأجسام الصلبة. لاحظ أن هذا ينطبق فقط على الأجسام الصلبة الديناميكية.",
  T_49_META_TYPE_325_D: "المعرف المستخدم لوصف عنصر التحكم في أصل الواجهة المخصصة",
  T_49_META_TYPE_326_D: "معلومات ملف تعريف اللاعب",
  T_49_META_TYPE_327_D: "الاستبدال حسب تكوين كل مكون",
  T_49_META_TYPE_328_D: "معرف شجرة السلوك",
  T_49_META_TYPE_329_D: "نوع المقعد",
  T_49_META_TYPE_33_D: "فرز حسب: تصاعدي تجاهل القيم الصفرية، تنازلي، تصاعدي",
  T_49_META_TYPE_330_D: "الحركة بالنسبة للذات",
  T_49_META_TYPE_331_D: "منحنى بيزيير",
  T_49_META_TYPE_332_D: "المكونات القابلة لإعادة التدوير",
  T_49_META_TYPE_333_D: "نوع نوع الخط",
  T_49_META_TYPE_334_D: "معرف غلاف المركبة",
  T_49_META_TYPE_335_D: "يمثل كيان التأثير الصوتي تأثيرًا صوتيًا يتم تشغيله.",
  T_49_META_TYPE_336_D: "قائمة تأثيرات الصوت",
  T_49_META_TYPE_337_D: "تأثير الصوت أو قائمة تأثيرات الصوت",
  T_49_META_TYPE_338_D: "كيان مزامنة سمة سلوك اللاعب",
  T_49_META_TYPE_339_D: "ملحقات المعدات",
  T_49_META_TYPE_34_D: "معرف العنصر",
  T_49_META_TYPE_340_D: "نوع صعوبة البوت",
  T_49_META_TYPE_341_D: "قاموس صحيح",
  T_49_META_TYPE_342_D: "كائن المؤقت",
  T_49_META_TYPE_343_D: "سكين الرمي (التقاط)",
  T_49_META_TYPE_344_D: "سكين رمي",
  T_49_META_TYPE_345_D: "نوع السلاح",
  T_49_META_TYPE_346_D: "نوع الذخيرة",
  T_49_META_TYPE_347_D: "حركة ذاتية لكل إطار",
  T_49_META_TYPE_348_D: "يشير مؤشر الوظيفة إلى مثيل وظيفة لتنفيذ وظيفة افتراضية أو آلية تفويض.",
  T_49_META_TYPE_349_D: "يشير إلى مقبض الروتين الفرعي، ويمكنه إجراء بعض عمليات المقبض",
  T_49_META_TYPE_350_D: "تعداد المركبات",
  T_49_META_TYPE_351_D: "يصف نوع الكائن",
  T_49_META_TYPE_352_D: "كيان UIToggle، واجهة المستخدم التي يقوم اللاعب بتحريرها من خلال محرر واجهة المستخدم",
  T_49_META_TYPE_353_D: "حقيبة الإسعافات الأولية",
  T_49_META_TYPE_354_D: "جهاز الاستنشاق",
  T_49_META_TYPE_355_D: "الخط الأفقي",
  T_49_META_TYPE_356_D: "الإنزال الجوي، بعد انتهاء وقت التحضير، سيبدأ بالسقوط من مكان مرتفع",
  T_49_META_TYPE_357_D: "اللون الوصفي للأشياء، مثل الحدود والأسطح وما إلى ذلك (حذف، قابل لإعادة التدوير)",
  T_49_META_TYPE_358_D: "يشير إلى حدث",
  T_49_META_TYPE_359_D: "وحدة تحكم اللاعب مع تأثيرات فيزيائية، يمكنها تطبيق القوة واستقبالها",
  T_49_META_TYPE_360_D: "منصة الإطلاق",
  T_49_META_TYPE_361_D: "يمكن استخدام المدفع المطوي لإطلاق النار على الأشخاص عند فتحه. احذر من إطلاق نفسك خارج منطقة الأمان!",
  T_49_META_TYPE_362_D: "معركة كرة الثلج! تكلفة!",
  T_49_META_TYPE_363_D: "طلب شراء من المتجر",
  T_49_META_TYPE_364_D: "زناد الرسوم المتحركة",
  T_49_META_TYPE_365_D: "مكون واجهة تشغيل الرسوم المتحركة",
  T_49_META_TYPE_366_D: "دفعة الجمع بين التقديم",
  T_49_META_TYPE_367_D: "البوصلة العلوية",
  T_49_META_TYPE_368_D: "معرف مورد الدور المخصص",
  T_49_META_TYPE_369_D: "معرف مورد الرسوم المتحركة المخصص",
  T_49_META_TYPE_370_D: "المعلومات المعروضة في بداية الجولة",
  T_49_META_TYPE_371_D: "في نهاية كل جولة، اعرض النتائج",
  T_49_META_TYPE_372_D: "نوع موقف اللاعب",
  T_49_META_TYPE_373_D: "معرف المجموعة، المستخدم لجمع معلومات الموارد",
  T_49_META_TYPE_374_D: "شريط الصحة المتبع",
  T_49_META_TYPE_375_D: "تعداد نوع هدف هجوم الوحش",
  T_49_META_TYPE_376_D: "تعداد نوع هدف هجوم برج الدفاع",
  T_49_META_TYPE_377_D: "أسماء مستعارة لكيانات اللاعب وأنواع كيانات المركبات",
  T_49_META_TYPE_378_D: "معرف يصف أصل الصوت.",
  T_49_META_TYPE_379_D: "المعرف المستخدم لوصف أصل جدول التكوين",
  T_49_META_TYPE_38_D: "كيان عنصر واجهة المستخدم الفارغ، تم تحرير واجهة المستخدم بواسطة اللاعب من خلال محرر واجهة المستخدم",
  T_49_META_TYPE_380_D: "معرف يصف أصل التأثير الخاص.",
  T_49_META_TYPE_381_D: "معرف يصف أصل وحدة التحكم في الرسوم المتحركة.",
  T_49_META_TYPE_382_D: "طريقة التعامل مع حالة الإسقاط",
  T_49_META_TYPE_383_D: "سطح الخريطة أو الزخارف",
  T_49_META_TYPE_384_D: "العناصر",
  T_49_META_TYPE_385_D: "معرف مهارة الشخصية",
  T_49_META_TYPE_386_D: "قائمة معرفات المهارة",
  T_49_META_TYPE_387_D: "كيان UITouchPad، واجهة المستخدم التي يقوم اللاعب بتحريرها من خلال محرر واجهة المستخدم",
  T_49_META_TYPE_388_D: "معرف غلاف الحقيبة",
  T_49_META_TYPE_389_D: "كيان عصا التحكم، واجهة المستخدم التي يحررها اللاعب من خلال محرر واجهة المستخدم",
  T_49_META_TYPE_39_D: "كيان صورة واجهة المستخدم، واجهة المستخدم التي تم تحريرها بواسطة اللاعب من خلال محرر واجهة المستخدم",
  T_49_META_TYPE_390_D: "هرمية",
  T_49_META_TYPE_391_D: "واجهة المستخدم المخصصة أو أداة",
  T_49_META_TYPE_392_D: "دائرة السم الأشياء التي يمكن وضعها",
  T_49_META_TYPE_393_D: "الكيانات ذات مكونات PhysicalCCT أو Rigidbody",
  T_49_META_TYPE_394_D: "الثوابت الرياضية",
  T_49_META_TYPE_395_D: "يمكن للكيانات التي تحتوي على مكونات PhysicalCCT أو PlayerCCT التحرك معها",
  T_49_META_TYPE_396_D: "إعداد الخروج أثناء اللعبة",
  T_49_META_TYPE_397_D: "المكون المستخدم لوصف شكل الاصطدام",
  T_49_META_TYPE_398_D: "سلسلة أو سلسلة محلية",
  T_49_META_TYPE_399_D: "وحدة تحكم الشخصيات ذات التأثيرات المادية، مخصصة لشخصيات FF فقط",
  T_49_META_TYPE_4_D: "نوع النقطة العائمة، رقم النقطة العائمة بدقة أحادية 32 بت",
  T_49_META_TYPE_40_D: "كيان نص واجهة المستخدم، واجهة المستخدم التي تم تحريرها بواسطة اللاعب من خلال محرر واجهة المستخدم",
  T_49_META_TYPE_400_D: "كيفية التعامل مع السلوك العدواني",
  T_49_META_TYPE_401_D: "نوع النار",
  T_49_META_TYPE_402_D: "أداة زر اجتماعي",
  T_49_META_TYPE_403_D: "أنواع الأزرار الاجتماعية",
  T_49_META_TYPE_404_D: "أنماط الأزرار الاجتماعية",
  T_49_META_TYPE_405_D: "نوع فرز التخطيط",
  T_49_META_TYPE_406_D: "يمكن أن يؤدي إلى تجاوز العوائق",
  T_49_META_TYPE_407_D: "نوع المنصة",
  T_49_META_TYPE_408_D: "الاسم المستعار للبيانات الأساسية",
  T_49_META_TYPE_409_D: "تعداد رمز الخطأ",
  T_49_META_TYPE_41_D: "كيان زر واجهة المستخدم، واجهة المستخدم التي يقوم اللاعب بتحريرها من خلال محرر واجهة المستخدم",
  T_49_META_TYPE_410_D: "اسم مستعار لكيان اللاعب أو نوع كيان التحويل.",
  T_49_META_TYPE_411_D: "مركبة هليكوبتر",
  T_49_META_TYPE_412_D: "مكون السيارة هو التوسع الوظيفي لمكون السيارة",
  T_49_META_TYPE_413_D: "NPC",
  T_49_META_TYPE_414_D: "تحديد زاوية دوران الكاميرا",
  T_49_META_TYPE_415_D: "شخصية",
  T_49_META_TYPE_416_D: "واجهة نافذة الدردشة الشخصية",
  T_49_META_TYPE_417_D: "مكون كيان الجسيم",
  T_49_META_TYPE_418_D: "تعداد حالة العضو",
  T_49_META_TYPE_419_D: "نوع جلد البندقية",
  T_49_META_TYPE_42_D: "كيان إدخال واجهة المستخدم، واجهة المستخدم التي يقوم اللاعب بتحريرها من خلال محرر واجهة المستخدم",
  T_49_META_TYPE_420_D: "أنواع أغطية المركبات",
  T_49_META_TYPE_421_D: "نوع البشرة",
  T_49_META_TYPE_422_D: "نوع جلد حقيبة الظهر",
  T_49_META_TYPE_423_D: "معرف الشخصية",
  T_49_META_TYPE_424_D: "نوع تأثير الضباب الأساسي",
  T_49_META_TYPE_425_D: "معرف أصل الجسيمات",
  T_49_META_TYPE_426_D: "نوع من مصادر الضوء يصدر ضوءًا مخروطيًا من مصدر الضوء إلى المحور Y السالب لمصدر الضوء، مما يؤدي إلى إضاءة الأرض افتراضيًا",
  T_49_META_TYPE_427_D: "NPC",
  T_49_META_TYPE_428_D: "معلومات الأزياء التي يجب على اللاعب الاحتفاظ بها عند التحول إلى شخصية أخرى",
  T_49_META_TYPE_429_D: "لاعب أو كيان NPC",
  T_49_META_TYPE_43_D: "يجب أن يكون نوع العنصر عبارة عن قائمة بكيانات اللاعب",
  T_49_META_TYPE_430_D: "مولد رقم عشوائي",
  T_49_META_TYPE_431_D: "يتحرك الكائن المتحرك على طول مسار مخصص",
  T_49_META_TYPE_432_D: "تخصيص نقاط مسار المنحنى",
  T_49_META_TYPE_433_D: "تخصيص نوع نقطة مسار المنحنى",
  T_49_META_TYPE_434_D: "مسار المنحنى المخصص",
  T_49_META_TYPE_435_D: "قائمة معرفات اللاعب الفريدة",
  T_49_META_TYPE_436_D: "قائمة رموز الخطأ",
  T_49_META_TYPE_437_D: "واجهة مستخدم لتفاصيل المباراة لكلا الفريقين. تعديل سمات الكيان سيؤثر على محتوى العرض في واجهة المستخدم المقابلة.",
  T_49_META_TYPE_438_D: "تفاصيل مباراة فريق متعددة، كيان واجهة المستخدم، تعديل سمات الكيان سيؤثر على محتوى العرض على واجهة المستخدم المقابلة",
  T_49_META_TYPE_439_D: "دمج",
  T_49_META_TYPE_44_D: "يجب أن يكون نوع العنصر عبارة عن قائمة بكيانات الفريق",
  T_49_META_TYPE_440_D: "الجدول الزمني",
  T_49_META_TYPE_441_D: "معرف مورد الجدول الزمني",
  T_49_META_TYPE_442_D: "مكون كيان مبسط جديد لمعلومات المباريات بين فريقين، ويدعم عرض الأرقام المخصصة بالكامل",
  T_49_META_TYPE_443_D: "معرف أصل تدفق الحوار",
  T_49_META_TYPE_444_D: "نوع اللغة",
  T_49_META_TYPE_45_D: "قائمة منطقية",
  T_49_META_TYPE_46_D: "قائمة عدد صحيح",
  T_49_META_TYPE_47_D: "قائمة الطفو",
  T_49_META_TYPE_48_D: "قائمة السلاسل",
  T_49_META_TYPE_49_D: "قائمة فكتور3",
  T_49_META_TYPE_5_D: "نوع السلسلة، القيمة هي محتوى نصي",
  T_49_META_TYPE_50_D: "يجب أن يكون نوع العنصر عبارة عن قائمة بالكيانات",
  T_49_META_TYPE_51_D: "نوع الزومبي",
  T_49_META_TYPE_53_D: "عنصر مستوى عام",
  T_49_META_TYPE_54_D: "عنصر قابل للتدمير",
  T_49_META_TYPE_55_D: "نقطة ظهور عامة",
  T_49_META_TYPE_56_D: "مركبة",
  T_49_META_TYPE_57_D: "يمكن نقل اللاعبين إلى موقع محدد عند الدخول",
  T_49_META_TYPE_58_D: "يمكن إنشاء التعزيزات حسب الطلب",
  T_49_META_TYPE_59_D: "المنصة المتحركة",
  T_49_META_TYPE_6_D: "متجه ثلاثي الأبعاد، والذي يمكن أن يمثل إحداثيات مكانية أو اتجاهات مكانية",
  T_49_META_TYPE_60_D: "سيؤدي إلى سقوط سلاح من النوع المحدد",
  T_49_META_TYPE_61_D: "سيؤدي الدخول إلى نطاق المشغل إلى فتح المتجر المرتبط",
  T_49_META_TYPE_62_D: "نرد ذو ارتداد ممتاز",
  T_49_META_TYPE_63_D: "سيتم إرجاع اللاعبين إلى الموقع المحدد عندما يخطون عليه",
  T_49_META_TYPE_64_D: "عندما يخطو اللاعب عليها، ستصدر صوتًا",
  T_49_META_TYPE_65_D: "قابل للتطوير الأساسي",
  T_49_META_TYPE_66_D: "المسار المخصص",
  T_49_META_TYPE_67_D: "نقطة المسار",
  T_49_META_TYPE_68_D: "كيانات وحوش الذكاء الاصطناعي، مثل الزومبي",
  T_49_META_TYPE_69_D: "الأعداد الكبيرة هي أرقام فاصلة عائمة عالية الدقة",
  T_49_META_TYPE_7_D: "الرقم هو اسم مستعار لنوع العدد الصحيح أو العدد الصحيح 64 بت أو النوع ذي النقطة العائمة",
  T_49_META_TYPE_70_D: "تُستخدم صيغ السمات لحساب قيم سمات الكيان. حاليًا، بعض سمات اللاعب وسمات السلاح فقط هي المدعومة.",
  T_49_META_TYPE_71_D: "يُستخدم فقط للعناصر المباعة في المتاجر. تختلف البضائع عن مفهوم المنتجات التي يتم الحصول عليها بشراء البضائع.",
  T_49_META_TYPE_72_D: "يحتوي على العديد من المنتجات",
  T_49_META_TYPE_73_D: "يحتوي على عدة رفوف",
  T_49_META_TYPE_74_D: "معرف العنصر",
  T_49_META_TYPE_75_D: "العودة",
  T_49_META_TYPE_76_D: "أسلوب الدورية",
  T_49_META_TYPE_77_D: "كيان مولد يمكنه إنشاء الكائنات وتحديثها",
  T_49_META_TYPE_78_D: "كيان وحدة يمكن استيعابه بواسطة مولدات الوحدات وتوليده في دفعات",
  T_49_META_TYPE_79_D: "سلاح",
  T_49_META_TYPE_8_D: "الشروط من نوع Bool خاص",
  T_49_META_TYPE_80_D: "واجهة المتجر",
  T_49_META_TYPE_81_D: "نوع buff",
  T_49_META_TYPE_82_D: "نبضات القلب",
  T_49_META_TYPE_83_D: "زر التفاعل",
  T_49_META_TYPE_84_D: "الكيانات القابلة للتصنيف، والقادرة على التصنيف",
  T_49_META_TYPE_85_D: "الكيانات القابلة للتكامل لها تكاملاتها الخاصة",
  T_49_META_TYPE_86_D: "نوع عامل صيغة السمة",
  T_49_META_TYPE_87_D: "يصف نوع لون RGBA، يتراوح نطاق قيمة كل قناة بين 0 و255",
  T_49_META_TYPE_88_D: "نوع العملة، حاليًا نوع العملة الأساسية فقط",
  T_49_META_TYPE_89_D: "كيان العملة، يستخدم لوصف نوع ومقدار العملة",
  T_49_META_TYPE_9_D: "مجموعة من الشروط",
  T_49_META_TYPE_90_D: "كيان المحفظة هو حاوية لمجموعة من كيانات العملة",
  T_49_META_TYPE_91_D: "يشير إلى نوع عدد صحيح أو مجموعة أعداد صحيحة",
  T_49_META_TYPE_92_D: "نوع العنصر القابل للتكوين الديناميكي",
  T_49_META_TYPE_93_D: "الكيانات ذات الخصائص القابلة للصياغة",
  T_49_META_TYPE_94_D: "طريقة تعديل السمة",
  T_49_META_TYPE_95_D: "مولد الذهب",
  T_49_META_TYPE_96_D: "المحفظة",
  T_49_META_TYPE_97_D: "الموضع والدوران والقياس ودعم هيكل الوالد والطفل",
  T_49_META_TYPE_98_D: "قائمة بجميع الأنواع المتاحة",
  T_49_META_TYPE_99_D: "كرة القدم"
};
export {
  _ as default
};
